(function() {
  angular.module('app', ['ui.router', 'ngResource', 'ui.timepicker', 'ui.grid', 'ui.grid.pagination', 'uuid4', 'angularFileUpload', 'ngDialog', 'templates', 'ngCsv', 'ngAnimate', 'focusOn', 'ngKookies', 'infinite-scroll', 'angularPayments', 'ct.ui.router.extras.core', 'ct.ui.router.extras.sticky', 'ct.ui.router.extras.previous', 'ngTagsInput', 'pickadate', 'rzModule', 'btford.socket-io', 'smart-table', 'ngRaven', 'dateParser', 'angular-clipboard', 'ngProgressLite', 'pascalprecht.translate', 'bw.paging', 'vr.directives.nlForm']).run(["$rootScope", "$state", "$timeout", "$location", "AccountF", "RouteS", "MessagingF", "States", "SocketF", "AbTestF", "ReduxStoreF", function($rootScope, $state, $timeout, $location, AccountF, RouteS, MessagingF, States, SocketF, AbTestF, ReduxStoreF) {
    var BIG_MODAL_STATES, THIRTY_SECONDS_IN_MILLISECONDS, locationSearch, _connectToSocket, _redirectIfNotLoggedIn, _redirectToBeta, _redirectToLogin, _verifyLoggedIn;
    if (typeof mixpanel !== "undefined" && mixpanel !== null) {
      mixpanel.init('b0228d795dd9df083f958060f0aca1e7');
    }
    THIRTY_SECONDS_IN_MILLISECONDS = 30000;
    BIG_MODAL_STATES = [States.modalProjectsLoad];
    _redirectToBeta = function(event) {
      if (event) {
        event.preventDefault();
      }
      return AccountF.goToBeta();
    };
    _redirectToLogin = function(event) {
      if (event) {
        event.preventDefault();
      }
      return AccountF.goToLogin();
    };
    _redirectIfNotLoggedIn = function(event) {
      if (!AccountF.fetchUserToken()) {
        return _redirectToLogin(event);
      }
      if (!AccountF.getUser()) {
        AccountF.fetchUpgrade();
        AccountF.fetchShopifyDetails();
        return AccountF.fetchUser().then(function() {
          return ReduxStoreF.init();
        })["catch"](function() {
          return _redirectToLogin(event);
        });
      }
    };
    _connectToSocket = function() {
      var authToken = AccountF.fetchUserToken();
      if (authToken) {
        return SocketF.connect(authToken);
      }
    };
    _verifyLoggedIn = function() {
      return $timeout(function() {
        _redirectIfNotLoggedIn();
        return _verifyLoggedIn();
      }, THIRTY_SECONDS_IN_MILLISECONDS);
    };
    locationSearch = $location.search();
    $rootScope.$on('$stateChangeSuccess', function(event, toState) {
      var context = {
        url: $state.href(toState.name, {}, {
          absolute: true
        }),
        name: toState.name,
        path: toState.name
      };
      analytics.page(context);
      if (locationSearch != null) {
        $location.search(locationSearch);
      }
      return locationSearch = null;
    });
    $rootScope.$on('$stateChangeStart', function(event, toState) {
      _redirectIfNotLoggedIn(event);
      if (toState.$$state().includes[States.modalSettings] && RouteS.isInProgress()) {
        MessagingF.replaceWarning("Please wait - Route Optimization Magic in progress!");
        return event.preventDefault();
      }
    });
    _connectToSocket();
    return _verifyLoggedIn();
  }]).config(["$stateProvider", "$urlRouterProvider", "$urlMatcherFactoryProvider", "States", "TranslateProvider", function($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, States, TranslateProvider) {
    var _parseAddressCheckerLocation;
    _parseAddressCheckerLocation = function(currentLocation, allLocations) {
      var allResults;
      if (allLocations) {
        allResults = [];
        allResults = allLocations.map(function(location) {
          return {
            address: location.address,
            coords: {
              lat: location.latitude || location.lat,
              lng: location.longitude || location.lng
            }
          };
        });
        return allResults;
      } else {
        return [currentLocation];
      }
    };
    $urlMatcherFactoryProvider.type('notificationRoutes', {
      encode: function(val) {
        if (val != null) {
          return val.toString();
        } else {
          return val;
        }
      },
      decode: function(val) {
        if (val != null) {
          return val.toString();
        } else {
          return val;
        }
      },
      is: function(val) {
        return this.pattern.test(val);
      },
      pattern: /.*/
    });
    $urlRouterProvider.otherwise('/hud/project/route/timeline/plan');
    return $stateProvider.state(States.projectDeepLink, {
      url: '/projects/{projectId}',
      templateUrl: 'hud/projects/deeplink.html',
      controller: 'DeeplinkC',
      controllerAs: 'deeplink',
      resolve: {
        defaultTranslation: ["Translate", function(Translate) {
          return Translate.setDefaultTranslation();
        }],
        currentUser: ["AccountF", "defaultTranslation", function(AccountF, defaultTranslation) {
          return AccountF.getCurrentUser();
        }],
        messageTemplate: ["MessageTemplateF", function(MessageTemplateF) {
          return MessageTemplateF.load();
        }]
      }
    }).state(States.main, {
      url: '/hud',
      templateUrl: 'hud/main.html',
      controller: 'HudC',
      controllerAs: 'hud',
      resolve: {
        defaultTranslation: ["Translate", function(Translate) {
          return Translate.setDefaultTranslation();
        }],
        currentUser: ["AccountF", "defaultTranslation", function(AccountF, defaultTranslation) {
          return AccountF.getCurrentUser();
        }],
        selectedTranslation: ["currentUser", "Translate", function(currentUser, Translate) {
          var _ref, _ref1;
          Translate.setAvailableTranslations((_ref = currentUser.language) != null ? _ref.available_languages : void 0);
          return Translate.setSelectedTranslation((_ref1 = currentUser.language) != null ? _ref1.selected_id : void 0);
        }],
        messageTemplate: ["MessageTemplateF", function(MessageTemplateF) {
          return MessageTemplateF.load();
        }],
        questionnaire: ["currentUser", "QuestionnaireF", "Constants", function(currentUser, QuestionnaireF, Constants) {
          var _ref;
          if ((_ref = currentUser.settings) != null ? _ref.sentQuestionnaire : void 0) {
            return QuestionnaireF.fetchUserQuestionnaire();
          }
        }],
        project: ["$q", "$timeout", "currentUser", "selectedTranslation", "ProjectF", "VisitF", "RouteHistoryF", "MessagingF", "Messages", function($q, $timeout, currentUser, selectedTranslation, ProjectF, VisitF, RouteHistoryF, MessagingF, Messages) {
          var TWENTY_SECONDS, deferred, maxResolveTimeout, promise, tempInfo, _ref;
          TWENTY_SECONDS = 20 * 1000;
          deferred = $q.defer();
          maxResolveTimeout = $timeout(function() {
            return deferred.resolve(null);
          }, TWENTY_SECONDS);
          VisitF.clearCache();
          RouteHistoryF.clear();
          promise = null;
          if ((_ref = currentUser.project) != null ? _ref.id : void 0) {
            promise = ProjectF.load(currentUser.project.id);
          } else {
            MessagingF.replaceError("MESSAGES.PROJECT_LOAD_FAILED", {
              email: Messages.PROJECT_LOAD_EMAIL
            });
            tempInfo = ProjectF.getProjectTempInfo();
            promise = ProjectF.create(tempInfo.name, tempInfo.date).then(function() {
              return ProjectF.load(ProjectF.project.id);
            });
          }
          promise.then(function(project) {
            return deferred.resolve(project);
          })["catch"](function() {
            return deferred.resolve(null);
          })["finally"](function() {
            return $timeout.cancel(maxResolveTimeout);
          });
          return deferred.promise;
        }],
        types: ["project", "TypeF", function(project, TypeF) {
          return TypeF.reload();
        }],
        driverCsv: ["currentUser", "DriverCsvHeaderF", function(currentUser, DriverCsvHeaderF) {
          return DriverCsvHeaderF.initialize();
        }],
        customNotes: ["currentUser", "project", "VisitF", "VisitCsvHeaderF", function(currentUser, project, VisitF, VisitCsvHeaderF) {
          return VisitCsvHeaderF.initialize(VisitF.getVisits());
        }],
        isProjectLoaded: ["project", function(project) {
          return !!project;
        }],
        settings: ["SettingsF", function(SettingsF) {
          return SettingsF.init();
        }],
        isInDemo: ["currentUser", "DemoF", function(currentUser, DemoF) {
          return false;
        }],
        showWorldMap: ["isProjectLoaded", "isInDemo", function(isProjectLoaded, isInDemo) {
          return !isProjectLoaded && isInDemo;
        }]
      }
    }).state(States.mainNav, {
      sticky: true,
      views: {
        'nav@hud': {
          templateUrl: 'hud/rightNav.html'
        }
      }
    }).state(States.notifications, {
      url: '/notifications',
      abstract: true,
      views: {
        'main@hud.nav': {
          template: '<notification-entry settings="notifications.settings" />',
          controllerAs: 'notifications',
          controller: ["user", function(user) {
            this.settings = user.settings;
          }]
        }
      },
      resolve: {
        user: ["$q", "AccountF", function($q, AccountF) {
          return AccountF.getCurrentUser().then(function(userInfo) {
            if (!AccountF.hasCustomerNotification()) {
              return $q.reject();
            }
            return $q.when(userInfo);
          });
        }]
      }
    }).state(States.notificationsChildren, {
      url: '{path:notificationRoutes}?allow'
    }).state(States.customers, {
      url: '/customers',
      views: {
        'main@hud.nav': {
          templateUrl: 'hud/customers/index.html',
          controller: 'CustomersTableC',
          controllerAs: 'customersTable'
        }
      },
      resolve: {
        geocodeInfo: ["CustomerF", function(CustomerF) {
          return CustomerF.getGeocodeInfo();
        }],
        results: ["CustomerF", "AccountF", "LocalStorageStringF", function(CustomerF, AccountF, LocalStorageStringF) {
          return AccountF.getCurrentUser().then(function() {
            var sortOrder;
            var sortBy = LocalStorageStringF('customersSortBy').load();
            sortOrder = LocalStorageStringF('customersSortOrder').load();
            return CustomerF.getCustomers(sortBy, sortOrder, "", 25, 0);
          });
        }]
      }
    }).state(States.customersUpload, {
      url: '/upload',
      views: {
        'customer-sidepanel@hud.nav.customers': {
          templateUrl: 'hud/customers/sidepanel/upload.html',
          controller: 'CustomerUploadC',
          controllerAs: 'customerUpload'
        }
      }
    }).state(States.customersEdit, {
      url: '/{customerId}/edit',
      views: {
        'customer-sidepanel@hud.nav.customers': {
          templateUrl: 'hud/customers/sidepanel/edit.html',
          controller: 'CustomerFormC',
          controllerAs: 'customerForm'
        }
      },
      resolve: {
        customer: ["CustomerF", "$stateParams", function(CustomerF, $stateParams) {
          var customer = CustomerF.getCustomer($stateParams.customerId);
          if (customer && customer.status !== 'geocoding') {
            return customer;
          } else {
            return $state.go(States.customers);
          }
        }]
      }
    }).state(States.customersCreate, {
      url: '/create',
      views: {
        'customer-sidepanel@hud.nav.customers': {
          templateUrl: 'hud/customers/sidepanel/create.html',
          controller: 'CustomerFormC',
          controllerAs: 'customerForm'
        }
      },
      resolve: {
        customer: function() {
          return {};
        }
      }
    }).state(States.projects, {
      url: '/projects',
      views: {
        'main@hud.nav': {
          templateUrl: 'hud/projects/index.html',
          controller: 'ProjectsTableC',
          controllerAs: 'projectsTable'
        }
      },
      resolve: {
        projects: ["ProjectF", "AccountF", "Constants", "$location", "$state", "$kookies", "$interval", "EventListenersF", "Events", function(ProjectF, AccountF, Constants, $location, $state, $kookies, $interval, EventListenersF, Events) {
          var dateFrom, dateFromFormatted, daysProjectsQuery;
          daysProjectsQuery = AccountF.maxDaysProjectsQuery();
          if (daysProjectsQuery) {
            dateFrom = new Date();
            dateFrom.setDate(dateFrom.getDate() - daysProjectsQuery);
            dateFromFormatted = dateFrom.toISOString().slice(0, 10);
            return ProjectF.fetchProjectsWithDates(dateFromFormatted);
          } else {
            return ProjectF.fetchProjects();
          }
        }],
        minMaxDates: ["projects", function(projects) {
          var maxDate, minDate, minMaxDates, p, _i, _len;
          minDate = null;
          maxDate = null;
          for (_i = 0, _len = projects.length; _i < _len; _i++) {
            p = projects[_i];
            if ((minDate == null) || p.date < minDate) {
              minDate = p.date;
            }
            if ((maxDate == null) || p.date > maxDate) {
              maxDate = p.date;
            }
          }
          minMaxDates = {
            minDate: minDate,
            maxDate: maxDate
          };
          return minMaxDates;
        }]
      }
    }).state(States.project, {
      url: '/project',
      views: {
        'main@hud.nav': {
          templateUrl: 'hud/project/index.html',
          controller: 'ProjectC',
          controllerAs: 'projectC'
        }
      },
      resolve: {
        points: ["project", "MarkersF", function(project, MarkersF) {
          return MarkersF.getPoints();
        }],
        location: ["SettingsF", "Constants", "showWorldMap", function(SettingsF, Constants, showWorldMap) {
          SettingsF.setLocation(Constants.vancouver);
          if (showWorldMap) {
            return Constants.worldCenter;
          } else {
            return Constants.vancouver;
          }
        }],
        mapCenter: ["$q", "points", "location", "Constants", "MapF", "showWorldMap", function($q, points, location, Constants, MapF, showWorldMap) {
          var bounds, center, centerPosition, coords, lat, lng, zoomLevel;
          center = void 0;
          if (points.length === 0) {
            zoomLevel = showWorldMap ? 3 : 10;
            centerPosition = {
              zoom: zoomLevel,
              bounds: void 0,
              offset: {
                x: 0,
                y: 0
              }
            };
            if (location) {
              coords = location.coords;
              lat = parseFloat(coords.lat);
              lng = parseFloat(coords.lng);
              centerPosition.center = {
                lat: lat,
                lng: lng
              };
              centerPosition;
            } else {
              console.error("Failed to find user's location");
              centerPosition.center = Constants.vancouver.coords;
              centerPosition;
            }
            center = $q.when(centerPosition);
          } else {
            bounds = MapF.calculateLatLngBound(points);
            center = $q.when({
              center: void 0,
              zoom: void 0,
              zoomOffset: void 0,
              bounds: bounds,
              offset: {
                x: 0,
                y: 0
              }
            });
          }
          return center;
        }]
      }
    }).state(States.projectInput, {
      url: '/input',
      views: {
        'content@hud.nav.project': {
          templateUrl: 'hud/project/input/input.html',
          controller: 'InputC',
          controllerAs: 'input'
        }
      },
      onEnter: ["$rootScope", "$timeout", "GMarkerF", "MarkersF", function($rootScope, $timeout, GMarkerF, MarkersF) {
        MarkersF.fitToPoints();
        return $timeout(function() {
          var _ref;
          var marker = GMarkerF.getMarkerAndScope().marker;
          if (marker != null) {
            GMarkerF.openInfoWindow((_ref = marker.parameter) != null ? _ref.id : void 0);
          }
          return $rootScope.$broadcast('RESET_MAP_SIZE');
        });
      }]
    }).state(States.projectVisits, {
      url: '/visits',
      templateUrl: 'hud/project/visits/index.html',
      controller: 'VisitC',
      controllerAs: 'visit'
    }).state(States.projectVisitsList, {
      url: '/list',
      templateUrl: 'hud/project/visits/list.html',
      controller: ["$scope", "$state", function($scope, $state) {
        return $scope.visit.initializeEntry();
      }]
    }).state(States.projectVisitsCreate, {
      url: '/create',
      templateUrl: 'hud/project/visits/create.html',
      controller: ["$scope", function($scope) {
        return $scope.visit.initializeEntry();
      }]
    }).state(States.projectVisitsQuickadd, {
      url: '/quickadd',
      templateUrl: 'hud/project/visits/quickadd.html',
      controller: ["$scope", function($scope) {
        return $scope.visit.initializeEntry();
      }]
    }).state(States.projectVisitsUpload, {
      url: '/upload',
      templateUrl: 'hud/project/visits/upload.html',
      controller: 'VisitUploadC',
      controllerAs: 'upload'
    }).state(States.projectVisitsEdit, {
      url: '/{visitID}/edit',
      templateUrl: 'hud/project/visits/edit.html',
      resolve: {
        isLocked: ["$q", "$stateParams", "VisitF", "RouteS", "project", function($q, $stateParams, VisitF, RouteS, project) {
          var visit = VisitF.getVisit($stateParams.visitID);
          if (RouteS.isVisitLocked(visit.id)) {
            return $q.reject();
          }
        }]
      },
      controller: ["$scope", "$state", "$stateParams", "$previousState", "VisitF", function($scope, $state, $stateParams, $previousState, VisitF) {
        var visitClone;
        var visit = VisitF.getVisit($stateParams.visitID);
        if (visit == null) {
          return $state.go(States.main);
        }
        $previousState.memo($scope.visit.previousState);
        visitClone = _.cloneDeep(visit);
        return $scope.visit.initializeEntry(visitClone);
      }]
    }).state(States.modalCustomerChecker, {
      url: '/customerchecker/{customerID}',
      views: {
        'modal@': {
          templateUrl: 'hud/customers/checker.html',
          controller: 'customerCheckerC',
          controllerAs: 'customerChecker',
          resolve: {
            customer: ["$q", "$stateParams", "CustomerF", function($q, $stateParams, CustomerF) {
              return CustomerF.getCustomer($stateParams.customerID).then(function(res) {
                var allLocations, currentLocation, customerClone;
                if (!(res != null ? res.location : void 0)) {
                  return $q.reject();
                }
                customerClone = _.cloneDeep(res);
                currentLocation = {};
                currentLocation.address = customerClone.location.address;
                currentLocation.coords = customerClone.location.coords || {
                  lat: null,
                  lng: null
                };
                allLocations = customerClone.location.all_results;
                customerClone.location = currentLocation;
                customerClone.location.all_results = _parseAddressCheckerLocation(currentLocation, allLocations);
                return customerClone;
              });
            }]
          }
        }
      }
    }).state(States.modalVisitChecker, {
      url: '/visitchecker/{visitID}',
      views: {
        'modal@': {
          templateUrl: 'visits/checker.html',
          controller: 'visitCheckerC',
          controllerAs: 'visitChecker',
          resolve: {
            isLocked: ["$q", "$stateParams", "VisitF", "RouteS", function($q, $stateParams, VisitF, RouteS) {
              var visit = VisitF.getVisit($stateParams.visitID);
              if (RouteS.isVisitLocked(visit.id)) {
                return $q.reject();
              }
            }],
            visit: ["$stateParams", "$q", "ProjectF", "VisitF", function($stateParams, $q, ProjectF, VisitF) {
              var currentLocation, localVisit, visitId, _ref, _ref1;
              visitId = $stateParams.visitID;
              localVisit = _.cloneDeep(VisitF.getVisit(visitId));
              if (!(localVisit != null ? localVisit.location : void 0)) {
                return $q.reject();
              }
              if ((_ref = (_ref1 = localVisit.visitStatus) != null ? _ref1.status : void 0) === 'done' || _ref === 'skipped') {
                return $q.reject();
              }
              currentLocation = {
                address: localVisit.location.address,
                coords: localVisit.location.coords
              };
              if (localVisit.location.num_results > 1 || localVisit.location.all_results) {
                return ProjectF.fetchProjectVisit(visitId).then(function(res) {
                  if (!res.location) {
                    return $q.reject();
                  }
                  localVisit.location.all_results = _parseAddressCheckerLocation(currentLocation, res.location.all_results);
                  return localVisit;
                });
              } else {
                localVisit.location.all_results = [currentLocation];
                return localVisit;
              }
            }]
          }
        }
      }
    }).state(States.projectVisitsDuplicate, {
      url: '/{visitID}/duplicate',
      templateUrl: 'hud/project/visits/duplicate.html',
      controller: ["$scope", "$state", "$stateParams", "$previousState", "VisitF", "AnalyticsS", function($scope, $state, $stateParams, $previousState, VisitF, AnalyticsS) {
        var visitClone;
        var visit = VisitF.getVisit($stateParams.visitID);
        if (visit == null) {
          return $state.go(States.main);
        }
        $previousState.memo($scope.visit.previousState);
        visitClone = _.cloneDeep(visit);
        delete visitClone.id;
        AnalyticsS.track('Rescheduled stop');
        return $scope.visit.initializeEntry(visitClone);
      }]
    }).state(States.projectDrivers, {
      url: '/drivers',
      templateUrl: 'hud/project/drivers/index.html',
      controller: 'DriverC',
      controllerAs: 'driver'
    }).state(States.projectDriversList, {
      url: '/list',
      templateUrl: 'hud/project/drivers/list.html'
    }).state(States.projectDriversCreate, {
      url: '/create',
      templateUrl: 'hud/project/drivers/create.html',
      controller: ["$scope", function($scope) {
        return $scope.driver.initializeEntry();
      }]
    }).state(States.projectDriversQuickadd, {
      url: '/quickadd',
      templateUrl: 'hud/project/drivers/quickadd.html',
      controller: ["$scope", function($scope) {
        return $scope.driver.initializeEntry();
      }]
    }).state(States.projectDriversUpload, {
      url: '/upload',
      templateUrl: 'hud/project/drivers/upload.html',
      controller: 'DriverUploadC',
      controllerAs: 'upload'
    }).state(States.projectDriversEdit, {
      url: '/{driverID}/edit',
      templateUrl: 'hud/project/drivers/edit.html',
      resolve: {
        isLocked: ["$q", "$stateParams", "DriverF", "RouteS", "project", function($q, $stateParams, DriverF, RouteS, project) {
          var driver = DriverF.getDriver($stateParams.driverID);
          if (RouteS.isRouteLocked(driver.id)) {
            return $q.reject();
          }
        }]
      },
      controller: ["$scope", "$state", "$stateParams", "$previousState", "DriverF", function($scope, $state, $stateParams, $previousState, DriverF) {
        var driver, driverClone;
        $previousState.memo($scope.driver.previousState);
        driver = DriverF.getDriver($stateParams.driverID);
        if (driver == null) {
          return $state.go('hud');
        }
        driverClone = _.cloneDeep(driver);
        return $scope.driver.initializeEntry(driverClone);
      }]
    }).state(States.projectRoute, {
      url: '/route',
      views: {
        'content@hud.nav.project': {
          templateUrl: 'hud/project/route/index.html',
          controller: 'RouteC',
          controllerAs: 'route'
        },
        'sidepanel@hud.nav.project': {
          templateUrl: 'hud/project/sidepanel/index.html',
          controller: 'SidepanelC',
          controllerAs: 'side'
        }
      },
      onEnter: ["MarkersF", function(MarkersF) {
        return MarkersF.fitToPoints(MarkersF.OFFSET.ROUTE_VIEW);
      }]
    }).state(States.projectRouteTimeline, {
      url: '/timeline',
      templateUrl: 'hud/project/route/timeline.html',
      controller: 'RouteTimelineC',
      controllerAs: 'routeTimeline'
    }).state(States.projectRoutePlan, {
      url: '/plan'
    }).state(States.projectRouteLive, {
      url: '/live'
    }).state(States.projectRouteEdit, {
      url: '/edit'
    }).state(States.projectRouteDispatch, {
      url: '/dispatch',
      templateUrl: 'hud/project/route/dispatch.html',
      controller: 'RouteDispatchC',
      controllerAs: 'routeDispatch'
    }).state(States.modal, {
      onEnter: ["$state", "$previousState", "ngDialog", "AccountF", "SettingsF", "MessagingF", function($state, $previousState, ngDialog, AccountF, SettingsF, MessagingF) {
        var STATE_MEMO, dialog;
        if (!$previousState.get()) {
          return $state.go(States.projectRoutePlan);
        }
        STATE_MEMO = 'modalInvoker';
        $previousState.memo(STATE_MEMO);
        dialog = ngDialog.open({
          plain: true,
          template: '<div ui-view="modal"></div>',
          className: 'modal',
          preCloseCallback: function(value) {
            if ($state.current.name === States.modalSettings && value === '$document' && SettingsF.hasChanged) {
              MessagingF.replaceWarning("MESSAGES.UNSAVED_SETTINGS", null, null, "OK");
              return false;
            }
            if ($state.current.name === States.modalQuestionnaire && !value) {
              return false;
            }
            return true;
          },
          controller: [
            "$scope", function($scope) {
              $scope.states = States;
              return $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState) {
                var keepQuestionnaire = AccountF.shouldShowQuestionnaire() && fromState.name === States.modalQuestionnaire;
                if (!(toState.$$state().includes[States.modal] || keepQuestionnaire)) {
                  return $scope.closeThisDialog();
                }
              });
            }
          ]
        });
        return dialog.closePromise.then(function(res) {
          if (res.value && res.value !== '$document') {
            $previousState.forget(STATE_MEMO);
            return $state.go(res.value);
          }
          if ($previousState.get(STATE_MEMO).state) {
            return $previousState.go(STATE_MEMO);
          }
        });
      }]
    }).state(States.modalOptInBeta, {
      url: '/optinbeta',
      views: {
        'modal@': {
          templateUrl: 'optInBeta/index.html',
          controller: 'OptInBetaC',
          controllerAs: 'optInBeta'
        }
      }
    }).state(States.modalAccount, {
      url: '/account',
      views: {
        'modal@': {
          templateUrl: 'account/index.html',
          controller: 'AccountC',
          controllerAs: 'account'
        }
      }
    }).state(States.modalAccountUpgrade, {
      url: '/upgrade',
      views: {
        'modal@': {
          templateUrl: 'account/upgrade.html',
          controller: 'UpgradeC',
          controllerAs: 'upgrade'
        }
      }
    }).state(States.modalAccountCardUpdate, {
      url: '/card',
      views: {
        'modal@': {
          templateUrl: 'account/updateCard.html',
          controller: 'UpdateCardC',
          controllerAs: 'update'
        }
      }
    }).state(States.modalSettings, {
      url: '/settings',
      views: {
        'modal@': {
          templateUrl: 'account/settings.html',
          controller: 'SettingsC',
          controllerAs: 'settings'
        }
      }
    }).state(States.modalVideo, {
      url: '/video',
      views: {
        'modal@': {
          templateUrl: 'hud/video.html',
          controller: 'VideoC',
          controllerAs: 'video'
        }
      }
    }).state(States.modalCsvMap, {
      url: '/csv-map'
    }).state(States.modalCsvMapVisits, {
      url: '/visits',
      views: {
        'modal@': {
          templateUrl: 'csv/map.html',
          controller: 'VisitCsvMapC',
          controllerAs: 'csvMap'
        }
      }
    }).state(States.modalCsvMapDrivers, {
      url: '/drivers',
      views: {
        'modal@': {
          templateUrl: 'csv/map.html',
          controller: 'DriverCsvMapC',
          controllerAs: 'csvMap'
        }
      }
    }).state(States.modalCsvMapCustomers, {
      url: '/customers',
      views: {
        'modal@': {
          templateUrl: 'csv/map.html',
          controller: 'CustomerCsvMapC',
          controllerAs: 'csvMap'
        }
      }
    }).state(States.modalProjects, {
      url: '/projects',
      params: {
        selectedCustomerIds: []
      },
      views: {
        'modal@': {
          template: '<div ui-view></div>',
          controller: 'ProjectsModalC',
          controllerAs: 'projectsModalC'
        }
      }
    }).state(States.modalProjectsNew, {
      url: '/new',
      templateUrl: 'projects/new.html'
    }).state(States.modalProjectsLoad, {
      url: '/load',
      templateUrl: 'projects/load.html',
      controller: 'ProjectLoadC',
      controllerAs: 'projectLoadC',
      resolve: {
        projects: ["ProjectF", "AccountF", function(ProjectF, AccountF) {
          var dateFrom, dateFromFormatted, daysProjectsQuery;
          daysProjectsQuery = AccountF.maxDaysProjectsQuery();
          if (daysProjectsQuery) {
            dateFrom = new Date();
            dateFrom.setDate(dateFrom.getDate() - daysProjectsQuery);
            dateFromFormatted = dateFrom.toISOString().slice(0, 10);
            return ProjectF.fetchProjectsWithDates(dateFromFormatted);
          } else {
            return ProjectF.fetchProjects();
          }
        }]
      }
    }).state(States.modalProjectsDuplicate, {
      url: '/duplicate',
      templateUrl: 'projects/duplicate.html'
    }).state(States.modalProjectsEdit, {
      url: '/edit',
      templateUrl: 'projects/edit.html',
      controller: ["$scope", "ProjectF", "TimeUtilF", function($scope, ProjectF, TimeUtilF) {
        var project = ProjectF.project;
        if (!project) {
          return;
        }
        $scope.projectsModalC.date = project.date;
        return $scope.projectsModalC.name = project.name;
      }]
    }).state(States.modalQuestionnaire, {
      url: '/questionnaire',
      views: {
        'modal@': {
          templateUrl: 'questionnaire/questionnaire.html',
          controller: 'QuestionnaireC',
          controllerAs: 'questionnaire'
        }
      }
    }).state(States.modalProjectReport, {
      url: '/report',
      views: {
        'modal@': {
          templateUrl: 'reports/report.html',
          controller: 'ProjectReportC',
          controllerAs: 'report'
        }
      }
    }).state(States.modalProjectEndDay, {
      url: '/end-day',
      views: {
        'modal@': {
          templateUrl: 'projects/endDay.html',
          controller: 'ProjectEndDayC',
          controllerAs: 'endDayC'
        }
      }
    }).state(States.modalCustomerUploadError, {
      url: '/customer-error',
      views: {
        'modal@': {
          templateUrl: 'hud/customers/customerUploadError.html',
          controller: 'CustomerUploadErrorC',
          controllerAs: 'customerUploadError'
        }
      }
    }).state(States.modalCustomerProfile, {
      url: '/customer-profile',
      views: {
        'modal@': {
          templateUrl: 'hud/customers/customerModal.html',
          controller: 'CustomersTableC',
          controllerAs: 'customersTable'
        }
      },
      resolve: {
        geocodeInfo: ["CustomerF", function(CustomerF) {
          return CustomerF.getGeocodeInfo();
        }],
        results: ["CustomerF", "AccountF", "LocalStorageStringF", function(CustomerF, AccountF, LocalStorageStringF) {
          return AccountF.getCurrentUser().then(function() {
            var sortOrder;
            var sortBy = LocalStorageStringF('customersSortBy').load();
            sortOrder = LocalStorageStringF('customersSortOrder').load();
            return CustomerF.getCustomers(sortBy, sortOrder, "", 25, 0);
          });
        }]
      }
    }).state(States.internalProjects, {
      url: '/internalProjects',
      views: {
        'main@hud.nav': {
          templateUrl: 'hud/internal/index.html',
          controller: 'IProjectsTableC',
          controllerAs: 'iProjectsTable'
        }
      },
      onEnter: ["$state", "AccountF", function($state, AccountF) {
        if (!AccountF.getUser().isRoutificAdmin) {
          return $state.go(States.projectRoutePlan);
        }
      }]
    }).state(States.projectRouteDebug, {
      url: '/debug',
      templateUrl: 'hud/internal/debug.html',
      controller: 'IRouteDebugC',
      controllerAs: 'routeDebug',
      onEnter: ["$state", "AccountF", function($state, AccountF) {
        if (!AccountF.getUser().isRoutificAdmin) {
          return $state.go(States.projectRoutePlan);
        }
      }]
    });
  }]);

}).call(this);

(function() {
  var _exceptionHandler;

  _exceptionHandler = function($delegate, $injector) {
    var Constants = null;
    return function(exception, cause) {
      Constants || (Constants = $injector.get("Constants"));
      if (!Constants.inProduction) {
        return $delegate(exception, cause);
      }
    };
  };

  angular.module('app').config(["$provide", function($provide) {
    return $provide.decorator('$exceptionHandler', ['$delegate', '$injector', _exceptionHandler]);
  }]);

}).call(this);


/*
expId
  <experimentId>.<variantId>

shouldRun
  Expose condition fn to window for Google optimize to call
  to determine whether the experiment is shown

changes
  List of features to be checked if usable in this experiment
 */

(function() {
  var AbExperiments = function(AccountF, $kookies) {
    AbExperiments = {};
    AbExperiments.fullFeatureDemo = {
      expId: 'zYsFwlyiRSqZEO3FM_eiCw.1',
      shouldRun: function() {
        var cookie;
        if (!AccountF.isDemoFinished()) {
          $kookies.set("routific-fullFeatureDemo", true);
          return true;
        } else {
          cookie = $kookies.get("routific-fullFeatureDemo");
          return (cookie != null) && JSON.parse(cookie) === true;
        }
      },
      changes: {
        'dragDrop': true,
        'mapMarker': true,
        'searchStop': true,
        'routeLock': true,
        'reverseRoute': true,
        'editDriver': true,
        'editVisit': true,
        'routeHistory': true,
        'chartToggle': true,
        'summaryDownload': true,
        'footerActions': true,
        'modifiedDemoDispatch': true
      }
    };
    return AbExperiments;
  };
  AbExperiments.$inject = ["AccountF", "$kookies"];

  angular.module('app').factory('AbExperiments', AbExperiments);

}).call(this);

(function() {
  var AbTestF = function() {
    AbTestF = {};
    AbTestF.activateChameleonTour = function() {
      return typeof chmln !== "undefined" && chmln !== null ? chmln.show("5d780c5d7f01340004d372d9", {
        use_segmentation: false,
        once: true,
        redirect: false
      }) : void 0;
    };
    AbTestF.poll = function(fn, timeout, interval) {
      var checkCondition, endTime;
      endTime = Number(new Date) + (timeout || 2000);
      interval = interval || 100;
      checkCondition = function(resolve, reject) {
        var result = fn();
        if (result) {
          resolve(result);
        } else if (Number(new Date) < endTime) {
          setTimeout(checkCondition, interval, resolve, reject);
        } else {
          reject(new Error('timed out abTest ' + fn + ': '));
        }
      };
      return new Promise(checkCondition);
    };
    return AbTestF;
  };

  angular.module('app').factory('AbTestF', AbTestF);

}).call(this);

(function() {
  var     __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  var AccountC = function($window, $scope, $translate, AccountF, Constants, TimeUtilF, AnalyticsS, Plans, UpgradeUtil, Translate, ConfirmF, MessagingF, ProjectF) {
    var _currentPlan, _mapErrorToField, _ref, _ref1, _translationNames, _translations;
    this.user = AccountF.getUser();
    this.isIndividual = this.user.type === 'individual';
    this.isPaid = AccountF.isPaid();
    this.hasShopifyBilling = AccountF.hasShopifyBilling();
    this.getShopifyDomain = AccountF.getShopifyDomain();
    _translations = null;
    _translationNames = null;
    _mapErrorToField = (function(_this) {
      return function(formName, field, error, errorList) {
        if (((errorList != null) && __indexOf.call(errorList, error) >= 0) || !errorList) {
          _this[formName].response[field] = "ACCOUNT.VALIDATION." + error;
          return true;
        }
        return false;
      };
    })(this);
    if (((_ref = this.user.plan) != null ? _ref.name : void 0) != null) {
      this.isPerVisit = Plans.PER_VISIT_PLANS[this.user.plan.name];
      _currentPlan = Plans.alias.type[this.user.plan.name];
      if (_currentPlan) {
        this.planName = _currentPlan.name;
        this.features = _currentPlan.features;
      }
    } else {
      this.planName = this.isPaid ? 'Paid User' : 'Trial User';
      this.features = Plans.type.TRIAL.addons;
    }
    if ((this.user.stripe_obj != null) && _currentPlan) {
      this.card = this.user.stripe_obj.sources.data[0];
      this.subscribedAddons = UpgradeUtil.getSubscribedAddons(this.user);
      if (this.user.billingCycle != null) {
        this.billingCycle = UpgradeUtil.getBillingCycle(this.user.billingCycle);
      }
      this.billAmount = UpgradeUtil.getSubtotal(this.user.maxVehicles, _currentPlan, this.subscribedAddons, this.billingCycle);
    }
    this.originalLanguage = _.clone(Translate.selectedLanguage);
    this.selectedLanguage = Translate.selectedLanguage;
    this.enabledNativeApp = (_ref1 = AccountF.getUser().settings) != null ? _ref1.nativeApp : void 0;
    this.notifyNativeAppOptInChange = function() {
      var event, _ref2;
      if ((((_ref2 = AccountF.getUser().settings) != null ? _ref2.nativeApp : void 0) == null) && this.enabledNativeApp) {
        MessagingF.replaceSuccessPopup("ACCOUNT.NATIVE_APP_ENABLED");
        event = 'First opted in native app';
      } else if (this.enabledNativeApp) {
        MessagingF.replaceSuccessPopup("ACCOUNT.NATIVE_APP_ENABLED");
        event = 'Opted in native app';
      } else {
        MessagingF.replaceSuccessPopup("ACCOUNT.NATIVE_APP_DISABLED");
        event = 'Opted out native app';
      }
      AnalyticsS.track(event);
      AnalyticsS.set({
        "Native App": this.enabledNativeApp
      });
      return AccountF.updateSettings({
        nativeApp: this.enabledNativeApp
      }).then(function() {
        return ProjectF.reloadProject();
      });
    };
    this.getTranslations = function() {
      var t;
      _translations || (_translations = Translate.getAvailableTranslations());
      _translationNames || (_translationNames = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = _translations.length; _i < _len; _i++) {
          t = _translations[_i];
          _results.push(t.name);
        }
        return _results;
      })());
      return _translationNames;
    };
    this.changeLanguage = function() {
      var t, _i, _len, _results;
      if (!(this.selectedLanguage && _translations && this.originalLanguage !== this.selectedLanguage)) {
        return;
      }
      _results = [];
      for (_i = 0, _len = _translations.length; _i < _len; _i++) {
        t = _translations[_i];
        if (!(t.name === this.selectedLanguage)) {
          continue;
        }
        ConfirmF.confirm("MESSAGES.CHANGE_LANGUAGE_CONFIRM").then(function() {
          AnalyticsS.track('103 Changed Language', {
            language: t.name
          });
          return Translate.changeTranslation(t, true, AccountF.updateLanguage);
        });
        break;
      }
      return _results;
    };
    this.hasSubscribedAddons = function() {
      var activeAddons, addon, _i, _len, _ref2;
      if (!this.subscribedAddons) {
        return false;
      }
      activeAddons = false;
      _ref2 = Object.keys(this.subscribedAddons);
      for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
        addon = _ref2[_i];
        activeAddons = activeAddons || this.subscribedAddons[addon].active;
      }
      return Object.keys(this.subscribedAddons).length !== 0 && activeAddons;
    };
    this.updateEmailModel = {};
    this.updatePasswordModel = {};
    this.isGrandfatheredPlan = function() {
      return (_currentPlan != null ? _currentPlan.grandfathered : void 0) != null;
    };
    this.isOldPlan = function() {
      return _currentPlan != null ? _currentPlan.deprecated : void 0;
    };
    this.goToShopify = function() {
      AnalyticsS.track('112 Intent upgrade shopify app');
      return window.location = "https://route-planning-app.routific.com/upgrade?shop=" + this.getShopifyDomain;
    };
    this.updateEmail = function(valid) {
      var email, emailFieldError, password, passwordFieldError, _ref2;
      if (!valid) {
        return;
      }
      ConfirmF.confirmInfo($translate.instant("ACCOUNT.EMAIL_POPUP_HEADING"), $translate.instant("ACCOUNT.EMAIL_POPUP_TEXT"), void 0, $translate.instant("ACCOUNT.EMAIL_POPUP_ACTION"));
      this.updateEmailForm.response = {};
      _ref2 = this.updateEmailModel, email = _ref2.email, password = _ref2.password;
      emailFieldError = ['ERR_MISSING_EMAIL', 'ERR_EXISTING_EMAIL', 'ERR_DISPOSABLE_EMAIL'];
      passwordFieldError = ['ERR_MISMATCH_PASSWORD', 'ERR_MISSING_PASSWORD'];
      return AccountF.updateEmail(email, password).then((function(_this) {
        return function(res) {
          if (res.status === 202) {
            _mapErrorToField('updateEmailForm', 'genericSuccess', 'CONFIRM_REQUIRED');
          } else {
            MessagingF.replaceSuccessPopup("ACCOUNT.UPDATE_EMAIL_SUCCESS");
          }
          _this.user = AccountF.getUser();
          _this.updateEmailModel = {
            email: _this.user.email
          };
          _this.updateEmailForm.$setUntouched();
          return _this.updateEmailForm.$setPristine();
        };
      })(this))["catch"](function(_arg) {
        var error;
        var data = _arg.data;
        error = data.error_type;
        if (!(_mapErrorToField('updateEmailForm', 'email', error, emailFieldError) || _mapErrorToField('updateEmailForm', 'password', error, passwordFieldError))) {
          return _mapErrorToField('updateEmailForm', 'genericError', error);
        }
      });
    };
    this.updatePassword = function(valid) {
      var confirm_new_password, newPasswordFieldError, new_password, password, passwordFieldError, _ref2;
      if (!valid) {
        return;
      }
      this.updatePasswordForm.response = {};
      _ref2 = this.updatePasswordModel, password = _ref2.password, new_password = _ref2.new_password, confirm_new_password = _ref2.confirm_new_password;
      passwordFieldError = ['ERR_MISMATCH_PASSWORD', 'ERR_MISSING_PASSWORD'];
      newPasswordFieldError = ['ERR_MISSING_NEW_PASSWORD', 'ERR_LENGTH_PASSWORD'];
      return AccountF.updatePassword(password, new_password).then((function(_this) {
        return function(res) {
          _this.updatePasswordModel = {};
          _this.updatePasswordForm.$setUntouched();
          _this.updatePasswordForm.$setPristine();
          return MessagingF.replaceSuccessPopup("ACCOUNT.UPDATE_PASS_SUCCESS");
        };
      })(this))["catch"](function(_arg) {
        var error;
        var data = _arg.data;
        error = data.error_type;
        if (!(_mapErrorToField('updatePasswordForm', 'password', error, passwordFieldError) || _mapErrorToField('updatePasswordForm', 'new_password', error, newPasswordFieldError))) {
          return _mapErrorToField('updatePasswordForm', 'genericError', error);
        }
      });
    };
    AnalyticsS.track('005 Account popup');
  };
  AccountC.$inject = ["$window", "$scope", "$translate", "AccountF", "Constants", "TimeUtilF", "AnalyticsS", "Plans", "UpgradeUtil", "Translate", "ConfirmF", "MessagingF", "ProjectF"];

  angular.module('app').controller('AccountC', AccountC);

}).call(this);

(function() {
  var AccountF = function($injector, $kookies, $window, $http, $q, $raven, Constants, TimeUtilF, EventListenersF, Events, UpgradeUtil, Feature, LoggerF, AbTestF) {
    var ACCOUNT_URL, BETA_TOKEN_KEY, BETA_URL, COOKIE_OPTIONS, DELIVER_METHOD, FEATURE_TRIAL_PERIOD_DAYS, INVALID_NUM_VEHICLES, INVALID_NUM_VEHICLES_ERROR, MISSING_ADDONS_LIST, MISSING_BILLING_CYCLE, MISSING_SELECTED_PLAN, MISSING_UPGRADE_DATA, NULL_STRIPE_TOKEN, ProjectF, TOKEN_KEY, TRIAL_PERIOD_DAYS, _authHeader, _dateFromObjectId, _fetchUserToken, _getTrialEnd, _initIntercom, _notificationDeliveryMethod, _privateMethods, _runOnce, _shopify, _token, _unreadMessages, _upgrade, _user, _validatateUpgradeData;
    TOKEN_KEY = 'token';
    BETA_TOKEN_KEY = 'access_token';
    ACCOUNT_URL = "" + Constants.routificUrl;
    BETA_URL = "" + Constants.betaUrl;
    COOKIE_OPTIONS = {
      domain: '.routific.com'
    };
    TRIAL_PERIOD_DAYS = Constants.TRIAL_PERIOD_DAYS;
    FEATURE_TRIAL_PERIOD_DAYS = Constants.FEATURE_TRIAL_PERIOD_DAYS;
    INVALID_NUM_VEHICLES_ERROR = new Error('Number of vehicles must be greater than 0');
    NULL_STRIPE_TOKEN = new Error('Stripe token is required');
    INVALID_NUM_VEHICLES = INVALID_NUM_VEHICLES_ERROR;
    MISSING_UPGRADE_DATA = new Error('Missing upgrade data object');
    MISSING_ADDONS_LIST = new Error('Missing addOns property from upgrade data');
    MISSING_SELECTED_PLAN = new Error('Missing plan property from upgrade data');
    MISSING_BILLING_CYCLE = new Error('Missing isAnnual property from upgrade data');
    ProjectF = null;
    _validatateUpgradeData = function(upgradeData, isUpgrade) {
      if (isUpgrade == null) {
        isUpgrade = false;
      }
      if (upgradeData == null) {
        throw MISSING_UPGRADE_DATA;
      }
      if (!upgradeData.plan) {
        throw MISSING_SELECTED_PLAN;
      }
      if (!upgradeData.hasOwnProperty('isAnnual')) {
        throw MISSING_BILLING_CYCLE;
      }
      if (!upgradeData.addOns) {
        throw MISSING_ADDONS_LIST;
      }
      if (!((upgradeData.numVehicles != null) && upgradeData.numVehicles > 0)) {
        throw INVALID_NUM_VEHICLES;
      }
      if (isUpgrade) {
        if (!upgradeData.card) {
          throw NULL_STRIPE_TOKEN;
        }
      }
    };
    _fetchUserToken = function() {
      var token = $kookies.get(TOKEN_KEY) || Constants.apiTestToken;
      token = token === "undefined" ? null : token;
      return token;
    };
    DELIVER_METHOD = {
      EMAIL: 'email',
      SMS: 'sms',
      NONE: 'none'
    };
    _notificationDeliveryMethod = DELIVER_METHOD.NONE;
    _runOnce = false;
    _unreadMessages = 0;
    _user = null;
    _upgrade = null;
    _shopify = null;
    _token = _fetchUserToken();
    _authHeader = {
      headers: {
        'Authorization': "bearer " + _token,
        'Routific-App': Constants.mainAppID
      }
    };
    _dateFromObjectId = function(id) {
      return new Date(parseInt(id.substring(0, 8), 16) * 1000);
    };
    _getTrialEnd = function(user) {
      var trialEnd, _ref;
      if (user.trialExpiry) {
        trialEnd = user.trialExpiry;
      } else {
        trialEnd = ((_ref = user.stripe_obj) != null ? _ref.subscriptions.data[0].trial_end : void 0) * 1000;
      }
      if (trialEnd) {
        trialEnd = new Date(trialEnd);
      } else {
        trialEnd = TimeUtilF.addDays(user.signUpAt, TRIAL_PERIOD_DAYS);
      }
      return trialEnd;
    };
    _privateMethods = {
      redirectTo: function(location) {
        return $window.location.href = location;
      },
      openInNewTab: function(location) {
        return $window.open(location, '_blank');
      }
    };
    _initIntercom = function(status) {
      if (!_runOnce) {
        _runOnce = true;
        return typeof analytics !== "undefined" && analytics !== null ? analytics.ready(function() {
          $window.Intercom('onUnreadCountChange', function(unreadCount) {
            return _unreadMessages = unreadCount;
          });
          analytics.page(void 0, void 0, void 0, {
            Intercom: {
              hideDefaultLauncher: true
            }
          });
          if (typeof Intercom !== "undefined" && Intercom !== null) {
            Intercom('update', {
              "hide_default_launcher": true
            });
          }
          if (typeof analytics !== "undefined" && analytics !== null) {
            analytics.identify(_user._id, {
              email: _user.email,
              name: _user.firstName != null ? _user.firstName : void 0,
              status: status
            });
          }
          return typeof posthog !== "undefined" && posthog !== null ? posthog.identify(_user._id, {
            email: _user.email,
            name: _user.firstName != null ? _user.firstName : void 0,
            status: status
          }) : void 0;
        }) : void 0;
      }
    };
    AccountF = {};
    AccountF.getUnreadMessages = function() {
      return _unreadMessages;
    };
    AccountF.fetchUser = function() {
      return $http.get("" + Constants.apiPath + "/users/login", _authHeader).then(function(res) {
        var bodyElement, currentData, status, userContext, _ref, _ref1, _ref2;
        _user = res.data;
        LoggerF.updateUserInfo(_user);
        _user.token = _fetchUserToken();
        status = _user.status === 'cancelled subscription' ? 'churned' : _user.status;
        if (typeof mixpanel !== "undefined" && mixpanel !== null) {
          mixpanel.identify(_user._id);
        }
        if (typeof chmln !== "undefined" && chmln !== null) {
          chmln.identify(_user._id, {
            email: _user.email
          });
        }
        if (typeof profitwell !== "undefined" && profitwell !== null) {
          profitwell('user_email', _user.email);
        }
        _initIntercom(status);
        _user.signUpAt = _dateFromObjectId(_user._id);
        currentData = new Date();
        if (Number(_user.signUpAt) > currentData.getTime() - 50000) {
          window.routificNewUser = true;
        }
        _user.trialEnd = _getTrialEnd(_user);
        _user.isInTrial = new Date(_user.trialEnd) > new Date();
        window.routificIsInTrial = _user.isInTrial;
        bodyElement = document.getElementsByTagName('body')[0];
        bodyElement.classList.add("intrial-" + _user.isInTrial);
        _user.canLiveTrackingOptIn = ((_ref = _user.settings) != null ? (_ref1 = _ref.trials) != null ? (_ref2 = _ref1[Feature.LIVE_TRACKING]) != null ? _ref2.expiryTime : void 0 : void 0 : void 0) == null;
        AccountF.updateEnabledAddOns(_user);
        if (AccountF.hasCustomerNotification()) {
          AccountF.getCustomerNotificationSettings();
        }
        userContext = {
          id: _user._id,
          email: _user.email
        };
        $raven.setUserContext(userContext);
        return _user;
      });
    };
    AccountF.fetchUpgrade = function() {
      return $http.get("" + Constants.apiPath + "/upgrade", _authHeader).then(function(res) {
        return _upgrade = res.data;
      });
    };
    AccountF.fetchShopifyDetails = function() {
      return $http.get("" + Constants.apiPath + "/users/shopify-shop", _authHeader).then(function(res) {
        return _shopify = res.data;
      });
    };
    AccountF.fetchUserToken = function() {
      _token = _fetchUserToken();
      return _token;
    };
    AccountF.setBetaUserToken = function(access_token) {
      var cookieOptions;
      var cookieDomain = Constants.cookieDomain;
      if (Constants.cookieDomain === "null") {
        cookieDomain = null;
      }
      cookieOptions = {
        domain: cookieDomain,
        path: "/"
      };
      return $kookies.set(BETA_TOKEN_KEY, access_token, cookieOptions);
    };
    AccountF.fetchBetaUserToken = function() {
      return $kookies.get(BETA_TOKEN_KEY);
    };
    AccountF.getUserToken = function() {
      return _token;
    };
    AccountF.getUser = function() {
      return _user;
    };
    AccountF.getCurrentUser = function() {
      if (_user) {
        return $q.when(_user);
      } else {
        return AccountF.fetchUser();
      }
    };
    AccountF.getAuthHeader = function() {
      var authHeader, _ref;
      ProjectF || (ProjectF = $injector.get('ProjectF'));
      authHeader = _.cloneDeep(_authHeader);
      if ((ProjectF != null ? (_ref = ProjectF.project) != null ? _ref.version : void 0 : void 0) != null) {
        authHeader.headers['Routific-Project-Version'] = ProjectF.project.version;
      }
      return authHeader;
    };
    AccountF.goToLogout = function() {
      $kookies.remove(TOKEN_KEY, COOKIE_OPTIONS);
      $raven.setUserContext();
      if (typeof posthog !== "undefined" && posthog !== null) {
        posthog.reset();
      }
      return _privateMethods.redirectTo("" + ACCOUNT_URL + "/login");
    };
    AccountF.goToLogin = function() {
      return _privateMethods.redirectTo("" + ACCOUNT_URL + "/login");
    };
    AccountF.goToBeta = function() {
      return _privateMethods.openInNewTab("" + BETA_URL);
    };
    AccountF.upgrade = function(upgradeData) {
      var data, e, isUpgrade;
      try {
        _validatateUpgradeData(upgradeData, isUpgrade = true);
      } catch (_error) {
        e = _error;
        return $q.reject(e);
      }
      data = UpgradeUtil.formatUpgradeData(upgradeData);
      return $http.post("" + Constants.apiPath + "/upgrade", data, _authHeader).then(function(res) {
        var user = res.data;
        _user.status = user.status;
        _user.maxVehicles = user.maxVehicles;
        _user.plan = user.plan;
        _user.settings = user.settings;
        _user.stripe_obj = user.stripe_obj;
        _user.billingCycle = user.billingCycle;
        AccountF.updateEnabledAddOns(_user);
        return _user;
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    AccountF.validateCoupon = function(couponCode, isAnnual) {
      return $http.get("" + Constants.apiPath + "/upgrade/coupon/" + couponCode + "?annual=" + isAnnual, _authHeader).then(function(res) {
        var _couponDetail;
        _couponDetail = res.data;
        return _couponDetail;
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    AccountF.changePlan = function(upgradeData) {
      var data, e, isUpgrade;
      try {
        _validatateUpgradeData(upgradeData, isUpgrade = false);
      } catch (_error) {
        e = _error;
        return $q.reject(e);
      }
      data = UpgradeUtil.formatUpgradeData(upgradeData);
      return $http.put("" + Constants.apiPath + "/upgrade/plan", data, _authHeader).then(function(res) {
        var user = res.data;
        _user.maxVehicles = user.maxVehicles;
        _user.plan = user.plan;
        _user.settings = user.settings;
        _user.stripe_obj = user.stripe_obj;
        _user.billingCycle = user.billingCycle;
        AccountF.updateEnabledAddOns(_user);
        return _user;
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    AccountF.updateCard = function(cardToken) {
      var data;
      if (!cardToken) {
        return $q.reject(NULL_STRIPE_TOKEN);
      }
      data = {
        card: cardToken
      };
      return $http.put("" + Constants.apiPath + "/upgrade/card", data, _authHeader).then(function(res) {
        _user.stripe_obj = res.data;
        return _user;
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    AccountF.updateSettings = function(settings, localUpdate) {
      var data, k, v;
      if (localUpdate == null) {
        localUpdate = false;
      }
      for (k in settings) {
        v = settings[k];
        _user.settings[k] = v;
      }
      data = {
        settings: _user.settings
      };
      if (localUpdate) {
        return;
      }
      return $http.put("" + Constants.apiPath + "/users", data, _authHeader).then(function(res) {
        return res.data;
      });
    };
    AccountF.updateDeliveryMethod = function(newMethod) {
      if (_notificationDeliveryMethod === newMethod) {
        return;
      }
      _notificationDeliveryMethod = newMethod;
      return EventListenersF.notify(Events.DELIVERY_METHOD_CHANGED);
    };
    AccountF.getCustomerNotificationSettings = function() {
      return $http.get("" + Constants.notificationApiPath + "/users/settings/delivery-method", _authHeader).then(function(res) {
        return AccountF.updateDeliveryMethod(res.data.delivery_method);
      })["catch"](function(err) {});
    };
    AccountF.updateLanguage = function(languageId) {
      var data = {
        selectedLanguage: languageId
      };
      return $http.put("" + Constants.apiPath + "/users", data, _authHeader).then(function(res) {
        return res.data;
      });
    };
    AccountF.updateEmail = function(email, password) {
      var data = {
        email: email,
        password: password
      };
      return $http.post("" + Constants.apiPath + "/users/update-email", data, _authHeader).then(function(res) {
        if (res.status !== 202) {
          _user.email = email;
        }
        return res;
      });
    };
    AccountF.updatePassword = function(password, new_password) {
      var data = {
        password: password,
        new_password: new_password
      };
      return $http.post("" + Constants.apiPath + "/users/update-password", data, _authHeader);
    };
    AccountF.getUserName = function() {
      return (_user != null ? _user.firstName : void 0) || (_user != null ? _user.lastName : void 0) || _user.email;
    };
    AccountF.shouldShowQuestionnaire = function() {
      return false;
    };
    AccountF.maxDaysProjectsQuery = function() {
      var _ref;
      return _user != null ? (_ref = _user.settings) != null ? _ref.maxDaysProjectsQuery : void 0 : void 0;
    };
    AccountF.isDemoFinished = function() {
      return true;
    };
    AccountF.isDemoLinkOpened = function() {
      var _ref;
      return (_user != null ? (_ref = _user.settings) != null ? _ref.demoLinkOpened : void 0 : void 0) === true;
    };
    AccountF.isPaid = function() {
      return _user.status === 'paid';
    };
    AccountF.hasLiveTracking = function() {
      var _ref;
      return (_ref = _user.features) != null ? _ref[Feature.LIVE_TRACKING] : void 0;
    };
    AccountF.hasPaidLiveTracking = function() {
      var _ref, _ref1;
      return !!((_ref = _user.settings) != null ? (_ref1 = _ref.features) != null ? _ref1[Feature.LIVE_TRACKING] : void 0 : void 0);
    };
    AccountF.hasSignature = function() {
      var _ref;
      return (_ref = _user.features) != null ? _ref[Feature.SIGNATURE] : void 0;
    };
    AccountF.hasLiveChat = function() {
      var _ref;
      return (_user != null ? (_ref = _user.features) != null ? _ref[Feature.LIVE_CHAT] : void 0 : void 0) || _user.isInTrial;
    };
    AccountF.hasGPSTracking = function() {
      var _ref, _ref1;
      return (_user != null ? (_ref = _user.features) != null ? _ref[Feature.LIVE_TRACKING] : void 0 : void 0) && !!(_user != null ? (_ref1 = _user.settings) != null ? _ref1.nativeApp : void 0 : void 0);
    };
    AccountF.nativeAppEnabled = function() {
      var _ref;
      return _user != null ? (_ref = _user.settings) != null ? _ref.nativeApp : void 0 : void 0;
    };
    AccountF.isInTrial = function() {
      return _user.isInTrial;
    };
    AccountF.isPaid = function() {
      return _user.status === "paid";
    };
    AccountF.hasShopifyBilling = function() {
      return (_upgrade != null ? _upgrade.sign_up_origin : void 0) === "shopify";
    };
    AccountF.getShopifyDomain = function() {
      return _shopify != null ? _shopify.shopify_shop_domain : void 0;
    };
    AccountF.hasCustomerNotification = function() {
      var _ref;
      return _user != null ? (_ref = _user.features) != null ? _ref[Feature.CUSTOMER_NOTIFICATION] : void 0 : void 0;
    };
    AccountF.hasPaidCustomerNotification = function() {
      var _ref;
      return _user != null ? (_ref = _user.features) != null ? _ref['paidCustomerNotifications'] : void 0 : void 0;
    };
    AccountF.isEtaNotificationOn = function() {
      var _ref, _ref1;
      var etaFlag = Feature.CUSTOMER_NOTIFICATION_FLAG.ETA;
      return (_ref = _user.settings) != null ? (_ref1 = _ref.customerNotification) != null ? _ref1[etaFlag] : void 0 : void 0;
    };
    AccountF.enforcedMessageTruncateLength = function() {
      var _ref, _ref1;
      var enforcedMessageTruncateLengthFlag = Feature.CUSTOMER_NOTIFICATION_FLAG.ENFORCED_MESSAGE_TRUNCATE_LENGTH;
      return (_ref = _user.settings) != null ? (_ref1 = _ref.customerNotification) != null ? _ref1[enforcedMessageTruncateLengthFlag] : void 0 : void 0;
    };
    AccountF.isDOTWNotificationOn = function() {
      var _ref, _ref1;
      var dotwFlag = Feature.CUSTOMER_NOTIFICATION_FLAG.DRIVER_ON_THE_WAY;
      return (_ref = _user.settings) != null ? (_ref1 = _ref.customerNotification) != null ? _ref1[dotwFlag] : void 0 : void 0;
    };
    AccountF.isDeliveryConfirmationNotificationOn = function() {
      var _ref, _ref1;
      var deliveryFlag = Feature.CUSTOMER_NOTIFICATION_FLAG.DELIVERY_CONFIRMATION;
      return (_ref = _user.settings) != null ? (_ref1 = _ref.customerNotification) != null ? _ref1[deliveryFlag] : void 0 : void 0;
    };
    AccountF.isCancelledNotificationOn = function() {
      var _ref, _ref1;
      var cancelledFlag = Feature.CUSTOMER_NOTIFICATION_FLAG.CANCELLED;
      return (_ref = _user.settings) != null ? (_ref1 = _ref.customerNotification) != null ? _ref1[cancelledFlag] : void 0 : void 0;
    };
    AccountF.isTrimStopInfoFromSolution = function() {
      var _ref;
      return !!(_user != null ? (_ref = _user.settings) != null ? _ref.trimStopInfoFromSolution : void 0 : void 0);
    };
    AccountF.isEmailNotificationOn = function() {
      return AccountF.hasCustomerNotification() && _notificationDeliveryMethod === DELIVER_METHOD.EMAIL;
    };
    AccountF.isSmsNotificationOn = function() {
      return AccountF.hasCustomerNotification() && _notificationDeliveryMethod === DELIVER_METHOD.SMS;
    };
    AccountF.isNotificationDisabled = function() {
      return AccountF.hasCustomerNotification() && _notificationDeliveryMethod === DELIVER_METHOD.NONE;
    };
    AccountF.shouldHideCustomerNotificationUi = function() {
      return !AccountF.hasCustomerNotification() || AccountF.isNotificationDisabled();
    };
    AccountF.updateEnabledAddOns = function(user) {
      var featureName, features, isTrial, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
      features = {};
      _ref = Feature.ALL_ADD_ONS;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        featureName = _ref[_i];
        if (featureName === 'customerNotification') {
          features['paidCustomerNotifications'] = (_ref1 = user.settings) != null ? (_ref2 = _ref1.features) != null ? _ref2[featureName] : void 0 : void 0;
        }
        isTrial = new Date((_ref3 = user.settings) != null ? (_ref4 = _ref3.trials) != null ? (_ref5 = _ref4[featureName]) != null ? _ref5.expiryTime : void 0 : void 0 : void 0) > new Date();
        features[featureName] = ((_ref6 = user.settings) != null ? (_ref7 = _ref6.features) != null ? _ref7[featureName] : void 0 : void 0) || isTrial;
      }
      _user.features = features;
      return features;
    };
    AccountF.optInLiveTracking = function() {
      var optInSettings;
      if (!_user.canLiveTrackingOptIn) {
        return $q.reject();
      }
      optInSettings = {
        trials: {
          liveTracking: {
            optInTime: new Date(),
            expiryTime: TimeUtilF.addDays(Date.now(), Constants.FEATURE_TRIAL_PERIOD_DAYS)
          },
          signature: {
            optInTime: new Date(),
            expiryTime: TimeUtilF.addDays(Date.now(), Constants.FEATURE_TRIAL_PERIOD_DAYS)
          }
        }
      };
      return AccountF.updateSettings(optInSettings).then(function(user) {
        _user = user;
        _user.canLiveTrackingOptIn = false;
        return AccountF.updateEnabledAddOns(_user);
      });
    };
    AccountF.getLiveTrackingTrial = function() {
      var _ref, _ref1;
      return (_ref = _user.settings) != null ? (_ref1 = _ref.trials) != null ? _ref1[Feature.LIVE_TRACKING] : void 0 : void 0;
    };
    AccountF.isOptedOutOfLiveTracking = function() {
      var _ref, _ref1, _ref2;
      return ((_ref = _user.settings) != null ? (_ref1 = _ref.trials) != null ? (_ref2 = _ref1[Feature.LIVE_TRACKING]) != null ? _ref2.optInTime : void 0 : void 0 : void 0) == null;
    };

    return AccountF;
  };
  AccountF.$inject = ["$injector", "$kookies", "$window", "$http", "$q", "$raven", "Constants", "TimeUtilF", "EventListenersF", "Events", "UpgradeUtil", "Feature", "LoggerF", "AbTestF"];

  angular.module('app').factory('AccountF', AccountF);

}).call(this);

(function() {
  var SettingsC = function($rootScope, $scope, $state, $q, $timeout, SettingsF, AccountF, RouteS, ConfirmF, MessagingF, ProjectF, EventListenersF, Events, VisitF, VisitMarker, States, DispatchF, AnalyticsS, DispatchStatusF) {
    var MIN_IDLE, ONE_SECOND, REOPTIMIZE, ROUTE_STATE, SHOW_TRAFFIC_VALUE, _confirmUpdateRoutes, _hasMadeChanges, _isInvalidState, _minIdleSettings, _reoptimizingSettings, _rerouteStrategy, _showErrorAndGoToInput, _updateRoutes;
    ONE_SECOND = 1000;
    SHOW_TRAFFIC_VALUE = ["f.hartlief@coolblue.nl", "planning@coolblue.nl", "planningtilburg@coolblue.nl", "planningutrecht@coolblue.nl", "test11@test.com"];
    _minIdleSettings = ['duration', 'strictStart', 'isPredicted', 'avoidTolls', 'load'];
    _reoptimizingSettings = ['autoBalanced', 'shortestDistance', 'driverLateness', 'stopLateness', 'avoidTolls'];
    REOPTIMIZE = 1;
    MIN_IDLE = 2;
    ROUTE_STATE = States.projectRoutePlan;
    _isInvalidState = function() {
      return VisitF.getInvalidVisits().length > 0;
    };
    _showErrorAndGoToInput = function() {
      return $state.go(States.projectVisitsList).then(function() {
        var numInvalidVisits = VisitF.getInvalidVisits().length;
        return MessagingF.replaceInfo("MESSAGES.SETTINGS_CHANGE_INVALID_VISITS", {
          numVisits: numInvalidVisits
        });
      });
    };
    _updateRoutes = function(minIdleOrReoptimize) {
      var date, loadingSuccessMessage, promise;
      if (minIdleOrReoptimize === REOPTIMIZE) {
        loadingSuccessMessage = 'Re-routing successfully completed.';
        date = ProjectF.project.date;
        promise = RouteS.reoptimize(date);
      } else {
        loadingSuccessMessage = 'New settings successfully applied.';
        promise = RouteS.minIdleDrivers();
      }
      return promise.then(function() {
        if (DispatchStatusF.hasDispatches()) {
          return $state.go(States.projectRouteEdit);
        } else {
          return $state.go(States.projectRoutePlan);
        }
      }).then(function() {
        var msg, _unserved;
        _unserved = RouteS.getRoute().num_unserved;
        if (_unserved > 0) {
          msg = _unserved === 1 ? "MESSAGES.INFO_UNSERVED_ONE" : "MESSAGES.INFO_UNSERVED_MANY";
          return MessagingF.replaceInfo(msg, {
            x: _unserved
          });
        } else {
          return MessagingF.replaceSuccessPopup(loadingSuccessMessage);
        }
      });
    };
    _confirmUpdateRoutes = function(minIdleOrReoptimize) {
      var confirm, deferred, __checkStateAndUpdateRoutes;
      deferred = $q.defer();
      __checkStateAndUpdateRoutes = function(reoptimize) {
        if (_isInvalidState()) {
          return _showErrorAndGoToInput();
        } else {
          return _updateRoutes(reoptimize);
        }
      };
      confirm = null;
      if (RouteS.hasRoute()) {
        if (minIdleOrReoptimize & REOPTIMIZE && !DispatchStatusF.hasDispatches()) {
          confirm = ConfirmF.confirm("MESSAGES.REOPTIMIZATION_SETTINGS_CONFIRMATION").then(function() {
            return __checkStateAndUpdateRoutes(REOPTIMIZE);
          });
        } else {
          confirm = $q.reject();
        }
        if (minIdleOrReoptimize & MIN_IDLE) {
          confirm["catch"](function() {
            return EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS).then(function() {
              return __checkStateAndUpdateRoutes(MIN_IDLE);
            }).then(function() {
              return EventListenersF.notify(Events.PROJECT_MODIFIED);
            })["finally"](function() {
              return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
            });
          });
        }
      } else {
        confirm = $q.when(true);
      }
      confirm["finally"](function() {
        return deferred.resolve(true);
      });
      return deferred.promise;
    };
    _rerouteStrategy = (function(_this) {
      return function() {
        var newSettings, property, strategy, __isPropertyChanged, _i, _j, _len, _len1;
        strategy = 0;
        newSettings = SettingsF.settings;
        __isPropertyChanged = function(property) {
          if (_this.oldSettings[property] !== newSettings[property]) {
            return true;
          }
          if (property === 'isPredicted') {
            if (newSettings.isPredicted) {
              if (_this.oldSettings.predictedTraffic !== newSettings.predictedTraffic) {
                return true;
              }
            } else if (_this.oldSettings.traffic !== newSettings.traffic) {
              return true;
            }
          }
        };
        for (_i = 0, _len = _reoptimizingSettings.length; _i < _len; _i++) {
          property = _reoptimizingSettings[_i];
          if (__isPropertyChanged(property)) {
            strategy = strategy | REOPTIMIZE;
          }
        }
        for (_j = 0, _len1 = _minIdleSettings.length; _j < _len1; _j++) {
          property = _minIdleSettings[_j];
          if (__isPropertyChanged(property)) {
            strategy = strategy | MIN_IDLE;
          }
        }
        return strategy;
      };
    })(this);
    this.oldSettings = _.cloneDeep(RouteS.getSettings() || SettingsF.settings);
    this.DISTANCE_FORMATS = SettingsF.DISTANCE_FORMATS;
    this.TRAFFIC_LIST = SettingsF.TRAFFIC_LIST;
    this.PREDICTED_TRAFFIC_LIST = SettingsF.PREDICTED_TRAFFIC_LIST;
    this.distanceFormat = SettingsF.settings.distanceFormat;
    this.duration = SettingsF.settings.duration;
    this.load = SettingsF.settings.load;
    this.autoBalanced = SettingsF.settings.autoBalanced;
    this.strictStart = SettingsF.settings.strictStart;
    this.traffic = SettingsF.settings.traffic;
    this.predictedTraffic = SettingsF.settings.predictedTraffic;
    this.isProPlan = AccountF.getUser().isProPlan;
    this.isPredicted = SettingsF.settings.isPredicted;
    this.shortestDistance = SettingsF.settings.shortestDistance;
    this.driverLateness = SettingsF.settings.driverLateness || 0;
    this.stopLateness = SettingsF.settings.stopLateness || 0;
    this.avoidTolls = SettingsF.settings.avoidTolls;
    this.updatePredictedTraffic = function(traffic) {
      return SettingsF.setPredictedTraffic(traffic);
    };
    this.notifyChange = function() {
      return SettingsF.hasChanged = true;
    };
    this.sliderOptions = {
      floor: SettingsF.MIN_TRAFFIC_FACTOR,
      ceil: SettingsF.MAX_TRAFFIC_FACTOR,
      step: 1,
      onChange: this.notifyChange,
      hideLimitLabels: true,
      translate: function(val) {
        var user = AccountF.getUser();
        if ((user != null ? user.email : void 0) && (SHOW_TRAFFIC_VALUE.indexOf(user.email) >= 0)) {
          return "" + (val - 100) + "%";
        } else {
          return '';
        }
      }
    };
    this.cancelSettings = function() {
      SettingsF.hasChanged = false;
      return $scope.closeThisDialog();
    };
    this.saveSettings = function() {
      var userSettings;
      SettingsF.hasChanged = false;
      userSettings = {
        distanceFormat: this.distanceFormat,
        duration: this.duration,
        load: this.load,
        autoBalanced: this.autoBalanced,
        strictStart: this.strictStart,
        traffic: this.traffic,
        isPredicted: this.isPredicted,
        shortestDistance: this.shortestDistance,
        driverLateness: this.driverLateness > 0 ? this.driverLateness : void 0,
        stopLateness: this.stopLateness > 0 ? this.stopLateness : void 0,
        avoidTolls: this.avoidTolls
      };
      return SettingsF.saveSettings(userSettings).then(function() {
        var strategy;
        $scope.closeThisDialog();
        strategy = _rerouteStrategy();
        if (strategy > 0) {
          return _confirmUpdateRoutes(strategy);
        }
      });
    };
    _hasMadeChanges = (function(_this) {
      return function() {
        var previousSettings, unsavedSettings;
        unsavedSettings = {
          distanceFormat: _this.distanceFormat,
          duration: _this.duration,
          load: _this.load,
          autoBalanced: _this.autoBalanced,
          strictStart: _this.strictStart,
          traffic: _this.traffic,
          isPredicted: _this.isPredicted,
          shortestDistance: _this.shortestDistance,
          driverLateness: _this.driverLateness,
          stopLateness: _this.stopLateness,
          avoidTolls: _this.avoidTolls
        };
        previousSettings = SettingsF.settings;
        delete previousSettings.predictedTraffic;
        return !_.isEqual(unsavedSettings, previousSettings);
      };
    })(this);
    this.onExit = function() {
      if (_hasMadeChanges()) {
        return MessagingF.replaceWarning("MESSAGES.UNSAVED_SETTINGS", null, null, "OK");
      } else {
        return $scope.closeThisDialog();
      }
    };
    this.isLiveRoute = function() {
      return DispatchStatusF.hasDispatches();
    };
    AnalyticsS.track('019 Project setting');
  };
  SettingsC.$inject = ["$rootScope", "$scope", "$state", "$q", "$timeout", "SettingsF", "AccountF", "RouteS", "ConfirmF", "MessagingF", "ProjectF", "EventListenersF", "Events", "VisitF", "VisitMarker", "States", "DispatchF", "AnalyticsS", "DispatchStatusF"];

  angular.module('app').controller('SettingsC', SettingsC);

}).call(this);

(function() {
  var SettingsF = function($q, Constants, LocalStorageObjectF, EventListenersF, Events, AccountF) {
    var DEFAULT_AUTO_BALANCED, DEFAULT_AVOID_TOLLS, DEFAULT_PREDICTED_TRAFFIC, DEFAULT_SHORTEST_DISTANCE, DEFAULT_STRICT_START, DEFAULT_TRAFFIC, PREDICTED_TRAFFIC_CONVERSION, TRAFFIC_CONVERSION, TRAFFIC_FACTOR_SCALE, _cacheSettings, _init, _save;
    DEFAULT_AUTO_BALANCED = true;
    DEFAULT_STRICT_START = true;
    DEFAULT_SHORTEST_DISTANCE = false;
    DEFAULT_TRAFFIC = 100;
    DEFAULT_PREDICTED_TRAFFIC = 'best guess';
    DEFAULT_AVOID_TOLLS = false;
    TRAFFIC_FACTOR_SCALE = 100;
    TRAFFIC_CONVERSION = {
      'regular': 100,
      'some': 125,
      'high': 150,
      'very high': 175,
      'gridlock': 200,
      'faster': 100,
      'fast': 125,
      'normal': 150,
      'slow': 175,
      'very slow': 200
    };
    PREDICTED_TRAFFIC_CONVERSION = {
      'optimistic': 'predicted_optimistic',
      'best guess': 'predicted',
      'pessimistic': 'predicted_pessimistic'
    };
    _cacheSettings = LocalStorageObjectF('settings');
    _init = function() {
      var settings;
      if (!SettingsF.settings) {
        settings = _cacheSettings.load();
        return SettingsF.replace(settings);
      }
    };
    _save = function() {
      var promises = [];
      promises.push(EventListenersF.notify(Events.SETTINGS_CHANGED));
      promises.push(EventListenersF.notify(Events.PROJECT_MODIFIED));
      return $q.all(promises);
    };
    SettingsF = {};
    SettingsF.hasChanged = false;
    SettingsF.KM_DISTANCE = "km";
    SettingsF.MILES_DISTANCE = "miles";
    SettingsF.MIN_TRAFFIC_FACTOR = 100;
    SettingsF.MAX_TRAFFIC_FACTOR = 200;
    SettingsF.DISTANCE_FORMATS = [SettingsF.KM_DISTANCE, SettingsF.MILES_DISTANCE];
    SettingsF.TRAFFIC_LIST = ['SETTINGS.NO_TRAFFIC', 'SETTINGS.SOME_TRAFFIC', 'SETTINGS.HIGH_TRAFFIC', 'SETTINGS.VERY_HIGH_TRAFFIC', 'SETTINGS.GRIDLOCK_TRAFFIC'];
    SettingsF.PREDICTED_TRAFFIC_LIST = ['optimistic', 'best guess', 'pessimistic'];
    SettingsF.saveSettings = function(settings) {
      SettingsF.settings = settings;
      return _save();
    };
    SettingsF.setLocation = function(location) {
      return SettingsF.location = location;
    };
    SettingsF.setPredictedTraffic = function(traffic) {
      if (!PREDICTED_TRAFFIC_CONVERSION[traffic]) {
        console.error("Invalid predicted traffic value provided");
        return;
      }
      SettingsF.settings.predictedTraffic = traffic;
      return _save();
    };
    SettingsF.getServerTraffic = function() {
      if (SettingsF.settings.isPredicted) {
        return PREDICTED_TRAFFIC_CONVERSION['best guess'];
      }
      return SettingsF.settings.traffic / TRAFFIC_FACTOR_SCALE;
    };
    SettingsF.replace = function(settings) {
      var traffic, _base, _base1, _base2, _base3, _base4, _base5, _base6, _base7, _base8, _ref, _ref1;
      if (settings == null) {
        settings = {};
      }
      SettingsF.settings = _.assign(SettingsF.settings || {}, settings);
      if ((_base = SettingsF.settings).duration == null) {
        _base.duration = Constants.DEFAULT_DURATION;
      }
      if ((_base1 = SettingsF.settings).load == null) {
        _base1.load = Constants.DEFAULT_LOAD;
      }
      if ((_base2 = SettingsF.settings).autoBalanced == null) {
        _base2.autoBalanced = DEFAULT_AUTO_BALANCED;
      }
      if ((_base3 = SettingsF.settings).traffic == null) {
        _base3.traffic = DEFAULT_TRAFFIC;
      }
      if ((_base4 = SettingsF.settings).predictedTraffic == null) {
        _base4.predictedTraffic = DEFAULT_PREDICTED_TRAFFIC;
      }
      if ((_base5 = SettingsF.settings).strictStart == null) {
        _base5.strictStart = DEFAULT_STRICT_START;
      }
      if ((_base6 = SettingsF.settings).shortestDistance == null) {
        _base6.shortestDistance = DEFAULT_SHORTEST_DISTANCE;
      }
      if ((_base7 = SettingsF.settings).isPredicted == null) {
        _base7.isPredicted = false;
      }
      if ((_base8 = SettingsF.settings).avoidTolls == null) {
        _base8.avoidTolls = DEFAULT_AVOID_TOLLS;
      }
      traffic = SettingsF.settings.traffic;
      if (typeof traffic === 'string') {
        SettingsF.settings.traffic = TRAFFIC_CONVERSION[traffic] || DEFAULT_TRAFFIC;
      } else {
        if ((2 >= traffic && traffic >= 1)) {
          SettingsF.settings.traffic = traffic * TRAFFIC_FACTOR_SCALE;
        }
      }
      if (!((_ref = AccountF.getUser()) != null ? _ref.isProPlan : void 0)) {
        SettingsF.settings.isPredicted = false;
      }
      if (!SettingsF.settings.distanceFormat) {
        if (((_ref1 = SettingsF.location) != null ? _ref1.countryCode : void 0) === 'US') {
          return SettingsF.settings.distanceFormat = SettingsF.MILES_DISTANCE;
        } else {
          return SettingsF.settings.distanceFormat = SettingsF.KM_DISTANCE;
        }
      }
    };
    SettingsF.init = _init;
    return SettingsF;
  };
  SettingsF.$inject = ["$q", "Constants", "LocalStorageObjectF", "EventListenersF", "Events", "AccountF"];

  angular.module('app').factory('SettingsF', SettingsF);

}).call(this);

(function() {
  var UpdateCardC = function($scope, $state, AccountF, UpgradeUtil, Plans, MessagingF) {
    this.inUpdate = false;
    this.user = AccountF.getUser();
    if (this.user.stripe_obj != null) {
      this.currentPlan = Plans.alias.type[this.user.plan.name];
      this.subscribedAddons = UpgradeUtil.getSubscribedAddons(this.user);
      if (this.user.billingCycle != null) {
        this.billingCycle = UpgradeUtil.getBillingCycle(this.user.billingCycle);
      }
      this.billAmount = UpgradeUtil.getSubtotal(this.user.maxVehicles, this.currentPlan, this.subscribedAddons, this.billingCycle);
    }
    this.cancel = function() {
      var previous = $previousState.get();
      if (previous.state.$$state().includes[States.modal]) {
        return $previousState.go();
      } else {
        return $scope.closeThisDialog();
      }
    };
    this.startUpdate = function(valid) {
      if (!valid) {
        return;
      }
      return this.inUpdate = true;
    };
    $scope.updateCard = (function(_this) {
      return function(status, response) {
        var token;
        if (!_this.form.$valid) {
          return console.log('Invalid form, credit card information not updated');
        }
        if (response.error) {
          return _this.error = response.error.message;
        } else {
          token = response.id;
          return AccountF.updateCard(token).then(function() {
            MessagingF.replaceSuccessPopup("MESSAGES.UPDATE_CARD_SUCCESS");
            return $state.go('^');
          })["catch"](function(err) {
            return _this.error = err.message;
          })["finally"](function() {
            return _this.inUpdate = false;
          });
        }
      };
    })(this);
  };
  UpdateCardC.$inject = ["$scope", "$state", "AccountF", "UpgradeUtil", "Plans", "MessagingF"];

  angular.module('app').controller('UpdateCardC', UpdateCardC);

}).call(this);

(function() {
  var UpgradeC,
    __hasProp = {}.hasOwnProperty,
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  UpgradeC = function($translate, $scope, $state, $previousState, AccountF, Constants, States, AnalyticsS, Plans, UpgradeUtil, MessagingF, Messages, DispatchF, ProjectF, Gtm) {
    var AMOUNT_DISCOUNT, BILLING_CYCLE_ANNUAL, BILLING_CYCLE_MONTHLY, PERCENT_DISCOUNT, _currentTrialStep, _discount, _discountType, _errorDiscount, _populateState, _resErrorHandler, _toggleAddon, _updateUpgradeData, _upgrade;
    _currentTrialStep = 0;
    _upgrade = {
      isAnnual: true
    };
    BILLING_CYCLE_ANNUAL = UpgradeUtil.BILLING_CYCLE_ANNUAL;
    BILLING_CYCLE_MONTHLY = UpgradeUtil.BILLING_CYCLE_MONTHLY;
    PERCENT_DISCOUNT = 'percent';
    AMOUNT_DISCOUNT = 'amount';
    _discount = 0;
    _discountType = PERCENT_DISCOUNT;
    _errorDiscount = null;
    this.user = AccountF.getUser();
    this.isTrial = !this.user.stripe_obj;
    this.isAnnual = true;
    this.isPaid = AccountF.isPaid();
    this.numVehicles = 0;
    this.validDiscount = 0;
    this.validDiscountLabel = null;
    this.validDiscountType = PERCENT_DISCOUNT;
    this.availableAddons = {};
    this.couponCode = '';
    this.inCoupon = false;
    this.plans = Plans.type;
    this.addons = Plans.addon;
    this.features = Plans.feature;
    this.supportEmail = Constants.email;
    this.error = null;
    this.errorDiscount = null;
    this.inUpgrade = false;
    this.countryList = Constants.COUNTRY_LIST;
    this.showRegion = [];
    _populateState = (function(_this) {
      return function() {
        var nextPlan, _ref, _ref1, _ref2;
        _this.numVehicles = _this.user.maxVehicles;
        _upgrade.plan = Plans.type.TRIAL;
        if (_this.user.stripe_obj != null) {
          if (Plans.alias.type[_this.user.plan.name] != null) {
            _upgrade.plan = Plans.alias.type[_this.user.plan.name];
          }
          if (UpgradeUtil.getBillingCycle(_this.user.billingCycle) === 'monthly') {
            _this.isAnnual = _upgrade.isAnnual = false;
          }
          if (((_ref = _upgrade.plan) != null ? _ref.grandfathered : void 0) != null) {
            nextPlan = _this.isAnnual ? (_ref1 = _upgrade.plan) != null ? _ref1.grandfathered.annual : void 0 : (_ref2 = _upgrade.plan) != null ? _ref2.grandfathered.monthly : void 0;
            if (Plans.alias.type[nextPlan] != null) {
              _upgrade.plan = Plans.alias.type[nextPlan];
            }
          }
        }
        _this.availableAddons = UpgradeUtil.getAddons(_this.user, _upgrade.plan);
        return _this.updateTotal();
      };
    })(this);
    this.isOldPlan = function() {
      var _ref;
      return (_ref = Plans.alias.type[this.user.plan.name]) != null ? _ref.deprecated : void 0;
    };
    _resErrorHandler = (function(_this) {
      return function(err) {
        var message;
        console.error("MESSAGES.ERROR_UPGRADE_FAILED", err);
        if (err) {
          message = err.error;
        } else {
          message = "MESSAGES.ERROR_SERVER_PROCESS";
        }
        return _this.error = $translate.instant(message);
      };
    })(this);
    this.goToPlanSelectStep = function(nextIndex) {
      var i, _i, _ref, _ref1, _ref2;
      if (nextIndex > _currentTrialStep) {
        for (i = _i = _currentTrialStep, _ref = nextIndex - 1; _currentTrialStep <= _ref ? _i <= _ref : _i >= _ref; i = _currentTrialStep <= _ref ? ++_i : --_i) {
          if (!this.isCompletedPlanSelectStep(i)) {
            return;
          }
        }
      }
      _currentTrialStep = nextIndex;
      if ((_ref1 = document.getElementsByClassName('upgrade-trial-header')) != null) {
        if ((_ref2 = _ref1[0]) != null) {
          _ref2.scrollIntoView();
        }
      }
      if (nextIndex === 2) {
        this.selectedCountry = void 0;
        this.selectedRegion = void 0;
        return this.regionList = [];
      }
    };
    this.isOnPlanSelectStep = function(index) {
      return _currentTrialStep === index;
    };
    this.isCompletedPlanSelectStep = function(index) {
      var _ref;
      switch (index) {
        case 0:
          return (_upgrade.isAnnual != null) && (_upgrade.plan != null);
        case 1:
          return this.numVehicles >= ((_ref = _upgrade.plan) != null ? _ref.minVehicle : void 0);
        case 2:
          return this.inUpgrade;
        default:
          return false;
      }
    };
    this.isCurrentPlan = function(id) {
      return Plans.type[id].id.monthly === this.user.plan.name || Plans.type[id].id.annual === this.user.plan.name;
    };
    this.setBillingCycle = function(isAnnual) {
      this.isAnnual = isAnnual;
      this.showBillingMenu = false;
      if (this.couponCode) {
        return this.checkCoupon();
      } else {
        return this.updateTotal();
      }
    };
    this.getPrice = function(_arg, cycle) {
      var price = _arg.price;
      if (cycle == null) {
        cycle = this.isAnnual ? BILLING_CYCLE_ANNUAL : BILLING_CYCLE_MONTHLY;
      }
      return price[cycle];
    };
    this.checkCoupon = function() {
      var _annual, _discountLabel;
      _discount = 0;
      _discountType = this.validDiscountType;
      _discountLabel = null;
      _errorDiscount = null;
      _annual = this.isAnnual;
      this.inCoupon = true;
      return AccountF.validateCoupon(this.couponCode, this.isAnnual).then(function(res) {
        if (res.valid) {
          _discountLabel = res.name;
          if (res.percent_off != null) {
            _discountType = PERCENT_DISCOUNT;
            return _discount = res.percent_off;
          } else if (res.amount_off != null) {
            _discountType = AMOUNT_DISCOUNT;
            return _discount = res.amount_off;
          }
        } else {
          _errorDiscount = 'Coupon not found';
          if ((res.duration != null) && res.duration === 'repeating' && _annual) {
            return _errorDiscount = 'Coupon is not valid on a yearly subscription';
          }
        }
      })["catch"](_resErrorHandler)["finally"]((function(_this) {
        return function() {
          _this.validDiscount = _discount;
          _this.validDiscountLabel = _discountLabel;
          _this.validDiscountType = _discountType;
          _this.errorDiscount = _errorDiscount;
          _this.inCoupon = false;
          return _this.updateTotal();
        };
      })(this));
    };
    this.clearDiscount = function() {
      this.validDiscount = 0;
      this.validDiscountLabel = null;
      this.validDiscountType = PERCENT_DISCOUNT;
      return this.updateTotal();
    };
    this.getDiscount = function() {
      return this.validDiscount;
    };
    this.getDiscountLabel = function() {
      return this.validDiscountLabel;
    };
    this.isPercentDiscount = function() {
      return this.validDiscountType === PERCENT_DISCOUNT;
    };
    this.isCoupon = function() {
      return this.couponCode.length > 0;
    };
    this.getNumAddons = function() {
      return Object.keys(this.availableAddons).length;
    };
    this.select = function(plan) {
      _upgrade.plan = plan;
      _upgrade.isAnnual = this.isAnnual;
      this.availableAddons = UpgradeUtil.getAddons(this.user, plan);
      if (plan.minVehicle > this.numVehicles) {
        this.numVehicles = plan.minVehicle;
      }
      if (this.isTrial || this.isOldPlan()) {
        this.goToPlanSelectStep(1);
      }
      this.showFullPlan = false;
      this.updateTotal();
      return Gtm.trackChosenTier(plan, this.isAnnual, this.numVehicles);
    };
    this.getSelected = function() {
      return _upgrade.plan;
    };
    _toggleAddon = function(k) {
      this.availableAddons[k].active = !this.availableAddons[k].active;
      return this.updateTotal();
    };
    this.toggleAddon = function(k) {
      return _toggleAddon.call(this, k);
    };
    this.updateTotal = function() {
      var addonTotal, addons, cycle, discountTotal, k, _monthlyAddonTotal, _monthlyCost, _monthlySubtotal, _ref, _subtotal;
      addons = this.availableAddons;
      addonTotal = 0;
      cycle = this.isAnnual ? BILLING_CYCLE_ANNUAL : BILLING_CYCLE_MONTHLY;
      for (k in addons) {
        if (!__hasProp.call(addons, k)) continue;
        if (!(addons[k].active && (_ref = addons[k].addon, __indexOf.call(_upgrade.plan.addons, _ref) < 0))) {
          continue;
        }
        addons[k].subtotal = UpgradeUtil.getAddonSubtotal(this.numVehicles, addons[k].addon, cycle);
        addonTotal += addons[k].subtotal;
      }
      _monthlyAddonTotal = UpgradeUtil.getAddonTotal(this.numVehicles, addons, BILLING_CYCLE_MONTHLY);
      _monthlySubtotal = this.numVehicles * _upgrade.plan.price.monthly;
      if (this.isAnnual) {
        this.monthlyCycleTotal = (_monthlyAddonTotal + _monthlySubtotal) * 12;
      }
      _monthlyCost = this.numVehicles * _upgrade.plan.price[cycle];
      _monthlySubtotal = addonTotal + _monthlyCost;
      discountTotal = 0;
      if (this.validDiscount > 0) {
        if (this.validDiscountType === PERCENT_DISCOUNT) {
          discountTotal = Math.round((_monthlySubtotal * (this.validDiscount / 100)) * 100) / 100;
        } else if (this.validDiscountType === AMOUNT_DISCOUNT) {
          discountTotal = this.validDiscount;
        }
      }
      _subtotal = (_monthlySubtotal - discountTotal) < 0 ? _monthlySubtotal : _monthlySubtotal - discountTotal;
      return this.grandTotal = this.isAnnual ? _subtotal * 12 : _subtotal;
    };
    _updateUpgradeData = (function(_this) {
      return function(token) {
        _upgrade.user = _this.user;
        _upgrade.isAnnual = _this.isAnnual;
        if ((_this.couponCode != null) && _this.validDiscount > 0) {
          _upgrade.coupon = _this.couponCode;
        }
        _upgrade.numVehicles = _this.numVehicles;
        _upgrade.addOns = _this.availableAddons;
        if (token != null) {
          _upgrade.card = token;
        }
        if (_this.selectedCountry) {
          _upgrade.country = _this.selectedCountry;
        }
        if (_this.selectRegion) {
          _upgrade.state = _this.selectedRegion;
        }
        return _upgrade;
      };
    })(this);
    this.trackSelectedCustomPlan = function() {
      var opts, subscription, _ref;
      subscription = this.isAnnual ? 'Yearly Subscription' : 'Monthly Subscription';
      opts = [subscription, "No-Vehicles: " + this.numVehicles];
      if (((_ref = this.availableAddons) != null ? _ref.CUSTOMER_NOTIFICATIONS : void 0) != null) {
        opts.push("Cust-Notif: " + this.availableAddons.CUSTOMER_NOTIFICATIONS.active);
      }
      return Gtm.trackCheckoutOptions(opts);
    };
    this.customizePlan = function() {
      this.trackSelectedCustomPlan();
      if (this.isTrial) {
        return this.goToPlanSelectStep(2);
      }
      this.inUpgrade = true;
      return AccountF.changePlan(_updateUpgradeData()).then(function() {
        return DispatchF.getProjectRoutes(ProjectF.project.id);
      }).then(function(res) {
        var dispatches = res;
        if (dispatches) {
          DispatchF.replace(dispatches);
        }
        $state.go('^');
        return MessagingF.replaceSuccessPopup("MESSAGES.UPDATE_PLAN_SUCCESS");
      })["catch"](_resErrorHandler)["finally"]((function(_this) {
        return function() {
          return _this.inUpgrade = false;
        };
      })(this));
    };
    this.cancel = function() {
      var previous = $previousState.get();
      if (previous.state.$$state().includes[States.modal]) {
        return $previousState.go();
      } else {
        return $scope.closeThisDialog();
      }
    };
    this.startUpgrade = function(valid) {
      if (!valid) {
        return;
      }
      return this.inUpgrade = true;
    };
    this.handlePremiumTier = function() {
      var professionalTier = {
        name: Plans.type.PREMIUM.name,
        id: Plans.type.PREMIUM.id
      };
      Gtm.trackChosenTier(professionalTier, this.isAnnual);
      return window.location.href = "mailto:" + this.supportEmail;
    };
    $scope.upgradeAccount = (function(_this) {
      return function(status, response) {
        var ifRegionIsRequiredAndFilled;
        if (!_this.form.$valid) {
          _this.inUpgrade = false;
          return console.log('Invalid form, account not upgraded');
        }
        ifRegionIsRequiredAndFilled = _this.regionList.length === 0 || (_this.regionList.length > 0 && _this.selectedRegion);
        if (!(_this.selectedCountry && ifRegionIsRequiredAndFilled)) {
          _this.inUpgrade = false;
          return;
        }
        if (response.error) {
          console.error("Failed to receive Stripe token", response.error);
          _this.error = response.error.message;
          return _this.inUpgrade = false;
        } else {
          Gtm.trackUpgradePlanClick(response.card.brand);
          return AccountF.upgrade(_updateUpgradeData(response.id)).then(function(user) {
            var pricePerMonth, subscriptionId, subscriptionObjs, _ref, _ref1, _ref2;
            MessagingF.replaceSuccessPopup("MESSAGES.UPGRADE_PLAN_SUCCESS", {
              planName: _upgrade.plan.name
            });
            AnalyticsS.track('018 upgrade account', {
              number_of_vehicles: $scope.upgrade.numVehicles
            });
            ga('send', {
              hitType: 'event',
              eventCategory: 'account',
              eventAction: 'upgrade'
            });
            pricePerMonth = $scope.upgrade.isAnnual ? $scope.upgrade.grandTotal / 12 : $scope.upgrade.grandTotal;
            if ((_ref = window.dataLayer) != null) {
              _ref.push({
                'formName': 'UpgradeForm',
                'event': 'trial_upgrade',
                'vehicle_number': $scope.upgrade.numVehicles,
                'price_per_vehicle_per_month': pricePerMonth / $scope.upgrade.numVehicles,
                'plan_type': $scope.upgrade.isAnnual ? 'annual' : 'monthly'
              });
            }
            subscriptionObjs = user != null ? (_ref1 = user.stripe_obj) != null ? (_ref2 = _ref1.subscriptions) != null ? _ref2.data : void 0 : void 0 : void 0;
            if (subscriptionObjs.length >= 1) {
              subscriptionId = subscriptionObjs.slice(0).pop().id;
              Gtm.trackUpgradedAccount(_upgrade, subscriptionId, $scope.upgrade.grandTotal, $scope.upgrade.numVehicles);
            } else {
              console.error('Unable to track upgrade. Subscription missing');
            }
            return DispatchF.getProjectRoutes(ProjectF.project.id);
          }).then(function(res) {
            var dispatches = res;
            if (dispatches) {
              DispatchF.replace(dispatches);
            }
            return $state.go('^');
          })["catch"](_resErrorHandler)["finally"](function() {
            return _this.inUpgrade = false;
          });
        }
      };
    })(this);
    this.closeDropdown = function() {
      return $scope.$broadcast('dropdownClose');
    };
    this.selectCountry = (function(_this) {
      return function(value) {
        _this.regionList = Constants.REGION_LIST[value] != null ? Constants.REGION_LIST[value] : [];
        _this.selectedCountry = value;
        return _this.selectedRegion = void 0;
      };
    })(this);
    this.selectRegion = (function(_this) {
      return function(value) {
        return _this.selectedRegion = value;
      };
    })(this);
    this.trackClickUpgrade = function() {
      return Gtm.trackClickUpgrade();
    };
    this.trackCustomizePlan = function() {
      return Gtm.trackCustomizePlan(_upgrade.plan, this.isAnnual, this.numVehicles);
    };
    this.trackBilling = function() {
      return Gtm.trackBilling(_upgrade.plan, this.isAnnual, this.numVehicles);
    };
    _populateState();
    AnalyticsS.track('017 Click on Upgrade');
  };

  angular.module('app').controller('UpgradeC', ['$translate', '$scope', '$state', '$previousState', 'AccountF', 'Constants', 'States', 'AnalyticsS', 'Plans', 'UpgradeUtil', 'MessagingF', 'Messages', 'DispatchF', 'ProjectF', 'Gtm', UpgradeC]);

}).call(this);

(function() {
  var UpgradeUtil,
    __hasProp = {}.hasOwnProperty,
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  UpgradeUtil = function(Plans) {
    var BILLING_CYCLE_ANNUAL, BILLING_CYCLE_MONTHLY, ONE_DAY_IN_MILLISECONDS, _Addons, _PrimaryPlan, _formatUpgradeData, _getAddonSubtotal, _getAddonTotal, _getAddons, _getBillingCycle, _getSubscribedAddons, _getSubtotal, _multiplyByVehicle;
    BILLING_CYCLE_ANNUAL = 'annual';
    BILLING_CYCLE_MONTHLY = 'monthly';
    ONE_DAY_IN_MILLISECONDS = 86400 * 1000;
    _PrimaryPlan = Plans.type;
    _Addons = Plans.addon;
    _formatUpgradeData = function(_arg) {
      var active, addOns, addon, addonId, card, country, coupon, cycle, data, isAnnual, k, numVehicles, plan, state, subscribed, user, _ref;
      user = _arg.user, card = _arg.card, coupon = _arg.coupon, isAnnual = _arg.isAnnual, plan = _arg.plan, addOns = _arg.addOns, numVehicles = _arg.numVehicles, country = _arg.country, state = _arg.state;
      subscribed = _getSubscribedAddons(user);
      cycle = isAnnual ? BILLING_CYCLE_ANNUAL : BILLING_CYCLE_MONTHLY;
      data = {
        addOns: {},
        numVehicles: numVehicles
      };
      data.plan = plan.id[cycle];
      if (card) {
        data.card = card;
      }
      if (coupon) {
        data.coupon = coupon;
      }
      for (k in subscribed) {
        data.addOns[k] = 0;
      }
      for (k in addOns) {
        _ref = addOns[k], active = _ref.active, addon = _ref.addon;
        if (!(active)) {
          continue;
        }
        addonId = addon.id[cycle];
        data.addOns[addonId] = numVehicles;
      }
      if (country) {
        data.country = country;
      }
      if (state) {
        data.state = state;
      }
      return data;
    };

    /*
      Return array of addons in customizable format.
      Removes addons included with plan, addons that are trial
      only when not a trial user. Include subscribed addons.
     */
    _getAddons = function(user, plan) {
      var addon, addons, annual, id, monthly, subscribed, _ref, _ref1, _ref2;
      subscribed = _getSubscribedAddons(user);
      addons = {};
      for (id in _Addons) {
        if (!__hasProp.call(_Addons, id)) continue;
        addon = _Addons[id];
        if (!((plan.availableAddons != null) && __indexOf.call(plan.availableAddons, addon) >= 0)) {
          continue;
        }
        if ((user.stripe_obj && addon.trialOnly) || __indexOf.call(plan.addons, addon) >= 0) {
          continue;
        }
        addons[id] = {
          id: id,
          addon: addon,
          active: false,
          subtotal: 0
        };
        _ref = addon.id, annual = _ref.annual, monthly = _ref.monthly;
        if (subscribed[annual] || subscribed[monthly]) {
          addons[id].active = true;
          addons[id].subtotal = (((_ref1 = subscribed[annual]) != null ? _ref1.subtotal : void 0) || ((_ref2 = subscribed[monthly]) != null ? _ref2.subtotal : void 0)) || 0;
        }
      }
      return addons;
    };
    _getSubscribedAddons = function(user) {
      var addons, alias, cycle, features, flag, id, isNotIncludedInPlan, name, planIncluded, _ref, _ref1, _ref2, _ref3;
      if ((user != null ? (_ref = user.settings) != null ? _ref.features : void 0 : void 0) == null) {
        return {};
      }
      features = user.settings.features;
      name = ((_ref1 = user.plan) != null ? _ref1.name : void 0) ? user.plan.name : 'per_vehicle_USD';
      cycle = user.billingCycle != null ? _getBillingCycle(user.billingCycle) : BILLING_CYCLE_MONTHLY;
      planIncluded = (_ref2 = Plans.alias.type[name]) != null ? _ref2.addons : void 0;
      alias = Plans.alias.addon;
      addons = {};
      for (flag in features) {
        if (!(alias[flag] && features[flag])) {
          continue;
        }
        isNotIncludedInPlan = (planIncluded != null) && (_ref3 = alias[flag], __indexOf.call(planIncluded, _ref3) < 0);
        id = alias[flag].id[cycle];
        addons[id] = {
          id: id,
          addon: alias[flag],
          active: isNotIncludedInPlan,
          subtotal: _getAddonSubtotal(user.maxVehicles, alias[flag], cycle)
        };
      }
      return addons;
    };
    _getBillingCycle = function(billingCycle) {
      var end, start;
      start = billingCycle.start, end = billingCycle.end;
      if ((end - start) / ONE_DAY_IN_MILLISECONDS >= 365) {
        return BILLING_CYCLE_ANNUAL;
      }
      return BILLING_CYCLE_MONTHLY;
    };
    _multiplyByVehicle = function(numVehicles, price) {
      return (numVehicles || 0) * price;
    };
    _getAddonSubtotal = function(numVehicles, addon, cycle) {
      if (addon.perUnit) {
        return _multiplyByVehicle(numVehicles, addon.price[cycle]);
      }
      return addon.price[cycle];
    };
    _getAddonTotal = function(numVehicles, addons, cycle) {
      var active, addon, k, total, _ref;
      total = 0;
      for (k in addons) {
        if (!__hasProp.call(addons, k)) continue;
        _ref = addons[k], active = _ref.active, addon = _ref.addon;
        if (active) {
          if (addon.perUnit) {
            total += _multiplyByVehicle(numVehicles, addon.price[cycle]);
          } else {
            total += addon.price[cycle];
          }
        }
      }
      return total;
    };
    _getSubtotal = function(numVehicles, _arg, addons, cycle) {
      var addonTotal, price, vehicleTotal;
      price = _arg.price;
      addonTotal = _getAddonTotal(numVehicles, addons, cycle);
      vehicleTotal = _multiplyByVehicle(numVehicles, price[cycle]);
      if (cycle === BILLING_CYCLE_ANNUAL) {
        return (addonTotal + vehicleTotal) * 12;
      } else {
        return addonTotal + vehicleTotal;
      }
    };
    UpgradeUtil = {
      BILLING_CYCLE_MONTHLY: BILLING_CYCLE_MONTHLY,
      BILLING_CYCLE_ANNUAL: BILLING_CYCLE_ANNUAL,
      getSubscribedAddons: _getSubscribedAddons,
      multiplyByVehicle: _multiplyByVehicle,
      formatUpgradeData: _formatUpgradeData,
      getAddonSubtotal: _getAddonSubtotal,
      getBillingCycle: _getBillingCycle,
      getAddonTotal: _getAddonTotal,
      getSubtotal: _getSubtotal,
      getAddons: _getAddons
    };
    return UpgradeUtil;
  };

  angular.module('app').factory('UpgradeUtil', ['Plans', UpgradeUtil]);

}).call(this);

(function() {
  var     __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  var AddressCheckerS = function($q, ngDialog) {
    var MAX_INSTANCE, geocoder, _checkerCount;
    geocoder = new google.maps.Geocoder();
    MAX_INSTANCE = 1;
    _checkerCount = 0;
    AddressCheckerS = (function() {
      function AddressCheckerS(address) {
        this.address = address;
        this.openAddressCheckerModal = __bind(this.openAddressCheckerModal, this);
        this.handleGeocodingResult = __bind(this.handleGeocodingResult, this);
      }

      AddressCheckerS.check = function(address) {
        var addressChecker;
        if (_checkerCount >= MAX_INSTANCE) {
          return;
        }
        addressChecker = new AddressCheckerS(address);
        return addressChecker.geocode(address);
      };

      AddressCheckerS.geocodeFromPlaceId = function(placeId) {
        var addressChecker, defer;
        defer = $q.defer();
        addressChecker = new AddressCheckerS(placeId);
        geocoder.geocode({
          placeId: placeId
        }, addressChecker.handleGeocodingResult(defer));
        return defer.promise;
      };

      AddressCheckerS.getSearchResults = function(address) {
        var addressChecker, defer;
        defer = $q.defer();
        addressChecker = new AddressCheckerS(address);
        geocoder.geocode({
          address: address
        }, addressChecker.handleGeocodingResult(defer));
        return defer.promise;
      };

      AddressCheckerS.prototype.geocode = function(address) {
        var defer = $q.defer();
        geocoder.geocode({
          address: address
        }, this.handleGeocodingResult(defer));
        return defer.promise.then(this.createDirectiveProps).then(this.openAddressCheckerModal);
      };

      AddressCheckerS.prototype.formatToLocationObject = function(results) {
        return results.map(function(result) {
          var formattedLocation = {};
          if (!((result != null) && result.geometry)) {
            return;
          }
          formattedLocation.address = result.formatted_address;
          formattedLocation.coords = {
            lat: result.geometry.location.lat(),
            lng: result.geometry.location.lng()
          };
          return formattedLocation;
        });
      };

      AddressCheckerS.prototype.handleGeocodingResult = function(promise) {
        return (function(_this) {
          return function(results, status) {
            if (status === 'OK' && (results != null) && results.length > 0) {
              promise.resolve(_this.formatToLocationObject(results));
            }
            return promise.reject();
          };
        })(this);
      };

      AddressCheckerS.prototype.createDirectiveProps = function(results) {
        return {
          status: 'valid',
          location: results[0],
          allResults: results
        };
      };

      AddressCheckerS.prototype.openAddressCheckerModal = function(_arg) {
        var allResults, location;
        location = _arg.location, allResults = _arg.allResults;
        _checkerCount += 1;
        return ngDialog.openConfirm({
          templateUrl: 'confirm/confirmAddress.html',
          controller: [
            '$scope', (function(_this) {
              return function($scope) {
                $scope.name = _this.address;
                $scope.location = location;
                $scope.allResults = allResults;
                $scope.onSubmit = function(isValid, _, selectedLocation) {
                  if (!isValid) {
                    return;
                  }
                  _checkerCount -= 1;
                  return $scope.confirm(selectedLocation);
                };
                return $scope.onExit = function() {
                  _checkerCount -= 1;
                  return $scope.closeThisDialog();
                };
              };
            })(this)
          ]
        });
      };

      return AddressCheckerS;

    })();
    return AddressCheckerS;
  };
  AddressCheckerS.$inject = ["$q", "ngDialog"];

  angular.module('app').factory('AddressCheckerS', AddressCheckerS);

}).call(this);

(function() {
  var AnalyticsS = function($http, $injector, Constants, AccountF) {
    var DriverF, OnboardingF, TRACK_URL, VisitF, _appendDrivers, _appendVisits;
    TRACK_URL = "" + Constants.apiPath + "/track";
    VisitF = null;
    DriverF = null;
    OnboardingF = null;
    _appendVisits = function(props) {
      VisitF || (VisitF = $injector.get("VisitF"));
      return props["#Visits"] = VisitF.getVisits().length;
    };
    _appendDrivers = function(props) {
      DriverF || (DriverF = $injector.get("DriverF"));
      return props["#Drivers"] = DriverF.getDrivers().length;
    };
    AnalyticsS = {};
    AnalyticsS.increment = function(data) {
      if (data == null) {
        data = {};
      }
      OnboardingF || (OnboardingF = $injector.get("OnboardingF"));
      if (OnboardingF.inProgress) {
        return;
      }
      return typeof mixpanel !== "undefined" && mixpanel !== null ? mixpanel.people.increment(data) : void 0;
    };
    AnalyticsS.set = function(data) {
      if (data == null) {
        data = {};
      }
      return typeof mixpanel !== "undefined" && mixpanel !== null ? mixpanel.people.set(data) : void 0;
    };
    AnalyticsS.track = function(eventName, props) {
      if (props == null) {
        props = {};
      }
      return AnalyticsS.track_force(eventName, props);
    };
    AnalyticsS.track_force = function(eventName, props) {
      var body;
      if (props == null) {
        props = {};
      }
      _appendVisits(props);
      _appendDrivers(props);
      body = {
        eventName: eventName,
        props: props
      };
      $http.post(TRACK_URL, body, AccountF.getAuthHeader());
    };

    return AnalyticsS;
  };
  AnalyticsS.$inject = ["$http", "$injector", "Constants", "AccountF"];

  angular.module('app').service('AnalyticsS', AnalyticsS);

}).call(this);

(function() {
  var ClientF = function() {
    ClientF = {};
    ClientF.track = function(eventName, eventData) {
      return typeof mixpanel !== "undefined" && mixpanel !== null ? mixpanel.track("web_" + eventName, eventData) : void 0;
    };
    return ClientF;
  };

  angular.module('app').factory('ClientF', ClientF);

}).call(this);

(function() {
  var Gtm = function() {
    var _buildCheckoutOptions, _buildProductsMeta, _getSubscription;
    _getSubscription = function(isAnnual) {
      var subscription = isAnnual ? 'Yearly Subscription' : 'Monthly Subscription';
      return subscription;
    };
    _buildCheckoutOptions = function(options) {
      return options.join(' | ');
    };
    _buildProductsMeta = function(plan, isAnnual, numVehicles) {
      var planFrequency, planId, planPrice, planType, _ref, _ref1;
      planType = plan.name;
      if (isAnnual) {
        planId = plan.id.annual;
        if ((plan != null ? (_ref = plan.price) != null ? _ref.annual : void 0 : void 0) != null) {
          planPrice = plan.price.annual * numVehicles;
        }
        planFrequency = 'Yearly Subscription';
      } else {
        planId = plan.id.monthly;
        if ((plan != null ? (_ref1 = plan.price) != null ? _ref1.monthly : void 0 : void 0) != null) {
          planPrice = plan.price.monthly * numVehicles;
        }
        planFrequency = 'Monthly Subscription';
      }
      return [
        {
          'name': planType,
          'id': planId,
          'price': planPrice,
          'brand': 'Routific',
          'category': 'Delivery Route Mapping App',
          'variant': planFrequency,
          'quantity': numVehicles
        }
      ];
    };
    Gtm.trackClickUpgrade = function() {
      return window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': {
              'step': 1,
              'option': 'In-App Upgrade Account'
            }
          }
        }
      });
    };
    Gtm.trackChosenTier = function(plan, isAnnual, numVehicles) {
      var productsMeta = _buildProductsMeta(plan, isAnnual, numVehicles);
      window.dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': 'USD',
          'add': {
            'products': productsMeta
          }
        }
      });
      return window.dataLayer.push({
        'event': 'checkoutOption',
        'ecommerce': {
          'checkout_option': {
            'actionField': {
              'step': 1,
              'option': productsMeta[0].variant
            }
          }
        }
      });
    };
    Gtm.trackCustomizePlan = function(plan, isAnnual, numVehicles) {
      return window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': {
              'step': 2,
              'option': _getSubscription(isAnnual)
            },
            'products': _buildProductsMeta(plan, isAnnual, numVehicles)
          }
        }
      });
    };
    Gtm.trackCheckoutOptions = function(options) {
      return window.dataLayer.push({
        'event': 'checkoutOption',
        'ecommerce': {
          'checkout_option': {
            'actionField': {
              'step': 2,
              'option': _buildCheckoutOptions(options)
            }
          }
        }
      });
    };
    Gtm.trackBilling = function(plan, isAnnual, numVehicles) {
      return window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': {
              'step': 3,
              'option': _getSubscription(isAnnual)
            },
            'products': _buildProductsMeta(plan, isAnnual, numVehicles)
          }
        }
      });
    };
    Gtm.trackUpgradePlanClick = function(cardType) {
      return window.dataLayer.push({
        'event': 'checkoutOption',
        'ecommerce': {
          'checkout_option': {
            'actionField': {
              'step': 3,
              'option': cardType
            }
          }
        }
      });
    };
    Gtm.trackUpgradedAccount = function(upgrade, subscriptionId, grandTotal, numVehicles) {
      var isAnnual, plan;
      var couponCode = '';
      plan = upgrade.plan, isAnnual = upgrade.isAnnual;
      if ((upgrade != null ? upgrade.coupon : void 0) != null) {
        couponCode = upgrade.coupon;
      }
      return window.dataLayer.push({
        'event': 'transaction',
        'ecommerce': {
          'purchase': {
            'actionField': {
              'id': subscriptionId,
              'affiliation': 'Routific Website',
              'revenue': grandTotal,
              'coupon': couponCode,
              'products': _buildProductsMeta(plan, isAnnual, numVehicles)
            }
          }
        }
      });
    };
    Gtm.trackLogout = function() {
      return window.dataLayer.push({
        'event': 'logout'
      });
    };
    return Gtm;
  };

  angular.module('app').service('Gtm', Gtm);

}).call(this);

(function() {
  var ConfettiS = function() {
    var DEFAULTS, _fireConfetti;
    var COUNT = 200;
    DEFAULTS = {
      origin: {
        y: 0.7
      },
      colors: ['#ffbc00', '2a3e54', '469cfc']
    };
    _fireConfetti = function(particleRatio, opts) {
      return confetti(Object.assign({}, DEFAULTS, opts, {
        particleCount: Math.floor(COUNT * particleRatio)
      }));
    };
    ConfettiS.delight = function() {
      _fireConfetti(0.25, {
        spread: 26,
        startVelocity: 55,
        scalar: 1.2
      });
      _fireConfetti(0.2, {
        spread: 60,
        scalar: 1.2
      });
      _fireConfetti(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 1
      });
      _fireConfetti(0.3, {
        spread: 190,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.4,
        origin: {
          x: 0.5,
          y: 0.7
        }
      });
      _fireConfetti(0.2, {
        spread: 100,
        startVelocity: 45,
        scalar: 1.2,
        origin: {
          x: 0.7,
          y: 0.7
        }
      });
      return _fireConfetti(0.2, {
        spread: 100,
        startVelocity: 45,
        scalar: 1.2,
        origin: {
          x: 0.3,
          y: 0.7
        }
      });
    };
    return ConfettiS;
  };

  angular.module('app').service('ConfettiS', ConfettiS);

}).call(this);

(function() {
  var States = {
    main: 'hud',
    mainNav: 'hud.nav',
    customers: 'hud.nav.customers',
    customersUpload: 'hud.nav.customers.upload',
    customersEdit: 'hud.nav.customers.edit',
    customersCreate: 'hud.nav.customers.create',
    notifications: 'hud.nav.notifications',
    notificationsChildren: 'hud.nav.notifications.children',
    project: 'hud.nav.project',
    projectInput: 'hud.nav.project.input',
    projectVisits: 'hud.nav.project.input.visits',
    projectVisitsList: 'hud.nav.project.input.visits.list',
    projectVisitsCreate: 'hud.nav.project.input.visits.create',
    projectVisitsQuickadd: 'hud.nav.project.input.visits.quickadd',
    projectVisitsUpload: 'hud.nav.project.input.visits.upload',
    projectVisitsEdit: 'hud.nav.project.input.visits.edit',
    projectVisitsDuplicate: 'hud.nav.project.input.visits.duplicate',
    projectDrivers: 'hud.nav.project.input.drivers',
    projectDriversList: 'hud.nav.project.input.drivers.list',
    projectDriversCreate: 'hud.nav.project.input.drivers.create',
    projectDriversQuickadd: 'hud.nav.project.input.drivers.quickadd',
    projectDriversUpload: 'hud.nav.project.input.drivers.upload',
    projectDriversEdit: 'hud.nav.project.input.drivers.edit',
    projectRoute: 'hud.nav.project.route',
    projectRouteTimeline: 'hud.nav.project.route.timeline',
    projectRoutePlan: 'hud.nav.project.route.timeline.plan',
    projectRouteEdit: 'hud.nav.project.route.timeline.edit',
    projectRouteLive: 'hud.nav.project.route.timeline.live',
    projectRouteDispatch: 'hud.nav.project.route.dispatch',
    projects: 'hud.nav.projects',
    modal: 'hud.modal',
    modalOptInBeta: 'hud.modal.optInBeta',
    modalAccount: 'hud.modal.account',
    modalAccountUpgrade: 'hud.modal.account.upgrade',
    modalAccountCardUpdate: 'hud.modal.account.updateCard',
    modalSettings: 'hud.modal.settings',
    modalVideo: 'hud.modal.video',
    modalCsvMap: 'hud.modal.csv-map',
    modalCsvMapVisits: 'hud.modal.csv-map.visits',
    modalCsvMapDrivers: 'hud.modal.csv-map.drivers',
    modalCsvMapCustomers: 'hud.modal.csv-map.customers',
    modalCustomerProfile: 'hud.modal.customer-profile',
    modalProjects: 'hud.modal.projects',
    modalProjectsNew: 'hud.modal.projects.new',
    modalProjectsLoad: 'hud.modal.projects.load',
    modalProjectsDuplicate: 'hud.modal.projects.duplicate',
    modalProjectsEdit: 'hud.modal.projects.edit',
    modalQuestionnaire: 'hud.modal.questionnaire',
    modalProjectReport: 'hud.modal.report',
    modalProjectEndDay: 'hud.modal.end-day',
    modalCustomerUploadError: 'hud.modal.customer-error',
    modalVisitChecker: 'hud.modal.visitchecker',
    modalCustomerChecker: 'hud.modal.customerchecker',
    projectDeepLink: 'deeplink',
    internalProjects: 'hud.nav.internal-projects',
    projectRouteDebug: 'hud.nav.project.route.debug'
  };

  angular.module('app').constant('States', States);

}).call(this);

(function() {
  var Constants, PRODUCTION_ENV, env, key, value,
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Constants = {
    isDispatcherApp: true,
    apiPath: 'https://api.routific.com',
    notificationApiPath: 'https://notification.routific.com',
    productApiPath: 'https://product-api.routific.com',
    apiTestToken: '',
    routificUrl: 'https://routific.com',
    betaUrl: 'https://plan.routific.com',
    fullProductUrl: 'https://app.routific.com/',
    socketPath: 'https://api-socket.routific.com',
    gpsSocketKey: 'tZdbXQ.x2fJdw:vXTqCOirj_f6i5xf',
    ipGeolocationKey: 'undefined',
    cookieDomain: '.routific.com',
    routeInvisibleCSS: 'invisible',
    costPerVehicle: 39,
    costPerUpVisit: 1,
    visitsPerVehicle: 30,
    email: 'support@routific.com',
    TRIAL_PERIOD_DAYS: 7,
    FEATURE_TRIAL_PERIOD_DAYS: 7,
    currencies: {
      USD: 'usd',
      CAD: 'cad'
    },
    timeWindowStart: new Date(2014, 2, 1, 8, 0),
    timeWindowEnd: new Date(2014, 2, 1, 16, 0),
    timePickerConfig: {
      step: 15,
      timeFormat: 'H:i'
    },
    mainAppID: "lJ1r55OJ",
    mobileAppID: "YEegQA4k",
    DEFAULT_DURATION: 10,
    DEFAULT_LOAD: 1,
    vancouver: {
      countryCode: 'CA',
      coords: {
        lat: 49.2612260,
        lng: -123.1139268
      }
    },
    worldCenter: {
      coords: {
        lat: 50,
        lng: -10
      }
    },
    visitStatusDone: 'done',
    visitStatusSkipped: 'skipped',
    visitStatusPending: 'pending',
    notificationTypes: {
      visitDone: 'visitDone',
      visitDoneLate: 'visitDoneLate',
      visitSkipped: 'visitSkipped',
      routeUpdated: 'routeUpdated',
      dispatchSent: 'dispatchSent',
      breakDone: 'breakDone',
      smsError: 'smsError'
    },
    cssHidden: 'hidden',
    cssVisible: 'visible',
    unservedMessages: {
      unscheduled: "UNSERVED_MESSAGES.UNSCHEDULED",
      constraints: "UNSERVED_MESSAGES.CONSTRAINTS",
      newVisit: "UNSERVED_MESSAGES.NEW_VISIT",
      newStop: "UNSERVED_MESSAGES.NEW_STOP",
      manuallyUnserved: "UNSERVED_MESSAGES.MANUALLY_UNSERVED"
    },
    projectReadyStatus: 'ready',
    projectGeocodingStatus: 'geocoding',
    defaultXMapOffset: -1700,
    maxFixVisits: 500,
    minMarkerClusterCount: 250,
    publicLaunchFeature: "PUBLIC_LAUNCH",
    publicBetaFeature: "PUBLIC_BETA",
    DISPATCH_STATUS: {
      MISSING_NUMBER: {
        className: "missing-number",
        key: "CONSTANTS.MISSING_NUMBER"
      },
      NOT_DISPATCHED: {
        className: "not-dispatched",
        key: "CONSTANTS.NOT_DISPATCHED"
      },
      WAITING_FOR_UPDATE: {
        className: "pending-update",
        key: "CONSTANTS.WAITING_FOR_UPDATE"
      },
      DISPATCHED: {
        className: "dispatched",
        key: "CONSTANTS.DISPATCHED"
      },
      LIVE_TRACKING: {
        className: "live-tracking",
        key: "CONSTANTS.LIVE_TRACKING"
      },
      COMPLETED: {
        className: "completed",
        key: "CONSTANTS.COMPLETED"
      }
    },
    minDurationInMinutes: 1,
    payloadLimitInBytes: 8 * 1000 * 1000,
    BREAK_ID: 'nowhere',
    tooltipBoxId: "#tooltip",
    sidePanelOffset: 400,
    headerAndTabOffset: 100,
    leftNavOffset: 50,
    DEMO_STEPS: {
      address: 0,
      optimize: 1,
      dispatch: 2,
      sms: 3,
      complete: 4
    },
    funFactUrl: "https://www.fastcompany.com/3062836/this-bee-inspired-algorithm-helps-delivery-companies-plan-the-most-effi",
    UPDATE_EMAIL_QS: 'update-email-success',
    UPGRADE_QS: 'upgrade',
    CN_TRIAL_OVER_MODAL: '5c82c98c1406f800049caf10',
    EMAIL_CAPTURE_MODAL: '5d5ec6d3667d1c0004805e5f',
    QUICK_ADD_DRIVER_OPTIONS: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
    COUNTRY_LIST: ["Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo, Republic of the (Brazzaville)", "Congo, the Democratic Republic of the (Kinshasa)", "Cook Islands", "Costa Rica", "Côte d'Ivoire, Republic of", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Islas Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern and Antarctic Lands", "Gabon", "Gambia, The", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (Vatican City)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic of", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia, Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Réunion", "Romania", "Russian Federation", "Rwanda", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela, Bolivarian Republic of", "Vietnam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"],
    REGION_LIST: {
      "Canada": ["Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon"],
      "United States": ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "Armed Forces Americas", "Armed Forces Europe, Canada, Africa and Middle East", "Armed Forces Pacific"]
    }
  };

  PRODUCTION_ENV = ['prod', 'staging'];

  env = 'prod';

  Constants.inProduction = __indexOf.call(PRODUCTION_ENV, env) >= 0;

  for (key in Constants) {
    value = Constants[key];
    if (Constants[key] === 'undefined') {
      Constants[key] = void 0;
    }
  }

  angular.module('app').constant('Constants', Constants);

}).call(this);

(function() {
  var DriverSchemaC = {
    "type": "object",
    "required": ["shift-start", "shift-end", "start-location"],
    "properties": {
      "capacity": {
        "description": "Maximum space that this driver can take",
        "type": "number"
      },
      "end-location": {
        "description": "Final destination of this driver",
        "$ref": "LocationSchemaC"
      },
      "shift-start": {
        "description": "Time this driver starts his/her shift",
        "type": "string",
        "format": "time"
      },
      "shift-end": {
        "description": "Time this driver finishes his/her shift",
        "type": "string",
        "format": "time"
      },
      "start-location": {
        "description": "Starting location of this driver",
        "$ref": "LocationSchemaC"
      }
    }
  };

  angular.module('app').constant('DriverSchemaC', DriverSchemaC);

}).call(this);

(function() {
  var Events = {
    DRIVER_MODIFIED: 'DRIVER_MODIFIED',
    PROJECT_SWITCHED: 'PROJECT_SWITCHED',
    PROJECT_MODIFIED: 'PROJECT_MODIFIED',
    PROJECT_MODIFIED_LOCALLY: 'PROJECT_MODIFIED_LOCALLY',
    PROJECT_BUSY: "PROJECT_BUSY",
    PROJECT_NOT_BUSY: "PROJECT_NOT_BUSY",
    PROJECT_RELOADED: "PROJECT_RELOADED",
    PROJECT_RELOAD_ERROR: "PROJECT_RELOAD_ERROR",
    PROJECT_LOADED: "PROJECT_LOADED",
    PROJECT_LOAD_ERROR: "PROJECT_LOAD_ERROR",
    PROJECT_UPDATE_FINISHED: 'PROJECT_UPDATE_FINISHED',
    PROJECT_VERSION_MISMATCH: 'PROJECT_VERSION_MISMATCH',
    CSV_MAP_CLOSED: "CSV_MAP_CLOSED",
    CSV_UPLOAD_IN_PROGRESS: "CSV_UPLOAD_IN_PROGRESS",
    CSV_UPLOAD_COMPLETED: "CSV_UPLOAD_COMPLETED",
    DISPATCHES_UPDATED: 'DISPATCHES_UPDATED',
    DISPATCHES_DELETED: 'DISPATCHES_DELETED',
    DISPATCH_DELETED: 'DISPATCH_DELETED',
    OPTIMIZATION_IN_PROGRESS: "OPTIMIZATION_IN_PROGRESS",
    OPTIMIZATION_COMPLETED: "OPTIMIZATION_COMPLETED",
    OPTIMIZATION_ERRORED: "OPTIMIZATION_ERRORED",
    PROJECT_DISPATCH_STARTED: "PROJECT_DISPATCH_STARTED",
    PROJECT_DISPATCH_ENDED: "PROJECT_DISPATCH_ENDED",
    EXPAND_GANTT_CHART: 'EXPAND_GANTT_CHART',
    FIX_ROUTE_IN_PROGRESS: "FIX_ROUTE_IN_PROGRESS",
    FIX_ROUTE_COMPLETED: "FIX_ROUTE_COMPLETED",
    SETTINGS_CHANGED: "SETTINGS_CHANGED",
    VISIT_STATUS_UPDATED: 'VISIT_STATUS_UPDATED',
    VERIFIED_VISIT_STATUS_UPDATE: 'VERIFIED_VISIT_STATUS_UPDATE',
    VERIFIED_ROUTE_SEEN: 'VERIFIED_ROUTE_SEEN',
    ROUTE_SET: 'ROUTE_SET',
    DISPATCH_SENT: 'DISPATCH_SENT',
    NEW_ROUTES_CREATED: 'NEW_ROUTES_CREATED',
    ROUTE_UPDATED: 'ROUTE_UPDATED',
    ROUTE_DELETED: 'ROUTE_DELETED',
    ROUTE_SEEN: 'ROUTE_SEEN',
    NEW_MESSAGE: 'NEW_MESSAGE',
    ROUTE_CHART_HEIGHT_CHANGED: 'ROUTE_CHART_HEIGHT_CHANGED',
    USER_LOGGING_OUT: "USER_LOGGING_OUT",
    VISIT_ROUTE_INFO_CHANGED: function(visitId) {
      return "VISIT_ROUTE_INFO_CHANGED_" + visitId;
    },
    VISIT_WARNINGS_CHANGED: function(visitId) {
      return "VISIT_WARNINGS_CHANGED_" + visitId;
    },
    VISIT_STATUS_CHANGED: function(visitId) {
      return "VISIT_STATUS_CHANGED_" + visitId;
    },
    VISIT_MARKER_CHANGED: function(visitId) {
      return "VISIT_MARKER_CHANGED_" + visitId;
    },
    DRIVER_LOCATION_MARKER_CHANGED: function(driverId) {
      return "DRIVER_LOCATION_MARKER_CHANGED_" + driverId;
    },
    DRIVER_GPS_LOCATION_UPDATED: function(driverId) {
      return "DRIVER_GPS_LOCATION_UPDATED_" + driverId;
    },
    VALID_VISITS_UPDATED: "VALID_VISITS_UPDATED",
    VALID_DRIVERS_UPDATED: "VALID_DRIVERS_UPDATED",
    MAP_MARKER_ADDED: "MAP_MARKER_ADDED",
    MAP_MARKER_DESTROYED: "MAP_MARKER_DESTROYED",
    MAP_SET: "MAP_SET",
    SOCKET_DISCONNECTED: "SOCKET_DISCONNECTED",
    SOCKET_CONNECTED: "SOCKET_CONNECTED",
    SESSION_COUNT_UPDATE: "SESSION_COUNT_UPDATE",
    SESSION_PROJECT_UPDATED: "SESSION_PROJECT_UPDATED",
    SESSION_PROJECT_DELETED: "SESSION_PROJECT_DELETED",
    SIDE_PANEL_CHANGED: "SIDE_PANEL_CHANGED",
    SIDE_PANEL_UNSERVED_CHANGED: "SIDE_PANEL_UNSERVED_CHANGED",
    SIDE_PANEL_CLOSED: "SIDE_PANEL_CLOSED",
    SIDE_PANEL_OPENED: "SIDE_PANEL_OPENED",
    SIDE_PANEL_UPDATING: "SIDE_PANEL_UPDATING",
    REASSIGN_PANEL_OPENED: "REASSIGN_PANEL_OPENED",
    REASSIGN_PANEL_CLOSED: "REASSIGN_PANEL_CLOSED",
    SWAP_DRIVERS: "SWAP_DRIVERS",
    ROUTE_SELECTED: function(driverId) {
      return "ROUTE_SELECTED_" + driverId;
    },
    ROUTE_UNSELECTED: function(driverId) {
      return "ROUTE_UNSELECTED_" + driverId;
    },
    DEMO_STARTED: 'DEMO_STARTED',
    DEMO_FINISHED: 'DEMO_FINISHED',
    DEMO_MAP_CHANGED: 'DEMO_MAP_CHANGED',
    DEMO_PROJECT_RECEIVED: 'DEMO_PROJECT_RECEIVED',
    CLEAR_LASSO_SELECTION: 'CLEAR_LASSO_SELECTION',
    UPDATE_LASSO_SELECTION: 'UPDATE_LASSO_SELECTION',
    CUSTOMER_ASYNC_STARTED: 'CUSTOMER_ASYNC_STARTED',
    CUSTOMER_ASYNC_FINISHED: 'CUSTOMER_ASYNC_FINISHED',
    CUSTOMERS_CREATED: 'CUSTOMERS_CREATED',
    CUSTOMER_UPDATED: 'CUSTOMER_UPDATED',
    CUSTOMERS_UPLOAD_ERROR: 'CUSTOMERS_UPLOAD_ERROR',
    CUSTOMERS_DELETED: 'CUSTOMERS_DELETED',
    CUSTOMER_GEOCODING_STARTED: 'CUSTOMER_GEOCODING_STARTED',
    CUSTOMER_GEOCODING_UPDATED: 'CUSTOMER_GEOCODING_UPDATED',
    NEW_STOPS_ADDED: 'NEW_STOPS_ADDED',
    STOPS_ADD_START: 'STOPS_ADD_START',
    STOPS_ADD_ERROR: 'STOPS_ADD_ERROR',
    STOPS_ADD_SUCCESS: 'STOPS_ADD_SUCCESS',
    STOPS_GEOCODE_ERROR: 'STOPS_GEOCODE_ERROR',
    STOPS_GEOCODE_SUCCESS: 'STOPS_GEOCODE_SUCCESS',
    ADDRESS_FIELD_CHANGED: 'ADDRESS_FIELD_CHANGED',
    PROJECT_UPDATING_STARTED: 'PROJECT_UPDATING_STARTED',
    PROJECT_UPDATING_ENDED: 'PROJECT_UPDATING_ENDED',
    SIDE_PANEL_OPENED_FROM_NOTIFICATION: 'SIDE_PANEL_OPENED_FROM_NOTIFICATION',
    SMS_FAILED: 'SMS_FAILED',
    NOTIFICATION_CLEARED: 'NOTIFICATION_CLEARED',
    SMS_ERRORS_LOADED: 'SMS_ERRORS_LOADED',
    SHRINK_GANTT_CHART: 'SHRINK_GANTT_CHART',
    DELIVERY_METHOD_CHANGED: 'DELIVERY_METHOD_CHANGED',
    NEW_NOTIFICATION_ADDED: 'NEW_NOTIFICATION_ADDED',
    VISIT_PHONE_VALIDATED: 'VISIT_PHONE_VALIDATED',
    VISIT_CONFIRMED_ADDRESS: 'VISIT_CONFIRMED_ADDRESS',
    HIDE_EMPTY_VEHICLES_CHANGED: 'HIDE_EMPTY_VEHICLES_CHANGED',
    SORT_VEHICLES_BY_DEPARTURE_TIME_CHANGED: 'SORT_VEHICLES_BY_DEPARTURE_TIME_CHANGED'
  };

  angular.module('app').constant('Events', Events);

}).call(this);

(function() {
  var FunFactsF = function($translate) {
    var FUN_FACT_KEY_PREFIX, NUM_FACTS;
    FUN_FACT_KEY_PREFIX = "FUN_FACTS.FACT_";
    NUM_FACTS = 31;
    FunFactsF = {};
    FunFactsF.fetchRandom = function() {
      var i = Math.floor(Math.random() * NUM_FACTS);
      return $translate.instant(FUN_FACT_KEY_PREFIX + i);
    };
    return FunFactsF;
  };
  FunFactsF.$inject = ["$translate"];

  angular.module('app').factory('FunFactsF', FunFactsF);

}).call(this);

(function() {
  var GanttConstants, ICON_SIZE, ITEM_MARGIN, VISIT_HEIGHT;

  VISIT_HEIGHT = 30;

  ICON_SIZE = 18;

  ITEM_MARGIN = 8;

  GanttConstants = {
    ITEM_MARGIN: ITEM_MARGIN,
    DEPOT_MARGIN: 8,
    ICON_SIZE: ICON_SIZE,
    UPDATE_VISIT_ICON_SIZE: 10,
    TOOLTIP_ICON_SIZE: 10,
    DEPOT_SIZE: 30,
    VISIT_HEIGHT: VISIT_HEIGHT,
    DRAG_CLASS: 'drag',
    LOCKED_CLASS: 'locked',
    HIDDEN_CLASS: 'hidden',
    UNSERVED_WIDTH: 25,
    UNSERVED_MARGIN: 9,
    SHADOW_CLASS: 'gantt-shadow',
    INDEX_TEXT_WIDTH: 7,
    INDEX_TEXT_HEIGHT: 8,
    BREAK_ICON: 'break-icon',
    SHADOW_ICON_Y: ((VISIT_HEIGHT - ICON_SIZE) / 2) + ITEM_MARGIN - 1,
    MAX_ROWS: 9,
    GANTT_TYPE_LIVE: "live",
    VISIT_SKIPPED_CLASS: 'visit-skipped',
    VISIT_ON_TIME_CLASS: 'visit-on-time',
    VISIT_LATE_CLASS: 'visit-late',
    ZONE_TYPE_DRIVER: "drop_zone_driver",
    ZONE_TYPE_ROUTE: "drop_zone_route",
    DROP_ZONE_EVENT_ACTIVATE: "activate",
    DROP_ZONE_EVENT_HIDE: "hide",
    UNSCHEDULED_DRIVER_NAME: 'ROUTE_BOX.UNSCHEDULED',
    AUTO_SCHEDULE_BTN_HEIGHT: 30,
    AUTO_SCHEDULE_BTN_MARGIN_BOTTOM: 7,
    AUTO_SCHEDULE_BTN_WIDTH: 140,
    AUTO_SCHEDULE_BTN_MARGIN_RIGHT: 20,
    UNSCHEDULED_REASONS_BTN_WIDTH: 190,
    PER_CHAR_WIDTH: 5,
    POPUP_TEXT_PADDING: 10,
    POPUP_TEXT_HEIGHT: 16,
    POPUP_BORDER_RADIUS: 3,
    TIME_TEXT_LEFT_MARGIN: 5,
    WARNING_ICON: 'warning-icon',
    CLOCK_ICON: 'clock-icon',
    NEW_VISIT_ICON: 'new-visit-icon'
  };

  angular.module('app').constant('GanttConstants', GanttConstants);

}).call(this);

(function() {
  var LocationSchemaC = {
    "type": "object",
    "required": ["id", "lat", "lng"],
    "properties": {
      "id": {
        "type": "string"
      },
      "lat": {
        "type": "number"
      },
      "lng": {
        "type": "number"
      },
      "name": {
        "type": "string"
      }
    }
  };

  angular.module('app').constant('LocationSchemaC', LocationSchemaC);

}).call(this);

(function() {
  var CLUSTER_STYLES, COLORS, FONT_FAMILY, SIZES, TEXT_COLOR, TEXT_SIZE, _initStyles;

  SIZES = [
    {
      id: '1',
      height: 50,
      width: 50,
      anchor: [0, 0]
    }, {
      id: '2',
      height: 57,
      width: 57,
      anchor: [0, 0]
    }, {
      id: '3',
      height: 65,
      width: 65,
      anchor: [0, 0]
    }
  ];

  COLORS = ['colorDriverViolet', 'colorDriverPink', 'colorDriverBlue', 'colorDriverOrange', 'colorDriverLimeGreen', 'colorDriverGreen', 'colorDriverFushcia', 'colorDriverYellow', 'colorDriverLightBlue', 'colorDriverBloodOrange', 'colorDriverBlueGreen', 'colorDriverGrey', 'colorDriverUnserved'];

  TEXT_COLOR = "#313E40";

  TEXT_SIZE = 14;

  FONT_FAMILY = "routific-full-product";

  CLUSTER_STYLES = {};

  _initStyles = function() {
    var color, size, style, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = COLORS.length; _i < _len; _i++) {
      color = COLORS[_i];
      CLUSTER_STYLES[color] = [];
      _results.push((function() {
        var _j, _len1, _results1;
        _results1 = [];
        for (_j = 0, _len1 = SIZES.length; _j < _len1; _j++) {
          size = SIZES[_j];
          style = {
            url: "/img/clusters/" + color + "_" + size.id + ".png",
            height: size.height,
            width: size.width,
            anchor: size.anchor,
            textColor: TEXT_COLOR,
            textSize: TEXT_SIZE
          };
          _results1.push(CLUSTER_STYLES[color].push(style));
        }
        return _results1;
      })());
    }
    return _results;
  };

  _initStyles();

  angular.module('app').constant('ClusterStyles', CLUSTER_STYLES);

}).call(this);

(function() {
  var Messages = function($translate) {
    var ERROR_500_EMAIL, PROJECT_LOAD_EMAIL, SUPPORT_EMAIL, UNSUPPORTED_EMAIL, _supportEmail;
    SUPPORT_EMAIL = 'support@routific.com';
    _supportEmail = function(subject) {
      return "<a href='mailto:" + SUPPORT_EMAIL + "?Subject=" + subject + "'>" + SUPPORT_EMAIL + "</a>";
    };
    UNSUPPORTED_EMAIL = _supportEmail("Unsupported%20SMS%20Region");
    ERROR_500_EMAIL = _supportEmail("500%20Error");
    PROJECT_LOAD_EMAIL = _supportEmail("Project%20load%20failed");
    Messages = {
      PROJECT_LOAD_EMAIL: PROJECT_LOAD_EMAIL,
      ERROR_500_EMAIL: ERROR_500_EMAIL,
      UNSUPPORTED_EMAIL: UNSUPPORTED_EMAIL,
      REMOVE_ADDON_WARNING: function(header, desc) {
        return "<h2>" + header + "</h2><p>" + desc + "</p>";
      },
      DEBUG_RUN_ERROR: $translate.instant("MESSAGES.DEBUG_RUN_ERROR"),
      DEBUG_RUN_INCOMPLETE: $translate.instant("MESSAGES.DEBUG_RUN_INCOMPLETE"),
      DEBUG_NOT_FOUND: $translate.instant("MESSAGES.DEBUG_NOT_FOUND"),
      CANNOT_MODIFY_DEBUG_PROJECT: $translate.instant("MESSAGES.CANNOT_MODIFY_DEBUG_PROJECT")
    };
    return Messages;
  };
  Messages.$inject = ["$translate"];

  angular.module('app').factory('Messages', Messages);

}).call(this);

(function() {
  var PER_VISIT_PLANS, Plans, SMALL_BUSINESS_PLANS, addon, addon_legacy, alias, feature, k, name, type, v,
    __hasProp = {}.hasOwnProperty;

  feature = {
    ONBOARDING_TUTORIAL: 'Onboarding tutorials',
    EMAIL_SUPPORT: 'Email support',
    PHONE_LIVE_SUPPORT: 'Phone + live chat support',
    WEB_DRIVER_APP: 'Web + Driver app',
    CHOOSE_OWN_ADDONS: 'Choose your own add-ons',
    THREE_HOURS_TRAINING: 'Up to 3 hours training',
    TEN_HOURS_TRAINING: 'Up to 10 hours training',
    LIVE_TRACKING: 'Live Driver Tracking',
    SIGNATURE_CAPTURE: 'Signature Capture',
    DELIVERY_PERF_ANALYTICS: 'Driver Analytics',
    API_INTEGRATION: 'API integration',
    OPTIMIZE_UP_TO: 'Optimize up to 2,000 stops',
    OPTIMIZE_WITH: 'Optimize with unlimited stops',
    SUPPORT_SLA: 'Premium support SLA',
    CUSTOM_INTEGRATIONS: 'Custom integrations',
    FEATURES_UPON_REQUEST: 'Advanced features upon request',
    WHITE_LABEL_SOLUTION: 'White-labeled solution',
    UNLIMITED_PROJECTS: 'Unlimited routing projects',
    DEDICATED_SUCCESS_MANAGER: 'Dedicated Success Manager'
  };

  addon_legacy = {
    LIVE_TRACKING: {
      name: 'Live Tracking',
      tooltip: 'Track your drivers’ progress and get updated ETAs throughout the day. Make quick adjustments and re-route instantly.',
      price: {
        monthly: 19,
        annual: 16
      },
      perUnit: true,
      trialOnly: false,
      id: {
        monthly: 'live_tracking',
        annual: 'live_tracking_annual'
      }
    },
    SIGNATURE_CAPTURE: {
      name: 'Signature Capture',
      tooltip: 'Everyone stays accountable with proof of delivery.',
      price: {
        monthly: 5,
        annual: 3
      },
      perUnit: true,
      trialOnly: false,
      id: {
        monthly: 'signature',
        annual: 'signature_annual'
      }
    }
  };

  addon = {
    CUSTOMER_NOTIFICATIONS: {
      name: 'Customer Notifications',
      tooltip: 'Automatically update your customers on their order\'s ETA and delivery status via SMS (text message)',
      price: {
        monthly: 19,
        annual: 16
      },
      perUnit: true,
      trialOnly: false,
      id: {
        monthly: 'customer_notifications_per_vehicle_monthly',
        annual: 'customer_notifications_per_vehicle_annual'
      }
    },
    CUSTOMER_NOTIFICATIONS_2023: {
      name: 'Customer Notifications',
      tooltip: 'Automatically update your customers on their order\'s ETA and delivery status via SMS (text message)',
      price: {
        monthly: 24,
        annual: 19
      },
      perUnit: true,
      trialOnly: false,
      id: {
        monthly: 'price_0O2KfDL8keDL1NYcPvoZ0pl1',
        annual: 'price_0O0RsyL8keDL1NYcTRTSIEBI'
      }
    }
  };

  type = {
    TRIAL: {
      name: 'Trial Plan',
      minVehicle: 1,
      price: {
        monthly: 0,
        annual: 0
      },
      contactOnly: false,
      id: {
        monthly: 'trial',
        annual: 'trial'
      },
      addons: [addon_legacy.LIVE_TRACKING, addon_legacy.SIGNATURE_CAPTURE, addon.CUSTOMER_NOTIFICATIONS],
      features: []
    },
    SMALL_BUSINESS: {
      name: 'Small Business',
      minVehicle: 1,
      price: {
        monthly: 39,
        annual: 33
      },
      contactOnly: false,
      id: {
        monthly: 'per_vehicle_app_USD',
        annual: 'per_vehicle_app_annual'
      },
      addons: [],
      availableAddons: [addon_legacy.LIVE_TRACKING, addon_legacy.SIGNATURE_CAPTURE],
      features: [feature.ONBOARDING_TUTORIAL, feature.EMAIL_SUPPORT, feature.WEB_DRIVER_APP, feature.CHOOSE_OWN_ADDONS],
      deprecated: true
    },
    GROWTH: {
      name: 'Growth',
      minVehicle: 5,
      price: {
        monthly: 59,
        annual: 49
      },
      contactOnly: false,
      id: {
        monthly: 'growth_per_vehicle',
        annual: 'growth_per_vehicle_annual'
      },
      addons: [addon_legacy.LIVE_TRACKING, addon_legacy.SIGNATURE_CAPTURE],
      features: [feature.THREE_HOURS_TRAINING, feature.PHONE_LIVE_SUPPORT, feature.WEB_DRIVER_APP, feature.LIVE_TRACKING, feature.SIGNATURE_CAPTURE, feature.DELIVERY_PERF_ANALYTICS, feature.API_INTEGRATION, feature.OPTIMIZE_UP_TO],
      deprecated: true
    },
    ENTERPRISE: {
      name: 'Enterprise',
      minVehicle: 0,
      price: {
        monthly: 79,
        annual: 66
      },
      contactOnly: true,
      id: {
        monthly: 'enterprise_per_vehicle',
        annual: 'enterprise_per_vehicle_annual'
      },
      addons: [addon_legacy.LIVE_TRACKING, addon_legacy.SIGNATURE_CAPTURE],
      features: [feature.TEN_HOURS_TRAINING, feature.SUPPORT_SLA, feature.CUSTOM_INTEGRATIONS, feature.FEATURES_UPON_REQUEST, feature.SIGNATURE_CAPTURE, feature.DELIVERY_PERF_ANALYTICS, feature.API_INTEGRATION, feature.OPTIMIZE_WITH, feature.WHITE_LABEL_SOLUTION],
      deprecated: true
    },
    ESSENTIALS: {
      name: 'Essentials',
      minVehicle: 1,
      price: {
        monthly: 39,
        annual: 33
      },
      contactOnly: false,
      id: {
        monthly: 'essentials_per_vehicle_monthly',
        annual: 'essentials_per_vehicle_annual'
      },
      addons: [],
      availableAddons: [],
      features: [feature.WEB_DRIVER_APP, feature.UNLIMITED_PROJECTS, feature.EMAIL_SUPPORT],
      grandfathered: {
        monthly: 'price_0N8ryEL8keDL1NYcwT15Dpk8',
        annual: 'price_0N8ry4L8keDL1NYcOWHrV2oU'
      }
    },
    ESSENTIALS_2023: {
      name: 'Essentials',
      minVehicle: 1,
      price: {
        monthly: 49,
        annual: 39
      },
      contactOnly: false,
      id: {
        monthly: 'price_0N8ryEL8keDL1NYcwT15Dpk8',
        annual: 'price_0N8ry4L8keDL1NYcOWHrV2oU'
      },
      addons: [],
      availableAddons: [],
      features: [feature.WEB_DRIVER_APP, feature.UNLIMITED_PROJECTS, feature.EMAIL_SUPPORT]
    },
    PROFESSIONAL: {
      name: 'Professional',
      minVehicle: 1,
      price: {
        monthly: 59,
        annual: 49
      },
      contactOnly: false,
      id: {
        monthly: 'professional_per_vehicle_monthly',
        annual: 'professional_per_vehicle_annual'
      },
      grandfathered: {
        monthly: 'price_0O2KbjL8keDL1NYculupF5IK',
        annual: 'price_0O0RuJL8keDL1NYccdmTcUI5'
      },
      addons: [addon_legacy.LIVE_TRACKING, addon_legacy.SIGNATURE_CAPTURE],
      availableAddons: [addon.CUSTOMER_NOTIFICATIONS],
      features: [feature.WEB_DRIVER_APP, feature.UNLIMITED_PROJECTS, feature.EMAIL_SUPPORT, feature.PHONE_LIVE_SUPPORT, feature.LIVE_TRACKING, feature.SIGNATURE_CAPTURE, feature.DELIVERY_PERF_ANALYTICS, feature.API_INTEGRATION],
      unique: [feature.PHONE_LIVE_SUPPORT, feature.LIVE_TRACKING, feature.SIGNATURE_CAPTURE, feature.DELIVERY_PERF_ANALYTICS, feature.API_INTEGRATION]
    },
    PROFESSIONAL_2023: {
      name: 'Professional',
      minVehicle: 1,
      price: {
        monthly: 69,
        annual: 59
      },
      contactOnly: false,
      id: {
        monthly: 'price_0O2KbjL8keDL1NYculupF5IK',
        annual: 'price_0O0RuJL8keDL1NYccdmTcUI5'
      },
      addons: [addon_legacy.LIVE_TRACKING, addon_legacy.SIGNATURE_CAPTURE],
      availableAddons: [addon.CUSTOMER_NOTIFICATIONS_2023],
      features: [feature.WEB_DRIVER_APP, feature.UNLIMITED_PROJECTS, feature.EMAIL_SUPPORT, feature.PHONE_LIVE_SUPPORT, feature.LIVE_TRACKING, feature.SIGNATURE_CAPTURE, feature.DELIVERY_PERF_ANALYTICS, feature.API_INTEGRATION],
      unique: [feature.PHONE_LIVE_SUPPORT, feature.LIVE_TRACKING, feature.SIGNATURE_CAPTURE, feature.DELIVERY_PERF_ANALYTICS, feature.API_INTEGRATION]
    },
    PREMIUM: {
      name: 'Premium',
      minVehicle: 0,
      price: {
        monthly: 79,
        annual: 66
      },
      contactOnly: true,
      id: {
        monthly: 'premium_per_vehicle_monthly',
        annual: 'premium_per_vehicle_annual'
      },
      addons: [addon_legacy.SIGNATURE_CAPTURE, addon_legacy.LIVE_TRACKING],
      availableAddons: [addon.CUSTOMER_NOTIFICATIONS],
      features: [feature.WEB_DRIVER_APP, feature.UNLIMITED_PROJECTS, feature.EMAIL_SUPPORT, feature.PHONE_LIVE_SUPPORT, feature.LIVE_TRACKING, feature.SIGNATURE_CAPTURE, feature.DELIVERY_PERF_ANALYTICS, feature.API_INTEGRATION, feature.DEDICATED_SUCCESS_MANAGER, feature.TEN_HOURS_TRAINING],
      unique: [feature.DEDICATED_SUCCESS_MANAGER, feature.TEN_HOURS_TRAINING]
    },
    PER_VISIT: {
      name: 'Per Stop',
      minVehicle: 1,
      price: {
        monthly: 39,
        annual: 33
      },
      contactOnly: false,
      id: {
        monthly: 'per_visit_USD',
        annual: 'per_visit_USD'
      },
      addons: [],
      features: []
    },
    FIXED_TIER: {
      name: 'Fixed Tier',
      minVehicle: 1,
      price: {
        monthly: 39,
        annual: 33
      },
      contactOnly: false,
      id: {
        monthly: 'fixed_tier',
        annual: 'fixed_tier'
      },
      addons: [],
      features: []
    }
  };

  SMALL_BUSINESS_PLANS = {
    per_vehicle_app_USD_3_days_trial: true,
    per_vehicle_app_USD: true,
    per_vehicle_app_annual: true,
    per_vehicle_USD: true,
    per_vehicle: true
  };

  PER_VISIT_PLANS = {
    per_visit: true,
    per_visit_USD: true,
    fixed_tier_A: true,
    fixed_tier_B: true,
    fixed_tier_C: true,
    fixed_tier_D: true,
    fixed_tier_E: true,
    fixed_tier_1000: true,
    fixed_tier_2000: true,
    fixed_tier_5000: true,
    fixed_tier_15000: true,
    fixed_tier_35000: true,
    daily_fixed_tier_1000: true,
    daily_fixed_tier_2000: true,
    daily_fixed_tier_5000: true,
    daily_fixed_tier_15000: true
  };

  alias = {
    addon: {},
    type: {}
  };

  for (k in addon) {
    if (!__hasProp.call(addon, k)) continue;
    v = addon[k];
    alias.addon[v.id.monthly] = v;
    alias.addon[v.id.annual] = v;
  }

  for (k in type) {
    if (!__hasProp.call(type, k)) continue;
    v = type[k];
    alias.type[v.id.monthly] = v;
    alias.type[v.id.annual] = v;
  }

  alias.type['per_vehicle_app_USD_3_days_trial'] = type.SMALL_BUSINESS;

  alias.type['per_vehicle_USD'] = type.SMALL_BUSINESS;

  alias.type['per_vehicle'] = type.SMALL_BUSINESS;

  alias.type['per_visit'] = type.PER_VISIT;

  alias.type['per_visit_USD'] = type.PER_VISIT;

  alias.type['fixed_tier_A'] = type.FIXED_TIER;

  alias.type['fixed_tier_B'] = type.FIXED_TIER;

  alias.type['fixed_tier_C'] = type.FIXED_TIER;

  alias.type['fixed_tier_D'] = type.FIXED_TIER;

  alias.type['fixed_tier_E'] = type.FIXED_TIER;

  alias.type['fixed_tier_1000'] = type.FIXED_TIER;

  alias.type['fixed_tier_2000'] = type.FIXED_TIER;

  alias.type['fixed_tier_5000'] = type.FIXED_TIER;

  alias.type['fixed_tier_15000'] = type.FIXED_TIER;

  alias.type['fixed_tier_35000'] = type.FIXED_TIER;

  alias.type['daily_fixed_tier_1000'] = type.FIXED_TIER;

  alias.type['daily_fixed_tier_2000'] = type.FIXED_TIER;

  alias.type['daily_fixed_tier_5000'] = type.FIXED_TIER;

  alias.type['daily_fixed_tier_15000'] = type.FIXED_TIER;

  alias.addon['liveTracking'] = addon_legacy.LIVE_TRACKING;

  alias.addon['signature'] = addon_legacy.SIGNATURE_CAPTURE;

  alias.addon['customerNotification'] = addon.CUSTOMER_NOTIFICATIONS_2023;

  for (name in SMALL_BUSINESS_PLANS) {
    alias.type[name] = type.SMALL_BUSINESS;
  }

  Plans = {
    PER_VISIT_PLANS: PER_VISIT_PLANS,
    SMALL_BUSINESS_PLANS: SMALL_BUSINESS_PLANS,
    addon: addon,
    type: type,
    alias: alias,
    feature: feature
  };

  angular.module('app').constant('Plans', Plans);

}).call(this);

(function() {
  var Questions = {
    business_type: ['Business that makes home deliveries', 'Courier', 'Other'],
    total_monthly_stops: ['1 - 300', '300 - 2000', '2000 - 10000', '10000+'],
    routing_method: ['Google Maps, Mapquest, etc', 'Spreadsheets', 'Pen and paper', 'Other software', 'Drivers'],
    routing_frequency: _.shuffle(['Multiple days at one time', 'One day at a time', 'On demand with lots of routes per day'])
  };

  angular.module('app').constant('Questions', Questions);

}).call(this);

(function() {
  var Customer = function(TimeUtilF) {
    var _parseTimeWindow;
    _parseTimeWindow = function(start, end) {
      var timeWindow = '';
      if (start) {
        timeWindow += start + ' - ';
        if (end) {
          timeWindow += end;
        }
      } else if (end) {
        timeWindow += ' - ' + end;
      }
      return timeWindow;
    };
    Customer = (function() {
      function Customer(entry) {
        var k, v, _ref, _ref1, _ref2;
        if (entry.id != null) {
          this.id = entry.id;
        }
        if (entry.status != null) {
          this.status = entry.status;
        }
        if (entry.user_id != null) {
          this.user_id = entry.user_id;
        }
        if (entry.name != null) {
          this.name = entry.name;
        }
        if (entry.location != null) {
          this.location = entry.location;
        }
        if (((_ref = entry.location) != null ? _ref.address : void 0) != null) {
          this.address = (_ref1 = entry.location) != null ? _ref1.address : void 0;
        }
        if (entry.email != null) {
          this.email = entry.email;
        }
        if (entry.start != null) {
          this.startDate = TimeUtilF.convertTimeToDate(entry.start);
        }
        if (entry.end != null) {
          this.endDate = TimeUtilF.convertTimeToDate(entry.end);
        }
        this.timeWindow = _parseTimeWindow(entry.start, entry.end);
        if (entry.phone != null) {
          this.phone = entry.phone;
        }
        if (entry.notes != null) {
          this.notes = entry.notes;
        }
        if (entry.notes_2 != null) {
          this.notes_2 = entry.notes_2;
        }
        if (entry.types != null) {
          this.types = entry.types;
        }
        if (entry.load != null) {
          this.load = entry.load;
        }
        if (entry.duration != null) {
          this.duration = entry.duration;
        }
        if (entry.priority != null) {
          this.priority = entry.priority;
        }
        if (entry.created_date != null) {
          this.created_date = entry.created_date;
        }
        if (entry.updated_date != null) {
          this.updated_date = entry.updated_date;
        }
        if (entry.metadata != null) {
          this.metadata = entry.metadata;
        }
        this.selected = false;
        if (entry.metadata != null) {
          _ref2 = entry.metadata;
          for (k in _ref2) {
            v = _ref2[k];
            this[k] = v;
          }
        }
      }

      return Customer;

    })();
    return Customer;
  };
  Customer.$inject = ["TimeUtilF"];

  angular.module('app').factory('Customer', Customer);

}).call(this);

(function() {
  var CustomerCsvMapC = function($scope, $state, CustomerF, VisitCsvHeaderF, CustomerFileUploadF, MessagingF, MarkersF, EventListenersF, Events, States) {
    var _isColumnSelected, _mapMatchingColumns, _saveCsvColumns;
    _mapMatchingColumns = (function(_this) {
      return function() {
        var col, columnName, lowerMappedName, mappedHeader, name, _i, _len, _ref, _ref1, _results;
        var cachedMap = VisitCsvHeaderF.headerMap;
        _ref = _this.columns;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          col = _ref[_i];
          columnName = col.name.toLowerCase();
          mappedHeader = cachedMap[columnName];
          lowerMappedName = mappedHeader != null ? (_ref1 = mappedHeader.mappedCol) != null ? _ref1.trim().toLowerCase() : void 0 : void 0;
          name = void 0;
          if (lowerMappedName) {
            name = _.detect(_this.userHeader, function(current) {
              return lowerMappedName === current.trim().toLowerCase();
            });
          }
          if (!name) {
            name = _.detect(_this.userHeader, function(current) {
              return columnName === current.trim().toLowerCase();
            });
          }
          _results.push(col.mappedCol = name ? name : void 0);
        }
        return _results;
      };
    })(this);
    _isColumnSelected = function(columns, columnName) {
      var col, _i, _len;
      for (_i = 0, _len = columns.length; _i < _len; _i++) {
        col = columns[_i];
        if (col.name === columnName) {
          return !!col.mappedCol;
        }
      }
      return false;
    };
    _saveCsvColumns = function(mapping) {
      var current;
      var columns = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = mapping.length; _i < _len; _i++) {
          current = mapping[_i];
          _results.push(current.name);
        }
        return _results;
      })();
      return VisitCsvHeaderF.updateColumns(columns);
    };
    this.enableCustomNotes = true;
    this.userHeader = CustomerFileUploadF.userHeader;
    this.columns = _.cloneDeep(VisitCsvHeaderF.columns);
    this.read = function(columns) {
      var addressSelected, latSelected, lngSelected, message, onFileValidated;
      EventListenersF.notify(Events.CSV_MAP_CLOSED);
      columns = _.filter(columns, function(obj) {
        return !!obj.name;
      });
      addressSelected = _isColumnSelected(columns, 'Address');
      latSelected = _isColumnSelected(columns, 'Latitude');
      lngSelected = _isColumnSelected(columns, 'Longitude');
      if (latSelected || lngSelected) {
        message = null;
        if (!lngSelected) {
          message = "'Longitude' column must be selected since 'Latitude' is selected";
        }
        if (!latSelected) {
          message = "'Latitude' column must be selected since 'Longitude' is selected";
        }
        if (message) {
          this.error = message;
          return;
        }
      } else if (!addressSelected) {
        this.error = "'Address' or 'Latitude/Longitude' columns must be selected";
        return;
      }
      onFileValidated = function() {
        VisitCsvHeaderF.setHeaderMap(columns);
        _saveCsvColumns(columns);
        return $scope.closeThisDialog(States.customers);
      };
      return CustomerFileUploadF.read(CustomerFileUploadF.file, columns, false).then(function(res) {
        return CustomerF.createCustomers(res, true);
      }).then(null, null, onFileValidated)["catch"](function(err) {
        var _ref;
        $scope.closeThisDialog();
        if (((_ref = err.data) != null ? _ref.errors : void 0) != null) {
          return CustomerFileUploadF.handleUploadErr(err.data.errors);
        } else {
          return MessagingF.replaceError(err.message || err.error);
        }
      });
    };
    this.updateFieldName = function(column) {
      return function(newName) {
        return column.name = newName;
      };
    };
    this.updateCancelled = function(column) {
      return (function(_this) {
        return function() {
          var current, index, _i, _len, _ref, _results;
          if (column.name.trim().length === 0) {
            _ref = _this.columns;
            _results = [];
            for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
              current = _ref[index];
              if (!(current.id === column.id)) {
                continue;
              }
              _this.columns.splice(index, 1);
              break;
            }
            return _results;
          }
        };
      })(this);
    };
    this.addNewColumn = function() {
      return this.columns.push({
        id: this.columns.length,
        name: '',
        isOptional: true,
        isUserDefined: true
      });
    };
    _mapMatchingColumns();
  };
  CustomerCsvMapC.$inject = ["$scope", "$state", "CustomerF", "VisitCsvHeaderF", "CustomerFileUploadF", "MessagingF", "MarkersF", "EventListenersF", "Events", "States"];

  angular.module('app').controller('CustomerCsvMapC', CustomerCsvMapC);

}).call(this);

(function() {
  var CustomerF = function($http, $q, AccountF, Customer, Constants, EventListenersF, MessagingF, TimeUtilF, Events, SessionF) {
    var CUSTOMERS_URL, DEFAULT_LIMIT, DEFAULT_OFFSET, DEFAULT_SORT_BY, DEFAULT_SORT_ORDER, MAX_LIMIT, _customersById, _fetchCustomer, _fetchCustomerByIds, _fetchCustomers, _formatCustomer, _parseCustomer;
    CUSTOMERS_URL = "" + Constants.productApiPath + "/customers";
    DEFAULT_SORT_BY = "created_date";
    DEFAULT_SORT_ORDER = "desc";
    DEFAULT_LIMIT = 100;
    DEFAULT_OFFSET = 0;
    MAX_LIMIT = 100000;
    _customersById = {};
    _parseCustomer = function(customerObj) {
      var customer = new Customer(customerObj);
      return customer;
    };
    _formatCustomer = function(customerEntry) {
      var k, newEntry, v, _ref, _ref1;
      newEntry = _.clone(customerEntry);
      if ((newEntry.phone != null) && newEntry.phone.length === 0) {
        newEntry.phone = null;
      }
      if ((newEntry.email != null) && newEntry.email.length === 0) {
        newEntry.email = null;
      }
      if ((newEntry.notes != null) && newEntry.notes.length === 0) {
        newEntry.notes = null;
      }
      if ((newEntry.notes_2 != null) && newEntry.notes_2.length === 0) {
        newEntry.notes_2 = null;
      }
      if (newEntry.startDate) {
        newEntry.start = TimeUtilF.convertDateToTime(newEntry.startDate);
        delete newEntry.startDate;
      }
      if (newEntry.endDate) {
        newEntry.end = TimeUtilF.convertDateToTime(newEntry.endDate);
        delete newEntry.endDate;
      }
      if (((_ref = newEntry.location) != null ? _ref.all_results : void 0) != null) {
        delete newEntry.location.all_results;
      }
      if (newEntry.metadata != null) {
        _ref1 = newEntry.metadata;
        for (k in _ref1) {
          v = _ref1[k];
          if (!v) {
            delete newEntry.metadata[k];
          }
        }
      }
      return newEntry;
    };
    _fetchCustomerByIds = function(ids, sortBy, sortOrder, limit, offset, status) {
      var statusParam;
      var authHeader = AccountF.getAuthHeader();
      statusParam = status ? "&status=" + status : "";
      return $http.post("" + CUSTOMERS_URL + "/id?limit=" + limit + "&offset=" + offset + "&sort_by=" + sortBy + "&sort_order=" + sortOrder + statusParam, ids, authHeader).then(function(res) {
        var customers, entries, entry, total;
        entries = res.data.data;
        total = res.data.total;
        customers = (function() {
          var _i, _len, _results;
          _results = [];
          for (_i = 0, _len = entries.length; _i < _len; _i++) {
            entry = entries[_i];
            _results.push(_parseCustomer(entry));
          }
          return _results;
        })();
        return {
          customers: customers,
          total: total
        };
      });
    };
    _fetchCustomers = function(sortBy, sortOrder, searchString, limit, offset, idsOnly, status) {
      var idsOnlyParam, searchParam, statusParam;
      var authHeader = AccountF.getAuthHeader();
      searchParam = (searchString != null) && searchString !== "" ? "&search=" + searchString : "";
      idsOnlyParam = idsOnly ? "&id_only=true" : "";
      statusParam = status ? "&status=" + status : "";
      return $http.get("" + CUSTOMERS_URL + "?limit=" + limit + "&offset=" + offset + "&sort_by=" + sortBy + "&sort_order=" + sortOrder + searchParam + idsOnlyParam + statusParam, authHeader).then(function(res) {
        var customers, entries, entry, ids, total;
        entries = res.data.data;
        total = res.data.total;
        customers = [];
        ids = [];
        if (!idsOnly) {
          customers = (function() {
            var _i, _len, _results;
            _results = [];
            for (_i = 0, _len = entries.length; _i < _len; _i++) {
              entry = entries[_i];
              _results.push(_parseCustomer(entry));
            }
            return _results;
          })();
        } else {
          ids = (function() {
            var _i, _len, _results;
            _results = [];
            for (_i = 0, _len = entries.length; _i < _len; _i++) {
              entry = entries[_i];
              _results.push(entry.id);
            }
            return _results;
          })();
        }
        return {
          customers: customers,
          total: total,
          ids: ids
        };
      });
    };
    _fetchCustomer = function(customerId) {
      var authHeader = AccountF.getAuthHeader();
      return $http.get("" + CUSTOMERS_URL + "/" + customerId, authHeader).then(function(res) {
        var customer, entry;
        entry = res.data;
        customer = _parseCustomer(entry);
        return customer;
      });
    };
    CustomerF.getCustomerByIds = function(ids, sortBy, sortOrder, limit, offset, status, noEvents) {
      sortBy = sortBy || DEFAULT_SORT_BY;
      sortOrder = sortOrder || DEFAULT_SORT_ORDER;
      limit = limit || DEFAULT_LIMIT;
      offset = offset || DEFAULT_OFFSET;
      if (!noEvents) {
        EventListenersF.notify(Events.CUSTOMER_ASYNC_STARTED);
      }
      return _fetchCustomerByIds(ids, sortBy, sortOrder, limit, offset, status).then(function(_arg) {
        var customer, customers, total, _i, _len;
        customers = _arg.customers, total = _arg.total;
        for (_i = 0, _len = customers.length; _i < _len; _i++) {
          customer = customers[_i];
          _customersById[customer.id] = customer;
        }
        return {
          customers: customers,
          total: total
        };
      })["finally"](function() {
        if (!noEvents) {
          return EventListenersF.notify(Events.CUSTOMER_ASYNC_FINISHED);
        }
      });
    };
    CustomerF.getAllIdsForQuery = function(sortBy, sortOrder, searchString) {
      var limit, offset;
      sortBy = sortBy || DEFAULT_SORT_BY;
      sortOrder = sortOrder || DEFAULT_SORT_ORDER;
      offset = DEFAULT_OFFSET;
      limit = MAX_LIMIT;
      EventListenersF.notify(Events.CUSTOMER_ASYNC_STARTED);
      return _fetchCustomers(sortBy, sortOrder, searchString, limit, offset, true).then(function(_arg) {
        var ids, total;
        var customers = _arg.customers, total = _arg.total, ids = _arg.ids;
        return {
          total: total,
          ids: ids
        };
      })["finally"](function() {
        return EventListenersF.notify(Events.CUSTOMER_ASYNC_FINISHED);
      });
    };
    CustomerF.getCustomers = function(sortBy, sortOrder, searchString, limit, offset, status) {
      sortBy = sortBy || DEFAULT_SORT_BY;
      sortOrder = sortOrder || DEFAULT_SORT_ORDER;
      limit = limit || DEFAULT_LIMIT;
      offset = offset || DEFAULT_OFFSET;
      EventListenersF.notify(Events.CUSTOMER_ASYNC_STARTED);
      return _fetchCustomers(sortBy, sortOrder, searchString, limit, offset, false, status).then(function(_arg) {
        var customer, customers, ids, total, _i, _len;
        customers = _arg.customers, total = _arg.total, ids = _arg.ids;
        for (_i = 0, _len = customers.length; _i < _len; _i++) {
          customer = customers[_i];
          _customersById[customer.id] = customer;
        }
        return {
          customers: customers,
          total: total
        };
      })["finally"](function() {
        return EventListenersF.notify(Events.CUSTOMER_ASYNC_FINISHED);
      });
    };
    CustomerF.getCustomer = function(customerId) {
      var customer = _customersById[customerId];
      if (customer != null) {
        return $q.when(customer);
      } else {
        EventListenersF.notify(Events.CUSTOMER_ASYNC_STARTED);
        return _fetchCustomer(customerId).then(function(customer) {
          _customersById[customer.id] = customer;
          return customer;
        })["finally"](function() {
          return EventListenersF.notify(Events.CUSTOMER_ASYNC_FINISHED);
        });
      }
    };
    CustomerF.createCustomers = function(customersArray, skipFormat) {
      var authHeader, formattedCustomers;
      if (skipFormat == null) {
        skipFormat = false;
      }
      EventListenersF.notify(Events.CUSTOMER_ASYNC_STARTED);
      if (skipFormat) {
        formattedCustomers = customersArray;
      } else {
        formattedCustomers = _.map(customersArray, function(customer) {
          return _formatCustomer(customer);
        });
      }
      authHeader = AccountF.getAuthHeader();
      return $http.post("" + Constants.productApiPath + "/customers-batch", formattedCustomers, authHeader).then(function(res) {
        var _ref;
        EventListenersF.notify(Events.CUSTOMERS_CREATED, res.data.count);
        if (formattedCustomers.length === 1) {
          return MessagingF.replaceSuccessPopup("CUSTOMER_MESSAGES.CREATE_SUCCESS", {
            name: formattedCustomers[0].name
          });
        } else {
          return MessagingF.replaceSuccessPopup("CUSTOMER_MESSAGES.UPLOAD_SUCCESS", {
            count: (_ref = res.data) != null ? _ref.count : void 0
          });
        }
      })["finally"](function() {
        return EventListenersF.notify(Events.CUSTOMER_ASYNC_FINISHED);
      });
    };
    CustomerF.updateCustomer = function(customerId, customer) {
      var authHeader, formattedCustomer;
      EventListenersF.notify(Events.CUSTOMER_ASYNC_STARTED);
      formattedCustomer = _formatCustomer(customer);
      authHeader = AccountF.getAuthHeader();
      return $http.put("" + Constants.productApiPath + "/customers/" + customerId, formattedCustomer, authHeader).then(function(res) {
        var parsedCustomer = _parseCustomer(res.data);
        _customersById[customerId] = parsedCustomer;
        EventListenersF.notify(Events.CUSTOMER_UPDATED, parsedCustomer);
        return MessagingF.replaceSuccessPopup("CUSTOMER_MESSAGES.UPDATE_SUCCESS", {
          name: formattedCustomer.name
        });
      })["finally"](function() {
        return EventListenersF.notify(Events.CUSTOMER_ASYNC_FINISHED);
      });
    };
    CustomerF.deleteCustomers = function(customersIds) {
      var authHeader;
      EventListenersF.notify(Events.CUSTOMER_ASYNC_STARTED);
      authHeader = AccountF.getAuthHeader();
      return $http["delete"]("" + Constants.productApiPath + "/customers-batch?ids=" + (customersIds.join()), authHeader)["finally"](function() {
        return EventListenersF.notify(Events.CUSTOMER_ASYNC_FINISHED);
      });
    };
    CustomerF.getGeocodeInfo = function() {
      var authHeader = AccountF.getAuthHeader();
      return $http.get("" + Constants.productApiPath + "/geocoding-jobs", authHeader).then(function(res) {
        return res.data;
      });
    };
    CustomerF.updateCustomerLocation = function(customerId, locationObj) {
      var authHeader;
      EventListenersF.notify(Events.CUSTOMER_ASYNC_STARTED);
      authHeader = AccountF.getAuthHeader();
      return $http.put("" + Constants.productApiPath + "/customers/" + customerId + "/location", locationObj, authHeader).then(function(res) {
        var parsedCustomer = _parseCustomer(res.data);
        _customersById[customerId] = parsedCustomer;
        EventListenersF.notify(Events.CUSTOMER_UPDATED, parsedCustomer);
        return MessagingF.replaceSuccessPopup("CUSTOMER_MESSAGES.ADDRESS_UPDATE_SUCCESS", {
          name: parsedCustomer.name
        });
      })["finally"](function() {
        return EventListenersF.notify(Events.CUSTOMER_ASYNC_FINISHED);
      });
    };
    CustomerF.addToProject = function(customerIds, projectId) {
      var _ref;
      var authHeader = AccountF.getAuthHeader();
      if ((_ref = authHeader.headers) != null) {
        _ref['Session-Id'] = SessionF.getSessionId();
      }
      return $http.post("" + Constants.productApiPath + "/v0.1/project/" + projectId + "/customers", customerIds, authHeader);
    };

    return CustomerF;
  };
  CustomerF.$inject = ["$http", "$q", "AccountF", "Customer", "Constants", "EventListenersF", "MessagingF", "TimeUtilF", "Events", "SessionF"];

  angular.module('app').factory('CustomerF', CustomerF);

}).call(this);

(function() {
  var CustomerFileUploadF = function($q, $state, $translate, CustomerF, FileUploadUtil, VisitUploadF, ValidatorF, VisitCsvHeaderF, VisitFileUploadF, TimeUtilF, NumberUtilF, CustomerUtilF, States, CustomerErrors) {
    var _addCustomers, _parseCustomer, _rowMap, _uploadErrors;
    var AddressData = (function() {
      function AddressData(id, columnName) {
        this.id = id;
        this.columnName = columnName;
      }

      return AddressData;

    })();
    _rowMap = void 0;
    _uploadErrors = void 0;
    _parseCustomer = function(row, mapping) {
      var address, addressColumns, addressData, col, customer, data, info, location, parsedLat, parsedLng, parsedMetadata, type, types, _i, _j, _k, _len, _len1, _len2, _ref, _ref1;
      data = {};
      customer = {};
      parsedMetadata = {};
      for (_i = 0, _len = mapping.length; _i < _len; _i++) {
        col = mapping[_i];
        if (col.isUserDefined) {
          col.name = col.name.replace(/\./g, ' ');
          if (row[col.mappedCol] && Boolean(row[col.mappedCol].trim())) {
            if (row[col.mappedCol]) {
              parsedMetadata[col.name] = row[col.mappedCol].toString();
            }
          }
        } else {
          data[col.name] = row[col.mappedCol];
        }
      }
      if (Object.keys(parsedMetadata).length > 0) {
        customer.metadata = parsedMetadata;
      }
      addressColumns = [new AddressData('street', 'Address'), new AddressData('city', 'City'), new AddressData('state', 'State'), new AddressData('zipCode', 'Zip code')];
      location = {};
      address = [];
      for (_j = 0, _len1 = addressColumns.length; _j < _len1; _j++) {
        addressData = addressColumns[_j];
        info = data[addressData.columnName];
        if (info) {
          address.push(info);
        }
      }
      if (address.length > 0) {
        location.address = address.join(', ');
      }
      if (data['Latitude'] && data['Longitude']) {
        parsedLat = parseFloat(data['Latitude']);
        parsedLng = parseFloat(data['Longitude']);
        if (parsedLat && parsedLng) {
          location.coords = {
            lat: parsedLat,
            lng: parsedLng
          };
        }
      }
      if (data['Types']) {
        types = [];
        _ref = data['Types'].split(',');
        for (_k = 0, _len2 = _ref.length; _k < _len2; _k++) {
          type = _ref[_k];
          type = type.trim();
          if (type.length > 0) {
            types.push(type);
          }
        }
        if (types.length > 0) {
          customer.types = types;
        }
      }
      if (data['Name']) {
        customer.name = data['Name'].toString();
      }
      customer.location = location;
      if (data['From']) {
        customer.start = TimeUtilF.padZero(data['From']);
      }
      if (data['To']) {
        customer.end = TimeUtilF.padZero(data['To']);
      }
      if (data['Duration']) {
        customer.duration = parseInt(data['Duration'], 10);
      }
      if (data['Load']) {
        customer.load = parseFloat(data['Load']);
      }
      if (data['Phone']) {
        customer.phone = CustomerUtilF.normalizePhoneNumber(data['Phone']);
      }
      if (data['Email']) {
        customer.email = data['Email'];
      }
      if (data['Notes']) {
        customer.notes = data['Notes'].toString();
      }
      if (data['Notes 2']) {
        customer.notes_2 = data['Notes 2'].toString();
      }
      if (((_ref1 = data['Priority']) != null ? _ref1.trim().toLowerCase() : void 0) === 'yes') {
        customer.priority = true;
      }
      return customer;
    };
    _addCustomers = function(data, mapping) {
      var col, entries, row, _i, _j, _len, _len1;
      entries = [];
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        row = data[_i];
        for (_j = 0, _len1 = mapping.length; _j < _len1; _j++) {
          col = mapping[_j];
          entries.push(_parseCustomer(row, mapping));
          break;
        }
      }
      return entries;
    };
    CustomerFileUploadF.read = function(file, mapping, isStrict) {
      var data, deferred, mapCopy;
      if (mapping == null) {
        mapping = VisitCsvHeaderF.DEFAULT_COLUMN_MAPPING;
      }
      if (isStrict == null) {
        isStrict = true;
      }
      CustomerFileUploadF.file = null;
      CustomerFileUploadF.userHeader = null;
      CustomerFileUploadF.file = file;
      deferred = $q.defer();
      data = null;
      mapCopy = FileUploadUtil.toLowerCaseMapColumn(mapping);
      FileUploadUtil.read(file, false).then(function(res) {
        if (res.originalData) {
          CustomerFileUploadF.setRowMap(res.originalData);
        }
        data = res.data;
        CustomerFileUploadF.userHeader = res.header;
        return ValidatorF.validateCustomerCsv(data, mapCopy, isStrict);
      }).then(function() {
        var promise;
        deferred.notify('validated');
        promise = _addCustomers(data, mapCopy);
        return deferred.resolve(promise);
      })["catch"](function(err) {
        return deferred.reject(err);
      });
      return deferred.promise;
    };
    CustomerFileUploadF.setRowMap = function(customerArray) {
      var map = {};
      customerArray.forEach(function(customer, i) {
        return map[i] = customer.__rowNum__;
      });
      return _rowMap = map;
    };
    CustomerFileUploadF.setUploadErrors = function(errors) {
      return _uploadErrors = errors;
    };
    CustomerFileUploadF.getUploadErrors = function() {
      return _uploadErrors;
    };
    CustomerFileUploadF.handleUploadErr = function(errors) {
      var err, formattedErrors, newErr, _i, _len;
      formattedErrors = [];
      for (_i = 0, _len = errors.length; _i < _len; _i++) {
        err = errors[_i];
        newErr = {};
        newErr.row = _rowMap[err.index] + 1;
        newErr.message = CustomerUtilF.mapErrorMessage(err.field, err.error_code);
        formattedErrors.push(newErr);
      }
      CustomerFileUploadF.setUploadErrors(formattedErrors);
      return $state.go(States.modalCustomerUploadError, {}, {
        location: false
      });
    };
    return CustomerFileUploadF;
  };
  CustomerFileUploadF.$inject = ["$q", "$state", "$translate", "CustomerF", "FileUploadUtil", "VisitUploadF", "ValidatorF", "VisitCsvHeaderF", "VisitFileUploadF", "TimeUtilF", "NumberUtilF", "CustomerUtilF", "States", "CustomerErrors"];

  angular.module('app').factory('CustomerFileUploadF', CustomerFileUploadF);

}).call(this);

(function() {
  var CustomerFormC = function($state, $scope, $translate, customer, CustomerF, MessagingF, EventListenersF, ConfirmF, CustomerUtilF, SettingsF, AccountF, Events, States, AddressCheckerS) {
    this.entry = _.cloneDeep(customer || {});
    this.defaultDuration = SettingsF.settings.duration;
    this.defaultLoad = SettingsF.settings.load;
    this.shouldShowEmailNotificationWarning = AccountF.isEmailNotificationOn();
    this.shouldShowSmsNotificationWarning = AccountF.isSmsNotificationOn();
    this.close = function() {
      return $state.go(States.customers);
    };
    this.create = function(isValid, entry, addressCtrl) {
      if (addressCtrl && !addressCtrl.$valid) {
        AddressCheckerS.check(addressCtrl.$viewValue).then(function(newLoc) {
          var _ref, _ref1;
          return (_ref = $scope.customerForm) != null ? (_ref1 = _ref.entry) != null ? _ref1.location = newLoc : void 0 : void 0;
        });
      }
      if (!isValid) {
        return;
      }
      return CustomerF.createCustomers([entry]).then(null, null, $state.go(States.customers))["catch"](function(err) {
        var _ref, _ref1, _ref2, _ref3;
        return MessagingF.replaceError(CustomerUtilF.mapErrorMessage((_ref = err.data) != null ? (_ref1 = _ref.errors) != null ? _ref1[0].field : void 0 : void 0, (_ref2 = err.data) != null ? (_ref3 = _ref2.errors) != null ? _ref3[0].error_code : void 0 : void 0));
      });
    };
    this.saveEdit = function(isValid, entry, addressCtrl) {
      if (addressCtrl && !(addressCtrl != null ? addressCtrl.$valid : void 0)) {
        AddressCheckerS.check(addressCtrl.$viewValue).then(function(newLoc) {
          var _ref, _ref1;
          return (_ref = $scope.customerForm) != null ? (_ref1 = _ref.entry) != null ? _ref1.location = newLoc : void 0 : void 0;
        });
      }
      if (!isValid) {
        return;
      }
      return CustomerF.updateCustomer(entry.id, entry).then(null, null, $state.go(States.customers))["catch"](function(err) {
        var _ref, _ref1;
        return MessagingF.replaceError(CustomerUtilF.mapErrorMessage((_ref = err.data) != null ? _ref.field : void 0, (_ref1 = err.data) != null ? _ref1.error_code : void 0));
      });
    };
    this.deleteCustomer = function() {
      var confirmation = ConfirmF.confirmWarning($translate.instant("CUSTOMER_MESSAGES.CONFIRM_DELETION_HEADING_SINGLE", {
        name: this.entry.name
      }), $translate.instant("CUSTOMER_MESSAGES.CONFIRM_DELETION_TEXT"), void 0, $translate.instant("CUSTOMER_MESSAGES.CONFIRM_DELETION"));
      return confirmation.then((function(_this) {
        return function() {
          return CustomerF.deleteCustomers([_this.entry.id]);
        };
      })(this)).then(function() {
        return $state.go(States.customers);
      }).then((function(_this) {
        return function() {
          return MessagingF.replaceSuccessPopup("CUSTOMER_MESSAGES.DELETE_SINGLE_SUCCESS", {
            name: _this.entry.name
          });
        };
      })(this)).then(function() {
        return EventListenersF.notify(Events.CUSTOMERS_DELETED);
      })["catch"](function(err) {
        if (err) {
          return MessagingF.replaceError("CUSTOMER_MESSAGES.GENERIC_ERROR");
        }
      });
    };
    this.setPriority = (function(_this) {
      return function(isPriority, formC) {
        _this.entry.priority = isPriority;
        return formC.$dirty = true;
      };
    })(this);
    this.setDirty = (function(_this) {
      return function() {
        var _ref, _ref1;
        return (_ref = $scope.forms) != null ? (_ref1 = _ref.customerForm) != null ? _ref1.$setDirty(true) : void 0 : void 0;
      };
    })(this);
    EventListenersF.addEventListener(Events.CUSTOMER_UPDATED, (function(_this) {
      return function(customer) {
        return _this.entry = customer;
      };
    })(this));
    EventListenersF.addEventListener(Events.DELIVERY_METHOD_CHANGED, (function(_this) {
      return function() {
        _this.shouldShowEmailNotificationWarning = AccountF.isEmailNotificationOn();
        return _this.shouldShowSmsNotificationWarning = AccountF.isSmsNotificationOn();
      };
    })(this));
  };
  CustomerFormC.$inject = ["$state", "$scope", "$translate", "customer", "CustomerF", "MessagingF", "EventListenersF", "ConfirmF", "CustomerUtilF", "SettingsF", "AccountF", "Events", "States", "AddressCheckerS"];

  angular.module('app').controller('CustomerFormC', CustomerFormC);

}).call(this);

(function() {
  var CustomerUploadC = function(CustomerF, $state, States, CustomerFileUploadF, MessagingF, AccountF, EventListenersF, Events) {
    this.SUPPORTED_FILE_DROP = "*.csv,*.xml,*.xls,*.xlsx,*.xlsm";
    this.SUPPORTED_FILE_SELECT = ".csv,.xml,.xls,.xlsx,.xlsm";
    this.shouldShowEmailNotificationWarning = AccountF.isEmailNotificationOn();
    this.shouldShowSmsNotificationWarning = AccountF.isSmsNotificationOn();
    this.close = function() {
      return $state.go(States.customers);
    };
    this.sidePanelActive = $state.current.name === States.customersUpload;
    this.readFile = function(files) {
      if (!(files && files.length > 0)) {
        return;
      }
      return CustomerFileUploadF.read(files[0]).then(function(res) {
        return CustomerF.createCustomers(res, true);
      }).then(null, null, $state.go(States.customers))["catch"](function(err) {
        var _ref;
        if (err.name === 'CsvUploadError') {
          return $state.go(States.modalCsvMapCustomers, {}, {
            location: false
          });
        } else if (((_ref = err.data) != null ? _ref.errors : void 0) != null) {
          return CustomerFileUploadF.handleUploadErr(err.data.errors);
        } else {
          return MessagingF.replaceError(err.message || err.error);
        }
      });
    };
    EventListenersF.addEventListener(Events.DELIVERY_METHOD_CHANGED, (function(_this) {
      return function() {
        _this.shouldShowEmailNotificationWarning = AccountF.isEmailNotificationOn();
        return _this.shouldShowSmsNotificationWarning = AccountF.isSmsNotificationOn();
      };
    })(this));
  };
  CustomerUploadC.$inject = ["CustomerF", "$state", "States", "CustomerFileUploadF", "MessagingF", "AccountF", "EventListenersF", "Events"];

  angular.module('app').controller('CustomerUploadC', CustomerUploadC);

}).call(this);

(function() {
  var CustomerUploadErrorC = function(CustomerFileUploadF) {
    this.errors = CustomerFileUploadF.getUploadErrors();
    return this.total = this.errors.length;
  };
  CustomerUploadErrorC.$inject = ["CustomerFileUploadF"];

  angular.module('app').controller('CustomerUploadErrorC', CustomerUploadErrorC);

}).call(this);

(function() {
  var CustomersTableC = function($state, $scope, $rootScope, $translate, $q, results, CustomerF, ProjectF, VisitF, RouteS, LocalStorageStringF, EventListenersF, LocalStorageObjectF, MessagingF, ConfirmF, TimeUtilF, States, Events, geocodeInfo, AnalyticsS, LoggerF) {
    var COL_SETTINGS_KEY, DEFAULT_SORT_BY, DEFAULT_STATE, MIN_QUERY, RESULTS_PER_PAGE, SORT_ASC, SORT_BY_CACHE_KEY, SORT_DESC, SORT_ORDER_CACHE_KEY, _addedCustomFields, _colSettings, _colSettingsCache, _fetchingGeocodeInfo, _formatSelectedIds, _geocodeUpdateQueue, _getErrorMessage, _getGeocodeProgressMeter, _getOffsetForPage, _handleError, _initColSettings, _isCustomerInView, _removeFromSelection, _resetCustomers, _shouldShowUploadView, _sortBy, _sortByCache, _sortOrder, _sortOrderCache, _updateProjectSelectionInfo;
    DEFAULT_STATE = States.projectRoutePlan;
    DEFAULT_SORT_BY = "created_date";
    SORT_ASC = "asc";
    SORT_DESC = "desc";
    RESULTS_PER_PAGE = 25;
    SORT_BY_CACHE_KEY = "customersSortBy";
    SORT_ORDER_CACHE_KEY = "customersSortOrder";
    COL_SETTINGS_KEY = "tableColSettings";
    MIN_QUERY = 3;
    _fetchingGeocodeInfo = false;
    _geocodeUpdateQueue = [];
    _sortByCache = LocalStorageStringF(SORT_BY_CACHE_KEY);
    _sortOrderCache = LocalStorageStringF(SORT_ORDER_CACHE_KEY);
    _colSettingsCache = LocalStorageObjectF(COL_SETTINGS_KEY);
    _sortBy = _sortByCache.load();
    _sortOrder = _sortOrderCache.load();
    _colSettings = _colSettingsCache.load();
    _addedCustomFields = {};
    _getOffsetForPage = function(pageNum) {
      var pageIdx = pageNum - 1;
      return pageIdx * RESULTS_PER_PAGE;
    };
    _initColSettings = function(fields) {
      var field, id, settings, _i, _len;
      settings = _colSettings;
      for (_i = 0, _len = fields.length; _i < _len; _i++) {
        field = fields[_i];
        id = field.id;
        field.show = !settings[id];
      }
      return fields;
    };
    _isCustomerInView = (function(_this) {
      return function(customerId) {
        return _.findIndex(_this.customers, function(customer) {
          return customer.id === customerId;
        });
      };
    })(this);
    _getGeocodeProgressMeter = function(_arg) {
      var invalid, pending, percent;
      var completed = _arg.completed, invalid = _arg.invalid, pending = _arg.pending;
      percent = Math.floor((completed / (completed + pending)) * 100);
      if (isNaN(percent)) {
        percent = 0;
      }
      return percent;
    };
    _shouldShowUploadView = (function(_this) {
      return function() {
        return _this.customers.length === 0 && !_this.showSelected && !_this.showInvalidCustomer && _this.searchQuery < MIN_QUERY;
      };
    })(this);
    _updateProjectSelectionInfo = (function(_this) {
      return function() {
        var customer, projectVisits, _i, _len, _ref, _results;
        if (!_this.isModalView) {
          return;
        }
        projectVisits = VisitF.getVisitIds();
        _ref = _this.customers;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          customer = _ref[_i];
          if (projectVisits[customer.id] != null) {
            _results.push(customer.isInProject = true);
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
    })(this);
    _getErrorMessage = function(customerId, message) {
      return CustomerF.getCustomer(customerId).then(function(customer) {
        return customer.name + ':  ' + message + '<br/>';
      });
    };
    _handleError = function(errors) {
      var err, errorString, promises, _i, _len;
      errorString = '';
      promises = [];
      for (_i = 0, _len = errors.length; _i < _len; _i++) {
        err = errors[_i];
        promises.push(_getErrorMessage(err.id, err.message));
      }
      return $q.all(promises).then(function(allErrors) {
        var error, _j, _len1;
        for (_j = 0, _len1 = allErrors.length; _j < _len1; _j++) {
          error = allErrors[_j];
          errorString += error;
        }
        return errorString;
      });
    };
    this.customers = _.clone(results.customers);
    this.project = ProjectF.project;
    this.searchQuery = "";
    this.showInvalidCustomer = false;
    this.showSelected = false;
    this.allSelected = false;
    this.allSelectedInPage = false;
    this.selectedCount = 0;
    this.sortBy = _sortBy === "" ? DEFAULT_SORT_BY : _sortBy;
    this.sortOrder = _sortOrder === "" ? SORT_ASC : _sortOrder;
    this.colSettings = _colSettings != null ? _colSettings : {};
    this.resultsPerPage = RESULTS_PER_PAGE;
    this.currentPage = 0;
    this.statusFilter = void 0;
    this.resultsCount = results.total;
    this.customerSelections = {};
    this.inProgress = false;
    this.showUploadView = this.customers.length === 0;
    this.showColWindow = false;
    this.geocodeInfo = geocodeInfo;
    this.isModalView = $state.current.name === States.modalCustomerProfile;
    _updateProjectSelectionInfo();
    this.fields = _initColSettings([
      {
        name: "Name",
        langId: "CUSTOMER_FIELDS.NAME",
        width: "1",
        id: "name",
        show: true,
        sortable: true,
        canFilter: false
      }, {
        name: "Address",
        langId: "CUSTOMER_FIELDS.ADDRESS",
        width: "2",
        id: "address",
        show: true,
        sortable: true,
        canFilter: false
      }, {
        name: "Time Window",
        langId: "CUSTOMER_FIELDS.TIME",
        width: "1",
        id: "timeWindow",
        show: true,
        sortable: false,
        canFilter: true
      }, {
        name: "Duration",
        langId: "CUSTOMER_FIELDS.DURATION",
        width: "0.5",
        id: "duration",
        show: true,
        sortable: false,
        canFilter: true
      }, {
        name: "Load",
        langId: "CUSTOMER_FIELDS.LOAD",
        width: "0.5",
        id: "load",
        show: true,
        sortable: false,
        canFilter: true
      }, {
        name: "Mobile Number",
        langId: "CUSTOMER_FIELDS.PHONE",
        width: "1",
        id: "phone",
        show: true,
        sortable: true,
        canFilter: true
      }, {
        name: "Priority",
        langId: "CUSTOMER_FIELDS.PRIORITY",
        width: "0.5",
        id: "priority",
        show: true,
        sortable: false,
        canFilter: true
      }, {
        name: "Email",
        langId: "CUSTOMER_FIELDS.EMAIL",
        width: "1",
        id: "email",
        show: true,
        sortable: true,
        canFilter: true
      }, {
        name: "Types",
        langId: "CUSTOMER_FIELDS.TYPES",
        width: "2",
        id: "type",
        show: true,
        sortable: false,
        canFilter: true
      }, {
        name: "Notes",
        langId: "CUSTOMER_FIELDS.NOTES",
        width: "1",
        id: "notes",
        show: true,
        sortable: true,
        canFilter: true
      }, {
        name: "Notes 2",
        langId: "CUSTOMER_FIELDS.NOTES_2",
        width: "1",
        id: "notes_2",
        show: true,
        sortable: true,
        canFilter: true
      }, {
        name: "Status",
        langId: "CUSTOMER_FIELDS.STATUS",
        width: "1",
        id: "status",
        show: true,
        sortable: false,
        canFilter: true
      }, {
        name: "Created on",
        langId: "CUSTOMER_FIELDS.CREATED_ON",
        width: "1",
        id: "created_date",
        show: true,
        sortable: true,
        canFilter: true
      }
    ]);
    this.backToProject = function() {
      return $state.go(DEFAULT_STATE);
    };
    this.goToCsvUpload = function() {
      this.showColWindow = false;
      return $state.go(States.customersUpload);
    };
    this.goToCreate = function() {
      this.showColWindow = false;
      return $state.go(States.customersCreate);
    };
    this.toggleColWindow = function() {
      return this.showColWindow = !this.showColWindow;
    };
    this.toggleColField = (function(_this) {
      return function(idx) {
        var fieldId = _this.fields[idx].id;
        return function(value) {
          value = !value;
          _this.colSettings[fieldId] = value;
          _colSettingsCache.set(_.clone(_this.colSettings));
        };
      };
    })(this);
    this.toggleSelectAllInPage = (function(_this) {
      return function(value) {
        var customer, isSelected, k, projectVisits, _i, _len, _ref, _ref1, _results;
        if (_this.geocodeInfo.pending > 0) {
          _this.allSelectedInPage = false;
          return;
        }
        _ref = _this.customers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          customer = _ref[_i];
          if (!_this.isModalView) {
            _this.customerSelections[customer.id] = value;
          } else {
            projectVisits = VisitF.getVisitIds();
            if (projectVisits[customer.id] == null) {
              _this.customerSelections[customer.id] = value;
            }
          }
        }
        _this.allSelectedInPage = value;
        _this.selectedCount = 0;
        _ref1 = _this.customerSelections;
        _results = [];
        for (k in _ref1) {
          isSelected = _ref1[k];
          if (isSelected) {
            _results.push(_this.selectedCount++);
          }
        }
        return _results;
      };
    })(this);
    this.deselectAll = (function(_this) {
      return function() {
        var k, v, _ref;
        _this.allSelected = false;
        _this.allSelectedInPage = false;
        _this.selectedCount = 0;
        _ref = _this.customerSelections;
        for (k in _ref) {
          v = _ref[k];
          _this.customerSelections[k] = false;
        }
        if (_this.showSelected) {
          return _this.toggleShowSelected(false);
        }
      };
    })(this);
    this.selectAll = (function(_this) {
      return function() {
        _this.allSelected = true;
        _this.allSelectedInPage = true;
        return CustomerF.getAllIdsForQuery(_this.sortBy, _this.sortOrder, _this.searchQuery).then(function(_arg) {
          var id, ids, projectVisits, total, visitsInProjectCount, _i, _j, _len, _len1, _results, _results1;
          total = _arg.total, ids = _arg.ids;
          _this.selectedCount = total;
          _this.resultsCount = total;
          if (!_this.isModalView) {
            _results = [];
            for (_i = 0, _len = ids.length; _i < _len; _i++) {
              id = ids[_i];
              _results.push(_this.customerSelections[id] = true);
            }
            return _results;
          } else {
            projectVisits = VisitF.getVisitIds();
            visitsInProjectCount = Object.keys(projectVisits).length;
            _this.selectedCount = _this.selectedCount - visitsInProjectCount;
            _results1 = [];
            for (_j = 0, _len1 = ids.length; _j < _len1; _j++) {
              id = ids[_j];
              if (projectVisits[id] == null) {
                _results1.push(_this.customerSelections[id] = true);
              } else {
                _results1.push(void 0);
              }
            }
            return _results1;
          }
        });
      };
    })(this);
    this.customerSelected = (function(_this) {
      return function(customerId) {
        return function(value) {
          _this.customerSelections[customerId] = value;
          if (value) {
            return ++_this.selectedCount;
          } else if (_this.selectedCount > 0) {
            _this.allSelectedInPage = false;
            _this.allSelected = false;
            --_this.selectedCount;
            if (_this.selectedCount === 0 && _this.showSelected) {
              return _this.toggleShowSelected(false);
            }
          }
        };
      };
    })(this);
    this.goToPage = (function(_this) {
      return function(num) {
        var ids, offset, promise;
        if (_this.currentPage === num) {
          return;
        }
        _this.currentPage = num;
        offset = _getOffsetForPage(_this.currentPage);
        if (_this.showSelected) {
          ids = _formatSelectedIds(_this.customerSelections);
          promise = CustomerF.getCustomerByIds(ids, _this.sortBy, _this.sortOrder, RESULTS_PER_PAGE, offset, _this.statusFilter);
        } else {
          promise = CustomerF.getCustomers(_this.sortBy, _this.sortOrder, _this.searchQuery, RESULTS_PER_PAGE, offset, _this.statusFilter);
        }
        return promise.then(function(_arg) {
          var total;
          var customers = _arg.customers, total = _arg.total;
          _this.resultsCount = total;
          _this.customers = _.clone(customers);
          return _this.updateCustomerSelections(_this.customers);
        });
      };
    })(this);
    this.updateCustomerSelections = (function(_this) {
      return function(newCustomers) {
        var c, isSelected, _i, _len;
        var allSelectedInPage = true;
        for (_i = 0, _len = newCustomers.length; _i < _len; _i++) {
          c = newCustomers[_i];
          if (c.status === 'geocoding') {
            _this.customerSelections[c.id] = false;
            _this.allSelected = false;
            _this.allSelectedInPage = false;
            return;
          }
          isSelected = _this.customerSelections[c.id];
          if (isSelected == null) {
            _this.customerSelections[c.id] = _this.allSelected || false;
          }
          if (!isSelected) {
            allSelectedInPage = false;
          }
        }
        if (_this.isModalView) {
          _updateProjectSelectionInfo();
        }
        return _this.allSelectedInPage = allSelectedInPage && _this.customers.length > 0;
      };
    })(this);
    this.updateFieldsWithMetadata = (function(_this) {
      return function(newCustomers) {
        var c, k, v, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = newCustomers.length; _i < _len; _i++) {
          c = newCustomers[_i];
          if (c.metadata == null) {
            break;
          }
          _results.push((function() {
            var _ref, _results1;
            _ref = c.metadata;
            _results1 = [];
            for (k in _ref) {
              v = _ref[k];
              if (!(_addedCustomFields[k] == null)) {
                continue;
              }
              _addedCustomFields[k] = true;
              _results1.push(this.fields.push({
                name: k,
                width: "1",
                id: k,
                langId: k,
                show: true,
                isMetadata: true,
                sortable: true
              }));
            }
            return _results1;
          }).call(_this));
        }
        return _results;
      };
    })(this);
    _resetCustomers = (function(_this) {
      return function(customers, total) {
        _this.currentPage = 1;
        _this.resultsCount = total;
        _this.customers = _.clone(customers);
        return _this.updateCustomerSelections(_this.customers);
      };
    })(this);
    _formatSelectedIds = function(selectedIds) {
      var id, isSelected, _results;
      _results = [];
      for (id in selectedIds) {
        isSelected = selectedIds[id];
        if (isSelected) {
          _results.push(id);
        }
      }
      return _results;
    };
    _removeFromSelection = (function(_this) {
      return function(newCustomers) {
        var customer, id, newCustomerIds, selected, _, _i, _len, _ref;
        newCustomerIds = {};
        for (_i = 0, _len = newCustomers.length; _i < _len; _i++) {
          customer = newCustomers[_i];
          newCustomerIds[customer.id] = true;
        }
        for (id in _this.customerSelections) {
          if (!newCustomerIds[id]) {
            if (_this.customerSelections[id] === true) {
              _this.selectedCount--;
            }
            delete _this.customerSelections[id];
          }
        }
        if (Object.keys(_this.customerSelections).length === 0) {
          return _this.showSelected = false;
        } else {
          _ref = _this.customerSelected;
          for (_ in _ref) {
            selected = _ref[_];
            if (selected) {
              return;
            }
          }
          return _this.showSelected = false;
        }
      };
    })(this);
    this.sortByField = (function(_this) {
      return function(fieldId, isMetadata, isSortable) {
        var ids, isSameField, promise;
        if (!isSortable) {
          return;
        }
        if (isMetadata) {
          fieldId = "metadata." + fieldId;
        }
        isSameField = fieldId === _this.sortBy;
        _this.sortBy = fieldId;
        _this.sortOrder = _this.sortOrder === SORT_ASC && isSameField ? SORT_DESC : SORT_ASC;
        _sortByCache.set(_.clone(_this.sortBy));
        _sortOrderCache.set(_.clone(_this.sortOrder));
        if (_this.showSelected) {
          ids = _formatSelectedIds(_this.customerSelections);
          promise = CustomerF.getCustomerByIds(ids, _this.sortBy, _this.sortOrder, RESULTS_PER_PAGE, 0, _this.statusFilter);
        } else {
          promise = CustomerF.getCustomers(_this.sortBy, _this.sortOrder, _this.searchQuery, RESULTS_PER_PAGE, 0, _this.statusFilter);
        }
        return promise.then(function(_arg) {
          var total;
          var customers = _arg.customers, total = _arg.total;
          return _resetCustomers(customers, total);
        });
      };
    })(this);
    this.search = (function(_this) {
      return function(text) {
        _this.searchQuery = text;
        return CustomerF.getCustomers(_this.sortBy, _this.sortOrder, _this.searchQuery, RESULTS_PER_PAGE, 0).then(function(_arg) {
          var total;
          var customers = _arg.customers, total = _arg.total;
          _this.showSelected = false;
          _this.showInvalidCustomer = false;
          return _resetCustomers(customers, total);
        });
      };
    })(this);
    this.openCustomer = function(customerId) {
      var index = _isCustomerInView(customerId);
      if (this.customers[index].status === 'geocoding') {
        return;
      }
      if (this.isModalView) {
        return;
      }
      this.showColWindow = false;
      if ($state.params.customerId === customerId) {
        return $state.go(States.customers);
      } else {
        return $state.go(States.customersEdit, {
          customerId: customerId
        });
      }
    };
    this.startProject = function() {
      var selectedIds = _formatSelectedIds(this.customerSelections);
      return $state.go(States.modalProjectsNew, {
        selectedCustomerIds: selectedIds
      });
    };
    this.addCustomersToCurrentProject = function() {
      var count, selectedIds;
      selectedIds = _formatSelectedIds(this.customerSelections);
      count = void 0;
      return CustomerF.addToProject(selectedIds, ProjectF.project.id).then(function(res) {
        var promises, visit, visits, _i, _len;
        ProjectF.incrementVersion();
        visits = res.data;
        count = visits.length;
        promises = [];
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          visit = visits[_i];
          if (visit.start) {
            visit.startDate = TimeUtilF.convertTimeToDate(visit.start);
          }
          if (visit.end) {
            visit.endDate = TimeUtilF.convertTimeToDate(visit.end);
          }
          promises.push(VisitF.addVisit(visit, true));
        }
        return $q.all(promises);
      }).then(function(newVisits) {
        if (RouteS.hasRoute()) {
          RouteS.addVisitsAsUnserved(newVisits);
        }
        return VisitF.updateValidVisits();
      }).then(function() {
        LoggerF.info(LoggerF.ACTIONS.ADDED_STOPS_CUSTOMER, selectedIds);
        $scope.closeThisDialog();
        MessagingF.replaceSuccessPopup("CUSTOMER_MESSAGES.STOPS_ADDED_SUCCESS", {
          count: count
        });
        EventListenersF.notify(Events.PROJECT_MODIFIED_LOCALLY);
        return AnalyticsS.track('ADDED_CUSTOMER_TO_PROJECT', {
          amountAdded: count
        });
      })["catch"](function(err) {
        var _ref, _ref1;
        LoggerF.error(LoggerF.ACTIONS.ADDED_STOPS_CUSTOMER, selectedIds, err);
        if (((_ref = err.data) != null ? _ref.errors : void 0) != null) {
          return _handleError(err.data.errors).then(function(formattedErrors) {
            return ConfirmF.confirmWarning($translate.instant("CUSTOMER_MESSAGES.STOPS_ADDED_FAIL", {
              count: selectedIds.length
            }), formattedErrors, void 0, 'OK');
          });
        } else {
          return MessagingF.replaceError(((_ref1 = err.data) != null ? _ref1.message : void 0) || err.error);
        }
      });
    };
    this.toggleShowSelected = (function(_this) {
      return function(value) {
        var ids, promise;
        _this.showSelected = value;
        if (_this.showSelected) {
          ids = _formatSelectedIds(_this.customerSelections);
          promise = CustomerF.getCustomerByIds(ids, _this.sortBy, _this.sortOrder, RESULTS_PER_PAGE, 0, _this.statusFilter);
        } else {
          promise = CustomerF.getCustomers(_this.sortBy, _this.sortOrder, _this.searchQuery, RESULTS_PER_PAGE, 0, _this.statusFilter);
        }
        return promise.then(function(_arg) {
          var total;
          var customers = _arg.customers, total = _arg.total;
          return _resetCustomers(customers, total);
        });
      };
    })(this);
    this.deleteCustomers = function() {
      var confirmation, selectedIds;
      selectedIds = _formatSelectedIds(this.customerSelections);
      confirmation = ConfirmF.confirmWarning($translate.instant("CUSTOMER_MESSAGES.CONFIRM_DELETION_HEADING", {
        count: selectedIds.length
      }), $translate.instant("CUSTOMER_MESSAGES.CONFIRM_DELETION_TEXT"), void 0, $translate.instant("CUSTOMER_MESSAGES.CONFIRM_DELETION"));
      return confirmation.then(function() {
        return CustomerF.deleteCustomers(selectedIds);
      }).then(function(res) {
        var _ref;
        MessagingF.replaceSuccessPopup("CUSTOMER_MESSAGES.DELETE_MULTIPLE_SUCCESS", {
          count: (_ref = res.data) != null ? _ref.count : void 0
        });
        return EventListenersF.notify(Events.CUSTOMERS_DELETED);
      })["catch"](function(err) {
        if (err) {
          return MessagingF.replaceError("CUSTOMER_MESSAGES.GENERIC_ERROR");
        }
      });
    };
    this.updateCustomersStatus = function(geocodedCustomerIds) {
      var customerId, customersAwaitingUpdate, _i, _len;
      customersAwaitingUpdate = [];
      for (_i = 0, _len = geocodedCustomerIds.length; _i < _len; _i++) {
        customerId = geocodedCustomerIds[_i];
        if (_isCustomerInView(customerId) > -1) {
          customersAwaitingUpdate.push(customerId);
        }
      }
      if (customersAwaitingUpdate.length > 0) {
        CustomerF.getCustomerByIds(customersAwaitingUpdate, this.sortBy, this.sortOrder, RESULTS_PER_PAGE, 0, this.statusFilter, true).then((function(_this) {
          return function(_arg) {
            var customer, customers, index, total, _j, _len1, _results;
            customers = _arg.customers, total = _arg.total;
            _results = [];
            for (_j = 0, _len1 = customers.length; _j < _len1; _j++) {
              customer = customers[_j];
              index = _isCustomerInView(customer.id);
              if (index > -1) {
                _results.push(_this.customers[index] = customer);
              } else {
                _results.push(void 0);
              }
            }
            return _results;
          };
        })(this));
      }
    };
    this.toggleInvalidCustomers = (function(_this) {
      return function(value) {
        var ids, promise;
        _this.showInvalidCustomer = value;
        if (_this.showInvalidCustomer) {
          _this.statusFilter = 'invalid';
        } else {
          _this.statusFilter = void 0;
        }
        if (_this.showSelected) {
          ids = _formatSelectedIds(_this.customerSelections);
          promise = CustomerF.getCustomerByIds(ids, _this.sortBy, _this.sortOrder, RESULTS_PER_PAGE, 0, _this.statusFilter);
        } else {
          promise = CustomerF.getCustomers(_this.sortBy, _this.sortOrder, _this.searchQuery, RESULTS_PER_PAGE, 0, _this.statusFilter);
        }
        return promise.then(function(_arg) {
          var total;
          var customers = _arg.customers, total = _arg.total;
          _this.resultsCount = total;
          _this.customers = _.clone(customers);
          return _this.updateCustomerSelections(_this.customers);
        });
      };
    })(this);
    EventListenersF.addEventListener(Events.CUSTOMER_ASYNC_STARTED, (function(_this) {
      return function() {
        return _this.inProgress = true;
      };
    })(this));
    EventListenersF.addEventListener(Events.CUSTOMER_ASYNC_FINISHED, (function(_this) {
      return function() {
        return _this.inProgress = false;
      };
    })(this));
    EventListenersF.addEventListener(Events.CUSTOMERS_CREATED, (function(_this) {
      return function() {
        if (_this.showSelected || _this.showInvalidCustomer) {
          return;
        }
        return CustomerF.getCustomers(_this.sortBy, _this.sortOrder, _this.searchQuery, RESULTS_PER_PAGE, 0).then(function(_arg) {
          var total;
          var customers = _arg.customers, total = _arg.total;
          _resetCustomers(customers, total);
          _this.showUploadView = _shouldShowUploadView();
          return _this.updateFieldsWithMetadata(_this.customers);
        });
      };
    })(this));
    EventListenersF.addEventListener(Events.CUSTOMER_UPDATED, (function(_this) {
      return function(customer) {
        var _customers;
        var updatedIndex = _isCustomerInView(customer.id);
        if (updatedIndex > -1) {
          _customers = _.clone(_this.customers);
          _customers[updatedIndex] = customer;
          _this.customers = _customers;
        }
        return _this.updateFieldsWithMetadata(_this.customers);
      };
    })(this));
    EventListenersF.addEventListener(Events.CUSTOMERS_DELETED, (function(_this) {
      return function() {
        return CustomerF.getCustomers(_this.sortBy, _this.sortOrder, _this.searchQuery, RESULTS_PER_PAGE, 0, _this.statusFilter).then(function(_arg) {
          var total;
          var customers = _arg.customers, total = _arg.total;
          _removeFromSelection(customers);
          _resetCustomers(customers, total);
          return _this.showUploadView = _shouldShowUploadView();
        });
      };
    })(this));
    EventListenersF.addEventListener(Events.CUSTOMER_GEOCODING_STARTED, (function(_this) {
      return function() {
        _fetchingGeocodeInfo = true;
        return CustomerF.getGeocodeInfo().then(function(geocodeInfo) {
          _this.geocodeInfo = geocodeInfo;
          _this.geocodeProgressMeter = _getGeocodeProgressMeter(_this.geocodeInfo);
          _this.updateCustomersStatus(_geocodeUpdateQueue.splice(0));
          return _fetchingGeocodeInfo = false;
        });
      };
    })(this));
    EventListenersF.addEventListener(Events.CUSTOMER_GEOCODING_UPDATED, (function(_this) {
      return function(data) {
        var customerIds = data.customer_status_updated;
        if (_fetchingGeocodeInfo) {
          return _geocodeUpdateQueue.push.apply(_geocodeUpdateQueue, customerIds);
        } else {
          if (_this.geocodeInfo.pending > 0) {
            _this.geocodeInfo.pending -= customerIds.length;
            _this.geocodeInfo.completed += customerIds.length;
            _this.geocodeProgressMeter = _getGeocodeProgressMeter(_this.geocodeInfo);
          }
          return _this.updateCustomersStatus(customerIds);
        }
      };
    })(this));
    this.updateCustomerSelections(this.customers);
    this.updateFieldsWithMetadata(this.customers);
    this.geocodeProgressMeter = _getGeocodeProgressMeter(this.geocodeInfo);
    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState) {
      if (fromState.name === States.modalCustomerProfile && toState.name === States.projectVisitsUpload) {
        return $state.go(States.projectVisitsList);
      }
    });

    /* analytics */
    AnalyticsS.track('Viewed customer profiles');

  };
  CustomersTableC.$inject = ["$state", "$scope", "$rootScope", "$translate", "$q", "results", "CustomerF", "ProjectF", "VisitF", "RouteS", "LocalStorageStringF", "EventListenersF", "LocalStorageObjectF", "MessagingF", "ConfirmF", "TimeUtilF", "States", "Events", "geocodeInfo", "AnalyticsS", "LoggerF"];

  angular.module('app').controller('CustomersTableC', CustomersTableC);

}).call(this);

(function() {
  var CustomerCheckerC = function($scope, CustomerF, customer) {
    this.customer = customer;
    this.onExit = function() {
      return $scope.closeThisDialog();
    };
    this.updateAddress = (function(_this) {
      return function(isValid, isAddressChanged, selectedLocation) {
        if (!isValid) {
          return;
        }
        if (!isAddressChanged) {
          return $scope.closeThisDialog();
        }
        return CustomerF.updateCustomerLocation(_this.customer.id, selectedLocation).then(function() {
          return $scope.closeThisDialog();
        });
      };
    })(this);
  };
  CustomerCheckerC.$inject = ["$scope", "CustomerF", "customer"];

  angular.module('app').controller('customerCheckerC', CustomerCheckerC);

}).call(this);

(function() {
  var CustomerErrors = {
    GENERIC: "CUSTOMER_MESSAGES.GENERIC_ERROR",
    GENERIC_INPUT: "CUSTOMER_ERRORS.INPUT_GENERIC",
    FIELD_IS_REQUIRED: "CUSTOMER_ERRORS.EMPTY_FIELD",
    STRING_EXCEED_MAX_LENGTH: "CUSTOMER_ERRORS.EXCEED_MAX_STRING_LENGTH",
    MUST_BE_NUMBER: "CUSTOMER_ERRORS.MUST_BE_NUMBER",
    MUST_BE_NONNEGATIVE: "CUSTOMER_ERRORS.MUST_BE_NONNEGATIVE",
    MUST_BE_BOOLEAN: "CUSTOMER_ERRORS.MUST_BE_BOOLEAN",
    MUST_BE_INTEGER: "CUSTOMER_ERRORS.MUST_BE_INTEGER",
    MUST_BE_POSITIVE_INTEGER: "CUSTOMER_ERRORS.MUST_BE_POSITIVE_INTEGER",
    START_LATER_THAN_END: "CUSTOMER_ERRORS.START_LATER_THAN_END",
    DURATION_LARGER_THAN_TIME_WINDOW: "CUSTOMER_ERRORS.DURATION_LARGER_THAN_TIME_WINDOW",
    MUST_NOT_BE_EMPTY: "CUSTOMER_ERRORS.EMPTY_FIELD",
    INVALID_FORMAT: {
      phone: "CUSTOMER_ERRORS.INVALID_FORMAT_PHONE",
      email: "CUSTOMER_ERRORS.INVALID_FORMAT_EMAIL",
      GENERIC: "CUSTOMER_ERRORS.INVALID_FORMAT"
    },
    EXCEED_RANGE: {
      lat: "CUSTOMER_ERRORS.LAT_EXCEED_RANGE",
      lng: "CUSTOMER_ERRORS.LNG_EXCEED_RANGE",
      GENERIC: "CUSTOMER_ERRORS.EXCEED_RANGE"
    }
  };

  angular.module('app').constant('CustomerErrors', CustomerErrors);

}).call(this);

(function() {
  var CustomerUtilF = function($translate, CustomerErrors) {
    CustomerUtilF.normalizePhoneNumber = function(phone) {
      if (!phone) {
        return;
      }
      phone = phone.toString().replace(/[- )(]/g, '');
      if (phone[0] !== '+') {
        phone = '+' + phone;
      }
      return phone;
    };
    CustomerUtilF.mapErrorMessage = function(errorField, errorCode) {
      var mappedError;
      if (!errorField || !errorCode) {
        return $translate.instant(CustomerErrors.GENERIC, {
          name: errorField
        });
      }
      mappedError = CustomerErrors[errorCode];
      if (!mappedError) {
        return $translate.instant(CustomerErrors.GENERIC_INPUT, {
          name: errorField
        });
      }
      if (typeof mappedError === 'string') {
        return $translate.instant(mappedError, {
          name: errorField
        });
      } else if (typeof mappedError === 'object') {
        if (mappedError[errorField]) {
          return $translate.instant(mappedError[errorField], {
            name: errorField
          });
        } else {
          return $translate.instant(mappedError.GENERIC, {
            name: errorField
          });
        }
      }
    };
    return CustomerUtilF;
  };
  CustomerUtilF.$inject = ["$translate", "CustomerErrors"];

  angular.module('app').factory('CustomerUtilF', CustomerUtilF);

}).call(this);

(function() {
  var DeeplinkC = function(currentUser, $q, $state, $stateParams, $kookies, $interval, $timeout, ProjectF, MessageTemplateF, States, Constants) {
    var INTERVAL_CANCELLED_ERROR, deferred, projectId, projectStatusInterval, _checkProjectStatus;
    this.messageTemplate = MessageTemplateF.templates.lock;
    projectId = $stateParams.projectId;
    $kookies.set('projectIdFromQuery', projectId);
    deferred = $q.defer();
    projectStatusInterval = null;
    INTERVAL_CANCELLED_ERROR = 'canceled';
    _checkProjectStatus = (function(_this) {
      return function() {
        return ProjectF.fetch(projectId).then(function(res) {
          if (res.status === Constants.projectReadyStatus) {
            if (!!projectStatusInterval) {
              $interval.cancel(projectStatusInterval);
            }
            currentUser.project.id = projectId;
            return $state.go(States.projectVisitsList);
          } else if (!projectStatusInterval) {
            return projectStatusInterval = $interval(_checkProjectStatus, 2000);
          }
        })["catch"](function(err) {
          if (err === INTERVAL_CANCELLED_ERROR) {
            return;
          }
          return _this.messageTemplate = MessageTemplateF.templates.hiccup;
        });
      };
    })(this);
    $timeout(_checkProjectStatus, 2000);
  };
  DeeplinkC.$inject = ["currentUser", "$q", "$state", "$stateParams", "$kookies", "$interval", "$timeout", "ProjectF", "MessageTemplateF", "States", "Constants"];

  angular.module('app').controller('DeeplinkC', DeeplinkC);

}).call(this);

(function() {
  var DemoC = function($state, $window, $q, $translate, DemoF, ProjectF, DriverF, DispatchF, AccountF, MessagingF, MarkersF, ConfirmF, OnboardingF, RouteS, States, Constants, EventListenersF, Events, AnalyticsS, TimeUtilF, AbTestF) {
    var _findDispatchDriver, _getProjectRoutesInfo, _hideCompleteWidget, _lastStep, _setUpRedirect;
    this.steps = Constants.DEMO_STEPS;
    this.stepNames = [$translate.instant("DEMO.DEMO_START"), $translate.instant("DEMO.DEMO_OPTIMIZE"), $translate.instant("DEMO.DEMO_DISPATCH"), $translate.instant("DEMO.DEMO_SMS"), $translate.instant("DEMO.DEMO_DONE")];
    this.nextSteps = [$translate.instant("DEMO.DEMO_TRY_START"), $translate.instant("DEMO.DEMO_TRY_DELIVER"), $translate.instant("DEMO.DEMO_TRY_UPDATE"), $translate.instant("DEMO.DEMO_TRY_OWN")];
    _lastStep = DemoF.findLastStep();
    this.step = _lastStep;
    this.userName = AccountF.getUserName();
    this.driverLocation = {};
    this.driverPhone = void 0;
    this.driverName = void 0;
    this.routeLink = void 0;
    this.hideComplete = false;
    this.inProgress = false;
    _setUpRedirect = function() {
      if (_lastStep > Constants.DEMO_STEPS.optimize) {
        return $state.go(States.projectRoutePlan);
      }
    };
    _setUpRedirect();
    _hideCompleteWidget = (function(_this) {
      return function() {
        if (_this.step !== _this.steps.complete) {
          return;
        }
        return window.setTimeout(function() {
          return _this.hideComplete = true;
        }, 6000);
      };
    })(this);
    _hideCompleteWidget();
    _getProjectRoutesInfo = (function(_this) {
      return function() {
        if (_this.step !== _this.steps.sms) {
          return;
        }
        return DispatchF.getProjectRoutes(ProjectF.project.id).then(function(res) {
          var driver, routeInfo, _results;
          _results = [];
          for (driver in res) {
            routeInfo = res[driver];
            _this.driverName = driver;
            _results.push(_this.routeLink = DispatchF.getRouteLink(routeInfo._id, routeInfo.vehicle._id));
          }
          return _results;
        });
      };
    })(this);
    _getProjectRoutesInfo();
    _findDispatchDriver = function() {
      var driver, drivers, _i, _len;
      drivers = DriverF.getDrivers();
      for (_i = 0, _len = drivers.length; _i < _len; _i++) {
        driver = drivers[_i];
        if (driver.name === AccountF.getUserName()) {
          return driver;
        }
      }
      return drivers[0];
    };
    this.toggleCompleteWidget = function(shouldHide) {
      return this.hideComplete = shouldHide;
    };
    this.skipDemo = function() {
      var tempInfo;
      AnalyticsS.track("0006_WEB_UI skip demo");
      ProjectF.clear();
      tempInfo = ProjectF.getProjectTempInfo();
      return ProjectF.create(tempInfo.name, tempInfo.date).then(function() {
        return ProjectF.load(ProjectF.project.id);
      }).then(function() {
        EventListenersF.notify(Events.DEMO_FINISHED);
        EventListenersF.notify(Events.PROJECT_SWITCHED);
        return $state.go(States.projectDriversList);
      }).then(function() {
        return ConfirmF.onboardingStart(AbTestF.activateChameleonTour).then(function() {
          return OnboardingF.startOnboarding();
        })["catch"](function() {
          return OnboardingF.skipTour();
        });
      });
    };
    this.proceed = function() {
      return this.step += 1;
    };
    this.submitAddress = function(isValid) {
      var payload, tempInfo;
      if (!isValid) {
        return;
      }
      this.inProgress = true;
      tempInfo = ProjectF.getProjectTempInfo();
      payload = {};
      payload.address = this.driverLocation.address;
      payload.location = this.driverLocation.coords;
      payload.projectDate = TimeUtilF.toString(tempInfo.date);
      payload.startTime = TimeUtilF.dateToHhMm(tempInfo.date, true);
      payload.timezone = tempInfo.date.getTimezoneOffset() * (60 * 1000) * -1;
      return ProjectF.createDemo(payload).then(function(project) {
        return ProjectF.loadProjectData(project);
      }).then(function() {
        EventListenersF.notify(Events.DEMO_MAP_CHANGED);
        return EventListenersF.notify(Events.PROJECT_SWITCHED);
      }).then(function() {
        return MarkersF.fitToPoints(MarkersF.OFFSET.ROUTE_VIEW);
      }).then((function(_this) {
        return function() {
          AnalyticsS.track("0007_WEB_UI generate demo drivers and stops");
          return _this.proceed();
        };
      })(this))["catch"]((function(_this) {
        return function() {
          return MessagingF.replaceError("DEMO.GENERIC_ERROR");
        };
      })(this))["finally"]((function(_this) {
        return function() {
          return _this.inProgress = false;
        };
      })(this));
    };
    this.optimizeRoute = function() {
      var date;
      this.inProgress = true;
      date = ProjectF.project.date;
      return RouteS.reoptimize(date, {
        isInDemo: DemoF.isInDemo()
      }).then(function() {
        $state.go(States.projectRoutePlan);
        return AnalyticsS.track("0009_WEB_UI optimize route from demo", {
          '#unserved': _.size(RouteS.getUnserved())
        });
      }).then((function(_this) {
        return function() {
          _this.inProgress = false;
          return _this.proceed();
        };
      })(this));
    };
    this.dispatchRoute = function(isValid) {
      var dispatchDriver;
      if (!isValid) {
        return;
      }
      this.inProgress = true;
      dispatchDriver = _findDispatchDriver();
      dispatchDriver.phoneNumber = this.driverPhone;
      this.driverName = dispatchDriver.name;
      return DriverF.update(dispatchDriver).then(function() {
        return DispatchF.dispatchDrivers(ProjectF.project);
      }).then((function(_this) {
        return function(res) {
          var routeInfo = res[0].res;
          _this.routeLink = DispatchF.getRouteLink(routeInfo._id, routeInfo.vehicle._id);
          return AnalyticsS.track("0011_WEB_UI demo confirm dispatch");
        };
      })(this)).then(function() {
        return EventListenersF.notify(Events.PROJECT_MODIFIED, true);
      })["catch"]((function(_this) {
        return function(err) {
          if (err) {
            MessagingF.replaceError(err.message || err.error);
          }
          return $q.reject();
        };
      })(this)).then((function(_this) {
        return function() {
          return _this.proceed();
        };
      })(this)).then(function() {
        return $state.go(States.projectRouteLive);
      })["finally"]((function(_this) {
        return function() {
          return _this.inProgress = false;
        };
      })(this));
    };
    this.openLink = function() {
      if (!this.routeLink) {
        return;
      }
      AnalyticsS.track("0012_WEB_UI demo failed sending sms");
      $window.open(this.routeLink, '_blank');
      return true;
    };
    this.startNewProject = function() {
      return $state.go(States.modalProjectsNew);
    };
    this.hidePhoneEntry = function() {
      if (!DemoF.isModifiedDemoDispatch()) {
        return false;
      }
      return !DemoF.isDispatchClicked;
    };
    EventListenersF.addEventListener(Events.DEMO_STARTED, (function(_this) {
      return function() {
        return _this.step = Constants.DEMO_STEPS.address;
      };
    })(this));
    EventListenersF.addEventListener(Events.ROUTE_SEEN, (function(_this) {
      return function() {
        if (_this.step !== _this.steps.sms) {
          return;
        }
        return AccountF.updateSettings({
          demoLinkOpened: true
        }).then(function() {
          _this.step = _this.steps.complete;
          return _hideCompleteWidget();
        });
      };
    })(this));
  };
  DemoC.$inject = ["$state", "$window", "$q", "$translate", "DemoF", "ProjectF", "DriverF", "DispatchF", "AccountF", "MessagingF", "MarkersF", "ConfirmF", "OnboardingF", "RouteS", "States", "Constants", "EventListenersF", "Events", "AnalyticsS", "TimeUtilF", "AbTestF"];

  angular.module('app').controller('DemoC', DemoC);

}).call(this);

(function() {
  var DemoF = function($state, States, Constants, RouteS, AccountF, DispatchStatusF, ProjectF) {
    var _inDemo, _lastStep;
    _lastStep = -1;
    _inDemo = false;
    DemoF = {};
    DemoF.isDispatchClicked = false;
    DemoF.setDemoStatus = function(inDemo) {
      return _inDemo = inDemo;
    };
    DemoF.isInDemo = function() {
      return _inDemo;
    };
    DemoF.isUsableInDemo = function(featureName) {
      if (!_inDemo) {
        return true;
      }
    };
    DemoF.isModifiedDemoDispatch = function() {
      if (!_inDemo) {
        return false;
      }
    };
    DemoF.clickedDispatch = function() {
      return DemoF.isDispatchClicked = true;
    };
    DemoF.findLastStep = function() {
      if (ProjectF.project.id) {
        if (AccountF.isDemoLinkOpened()) {
          return Constants.DEMO_STEPS.complete;
        } else if (RouteS.hasRoute()) {
          if (DispatchStatusF.hasDispatches()) {
            return Constants.DEMO_STEPS.sms;
          } else {
            return Constants.DEMO_STEPS.dispatch;
          }
        } else {
          return Constants.DEMO_STEPS.optimize;
        }
      } else if (AccountF.shouldShowQuestionnaire()) {
        return -1;
      } else {
        return Constants.DEMO_STEPS.address;
      }
    };
    return DemoF;
  };
  DemoF.$inject = ["$state", "States", "Constants", "RouteS", "AccountF", "DispatchStatusF", "ProjectF"];

  angular.module('app').factory('DemoF', DemoF);

}).call(this);

(function() {
  var ConfirmF = function($q, $kookies, $translate, ngDialog) {
    var _currentScope, _isDialogOpen, _openConfirmationDialog;
    var TYPES = {
      INFORMATION: 'info',
      WARNING: 'warning',
      CN_WARNING: 'cn-warning'
    };
    _isDialogOpen = false;
    _currentScope = void 0;
    _openConfirmationDialog = function(obj) {
      _isDialogOpen = true;
      return ngDialog.openConfirm(obj)["finally"](function() {
        return _isDialogOpen = false;
      });
    };
    return {
      isDialogOpen: function() {
        return _isDialogOpen;
      },
      closeConfirm: function() {
        if (!_currentScope) {
          return;
        }
        _currentScope.closeThisDialog(0);
        return _currentScope = void 0;
      },
      confirm: function(textKey) {
        var text = $translate.instant(textKey);
        return _openConfirmationDialog({
          template: 'confirm/confirm.html',
          controller: [
            '$scope', function($scope) {
              $scope.text = text;
              return _currentScope = $scope;
            }
          ]
        });
      },
      confirmTemplate: function(heading, text, cancelText, actionText, messageType, disableAction, disableMessage, actionable, doNotShowCookieName, hideClose) {
        var cookie, isHiddenState, style;
        isHiddenState = null;
        if (doNotShowCookieName != null) {
          cookie = $kookies.get(doNotShowCookieName);
          if (cookie != null) {
            isHiddenState = JSON.parse(cookie);
          }
          if ((cookie != null) && isHiddenState === true) {
            return $q.when();
          }
        }
        if (heading) {
          heading = $translate.instant(heading);
        }
        text = $translate.instant(text);
        if (cancelText) {
          cancelText = $translate.instant(cancelText);
        }
        if (actionText) {
          actionText = $translate.instant(actionText);
        }
        style = {};
        switch (messageType) {
          case TYPES.INFORMATION:
            style.iconName = 'icon-info-alt';
            style.className = 'info';
            break;
          case TYPES.WARNING:
            style.iconName = 'icon-warning-alt';
            style.className = 'warning';
            break;
          case TYPES.ERROR:
            style.iconName = 'icon-alert';
            style.className = 'error';
            break;
          case TYPES.CN_WARNING:
            style.iconName = 'icon-cn-warning';
            style.className = 'info';
        }
        return _openConfirmationDialog({
          template: 'confirm/confirmTemplate.html',
          controller: [
            '$scope', function($scope) {
              $scope.heading = heading;
              $scope.text = text;
              $scope.cancelText = cancelText;
              $scope.actionText = actionText;
              $scope.style = style;
              $scope.disableAction = disableAction;
              $scope.disableMessage = disableMessage;
              $scope.actionable = actionable;
              $scope.hideClose = hideClose;

              /*
                Do not show again checkbox
               */
              $scope.canHideWindow = doNotShowCookieName != null;
              $scope.isHideWindowChecked = !!isHiddenState;
              return $scope.setHideWindow = function(isHidden) {
                $kookies.set(doNotShowCookieName, isHidden);
                return $scope.isHideWindowChecked = isHidden;
              };
            }
          ]
        });
      },
      confirmInfo: function(heading, text, cancelText, actionText) {
        return this.confirmTemplate(heading, text, cancelText, actionText, TYPES.INFORMATION);
      },
      confirmWarning: function(heading, text, cancelText, actionText, disableAction, disableMessage) {
        return this.confirmTemplate(heading, text, cancelText, actionText, TYPES.WARNING, disableAction, disableMessage);
      },
      actionableConfirmWarning: function(heading, text, cancelText, actionText, disableAction, disableMessage) {
        return this.confirmTemplate(heading, text, cancelText, actionText, TYPES.WARNING, disableAction, disableMessage, true);
      },
      confirmError: function(heading, text, cancelText, actionText) {
        return this.confirmTemplate(heading, text, cancelText, actionText, TYPES.ERROR);
      },
      confirmRedispatch: function(pendingRoutes, noPhoneRoutes, parentController) {
        return _openConfirmationDialog({
          template: 'confirm/redispatchConfirm.html',
          controller: [
            '$scope', function($scope) {
              $scope.pendingRoutes = pendingRoutes;
              $scope.noPhoneRoutes = noPhoneRoutes;
              $scope.parentController = parentController;
              return $scope.updatePhone = function(isValid, route, newPhone) {
                $scope.closeThisDialog();
                return parentController.updatePhone(isValid, route, newPhone);
              };
            }
          ]
        });
      },
      welcomeExistingUser: function(firstName) {
        return _openConfirmationDialog({
          template: 'confirm/welcomeExistingUser.html',
          className: 'ngdialog-onboarding',
          controller: [
            '$scope', function($scope) {
              return $scope.firstName = firstName;
            }
          ]
        });
      },
      onboardingStart: function(activateChameleonTour) {
        return _openConfirmationDialog({
          template: 'confirm/onboardingStart.html',
          className: 'ngdialog-onboarding',
          controller: [
            '$scope', function($scope) {
              return $scope.activateChameleonTour = activateChameleonTour;
            }
          ]
        });
      },
      onboardingEnd: function() {
        return _openConfirmationDialog({
          template: 'confirm/onboardingEnd.html',
          className: 'ngdialog-onboarding'
        });
      },
      trialEndUpgrade: function(firstName, activateIntercom, hasShopifyBilling) {
        return _openConfirmationDialog({
          template: 'confirm/trialEndMessage.html',
          className: 'ngdialog-trialend',
          controller: [
            '$scope', function($scope) {
              $scope.firstName = firstName;
              $scope.activateIntercom = activateIntercom;
              return $scope.hasShopifyBilling = hasShopifyBilling;
            }
          ]
        });
      },

      /*
        Notification confirmation windows
       */
      notificationUnscheduleWarning: function() {
        return this.confirmTemplate("CUSTOMER_NOTIFICATIONS.REOPTIMIZE_UNSCHEDULE.HEADING", "CUSTOMER_NOTIFICATIONS.REOPTIMIZE_UNSCHEDULE.TEXT", "CUSTOMER_NOTIFICATIONS.REOPTIMIZE_UNSCHEDULE.CANCEL", "CUSTOMER_NOTIFICATIONS.REOPTIMIZE_UNSCHEDULE.OK", TYPES.CN_WARNING, null, null, null);
      },
      notificationUnscheduleConfirm: function() {
        return this.confirmTemplate("CUSTOMER_NOTIFICATIONS.CONFIRM_UNSCHEDULE.HEADING", "CUSTOMER_NOTIFICATIONS.CONFIRM_UNSCHEDULE.TEXT", "CUSTOMER_NOTIFICATIONS.CONFIRM_UNSCHEDULE.CANCEL", "CUSTOMER_NOTIFICATIONS.CONFIRM_UNSCHEDULE.OK", TYPES.CN_WARNING, null, null, null, "hide-notification-unschedule-confirm");
      },
      notificationDeleteWarning: function() {
        return this.confirmTemplate("CUSTOMER_NOTIFICATIONS.WARNING_DELETE.HEADING", "CUSTOMER_NOTIFICATIONS.WARNING_DELETE.TEXT", "CUSTOMER_NOTIFICATIONS.WARNING_DELETE.CANCEL", "CUSTOMER_NOTIFICATIONS.WARNING_DELETE.OK", TYPES.CN_WARNING, null, null, null, "hide-notification-delete-warning");
      },
      notificationDeleteConfirm: function() {
        return _openConfirmationDialog({
          template: 'confirm/notificationDeleteConfirm.html',
          className: 'ngdialog-notification-delete-confirm',
          controller: [
            '$scope', 'DispatchStatusF', function($scope, DispatchStatusF) {
              $scope.heading = $translate.instant("CUSTOMER_NOTIFICATIONS.CONFIRM_DELETE.HEADING");
              $scope.text = $translate.instant("CUSTOMER_NOTIFICATIONS.CONFIRM_DELETE.TEXT");
              $scope.cancelText = $translate.instant("CUSTOMER_NOTIFICATIONS.CONFIRM_DELETE.CANCEL");
              $scope.actionText = $translate.instant("CUSTOMER_NOTIFICATIONS.CONFIRM_DELETE.OK");
              $scope.style = {
                iconName: 'icon-warning-alt',
                className: 'warning'
              };
              return $scope.dispatchTooltipData = {
                drivers: DispatchStatusF.getPendingRoutesCount(),
                customers: -1
              };
            }
          ]
        });
      },
      projectVersionMismatch: function() {
        return this.confirmTemplate("MESSAGES.PROJECT_VER_ERR_HEADING", "MESSAGES.PROJECT_VER_ERR_BODY", void 0, "I understand", TYPES.WARNING, null, null, null, null, true);
      }
    };
  };
  ConfirmF.$inject = ["$q", "$kookies", "$translate", "ngDialog"];

  angular.module('app').factory('ConfirmF', ConfirmF);

}).call(this);

(function() {
  var CustomerNotificationF = function($q, $http, AccountF, MessagingF, ProjectF, Constants, AnalyticsS) {
    var _getTruncateValue, _getValidNotificationCount;
    CustomerNotificationF = {};
    _getValidNotificationCount = function(res) {
      var notification, _i, _j, _len, _len1;
      var count = 0;
      if (AccountF.isEmailNotificationOn()) {
        for (_i = 0, _len = res.length; _i < _len; _i++) {
          notification = res[_i];
          if (notification.email != null) {
            count += 1;
          }
        }
      } else if (AccountF.isSmsNotificationOn()) {
        for (_j = 0, _len1 = res.length; _j < _len1; _j++) {
          notification = res[_j];
          if (notification.phone != null) {
            count += 1;
          }
        }
      }
      return count;
    };
    _getTruncateValue = function() {
      if (AccountF.enforcedMessageTruncateLength) {
        return 15;
      }
      return 50;
    };
    CustomerNotificationF.sendPlannedEta = function() {
      var authHeader, projectId;
      if (!AccountF.hasCustomerNotification() || AccountF.isNotificationDisabled() || !AccountF.isEtaNotificationOn()) {
        return $q.when();
      }
      authHeader = AccountF.getAuthHeader();
      projectId = ProjectF.project.id;
      return $http.post("" + Constants.productApiPath + "/v0.1/project/" + projectId + "/send-planned-etas", {}, authHeader).then(function(res) {
        var count;
        console.log('res', res.data);
        if (res.data.length > 0) {
          count = _getValidNotificationCount(res.data);
          if (count > 0) {
            return AnalyticsS.track('Sent eta notifications', count);
          }
        }
      })["catch"](function(err) {
        return console.log('err', err.data);
      });
    };
    CustomerNotificationF.sendCancellation = function(projectId, deletedStopInfo) {
      var authHeader, data, _ref, _ref1, _ref2, _ref3, _ref4;
      if (!AccountF.hasCustomerNotification() || !AccountF.isCancelledNotificationOn()) {
        return $q.when();
      }
      data = {};
      if (deletedStopInfo != null) {
        if (((_ref = deletedStopInfo.email) != null ? _ref.length : void 0) <= 0 && ((_ref1 = deletedStopInfo.phone) != null ? _ref1.length : void 0) <= 0) {
          return $q.when();
        }
        data.id = deletedStopInfo.id;
        if (((_ref2 = deletedStopInfo.email) != null ? _ref2.length : void 0) > 0) {
          data.email = deletedStopInfo.email;
        }
        if (((_ref3 = deletedStopInfo.phone) != null ? _ref3.length : void 0) > 0) {
          data.phone = deletedStopInfo.phone;
        }
        data.properties = {
          stop_name: deletedStopInfo.name.substring(0, _getTruncateValue()),
          notes: ((_ref4 = deletedStopInfo.notes) != null ? _ref4.substring(0, _getTruncateValue()) : void 0) || ''
        };
      }
      authHeader = AccountF.getAuthHeader();
      projectId = ProjectF.project.id;
      return $http.post("" + Constants.productApiPath + "/v0.1/project/" + projectId + "/send-cancellation-notifications", data, authHeader).then(function(res) {
        return console.log('res', res.data);
      })["catch"](function(err) {
        return console.log('err', err.data);
      });
    };
    return CustomerNotificationF;
  };
  CustomerNotificationF.$inject = ["$q", "$http", "AccountF", "MessagingF", "ProjectF", "Constants", "AnalyticsS"];

  angular.module('app').factory('CustomerNotificationF', CustomerNotificationF);

}).call(this);

(function() {
  var DispatchF = function($injector, $http, $q, $translate, ValidatorF, Constants, VisitF, DriverF, AccountF, RouteUtil, TimeUtilF, EventListenersF, Events, StoredDriverF, DispatchStatusF, Messages, VisitUtilF, LoggerF) {
    var GPSRoutesF, ProjectF, _addDoneToStats, _addSkippedToStats, _addStatForVehicle, _createRoute, _deleteRoute, _dispatches, _fetchDispatchInfo, _getCurrentLocation, _getHeading, _getRoute, _getVisitIndex, _initEventListeners, _isDispatchable, _parseDispatch, _parseDispatches, _parseRoute, _removeDoneFromStats, _removeSkippedFromStats, _replaceStatsWithDispatches, _route, _sendRouteSms, _stats, _updateRoute, _updateStatsWithStatus, _upsertDispatch;
    ProjectF = null;
    GPSRoutesF = null;
    DispatchF = {};
    _dispatches = {};
    _stats = null;
    _route = null;
    _initEventListeners = function() {
      EventListenersF.addEventListener(Events.ROUTE_SET, function(route) {
        return DispatchF.setRoute(route);
      });
      EventListenersF.addEventListener(Events.ROUTE_SEEN, function(data) {
        var dispatchToUpdate, routeId, userId;
        userId = data.userId;
        if (userId === AccountF.getUser()._id) {
          routeId = data.routeId;
          dispatchToUpdate = DispatchF.getDispatchWithRouteId(routeId);
          if (dispatchToUpdate) {
            dispatchToUpdate.lastSeen = data.lastSeen;
          }
          return EventListenersF.notify(Events.VERIFIED_ROUTE_SEEN);
        }
      });
      return EventListenersF.addEventListener(Events.VISIT_STATUS_UPDATED, function(data) {
        var dispatchToUpdate, promise, routeId, userId, vehicleId;
        userId = data.userId;
        if (userId === AccountF.getUser()._id) {
          routeId = data.routeId;
          dispatchToUpdate = DispatchF.getDispatchWithRouteId(routeId);
          if (dispatchToUpdate) {
            vehicleId = dispatchToUpdate.vehicle.id;
            promise = null;
            if (!!data.new_stop_id) {
              promise = _fetchDispatchInfo(dispatchToUpdate.vehicle._id, routeId).then(function(dispatch) {
                _dispatches[vehicleId] = dispatch;
                return dispatchToUpdate = dispatch;
              });
            } else {
              promise = $q.when();
            }
            return promise.then(function() {
              var currentLocation, dispatches, heading, isRouteFinished, minsLate, newVisit, nextLocation, oldStatus, visitIndex, _ref, _ref1, _ref2, _ref3;
              visitIndex = _getVisitIndex(data.visit_id, dispatchToUpdate.solution.visits);
              newVisit = data.detail;
              oldStatus = (_ref = dispatchToUpdate.solution) != null ? (_ref1 = _ref.visits[visitIndex]) != null ? _ref1.status : void 0 : void 0;
              minsLate = VisitUtilF.getVisitLateness(newVisit);
              newVisit.minsLate = minsLate;
              newVisit.isLate = minsLate > 0;
              dispatchToUpdate.solution.visits[visitIndex] = null;
              dispatchToUpdate.solution.visits[visitIndex] = newVisit;
              isRouteFinished = visitIndex === dispatchToUpdate.solution.visits.length - 1;
              GPSRoutesF || (GPSRoutesF = $injector.get('GPSRoutesF'));
              if (!GPSRoutesF.isSubscribedRoute(routeId)) {
                _ref2 = _getCurrentLocation(dispatchToUpdate), currentLocation = _ref2[0], nextLocation = _ref2[1];
                heading = _getHeading(currentLocation, nextLocation);
                DriverF.setCurrentLocation(vehicleId, currentLocation, heading);
              }
              dispatches = {};
              dispatches[vehicleId] = dispatchToUpdate;
              VisitF.updateVisitsWithDispatchInfo(dispatches);
              if (!newVisit["break"] && newVisit.finish_time) {
                _updateStatsWithStatus(vehicleId, newVisit.status, oldStatus);
              }
              return EventListenersF.notify(Events.VERIFIED_VISIT_STATUS_UPDATE, {
                data: data,
                vehicleId: vehicleId,
                driverName: dispatchToUpdate != null ? (_ref3 = dispatchToUpdate.vehicle) != null ? _ref3.name : void 0 : void 0,
                isRouteFinished: isRouteFinished
              });
            });
          }
        }
      });
    };
    _parseDispatch = function(dispatch) {
      var _ref;
      return dispatch.vehicle.name = (_ref = DriverF.getDriver(dispatch.vehicle.id)) != null ? _ref.name : void 0;
    };
    _getVisitIndex = function(visitId, visits) {
      var visitIndex = void 0;
      visits.forEach(function(visit, index) {
        var _ref;
        if (((_ref = visit.location) != null ? _ref.id : void 0) === visitId) {
          return visitIndex = index;
        } else if (visit["break"] && visitId === Constants.BREAK_ID) {
          return visitIndex = index;
        }
      });
      return visitIndex;
    };
    _parseDispatches = function(entries) {
      var dispatch, dispatches, _i, _len, _ref;
      dispatches = {};
      for (_i = 0, _len = entries.length; _i < _len; _i++) {
        dispatch = entries[_i];
        if (!((_ref = dispatch.vehicle) != null ? _ref.id : void 0)) {
          continue;
        }
        _parseDispatch(dispatch);
        dispatches[dispatch.vehicle.id] = dispatch;
      }
      return dispatches;
    };
    _getCurrentLocation = function(dispatch) {
      var currentLocation, idx, locationIdx, nextLocation, v, visits, _i, _len, _ref, _ref1;
      visits = (_ref = dispatch.solution) != null ? _ref.visits : void 0;
      currentLocation = null;
      for (idx = _i = 0, _len = visits.length; _i < _len; idx = ++_i) {
        v = visits[idx];
        if (v.status === Constants.visitStatusDone || v.status === Constants.visitStatusSkipped) {
          if (!v["break"]) {
            currentLocation = v.location;
            locationIdx = idx;
          }
        } else if (idx === 0) {
          currentLocation = v.location;
          locationIdx = idx;
          break;
        }
      }
      nextLocation = (_ref1 = visits[++locationIdx]) != null ? _ref1.location : void 0;
      return [currentLocation, nextLocation];
    };
    _getHeading = function(curr, next) {
      var lat, lng;
      var heading = "liveDriverNE";
      if (curr && next) {
        lat = next.lat >= curr.lat ? "N" : "S";
        lng = next.lng >= curr.lng ? "E" : "W";
        heading = "liveDriver" + lat + lng;
      }
      return heading;
    };
    _parseRoute = function(route) {
      var newRoute;
      if (!route) {
        return;
      }
      newRoute = {};
      if (route._id) {
        newRoute._id = route._id;
      }
      if (route.date) {
        newRoute.date = route.date;
      }
      if (route.secret) {
        newRoute.secret = route.secret;
      }
      if (route.solution) {
        newRoute.solution = route.solution;
      }
      if (route._project) {
        newRoute.project = route._project;
      }
      if (route._vehicle) {
        newRoute.vehicle = {};
        if (route._vehicle.id) {
          newRoute.vehicle.id = route._vehicle.id;
        }
        if (route._vehicle._id) {
          newRoute.vehicle._id = route._vehicle._id;
        }
      }
      return newRoute;
    };
    _sendRouteSms = function(driverId, routeId) {
      return $http.post("" + Constants.apiPath + "/product/fleet/" + driverId + "/routes/" + routeId + "/send-sms", null, AccountF.getAuthHeader()).then(function(res) {
        return res.status;
      });
    };
    _deleteRoute = function(driverId, routeId) {
      return $http["delete"]("" + Constants.apiPath + "/product/fleet/" + driverId + "/routes/" + routeId, AccountF.getAuthHeader()).then(function(res) {
        return res.data;
      });
    };
    _updateRoute = function(driverid, routeId, data) {
      return $http.put("" + Constants.apiPath + "/product/fleet/" + driverid + "/routes/" + routeId + "/visits", data, AccountF.getAuthHeader()).then(function(res) {
        LoggerF.info(LoggerF.ACTIONS.UPDATED_ROUTES, res.data);
        return res.data;
      });
    };
    _createRoute = function(driverid, data) {
      return $http.post("" + Constants.apiPath + "/product/fleet/" + driverid + "/routes", data, AccountF.getAuthHeader()).then(function(res) {
        var _ref;
        var parsedRoute = void 0;
        if (((_ref = res.data) != null ? _ref._vehicle : void 0) != null) {
          parsedRoute = _parseRoute(res.data);
        } else {
          parsedRoute = res.data;
        }
        EventListenersF.notify(Events.NEW_ROUTES_CREATED, parsedRoute);
        LoggerF.info(LoggerF.ACTIONS.CREATED_ROUTES, parsedRoute);
        return parsedRoute;
      });
    };
    _upsertDispatch = function(driverid, dispatch) {
      var routeId;
      var existingDispatch = DispatchF.getDispatchWithVehicleId(dispatch.vehicle.id);
      if (existingDispatch) {
        routeId = existingDispatch._id;
        return _updateRoute(driverid, routeId, dispatch);
      } else {
        return _createRoute(driverid, dispatch);
      }
    };
    _fetchDispatchInfo = function(driverId, routeId) {
      return $http.get("" + Constants.apiPath + "/product/fleet/" + driverId + "/routes/" + routeId, AccountF.getAuthHeader()).then(function(res) {
        var dispatchInfo = _parseRoute(res.data);
        _parseDispatch(dispatchInfo);
        return dispatchInfo;
      });
    };
    _addDoneToStats = function(vehicleId) {
      var _ref;
      _stats.numDone++;
      return (_ref = _stats.drivers[vehicleId]) != null ? _ref.numDone++ : void 0;
    };
    _addSkippedToStats = function(vehicleId) {
      var _ref;
      _stats.numSkipped++;
      return (_ref = _stats.drivers[vehicleId]) != null ? _ref.numSkipped++ : void 0;
    };
    _removeSkippedFromStats = function(vehicleId) {
      var _ref;
      _stats.numSkipped--;
      return (_ref = _stats.drivers[vehicleId]) != null ? _ref.numSkipped-- : void 0;
    };
    _removeDoneFromStats = function(vehicleId) {
      var _ref;
      _stats.numDone--;
      return (_ref = _stats.drivers[vehicleId]) != null ? _ref.numDone-- : void 0;
    };
    _updateStatsWithStatus = function(vehicleId, status, oldStatus) {
      switch (status) {
        case Constants.visitStatusDone:
          return _addDoneToStats(vehicleId);
        case Constants.visitStatusSkipped:
          return _addSkippedToStats(vehicleId);
        case Constants.visitStatusPending:
          if (oldStatus === Constants.visitStatusDone) {
            return _removeDoneFromStats(vehicleId);
          } else if (oldStatus === Constants.visitStatusSkipped) {
            return _removeSkippedFromStats(vehicleId);
          }
      }
    };
    _getRoute = function() {
      return _route;
    };
    _addStatForVehicle = function(vehicleId) {
      var colorName, driverName, driverRoute, driverStats, route, _ref, _ref1, _ref2, _ref3;
      if (_stats == null) {
        DispatchF.clearStats();
      }
      if (_stats.drivers[vehicleId] != null) {
        return;
      }
      route = _route;
      driverRoute = (_ref = route.solution) != null ? (_ref1 = _ref.response) != null ? _ref1[vehicleId] : void 0 : void 0;
      driverName = driverRoute != null ? (_ref2 = driverRoute.driver) != null ? _ref2.name : void 0 : void 0;
      colorName = driverRoute != null ? (_ref3 = driverRoute.color) != null ? _ref3.name : void 0 : void 0;
      driverStats = {
        numDone: 0,
        numSkipped: 0,
        name: driverName,
        color: colorName
      };
      return _stats.drivers[vehicleId] = driverStats;
    };
    _replaceStatsWithDispatches = function(dispatches) {
      var colorName, dispatch, driverName, driverStats, idx, newStats, route, solution, vehicleId, visit, visits, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4;
      newStats = {
        numDone: 0,
        numSkipped: 0,
        drivers: {}
      };
      route = _route;
      _ref1 = (_ref = route.solution) != null ? _ref.response : void 0;
      for (vehicleId in _ref1) {
        solution = _ref1[vehicleId];
        driverName = (_ref2 = solution.driver) != null ? _ref2.name : void 0;
        colorName = (_ref3 = solution.color) != null ? _ref3.name : void 0;
        driverStats = {
          numDone: 0,
          numSkipped: 0,
          name: driverName,
          color: colorName
        };
        dispatch = dispatches[vehicleId];
        if (dispatch) {
          visits = (_ref4 = dispatch.solution) != null ? _ref4.visits : void 0;
          for (idx = _i = 0, _len = visits.length; _i < _len; idx = ++_i) {
            visit = visits[idx];
            if (!visit["break"] && visit.finish_time) {
              if (visit.status === Constants.visitStatusDone) {
                newStats.numDone++;
                driverStats.numDone++;
              } else if (visit.status === Constants.visitStatusSkipped) {
                newStats.numSkipped++;
                driverStats.numSkipped++;
              }
            }
          }
        }
        newStats.drivers[vehicleId] = driverStats;
      }
      return _stats = newStats;
    };
    DispatchF.setRoute = function(route) {
      return _route = route;
    };
    DispatchF.clear = function() {
      DispatchF.clearDispatches();
      return DispatchF.clearStats();
    };
    DispatchF.clearDispatches = function() {
      return _dispatches = {};
    };
    DispatchF.clearStats = function() {
      return _stats = {
        numDone: 0,
        numSkipped: 0,
        drivers: {}
      };
    };
    DispatchF.initialize = function(fleet) {
      var colorName, driver, driverName, route, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _results;
      if (fleet == null) {
        fleet = null;
      }
      fleet = fleet || DriverF.getValidDrivers();
      DispatchF.clear();
      route = _route;
      _results = [];
      for (_i = 0, _len = fleet.length; _i < _len; _i++) {
        driver = fleet[_i];
        driverName = (_ref = route.solution) != null ? (_ref1 = _ref.response) != null ? (_ref2 = _ref1[driver.id]) != null ? (_ref3 = _ref2.driver) != null ? _ref3.name : void 0 : void 0 : void 0 : void 0;
        colorName = (_ref4 = route.solution) != null ? (_ref5 = _ref4.response) != null ? (_ref6 = _ref5[driver.id]) != null ? (_ref7 = _ref6.color) != null ? _ref7.name : void 0 : void 0 : void 0 : void 0;
        _results.push(_stats.drivers[driver.id] = {
          numDone: 0,
          numSkipped: 0,
          name: driverName,
          color: colorName
        });
      }
      return _results;
    };
    DispatchF.getSolutionsByDispatchStatus = function() {
      var dispatchInfo, fleet, hhMM, id, isDirty, route, routes, sentDate, sentTime, sentTimes, solution, solutions, solutionsByDispatchType, solutionsClone, _i, _len, _name, _name1, _name2, _ref;
      route = _getRoute();
      fleet = route.solution.request.fleet;
      routes = _.pick(route.solution, _.isArray);
      solutions = RouteUtil.parseRouteDispatch(fleet, routes);
      dispatchInfo = route.dispatches;
      solutionsClone = _.cloneDeep(solutions);
      sentTimes = DispatchStatusF.getSentTimes();
      solutionsByDispatchType = {};
      for (_i = 0, _len = solutionsClone.length; _i < _len; _i++) {
        solution = solutionsClone[_i];
        id = solution.id;
        sentTime = sentTimes != null ? sentTimes[id] : void 0;
        isDirty = dispatchInfo != null ? (_ref = dispatchInfo[id]) != null ? _ref.isDirty : void 0 : void 0;
        solution.show = false;
        if (sentTime != null) {
          if (isDirty) {
            solutionsByDispatchType[_name = DispatchStatusF.statuses.STATUS_UPDATED] || (solutionsByDispatchType[_name] = []);
            solutionsByDispatchType[DispatchStatusF.statuses.STATUS_UPDATED].push(solution);
          } else {
            sentDate = new Date(sentTime);
            hhMM = TimeUtilF.dateToHhMm(sentDate);
            solutionsByDispatchType[_name1 = DispatchStatusF.statuses.STATUS_SENT] || (solutionsByDispatchType[_name1] = []);
            solutionsByDispatchType[DispatchStatusF.statuses.STATUS_SENT].push(solution);
          }
        } else {
          solutionsByDispatchType[_name2 = DispatchStatusF.statuses.STATUS_NEW] || (solutionsByDispatchType[_name2] = []);
          solutionsByDispatchType[DispatchStatusF.statuses.STATUS_NEW].push(solution);
        }
      }
      return solutionsByDispatchType;
    };
    DispatchF.getAllSolutions = function() {
      var sol, soltns, solutions, solutionsByType, type, _i, _len;
      solutionsByType = DispatchF.getSolutionsByDispatchStatus();
      solutions = [];
      for (type in solutionsByType) {
        soltns = solutionsByType[type];
        for (_i = 0, _len = soltns.length; _i < _len; _i++) {
          sol = soltns[_i];
          sol.dispatchStatus = type;
          solutions.push(sol);
        }
      }
      return solutions;
    };
    _isDispatchable = function(route) {
      var _ref;
      return (route.driver.phoneNumber != null) && ((_ref = route.dispatchStatus) === DispatchStatusF.statuses.STATUS_NEW || _ref === DispatchStatusF.statuses.STATUS_UPDATED);
    };
    DispatchF.dispatchDrivers = function(project) {
      var logPayload, message;
      ProjectF || (ProjectF = $injector.get('ProjectF'));
      if (ProjectF.isOverPayloadLimitSize(true)) {
        logPayload = {
          projectId: project.id
        };
        LoggerF.error(LoggerF.ACTIONS.DISPATCH_ROUTE, logPayload, "Project payload too large to save");
        message = $translate.instant("MESSAGES.DISPATCH_OVER_PAYLOAD_SIZE_LIMIT");
        return $q.reject({
          error: message,
          res: null
        });
      }
      return ProjectF.checkProjectVersion().then(function(res) {
        var date, projectId, projectName, promises, route, _i, _len, _ref;
        if (!res.isCurrentVersion) {
          LoggerF.error(LoggerF.ACTIONS.VALIDATED_PROJECT_VERSION, {
            client_version: res.clientVersion,
            server_version: res.serverVersion
          }, 'Project version mismatch before dispatch');
          EventListenersF.notify(Events.PROJECT_VERSION_MISMATCH);
          return $q.reject();
        }
        promises = [];
        projectId = project.id;
        projectName = project.name;
        date = project.date;
        _ref = DispatchF.getAllSolutions();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          route = _ref[_i];
          if (_isDispatchable(route)) {
            promises.push((function(route) {
              return DispatchF.sendRoute(route.driver, projectId, date, projectName).then(function(res) {
                DispatchStatusF.sendDispatch(_getRoute(), route);
                EventListenersF.notify(Events.DISPATCH_SENT, {
                  routeId: res._id
                });
                return {
                  error: null,
                  res: res
                };
              })["catch"](function(err) {
                if (err.message === 404) {
                  message = $translate.instant("MESSAGES.UNSUPPORTED_SMS_REGION", {
                    x: route.driver.name,
                    email: Messages.UNSUPPORTED_EMAIL
                  });
                } else {
                  message = $translate.instant("MESSAGES.ERROR_SMS", {
                    x: route.driver.name
                  });
                }
                return {
                  error: message,
                  res: null
                };
              });
            })(route));
          }
        }
        return $q.all(promises);
      })["catch"](function(err) {
        logPayload = {
          project_id: project.id
        };
        LoggerF.error(LoggerF.ACTIONS.DISPATCH_ROUTE, logPayload, err);
        return $q.reject(err);
      });
    };
    DispatchF.replace = function(dispatches) {
      var currentLocation, dispatch, heading, minsLate, nextLocation, vehicleId, visit, _i, _len, _ref, _ref1, _ref2;
      DispatchF.clear();
      _dispatches = dispatches;
      _replaceStatsWithDispatches(dispatches);
      for (vehicleId in dispatches) {
        dispatch = dispatches[vehicleId];
        _ref1 = (_ref = dispatch.solution) != null ? _ref.visits : void 0;
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          visit = _ref1[_i];
          minsLate = VisitUtilF.getVisitLateness(visit);
          visit.minsLate = minsLate;
          visit.isLate = minsLate > 0;
        }
        _ref2 = _getCurrentLocation(dispatch), currentLocation = _ref2[0], nextLocation = _ref2[1];
        if (currentLocation) {
          heading = _getHeading(currentLocation, nextLocation);
          DriverF.setCurrentLocation(vehicleId, currentLocation, heading);
        }
      }
      VisitF.updateVisitsWithDispatchInfo(dispatches);
      EventListenersF.notify(Events.DISPATCHES_UPDATED, dispatches);
      return _dispatches;
    };
    DispatchF.getDispatches = function() {
      return _dispatches;
    };
    DispatchF.hasDispatches = function() {
      return !_.isEmpty(_dispatches);
    };
    DispatchF.getStats = function() {
      return _stats;
    };
    DispatchF.getProjectRoutes = function(projectId) {
      if (!projectId) {
        return $q.reject(new Error("Project ID is not provided"));
      }
      return $http.get("" + Constants.apiPath + "/product/projects/" + projectId + "/routes", AccountF.getAuthHeader()).then(function(res) {
        return _parseDispatches(res.data);
      });
    };
    DispatchF.getDispatchWithVehicleId = function(vehicleId) {
      return _dispatches[vehicleId];
    };
    DispatchF.getDispatchWithRouteId = function(routeId) {
      var dispatch, id;
      for (id in _dispatches) {
        dispatch = _dispatches[id];
        if (dispatch._id === routeId) {
          return dispatch;
        }
      }
      return null;
    };
    DispatchF.hasVisitBeenDispatched = function(visitId) {
      var dispatch, vehicleId, visit, visits, _i, _len, _ref, _ref1;
      for (vehicleId in _dispatches) {
        dispatch = _dispatches[vehicleId];
        visits = (_ref = dispatch.solution) != null ? _ref.visits : void 0;
        if (!visits) {
          return false;
        }
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          visit = visits[_i];
          if (((_ref1 = visit.location) != null ? _ref1.id : void 0) === visitId) {
            return true;
          }
        }
      }
      return false;
    };
    DispatchF.deleteAll = function() {
      var dispatch, driverId, key, routeId, _ref;
      for (key in _dispatches) {
        dispatch = _dispatches[key];
        routeId = dispatch._id;
        driverId = (_ref = dispatch.vehicle) != null ? _ref._id : void 0;
        if (routeId && driverId) {
          DispatchF.deleteRoute(dispatch);
        }
      }
      DispatchF.clear();
      return EventListenersF.notify(Events.DISPATCHES_DELETED);
    };
    DispatchF.deleteRoute = function(dispatch) {
      var driverId, routeId, _ref;
      if (!(dispatch && ((_ref = dispatch.vehicle) != null ? _ref._id : void 0) && dispatch._id)) {
        return;
      }
      driverId = dispatch.vehicle._id;
      routeId = dispatch._id;
      return _deleteRoute(driverId, routeId).then(function(data) {
        delete _dispatches[dispatch.vehicle.id];
        if (_stats != null) {
          delete _stats.drivers[dispatch.vehicle.id];
        }
        data;
        return EventListenersF.notify(Events.DISPATCH_DELETED, {
          routeId: routeId
        });
      });
    };
    DispatchF.resendSms = function(routeId, vehicleId) {
      if (!(routeId && vehicleId)) {
        return;
      }
      return _sendRouteSms(vehicleId, routeId);
    };
    DispatchF.getRouteLink = function(routeId, driverId) {
      if (!((routeId != null) && (driverId != null))) {
        return;
      }
      return "" + Constants.fullProductUrl + "m/#/vehicle/" + driverId + "/routes/" + routeId;
    };
    DispatchF.sendRoute = function(vehicle, projectId, date, projectName) {
      var distance, route, solution, vehicleId;
      if (projectName == null) {
        projectName = null;
      }
      if (!(vehicle && vehicle.id)) {
        return $q.reject(new Error("Vehicle ID is not provided"));
      }
      vehicleId = vehicle.id;
      route = _route;
      distance = route.distances[vehicleId];
      solution = route.solution.response[vehicleId];
      if (!solution) {
        return $q.reject(new Error("Unknown vehicle ID is provided"));
      }
      route = solution.visits;
      return ValidatorF.validateRoute(route).then(function() {
        return StoredDriverF.upsertInDb(vehicle);
      }).then(function(storedDriver) {
        var parsed, parsedVehicle;
        parsedVehicle = {
          id: vehicle.id,
          name: vehicle.name,
          'phone-number': vehicle.phoneNumber,
          types: vehicle.types
        };
        if (vehicle.startShift) {
          parsedVehicle['shift-start'] = TimeUtilF.convertDateToTime(vehicle.startShift);
        }
        if (vehicle.endShift) {
          parsedVehicle['shift-end'] = TimeUtilF.convertDateToTime(vehicle.endShift);
        }
        if (vehicle.capacity) {
          parsedVehicle.capacity = vehicle.capacity;
        }
        parsed = {
          date: date,
          distance: distance,
          visits: RouteUtil.formatDispatchRoute(route),
          vehicle: parsedVehicle,
          project: projectId,
          name: projectName
        };
        return _upsertDispatch(storedDriver._id, parsed);
      }).then(function(dispatch) {
        var dispatches, minsLate, visit, _i, _len, _ref, _ref1;
        _parseDispatch(dispatch);
        vehicleId = dispatch.vehicle.id;
        dispatches = DispatchF.getDispatches();
        _ref1 = (_ref = dispatch.solution) != null ? _ref.visits : void 0;
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          visit = _ref1[_i];
          minsLate = VisitUtilF.getVisitLateness(visit);
          visit.minsLate = minsLate;
          visit.isLate = minsLate > 0;
        }
        dispatches[vehicleId] = dispatch;
        _addStatForVehicle(vehicleId);
        return dispatch;
      });
    };
    _initEventListeners();
    DispatchF.sendWebhook = function(projectId) {
      return $http.post("" + Constants.apiPath + "/product/projects/" + projectId + "/webhook", {}, AccountF.getAuthHeader())["catch"](function(err) {
        console.error("Failed to dispatch through webhook", err);
        throw new Error("Ooops... an error occured while dispatching to your webhook endpoint. Please contact " + Constants.email + ".");
      });
    };
    DispatchF.hasLiveTrackingInVisit = function() {
      var routeId, routeInfo, visit, _i, _len, _ref, _ref1;
      if (!_dispatches) {
        return false;
      }
      for (routeId in _dispatches) {
        routeInfo = _dispatches[routeId];
        _ref1 = (_ref = routeInfo.solution) != null ? _ref.visits : void 0;
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          visit = _ref1[_i];
          if (visit.hasLiveTracking) {
            return true;
          }
        }
      }
      return false;
    };
    DispatchF.isNotifiedStop = function(stopId) {
      var visit, _ref, _ref1;
      if (DispatchF.hasVisitBeenDispatched(stopId)) {
        visit = VisitF.getVisit(stopId);
        if ((visit != null) && (((_ref = visit.email) != null ? _ref.length : void 0) > 0 || ((_ref1 = visit.phone) != null ? _ref1.length : void 0) > 0)) {
          return true;
        }
      }
      return false;
    };
    DispatchF.hasDispatchCompleted = function(driverId) {
      var dispatch = DispatchF.getDispatchWithVehicleId(driverId);
      return RouteUtil.isDone(dispatch);
    };
    return DispatchF;
  };
  DispatchF.$inject = ["$injector", "$http", "$q", "$translate", "ValidatorF", "Constants", "VisitF", "DriverF", "AccountF", "RouteUtil", "TimeUtilF", "EventListenersF", "Events", "StoredDriverF", "DispatchStatusF", "Messages", "VisitUtilF", "LoggerF"];

  angular.module('app').factory('DispatchF', DispatchF);

}).call(this);

(function() {
  var DispatchStatusF = [
    'TimeUtilF', 'DriverF', function(TimeUtilF, DriverF) {
      var _pendingRoutesCount, _sentTimes, _setPendingRoutesCount;
      _sentTimes = {};
      _pendingRoutesCount = 0;
      _setPendingRoutesCount = function(route) {
        var count, dispatches, driver, routeStatus, sentTime, solution, vehId, _ref;
        if (route != null) {
          count = 0;
          dispatches = route.dispatches;
          solution = _.pick(route.solution, _.isArray);
          for (vehId in solution) {
            route = solution[vehId];
            driver = DriverF.getDriver(vehId);
            if (dispatches) {
              routeStatus = dispatches[vehId];
            }
            sentTime = ((_ref = DispatchStatusF.getSentTimes()) != null ? _ref[vehId] : void 0) || (routeStatus != null ? routeStatus.sentTime : void 0);
            if (driver.phoneNumber && (!sentTime || routeStatus.isDirty)) {
              count += 1;
            }
          }
          return _pendingRoutesCount = count;
        } else {
          return _pendingRoutesCount = 0;
        }
      };
      DispatchStatusF = {};
      DispatchStatusF.statuses = {
        STATUS_NEW: "new",
        STATUS_SENT: "sent",
        STATUS_UPDATED: "updated"
      };
      DispatchStatusF.hasDispatches = function() {
        return !_.isEmpty(_sentTimes);
      };
      DispatchStatusF.clearSentTimes = function() {
        return _sentTimes = {};
      };
      DispatchStatusF.getSentTimes = function() {
        return _sentTimes;
      };
      DispatchStatusF.getLastSentTime = function() {
        var current, id, time;
        time = null;
        for (id in _sentTimes) {
          current = _sentTimes[id];
          if (!time || current > time) {
            time = current;
          }
        }
        return time;
      };
      DispatchStatusF.load = function(route, dispatches) {
        var info, vehicleId;
        DispatchStatusF.clearSentTimes();
        for (vehicleId in dispatches) {
          info = dispatches[vehicleId];
          if (info.sentTime) {
            _sentTimes[vehicleId] = info.sentTime;
          }
          delete info.sentTime;
        }
        return route.dispatches = _.cloneDeep(dispatches);
      };
      DispatchStatusF.resetDispatchStatus = function(route) {
        var dispatchStatus, dispatches, solutions, vehicleId, visits;
        dispatches = {};
        solutions = _.pick(route.solution, _.isArray);
        for (vehicleId in solutions) {
          visits = solutions[vehicleId];
          dispatchStatus = {
            isDirty: true
          };
          dispatches[vehicleId] = dispatchStatus;
        }
        return route.dispatches = dispatches;
      };
      DispatchStatusF.removeDispatchWithVehicleId = function(route, vehicleId) {
        var _ref;
        delete _sentTimes[vehicleId];
        return (_ref = route.dispatches) != null ? delete _ref[vehicleId] : void 0;
      };
      DispatchStatusF.sendDispatch = function(route, sentRoute) {
        var dispatch = {};
        dispatch.isDirty = false;
        if (route.dispatches == null) {
          route.dispatches = {};
        }
        _sentTimes[sentRoute.id] = Date.now();
        return route.dispatches[sentRoute.id] = dispatch;
      };
      DispatchStatusF.updateDispatchStatusForRoute = function(route, affectedVehicles, oldRoute) {
        var dispatchStatus, dispatches, vehicle, _i, _len;
        if (oldRoute == null) {
          oldRoute = {};
        }
        dispatches = _.cloneDeep(oldRoute != null ? oldRoute.dispatches : void 0) || {};
        for (_i = 0, _len = affectedVehicles.length; _i < _len; _i++) {
          vehicle = affectedVehicles[_i];
          dispatchStatus = (dispatches != null ? dispatches[vehicle.id] : void 0) || {};
          dispatchStatus.isDirty = true;
          dispatches[vehicle.id] = dispatchStatus;
        }
        return route.dispatches = dispatches;
      };
      DispatchStatusF.setPendingRoutesCount = function(route) {
        return _setPendingRoutesCount(route);
      };
      DispatchStatusF.getPendingRoutesCount = function() {
        return _pendingRoutesCount;
      };
      DispatchStatusF.hasUnsentRoutes = function() {
        return (_pendingRoutesCount != null) && _pendingRoutesCount > 0;
      };
      return DispatchStatusF;
    }
  ];

  angular.module('app').factory('DispatchStatusF', DispatchStatusF);

}).call(this);

(function() {
  var QuestionDropdownD = function() {
    return {
      restrict: 'E',
      templateUrl: 'directives/questionDropdown.html',
      scope: {
        'name': '@',
        'items': '=',
        'selected': '=',
        'placeholder': '@',
        'required': '@'
      },
      link: function($scope, $elem, $attrs) {
        $scope.isRequired = !($attrs.required == null) && $attrs.required !== 'false';
        $scope.toggleDropdown = function(event) {
          event.stopPropagation();
          return $scope.selectionVisible = !$scope.selectionVisible;
        };
        $scope.select = function(item, event) {
          event.stopPropagation();
          $scope.selected = item;
          $scope.selectionVisible = false;
        };
        return $scope.$on('dropdownClose', function() {
          return $scope.selectionVisible = false;
        });
      }
    };
  };

  angular.module('app').directive('questionDropdownD', QuestionDropdownD);

}).call(this);

(function() {
  var AddressCheckerD = function() {
    return {
      restrict: 'E',
      replace: true,
      controllerAs: 'addressChecker',
      bindToController: true,
      scope: {
        name: '=',
        status: '=',
        location: '=',
        autoSelect: '=?',
        allResults: '=',
        onSubmit: '&',
        onExit: '&'
      },
      templateUrl: 'directives/addressChecker.html',
      controller: function() {
        var _findSameCoordinate, _isSameCoordinate, _isSameLocation, _updateMarkers;
        _updateMarkers = function(allResults) {
          return allResults.map(function(v, index) {
            return {
              id: index,
              fill: 'visitAddressChecker',
              lat: v.coords.lat,
              lng: v.coords.lng
            };
          });
        };
        _isSameCoordinate = function(location1, location2) {
          return (location1.coords.lat === location2.coords.lat) && (location1.coords.lng === location2.coords.lng);
        };
        _isSameLocation = function(location1, location2) {
          return (location1 != null) && (location2 != null) && (location1.address === location2.address) && _isSameCoordinate(location1, location2);
        };
        _findSameCoordinate = function(location, allResults) {
          var current, index, _i, _len;
          for (index = _i = 0, _len = allResults.length; _i < _len; index = ++_i) {
            current = allResults[index];
            if (_isSameCoordinate(current, location)) {
              return index;
            }
          }
          return null;
        };
        this.addressName = "";
        this.isAddressChanged = (this.autoSelect != null) && this.allResults.length === 1 ? this.autoSelect : false;
        this.selectedLocation = this.allResults[0];
        this.selectedId = _findSameCoordinate(this.selectedLocation, this.allResults);
        this.markers = _updateMarkers(this.allResults);
        this.setResults = (function(_this) {
          return function(allResults, index, addressName) {
            if (index == null) {
              index = null;
            }
            _this.selectedId = index != null ? index : null;
            _this.selectedLocation = index != null ? allResults[index] : null;
            _this.allResults = allResults;
            _this.markers = _updateMarkers(allResults);
            _this.addressName = addressName;
            return _this.isAddressChanged = !_isSameLocation(_this.selectedLocation, _this.location);
          };
        })(this);
        this.setSelected = (function(_this) {
          return function(index) {
            _this.selectedId = index;
            _this.selectedLocation = _this.allResults[_this.selectedId];
            return _this.isAddressChanged = !_isSameLocation(_this.selectedLocation, _this.location);
          };
        })(this);
        this.onExit = this.onExit();
        return this.submit = (function(_this) {
          return function(isValid) {
            return _this.onSubmit()(isValid, _this.isAddressChanged, _this.selectedLocation);
          };
        })(this);
      }
    };
  };

  angular.module('app').directive('addressCheckerD', AddressCheckerD);

}).call(this);

(function() {
  var AddressPickerD = function(AddressCheckerS) {
    var AUTO_COMPLETE_OPTIONS, _switchTemplate;
    AUTO_COMPLETE_OPTIONS = {
      fields: ['place_id', 'name', 'types', 'geometry']
    };
    _switchTemplate = function(elem, attr) {
      if (attr.searchable) {
        return 'directives/addressSearch.html';
      } else {
        return 'directives/addressPicker.html';
      }
    };
    return {
      restrict: 'E',
      require: '^form',
      replace: true,
      templateUrl: _switchTemplate,
      scope: {
        name: '@',
        result: '=?',
        required: '@',
        searchable: '=?',
        setResults: '=?'
      },
      controller: ["$scope", function($scope) {
        var _deleteContainerForAutocomplete;
        _deleteContainerForAutocomplete = function(autocomplete) {
          return $('.pac-container').last().remove();
        };
        $scope.setValidity = (function(_this) {
          return function(form, name, isValid) {
            return form[name].$setValidity(name, isValid);
          };
        })(this);
        return $scope.$on("$destroy", function() {
          return _deleteContainerForAutocomplete($scope.autocomplete);
        });
      }],
      link: function($scope, $element, $attrs, form) {
        var addressField, autocomplete, hasCoords, isRequired, isSearchable, name, openModalIcon, searchIcon, _ref, _ref1;
        $attrs.name || ($attrs.name = 'address');
        name = $attrs.name;
        isSearchable = $scope.searchable;
        $scope.inputForm = form;
        addressField = angular.element($element[0].querySelector(".address-field"));
        isRequired = $attrs.hasOwnProperty('required') && ($attrs['required'] != null) && $attrs['required'] !== 'false';
        $attrs.required = isRequired;
        $scope.$watch('result', function(newVal, oldVal) {
          var _ref, _ref1;
          if (newVal === oldVal) {
            return;
          }
          if (newVal != null ? newVal.address : void 0) {
            $scope.address = newVal != null ? newVal.address : void 0;
          }
          if ((newVal != null ? newVal.address : void 0) && (newVal != null ? (_ref = newVal.coords) != null ? _ref.lat : void 0 : void 0) && (newVal != null ? (_ref1 = newVal.coords) != null ? _ref1.lng : void 0 : void 0)) {
            return $scope.setValidity(form, name, true);
          } else {
            return $scope.setValidity(form, name, !isRequired);
          }
        });
        if (isSearchable) {
          searchIcon = angular.element($element[0].querySelector(".search-icon"));
          searchIcon.on('click', function() {
            var address = addressField.val();
            return AddressCheckerS.getSearchResults(address).then(function(res) {
              if (res) {
                return $scope.setResults(res);
              } else {
                return $scope.setResults([], null, addressField.val());
              }
            });
          });
        } else {
          openModalIcon = angular.element($element[0].querySelector('.open-address-modal-icon'));
          openModalIcon.on('click', function() {
            return AddressCheckerS.check(addressField.val()).then(function(newLoc) {
              return $scope.result = newLoc;
            });
          });
        }
        if (($scope.result != null) && ($scope.result.address != null)) {
          $scope.address = $scope.result.address;
          hasCoords = !!((_ref = $scope.result.coords) != null ? _ref.lat : void 0) && !!((_ref1 = $scope.result.coords) != null ? _ref1.lng : void 0);
          $scope.setValidity(form, name, hasCoords);
        } else {
          $scope.setValidity(form, name, !isRequired);
        }
        addressField.on('input', function() {
          return $scope.$apply(function() {
            $scope.result = void 0;
            return $scope.setValidity(form, name, !isRequired && !addressField.val());
          });
        });
        addressField.bind('keypress keydown', function(event) {
          var address;
          if (event.which === 13) {
            event.preventDefault();
            if (isSearchable) {
              address = addressField.val();
              return AddressCheckerS.getSearchResults(address).then(function(res) {
                if (res) {
                  return $scope.setResults(res);
                } else {
                  return $scope.setResults([], null, addressField.val());
                }
              });
            } else {
              return AddressCheckerS.check(addressField.val()).then(function(newLoc) {
                return $scope.result = newLoc;
              });
            }
          }
        });
        autocomplete = new google.maps.places.Autocomplete(addressField[0], AUTO_COMPLETE_OPTIONS);
        $scope.autocomplete = autocomplete;
        google.maps.event.addListener(autocomplete, 'place_changed', function() {
          var place = autocomplete.getPlace();
          if ((place != null) && (place.place_id != null)) {
            return AddressCheckerS.geocodeFromPlaceId(place.place_id).then(function(res) {
              var result = res[0];
              $scope.result = result;
              if (isSearchable) {
                return $scope.setResults([result], 0);
              }
            });
          } else {
            return $scope.$apply(function() {
              return $scope.result = {};
            });
          }
        });

      }
    };
  };
  AddressPickerD.$inject = ["AddressCheckerS"];

  angular.module('app').directive('addressPickerD', AddressPickerD);

}).call(this);

(function() {
  var AnimateChangeD = function($timeout, $animate) {
    var DEFAULT_CHANGE_CLASS;
    DEFAULT_CHANGE_CLASS = 'change';
    return {
      restrict: 'A',
      link: function($scope, $elem, $attr) {
        return $scope.$watch($attr.animateChangeD, function(newVal, oldVal) {
          var changeClass;
          if (newVal !== oldVal) {
            changeClass = $attr.changeClass || DEFAULT_CHANGE_CLASS;
            return $animate.addClass($elem, changeClass).then(function() {
              return $timeout(function() {
                return $animate.removeClass($elem, changeClass);
              });
            });
          }
        });
      }
    };
  };
  AnimateChangeD.$inject = ["$timeout", "$animate"];

  angular.module('app').directive('animateChangeD', AnimateChangeD);

}).call(this);

(function() {
  var AutofocusD = function($timeout) {
    return {
      restrict: 'A',
      link: function($scope, $element) {
        return $timeout(function() {
          return $element[0].focus();
        });
      }
    };
  };
  AutofocusD.$inject = ["$timeout"];

  angular.module('app').directive('autofocusD', AutofocusD);

}).call(this);

(function() {
  var checkBoxAndLabelD = function() {
    return {
      restrict: 'E',
      scope: {
        label: "@",
        isSelected: '=',
        onUpdate: '&'
      },
      template: '<span class="check-box-and-label"> <input type="checkbox" ng-model="isSelected" /> <span class="checkmark"></span> <span>{{label}}</span> </span>',
      replace: true,
      link: function(scope, elem, attrs) {
        return scope.$watch("isSelected", function(newValue, oldValue) {
          if (oldValue === newValue) {
            return;
          }
          if (scope.onUpdate != null) {
            return scope.onUpdate()(newValue);
          }
        });
      }
    };
  };

  angular.module('app').directive('checkBoxAndLabelD', checkBoxAndLabelD);

}).call(this);

(function() {
  var checkBoxD = function() {
    return {
      restrict: 'E',
      scope: {
        isSelected: '=',
        onUpdate: '&',
        onClick: '&',
        disable: '=?'
      },
      template: '<span class="check-box"> <input type="checkbox" ng-model="isSelected" ng-disabled="disable"/> <span class="checkmark"></span> </span>',
      replace: true,
      link: function(scope, elem, attrs) {
        scope.$watch("isSelected", function(v) {
          var update = typeof scope.onUpdate === "function" ? scope.onUpdate() : void 0;
          if (update != null) {
            return update(v);
          }
        });
        return elem.bind('click', function() {
          var onClick = typeof scope.onClick === "function" ? scope.onClick() : void 0;
          if (onClick != null) {
            onClick(scope.isSelected);
            return scope.$apply();
          }
        });
      }
    };
  };

  angular.module('app').directive('checkBoxD', checkBoxD);

}).call(this);

(function() {
  var ClickExitD = function($window) {
    return {
      restrict: 'A',
      scope: {
        clickExitD: '=?'
      },
      link: function($scope, $elem, $attrs) {
        var handleClick, isWithinEle;
        var container = $elem[0];
        isWithinEle = function(target) {
          var currentNode = target;
          while (currentNode) {
            if (currentNode === container) {
              return true;
            }
            currentNode = currentNode.parentNode;
          }
          return false;
        };
        handleClick = function(e) {
          if (!isWithinEle(e.target)) {
            return $scope.$apply(function() {
              return $scope.clickExitD = false;
            });
          }
        };
        $scope.$watch('clickExitD', function(newValue, oldValue) {
          if (oldValue === newValue) {
            return;
          }
          if (newValue) {
            return setTimeout(function() {
              return $window.addEventListener('click', handleClick);
            });
          } else {
            return $window.removeEventListener('click', handleClick);
          }
        });
        return $scope.$on('destroy', function() {
          return $window.removeEventListener('click', handleClick);
        });
      }
    };
  };
  ClickExitD.$inject = ["$window"];

  angular.module('app').directive('clickExitD', ClickExitD);

}).call(this);

(function() {
  var CountdownClockD = function($interval) {
    return {
      restrict: 'E',
      templateUrl: 'directives/countdownClock.html',
      scope: {
        'deadline': '='
      },
      link: function($scope, $elem, $attrs) {
        var timeInterval, _getTimeLeft;
        _getTimeLeft = function() {
          var diff, localTime, tzOffset;
          localTime = new Date();
          diff = Date.parse($scope.deadline) - Date.parse(localTime);
          tzOffset = localTime.getTimezoneOffset() * 60 * 1000;
          diff += tzOffset;
          $scope.seconds = Math.floor((diff / 1000) % 60);
          $scope.minutes = Math.floor((diff / 1000 / 60) % 60);
          $scope.hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          return $scope.days = Math.floor(diff / (1000 * 60 * 60 * 24));
        };
        _getTimeLeft();
        return timeInterval = $interval(_getTimeLeft, 1000);
      }
    };
  };
  CountdownClockD.$inject = ["$interval"];

  angular.module('app').directive('countdownClockD', CountdownClockD);

}).call(this);

(function() {
  var dateRangeD = [
    'TimeUtilF', function(TimeUtilF) {
      return {
        restrict: 'E',
        replace: true,
        require: '^stTable',
        templateUrl: 'directives/dateRange.html',
        scope: {
          min: '=',
          max: '='
        },
        link: function(scope, element, attr, table) {
          var _updateTable;
          scope.fromDate = "";
          scope.toDate = "";
          scope.showFrom = false;
          scope.showTo = false;
          scope.minDate = scope.min;
          scope.maxDate = scope.max;
          _updateTable = function() {
            var expression = {};
            if (scope.fromDate) {
              expression.fromDate = scope.fromDate;
            }
            if (scope.toDate) {
              expression.toDate = scope.toDate;
            }
            return table.search(expression, "date");
          };
          scope.fromDateChanged = function(newDate) {
            if (newDate) {
              scope.fromDate = newDate;
              return _updateTable();
            }
          };
          scope.toDateChanged = function(newDate) {
            if (newDate) {
              scope.toDate = newDate;
              return _updateTable();
            }
          };
          scope.togglePopups = function(clickedFromButton) {
            if (clickedFromButton) {
              scope.showFrom = !scope.showFrom;
              return scope.showTo = false;
            } else {
              scope.showTo = !scope.showTo;
              return scope.showFrom = false;
            }
          };
          scope.selectRange = function(startDiff, endDiff) {
            var fromDate, toDate, today;
            today = new Date();
            fromDate = TimeUtilF.addDays(today, startDiff);
            toDate = TimeUtilF.addDays(today, endDiff);
            return scope.changeDates(TimeUtilF.toString(fromDate), TimeUtilF.toString(toDate));
          };
          scope.getSelectedClass = function(isSelected) {
            if (isSelected) {
              return "selected";
            }
          };
          scope.resetDates = function() {
            var toDate;
            var fromDate = scope.min;
            toDate = scope.max;
            return scope.changeDates(fromDate, toDate);
          };
          return scope.changeDates = function(fromDate, toDate) {
            scope.fromDateChanged(fromDate);
            return scope.toDateChanged(toDate);
          };
        }
      };
    }
  ];

  angular.module('app').directive('dateRangeD', dateRangeD);

}).call(this);

(function() {
  var DonutChartD = function() {
    var DEFAULT_CHART_HEIGHT, DEFAULT_CHART_WIDTH, INNER_RADIUS_FACTOR, _getInnerRadius, _getRadius, _makePieChart;
    DEFAULT_CHART_HEIGHT = 300;
    DEFAULT_CHART_WIDTH = 300;
    INNER_RADIUS_FACTOR = 0.74;
    _getInnerRadius = function(radius) {
      return radius * INNER_RADIUS_FACTOR;
    };
    _getRadius = function(width) {
      return width / 2;
    };
    _makePieChart = function(element, data, width, height, radius, totalCount, objectName) {
      var arc, g, path, pie, svg;
      svg = element.append('svg').attr('width', width).attr('height', height);
      g = svg.append('g').attr('transform', 'translate(' + (width / 2) + ',' + (height / 2) + ')');
      pie = d3.layout.pie().value(function(d) {
        return d.percent;
      }).sort(null);
      arc = d3.svg.arc().innerRadius(_getInnerRadius(radius)).outerRadius(radius);
      path = g.selectAll('path').data(pie(data)).enter().append('path').attr('d', arc).attr('fill', function(d, i) {
        return d.data.color;
      });
      if (totalCount) {
        g.append('text').text(totalCount).attr('x', 0).attr('y', -5).attr('text-anchor', 'middle').attr('class', 'count');
      }
      if (objectName) {
        return g.append('text').text(objectName).attr('x', 0).attr('y', 15).attr('text-anchor', 'middle').attr('class', 'object-name');
      }
    };
    return {
      restrict: 'E',
      templateUrl: 'directives/donutChart.html',
      scope: {
        'parts': '=',
        'objectName': '@',
        'totalCount': '=',
        'hasLegend': '=',
        'width': '=',
        'height': '='
      },
      link: function($scope, $elem, $attrs) {
        var chartContainer, chartContent, height, radius, width;
        width = $scope.width || DEFAULT_CHART_WIDTH;
        height = $scope.height || DEFAULT_CHART_HEIGHT;
        radius = _getRadius(width);
        chartContainer = d3.select($elem[0]);
        chartContent = chartContainer.select("#chart-content");
        return _makePieChart(chartContent, $scope.parts, width, height, radius, $scope.totalCount, $scope.objectName);
      }
    };
  };

  angular.module('app').directive('donutChartD', DonutChartD);

}).call(this);

(function() {
  var DriverMapMarkersD = function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        drivers: '='
      },
      templateUrl: 'directives/driverMapMarkers.html'
    };
  };

  angular.module('app').directive('driverMapMarkersD', DriverMapMarkersD);

}).call(this);

(function() {
  var DropdownD = function(Constants) {
    var OFFSET_X, OFFSET_Y;
    OFFSET_X = 0;
    OFFSET_Y = 20;
    return {
      restrict: 'A',
      transclude: true,
      template: '<div id="dropdown-box"><ng-transclude /></div>',
      link: function($scope, $element, $attrs) {
        var handleClick, handleWindowClick, registerEvents, removeEvents;
        var dropdownD = $element;
        if (!dropdownD) {
          return;
        }
        handleClick = function() {
          var dropdownBox = angular.element('#dropdown-box');
          if (!dropdownD[0].classList.contains('show-dropdown')) {
            dropdownD[0].classList.add('show-dropdown');
            dropdownBox[0].style.left = "" + OFFSET_X + "px";
            dropdownBox[0].style.right = 'auto';
            dropdownBox[0].style.top = "" + OFFSET_Y + "px";
            dropdownBox[0].style.bottom = 'auto';
            return $(window).on('click', handleWindowClick);
          } else {
            dropdownD[0].classList.remove('show-dropdown');
            return $(window).off('click', handleWindowClick);
          }
        };
        handleWindowClick = function(event) {
          var isButtonClick = $(event.target).closest('.dropdown-directive').length;
          if (!isButtonClick) {
            if (dropdownD[0].classList.contains('show-dropdown')) {
              dropdownD[0].classList.remove('show-dropdown');
              return $(window).off('click', handleWindowClick);
            }
          }
        };
        registerEvents = function() {
          $element.on('click', handleClick);
          return $(window).on('click', handleWindowClick);
        };
        removeEvents = function() {
          $element.off('click', handleClick);
          return $(window).off('click', handleWindowClick);
        };
        registerEvents();
        return $scope.$on('$destroy', function() {
          return removeEvents();
        });
      }
    };
  };
  DropdownD.$inject = ["Constants"];

  angular.module('app').directive('dropdownD', DropdownD);

}).call(this);

(function() {
  var EditableTextD = function(EventListenersF, Events) {
    var _isDuplicate;
    _isDuplicate = function(text, list) {
      var current, _i, _len;
      for (_i = 0, _len = list.length; _i < _len; _i++) {
        current = list[_i];
        if (current.name.trim().toLowerCase() === text) {
          return true;
        }
      }
      return false;
    };
    return {
      restrict: 'E',
      templateUrl: 'directives/editableTextD.html',
      scope: {
        text: '=',
        list: '=',
        textUpdated: '&',
        cancelled: '&'
      },
      link: function(scope, element, attrs, ctrls) {
        var onCancelled, onTextUpdated;
        scope.editMode = !scope.text;
        scope.output = _.clone(scope.text);
        onTextUpdated = scope.textUpdated();
        onCancelled = scope.cancelled();
        scope.updateText = function(text) {
          if (_isDuplicate(text.trim().toLowerCase(), scope.list)) {
            return scope.form.property.$setValidity('duplicate', false);
          } else {
            scope.form.property.$setValidity('duplicate', true);
            if (scope.text !== text) {
              onTextUpdated(text);
            }
            return scope.editMode = false;
          }
        };
        scope.cancelEdit = function() {
          scope.form.property.$setValidity('duplicate', true);
          scope.output = _.clone(scope.text);
          onCancelled();
          return scope.editMode = false;
        };
        return EventListenersF.addEventListener(Events.CSV_MAP_CLOSED, function() {
          var newText = scope.output;
          if (!newText || (scope.text !== newText && !_isDuplicate(newText.trim().toLowerCase(), scope.list))) {
            onTextUpdated(newText);
          }
          return scope.editMode = false;
        });
      }
    };
  };
  EditableTextD.$inject = ["EventListenersF", "Events"];

  angular.module('app').directive('editableTextD', EditableTextD);

}).call(this);

(function() {
  var VariableTableHeightD = function($window) {
    var PADDING_TOP, PAGINATION_FOOTER_HEIGHT, _updateElementHeight;
    PADDING_TOP = 120;
    PAGINATION_FOOTER_HEIGHT = 100;
    _updateElementHeight = function(element, windowHeight) {
      var height = "" + (windowHeight - PADDING_TOP - PAGINATION_FOOTER_HEIGHT) + "px";
      return element.css('height', height);
    };
    return {
      link: function($scope, $element) {
        _updateElementHeight($element, $window.innerHeight);
        return angular.element($window).bind('resize', function() {
          return _updateElementHeight($element, $window.innerHeight);
        });
      }
    };
  };
  VariableTableHeightD.$inject = ["$window"];

  angular.module('app').directive('variableTableHeightD', VariableTableHeightD);

}).call(this);

(function() {
  var GpsMarkerD = function($translate, $state, SvgMarkerF, GMarkerF, ScrollToS, Events, EventListenersF) {
    return {
      restrict: 'E',
      replace: false,
      require: '^mapD',
      scope: {
        driver: '=',
        routeInfo: '=',
        marker: '=',
        markerType: '@markerType'
      },
      link: function($scope, $elem, $attrs, $mapD) {
        var FIVE_MINUTE, driverId, map, marker, _isOffline, _offlineTimer, _savedFillCss, _visible;
        FIVE_MINUTE = 5 * 60 * 1000;
        _isOffline = false;
        _offlineTimer = null;
        _savedFillCss = $scope.routeInfo.fill;
        _visible = false;
        map = $mapD.getMap();
        marker = new SvgMarkerF($scope.driver.startLocation.info.coords, SvgMarkerF.markers.driverGps, map);
        marker.setVisible(false);
        marker.setFillCss($scope.routeInfo.fill);
        driverId = $scope.driver.id;
        $scope.$on('$destroy', function() {
          return marker.remove();
        });
        return EventListenersF.addEventListener(Events.DRIVER_GPS_LOCATION_UPDATED(driverId), function(_arg) {
          var timestamp;
          var nextLocation = _arg.nextLocation, timestamp = _arg.timestamp;
          if (_offlineTimer != null) {
            clearTimeout(_offlineTimer);
          }
          if (_isOffline) {
            _isOffline = false;
            marker.setFillCss(_savedFillCss);
          }
          _offlineTimer = setTimeout((function() {
            marker.setFillCss('colorDriverUnserved');
            return _isOffline = true;
          }), FIVE_MINUTE);
          if (!_visible) {
            setTimeout(function() {
              $(marker.div).addClass('gps-driver-marker');
              marker.setPosition({
                lat: nextLocation.lat,
                lng: nextLocation.lng
              });
              marker.setVisible(true);
              marker.setText('Driver is offline');
              return _visible = true;
            });
            return;
          }
          return marker.animateTo(new google.maps.LatLng(nextLocation.lat, nextLocation.lng), {
            duration: 300,
            easing: 'linear'
          });
        });
      }
    };
  };
  GpsMarkerD.$inject = ["$translate", "$state", "SvgMarkerF", "GMarkerF", "ScrollToS", "Events", "EventListenersF"];

  angular.module('app').directive('gpsMarkerD', GpsMarkerD);

}).call(this);

(function() {
  var InfoTooltipD = function() {
    return {
      restrict: 'E',
      template: '<div class="info-tooltip-icon" tooltip-class="info-tooltip" tooltip-d={{message}} small-offset="true"><div ng-include="\'/img/info.svg\'"></div></div>',
      scope: {
        message: "@"
      }
    };
  };

  angular.module('app').directive('infoTooltipD', InfoTooltipD);

}).call(this);

(function() {
  var IntlTelD = function() {
    return {
      replace: true,
      restrict: 'E',
      require: 'ngModel',
      template: "<input type='tel' class='form-control' placeholder='optional'>",
      link: function($scope, $elem, $attrs, ngModel) {
        var read = function() {
          var selectedCountry, value;
          value = $elem.val();
          if ((value != null ? value.length : void 0) > 0 && value[0] !== '+') {
            selectedCountry = $elem.intlTelInput('getSelectedCountryData');
            value = '+' + selectedCountry.dialCode + value;
          }
          return ngModel.$setViewValue(value);
        };
        $elem.intlTelInput({
          defaultCountry: 'us',
          nationalMode: true
        });
        $elem.on('focus blur keyup change', function() {
          return $scope.$apply(read);
        });
        $elem.on('$destroy', function() {
          $elem.intlTelInput('destroy');
          return $elem.off('blur keyup change');
        });
        return read();
      }
    };
  };

  angular.module('app').directive('intlTel', IntlTelD);

}).call(this);

(function() {
  var intlTelInputD = function($http, EventListenersF, Events, GeoIpF) {
    return {
      restrict: 'E',
      require: 'ngModel',
      template: '<input type="tel">',
      replace: true,
      link: function(scope, elem, attr, ngModelCtrl) {
        var options, watchElem, watchValue, _initialValiditySet, _initialized;
        _initialized = false;
        _initialValiditySet = false;
        options = {
          initialCountry: 'auto',
          utilsScript: 'assets/utils.js',
          geoIpLookup: function(cb) {
            return GeoIpF.getCountry().then(function(country) {
              if (_.isEmpty(elem.intlTelInput('getSelectedCountryData'))) {
                elem.intlTelInput('setCountry', country != null ? country.toLowerCase() : void 0);
              }
              return cb(country);
            });
          }
        };
        elem.intlTelInput(options);
        elem.on('focusout', function() {
          var formatted = elem.intlTelInput('getNumber');
          elem.intlTelInput('setNumber', formatted);
          return ngModelCtrl.$setViewValue(formatted);
        });
        elem.on('keyup', function() {
          var isValid;
          if (!ngModelCtrl.$modelValue) {
            return ngModelCtrl.$setValidity('pattern', true);
          } else {
            isValid = elem.intlTelInput('isValidNumber');
            ngModelCtrl.$setValidity('pattern', isValid);
            ngModelCtrl.$setViewValue(elem.intlTelInput('getNumber'));
            if (isValid) {
              return EventListenersF.notify(Events.VISIT_PHONE_VALIDATED);
            }
          }
        });
        watchValue = function() {
          return ngModelCtrl.$modelValue;
        };
        scope.$watch(watchValue, function(newValue) {
          if (!_initialized && newValue) {
            _initialized = true;
            return elem.intlTelInput('setNumber', newValue);
          }
        });
        watchElem = function() {
          return elem.intlTelInput('getNumber');
        };
        return scope.$watch(watchElem, function(newVal) {
          if (!_initialValiditySet && newVal && typeof newVal === 'string') {
            _initialValiditySet = true;
            ngModelCtrl.$setViewValue(elem.intlTelInput('getNumber'));
            return ngModelCtrl.$setValidity('pattern', elem.intlTelInput('isValidNumber'));
          }
        });
      }
    };
  };
  intlTelInputD.$inject = ["$http", "EventListenersF", "Events", "GeoIpF"];

  angular.module('app').directive('intlTelInput', intlTelInputD);

}).call(this);

(function() {
  var MapDrawingD = function($interval, EventListenersF, Events, GMarkerF, AccountF, ProjectF, MessagingF, FeatureFlagF) {
    return {
      restrict: 'E',
      replace: false,
      require: '^mapD',
      scope: {
        id: '=',
        coords: '=',
        options: '='
      },
      link: function($scope, $elem, $attrs, $mapD) {
        var all_overlays, currentDrawnCoordinates, drawingManager, map, _canLasso, _deleteAllShape, _findMarkers, _parsePolygonCoordinates, _resetLassoMarkers, _selectMarkers;
        all_overlays = {};
        currentDrawnCoordinates = [];
        _deleteAllShape = function() {
          var i = 0;
          while (i < all_overlays.length) {
            all_overlays[i].setMap(null);
            i++;
          }
          all_overlays = [];
        };
        _resetLassoMarkers = function(closeSidePanel) {
          _deleteAllShape();
          GMarkerF.clearAllStyles();
          GMarkerF.closeOtherWindow();
          if (closeSidePanel) {
            return EventListenersF.notify(Events.REASSIGN_PANEL_CLOSED);
          }
        };
        _parsePolygonCoordinates = function(polygonCoordinates) {
          var item, lat, lng, polygonCoordinatesFixed;
          polygonCoordinatesFixed = [];
          for (item in polygonCoordinates) {
            lat = polygonCoordinates[item].lat();
            lng = polygonCoordinates[item].lng();
            polygonCoordinatesFixed.push({
              lat: lat,
              lng: lng
            });
          }
          return polygonCoordinatesFixed;
        };
        _selectMarkers = function(drawnPolgon) {
          var projectStatusInterval, _checkMarkers;
          var lassoMarkers = [];
          _checkMarkers = (function(_this) {
            return function() {
              var id, item, point, position, _results;
              var allMarkers = GMarkerF.getAll();
              if (Object.keys(allMarkers).length) {
                $interval.cancel(projectStatusInterval);
                _results = [];
                for (id in allMarkers) {
                  item = allMarkers[id];
                  position = item.marker.getPosition();
                  point = new google.maps.LatLng(position.lat(), position.lng());
                  if (google.maps.geometry.poly.containsLocation(point, drawnPolgon) && item.type === 'visit') {
                    GMarkerF.setLassoSelected(id, true);
                    _results.push(lassoMarkers.push(id));
                  } else {
                    _results.push(void 0);
                  }
                }
                return _results;
              }
            };
          })(this);
          projectStatusInterval = $interval(_checkMarkers, 100);
          return lassoMarkers;
        };
        _findMarkers = function(polygonCoordinates) {
          var drawnPolgon, markers, polygon;
          if (!polygonCoordinates.length) {
            return false;
          }
          currentDrawnCoordinates = polygonCoordinates;
          if (drawingManager.getDrawingMode()) {
            drawingManager.setDrawingMode(null);
          }
          GMarkerF.clearAllStyles();
          polygon = _parsePolygonCoordinates(polygonCoordinates);
          drawnPolgon = new google.maps.Polygon({
            paths: polygon
          });
          markers = _selectMarkers(drawnPolgon);
          EventListenersF.notify(Events.REASSIGN_PANEL_OPENED, markers);
        };
        _canLasso = function() {
          return FeatureFlagF.isEnabled('LassoTool');
        };
        map = $mapD.getMap();
        drawingManager = new google.maps.drawing.DrawingManager({
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_LEFT,
            drawingModes: [google.maps.drawing.OverlayType.POLYGON]
          },
          polygonOptions: {
            fillColor: '#000',
            fillOpacity: .2,
            strokeColor: '#2c3b4d',
            strokeWeight: 5,
            clickable: true,
            editable: true,
            draggable: false,
            zIndex: 1
          }
        });
        _canLasso().then(function(isEnabled) {
          if (isEnabled) {
            return drawingManager.setMap(map);
          }
        });
        google.maps.event.addListener(drawingManager, "drawingmode_changed", function(event) {
          if (drawingManager.getDrawingMode() === "polygon") {
            MessagingF.replaceInfoPopup("LASSO_SELECTION.MULTI_SELECT_ON");
            _resetLassoMarkers(true);
            EventListenersF.notify(Events.LASSO_UPDATED, false);
            return EventListenersF.notify(Events.SHRINK_GANTT_CHART);
          } else if (!drawingManager.getDrawingMode() && !all_overlays.length) {
            MessagingF.replaceInfoPopup("LASSO_SELECTION.MULTI_SELECT_OFF");
            return EventListenersF.notify(Events.EXPAND_GANTT_CHART);
          }
        });
        google.maps.event.addListener(drawingManager, 'polygoncomplete', function(event) {
          var newShape = event;
          all_overlays.push(event);
          _findMarkers(event.getPath().getArray());
          MessagingF.replaceInfoPopup("LASSO_SELECTION.MULTI_SELECT_OFF");
          EventListenersF.notify(Events.LASSO_UPDATED, true);
          google.maps.event.addListener(newShape.getPath(), 'set_at', function() {
            _findMarkers(newShape.getPath().getArray());
          });
          google.maps.event.addListener(newShape.getPath(), 'insert_at', function() {
            _findMarkers(newShape.getPath().getArray());
          });
          return google.maps.event.addListener(newShape.getPath(), 'remove_at', function() {
            _findMarkers(newShape.getPath().getArray());
          });
        });
        EventListenersF.addEventListener(Events.CLEAR_LASSO_SELECTION, (function(_this) {
          return function(closeSidePanel) {
            return _resetLassoMarkers(closeSidePanel);
          };
        })(this));
        return EventListenersF.addEventListener(Events.UPDATE_LASSO_SELECTION, (function(_this) {
          return function() {
            return _findMarkers(currentDrawnCoordinates);
          };
        })(this));
      }
    };
  };
  MapDrawingD.$inject = ["$interval", "EventListenersF", "Events", "GMarkerF", "AccountF", "ProjectF", "MessagingF", "FeatureFlagF"];

  angular.module('app').directive('mapDrawingD', MapDrawingD);

}).call(this);

(function() {
  var MapMarkerD = function($translate, $state, SvgMarkerF, GMarkerF, ScrollToS, Events, EventListenersF, DemoF, Constants, RouteInspectorF, States) {
    var _setInfo;
    _setInfo = function(marker, info, hasMultipleAddresses) {
      if (info) {
        marker.setFillCss(info.fill);
        marker.setText(info.order);
        return marker.setDriverId(info.driverId);
      } else if (hasMultipleAddresses) {
        return marker.setFillCss('colorDriverOrange');
      } else {
        marker.removeFillCss();
        return marker.setText('');
      }
    };
    return {
      restrict: 'E',
      replace: false,
      require: '^mapD',
      scope: {
        marker: '=',
        markerType: '@markerType',
        warningId: '=',
        routeInfo: '=',
        visitStatus: '=',
        onDownloadSignature: '&',
        onViewPhoto: '&'
      },
      link: function($scope, $elem, $attrs, $mapD) {
        var coords, data, eventId, hasMultipleAddresses, id, info, isVisible, map, marker, markerTemplate, onDownloadSignature, onViewPhoto, templateUrl, _handleMarkerChange, _ref, _ref1, _visitStatusTranslation;
        map = $mapD.getMap();
        markerTemplate = (function() {
          switch ($scope.markerType) {
            case 'visit':
              return SvgMarkerF.markers.visit;
            case 'liveDriverNE':
              return SvgMarkerF.markers.liveDriverNE;
            case 'liveDriverSE':
              return SvgMarkerF.markers.liveDriverSE;
            case 'liveDriverSW':
              return SvgMarkerF.markers.liveDriverSW;
            case 'liveDriverNW':
              return SvgMarkerF.markers.liveDriverNW;
            case 'driver':
              return SvgMarkerF.markers.driver;
            case 'finish':
              return SvgMarkerF.markers.finish;
          }
        })();
        coords = $scope.marker.position.coords;
        isVisible = $scope.marker.parameter.initialVisibility;
        templateUrl = $scope.marker.templateUrl;
        data = $scope.marker.parameter;
        if (((_ref = data.location) != null ? _ref.num_results : void 0) > 1 || ((_ref1 = data.location) != null ? _ref1.all_results : void 0)) {
          hasMultipleAddresses = true;
        }
        if ($scope.warningId) {
          data.warnings = RouteInspectorF.getWarnings($scope.warningId);
        }
        marker = new SvgMarkerF(coords, markerTemplate, map, isVisible, templateUrl, data);
        $scope.marker.parameter.isUsableInDemo = function() {
          return DemoF.isUsableInDemo('mapMarker');
        };
        info = $scope.routeInfo;
        _setInfo(marker, info, hasMultipleAddresses);
        id = $scope.marker.parameter.id;
        google.maps.event.addListener(marker, 'click', function() {
          var driverId;
          if (GMarkerF.isInfoWindowOpen(id)) {
            GMarkerF.forceCloseInfoWindow(id);
          } else {
            GMarkerF.toggleAndCloseOtherWindow(id);
            if ($scope.markerType === 'visit') {
              ScrollToS.scrollToVisit(id);
            } else {
              driverId = $scope.marker.parameter.parentId;
              ScrollToS.scrollToDriver(driverId);
            }
          }
          return GMarkerF.emitEvent(id, 'click');
        });
        google.maps.event.addListener(marker, 'mouseover', function() {
          return GMarkerF.emitEvent(id, 'mouseover');
        });
        google.maps.event.addListener(marker, 'mouseout', function() {
          return GMarkerF.emitEvent(id, 'mouseout');
        });
        $scope.$on('$destroy', function() {
          return GMarkerF.destroy(id);
        });
        eventId = $scope.marker.parameter.parentId || $scope.marker.parameter.id;
        EventListenersF.addEventListener(Events.VISIT_ROUTE_INFO_CHANGED(eventId), function(info) {
          return _setInfo(marker, info);
        });
        EventListenersF.addEventListener(Events.VISIT_WARNINGS_CHANGED, function(warnings) {
          if ($scope.warningId) {
            return marker.parameter.warnings = warnings[$scope.warningId];
          }
        });
        _handleMarkerChange = function(updatedMarker, positionChanged) {
          var heading, newLat, newLng, parameter, _ref2;
          newLat = updatedMarker.position.coords.lat;
          newLng = updatedMarker.position.coords.lng;
          heading = updatedMarker.parameter.heading;
          parameter = updatedMarker.parameter;
          parameter.warnings = RouteInspectorF.getWarnings($scope.warningId);
          if ((_ref2 = parameter.location) != null ? _ref2.resolved : void 0) {
            hasMultipleAddresses = false;
            marker.removeFillCss();
          }
          if (heading != null) {
            marker.setDataWithHeading(heading);
          }
          marker.setPosition({
            lat: newLat,
            lng: newLng
          });
          marker.setParameter(parameter);
          if (!positionChanged) {
            marker.remove();
            marker.redraw();
          }
          if ($state.includes(States.projectRoute)) {
            return GMarkerF.setSidepanelContent(marker, true);
          } else {
            return GMarkerF.forceCloseInfoWindow(id);
          }
        };
        _visitStatusTranslation = function(status) {
          var key = null;
          switch (status) {
            case Constants.visitStatusDone:
              key = "VISIT_COMPLETION_STATUS.DONE";
              break;
            case Constants.visitStatusSkipped:
              key = "VISIT_COMPLETION_STATUS.MISSED";
              break;
            case Constants.visitStatusPending:
              key = "VISIT_COMPLETION_STATUS.PENDING";
              break;
          }
          return $translate.instant(key);
        };
        EventListenersF.addEventListener(Events.VISIT_MARKER_CHANGED(eventId), function(updatedMarker) {
          return _handleMarkerChange(updatedMarker);
        });
        if (marker.parameter.isDriverLocation) {
          EventListenersF.addEventListener(Events.DRIVER_LOCATION_MARKER_CHANGED(eventId), function(updatedMarker) {
            return _handleMarkerChange(updatedMarker, true);
          });
        }
        onDownloadSignature = $scope.onDownloadSignature();
        onViewPhoto = $scope.onViewPhoto();
        EventListenersF.addEventListener(Events.VISIT_STATUS_CHANGED(eventId), function(visitStatus) {
          var photoUrl, signatureId;
          if (!visitStatus) {
            return;
          }
          signatureId = visitStatus.signatureId;
          photoUrl = visitStatus.photoUrl;
          if (signatureId) {
            marker.parameter.signatureId = signatureId;
            marker.parameter.downloadSignature = function() {
              return onDownloadSignature(visitStatus.signatureId, visitStatus.routeId);
            };
          }
          if (photoUrl) {
            marker.parameter.photoUrl = photoUrl;
            marker.parameter.viewPhoto = function() {
              return onViewPhoto(photoUrl);
            };
          }
          if (visitStatus.status != null) {
            marker.parameter.visitStatus = visitStatus.status;
            marker.parameter.visitStatusInfo = visitStatus.info;
            marker.parameter.isLate = visitStatus.isLate;
            marker.parameter.displayedVisitStatus = _visitStatusTranslation(visitStatus.status);
            return marker.parameter.driver = visitStatus.driver;
          }
        });
        return GMarkerF.add(id, map, marker, $mapD, $scope.markerType);
      }
    };
  };
  MapMarkerD.$inject = ["$translate", "$state", "SvgMarkerF", "GMarkerF", "ScrollToS", "Events", "EventListenersF", "DemoF", "Constants", "RouteInspectorF", "States"];

  angular.module('app').directive('mapMarkerD', MapMarkerD);

}).call(this);

(function() {
  var MapMarkerWindowD = function($compile, $http, $templateCache) {
    return {
      restrict: 'E',
      require: '^mapMarkerD',
      replace: true,
      scope: {
        'template': '=',
        'data': '='
      },
      link: function($scope, $elem, $attrs, $mapMarkerD) {
        var infoWindow, map, marker, options, _setInfoWindowContent;
        _setInfoWindowContent = function(infoWindow, content, data) {
          var compiled, templateScope;
          templateScope = $scope.$new();
          templateScope.parameter = data;
          compiled = $compile(content)(templateScope);
          return infoWindow.setContent(compiled[0]);
        };
        marker = $mapMarkerD.getMarker();
        map = marker.getMap();
        options = {
          maxWidth: 230
        };
        infoWindow = new google.maps.InfoWindow(options);
        $http.get($scope.template, {
          cache: $templateCache
        }).then(function(content) {
          var data = $attrs.data != null ? $scope.data : void 0;
          return _setInfoWindowContent(infoWindow, content.data, data);
        });
        google.maps.event.addListener(marker, 'click', function() {
          return infoWindow.open(map, marker);
        });
        return $scope.$watch('data.infoVisible', function(isVisible) {
          if (isVisible) {
            return infoWindow.open(map, marker);
          } else {
            return infoWindow.close();
          }
        });
      }
    };
  };
  MapMarkerWindowD.$inject = ["$compile", "$http", "$templateCache"];

  angular.module('app').directive('mapMarkerWindowD', MapMarkerWindowD);

}).call(this);

(function() {
  var MapPolylineD = function(GPolylineF, DriverF, EventListenersF, Events, $interval, $q) {
    var _generatePath;
    _generatePath = function(coords) {
      return coords.map(function(coord) {
        return new google.maps.LatLng(coord.latitude, coord.longitude);
      });
    };
    return {
      restrict: 'E',
      replace: false,
      require: '^mapD',
      scope: {
        id: '=',
        coords: '=',
        options: '='
      },
      link: function($scope, $elem, $attrs, $mapD) {
        var defaultOptions, id, isVisible, map, options, path, polyline, _ref;
        path = _generatePath($scope.coords);
        defaultOptions = {
          clickable: false,
          draggable: false,
          editable: false,
          geodesic: true,
          path: path,
          strokeColor: '#FF0000',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          map: null
        };
        options = _.merge(defaultOptions, $scope.options || {});
        polyline = new google.maps.Polyline(options);
        map = $mapD.getMap();
        polyline.setMap(map);
        id = $scope.id;
        $scope.$on('$destroy', function() {
          return GPolylineF.destroy(id);
        });
        GPolylineF.add(id, polyline);
        isVisible = (_ref = DriverF.getDriver(id)) != null ? _ref.getVisible() : void 0;
        if (isVisible == null) {
          isVisible = true;
        }
        GPolylineF.setVisible(id, isVisible);
        $scope.$watch('coords', function(newCoords) {
          path = _generatePath(newCoords);
          return polyline.setPath(path);
        });
        return $scope.$watch('options', function(newOptions) {
          return polyline.setOptions(newOptions);
        });
      }
    };
  };
  MapPolylineD.$inject = ["GPolylineF", "DriverF", "EventListenersF", "Events", "$interval", "$q"];

  angular.module('app').directive('mapPolylineD', MapPolylineD);

}).call(this);

(function() {
  var MessageD = function($compile, $timeout, MessagingF) {
    var _switchTemplate;
    _switchTemplate = function(elem, attr) {
      var _ref;
      if ((_ref = attr.options) != null ? _ref.top : void 0) {
        return 'directives/messageTop.html';
      } else {
        return 'directives/message.html';
      }
    };
    return {
      restrict: 'E',
      scope: {
        type: '=',
        index: '=',
        content: '=',
        style: '=',
        closingText: '=',
        action: '=',
        options: '=?',
        offset: "=?"
      },
      replace: false,
      transclude: false,
      templateUrl: _switchTemplate,
      compile: function(elem, attr) {
        return {
          pre: function(scope, elem) {
            var READING_TIME, READING_TIME_PER_CHAR_IN_MS, SIX_SECONDS_IN_MS, THREE_SECONDS_IN_MS, content, delayTime, message, target, _ref;
            message = scope.content || '';
            THREE_SECONDS_IN_MS = 3000;
            SIX_SECONDS_IN_MS = 6000;
            READING_TIME_PER_CHAR_IN_MS = 50;
            READING_TIME = message.length * READING_TIME_PER_CHAR_IN_MS;
            delayTime = ((_ref = attr.options) != null ? _ref.top : void 0) ? SIX_SECONDS_IN_MS + READING_TIME : THREE_SECONDS_IN_MS + READING_TIME;
            content = $compile("<span>" + message + "</span>")(scope);
            target = elem.find("span.text-content");
            target.append(content);
            scope.containerClass = scope.options.overlay ? 'message-overlay' : 'message-container';
            switch (scope.type) {
              case MessagingF.Type.SUCCESS:
                scope.iconClass = 'icon-checkmark';
                break;
              case MessagingF.Type.INFORMATION:
                scope.iconClass = 'icon-info-alt';
                break;
              case MessagingF.Type.ERROR:
                scope.iconClass = 'icon-alert';
                break;
              case MessagingF.Type.LOADING:
              case MessagingF.Type.WARNING:
              case MessagingF.Type.CONFIRM:
                scope.iconClass = 'icon-warning-alt';
            }
            if ((scope.style === MessagingF.Style.POPUP) && (scope.type !== MessagingF.Type.LOADING)) {
              if (scope.offset) {
                scope.style += ' offset';
              }
              $timeout((function() {
                return scope.remove();
              }), delayTime);
            }
          }
        };
      },
      controller: ["$scope", function($scope) {
        var _removeMessage;
        _removeMessage = function() {
          return MessagingF.removeMessageAt($scope.index);
        };
        $scope.next = function() {
          if ($scope.action) {
            $scope.action();
          }
          return _removeMessage();
        };
        return $scope.remove = _removeMessage;
      }]
    };
  };
  MessageD.$inject = ["$compile", "$timeout", "MessagingF"];

  angular.module('app').directive('messageD', MessageD);

}).call(this);

(function() {
  var MiniMapD = function($timeout, MapStyleC, MiniMapF) {
    var _focus;
    _focus = function(controller, markers) {
      var bound;
      if ((markers != null ? markers.length : void 0) > 1) {
        bound = controller.calculateLatLngBound(markers);
        return controller.panToBounds(bound, 0, 0, 1);
      } else if ((markers != null ? markers.length : void 0) === 1) {
        return controller.center(markers[0].lat, markers[0].lng, 0, 0, 14);
      }
    };
    return {
      restrict: 'E',
      replace: false,
      transclude: true,
      scope: {
        markers: "=",
        setSelected: "=",
        selectedId: "="
      },
      template: '<div class="map-mini"></div><ng-transclude />',
      link: {
        pre: function($scope, $elem, $attrs) {
          var mapContainer;
          var element = MiniMapF.getElement();
          mapContainer = $elem.find(".map-mini")[0];
          return mapContainer.appendChild(element);
        },
        post: function($scope, $elem, $attrs) {
          var markers;
          var map = MiniMapF.getInstance();
          markers = _.clone($scope.markers);
          google.maps.event.addDomListenerOnce(map, 'resize', function() {
            return _focus(MiniMapF, markers);
          });
          return $timeout(function() {
            return google.maps.event.trigger(map, 'resize');
          });
        }
      },
      controller: ["$scope", function($scope) {
        var watchId, watchMarker, _markers;
        _markers = {};
        this.getMap = MiniMapF.getInstance;
        this.center = function(lat, lng, x, y) {
          if (x == null) {
            x = 0;
          }
          if (y == null) {
            y = 0;
          }
          return MiniMapF.center(lat, lng, x, y, null);
        };
        this.setSelected = function(data) {
          $scope.setSelected(data.id);
          return this.center(data.lat, data.lng);
        };
        this.addMarker = function(id, marker) {
          if ($scope.selectedId === id) {
            google.maps.event.trigger(marker, 'selected');
          }
          return _markers[id] = marker;
        };
        this.unselectAll = function() {
          var markers, _, _results;
          _results = [];
          for (_ in _markers) {
            markers = _markers[_];
            _results.push(google.maps.event.trigger(markers, 'unselected'));
          }
          return _results;
        };
        this.clearMarkers = function() {
          var marker, _;
          for (_ in _markers) {
            marker = _markers[_];
            marker.setMap(null);
          }
          return _markers = {};
        };
        watchMarker = $scope.$watch('markers', (function(_this) {
          return function(newVal, oldVal) {
            var map;
            if (newVal !== oldVal) {
              _this.clearMarkers();
              map = _this.getMap();
              google.maps.event.addDomListenerOnce(map, 'resize', function() {
                return _focus(MiniMapF, newVal);
              });
              return $timeout(function() {
                return google.maps.event.trigger(map, 'resize');
              });
            }
          };
        })(this));
        watchId = $scope.$watch('selectedId', (function(_this) {
          return function(newVal, oldVal) {
            var position;
            if (newVal !== oldVal && (newVal != null)) {
              _this.unselectAll();
              if (_markers[newVal] != null) {
                position = _markers[newVal].position;
                _this.center(position.lat(), position.lng());
                return google.maps.event.trigger(_markers[newVal], 'selected');
              }
            }
          };
        })(this));
        return $scope.$on('$destroy', (function(_this) {
          return function() {
            _this.clearMarkers();
            watchMarker();
            return watchId();
          };
        })(this));
      }]
    };
  };
  MiniMapD.$inject = ["$timeout", "MapStyleC", "MiniMapF"];

  angular.module('app').directive('miniMapD', MiniMapD);

}).call(this);

(function() {
  var NotificationD = function($compile, $templateRequest, $rootScope, Constants, GMarkerF, EventListenersF, Events) {
    return {
      restrict: 'E',
      replace: false,
      templateUrl: 'notifications/notification.html',
      scope: {
        notification: '=',
        onDownloadSignature: "&",
        onViewPhoto: "&"
      },
      link: function($scope, $elem, $attrs) {
        var onDownloadSignature, onViewPhoto, _getIconClass;
        var notification = $scope.notification;
        _getIconClass = function() {
          switch (notification.type) {
            case Constants.notificationTypes.visitDone:
              return 'icon-checkmark';
            case Constants.notificationTypes.visitSkipped:
              return 'icon-cross';
            case Constants.notificationTypes.breakDone:
              return 'icon-break';
            case Constants.notificationTypes.visitDoneLate:
              return 'icon-late';
          }
        };
        $scope.selectVisit = function(visitId) {
          GMarkerF.toggleAndCloseOtherWindow(visitId);
          return EventListenersF.notify(Events.SIDE_PANEL_OPENED_FROM_NOTIFICATION);
        };
        onDownloadSignature = $scope.onDownloadSignature();
        onViewPhoto = $scope.onViewPhoto();
        $scope.downloadSignature = function() {
          return onDownloadSignature(notification.signatureId, notification.routeId);
        };
        $scope.viewPhoto = function() {
          return onViewPhoto(notification.photoUrl);
        };
        return $scope.iconClass = _getIconClass();
      }
    };
  };
  NotificationD.$inject = ["$compile", "$templateRequest", "$rootScope", "Constants", "GMarkerF", "EventListenersF", "Events"];

  angular.module('app').directive('notificationD', NotificationD);

}).call(this);

(function() {
  var OnboardingListElementD = function() {
    return {
      restrict: 'E',
      templateUrl: 'directives/onboardingListElement.html',
      scope: {
        enabled: '=',
        listItems: '=',
        titleText: '=',
        activeListIndex: '=',
        hasProgressBar: '=',
        progressIndex: '=',
        progressCount: '=',
        style: '=',
        completed: '=',
        completedClass: '=',
        completedTitle: '=',
        completedListItems: '=',
        description: '=',
        image: '='
      },
      link: function(scope, element, attrs) {
        var _i, _ref, _results;
        scope.getListItems = function() {
          if (scope.completed && (scope.completedListItems != null)) {
            return scope.completedListItems;
          } else {
            return scope.listItems;
          }
        };
        scope.getClasses = function() {
          var classes = [scope.style];
          if (scope.completed && (scope.completedClass != null)) {
            classes.push(scope.completedClass);
          }
          return classes;
        };
        return scope.progressBarRange = (function() {
          _results = [];
          for (var _i = 0, _ref = scope.progressCount - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; 0 <= _ref ? _i++ : _i--){ _results.push(_i); }
          return _results;
        }).apply(this);
      }
    };
  };

  angular.module('app').directive('onboardingListElementD', OnboardingListElementD);

}).call(this);

(function() {
  var OnboardingPopupTourD = function($sce, $translate, AnalyticsS, $timeout) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'directives/onboardingPopup.html',
      scope: {
        enabled: '=',
        steps: '=',
        onFinishCallback: '&onFinishCallback',
        onSkipCallback: '&onSkipCallback',
        index: '=index',
        style: '=',
        showSkipButton: '=',
        hasProgressBar: '=',
        showBackButton: '='
      },
      link: function(scope, element, attrs) {
        var BOTTOM, HEIGHT, LEFT, POSITION, RIGHT, TITLE, TOP, WIDTH, attributesToClear, curStep, setupOverlay, setupPositioning, _redraw;
        TITLE = 'title';
        TOP = 'top';
        RIGHT = 'right';
        BOTTOM = 'bottom';
        LEFT = 'left';
        WIDTH = 'width';
        HEIGHT = 'height';
        POSITION = 'position';
        scope.closeButtonText = $translate.instant("ONBOARDING.CLOSE_BUTTON_TEXT");
        scope.nextButtonText = $translate.instant("ONBOARDING.NEXT_BUTTON_TEXT");
        scope.previousButtonText = $translate.instant("ONBOARDING.PREVIOUS_BUTTON_TEXT");
        scope.doneButtonText = $translate.instant("ONBOARDING.DONE_BUTTON_TEXT");
        curStep = null;
        attributesToClear = [TITLE, TOP, RIGHT, BOTTOM, LEFT, WIDTH, HEIGHT, POSITION];
        scope.stepCount = scope.steps.length;
        scope.next = function() {
          AnalyticsS.track_force('030 Continue onboarding', {
            index: scope.index + 1
          });
          return scope.index = scope.index + 1;
        };
        scope.previous = function() {
          return scope.index = scope.index - 1;
        };
        scope.close = function() {
          var finishCb;
          AnalyticsS.track_force('031 Finish onboarding');
          scope.enabled = false;
          setupOverlay(false);
          finishCb = scope.onFinishCallback();
          if (finishCb) {
            return finishCb();
          }
        };
        scope.skip = function() {
          var finishCb, skipCb;
          AnalyticsS.track_force('003 Skip onboarding');
          scope.enabled = false;
          setupOverlay(false);
          skipCb = scope.onSkipCallback();
          finishCb = scope.onFinishCallback();
          if (skipCb) {
            return skipCb();
          } else if (finishCb) {
            return finishCb();
          }
        };
        scope.$watch('enabled', function(enabled) {
          if (enabled) {
            return $timeout(_redraw, 0);
          }
        });
        scope.$watch('index', function(newVal, oldVal) {
          if (newVal === null) {
            scope.enabled = false;
            setupOverlay(false);
            return;
          }
          return _redraw();
        });
        _redraw = function() {
          var attr, k, v, _i, _len;
          curStep = scope.steps[scope.index];
          scope.isLastStep = scope.index + 1 === scope.steps.length;
          scope.isNextButtonVisible = scope.index + 1 < scope.steps.length;
          scope.isPreviousButtonVisible = (scope.index > 0) && ((curStep.showBackButton == null) || curStep.showBackButton);
          for (_i = 0, _len = attributesToClear.length; _i < _len; _i++) {
            attr = attributesToClear[_i];
            scope[attr] = null;
          }
          for (k in curStep) {
            v = curStep[k];
            scope[k] = v;
          }
          setupOverlay();
          return setupPositioning();
        };
        setupOverlay = function(showOverlay) {
          if (showOverlay == null) {
            showOverlay = true;
          }
          $('.onboarding-focus').removeClass('onboarding-focus');
          if (showOverlay && curStep['attachTo'] && scope.overlay) {
            return $(curStep['attachTo']).addClass('onboarding-focus');
          }
        };
        setupPositioning = function() {
          var bottom, left, right, top, xMargin, yMargin;
          var attachTo = curStep['attachTo'];
          scope[POSITION] = curStep['position'];
          xMargin = 15;
          yMargin = 15;
          scope.arrowLeftOffset = curStep['arrowLeftOffset'];
          if (attachTo && ($(attachTo).offset() != null)) {
            if (!(scope[LEFT] || scope[RIGHT])) {
              left = null;
              right = null;
              if (scope[POSITION] === 'right') {
                left = $(attachTo).offset().left + $(attachTo).outerWidth() + xMargin;
              } else if (scope[POSITION] === 'left') {
                right = $(window).width() - $(attachTo).offset().left + xMargin;
              } else if (scope[POSITION] === 'top' || scope[POSITION] === 'bottom') {
                left = $(attachTo).offset().left;
              }
              if (curStep['xOffset']) {
                if (left !== null) {
                  left = left + curStep['xOffset'];
                }
                if (right !== null) {
                  right = right - curStep['xOffset'];
                }
              }
              scope[LEFT] = left;
              scope[RIGHT] = right;
            }
            if (!(scope[TOP] || scope[BOTTOM])) {
              top = null;
              bottom = null;
              if (scope[POSITION] === 'left' || scope[POSITION] === 'right') {
                top = $(attachTo).offset().top;
              } else if (scope[POSITION] === 'bottom') {
                top = $(attachTo).offset().top + $(attachTo).outerHeight() + yMargin;
              } else if (scope[POSITION] === 'top') {
                bottom = $(window).height() - $(attachTo).offset().top + yMargin;
              }
              if (curStep['yOffset']) {
                if (top !== null) {
                  top = top + curStep['yOffset'];
                }
                if (bottom !== null) {
                  bottom = bottom - curStep['yOffset'];
                }
              }
              scope[TOP] = top;
              scope[BOTTOM] = bottom;
            }
          }
          if (scope[POSITION] && scope[POSITION].length) {
            return scope.positionClass = "onboarding-" + scope[POSITION];
          } else {
            return scope.positionClass = null;
          }
        };
        if (scope.steps.length && !scope.index) {
          return scope.index = 0;
        }
      }
    };
  };
  OnboardingPopupTourD.$inject = ["$sce", "$translate", "AnalyticsS", "$timeout"];

  angular.module('app').directive('onboardingPopupTourD', OnboardingPopupTourD);

}).call(this);

(function() {
  var ScrollShadowD = function() {
    return {
      template: "<div><ng-transclude /></div>",
      transclude: true,
      replace: true,
      link: function(scope, element) {
        var watchValue, _addClass;
        _addClass = function() {
          if (element[0].scrollHeight !== element[0].clientHeight) {
            return angular.element(element).addClass('dynamic-bottom-shadow');
          }
        };
        watchValue = function() {
          return element[0].scrollHeight;
        };
        scope.$watch(watchValue, function(newVal, oldVal) {
          if (newVal !== oldVal) {
            return _addClass();
          }
        });
        return angular.element(window).bind('resize', function() {
          return _addClass();
        });
      }
    };
  };

  angular.module('app').directive('scrollShadowD', ScrollShadowD);

}).call(this);

(function() {
  var SelectD, SelectDrivers, appModule, selectDropdown;

  selectDropdown = function(templateUrl) {
    return {
      restrict: 'E',
      templateUrl: templateUrl,
      replace: false,
      scope: {
        'name': '@',
        'allowBlank': '=',
        'options': '=',
        'groupby': '@',
        'output': '@',
        'selected': '=',
        'placeholder': '@',
        'required': '@'
      },
      link: function($scope, $elem, $attrs) {
        var items, key, option, _i, _len, _ref;
        $scope.isRequired = !($attrs.required == null) && $attrs.required !== 'false';
        items = {};
        _ref = $scope.options;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          option = _ref[_i];
          key = $scope.groupby ? option[$scope.groupby] : null;
          if (items[key] == null) {
            items[key] = [];
          }
          items[key].push(option);
        }
        $scope.items = items;
        $scope.toggleDropdown = function(event) {
          event.stopPropagation();
          return $scope.selectionVisible = !$scope.selectionVisible;
        };
        $scope.select = function(item, event) {
          event.stopPropagation();
          $scope.selected = item;
          $scope.selectionVisible = false;
        };
        return $scope.$on('dropdownClose', function() {
          return $scope.selectionVisible = false;
        });
      }
    };
  };

  SelectD = function() {
    return selectDropdown('directives/select.html');
  };

  SelectDrivers = function() {
    return selectDropdown('directives/selectDrivers.html');
  };

  appModule = angular.module('app');

  appModule.directive('selectD', SelectD);

  appModule.directive('selectDrivers', SelectDrivers);

}).call(this);

(function() {
  var SimpleMarkerD = function(SvgMarkerF) {
    return {
      restrict: 'E',
      replace: false,
      require: '^miniMapD',
      scope: {
        marker: '='
      },
      link: function($scope, $elem, $attrs, $miniMapD) {
        return google.maps.event.addDomListenerOnce($miniMapD.getMap(), 'resize', function() {
          var clickEvent, data, map, marker, selectedEvent, unselectedEvent;
          map = $miniMapD.getMap();
          data = $scope.marker;
          marker = new SvgMarkerF(data, SvgMarkerF.markers.visit, map, true, null, null);
          marker.setFillCss(data.fill);
          clickEvent = google.maps.event.addListener(marker, 'click', function() {
            return $miniMapD.setSelected(data);
          });
          selectedEvent = google.maps.event.addListener(marker, 'selected', function() {
            return marker.setSelected(true);
          });
          unselectedEvent = google.maps.event.addListener(marker, 'unselected', function() {
            return marker.setSelected(false);
          });
          $miniMapD.addMarker(data.id, marker);
          return $scope.$on('$destroy', function() {
            google.maps.event.removeListener(clickEvent);
            google.maps.event.removeListener(selectedEvent);
            return google.maps.event.removeListener(unselectedEvent);
          });
        });
      }
    };
  };
  SimpleMarkerD.$inject = ["SvgMarkerF"];

  angular.module('app').directive('simpleMarkerD', SimpleMarkerD);

}).call(this);

(function() {
  var SpinnerD = function() {
    return {
      restrict: 'E',
      templateUrl: 'directives/spinner.html',
      scope: {
        text: '@?'
      }
    };
  };

  angular.module('app').directive('spinnerD', SpinnerD);

}).call(this);

(function() {
  var textSearchBoxD = function() {
    return {
      restrict: 'E',
      scope: {
        placeholder: "@",
        value: '=',
        onUpdate: '&',
        style: '@'
      },
      template: '<span class="search-box"> <span ng-if="focused && queryLength < 3 && queryLength > 0" class="tooltip {{arrow}}"> Type {{ 3 - queryLength }} more {{ queryLength > 1? "character" : "characters"}} </span> <input placeholder="{{placeholder}}" ng-focus="focused = true" type="text" ng-model="value" /> <span ng-if="queryLength > 0" ng-click="clearSearch()" class="clear-search">CLEAR SEARCH</span> </span>',
      replace: true,
      link: function(scope, elem, attrs) {
        var handleValue, searchTimeout;
        var DELAY = 500;
        searchTimeout = void 0;
        if (scope.style === 'top') {
          scope.arrow = 'arrow-top';
        } else {
          scope.arrow = 'arrow-bottom';
        }
        scope.clearSearch = function() {
          return scope.value = "";
        };
        handleValue = function(value) {
          scope.queryLength = value.length;
          scope.$apply();
          if (value.length < 3 && value.length > 0) {
            return;
          }
          return scope.onUpdate()(value);
        };
        return scope.$watch("value", function(newValue, oldValue) {
          if (newValue === oldValue) {
            return;
          }
          if (scope.onUpdate != null) {
            if (searchTimeout) {
              clearTimeout(searchTimeout);
            }
            return searchTimeout = setTimeout(function() {
              return handleValue(newValue);
            }, DELAY);
          }
        });
      }
    };
  };

  angular.module('app').directive('textSearchBoxD', textSearchBoxD);

}).call(this);

(function() {
  var timePickerD = function($compile, $parse, $document, dateFilter, $dateParser, TimeUtilF) {
    var HOURS_IN_DAY, HOUR_SEPARATOR, MINUTES_IN_HOUR, TIME_FORMAT;
    MINUTES_IN_HOUR = 60;
    HOURS_IN_DAY = 24;
    HOUR_SEPARATOR = ":";
    TIME_FORMAT = 'HH:mm';
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        ngModel: '='
      },
      link: function(scope, element, attrs, ctrls) {
        var _calculateExtraDays, _getHour, _getMinutes, _getUpdatedDate, _parseTime, _prependZeros, _replaceHour, _setCurrentValue;
        var current = null;
        scope.element = null;
        _getUpdatedDate = function(date, extraDays) {
          var defaultDate;
          if (extraDays == null) {
            extraDays = 0;
          }
          defaultDate = TimeUtilF.DEFAULT_DATE;
          if (!current) {
            current = angular.isDate(scope.ngModel) ? scope.ngModel : new Date(defaultDate);
          }
          current.setDate(defaultDate.getDate() + extraDays);
          current.setHours(date.getHours());
          current.setMinutes(date.getMinutes());
          current.setSeconds(date.getSeconds());
          _setCurrentValue(current);
          return current;
        };
        _setCurrentValue = function(value) {
          if (value && !angular.isDate(value)) {
            value = $dateParser(scope.ngModel, TIME_FORMAT);
            if (isNaN(value)) {
              console.error("Failed to parse model.");
            }
          }
          return current = value;
        };
        _getHour = function(value) {
          return parseInt(value.split(HOUR_SEPARATOR)[0], 10);
        };
        _getMinutes = function(value) {
          var mmInt;
          var mm = value.split(HOUR_SEPARATOR)[1];
          if ((mm != null ? mm.length : void 0) < 2) {
            mm = "" + mm + "0";
          }
          mmInt = parseInt(mm, 10);
          if (!mm) {
            return;
          }
          if (isNaN(mmInt) || mmInt >= MINUTES_IN_HOUR) {
            return NaN;
          }
          return mmInt;
        };
        _calculateExtraDays = function(value) {
          if (!angular.isDate(value)) {
            return null;
          }
          return Math.floor((value - TimeUtilF.DEFAULT_DATE) / TimeUtilF.MILLISECONDS_IN_DAY);
        };
        _prependZeros = function(value, len) {
          var valueStr = value.toString();
          while (valueStr.length < len) {
            valueStr = "0" + valueStr;
          }
          return valueStr;
        };
        _replaceHour = function(value, hour) {
          var values = value.split(HOUR_SEPARATOR);
          values[0] = _prependZeros(hour, 2);
          return values.join(HOUR_SEPARATOR);
        };
        _parseTime = function(viewValue) {
          var date, extraDays, hh;
          extraDays = 0;
          hh = _getHour(viewValue);
          if (!isNaN(hh)) {
            extraDays = Math.floor(hh / HOURS_IN_DAY);
            hh %= HOURS_IN_DAY;
            viewValue = _replaceHour(viewValue, hh);
          }
          date = $dateParser(viewValue, TIME_FORMAT);
          return [date, extraDays];
        };
        scope.$watch("ngModel", function(value) {
          _setCurrentValue(value);
          return ctrls.$render();
        });
        ctrls.$render = function() {
          var extraDays, hh, viewValue;
          viewValue = null;
          if (angular.isDate(current)) {
            viewValue = dateFilter(current, TIME_FORMAT);
            extraDays = _calculateExtraDays(current);
            if (extraDays > 0) {
              hh = _getHour(viewValue);
              if (!isNaN(hh)) {
                hh += extraDays * HOURS_IN_DAY;
                viewValue = _replaceHour(viewValue, hh);
              }
            }
          } else {
            viewValue = ctrls.$viewValue || "";
          }
          return element.val(viewValue);
        };
        ctrls.$parsers.unshift(function(viewValue) {
          var date, extraDays, _ref;
          ctrls.$setValidity("time", true);
          if (!viewValue) {
            return viewValue;
          }
          date = null;
          extraDays = 0;
          if (angular.isDate(viewValue)) {
            date = viewValue;
            extraDays = _calculateExtraDays(date);
          } else {
            _ref = _parseTime(viewValue), date = _ref[0], extraDays = _ref[1];
          }
          if (isNaN(date)) {
            ctrls.$setValidity("time", false);
            return;
          }
          return _getUpdatedDate(date, extraDays);
        });
        element.bind("blur", function(event) {
          var date, extraDays, hh, hhStr, mm, mmStr, viewValue, _ref;
          if (ctrls.$valid || !ctrls.$viewValue) {
            return;
          }
          hh = _getHour(ctrls.$viewValue);
          mm = _getMinutes(ctrls.$viewValue);
          if (isNaN(hh) || (mm && isNaN(mm))) {
            return ctrls.$viewValue;
          }
          hhStr = _prependZeros(hh, 2);
          if (!mm) {
            mmStr = "00";
          } else {
            mmStr = _prependZeros(mm, 2);
          }
          viewValue = "" + hhStr + ":" + mmStr;
          _ref = _parseTime(viewValue), date = _ref[0], extraDays = _ref[1];
          if (isNaN(date)) {
            return;
          }
          ctrls.$setViewValue(_getUpdatedDate(date, extraDays));
          return ctrls.$render();
        });
        return _setCurrentValue(scope.ngModel);
      }
    };
  };
  timePickerD.$inject = ["$compile", "$parse", "$document", "dateFilter", "$dateParser", "TimeUtilF"];

  angular.module('app').directive('timePickerD', timePickerD);

}).call(this);

(function() {
  var timeRangeD = [
    'TimeUtilF', 'Constants', function(TimeUtilF, Constants) {
      return {
        restrict: 'E',
        replace: true,
        require: ['^form'],
        templateUrl: 'directives/timeRange.html',
        scope: {
          from: '=',
          to: '=',
          min: '=?',
          max: '=?',
          duration: '=?',
          fromName: '@?',
          toName: '@?',
          bothRequired: '='
        },
        link: function(scope, element, attrs, ctrls) {
          var _toSameDay, _validate, _validateDuration, _validateMax, _validateMin, _validateMissingWindow, _validateRange, _validateRequired;
          var form = ctrls[0];
          scope.isRequired = attrs['required'] != null;
          scope.fromName || (scope.fromName = 'from');
          scope.toName || (scope.toName = 'to');
          _validateRequired = function() {
            if (!scope.isRequired) {
              return;
            }
            form[scope.fromName].$setValidity('required', !!scope.from);
            return form[scope.toName].$setValidity('required', !!scope.to);
          };
          _validateMissingWindow = function() {
            var fromMissing, toMissing;
            if (!scope.bothRequired) {
              return;
            }
            toMissing = !!scope.from && !scope.to;
            fromMissing = !scope.from && !!scope.to;
            form[scope.toName].$setValidity('missingWindow', !toMissing);
            return form[scope.fromName].$setValidity('missingWindow', !fromMissing);
          };
          _validateRange = function(source) {
            if (scope.from && scope.to && source && scope.from >= scope.to) {
              return form[source].$setValidity('timeWindow', false);
            } else {
              form[scope.fromName].$setValidity('timeWindow', true);
              return form[scope.toName].$setValidity('timeWindow', true);
            }
          };
          _validateMin = function() {
            var isValid = !scope.min || !scope.from || (scope.from >= scope.min);
            return form[scope.fromName].$setValidity('minTime', isValid);
          };
          _validateMax = function() {
            var isValid = !scope.max || !scope.to || (scope.to <= scope.max);
            return form[scope.toName].$setValidity('maxTime', isValid);
          };
          _validateDuration = function(source) {
            var minDuration, target, timeDuration;
            form[scope.fromName].$setValidity('duration', true);
            form[scope.toName].$setValidity('duration', true);
            minDuration = scope.duration;
            if (!(minDuration && scope.from && scope.to)) {
              return;
            }
            timeDuration = TimeUtilF.compareDates(scope.to, scope.from);
            target = source || scope.toName;
            return form[target].$setValidity('duration', timeDuration >= minDuration);
          };
          _validate = function(source) {
            _validateRequired();
            _validateRange(source);
            _validateMissingWindow();
            _validateMin();
            _validateMax();
            return _validateDuration(source);
          };
          _toSameDay = function(from, to) {
            from.setFullYear(to.getFullYear());
            from.setMonth(to.getMonth());
            return from.setDate(to.getDate());
          };
          scope.$watch('from', function() {
            return _validate(scope.fromName);
          }, true);
          scope.$watch('to', function() {
            return _validate(scope.toName);
          }, true);
          scope.$watch('duration', function() {
            return _validate();
          });
          scope.$watch('min', function() {
            return _validate();
          });
          return scope.$watch('max', function() {
            return _validate();
          });
        },
        controller: ["$scope", function($scope) {
          return $scope.config = Constants.timePickerConfig;
        }]
      };
    }
  ];

  angular.module('app').directive('timeRangeD', timeRangeD);

}).call(this);

(function() {
  var TooltipD = function(Constants) {
    var OFFSET_X, OFFSET_Y;
    OFFSET_X = 20;
    OFFSET_Y = 20;
    return {
      restrict: 'A',
      scope: {
        tooltipD: '@',
        canShow: '&?',
        tooltipClass: '@?',
        smallOffset: '=?'
      },
      link: function($scope, $element, $attrs) {
        var canInit, classes, handeOver, handleMove, handleOut, registerEvents, removeEvents, tooltipBox, tooltipOn, _ref;
        if ($scope.smallOffset) {
          OFFSET_X = 5;
          OFFSET_Y = 5;
        }
        tooltipOn = false;
        tooltipBox = angular.element(Constants.tooltipBoxId);
        classes = (_ref = $scope.tooltipClass) != null ? _ref.split(' ') : void 0;
        if (!tooltipBox) {
          return;
        }
        handeOver = function() {
          var _ref1;
          tooltipBox[0].classList.add('show');
          if (classes != null) {
            (_ref1 = tooltipBox[0].classList).add.apply(_ref1, classes);
          }
          return tooltipBox.html($scope.tooltipD);
        };
        handleMove = function(_arg) {
          var height, pageX, pageY, width, x, y, _ref1;
          pageX = _arg.pageX, pageY = _arg.pageY;
          _ref1 = tooltipBox[0].getBoundingClientRect(), width = _ref1.width, height = _ref1.height;
          x = pageX + OFFSET_X;
          y = pageY + OFFSET_Y;
          if ((x + width) > window.innerWidth) {
            tooltipBox[0].style.right = "" + (0 + OFFSET_X) + "px";
            tooltipBox[0].style.left = "auto";
          } else {
            tooltipBox[0].style.right = "auto";
            tooltipBox[0].style.left = "" + x + "px";
          }
          if ((y + height) > window.innerHeight) {
            tooltipBox[0].style.bottom = "" + (0 + OFFSET_X) + "px";
            return tooltipBox[0].style.top = "auto";
          } else {
            tooltipBox[0].style.bottom = "auto";
            return tooltipBox[0].style.top = "" + y + "px";
          }
        };
        handleOut = function() {
          var _ref1;
          tooltipBox[0].classList.remove('show');
          if (classes != null) {
            (_ref1 = tooltipBox[0].classList).remove.apply(_ref1, classes);
          }
          tooltipBox[0].style.top = "auto";
          tooltipBox[0].style.left = "auto";
          tooltipBox[0].style.right = "auto";
          return tooltipBox[0].style.bottom = "auto";
        };
        registerEvents = function() {
          $element.on('mouseover', handeOver);
          $element.on('mousemove', handleMove);
          return $element.on('mouseout', handleOut);
        };
        removeEvents = function() {
          $element.off('mouseover', handeOver);
          $element.off('mousemove', handleMove);
          return $element.off('mouseout', handleOut);
        };
        canInit = $scope.canShow();
        if ((canInit == null) || ((canInit != null) && canInit)) {
          registerEvents();
        }
        if (canInit != null) {
          $scope.$watch($scope.canShow, function(newValue, oldValue) {
            if (newValue !== oldValue) {
              if (newValue) {
                return registerEvents();
              } else {
                handleOut();
                return removeEvents();
              }
            }
          });
        }
        return $scope.$on('$destroy', function() {
          return removeEvents();
        });
      }
    };
  };
  TooltipD.$inject = ["Constants"];

  angular.module('app').directive('tooltipD', TooltipD);

}).call(this);

(function() {
  var TypeInputD = function($q, TypeF) {
    return {
      restrict: 'E',
      templateUrl: 'directives/typeInput.html',
      scope: {
        types: '=',
        owner: '=?',
        onChange: '=?'
      },
      controller: ["$scope", function($scope) {
        var OWNER_DRIVER, _formatTag, _isDriverType;
        OWNER_DRIVER = 'driver';
        $scope.shouldShowWarning = false;
        _isDriverType = $scope.owner === OWNER_DRIVER;
        _formatTag = function(val) {
          return {
            text: val
          };
        };
        $scope.typeList = Object.keys(TypeF.types);
        if ($scope.types) {
          $scope.currentType = _.map($scope.types, _formatTag);
        } else {
          $scope.types = [];
          $scope.currentType = [];
        }
        $scope.onTagAdded = function(tag) {
          var type = tag.text;
          $scope.types.push(type);
          if ($scope.onChange) {
            return $scope.onChange();
          }
        };
        $scope.onTagRemoved = function(tag) {
          var index;
          $scope.shouldShowWarning = _isDriverType && true;
          index = $scope.types.indexOf(tag.text);
          if (index >= 0) {
            $scope.types.splice(index, 1);
          }
          if ($scope.onChange) {
            return $scope.onChange();
          }
        };
        return $scope.getTypeList = function(query) {
          var list, lowerCase;
          lowerCase = query.toLowerCase();
          list = _.filter($scope.typeList, function(val) {
            return val.toLowerCase().indexOf(lowerCase) > -1;
          });
          return $q.when(list);
        };
      }]
    };
  };
  TypeInputD.$inject = ["$q", "TypeF"];

  angular.module('app').directive('typeInputD', TypeInputD);

}).call(this);

(function() {
  var UiScaleD = function(HudF, MapF) {
    return {
      restrict: 'A',
      link: function(scope, element) {
        var broadcastWindowResize, debounce, timeout;
        debounce = 400;
        timeout = false;
        broadcastWindowResize = function() {
          google.maps.event.trigger(MapF.map, 'resize');
          scope.$broadcast('parentResized');
          timeout = false;
        };
        $(window).resize(function() {
          if (timeout) {
            return;
          }
          timeout = true;
          return setTimeout(broadcastWindowResize, debounce);
        });
        return broadcastWindowResize();
      }
    };
  };
  UiScaleD.$inject = ["HudF", "MapF"];

  angular.module('app').directive('uiScaleD', UiScaleD);

}).call(this);

(function() {
  var DriverC = (function() {
    DriverC.$inject = ["$rootScope", "$scope", "$state", "$q", "$previousState", "$translate", "UUID", "DriverF", "Constants", "MessagingF", "ConfirmF", "ValidatorF", "RouteS", "GMarkerF", "MarkersF", "Marker", "TypeF", "EventListenersF", "Events", "States", "DispatchF", "TimeUtilF", "ProjectF", "AnalyticsS", "DispatchStatusF", "RouteHistoryF", "AddressCheckerS", "LoggerF", "DriverUploadF", "AccountF"];
    function DriverC($rootScope, $scope, $state, $q, $previousState, $translate, UUID, DriverF, Constants, MessagingF, ConfirmF, ValidatorF, RouteS, GMarkerF, MarkersF, Marker, TypeF, EventListenersF, Events, States, DispatchF, TimeUtilF, ProjectF, AnalyticsS, DispatchStatusF, RouteHistoryF, AddressCheckerS, LoggerF, DriverUploadF, AccountF) {
      var DRIVER_LIST_STATE, ROUTE_STATE, _addDrivers, _clearActions, _confirmRemoveRoute, _goToPreviousOrDefaultState, _hasDriverWithServedStops, _hasEditChanges, _isNameChanged, _isResetChange, _originalEntry, _ref, _removeDriverAndMoveStopsToUnserved, _resetableChanges, _routeAlterStates, _setSelected, _showRouteProgressInfo;
      _routeAlterStates = [States.projectDriversEdit, States.projectDriversCreate];
      this.quickAddDriverOptions = Constants.QUICK_ADD_DRIVER_OPTIONS;
      this.user = AccountF.getUser();
      this.isTrial = ((_ref = this.user) != null ? _ref.status : void 0) === 'trial';
      _resetableChanges = ['startShift', 'endShift', 'duration', 'capacity', 'types', 'startLocation', 'endLocation', 'speed', 'breaks'];
      _originalEntry = null;
      _setSelected = function(entry, isSelected) {
        if (entry.startLocation) {
          GMarkerF.setSelected(entry.startLocation.id, isSelected);
        }
        if (entry.endLocation) {
          GMarkerF.setSelected(entry.endLocation.id, isSelected);
        }
      };
      _hasEditChanges = (function(_this) {
        return function() {
          var _ref1, _ref2;
          return ((_ref1 = _this.entry) != null ? (_ref2 = _ref1.startLocation) != null ? _ref2.info : void 0 : void 0) != null;
        };
      })(this);
      _showRouteProgressInfo = function() {
        MessagingF.replaceInfoPopup("MESSAGES.ROUTING_IN_PROGRESS");
      };
      _isNameChanged = function(entry) {
        if ((entry['name'] != null) && _originalEntry['name']) {
          return entry['name'] !== _originalEntry['name'];
        }
        return false;
      };
      _isResetChange = function(entry) {
        var brk, idx, isDifferentEnd, isDifferentStart, newValue, oldBrk, original, property, val, _i, _j, _k, _len, _len1, _len2, _ref1, _ref10, _ref11, _ref12, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;
        for (_i = 0, _len = _resetableChanges.length; _i < _len; _i++) {
          property = _resetableChanges[_i];
          newValue = entry[property];
          original = _originalEntry[property];
          if (!newValue && !original) {
            continue;
          }
          switch (property) {
            case 'breaks':
              if (((newValue != null ? newValue.length : void 0) || 0) !== ((original != null ? original.length : void 0) || 0)) {
                return true;
              }
              for (idx = _j = 0, _len1 = newValue.length; _j < _len1; idx = ++_j) {
                brk = newValue[idx];
                oldBrk = original[idx];
                isDifferentStart = (oldBrk != null ? (_ref1 = oldBrk.start) != null ? typeof _ref1.getTime === "function" ? _ref1.getTime() : void 0 : void 0 : void 0) !== (brk != null ? (_ref2 = brk.start) != null ? typeof _ref2.getTime === "function" ? _ref2.getTime() : void 0 : void 0 : void 0);
                isDifferentEnd = (oldBrk != null ? (_ref3 = oldBrk.end) != null ? typeof _ref3.getTime === "function" ? _ref3.getTime() : void 0 : void 0 : void 0) !== (brk != null ? (_ref4 = brk.end) != null ? typeof _ref4.getTime === "function" ? _ref4.getTime() : void 0 : void 0 : void 0);
                if (isDifferentStart || isDifferentEnd) {
                  return true;
                }
              }
              break;
            case 'startLocation':
            case 'endLocation':
              if ((((newValue != null ? newValue.info : void 0) != null) !== ((original != null ? original.info : void 0) != null)) || ((newValue != null ? (_ref5 = newValue.info) != null ? (_ref6 = _ref5.coords) != null ? _ref6.lat : void 0 : void 0 : void 0) !== (original != null ? (_ref7 = original.info) != null ? (_ref8 = _ref7.coords) != null ? _ref8.lat : void 0 : void 0 : void 0)) || ((newValue != null ? (_ref9 = newValue.info) != null ? (_ref10 = _ref9.coords) != null ? _ref10.lng : void 0 : void 0 : void 0) !== (original != null ? (_ref11 = original.info) != null ? (_ref12 = _ref11.coords) != null ? _ref12.lng : void 0 : void 0 : void 0))) {
                return true;
              }
              break;
            case 'types':
              if (((newValue != null ? newValue.length : void 0) || 0) !== ((original != null ? original.length : void 0) || 0)) {
                return true;
              }
              if (newValue != null) {
                for (_k = 0, _len2 = newValue.length; _k < _len2; _k++) {
                  val = newValue[_k];
                  if (!_.contains(original, val)) {
                    return true;
                  }
                }
              }
              break;
            case 'startShift':
            case 'endShift':
              if (!newValue || !original || (newValue.getTime() !== original.getTime())) {
                return true;
              }
              break;
            default:
              if (newValue !== original) {
                return true;
              }
          }
        }
        return false;
      };
      _removeDriverAndMoveStopsToUnserved = function(driver) {
        if (RouteS.isDriverEmpty(driver)) {
          return RouteS.removeEmptyDriver(driver, false);
        } else {
          return RouteS.moveDriverStopsToUnserved(driver, false).then(function() {
            return RouteS.removeEmptyDriver(driver, false);
          });
        }
      };
      _confirmRemoveRoute = function() {
        if (RouteS.hasRoute()) {
          return ConfirmF.confirm("MESSAGES.CLEAR_ROUTE_CONFIRMATION").then(function() {
            RouteS.clear();
            DispatchF.deleteAll();
            return true;
          });
        } else {
          return $q.when(true);
        }
      };
      _clearActions = function() {
        RouteS.clear();
        DispatchF.deleteAll();
        return DriverF.deleteAll();
      };
      _goToPreviousOrDefaultState = (function(_this) {
        return function() {
          var _ref1;
          if ((_ref1 = $previousState.get(_this.previousState)) != null ? _ref1.state : void 0) {
            return $previousState.go(_this.previousState);
          } else {
            return $state.go(DRIVER_LIST_STATE);
          }
        };
      })(this);
      _hasDriverWithServedStops = function() {
        var driver, _i, _len, _ref1;
        _ref1 = DriverF.getDrivers();
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          driver = _ref1[_i];
          if (RouteS.isDriverHasServedStops(driver)) {
            return true;
          }
        }
        return false;
      };
      _addDrivers = function(drivers) {
        return DriverUploadF.addDrivers(drivers, true);
      };
      DRIVER_LIST_STATE = States.projectDriversList;
      ROUTE_STATE = States.projectRoute;
      this.timePickerConfig = Constants.timePickerConfig;
      this.phoneRegex = ValidatorF.PHONE_REGEXP;
      this.previousState = 'driverPrevious';
      this.maxHours = TimeUtilF.MAX_HOURS;
      this.maxDate = TimeUtilF.MAX_DATE;
      this.SPEED_LIST = DriverF.SPEED_LIST;
      this.speedSettings = {
        floor: 0.1,
        ceil: 1.9,
        step: 0.05,
        precision: 2,
        hideLimitLabels: true,
        translate: function(val) {
          return Math.round(val * 100) + '%';
        }
      };
      this.getList = function() {
        return DriverF.getDrivers();
      };
      this.isRouteLocked = function(id) {
        return RouteS.isRouteLocked(id);
      };
      this.getNumDrivers = function() {
        return DriverF.getDrivers().length;
      };
      this.goToCreate = function() {
        AnalyticsS.track('021 Add a driver');
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        return $state.go(States.projectDriversCreate);
      };
      this.goToUpload = function() {
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        return $state.go(States.projectDriversUpload);
      };
      this.goToQuickadd = function() {
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        return $state.go(States.projectDriversQuickadd);
      };
      this.goToEdit = function(driver, event) {
        if (event) {
          event.stopPropagation();
        }
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        AnalyticsS.track('078 Edit driver');
        return $state.go(States.projectDriversEdit, {
          driverID: driver.id
        });
      };
      this.quickAddDriver = function(valid, entry, formCtrl, totalDrivers) {
        var driver, entries, index, newEntry, promise;
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        if ((formCtrl != null) && (formCtrl.startLoc != null) && !formCtrl.startLoc.$valid) {
          AddressCheckerS.check(formCtrl.startLoc.$viewValue).then(function(newLoc) {
            var _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
            if (((_ref1 = $scope.driver) != null ? (_ref2 = _ref1.entry) != null ? _ref2.startLocation : void 0 : void 0) == null) {
              if ((_ref3 = $scope.driver) != null) {
                if ((_ref4 = _ref3.entry) != null) {
                  _ref4.startLocation = {};
                }
              }
            }
            return (_ref5 = $scope.driver) != null ? (_ref6 = _ref5.entry) != null ? _ref6.startLocation.info = newLoc : void 0 : void 0;
          });
        }
        if ((formCtrl != null) && (formCtrl.finalLoc != null) && !formCtrl.finalLoc.$valid) {
          AddressCheckerS.check(formCtrl.finalLoc.$viewValue).then(function(newLoc) {
            var _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
            if (((_ref1 = $scope.driver) != null ? (_ref2 = _ref1.entry) != null ? _ref2.endLocation : void 0 : void 0) == null) {
              if ((_ref3 = $scope.driver) != null) {
                if ((_ref4 = _ref3.entry) != null) {
                  _ref4.endLocation = {};
                }
              }
            }
            return (_ref5 = $scope.driver) != null ? (_ref6 = _ref5.entry) != null ? _ref6.endLocation.info = newLoc : void 0 : void 0;
          });
        }
        if (!valid) {
          return console.log('Invalid form, driver not created');
        }
        entries = [];
        newEntry = entry;
        newEntry.endShift = null;
        index = 0;
        while (index < totalDrivers) {
          driver = Object.assign({}, newEntry, {
            'name': 'Driver ' + (index + 1)
          });
          entries.push(driver);
          index++;
        }
        this.inUpsert = true;
        return promise = _addDrivers(entries).then(function() {
          MarkersF.fitToPoints();
          LoggerF.info(LoggerF.ACTIONS.ADDED_DRIVER, entries);
          return $state.go('^.list');
        })["catch"]((function(_this) {
          return function(err) {
            LoggerF.error(LoggerF.ACTIONS.ADDED_DRIVER, entries, err);
            _this.inUpsert = false;
            if (err) {
              return MessagingF.replaceError(err.message || err.error);
            }
          };
        })(this))["finally"]((function(_this) {
          return function() {
            return _this.inUpsert = false;
          };
        })(this));
      };
      this.addDriver = function(valid, entry, formCtrl) {
        var driver;
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        if ((formCtrl != null) && (formCtrl.startLoc != null) && !formCtrl.startLoc.$valid) {
          AddressCheckerS.check(formCtrl.startLoc.$viewValue).then(function(newLoc) {
            var _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
            if (((_ref1 = $scope.driver) != null ? (_ref2 = _ref1.entry) != null ? _ref2.startLocation : void 0 : void 0) == null) {
              if ((_ref3 = $scope.driver) != null) {
                if ((_ref4 = _ref3.entry) != null) {
                  _ref4.startLocation = {};
                }
              }
            }
            return (_ref5 = $scope.driver) != null ? (_ref6 = _ref5.entry) != null ? _ref6.startLocation.info = newLoc : void 0 : void 0;
          });
        }
        if ((formCtrl != null) && (formCtrl.finalLoc != null) && !formCtrl.finalLoc.$valid) {
          AddressCheckerS.check(formCtrl.finalLoc.$viewValue).then(function(newLoc) {
            var _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
            if (((_ref1 = $scope.driver) != null ? (_ref2 = _ref1.entry) != null ? _ref2.endLocation : void 0 : void 0) == null) {
              if ((_ref3 = $scope.driver) != null) {
                if ((_ref4 = _ref3.entry) != null) {
                  _ref4.endLocation = {};
                }
              }
            }
            return (_ref5 = $scope.driver) != null ? (_ref6 = _ref5.entry) != null ? _ref6.endLocation.info = newLoc : void 0 : void 0;
          });
        }
        if (!valid) {
          return console.log('Invalid form, driver not created');
        }
        this.inUpsert = true;
        driver = null;
        return DriverF.add(entry).then(function(entry) {
          driver = entry;
          if (!RouteS.hasRoute()) {
            return;
          }
          return RouteS.addEmptyDrivers([driver]);
        }).then(function() {
          DriverF.updateDriversValidityList();
          return EventListenersF.notify(Events.PROJECT_MODIFIED);
        }).then(function() {
          MarkersF.fitToPoints();
          TypeF.addTypes(driver.types);
          LoggerF.info(LoggerF.ACTIONS.ADDED_DRIVER, entry);
          return $state.go('^.list');
        })["catch"]((function(_this) {
          return function(err) {
            LoggerF.error(LoggerF.ACTIONS.ADDED_DRIVER, entry, err);
            _this.inUpsert = false;
            if (err) {
              return MessagingF.replaceError(err.message || err.error);
            }
          };
        })(this))["finally"]((function(_this) {
          return function() {
            return _this.inUpsert = false;
          };
        })(this));
      };
      this.cancel = (function(_this) {
        return function() {
          AnalyticsS.track('024 Cancel driver form');
          return _goToPreviousOrDefaultState();
        };
      })(this);
      this.clear = (function(_this) {
        return function() {
          var _ref1;
          if (_this.getNumDrivers() === 0) {
            return;
          }
          if (RouteS.isInProgress()) {
            _showRouteProgressInfo();
            return;
          }
          if (ProjectF.isDispatchedProject()) {
            MessagingF.replaceError("MESSAGES.UNABLE_CLEAR_LIVE_ROUTE_DRIVERS");
            return;
          }
          if (_hasDriverWithServedStops()) {
            MessagingF.replaceError("MESSAGES.UNABLE_DELETE_ALL_DRIVERS_WITH_SERVED_STOPS");
            return;
          }
          if (((_ref1 = RouteHistoryF.seek()) != null ? _ref1.numLocks : void 0) > 0) {
            return MessagingF.replaceConfirm("MESSAGES.DELETE_ALL_DRIVERS_CONTAIN_LOCK", null, null, "Confirm deletion", _clearActions);
          } else {
            return ConfirmF.confirm("MESSAGES.DELETE_ALL_DRIVERS_CONFIRMATION").then(function() {
              return _clearActions();
            })["catch"](function(err) {
              if (err) {
                return MessagingF.replaceError(err.message || err.error);
              }
            });
          }
        };
      })(this);
      this.removeDriver = function(driver, event) {
        var dispatch, hasDispatches, hasRoute, message;
        if (event) {
          event.stopPropagation();
        }
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        if (RouteS.isDriverHasServedStops(driver)) {
          MessagingF.replaceError("MESSAGES.UNABLE_DELETE_DRIVERS_WITH_SERVED_STOPS");
          return;
        }
        AnalyticsS.track('079 Delete driver');
        hasDispatches = DispatchStatusF.hasDispatches();
        dispatch = DispatchF.getDispatchWithVehicleId(driver.id);
        hasRoute = RouteS.hasRoute();
        message = null;
        if (dispatch) {
          message = "MESSAGES.REMOVE_DRIVER_DISPATCH_CONFIRMATION";
        } else {
          message = "MESSAGES.REMOVE_DRIVER_CONFIRMATION";
        }
        return ConfirmF.confirm(message).then((function(_this) {
          return function() {
            driver.inProgress = true;
            _this.inDelete = true;
            if (!hasRoute || RouteS.isDriverEmpty(driver)) {
              return;
            }
            return RouteS.moveDriverStopsToUnserved(driver, false);
          };
        })(this)).then(function() {
          if (!hasRoute) {
            return;
          }
          RouteS.removeEmptyDriver(driver, false);
          if (!dispatch) {
            return;
          }
          return DispatchF.deleteRoute(dispatch);
        }).then(function() {
          return DriverF["delete"](driver.id, false);
        }).then(function() {
          if (!hasDispatches) {
            return;
          }
          RouteS.resetRoutesToCurrent();
          return DispatchF.dispatchDrivers(ProjectF.project);
        }).then(function() {
          DriverF.updateDriversValidityList();
          if (DriverF.getNumSelected() <= 0) {
            RouteS.clear();
          }
          return EventListenersF.notify(Events.PROJECT_MODIFIED, !!hasDispatches);
        }).then(function() {
          LoggerF.info(LoggerF.ACTIONS.DELETED_DRIVER, driver);
          if ($state.current.name === DRIVER_LIST_STATE || $state.includes(ROUTE_STATE)) {
            return;
          }
          return _goToPreviousOrDefaultState();
        })["catch"](function(err) {
          LoggerF.error(LoggerF.ACTIONS.DELETED_DRIVER, driver, err);
          driver.inProgress = false;
          if (err) {
            return MessagingF.replaceError(err.message || err.error);
          }
        })["finally"]((function(_this) {
          return function() {
            return _this.inDelete = false;
          };
        })(this));
      };
      this.updateDriver = function(valid, entry, formCtrl, fromListView) {
        var wasError, _needGanttRedraw, _needRefetchRoute, _ref1, _ref2, _refetchRoute;
        if (fromListView == null) {
          fromListView = true;
        }
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return $q.reject();
        }
        if ((formCtrl != null) && (formCtrl.startLoc != null) && !formCtrl.startLoc.$valid) {
          AddressCheckerS.check(formCtrl.startLoc.$viewValue).then(function(newLoc) {
            var _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
            if (((_ref1 = $scope.driver) != null ? (_ref2 = _ref1.entry) != null ? _ref2.startLocation : void 0 : void 0) == null) {
              if ((_ref3 = $scope.driver) != null) {
                if ((_ref4 = _ref3.entry) != null) {
                  _ref4.startLocation = {};
                }
              }
            }
            return (_ref5 = $scope.driver) != null ? (_ref6 = _ref5.entry) != null ? _ref6.startLocation.info = newLoc : void 0 : void 0;
          });
        }
        if ((formCtrl != null) && (formCtrl.finalLoc != null) && !formCtrl.finalLoc.$valid) {
          AddressCheckerS.check(formCtrl.finalLoc.$viewValue).then(function(newLoc) {
            var _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
            if (((_ref1 = $scope.driver) != null ? (_ref2 = _ref1.entry) != null ? _ref2.endLocation : void 0 : void 0) == null) {
              if ((_ref3 = $scope.driver) != null) {
                if ((_ref4 = _ref3.entry) != null) {
                  _ref4.endLocation = {};
                }
              }
            }
            return (_ref5 = $scope.driver) != null ? (_ref6 = _ref5.entry) != null ? _ref6.endLocation.info = newLoc : void 0 : void 0;
          });
        }
        if (!valid) {
          console.log('Invalid form, driver not updated');
          return $q.reject();
        }
        if (RouteS.isDriverHasServedStops(entry)) {
          MessagingF.replaceError("MESSAGES.UNABLE_UPDATE_DRIVERS_WITH_SERVED_STOPS");
          return $q.reject();
        }
        wasError = !!entry.error;
        if ((entry.startLocation != null) && (entry.startLocation.id == null)) {
          entry.startLocation.id = UUID.generate();
        }
        if ((entry.endLocation != null) && (entry.endLocation.id == null)) {
          entry.endLocation.id = UUID.generate();
        }
        if ((entry.endLocation != null) && (((_ref1 = entry.endLocation) != null ? (_ref2 = _ref1.info) != null ? _ref2.address : void 0 : void 0) == null)) {
          if (RouteS.hasRoute()) {
            RouteS.removeDepotFromRoute(entry.endLocation.id, entry.id);
          }
          entry.endLocation = null;
        }
        _needRefetchRoute = false;
        _refetchRoute = null;
        if (RouteS.hasRoute() && _isResetChange(entry) && !wasError) {
          _refetchRoute = ConfirmF.confirmWarning($translate.instant("DRIVER_INFO.CONFIRM_TITLE"), $translate.instant("DRIVER_INFO.CONFIRM_TEXT"), $translate.instant("DRIVER_INFO.CANCEL"), $translate.instant("DRIVER_INFO.CONFIRM_SAVE")).then(function() {
            return _needRefetchRoute = true;
          });
        } else {
          _needGanttRedraw = _isNameChanged(entry);
          _refetchRoute = $q.when(true);
        }
        return _refetchRoute.then((function(_this) {
          return function() {
            _this.inUpsert = true;
            return DriverF.update(entry);
          };
        })(this)).then(function(driver) {
          var _reoptimize;
          _reoptimize = null;
          if (wasError) {
            if (RouteS.hasRoute()) {
              _reoptimize = RouteS.addEmptyDrivers([driver]).then(function() {
                return DriverF.updateDriversValidityList();
              });
            } else {
              _reoptimize = $q.when(DriverF.updateDriversValidityList());
            }
          } else if (_needRefetchRoute) {
            _reoptimize = EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS).then(function() {
              return RouteS.forceDriversReroute([driver.id]);
            });
          } else {
            _reoptimize = $q.when(true);
          }
          return _reoptimize;
        }).then(function() {
          if (_needRefetchRoute) {
            RouteS.resetRoutesToCurrent();
          }
          EventListenersF.notify(Events.PROJECT_MODIFIED);
          if (_needGanttRedraw) {
            return $rootScope.$broadcast('ganttInfoChanged');
          }
        }).then(function() {
          if ($state.includes(DRIVER_LIST_STATE)) {
            MarkersF.fitToPoints();
          }
          LoggerF.info(LoggerF.ACTIONS.UPDATED_DRIVER, entry);
          if (fromListView) {
            return _goToPreviousOrDefaultState();
          }
        })["catch"](function(err) {
          LoggerF.error(LoggerF.ACTIONS.UPDATED_DRIVER, entry, err);
          if (err) {
            MessagingF.replaceError(err.message || err.error);
          }
          return $q.reject();
        })["finally"]((function(_this) {
          return function() {
            EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
            return _this.inUpsert = false;
          };
        })(this));
      };
      this.initializeEntry = function(entry) {
        var firstBreak, fleetSize, item, _i, _len, _ref1, _ref2, _results;
        this.inUpsert = false;
        this.inDelete = false;
        if (entry == null) {
          this.entry = {
            startShift: new Date(Constants.timeWindowStart),
            endShift: new Date(Constants.timeWindowEnd),
            speed: 1.0,
            breaks: [
              {
                start: null,
                end: null
              }
            ]
          };
        } else {
          if (entry.speed == null) {
            entry.speed = 1.0;
          }
          this.entry = entry;
          firstBreak = (_ref1 = entry.breaks) != null ? _ref1[0] : void 0;
          this.entry['breaks'] = [
            {
              id: firstBreak != null ? firstBreak.id : void 0,
              start: firstBreak != null ? firstBreak.start : void 0,
              end: firstBreak != null ? firstBreak.end : void 0
            }
          ];
        }
        _originalEntry = _.cloneDeep(this.entry);
        if (window.dataLayer && this.isTrial && this.getNumDrivers() === 0) {
          _ref2 = window.dataLayer;
          _results = [];
          for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
            item = _ref2[_i];
            if (item.fleet_size) {
              fleetSize = parseInt(item.fleet_size);
              _results.push(this.driverTotal = fleetSize > 0 && fleetSize < 21 ? fleetSize : '');
            } else {
              _results.push(void 0);
            }
          }
          return _results;
        }
      };
      this.setMarkerVisible = function(driver, isVisible, event) {
        var dispatch, hasDispatches, _showMessage;
        if (event) {
          event.stopPropagation();
        }
        if (ProjectF.isBusy) {
          driver.visible = !isVisible;
          return MessagingF.replaceError("MESSAGES.PROJECT_BUSY_ERROR");
        }
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        if (!isVisible && RouteS.isDriverHasServedStops(driver)) {
          MessagingF.replaceError("MESSAGES.UNABLE_DISABLE_DRIVERS_WITH_SERVED_STOPS");
          driver.visible = !isVisible;
          return;
        }
        hasDispatches = DispatchStatusF.hasDispatches();
        dispatch = DispatchF.getDispatchWithVehicleId(driver.id);
        _showMessage = (function(isVisible) {
          var message;
          if (isVisible) {
            return $q.when(true);
          }
          message = null;
          if (dispatch) {
            message = "MESSAGES.DISABLE_DRIVER_DISPATCH_CONFIRMATION";
          } else {
            message = "MESSAGES.DISABLE_DRIVER_CONFIRMATION";
          }
          return ConfirmF.confirmTemplate(null, message, 'Cancel', 'Confirm', 'warning', '', '', true, 'hideDisableDriverWarning').then(function() {
            return MessagingF.replaceSuccessPopup("MESSAGES.DISABLE_DRIVER_NOTIFICATION", {
              driverName: driver.name
            });
          });
        })(isVisible);
        return _showMessage.then(function() {
          ProjectF.isBusy = true;
          if (!RouteS.hasRoute()) {
            return;
          }
          if (isVisible) {
            return RouteS.addEmptyDrivers([driver]);
          } else {
            return _removeDriverAndMoveStopsToUnserved(driver);
          }
        }).then(function() {
          DriverF.updateDriversValidityList();
          if (isVisible || !dispatch) {
            return;
          }
          return DispatchF.deleteRoute(dispatch);
        }).then(function() {
          if (!RouteS.hasRoute()) {
            return;
          }
          RouteS.resetRoutesToCurrent();
          if (isVisible || !dispatch) {
            return;
          }
          return DispatchF.dispatchDrivers(ProjectF.project);
        }).then(function() {
          driver = DriverF.getDriver(driver.id);
          driver.visible = isVisible;
          driver.setVisible(isVisible);
          if (DriverF.getNumSelected() <= 0) {
            RouteS.clear();
          }
          ProjectF.isBusy = false;
          return EventListenersF.notify(Events.PROJECT_MODIFIED, !!hasDispatches);
        }).then(function() {
          if (isVisible) {
            MarkersF.fitToPoints();
          }
          return LoggerF.info(LoggerF.ACTIONS.CHANGED_DRIVER_VISIBILITY, {
            driverId: driver.id,
            isVisible: isVisible
          });
        })["catch"](function(err) {
          ProjectF.isBusy = false;
          LoggerF.error(LoggerF.ACTIONS.CHANGED_DRIVER_VISIBILITY, {
            driverId: driver.id,
            isVisible: isVisible
          }, err);
          driver.visible = !isVisible;
          if (err) {
            return MessagingF.replaceError(err.message || err.error);
          }
        });
      };
      this.highlight = function(driver) {
        return _setSelected(driver, true);
      };
      this.unhighlight = function(driver) {
        return _setSelected(driver, false);
      };
      this.toggleInfoWindow = function(driver) {
        var ids;
        if (!driver.visible) {
          return;
        }
        ids = [driver.startLocation.id];
        if (driver.endLocation) {
          ids.push(driver.endLocation.id);
        }
        return GMarkerF.closeOtherWindow(ids).then(function() {
          var isEndInfoOpen, isStartInfoOpen, toggle;
          isStartInfoOpen = GMarkerF.isInfoWindowOpen(driver.startLocation.id);
          isEndInfoOpen = driver.endLocation && GMarkerF.isInfoWindowOpen(driver.endLocation.id);
          if (isStartInfoOpen && isEndInfoOpen) {
            toggle = GMarkerF.forceCloseInfoWindow;
          } else {
            toggle = GMarkerF.openInfoWindow;
            toggle(driver.startLocation.id);
          }
          if (driver.endLocation) {
            return toggle(driver.endLocation.id);
          }
        });
      };
      this.setSelectAllVisible = function(isVisible) {
        var current, isAllSameVisibilities, originalVisibilities, _drivers, _i, _len;
        _drivers = this.getList();
        if (!isVisible && _hasDriverWithServedStops()) {
          MessagingF.replaceError("MESSAGES.UNABLE_DISABLE_ALL_DRIVERS_WITH_SERVED_STOPS");
          return;
        }
        originalVisibilities = {};
        isAllSameVisibilities = true;
        for (_i = 0, _len = _drivers.length; _i < _len; _i++) {
          current = _drivers[_i];
          originalVisibilities[current.id] = current.visible;
          if (current.visible !== isVisible) {
            isAllSameVisibilities = false;
            break;
          }
        }
        if (isAllSameVisibilities) {
          return;
        }
        return _confirmRemoveRoute().then(function() {
          var _j, _len1;
          for (_j = 0, _len1 = _drivers.length; _j < _len1; _j++) {
            current = _drivers[_j];
            current.visible = isVisible;
            current.setVisible(isVisible);
          }
          if (!isVisible) {
            RouteS.emptySummary();
          }
          return EventListenersF.notify(Events.PROJECT_MODIFIED);
        }).then(function() {
          if (isVisible) {
            return MarkersF.fitToPoints();
          }
        })["catch"](function() {
          var originalVisibility, _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = _drivers.length; _j < _len1; _j++) {
            current = _drivers[_j];
            originalVisibility = originalVisibilities[current.id];
            if (originalVisibility != null) {
              _results.push(current.visible = originalVisibility);
            } else {
              _results.push(void 0);
            }
          }
          return _results;
        });
      };
      this.statusList = Marker.Status;
      $rootScope.$on('$stateChangeStart', (function(_this) {
        return function(e, toState) {
          if ($state.current.name !== States.projectDriversQuickadd) {
            return false;
          }
          if (_hasEditChanges() && toState.name !== States.projectDriversList) {
            e.preventDefault();
            return MessagingF.replaceWarning("SIDEPANEL.UNSAVED_CHANGES", null, null, "SIDEPANEL.UNSAVED_CHANGES_OK");
          }
        };
      })(this));
      this.initializeEntry();
    }

    return DriverC;

  })();

  angular.module('app').controller('DriverC', DriverC);

}).call(this);

(function() {
  var DriverF = function($http, $q, UUID, Constants, ValidatorF, Marker, DriverMarker, AccountF, AnalyticsS, TimeUtilF, DriverUtil, DriverGeocoordF, EventListenersF, Events, StoredDriverF) {
    var DRIVER_URL, _convertToDriverMarker, _driverError, _drivers, _entryError, _formalizeEntry, _idError, _invalidDrivers, _isValidOrValidated, _validDrivers;
    DRIVER_URL = "" + Constants.apiPath + "/product/fleet";
    _driverError = new Error("Driver information must be defined");
    _entryError = new Error("Entry must be an object");
    _idError = new Error("Driver ID must be a string");
    _drivers = [];
    _validDrivers = [];
    _invalidDrivers = [];
    _isValidOrValidated = function(driver) {
      var valid, validated;
      validated = Marker.Status.Validated;
      valid = Marker.Status.Valid;
      return (driver.status === validated) || (driver.status === valid);
    };
    _formalizeEntry = function(driver) {
      var endLocPromise, promises, startLocPromise, _ref, _ref1;
      promises = [];
      if (((_ref = driver.startLocation) != null ? _ref.info : void 0) != null) {
        startLocPromise = DriverGeocoordF.translate(driver.startLocation.info).then(function(location) {
          location.id = driver.startLocation.id || UUID.generate();
          return driver.updateStartLocation(location);
        });
        promises.push(startLocPromise);
      }
      if (((_ref1 = driver.endLocation) != null ? _ref1.info : void 0) != null) {
        endLocPromise = DriverGeocoordF.translate(driver.endLocation.info).then(function(location) {
          location.id = driver.endLocation.id || UUID.generate();
          return driver.updateEndLocation(location);
        });
        promises.push(endLocPromise);
      }
      return $q.all(promises).then(function() {
        return ValidatorF.validateDriver(driver);
      }).then(function() {
        driver.status = Marker.Status.Validated;
        driver.error = null;
        return driver;
      })["catch"](function(error) {
        driver.status = Marker.Status.Invalid;
        driver.error = error.message;
        return driver;
      });
    };
    _convertToDriverMarker = function(entry) {
      var parsed = DriverUtil.formatDriverMarker(entry);
      return new DriverMarker(parsed);
    };
    DriverF = {};
    DriverF.SPEED_LIST = [
      {
        speed: 'SLOW',
        percentage: '10%'
      }, {
        speed: 'NORMAL',
        percentage: '100%'
      }, {
        speed: 'FAST',
        percentage: '190%'
      }
    ];
    DriverF.add = function(entry, isBatch) {
      var driver;
      if (isBatch == null) {
        isBatch = false;
      }
      if (!ValidatorF.isObject(entry)) {
        return $q.reject(_entryError);
      }
      if (entry.id == null) {
        entry.id = UUID.generate();
      }
      entry.status = Marker.Status.Pending;
      driver = _convertToDriverMarker(entry);
      _drivers.push(driver);
      return _formalizeEntry(driver).then(function(res) {
        driver = res;
        if (isBatch) {
          return $q.when(true);
        }
      }).then(function() {
        if (!driver.error) {
          return StoredDriverF.upsertInDb(driver);
        }
      }).then(function(storedDriver) {
        if (!isBatch) {
          AnalyticsS.increment({
            "#Added Drivers": 1
          });
        }
        if ((storedDriver != null ? storedDriver._id : void 0) != null) {
          driver.vehicleId = storedDriver._id;
        }
        return driver;
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    DriverF.clear = function() {
      _drivers = [];
      return DriverF.updateDriversValidityList();
    };
    DriverF.deleteAll = function() {
      if (!(_drivers && _drivers.length > 0)) {
        return $q.when(true);
      }
      DriverF.clear();
      return EventListenersF.notify(Events.PROJECT_MODIFIED);
    };
    DriverF["delete"] = function(id, saveProject) {
      var promise;
      if (saveProject == null) {
        saveProject = true;
      }
      if (!ValidatorF.isString(id)) {
        return $q.reject(_idError);
      }
      promise = null;
      _.remove(_drivers, {
        id: id
      });
      if (saveProject) {
        promise = EventListenersF.notify(Events.PROJECT_MODIFIED);
      } else {
        promise = $q.when(true);
      }
      return promise.then(function() {
        return AnalyticsS.track("Remove Driver");
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    DriverF.getDriver = function(id) {
      return _.find(_drivers, {
        id: id
      });
    };
    DriverF.getDrivers = function() {
      return _drivers;
    };
    DriverF.updateDriversValidityList = function() {
      var driver, _i, _len;
      _validDrivers = [];
      _invalidDrivers = [];
      for (_i = 0, _len = _drivers.length; _i < _len; _i++) {
        driver = _drivers[_i];
        if (_isValidOrValidated(driver)) {
          _validDrivers.push(driver);
        } else {
          _invalidDrivers.push(driver);
        }
      }
      return EventListenersF.notify(Events.VALID_DRIVERS_UPDATED);
    };
    DriverF.setCurrentLocation = function(driverId, location, heading) {
      var driver = DriverF.getDriver(driverId);
      if (driver && location) {
        driver.addCurrentLocation(location, heading);
        return EventListenersF.notify(Events.DRIVER_LOCATION_MARKER_CHANGED(driverId), driver.currentLocationMarker);
      }
    };
    DriverF.update = function(entry) {
      var driver, id, index;
      id = entry.id;
      if (!ValidatorF.isObject(entry)) {
        return $q.reject(_entryError);
      }
      if (!ValidatorF.isString(id)) {
        return $q.reject(_idError);
      }
      index = _.findIndex(_drivers, {
        id: id
      });
      if (index < 0) {
        return $q.reject(new Error("Driver with ID " + id + " does not exist"));
      }
      delete entry.error;
      driver = null;
      return ValidatorF.validateDriver(entry).then(function() {
        entry.status = Marker.Status.Valid;
        entry.error = null;
        driver = _convertToDriverMarker(entry);
        _drivers[index] = driver;
        DriverF.updateDriversValidityList();
        return EventListenersF.notify(Events.DRIVER_MODIFIED, driver);
      }).then(function() {
        if (!driver.error) {
          return StoredDriverF.upsertInDb(driver);
        }
      }).then(function() {
        AnalyticsS.track("Update Driver", driver);
        return _drivers[index];
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    DriverF.getSelectedDrivers = function() {
      return _.filter(_validDrivers, function(driver) {
        return driver.visible;
      });
    };
    DriverF.getNumSelected = function() {
      return DriverF.getSelectedDrivers().length;
    };
    DriverF.getInvalidDrivers = function() {
      return _invalidDrivers;
    };
    DriverF.getValidDrivers = function() {
      return _validDrivers;
    };
    DriverF.deSelectAll = function() {
      var d, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _drivers.length; _i < _len; _i++) {
        d = _drivers[_i];
        d.visible = false;
        _results.push(d.setVisible(false));
      }
      return _results;
    };
    DriverF.replace = function(drivers) {
      var driver, entry, promises, storedDrivers, _i, _len, _ref;
      DriverF.clear();
      promises = [];
      storedDrivers = StoredDriverF.getDrivers();
      if (drivers) {
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          entry = drivers[_i];
          if (entry.status === Marker.Status.Validated) {
            entry.status = Marker.Status.Valid;
          }
          if (entry.vehicleId == null) {
            entry.vehicleId = storedDrivers != null ? (_ref = storedDrivers[entry._id]) != null ? _ref._id : void 0 : void 0;
          }
          driver = new DriverMarker(entry);
          _drivers.push(driver);
          if (entry.status === Marker.Status.Pending) {
            promises.push(_formalizeEntry(driver));
          } else {
            promises.push($q.when(driver));
          }
        }
      }
      return $q.all(promises).then(function() {
        DriverF.updateDriversValidityList();
        return _drivers;
      });
    };
    return DriverF;
  };
  DriverF.$inject = ["$http", "$q", "UUID", "Constants", "ValidatorF", "Marker", "DriverMarker", "AccountF", "AnalyticsS", "TimeUtilF", "DriverUtil", "DriverGeocoordF", "EventListenersF", "Events", "StoredDriverF"];

  angular.module('app').factory('DriverF', DriverF);

}).call(this);

(function() {
  var DriverMarker = function(Marker, TimeUtilF, GMarkerF, UUID) {
    var MARKER_TEMPLATE_URL, _formatBreak, _formatDriverTypeText, _formatLocation, _initLocation, _retrieveLocationCoords, _updateLocation;
    MARKER_TEMPLATE_URL = 'markers/driver.html';
    _retrieveLocationCoords = function(location) {
      var lat, lng, _ref, _ref1;
      var coords = null;
      lat = location.lat || ((_ref = location.coords) != null ? _ref.lat : void 0);
      lng = location.lng || ((_ref1 = location.coords) != null ? _ref1.lng : void 0);
      if (lat && lng) {
        coords = {
          lat: lat,
          lng: lng
        };
      }
      return coords;
    };
    _formatDriverTypeText = function(type) {
      switch (type) {
        case "start":
          return " - Start Address";
        case "end":
          return " - End Address";
      }
      return "";
    };
    _formatBreak = function(driverBreak) {
      var end, start;
      var convert = TimeUtilF.convertTimeToDate;
      start = convert(driverBreak.start || driverBreak['break-start']);
      if (driverBreak.end) {
        end = convert(driverBreak.end);
      } else if (driverBreak['break-duration']) {
        end = TimeUtilF.addMinutes(start, driverBreak['break-duration']);
      } else {
        end = convert(driverBreak['break-end']);
      }
      return {
        id: driverBreak.id || UUID.generate(),
        inTransit: driverBreak['in_transit'],
        start: start,
        end: end
      };
    };
    _formatLocation = function(location, type) {
      location = {
        id: location.id,
        parentId: this.id,
        originalName: this.name,
        name: "" + this.name + " " + (_formatDriverTypeText(type)),
        types: this.types,
        shift: {
          start: this.startShift,
          end: this.endShift
        },
        capacity: this.capacity,
        info: {
          address: location.address,
          coords: _retrieveLocationCoords(location),
          driverMarkerType: type
        },
        initialVisibility: this.visible
      };
      return location;
    };
    _initLocation = function(type) {
      return {
        parentId: this.id,
        originalName: this.name,
        name: "" + this.name + " " + (_formatDriverTypeText(type)),
        types: this.types,
        shift: {
          start: this.startShift,
          end: this.endShift
        },
        capacity: this.capacity,
        initialVisibility: this.visible
      };
    };
    _updateLocation = function(locationKey, newLocation, type) {
      var _base;
      this[locationKey] || (this[locationKey] = _initLocation.call(this, type));
      this[locationKey].id = newLocation.id;
      (_base = this[locationKey]).info || (_base.info = {});
      this[locationKey].info.address = newLocation.address;
      this[locationKey].info.coords = _retrieveLocationCoords(newLocation);
      return this[locationKey].info.driverMarkerType = type;
    };
    DriverMarker = (function() {
      function DriverMarker(entry) {
        var driverBreak, _i, _len, _ref;
        this.id = entry._id;
        this.name = entry.name;
        this.startShift = TimeUtilF.convertTimeToDate(entry['shift-start']);
        this.endShift = TimeUtilF.convertTimeToDate(entry['shift-end']);
        if (entry['phone-number'] != null) {
          this.phoneNumber = entry['phone-number'];
        }
        if (entry.capacity != null) {
          this.capacity = entry.capacity;
        }
        if (entry.types) {
          this.types = [].concat(entry.types);
        }
        this.status = entry.status || Marker.Status.Valid;
        this.error = entry.error || null;
        this.visible = entry.visible != null ? entry.visible : entry.error == null;
        this.createdAt = entry.createdAt || Date.now();
        this.strictStart = entry['strict_start'];
        this.speed = entry.speed;
        this.breaks = [];
        if (entry.vehicleId != null) {
          this.vehicleId = entry.vehicleId;
        }
        if ((entry.breaks != null) && entry.breaks.length > 0) {
          _ref = entry.breaks;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            driverBreak = _ref[_i];
            this.breaks.push(_formatBreak(driverBreak));
          }
        } else if (entry['break-duration'] > 0) {
          this.breaks = [_formatBreak(entry)];
        }
        if (entry['start-location'] != null) {
          this.updateStartLocation(entry['start-location']);
          this.startLocationMarker = new Marker(this.startLocation.info, MARKER_TEMPLATE_URL, this.startLocation);
        }
        if (entry['end-location'] != null) {
          this.updateEndLocation(entry['end-location']);
          this.endLocationMarker = new Marker(this.endLocation.info, MARKER_TEMPLATE_URL, this.endLocation);
        }
      }

      return DriverMarker;

    })();
    DriverMarker.prototype.getVisible = function() {
      if (!this.startLocation) {
        return false;
      }
      return GMarkerF.getVisible(this.startLocation.id);
    };
    DriverMarker.prototype.updateStartLocation = function(location) {
      return _updateLocation.call(this, 'startLocation', location, 'start');
    };
    DriverMarker.prototype.updateEndLocation = function(location) {
      return _updateLocation.call(this, 'endLocation', location, 'end');
    };
    DriverMarker.prototype.addCurrentLocation = function(location, heading) {
      this.currentLocation = {
        id: this.id,
        isDriverLocation: true,
        parentId: this.id,
        name: "" + this.name + " - Last known location",
        heading: heading,
        types: this.types,
        shift: {
          start: this.startShift,
          end: this.endShift
        },
        capacity: this.capacity,
        info: {
          address: location.address,
          coords: {
            lat: location.lat || location.coords.lat,
            lng: location.lng || location.coords.lng
          },
          driverMarkerType: 'current'
        },
        initialVisibility: this.visible
      };
      if (this.currentLocationMarker != null) {
        this.currentLocationMarker.position = this.currentLocation.info;
        return this.currentLocationMarker.parameter = this.currentLocation;
      } else {
        return this.currentLocationMarker = new Marker(this.currentLocation.info, MARKER_TEMPLATE_URL, this.currentLocation);
      }
    };
    DriverMarker.prototype.setVisible = function(isVisible) {
      GMarkerF.setVisible(this.startLocation.id, isVisible);
      if (this.endLocation) {
        GMarkerF.setVisible(this.endLocation.id, isVisible);
      }
      if (this.currentLocation) {
        return GMarkerF.setVisible(this.currentLocation.id, isVisible);
      }
    };
    return DriverMarker;
  };
  DriverMarker.$inject = ["Marker", "TimeUtilF", "GMarkerF", "UUID"];

  angular.module('app').factory('DriverMarker', DriverMarker);

}).call(this);

(function() {
  var DriverS = function($http, $q, AccountF, Constants) {
    var _getFetchDriversQuerystring;
    DriverS = {};
    _getFetchDriversQuerystring = function(drivers) {
      var vehicleList = (drivers.map(function(driver) {
        return driver._id;
      })).join(',');
      if (drivers.length > 0) {
        return "drivers=" + vehicleList;
      } else {
        return "";
      }
    };
    DriverS.fetchDrivers = function(drivers) {
      var authHeader, qs;
      if ((drivers != null ? drivers.length : void 0) > 0) {
        authHeader = AccountF.getAuthHeader();
        qs = drivers ? _getFetchDriversQuerystring(drivers) : "";
        return $http.get("" + Constants.apiPath + "/product/fleet?" + qs, authHeader).then(function(res) {
          return res.data;
        })["catch"](function(err) {
          return $q.reject(err.data);
        });
      } else {
        return $q.when([]);
      }
    };
    DriverS.createDriver = function(driver) {
      var authHeader = AccountF.getAuthHeader();
      return $http.post("" + Constants.apiPath + "/product/fleet", driver, authHeader).then(function(res) {
        return res.data;
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    DriverS.updateDriver = function(driver) {
      var authHeader, id;
      id = driver._id;
      authHeader = AccountF.getAuthHeader();
      return $http.put("" + Constants.apiPath + "/product/fleet/" + id, driver, authHeader).then(function(res) {
        return res.data;
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    return DriverS;
  };
  DriverS.$inject = ["$http", "$q", "AccountF", "Constants"];

  angular.module('app').service('DriverS', DriverS);

}).call(this);

(function() {
  var DriverSorter = function(TimeUtilF, DriverF, RouteS, GanttSettings) {
    var _sortByDepartureTime, _sortByName;
    _sortByName = function(drivers) {
      var sortedDrivers;
      var driverMap = [];
      _.every(drivers, function(d) {
        return driverMap.push({
          id: d.id,
          name: d.name,
          obj: d
        });
      });
      driverMap = driverMap.slice().sort(function(a, b) {
        return a.name.localeCompare(b.name, void 0, {
          numeric: true
        });
      });
      sortedDrivers = _.map(driverMap, 'obj');
      return sortedDrivers;
    };
    _sortByDepartureTime = function(drivers, solution) {
      var sortedDrivers;
      var driverMap = [];
      _.every(drivers, function(d) {
        var driverId, _ref, _ref1;
        var departureTime = null;
        driverId = d.id;
        if ((_ref = solution[driverId]) != null ? _ref[0] : void 0) {
          departureTime = (_ref1 = TimeUtilF.convertTimeToDate(solution[driverId][0].arrival_time)) != null ? _ref1.getTime() : void 0;
        }
        return driverMap.push({
          id: driverId,
          departureTime: departureTime || 0,
          name: d.name,
          obj: d
        });
      });
      driverMap = _.sortBy(driverMap, ['departureTime', 'name']);
      sortedDrivers = _.map(driverMap, 'obj');
      return sortedDrivers;
    };
    DriverSorter = {};
    DriverSorter.getSortedDriverIds = function() {
      var sortedDrivers;
      var drivers = DriverF.getDrivers();
      sortedDrivers = null;
      if (GanttSettings.getSortByDepartureTime()) {
        sortedDrivers = _sortByDepartureTime(drivers, RouteS.getRoute().solution);
      } else {
        sortedDrivers = _sortByName(drivers);
      }
      return _.map(sortedDrivers, 'id');
    };
    return DriverSorter;
  };
  DriverSorter.$inject = ["TimeUtilF", "DriverF", "RouteS", "GanttSettings"];

  angular.module('app').factory('DriverSorter', DriverSorter);

}).call(this);

(function() {
  var StoredDriver,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  StoredDriver = [
    'DriverMarker', function(DriverMarker) {
      StoredDriver = (function(_super) {
        __extends(StoredDriver, _super);

        function StoredDriver(entry) {
          StoredDriver.__super__.constructor.call(this, entry);
          this._id = entry._id;
          this.id = entry.id;
        }

        return StoredDriver;

      })(DriverMarker);
      return StoredDriver;
    }
  ];

  angular.module('app').factory('StoredDriver', StoredDriver);

}).call(this);

(function() {
  var StoredDriverF = function($q, StoredDriver, DriverS, DriverUtil, EventListenersF, Events) {
    StoredDriverF = {};
    StoredDriverF.storedDrivers = {};
    StoredDriverF.upsertInDb = function(driver) {
      var entry, promise, storedDriver;
      if (!driver) {
        return $q.reject(false);
      }
      storedDriver = StoredDriverF.storedDrivers[driver.id];
      entry = DriverUtil.formatDriverEntry(driver);
      promise = null;
      if (storedDriver) {
        entry._id = storedDriver._id;
        promise = DriverS.updateDriver(entry);
      } else {
        promise = DriverS.createDriver(entry);
      }
      return promise.then(function(entry) {
        var newDriver = new StoredDriver(entry);
        StoredDriverF.storedDrivers[newDriver.id] = newDriver;
        return newDriver;
      });
    };
    StoredDriverF.init = function(drivers) {
      var storedDrivers = {};
      return DriverS.fetchDrivers(drivers).then(function(drivers) {
        var driver, entry, _i, _len;
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          entry = drivers[_i];
          driver = new StoredDriver(entry);
          storedDrivers[driver.id] = driver;
        }
        StoredDriverF.storedDrivers = storedDrivers;
        return StoredDriverF.storedDrivers;
      });
    };
    StoredDriverF.getDrivers = function() {
      return StoredDriverF.storedDrivers;
    };
    return StoredDriverF;
  };
  StoredDriverF.$inject = ["$q", "StoredDriver", "DriverS", "DriverUtil", "EventListenersF", "Events"];

  angular.module('app').factory('StoredDriverF', StoredDriverF);

}).call(this);

(function() {
  var CsvUploadError = (function() {
    function CsvUploadError(message) {
      this.message = message;
      this.name = 'CsvUploadError';
    }

    return CsvUploadError;

  })();

  CsvUploadError.prototype = Object.create(Error.prototype);

  angular.module('app').constant('CsvUploadError', CsvUploadError);

}).call(this);

(function() {
  var ProjectTableFilter = function() {
    return function(items, expression) {
      return _.filter(items, function(item) {
        var expressionName, fromPred, itemName, namePred, toPred, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
        namePred = true;
        fromPred = true;
        toPred = true;
        itemName = _.clone((_ref = item.name) != null ? _ref.toLowerCase() : void 0);
        expressionName = _.clone((_ref1 = expression.name) != null ? _ref1.toLowerCase() : void 0);
        if ((itemName != null) && (expressionName != null)) {
          namePred = itemName.indexOf(expressionName) > -1;
        }
        if ((item.date != null) && (((_ref2 = expression.date) != null ? _ref2.fromDate : void 0) != null) && ((_ref3 = expression.date) != null ? _ref3.fromDate : void 0) !== "") {
          fromPred = item.date >= ((_ref4 = expression.date) != null ? _ref4.fromDate : void 0);
        }
        if ((item.date != null) && (((_ref5 = expression.date) != null ? _ref5.toDate : void 0) != null) && ((_ref6 = expression.date) != null ? _ref6.toDate : void 0) !== "") {
          toPred = item.date <= ((_ref7 = expression.date) != null ? _ref7.toDate : void 0);
        }
        return namePred && fromPred && toPred;
      });
    };
  };

  angular.module('app').filter('projectTableFilter', ProjectTableFilter);

}).call(this);

(function() {
  var SortBy = function() {
    return function(items, property) {
      return _.sortBy(items, function(d) {
        return d[property] || '';
      });
    };
  };

  angular.module('app').filter('sortBy', SortBy);

}).call(this);

(function() {
  var AxisChartF = (function() {
    function AxisChartF(target) {
      var selection = target.selection();
      selection.each(function(data) {
        var axis, gAxis, height, margin, svg;
        svg = d3.select(this);
        gAxis = svg.selectAll('g.axis');
        if (gAxis.empty()) {
          margin = target.margin();
          height = target.height() - margin.top - margin.bottom;
          gAxis = svg.append('g').classed('axis', true).classed(target.chartType(), true);
          gAxis.append('g').classed('x', true);
        }
        axis = target.axis();
        return gAxis.select('g.x').transition().call(axis.xAxis);
      });
    }

    return AxisChartF;

  })();

  angular.module('app').factory('AxisChartF', function() {
    return AxisChartF;
  });

}).call(this);

(function() {
  var BarChartEventF = function($state, $translate, GMarkerF, ScrollChartF, GanttConstants, RouteS, MessagingF, Constants, DropZoneEventsF, AnalyticsS, States, EventListenersF, Events, DemoF, LoggerF, ProjectF, AccountF, DispatchF) {
    var MAX_DISTANCE, SCROLL_SPEED, SELECTED_CLASS, SHIFT_KEYCODE, UNSERVED_HEIGHT, _addClickEventListeners, _addDragEventListeners, _addKeyboardEventListener, _addMouseEventListeners, _addStateChangeEventListeners, _clickEventListener, _drag, _dragEnd, _dragEventListener, _fetchUserSolution, _findClosestDriver, _findClosestZone, _getLastDoneStopForVehicle, _getMidTime, _getSelectedVisits, _getServedVisits, _getShadow, _getUnserved, _isDraggableStatus, _isValidMove, _mouseOutEventListener, _mouseOverEventListener, _moveSelectedDates, _parseElem, _rectTransform, _replaceStartDate, _replaceStartEndDates, _retrieveStartEndDates, _selectedAsUnserved, _selectedBar, _selection, _setSelected, _setSelectedDragClass, _setSelectedRange, _setSelectedUnservedRange, _shiftKeyDown, _stateChangeEventListener, _unselectAll, _updateSelectedBar, _updateShadow;
    MAX_DISTANCE = 9007199254740992;
    SCROLL_SPEED = 8;
    SHIFT_KEYCODE = 16;
    UNSERVED_HEIGHT = 50;
    SELECTED_CLASS = 'selected';
    _selection = null;
    _shiftKeyDown = false;
    _selectedBar = null;
    _getServedVisits = function(data) {
      var d, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        d = data[_i];
        if (d.isVisit && d.driverId) {
          _results.push(d);
        }
      }
      return _results;
    };
    _getUnserved = function(data) {
      var d, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        d = data[_i];
        if (d.isVisit && !d.driverId) {
          _results.push(d);
        }
      }
      return _results;
    };

    /*
    Click event listeners
     */
    _setSelected = function(items, isSelected) {
      return items.classed(SELECTED_CLASS, isSelected);
    };
    _setSelectedUnservedRange = function(index1, index2) {
      var count, maxIndex, minIndex;
      minIndex = Math.min(index1, index2);
      maxIndex = Math.max(index1, index2);
      count = 0;
      return _selection.selectAll('g.item').each(function(d) {
        if (!d.driverId && d.index >= minIndex && d.index <= maxIndex) {
          count++;
          d.isShiftSelected = true;
          _setSelected(d3.select(this), true);
          return GMarkerF.setSelected(d.id, true, true);
        }
      });
    };
    _setSelectedRange = function(bar1, bar2) {
      var count, driverId, maxDate, minDate;
      if (!(bar1.driverId === bar2.driverId && bar1.endDate && bar2.endDate)) {
        return;
      }
      driverId = bar1.driverId;
      minDate = new Date(Math.min(bar1.startDate, bar2.startDate));
      maxDate = new Date(Math.max(bar1.endDate, bar2.endDate));
      count = 0;
      return _selection.selectAll('g.item').each(function(d) {
        if (d.driverId === driverId && d.startDate >= minDate && d.endDate && d.endDate <= maxDate) {
          count++;
          d.isShiftSelected = true;
          _setSelected(d3.select(this), true);
          return GMarkerF.setSelected(d.id, true, true);
        }
      });
    };
    _unselectAll = function() {
      return _selection.selectAll('g.item').each(function(d) {
        d.isShiftSelected = false;
        GMarkerF.setSelected(d.id, false);
        return _setSelected(d3.select(this), GMarkerF.getSelected(d.id));
      });
    };
    _getSelectedVisits = function() {
      var selected = [];
      _selection.selectAll('g.item').each(function(d) {
        if ((d.endDate || d.isUnserved) && !d["break"] && d3.select(this).classed(SELECTED_CLASS)) {
          return selected.push(d);
        }
      });
      return selected;
    };
    _clickEventListener = function(target) {
      return function(d) {
        var endDate, lastSelectedDriverId, promise, selectedDriverId;
        if (d3.event.defaultPrevented) {
          return;
        }
        if (GMarkerF.getVisible(d.id)) {
          _unselectAll();
          lastSelectedDriverId = _selectedBar != null ? _selectedBar.driverId : void 0;
          if ((_selectedBar != null) && !lastSelectedDriverId) {
            lastSelectedDriverId = 'unserved';
          }
          selectedDriverId = d.driverId != null ? d.driverId : 'unserved';
          endDate = d.isUnserved ? d.index : d.endDate;
          if (!(_shiftKeyDown && endDate && (lastSelectedDriverId === selectedDriverId))) {
            promise = null;
            if ((_selectedBar != null ? _selectedBar.id : void 0) === d.id) {
              promise = GMarkerF.toggleAndCloseOtherWindow(d.id);
            } else {
              promise = GMarkerF.closeOtherWindow([d.id]).then(function() {
                return GMarkerF.openInfoWindow(d.id);
              });
            }
            return promise.then((function(_this) {
              return function() {
                _setSelected(d3.select(_this), GMarkerF.getSelected(d.id));
                if (GMarkerF.getSelected(d.id) && endDate) {
                  return _selectedBar = d;
                } else {
                  return _selectedBar = null;
                }
              };
            })(this))["catch"](function() {});
          } else if (d.isUnserved) {
            return _setSelectedUnservedRange(_selectedBar.index, d.index);
          } else {
            return _setSelectedRange(_selectedBar, d);
          }
        }
      };
    };
    _addClickEventListeners = function(target) {
      return _selection.selectAll('g.item').on('click', _clickEventListener(target));
    };
    _mouseOverEventListener = function(target) {
      return function(d) {
        if (d3.event.defaultPrevented) {
          return;
        }
        if (GMarkerF.getVisible(d.id)) {
          return GMarkerF.setHovered(d.id, true);
        }
      };
    };
    _mouseOutEventListener = function(target) {
      return function(d) {
        if (d3.event.defaultPrevented) {
          return;
        }
        if (GMarkerF.getVisible(d.id) && !d.isShiftSelected) {
          return GMarkerF.setHovered(d.id, false);
        }
      };
    };
    _addMouseEventListeners = function(target) {
      return _selection.selectAll('g.item').on('mouseover', _mouseOverEventListener(target)).on('mouseout', _mouseOutEventListener(target));
    };
    _stateChangeEventListener = function(selection) {
      return selection.each(function(d) {
        GMarkerF.addEventListener(d.id, 'unselect', 'barChartEvent', (function(_this) {
          return function() {
            if (!d.isShiftSelected) {
              return _setSelected(d3.select(_this), false);
            }
          };
        })(this));
        GMarkerF.addEventListener(d.id, 'mouseover', 'barChartEvent', (function(_this) {
          return function() {
            return _setSelected(d3.select(_this), true);
          };
        })(this));
        return GMarkerF.addEventListener(d.id, 'mouseout', 'barChartEvent', (function(_this) {
          return function() {
            if (!d.isShiftSelected) {
              return _setSelected(d3.select(_this), GMarkerF.getSelected(d.id));
            }
          };
        })(this));
      });
    };
    _addStateChangeEventListeners = function(target) {
      return _selection.selectAll('g.item').call(_stateChangeEventListener);
    };
    _addKeyboardEventListener = function() {
      return d3.select('body').on('keydown', function() {
        if (d3.event.keyCode === SHIFT_KEYCODE) {
          return _shiftKeyDown = true;
        }
      }).on('keyup', function() {
        if (d3.event.keyCode === SHIFT_KEYCODE) {
          return _shiftKeyDown = false;
        }
      });
    };

    /*
    Drag event listeners
     */
    _getMidTime = function(task) {
      var end, start;
      if (task.idleDate) {
        start = task.idleDate.getTime();
      } else {
        start = task.startDate.getTime();
      }
      end = task.endDate.getTime();
      return (end + start) / 2;
    };
    _replaceStartDate = function(task, date) {
      if (task.idleDate) {
        return task.idleDate = date;
      } else {
        return task.startDate = date;
      }
    };
    _rectTransform = function(target, axis, d, elem, ganttY) {
      var x, xCoord;
      xCoord = d.idleDate ? d.idleDate : d.startDate;
      if (xCoord) {
        x = axis.x(xCoord);
      } else {
        x = elem.x;
      }
      return target.translate(x, ganttY || axis.y(d.driverId));
    };
    _parseElem = function(elem) {
      var pos;
      var elemWidth = parseInt(elem.attr("width"), 10);
      pos = d3.transform(elem.attr("transform"));
      return {
        x: pos.translate[0],
        y: pos.translate[1],
        width: elemWidth
      };
    };
    _findClosestZone = function(shadow) {
      if (shadow.x > 0) {
        return GanttConstants.ZONE_TYPE_ROUTE;
      }
      return GanttConstants.ZONE_TYPE_DRIVER;
    };
    _findClosestDriver = function(axis, posY) {
      var diff, distance, index, range, val, yIndex, _i, _len;
      range = axis.y.range();
      yIndex = null;
      distance = MAX_DISTANCE;
      for (index = _i = 0, _len = range.length; _i < _len; index = ++_i) {
        val = range[index];
        diff = Math.abs(posY - val);
        if (distance > diff) {
          yIndex = index;
          distance = diff;
        }
      }
      return axis.y.domain()[yIndex];
    };
    _fetchUserSolution = function(tasks) {
      var id, route, solution, task, unserved, userSolution, visit, visits, _i, _len, _name, _name1, _ref;
      solution = {};
      unserved = {};
      _ref = _getServedVisits(tasks);
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        task = _ref[_i];
        if (task.startDate) {
          if (solution[_name = task.driverId] == null) {
            solution[_name] = [];
          }
          solution[task.driverId].push(task);
        } else {
          if (unserved[_name1 = task.driverId] == null) {
            unserved[_name1] = [];
          }
          unserved[task.driverId].push(task.id);
        }
      }
      userSolution = {};
      for (id in solution) {
        visits = solution[id];
        solution[id] = visits.sort(function(task1, task2) {
          var mid1, mid2;
          mid1 = _getMidTime(task1);
          mid2 = _getMidTime(task2);
          return mid1 - mid2;
        });
        route = (function() {
          var _j, _len1, _ref1, _results;
          _ref1 = solution[id];
          _results = [];
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            visit = _ref1[_j];
            if (visit["break"]) {
              _results.push('nowhere');
            } else {
              _results.push(visit.id);
            }
          }
          return _results;
        })();
        userSolution[id] = {
          route: route
        };
      }
      for (id in unserved) {
        visits = unserved[id];
        if (!(visits)) {
          continue;
        }
        userSolution[id] || (userSolution[id] = {
          route: []
        });
        userSolution[id].unserved = visits;
      }
      return userSolution;
    };
    _getShadow = function() {
      return d3.selectAll("g." + GanttConstants.SHADOW_CLASS);
    };
    _updateShadow = function(width, color, isVisible, transform, isSmooth, onEnd, text) {
      var contentIcon, gShadow, icon, iconX, numDigits, rect, shadow, svgContent, textContent, textWidth, x, y;
      gShadow = _getShadow();
      gShadow.attr('class', "" + GanttConstants.SHADOW_CLASS + " " + color);
      rect = gShadow.selectAll('rect');
      rect.attr('width', width);
      icon = gShadow.selectAll('g.icon');
      iconX = 0;
      textContent = icon.selectAll('text.content');
      svgContent = icon.selectAll('svg.content');
      if (text) {
        textContent = icon.selectAll('text.content');
        textContent.text(text);
        numDigits = Math.log(text) * Math.LOG10E + 1 | 0;
        textWidth = numDigits * GanttConstants.INDEX_TEXT_WIDTH;
        x = (width - textWidth) / 2;
        y = (GanttConstants.INDEX_TEXT_HEIGHT + GanttConstants.ITEM_MARGIN + 6) / 2;
        textContent.attr('transform', "translate(" + x + ", " + y + ")");
        contentIcon = svgContent.selectAll('use');
        contentIcon.remove();
      }
      icon.attr('transform', "translate(" + iconX + ", " + GanttConstants.SHADOW_ICON_Y + ")");
      gShadow.classed(GanttConstants.HIDDEN_CLASS, !isVisible);
      shadow = void 0;
      if (isSmooth) {
        shadow = gShadow.transition();
      } else {
        shadow = gShadow;
      }
      shadow.attr('width', width).attr('transform', transform);
      if (onEnd) {
        return shadow.transition().each("end", onEnd);
      }
    };
    _setSelectedDragClass = function(isDragged) {
      return _selection.selectAll('g.item').each(function(d) {
        if (d3.select(this).classed(SELECTED_CLASS)) {
          return d3.select(this).classed(GanttConstants.DRAG_CLASS, isDragged);
        }
      });
    };
    _isDraggableStatus = function(status) {
      return status === Constants.visitStatusPending;
    };
    _drag = function(target, axis) {
      var that;
      if (!DemoF.isUsableInDemo('dragDrop')) {
        return;
      }
      that = this;
      return function(d) {
        var containerHeight, delta, dispatchForDriverCompleted, dragY, driverId, dropRouteLocked, dropZoneType, elem, elemWidth, ganttMaxY, hasUnserved, maxY, minY, parsedElem, parsedShadow, position, routeLocked, shadow, shadowX, shadowY, unservedHeight, yRange, _ref, _ref1, _ref2;
        that.dragAttempted = true;
        routeLocked = !!((_ref = target.routeLocks()) != null ? _ref[d.driverId] : void 0);
        if (!routeLocked && (_isDraggableStatus(d.visitStatus)) && ((_ref1 = target.chartType()) !== 'live' && _ref1 !== 'debug') && !target.isPastProject()) {
          that.isElemDragged = true;
          elem = d3.select(this);
          if (_selectedBar) {
            _setSelectedDragClass(true);
          } else {
            elem.classed(GanttConstants.DRAG_CLASS, true);
          }
          parsedElem = _parseElem(elem);
          elemWidth = parsedElem.width;
          containerHeight = target.rowHeight() * 3;
          position = -ScrollChartF.getPosition();
          hasUnserved = target.numUnserved() > 0;
          dragY = d3.event.y;
          unservedHeight = hasUnserved ? UNSERVED_HEIGHT : 0;
          if (!d.isUnserved) {
            dragY = dragY + unservedHeight;
          } else {
            dragY = dragY + position;
          }
          delta = 0;
          if (dragY < position) {
            delta = SCROLL_SPEED;
          }
          if (dragY > position + containerHeight) {
            delta = -SCROLL_SPEED;
          }
          if (delta) {
            ScrollChartF.move(delta);
          }
          shadowX = null;
          shadowY = null;
          shadowX = Math.max(-185, Math.min(target.width() - elemWidth, d3.event.x));
          yRange = axis.y.range();
          ganttMaxY = yRange[yRange.length - 1];
          minY = 0;
          maxY = Math.min(dragY, ganttMaxY + unservedHeight);
          shadowY = Math.max(minY, maxY) - position;
          _updateShadow(elemWidth, d.color.name, true, target.translate(shadowX, shadowY), false, null, d.index);
          shadow = _getShadow();
          parsedShadow = _parseElem(shadow);
          parsedShadow.y = parsedShadow.y - unservedHeight + position;
          driverId = _findClosestDriver(axis, parsedShadow.y);
          dropZoneType = _findClosestZone(parsedShadow);
          dropRouteLocked = !!((_ref2 = target.routeLocks()) != null ? _ref2[driverId] : void 0);
          dispatchForDriverCompleted = DispatchF.hasDispatchCompleted(driverId);
          shadow.classed(GanttConstants.LOCKED_CLASS, dropRouteLocked);
          if ((driverId != null) && (dropZoneType != null) && !dropRouteLocked && !dispatchForDriverCompleted) {
            return DropZoneEventsF.activate(driverId, dropZoneType);
          } else {
            return DropZoneEventsF.hide();
          }
        }
      };
    };
    _retrieveStartEndDates = function(driverId) {
      var dates = {};
      _selection.selectAll('g.item').each(function(d) {
        if (d.driverId === driverId && d.endDate) {
          return dates[d.id] = {
            startDate: d.startDate,
            endDate: d.endDate,
            idleDate: d.idleDate
          };
        }
      });
      return dates;
    };
    _replaceStartEndDates = function(dates) {
      _selection.selectAll('g.item').each(function(d) {
        var date;
        if (dates[d.id]) {
          date = dates[d.id];
          d.startDate = date.startDate;
          d.endDate = date.endDate;
          return d.idleDate = date.idleDate;
        }
      });
    };
    _moveSelectedDates = function(selected, targetDriver, date) {
      var current, time, _i, _len, _results;
      time = date.getTime();
      selected = _.sortBy(selected, function(d) {
        return d.startDate;
      });
      _results = [];
      for (_i = 0, _len = selected.length; _i < _len; _i++) {
        current = selected[_i];
        current.driverId = targetDriver;
        _replaceStartDate(current, new Date(time++));
        _results.push(current.endDate = new Date(time++));
      }
      return _results;
    };
    _selectedAsUnserved = function(selected, targetDriver) {
      var current, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = selected.length; _i < _len; _i++) {
        current = selected[_i];
        current.driverId = targetDriver;
        current.idleDate = null;
        current.startDate = null;
        _results.push(current.endDate = null);
      }
      return _results;
    };
    _getLastDoneStopForVehicle = function(vehicleId, data) {
      var idx, lastStop, maxStopIdx, stop, _i, _len;
      maxStopIdx = 0;
      lastStop = null;
      for (idx = _i = 0, _len = data.length; _i < _len; idx = ++_i) {
        stop = data[idx];
        if (stop.driverId === vehicleId && (stop.index != null) && stop.index >= maxStopIdx && stop.visitStatus !== Constants.visitStatusPending) {
          lastStop = stop;
          maxStopIdx = stop.index;
        }
      }
      return lastStop;
    };
    _isValidMove = function(target, dropDate, lastDoneStopDate) {
      var errKey, isAfterLastDone;
      isAfterLastDone = (lastDoneStopDate == null) || dropDate > lastDoneStopDate;
      errKey = null;
      if (!isAfterLastDone) {
        errKey = "MESSAGES.INVALID_DROP_BEFORE_LAST_UPDATED";
      }
      return [isAfterLastDone, errKey];
    };
    _dragEnd = function(target, axis, data) {
      var that = this;
      return function(d) {
        var dispatchForDriverCompleted, draggedToUnserved, driverId, dropRouteLocked, elem, errKey, ganttY, hasUnserved, lastDoneStop, lastStopDate, moveType, noChanges, numSelected, onEnd, originalDriverId, parsedShadow, position, previousSolution, projectId, routeLocked, selectedBars, shadow, startDate, startEndDates, transform, unserved, unservedHeight, userEmail, userSolution, validMove, visitDriverId, x, _goToEditRoute, _goToNewProject, _ref, _ref1, _ref2, _ref3, _ref4;
        originalDriverId = d.driverId;
        routeLocked = !!((_ref = target.routeLocks()) != null ? _ref[originalDriverId] : void 0);
        dispatchForDriverCompleted = DispatchF.hasDispatchCompleted(originalDriverId);
        if (that.dragAttempted) {
          if (target.isPastProject()) {
            _goToNewProject = function() {
              return $state.go(States.modalProjectsNew);
            };
            MessagingF.replaceInfo("MESSAGES.CANNOT_MODIFY_PAST_PROJECT", null, null, "MESSAGES.START_NEW_PROJECT", _goToNewProject);
          } else if (target.chartType() === 'live') {
            _goToEditRoute = function() {
              return $state.go(States.projectRouteEdit);
            };
            MessagingF.replaceInfo("MESSAGES.SWITCH_TO_EDIT_MODE", null, null, "MESSAGES.GO_TO_PLAN_MODE", _goToEditRoute);
          } else if (target.chartType() === 'debug') {
            MessagingF.replaceInfoPopup("MESSAGES.CANNOT_MODIFY_DEBUG_PROJECT");
          } else if (routeLocked) {
            MessagingF.replaceWarning("MESSAGES.CANNOT_MODIFY_LOCKED_ROUTE");
          } else if (dispatchForDriverCompleted) {
            MessagingF.replaceWarning("MESSAGES.CANNOT_MODIFY_COMPLETED_ROUTE");
          }
        }
        that.dragAttempted = false;
        if (!(that.isElemDragged && _isDraggableStatus(d.visitStatus) && !target.isPastProject() && !routeLocked)) {
          return;
        }
        d3.event.sourceEvent.stopPropagation();
        elem = d3.select(this);
        shadow = _getShadow();
        parsedShadow = _parseElem(shadow);
        position = -ScrollChartF.getPosition();
        hasUnserved = target.numUnserved() > 0;
        unservedHeight = hasUnserved ? UNSERVED_HEIGHT : 0;
        ganttY = parsedShadow.y - unservedHeight + position;
        onEnd = function() {
          if (_selectedBar) {
            _setSelectedDragClass(false);
          } else {
            elem.classed(GanttConstants.DRAG_CLASS, false);
          }
          return _updateShadow(0, '', false, 'translate(0,0)', false, null, '');
        };
        driverId = _findClosestDriver(axis, ganttY);
        dropRouteLocked = !!((_ref1 = target.routeLocks()) != null ? _ref1[driverId] : void 0);
        if (dropRouteLocked) {
          MessagingF.replaceWarning("MESSAGES.ROUTE_LOCKED");
        }
        dispatchForDriverCompleted = DispatchF.hasDispatchCompleted(driverId);
        if (dispatchForDriverCompleted) {
          MessagingF.replaceWarning("MESSAGES.ROUTE_ALREADY_COMPLETED");
        }
        draggedToUnserved = parsedShadow.y < unservedHeight && hasUnserved;
        if (driverId && !dropRouteLocked && !dispatchForDriverCompleted && !draggedToUnserved) {
          previousSolution = void 0;
          if (d.driverId === driverId) {
            previousSolution = _fetchUserSolution(data);
            startEndDates = _retrieveStartEndDates(driverId);
          }
          selectedBars = _getSelectedVisits();
          if (!_.find(selectedBars, {
            id: d.id
          })) {
            selectedBars = [d];
          }
          numSelected = selectedBars.length;
          validMove = true;
          moveType = void 0;
          projectId = ProjectF.project.id;
          userEmail = AccountF.getUser().email;
          if (_findClosestZone(parsedShadow) === GanttConstants.ZONE_TYPE_ROUTE) {
            moveType = 'route';
            startDate = axis.x.invert(parsedShadow.x);
            lastDoneStop = _getLastDoneStopForVehicle(driverId, data);
            lastStopDate = (lastDoneStop != null ? lastDoneStop.endDate : void 0) || (lastDoneStop != null ? lastDoneStop.startDate : void 0);
            _ref2 = _isValidMove(target, startDate, lastStopDate), validMove = _ref2[0], errKey = _ref2[1];
            if (validMove) {
              _moveSelectedDates(selectedBars, driverId, startDate);
            }
          } else {
            moveType = 'driver';
            _selectedAsUnserved(selectedBars, driverId);
          }
          userSolution = _fetchUserSolution(data);
          noChanges = previousSolution && JSON.stringify(previousSolution) === JSON.stringify(userSolution);
          if (!noChanges && validMove && moveType === 'route') {
            AnalyticsS.track('046 Drag into a route schedule', {
              "project_id": projectId,
              "user_email": userEmail,
              "before_first_dispatch": !DispatchF.hasDispatches()
            });
          } else if (!noChanges && moveType === 'driver') {
            AnalyticsS.track('047 Drag to driver', {
              "project_id": projectId,
              "user_email": userEmail,
              "before_first_dispatch": !DispatchF.hasDispatches()
            });
          }
          if (!validMove) {
            if (errKey) {
              MessagingF.replaceWarning(errKey);
            }
            transform = _rectTransform(target, axis, d, parsedShadow, parsedShadow.y);
          } else if (noChanges) {
            _replaceStartEndDates(startEndDates);
            transform = _rectTransform(target, axis, d, null, parsedShadow.y);
          } else {
            visitDriverId = (_ref3 = GMarkerF.get(d.id)) != null ? (_ref4 = _ref3.marker) != null ? _ref4.driverId : void 0 : void 0;
            if (numSelected <= 1 && !GMarkerF.getSelected(d.id)) {
              _unselectAll();
              GMarkerF.closeOtherWindow([d.id]).then(function() {
                return GMarkerF.openInfoWindow(d.id);
              }).then((function(_this) {
                return function() {
                  return _setSelected(d3.select(_this), true);
                };
              })(this));
              _selectedBar = d;
            }
            userSolution = _fetchUserSolution(data);
            unserved = _getUnserved(data);
            target.onSolutionUpdated(userSolution, unserved);
            transform = _rectTransform(target, axis, d, parsedShadow, parsedShadow.y);
            onEnd = void 0;
          }
        } else if (d.unservedIndex != null) {
          x = (d.unservedIndex * GanttConstants.UNSERVED_WIDTH) + (GanttConstants.UNSERVED_MARGIN * d.unservedIndex) + d.leftMargin;
          transform = "translate(" + x + ",0)";
        } else {
          transform = _rectTransform(target, axis, d, null, parsedShadow.y);
        }
        _updateShadow(parsedShadow.width, d.color.name, true, transform, true, onEnd, null);
        LoggerF.info(LoggerF.ACTIONS.DRAGGED_STOP, {
          stop_id: d.id,
          from_driver: originalDriverId,
          to_driver: driverId
        });
        that.isElemDragged = false;
        return DropZoneEventsF.hide();
      };
    };
    _dragEventListener = function(target, data) {
      var axis = target.axis();
      this.isElemDragged = false;
      return d3.behavior.drag().on('drag', _drag.call(this, target, axis)).on('dragend', _dragEnd.call(this, target, axis, data)).origin(function() {
        return _parseElem(d3.select(this));
      });
    };
    _addDragEventListeners = function(target, data) {
      return _selection.selectAll('g.visit').call(_dragEventListener(target, data));
    };
    _updateSelectedBar = function(data) {
      if (_selectedBar) {
        return _selectedBar = _.find(data, {
          id: _selectedBar.id
        });
      }
    };
    RouteS.addRouteUpdatedEventListener(_unselectAll);
    BarChartEventF = function(target, data, selection) {
      _selection = selection;
      _addClickEventListeners(target);
      _addMouseEventListeners(target);
      _addDragEventListeners(target, data);
      _addStateChangeEventListeners(target);
      _addKeyboardEventListener();
      return _updateSelectedBar(data);
    };
    return BarChartEventF;
  };
  BarChartEventF.$inject = ["$state", "$translate", "GMarkerF", "ScrollChartF", "GanttConstants", "RouteS", "MessagingF", "Constants", "DropZoneEventsF", "AnalyticsS", "States", "EventListenersF", "Events", "DemoF", "LoggerF", "ProjectF", "AccountF", "DispatchF"];

  angular.module('app').factory('BarChartEventF', BarChartEventF);

}).call(this);

(function() {
  var BarChartF = function($translate, RouteInspectorF, Constants, RouteS, GMarkerF, GanttConstants, BuildVisitsF, GanttUtilF, TimeUtilF) {
    var FLAG_ICON, MAX_DISTANCE, ROUTE_INVISIBLE_CLASS, SELECTED_CLASS, TRUCK_ICON, VISIT_ICON, _addVisibilityEventListener, _customizeBreaks, _customizeDepots, _drawBreaks, _drawDepots, _generateDepotInfo, _getBreaks, _getDepots, _getVisitStart, _getVisitWidth, _insertDepotImage, _insertIcon, _insertIcons, _rectTransform, _upsertItems;
    MAX_DISTANCE = 9007199254740992;
    VISIT_ICON = 'visit-icon';
    TRUCK_ICON = 'icon-driver';
    FLAG_ICON = 'icon-finish';
    SELECTED_CLASS = 'selected';
    ROUTE_INVISIBLE_CLASS = Constants.routeInvisibleCSS;
    _addVisibilityEventListener = function(id, selection) {
      return RouteS.addVisibilityEventListener(id, function(isVisible) {
        return selection.classed(ROUTE_INVISIBLE_CLASS, !isVisible);
      });
    };
    _rectTransform = function(target, axis, d) {
      var end, start, xDate;
      start = _getVisitStart(d);
      end = d.endDate;
      xDate = end > start ? start : end;
      return target.translate(axis.x(xDate), axis.y(d.driverId));
    };
    _getVisitStart = function(d) {
      var startDate;
      if (d.idleDate) {
        startDate = d.idleDate;
      } else {
        startDate = d.startDate;
      }
      return startDate;
    };
    _getVisitWidth = function(axis, d) {
      var start = _getVisitStart(d);
      if (d.endDate > start) {
        return axis.x(d.endDate) - axis.x(start);
      } else {
        return 5;
      }
    };
    _getDepots = function(data) {
      var d, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        d = data[_i];
        if (!d.isVisit && !d.isUnserved) {
          _results.push(d);
        }
      }
      return _results;
    };
    _getBreaks = function(data) {
      var d, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        d = data[_i];
        if (d["break"]) {
          _results.push(d);
        }
      }
      return _results;
    };
    _generateDepotInfo = function(axis, depot) {
      var icon, size, x, y;
      x = axis.x(depot.startDate);
      if (depot.isStartDepot) {
        x -= GanttConstants.DEPOT_SIZE;
      }
      y = axis.y(depot.driverId) + GanttConstants.DEPOT_MARGIN;
      size = GanttConstants.DEPOT_SIZE;
      icon = {
        size: GanttConstants.ICON_SIZE,
        x: (size - GanttConstants.ICON_SIZE) / 2,
        y: (size - GanttConstants.ICON_SIZE) / 2
      };
      if (depot.isStartDepot) {
        icon.name = TRUCK_ICON;
      } else {
        icon.name = FLAG_ICON;
      }
      return {
        x: x,
        y: y,
        size: size,
        icon: icon,
        color: depot.color
      };
    };
    _insertDepotImage = function(selection, depotInfo) {
      var icon;
      var bullet = selection.append('rect').classed('depot-bullet', true).attr('rx', 5).attr('ry', 5).style('stroke', "black").style('stroke-width', "1").style('stroke-opacity', "0.1").attr('height', depotInfo.size).attr('width', depotInfo.size);
      icon = selection.append('g').classed('icon', true);
      icon.append('svg').attr('width', depotInfo.icon.size).attr('height', depotInfo.icon.size).append('use').attr('xlink:href', "#" + depotInfo.icon.name);
      return icon.transition().attr('transform', "translate(" + depotInfo.icon.x + ", " + depotInfo.icon.y + ")");
    };
    _customizeDepots = function(target) {
      var axis = target.axis();
      return function(selection) {
        return selection.each(function(d) {
          var bullet, depotTipIndex, depotTipText, gDepot, gWarning, iUse, info, isVisible, size, warningIcon, warnings, x, y;
          gDepot = d3.select(this);
          isVisible = GMarkerF.getVisible(d.id);
          if (isVisible == null) {
            isVisible = true;
          }
          depotTipIndex = d.isStartDepot ? $translate.instant("CONSTANTS.START") : $translate.instant("CONSTANTS.END");
          depotTipText = TimeUtilF.dateToHhMm(d.startDate || d.endDate);
          gDepot.attr('class', 'depot item gantt-tooltip').classed(d.color.name, true).classed(ROUTE_INVISIBLE_CLASS, !isVisible).attr('data-tooltip-index', depotTipIndex).attr('data-tooltip-text', depotTipText).attr('data-tooltip-color', d.color.name).attr('data-tooltip-pos', 'top');
          info = _generateDepotInfo(axis, d);
          size = GanttConstants.DEPOT_SIZE;
          gDepot.transition().attr('transform', "translate(" + info.x + ", " + info.y + ")");
          _addVisibilityEventListener(d.driverId, gDepot);
          bullet = gDepot.selectAll('rect.depot-bullet');
          if (bullet.empty()) {
            _insertDepotImage(gDepot, info);
          }
          warnings = RouteInspectorF.getWarnings(d.driverId);
          gWarning = gDepot.selectAll('g.warning');
          if ((warnings != null ? warnings.length : void 0) > 0) {
            if (gWarning.empty()) {
              gWarning = gDepot.append('g').classed('warning', true);
              gWarning.append('svg').attr('width', GanttConstants.ICON_SIZE).attr('height', GanttConstants.ICON_SIZE).append('use');
              x = -(GanttConstants.ICON_SIZE / 3);
              y = size - (GanttConstants.ICON_SIZE / 2) - 3;
              gWarning.attr('transform', "translate(" + x + ", " + y + ")");
            }
            iUse = gWarning.selectAll('use');
            warningIcon = GanttUtilF.getWarningIcon(warnings);
            return iUse.attr('xlink:href', "#" + warningIcon);
          } else {
            return gWarning.remove();
          }
        });
      };
    };
    _customizeBreaks = function(target) {
      var rowHeight;
      var axis = target.axis();
      rowHeight = target.rowHeight();
      return function(selection) {
        return selection.each(function(d) {
          var driverYPos, gIcon, gIndex, gSvg, gTooltip, gVisit, gWarning, height, iUse, isFirstRow, isUnserved, isVisible, minContentWidth, popUp, popUpSvg, popupWidth, rect, selected, text, transform, warningIcon, warnings, width, x, y;
          gVisit = d3.select(this);
          height = GanttConstants.VISIT_HEIGHT;
          driverYPos = axis.y(d.driverId);
          isFirstRow = driverYPos < rowHeight;
          width = null;
          isUnserved = !d.driverId;
          transform = _rectTransform(target, axis, d);
          width = _getVisitWidth(axis, d);
          isVisible = GMarkerF.getVisible(d.breakVisibilityRefId);
          if (isVisible == null) {
            isVisible = true;
          }
          selected = GMarkerF.getSelected(d.id);
          gVisit.attr('class', 'break item').classed(SELECTED_CLASS, selected).classed(d.color.name, true).classed(ROUTE_INVISIBLE_CLASS, !isVisible).classed(GanttConstants.DRAG_CLASS, false);
          _addVisibilityEventListener(d.driverId, gVisit);
          gVisit.transition().attr('transform', transform).attr('width', width);
          rect = gVisit.selectAll('rect.bar');
          if (rect.empty()) {
            rect = gVisit.append('rect').classed('bar', true).attr('rx', 5).attr('ry', 5);
          }
          rect.classed('unserved', isUnserved).transition().attr('height', height).attr('width', width).attr('y', GanttConstants.ITEM_MARGIN);
          gIcon = gVisit.selectAll('g.icon');
          minContentWidth = GanttConstants.ICON_SIZE;
          text = String(d.index);
          if (gIcon.empty()) {
            gIcon = gVisit.append('g').classed('icon', true);
          }
          gSvg = gIcon.selectAll('svg');
          if (width >= minContentWidth) {
            if (gSvg.empty()) {
              gIcon.append('svg').attr('width', GanttConstants.ICON_SIZE).attr('height', GanttConstants.ICON_SIZE).append('use').attr('xlink:href', function(d) {
                return "#" + GanttConstants.BREAK_ICON;
              });
            }
            x = (width - GanttConstants.ICON_SIZE) / 2;
            y = ((height - GanttConstants.ICON_SIZE) / 2) + GanttConstants.ITEM_MARGIN - 1;
            gIcon.transition().attr('transform', "translate(" + x + ", " + y + ")");
          } else {
            gSvg.remove();
          }
          gTooltip = gVisit.selectAll('g.tooltip');
          popupWidth = minContentWidth + GanttConstants.POPUP_TEXT_PADDING;
          if (gTooltip.empty()) {
            gTooltip = gVisit.append('g').classed('tooltip', true);
            gTooltip.append('rect').classed('content', true).attr('style', "fill: #FFFFFF").style('stroke', "black").style('stroke-width', "1").style('stroke-opacity', "0.2").attr('rx', GanttConstants.POPUP_BORDER_RADIUS).attr('ry', GanttConstants.POPUP_BORDER_RADIUS).attr('height', GanttConstants.POPUP_TEXT_HEIGHT);
            gIndex = gTooltip.append('g').classed('index', true);
            gIndex.append('svg').attr('width', GanttConstants.TOOLTIP_ICON_SIZE).attr('height', GanttConstants.TOOLTIP_ICON_SIZE).append('use').attr('xlink:href', function(d) {
              return "#" + GanttConstants.BREAK_ICON;
            });
          }
          gTooltip.classed('below', isFirstRow);
          popUp = gTooltip.selectAll('rect.content');
          popUp.attr('width', popupWidth).attr('x', (width - popupWidth) / 2);
          popUpSvg = gTooltip.selectAll('g.index');
          x = (width - GanttConstants.TOOLTIP_ICON_SIZE) / 2;
          popUpSvg.attr('transform', "translate(" + x + ", 2)");
          warnings = RouteInspectorF.getBreakWarnings(d.driverId);
          gWarning = gVisit.selectAll('g.warning');
          if ((warnings != null ? warnings.length : void 0) > 0) {
            if (gWarning.empty()) {
              gWarning = gVisit.append('g').classed('warning', true);
              gWarning.append('svg').attr('width', GanttConstants.ICON_SIZE).attr('height', GanttConstants.ICON_SIZE).append('use');
            }
            x = -(GanttConstants.ICON_SIZE / 3);
            y = height - (GanttConstants.ICON_SIZE / 2) + GanttConstants.ITEM_MARGIN;
            gWarning.attr('transform', "translate(" + x + ", " + y + ")");
            iUse = gWarning.selectAll('use');
            warningIcon = GanttUtilF.getWarningIcon(warnings);
            return iUse.attr('xlink:href', "#" + warningIcon);
          } else {
            return gWarning.remove();
          }
        });
      };
    };
    _insertIcon = function(path, id, selection) {
      return d3.xml(path, 'image/svg+xml', function(err, doc) {
        var g, svg;
        if (err) {
          return;
        }
        svg = doc.getElementsByTagName('svg')[0];
        return g = selection.append('g').attr('id', id).html(svg.outerHTML);
      });
    };
    _insertIcons = function(selection) {
      _insertIcon('img/icon-visit.svg', VISIT_ICON, selection);
      _insertIcon('img/icon-break.svg', GanttConstants.BREAK_ICON, selection);
      _insertIcon('img/warning.svg', GanttConstants.WARNING_ICON, selection);
      _insertIcon('img/icon-visit-new.svg', GanttConstants.NEW_VISIT_ICON, selection);
      _insertIcon('img/clock.svg', GanttConstants.CLOCK_ICON, selection);
      _insertIcon('img/driver-new.svg', TRUCK_ICON, selection);
      return _insertIcon('img/flag.svg', FLAG_ICON, selection);
    };
    _drawDepots = function(selection, target, data) {
      var current, customDepot, startDepots;
      startDepots = _getDepots(data);
      customDepot = _customizeDepots(target);
      current = selection.selectAll('g.depot').data(startDepots, function(d) {
        return d.id;
      }).call(customDepot);
      current.enter().append('g').call(customDepot);
      return current.exit().remove();
    };
    _drawBreaks = function(selection, target, data) {
      var current, customBreak, newRect;
      var breaks = _getBreaks(data);
      customBreak = _customizeBreaks(target);
      current = selection.selectAll('g.break').data(breaks, function(d) {
        return d.id;
      }).call(customBreak);
      newRect = current.enter().append("g").call(customBreak);
      return current.exit().remove();
    };
    _upsertItems = function(target, data) {
      var defs, forUnserved, gGantt, gItems;
      gGantt = d3.select(this);
      gItems = gGantt.selectAll('g.items');
      if (gItems.empty()) {
        gItems = gGantt.append('g').classed('items', true);
      }
      _drawDepots(gItems, target, data);
      BuildVisitsF(gItems, target, data, forUnserved = false);
      _drawBreaks(gItems, target, data);
      defs = gItems.selectAll('defs');
      if (defs.empty()) {
        return gItems.append('defs').call(_insertIcons);
      }
    };
    BarChartF = function(target, selection) {
      return selection.each(function(data) {
        return _upsertItems.call(this, target, data);
      });
    };
    return BarChartF;
  };
  BarChartF.$inject = ["$translate", "RouteInspectorF", "Constants", "RouteS", "GMarkerF", "GanttConstants", "BuildVisitsF", "GanttUtilF", "TimeUtilF"];

  angular.module('app').factory('BarChartF', BarChartF);

}).call(this);

(function() {
  var CellsChartF = (function() {
    var TICK_BUFFER, _createCell, _customizeCells, _findMinTime, _generateCells, _upsertCells;

    TICK_BUFFER = 100;

    _createCell = function(coordY, x, y, width, height, routeLocked) {
      var classes, oddEvenRow;
      oddEvenRow = coordY % 2 === 0 ? 'odd' : 'even';
      classes = "" + oddEvenRow + "-row";
      return {
        id: "(" + coordY + ")",
        x: x,
        y: y,
        width: width,
        height: height,
        classes: classes,
        routeLocked: routeLocked
      };
    };

    _findMinTime = function(data) {
      var current, date, min, _i, _len;
      min = null;
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        current = data[_i];
        date = current.startDate;
        if (!min || date < min) {
          min = date;
        }
      }
      return min;
    };

    _generateCells = function(target, data) {
      var axis, cells, domain, driverId, height, i, lastTick, leftMargin, max, min, numMajorTicks, range, routeLocked, width, xCellWidth, xRange, y, yDiff, _i, _ref;
      cells = [];
      axis = target.axis();
      range = axis.y.range();
      domain = axis.y.domain();
      height = target.rowHeight();
      leftMargin = target.margin().left;
      numMajorTicks = axis.x.ticks().length;
      lastTick = axis.x.ticks()[numMajorTicks - 1];
      xRange = axis.x.range();
      xCellWidth = (xRange[1] - xRange[0]) / numMajorTicks;
      width = (xCellWidth * 2) + axis.x(lastTick) + TICK_BUFFER;
      yDiff = range[1] - range[0] || height;
      i = 0;
      min = axis.y.range()[0] - 1;
      max = Math.max(target.height(), axis.y.rangeExtent()[1]);
      for (y = _i = min; yDiff > 0 ? _i < max : _i > max; y = _i += yDiff) {
        driverId = domain[i];
        routeLocked = false;
        if (driverId) {
          routeLocked = !!((_ref = target.routeLocks()) != null ? _ref[driverId] : void 0);
        }
        cells.push(_createCell(i, -leftMargin, y, leftMargin + width, height, routeLocked));
        i++;
      }
      return cells;
    };

    _customizeCells = function(selection) {
      return selection.each(function(d) {
        var rect = d3.select(this);
        return rect.classed('cell', true).attr('transform', "translate(" + d.x + ", " + d.y + ")").attr('width', d.width).attr('height', d.height).classed(d.classes, true).classed('locked', d.routeLocked);
      });
    };

    _upsertCells = function(target, data) {
      var current, gCells, gContent;
      var cells = _generateCells(target, data);
      gContent = d3.select(this);
      gCells = gContent.selectAll('g.cells');
      if (gCells.empty()) {
        gCells = gContent.append('g').classed('cells', true);
      }
      current = gCells.selectAll('rect.cell').data(cells, function(d) {
        return d.id;
      }).call(_customizeCells);
      current.enter().append('rect').call(_customizeCells);
      return current.exit().remove();
    };

    function CellsChartF(target, selection) {
      selection.each(function(data) {
        return _upsertCells.call(this, target, data);
      });
    }

    return CellsChartF;

  })();

  angular.module('app').factory('CellsChartF', function() {
    return CellsChartF;
  });

}).call(this);

(function() {
  var ClockLineS = function($interval, TimeUtilF, GanttConstants, ProjectTimezoneF) {
    var TICK_INTERVAL, axis, moveInterval, _getCurrentProjectNormalizedTime, _initClock;
    TICK_INTERVAL = 30000;
    moveInterval = null;
    axis = null;
    _initClock = function(target) {
      return function(selection) {
        selection.classed('clock', true).append('svg:rect').classed('clock-line', true).attr('width', "3").attr('height', target.rowHeight() * (GanttConstants.MAX_ROWS + 1)).attr('transform', "translate(2, 20)");
        return selection.append('svg:polygon').classed('clock-top-marker', true).attr('width', "9").attr('height', "5").attr('transform', "translate(-1, -8)").attr('points', "0 -6.95697564e-17 9 -6.95697564e-17 4.5 5");
      };
    };
    _getCurrentProjectNormalizedTime = function() {
      return TimeUtilF.normalizeDateMonthYear(ProjectTimezoneF.getCurrentProjectTime());
    };
    ClockLineS = function(target) {
      var selection = target.selection();
      return selection.each(function(data) {
        var gClock, gGantt, now, xPos, _moveClock;
        gGantt = d3.select(this);
        axis = target.axis();
        gClock = gGantt.selectAll('g.clock');
        if (gClock.empty()) {
          now = _getCurrentProjectNormalizedTime();
          xPos = axis.x(now);
          if (xPos > 0) {
            gClock = gGantt.append('g').attr('transform', "translate(" + xPos + ", -10)").call(_initClock(target));
          }
        }
        _moveClock = function() {
          now = _getCurrentProjectNormalizedTime();
          xPos = axis.x(now);
          if (!gClock.empty()) {
            return gClock.attr('transform', "translate(" + xPos + ", -10)");
          }
        };
        if (moveInterval != null) {
          $interval.cancel(moveInterval);
        }
        _moveClock();
        return moveInterval = $interval(_moveClock, TICK_INTERVAL);
      });
    };
    return ClockLineS;
  };
  ClockLineS.$inject = ["$interval", "TimeUtilF", "GanttConstants", "ProjectTimezoneF"];

  angular.module('app').service('ClockLineS', ClockLineS);

}).call(this);

(function() {
  var ContentChartS = function(LineChartF, LabelChartF, BarChartF, CellsChartF, ScrollBarF, ScrollChartF, TickLinesChartF, UnservedRowChartF, DropZoneChartF, GMarkerF, DragShadowF, BarChartEventF) {
    var _addMarkerClickListener, _addMarkerClickListeners, _addMouseListener, _bottomX, _customizeClipPath, _initCanvas, _onMouseScroll, _scrollContentListener, _scrollX;
    _scrollX = 0;
    _bottomX = 0;
    _addMarkerClickListeners = function(target, data) {
      var d, _i, _len, _results;
      var axis = target.axis();
      _results = [];
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        d = data[_i];
        _results.push(_addMarkerClickListener(d, axis));
      }
      return _results;
    };
    _addMarkerClickListener = function(d, axis) {
      return GMarkerF.addEventListener(d.id, 'click', 'contentChartS', (function(_this) {
        return function() {
          if (!d.isUnserved) {
            return ScrollChartF.setPosition(axis.y(d.driverId) * -1);
          }
        };
      })(this));
    };
    _scrollContentListener = function(selection) {
      return function(position, event) {
        if (event === 'reset') {
          return selection.transition().attr('transform', "translate(0, " + position + ")");
        } else {
          return selection.attr('transform', "translate(0, " + position + ")");
        }
      };
    };
    _onMouseScroll = function(target, selection) {
      return function() {
        var delta, event, speed, wheelDelta;
        event = d3.event;
        if (event.preventDefault) {
          event.preventDefault();
        }
        if (event.stopPropagation) {
          event.stopPropagation();
        }
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }
        wheelDelta = (-event.deltaY * 2.5) || -event.detail;
        speed = ScrollChartF.SCROLL_SPEED;
        delta = Math.max(-speed, Math.min(speed, wheelDelta));
        ScrollChartF.move(delta);
        return false;
      };
    };
    _addMouseListener = function(target) {
      return function(selection) {
        var scroll = _onMouseScroll(target, selection);
        return selection.on('mousewheel', scroll).on('DOMMouseScroll', scroll).on('wheel', scroll).on('onmousewheel', scroll);
      };
    };
    _initCanvas = function(target) {
      return function(selection) {
        var gContent;
        selection.classed('canvas', true).append('g').classed('clip', true).attr('clip-path', 'url(#clip)').append('g').classed('content', true);
        selection.append('g').classed('unserved', true);
        gContent = selection.selectAll('g.content');
        gContent.call(_addMouseListener(target));
        return ScrollChartF.addListener(_scrollContentListener(gContent));
      };
    };
    _customizeClipPath = function(target) {
      var width, x;
      var margin = target.margin();
      width = target.width() + margin.left + margin.right;
      x = -margin.left;
      return function(selection) {
        var clip, defs;
        defs = selection.selectAll('defs.content');
        if (defs.empty()) {
          selection.append('defs').classed('content', true).append('svg:clipPath').attr('id', 'clip').append('svg:rect').attr('id', 'clip-rect').attr('width', width).attr('height', 500).attr('x', x).attr('y', 0);
        }
        return clip = selection.selectAll('defs.content');
      };
    };
    ContentChartS = function(target) {
      var selection = target.selection();
      return selection.each(function(data) {
        var contentHeight, gCanvas, gClip, gContent, gGantt, gUnserved, numDrivers, unservedRowHeight;
        unservedRowHeight = target.numUnserved() > 0 ? target.rowHeight() : 0;
        gGantt = d3.select(this);
        gCanvas = gGantt.selectAll('g.canvas');
        if (gCanvas.empty()) {
          gCanvas = gGantt.append('g').call(_initCanvas(target));
        }
        gCanvas.selectAll('g.clip').attr('transform', "translate(0, " + unservedRowHeight + ")");
        gUnserved = gCanvas.selectAll('g.unserved');
        gContent = gCanvas.selectAll('g.content');
        numDrivers = target.getDriverIds(data).length;
        contentHeight = numDrivers * target.rowHeight();
        ScrollChartF.setMinPosition(target.height() - unservedRowHeight - contentHeight);
        gContent.data([data]);
        gUnserved.data([data]);
        UnservedRowChartF(target, gUnserved);
        CellsChartF(target, gContent);
        TickLinesChartF(target, gContent);
        DropZoneChartF(target, gContent);
        LineChartF(target, gContent);
        LabelChartF(target, gContent);
        BarChartF(target, gContent);
        DragShadowF(gCanvas);
        ScrollBarF(target, gContent);
        BarChartEventF(target, data, gCanvas);
        gClip = gCanvas.selectAll('g.clip');
        gClip.call(_customizeClipPath(target));
        return _addMarkerClickListeners(target, data);
      });
    };
    return ContentChartS;
  };
  ContentChartS.$inject = ["LineChartF", "LabelChartF", "BarChartF", "CellsChartF", "ScrollBarF", "ScrollChartF", "TickLinesChartF", "UnservedRowChartF", "DropZoneChartF", "GMarkerF", "DragShadowF", "BarChartEventF"];

  angular.module('app').service('ContentChartS', ContentChartS);

}).call(this);

(function() {
  var DragShadowF = function(GanttConstants) {
    var _drawDragShadow, _resetDragShadow;
    _resetDragShadow = function(selection) {
      var rect;
      selection.attr('class', "" + GanttConstants.SHADOW_CLASS).classed(GanttConstants.HIDDEN_CLASS, true).attr('transform', 'translate(0,0)');
      rect = selection.selectAll('rect');
      if (rect) {
        return rect.attr('width', 0);
      }
    };
    _drawDragShadow = function(selection) {
      var gIcon, newShadow, shadow;
      shadow = selection.selectAll("g." + GanttConstants.SHADOW_CLASS).call(_resetDragShadow);
      newShadow = shadow.data([0]).enter().append('g').call(_resetDragShadow);
      newShadow.append('rect').attr('width', 0).attr('height', GanttConstants.VISIT_HEIGHT).attr('rx', 5).attr('ry', 5).attr('y', GanttConstants.ITEM_MARGIN).style('stroke', "black").style('stroke-width', "1").style('stroke-opacity', "0.2");
      gIcon = newShadow.append('g').classed('icon', true).attr('transform', "translate(0, " + GanttConstants.SHADOW_ICON_Y + ")");
      gIcon.append('text').classed('content', true);
      return gIcon.append('svg').classed('content', true).attr('width', GanttConstants.ICON_SIZE).attr('height', GanttConstants.ICON_SIZE);
    };
    DragShadowF = function(selection) {
      return _drawDragShadow(selection);
    };
    return DragShadowF;
  };
  DragShadowF.$inject = ["GanttConstants"];

  angular.module('app').factory('DragShadowF', DragShadowF);

}).call(this);

(function() {
  var DropZoneChartF = function(RouteS, Constants, GanttConstants, DropZoneEventsF, ScrollChartF) {
    var HEADER_REOPTIMIZE_MESSAGE, _driverId, _driversWidth, _driversXPos, _dropZoneChangeListener, _getYPos, _margin, _routesWidth, _routesXPos, _type, _updateDropZoneHeader, _upsertDropZone, _yPos;
    HEADER_REOPTIMIZE_MESSAGE = "Assign to driver & reoptimize";
    _yPos = null;
    _driversWidth = null;
    _routesWidth = null;
    _routesXPos = null;
    _driversXPos = null;
    _driverId = null;
    _type = null;
    _margin = {
      top: 3,
      left: 5
    };
    _updateDropZoneHeader = function(message) {
      var curHeight, headerMessage;
      headerMessage = d3.select('.drop-zone-message');
      curHeight = headerMessage.height;
      if (message != null) {
        headerMessage.style('visibility', Constants.cssVisible).select('.text').html(message);
      } else {
        headerMessage.style('visibility', Constants.cssHidden).select('.text').html('');
      }
      if (ScrollChartF.getPosition() < 0) {
        return headerMessage.style('height', '36px');
      } else {
        return headerMessage.style('height', '40px');
      }
    };
    _dropZoneChangeListener = function(rectRight, rectLeft) {
      return function(driverId, type, event) {
        var yPos;
        if (event === GanttConstants.DROP_ZONE_EVENT_ACTIVATE) {
          _driverId = driverId;
          _type = type;
          yPos = _yPos();
          rectRight.classed('active', type === GanttConstants.ZONE_TYPE_ROUTE).attr('transform', "translate(" + _routesXPos + ", " + yPos + ")").attr('width', _routesWidth).style('visibility', Constants.cssVisible);
          rectLeft.classed('active', type === GanttConstants.ZONE_TYPE_DRIVER).attr('transform', "translate(" + _driversXPos + ", " + yPos + ")").attr('width', _driversWidth).style('visibility', Constants.cssVisible);
          if (type === GanttConstants.ZONE_TYPE_DRIVER) {
            return _updateDropZoneHeader(HEADER_REOPTIMIZE_MESSAGE);
          } else {
            return _updateDropZoneHeader(null);
          }
        } else if (event === GanttConstants.DROP_ZONE_EVENT_HIDE) {
          rectLeft.attr('transform', "translate(0, 0)").style('visibility', Constants.cssHidden);
          rectRight.attr('transform', "translate(0, 0)").style('visibility', Constants.cssHidden);
          return _updateDropZoneHeader(null);
        }
      };
    };
    _upsertDropZone = function(target, data) {
      var current, gDropZones, gGantt, rectLeft, rectRight;
      gGantt = d3.select(this);
      gDropZones = gGantt.selectAll('g.dropzones');
      if (gDropZones.empty()) {
        gDropZones = gGantt.append('g').classed('dropzones', true);
      }
      current = gDropZones.select('rect.drop-zone');
      if (current.empty()) {
        rectRight = gDropZones.append('rect').classed('drop-zone', true).attr('transform', "translate(0, 0)").attr('width', 0).attr('height', target.rowHeight() * 0.83).attr("rx", 6).attr("ry", 6).style('visibility', Constants.cssHidden);
        rectLeft = gDropZones.append('rect').classed('drop-zone', true).attr('transform', "translate(0, 0)").attr('width', 0).attr('height', target.rowHeight() * 0.83).attr("rx", 6).attr("ry", 6).style('visibility', Constants.cssHidden);
        return DropZoneEventsF.addListener(_dropZoneChangeListener(rectRight, rectLeft));
      }
    };
    _getYPos = function(yTicks, driverIds) {
      return function() {
        var id, idx, index, _i, _len;
        for (idx = _i = 0, _len = driverIds.length; _i < _len; idx = ++_i) {
          id = driverIds[idx];
          if (id === _driverId) {
            index = idx;
            break;
          }
        }
        return yTicks[index] + _margin.top;
      };
    };
    DropZoneChartF = function(target, selection) {
      return selection.each(function(data) {
        var driverIds, range;
        var axis = target.axis();
        range = axis.y.range();
        driverIds = axis.y.domain();
        _yPos = _getYPos(range, driverIds);
        _routesXPos = _margin.left;
        _routesWidth = target.width() + target.margin().right - (_margin.left * 3);
        _driversXPos = _routesXPos - target.margin().left;
        _driversWidth = target.margin().left - (_margin.left * 2);
        return _upsertDropZone.call(this, target, data);
      });
    };
    return DropZoneChartF;
  };
  DropZoneChartF.$inject = ["RouteS", "Constants", "GanttConstants", "DropZoneEventsF", "ScrollChartF"];

  angular.module('app').factory('DropZoneChartF', DropZoneChartF);

}).call(this);

(function() {
  var DropZoneEventsF = function(GanttConstants) {
    var _callbacks, _driverId, _notify, _type;
    _callbacks = [];
    _driverId = null;
    _type = null;
    _notify = function(event) {
      var c, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _callbacks.length; _i < _len; _i++) {
        c = _callbacks[_i];
        _results.push(c(_driverId, _type, event));
      }
      return _results;
    };
    DropZoneEventsF = {};
    DropZoneEventsF.addListener = function(callback) {
      return _callbacks.push(callback);
    };
    DropZoneEventsF.hide = function() {
      _driverId = null;
      _type = null;
      return _notify(GanttConstants.DROP_ZONE_EVENT_HIDE);
    };
    DropZoneEventsF.activate = function(driverId, type) {
      if (driverId !== _driverId || type !== _type) {
        _driverId = driverId;
        _type = type;
        return _notify(GanttConstants.DROP_ZONE_EVENT_ACTIVATE);
      }
    };
    return DropZoneEventsF;
  };
  DropZoneEventsF.$inject = ["GanttConstants"];

  angular.module('app').factory('DropZoneEventsF', DropZoneEventsF);

}).call(this);

(function() {
  var _getDrivers, _getTasks, _getUnserved, _isEmptyVehicle;
  var GanttD = function(TimeUtilF, RouteUtil, ScheduleChartF, $rootScope, AnalyticsS, GMarkerF, AccountF, GanttConstants, GanttToolTipF) {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      template: '<div class="gantt" ng-transclude></div>',
      scope: {
        isPastProject: '=',
        solution: '=',
        reoptimize: '=',
        hideEmptyVehicles: '=',
        sortByDepartureTime: '=',
        dispatches: '=',
        showClock: "=",
        chartSize: "=",
        ganttType: "=",
        scheduleUnserveds: '='
      },
      link: function(scope, element, attrs) {
        var chart, currentDispatches, currentSolution, delta, fleet, numUnserved, reOptimizeRoute, rtime, targetElement, timeout, visits, _dispatchesChanged, _infoChangedListener, _parentResizedListener, _resizeEnd, _retrieveTasksAndDrivers, _unbindListener;
        if (!d3) {
          console.error('Missing dependency d3.js');
        }
        if (!attrs.solution) {
          throw new Error('Missing solution attribute (required)');
        }
        targetElement = element[0];
        chart = new ScheduleChartF(targetElement, scope.solution);
        chart.chartType(scope.ganttType).scheduleUnserveds(scope.scheduleUnserveds).isPastProject(scope.isPastProject);
        visits = null;
        fleet = null;
        currentDispatches = null;
        currentSolution = null;
        numUnserved = null;
        reOptimizeRoute = function(reoptimize, AnalyticsS, hideEmptyVehicles) {
          return function(userSolution, unserved) {
            return reoptimize(unserved, userSolution)["catch"](function() {
              var drivers, tasks, _ref;
              _ref = _retrieveTasksAndDrivers(currentSolution, hideEmptyVehicles, currentDispatches), tasks = _ref[0], drivers = _ref[1];
              chart.tasks(tasks).numUnserved(numUnserved).redraw(scope.showClock, true);
            });
          };
        };
        _retrieveTasksAndDrivers = function(solution, hideEmptyVehicles, dispatches) {
          var drivers, response, routesDirtyStatus, tasks, visit, _i, _len, _ref;
          response = solution.solution.response;
          routesDirtyStatus = solution.dispatches;
          tasks = _getTasks.call(TimeUtilF, response, fleet, hideEmptyVehicles, dispatches, routesDirtyStatus, RouteUtil, AccountF);
          drivers = _getDrivers(response, fleet, hideEmptyVehicles);
          if (solution.unserved) {
            _ref = _getUnserved(solution.unserved, visits);
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              visit = _ref[_i];
              tasks.unshift(visit);
            }
            drivers[null] = GanttConstants.UNSCHEDULED_DRIVER_NAME;
            numUnserved = Object.keys(solution.unserved).length;
          }
          return [tasks, drivers];
        };
        rtime = null;
        timeout = false;
        delta = 200;
        _parentResizedListener = $rootScope.$on('parentResized', function() {
          rtime = new Date();
          if (timeout === false) {
            timeout = true;
            return setTimeout(_resizeEnd, delta);
          }
        });
        _resizeEnd = function() {
          if (new Date() - rtime < delta) {
            return setTimeout(_resizeEnd, delta);
          } else {
            timeout = false;
            chart.resizeWidth(targetElement);
            return chart.numUnserved(numUnserved).redraw(scope.showClock, true);
          }
        };
        _infoChangedListener = $rootScope.$on('ganttInfoChanged', function() {
          var drivers, tasks, _ref;
          _ref = _retrieveTasksAndDrivers(currentSolution, scope.hideEmptyVehicles, currentDispatches), tasks = _ref[0], drivers = _ref[1];
          return chart.drivers(drivers).tasks(tasks).setSolution(currentSolution.solution).redraw(scope.showClock, true);
        });
        _unbindListener = GanttToolTipF(targetElement, scope);
        scope.$watch('hideEmptyVehicles', function(isHidden) {
          var drivers, tasks, _ref;
          if ((isHidden != null) && currentSolution) {
            _ref = _retrieveTasksAndDrivers(currentSolution, isHidden, currentDispatches), tasks = _ref[0], drivers = _ref[1];
            return chart.drivers(drivers).tasks(tasks).solutionUpdated(reOptimizeRoute(scope.reoptimize, AnalyticsS, isHidden)).redraw(scope.showClock, true);
          }
        });
        scope.$watch('sortByDepartureTime', function(sortByDeparture) {
          var drivers, tasks, _ref;
          if ((sortByDeparture != null) && currentSolution) {
            _ref = _retrieveTasksAndDrivers(currentSolution, scope.hideEmptyVehicles, currentDispatches), tasks = _ref[0], drivers = _ref[1];
            return chart.drivers(drivers).tasks(tasks).setSolution(currentSolution.solution).redraw(scope.showClock, true);
          }
        });
        scope.$watch('ganttType', function(chartType) {
          if (chartType != null) {
            return chart.chartType(chartType).redraw(scope.showClock, true);
          }
        });
        scope.$watch('chartSize', function(chartSize) {
          var drivers, tasks, _ref;
          if ((chartSize != null) && (currentSolution != null)) {
            _ref = _retrieveTasksAndDrivers(currentSolution, scope.hideEmptyVehicles, currentDispatches), tasks = _ref[0], drivers = _ref[1];
            return chart.resizeHeight(targetElement).numUnserved(numUnserved).redraw(scope.showClock, true);
          }
        });
        scope.$watch('solution', function(newSolution) {
          var drivers, request, tasks, _ref, _ref1;
          if ((newSolution != null ? newSolution.solution : void 0) != null) {
            currentSolution = newSolution;
            request = (_ref = currentSolution.solution) != null ? _ref.request : void 0;
            if (request != null) {
              visits = request.visits;
              fleet = request.fleet;
              _ref1 = _retrieveTasksAndDrivers(currentSolution, scope.hideEmptyVehicles, currentDispatches), tasks = _ref1[0], drivers = _ref1[1];
              return chart.resizeHeight(targetElement).drivers(drivers).tasks(tasks).routeLocks(currentSolution.routeLocks).driverLoadsOverview(currentSolution.driverLoadsOverview).driverShiftsOverview(currentSolution.driverShiftsOverview).numUnserved(numUnserved).solutionUpdated(reOptimizeRoute(scope.reoptimize, AnalyticsS, scope.hideEmptyVehicles)).setSolution(currentSolution.solution).redraw(scope.showClock, true);
            }
          }
        });
        _dispatchesChanged = function(dispatches) {
          var drivers, tasks, _ref;
          if ((dispatches != null) && !_.isEmpty(dispatches)) {
            currentDispatches = dispatches;
            _ref = _retrieveTasksAndDrivers(currentSolution, scope.hideEmptyVehicles, currentDispatches), tasks = _ref[0], drivers = _ref[1];
            return chart.drivers(drivers).tasks(tasks).redraw(scope.showClock, true);
          }
        };
        scope.$watch('dispatches', _dispatchesChanged, true);
        scope.$watch('isPastProject', function(newVal, oldVal) {
          if (newVal !== oldVal) {
            return chart.isPastProject(scope.isPastProject);
          }
        });
        scope.$on('$destroy', function() {
          if (typeof _unbindListener === "function") {
            _unbindListener();
          }
          if (typeof _parentResizedListener === "function") {
            _parentResizedListener();
          }
          return typeof _infoChangedListener === "function" ? _infoChangedListener() : void 0;
        });

      }
    };
  };
  GanttD.$inject = ["TimeUtilF", "RouteUtil", "ScheduleChartF", "$rootScope", "AnalyticsS", "GMarkerF", "AccountF", "GanttConstants", "GanttToolTipF"];

  angular.module('app').directive('ganttD', GanttD);


  /*
   * -------------
   * Helpers
   * -------------
   */

  _getTasks = function(sol, fleet, hideEmptyVehicles, dispatches, routesDirtyStatus, RouteUtil, AccountF) {
    var arrivalStr, arrivalTime, data, dispatch, dispatchStatus, dispatchVisit, dispatchVisitsByLocId, displayTime, finishTime, i, isEndDepot, isLate, isStartDepot, lastFinishTime, locationId, routeDispatchInfo, startTime, task, tasks, textIndex, vehId, vehicle, visit, visitStatus, visits, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2;
    tasks = [];
    dispatch = null;
    dispatchVisitsByLocId = {};
    if (!!dispatches) {
      for (vehId in dispatches) {
        dispatch = dispatches[vehId];
        _ref1 = (_ref = dispatch.solution) != null ? _ref.visits : void 0;
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          visit = _ref1[_i];
          locationId = visit["break"] ? "" + vehId + "_break" : (_ref2 = visit.location) != null ? _ref2.id : void 0;
          dispatchVisitsByLocId[locationId] = visit;
        }
      }
    }
    for (_j = 0, _len1 = fleet.length; _j < _len1; _j++) {
      vehicle = fleet[_j];
      vehId = vehicle.id;
      data = sol[vehId];
      visits = data.visits;
      if (hideEmptyVehicles && _isEmptyVehicle(visits)) {
        continue;
      }
      textIndex = 0;
      lastFinishTime = null;
      for (i = _k = 0, _len2 = visits.length; _k < _len2; i = ++_k) {
        visit = visits[i];
        isStartDepot = false;
        isEndDepot = false;
        displayTime = null;
        arrivalTime = this.convertTimeToDate(visit.arrival_time);
        finishTime = this.convertTimeToDate(visit.finish_time);
        if (visit.idle_time) {
          startTime = this.addMinutes(arrivalTime, visit.idle_time);
        } else {
          startTime = void 0;
        }
        if (!visit.finish_time) {
          if (i === 0) {
            isStartDepot = true;
          } else {
            isEndDepot = true;
          }
        }
        locationId = visit["break"] ? "" + vehId + "_break" : visit.location_id;
        if (dispatchVisitsByLocId != null) {
          dispatchVisit = dispatchVisitsByLocId[locationId];
          visitStatus = dispatchVisit != null ? dispatchVisit.status : void 0;
          isLate = dispatchVisit != null ? dispatchVisit.isLate : void 0;
        }
        routeDispatchInfo = routesDirtyStatus != null ? routesDirtyStatus[vehId] : void 0;
        dispatch = dispatches != null ? dispatches[vehId] : void 0;
        dispatchStatus = RouteUtil.getDispatchStatus(dispatch, routeDispatchInfo, vehicle.phoneNumber, AccountF.hasGPSTracking());
        arrivalStr = this.dateToHhMm(startTime || arrivalTime);
        displayTime = "" + arrivalStr + " - " + (this.dateToHhMm(finishTime));
        if ((lastFinishTime != null) && arrivalTime <= lastFinishTime) {
          arrivalTime = this.addMinutes(lastFinishTime, 1);
          finishTime = finishTime > arrivalTime ? finishTime : arrivalTime;
        }
        lastFinishTime = finishTime || arrivalTime;
        task = {
          id: locationId,
          startDate: arrivalTime,
          endDate: finishTime,
          "break": !!visit["break"],
          driverId: vehId,
          driverCreatedAt: vehicle.createdAt,
          dispatchStatus: dispatchStatus,
          idleDate: startTime,
          color: data.color,
          isVisit: !isStartDepot && !isEndDepot,
          isStartDepot: isStartDepot,
          isEndDepot: isEndDepot,
          visitStatus: visitStatus || "pending",
          isLate: isLate,
          displayTime: displayTime
        };
        if (task["break"]) {
          task.breakVisibilityRefId = visits[i - 1].location_id;
          task.index = -1;
        } else {
          task.index = textIndex++;
        }
        tasks.push(task);
      }
    }
    return tasks;
  };

  _getUnserved = function(unserved, visits) {
    var id, index, tasks, visit, visitObj, _i, _len;
    visitObj = {};
    for (_i = 0, _len = visits.length; _i < _len; _i++) {
      visit = visits[_i];
      visitObj[visit.id] = visit;
    }
    tasks = [];
    index = 1;
    for (id in unserved) {
      visit = unserved[id];
      tasks.push({
        id: id,
        driverId: null,
        driverCreatedAt: 0,
        isVisit: true,
        error: visit.error,
        color: visit.color,
        index: index++,
        createdAt: visitObj[id].createdAt,
        visitStatus: "pending"
      });
    }
    tasks = _.sortBy(tasks, function(task) {
      return task.createdAt;
    });
    return tasks;
  };

  _getDrivers = function(sol, fleet, hideEmptyVehicles) {
    var data, drivers, vehId, vehicle, visits, _i, _len;
    drivers = {};
    for (_i = 0, _len = fleet.length; _i < _len; _i++) {
      vehicle = fleet[_i];
      vehId = vehicle.id;
      data = sol[vehId];
      visits = data.visits;
      if (hideEmptyVehicles && _isEmptyVehicle(visits)) {
        continue;
      }
      drivers[vehId] = vehicle.name;
    }
    return drivers;
  };

  _isEmptyVehicle = function(visits) {
    return visits.length < 2 || (visits.length === 2 && !visits[1].finish_time) || (visits.length === 3 && visits[1]["break"] && !visits[2].finish_time);
  };

}).call(this);

(function() {
  var GanttSettings = function(EventListenersF, Events) {
    var isHideEmptyVehicles, isSortByDepartureTime;
    isSortByDepartureTime = false;
    isHideEmptyVehicles = false;
    GanttSettings = {};
    GanttSettings.setSortByDepartureTime = function(newValue) {
      isSortByDepartureTime = newValue;
      return EventListenersF.notify(Events.SORT_VEHICLES_BY_DEPARTURE_TIME_CHANGED);
    };
    GanttSettings.setHideEmptyVehicles = function(newValue) {
      isHideEmptyVehicles = newValue;
      return EventListenersF.notify(Events.HIDE_EMPTY_VEHICLES_CHANGED);
    };
    GanttSettings.getSortByDepartureTime = function(newValue) {
      return isSortByDepartureTime;
    };
    GanttSettings.getHideEmptyVehicles = function(newValue) {
      return isHideEmptyVehicles;
    };
    return GanttSettings;
  };
  GanttSettings.$inject = ["EventListenersF", "Events"];

  angular.module('app').factory('GanttSettings', GanttSettings);

}).call(this);

(function() {
  var LabelChartF = function(LabelF) {
    var _getDrivers, _upsertLabels;
    var axis = null;
    _getDrivers = function(tasks) {
      var servedTasks = _.filter(tasks, function(d) {
        return d.driverId;
      });
      return _.uniq(_.map(servedTasks, function(d) {
        return {
          id: d.driverId,
          color: d.color,
          dispatchStatus: d.dispatchStatus,
          yPos: axis.y(d.driverId)
        };
      }));
    };
    _upsertLabels = function(target, data) {
      var current, customLabels, drivers, gGantt, gLabels;
      gGantt = d3.select(this);
      drivers = _getDrivers(data);
      gLabels = gGantt.selectAll('g.labels');
      if (gLabels.empty()) {
        gLabels = gGantt.append('g').classed('labels', true);
      }
      customLabels = LabelF(target);
      current = gLabels.selectAll('g.item').data(drivers, function(d) {
        return d.id;
      }).call(customLabels);
      current.enter().append('g').call(customLabels);
      return current.exit().remove();
    };
    LabelChartF = function(target, selection) {
      axis = target.axis();
      return selection.each(function(data) {
        return _upsertLabels.call(this, target, data);
      });
    };
    return LabelChartF;
  };
  LabelChartF.$inject = ["LabelF"];

  angular.module('app').factory('LabelChartF', LabelChartF);

}).call(this);

(function() {
  var LineChartF = function(RouteS, Constants) {
    var ROUTE_INVISIBLE_CLASS, _addVisibilityEventListener, _customizeLines, _getLine, _getLines, _upsertLines;
    ROUTE_INVISIBLE_CLASS = Constants.routeInvisibleCSS;
    _addVisibilityEventListener = function(id, selection) {
      return RouteS.addVisibilityEventListener(id, function(isVisible) {
        return selection.classed(ROUTE_INVISIBLE_CLASS, !isVisible);
      });
    };
    _customizeLines = function(selection) {
      return selection.each(function(d) {
        var line = d3.select(this);
        line.classed('item', true).attr('stroke', d.color.rgba).attr('stroke-width', '9').attr('stroke-linecap', 'round').attr('stroke-dashoffset', '10').transition().attr('x1', d.x1).attr('y1', d.y1).attr('x2', d.x2).attr('y2', d.y2);
        if (d.isIdle) {
          line.attr('stroke-dasharray', '1,13').attr('stroke-linecap', 'round');
        }
        return _addVisibilityEventListener(d.routeId, line);
      });
    };
    _getLine = function(axis, d) {
      var line;
      var height = axis.y.rangeBand();
      line = {
        id: d.id,
        color: d.color,
        x1: axis.x(d.startDate),
        x2: axis.x(d.endDate || d.startDate),
        y: axis.y(d.driverId) + (height / 1.75)
      };
      line.idleDate = d.idleDate ? axis.x(d.idleDate) : void 0;
      return line;
    };
    _getLines = function(target, data) {
      var color, d, drivers, i, id, lid, lines, next, v, visits, y, _i, _j, _len, _len1;
      var axis = target.axis();
      drivers = {};
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        d = data[_i];
        if (!d.driverId) {
          continue;
        }
        if (drivers[d.driverId] == null) {
          drivers[d.driverId] = [];
        }
        drivers[d.driverId].push(_getLine(axis, d));
      }
      lines = [];
      for (id in drivers) {
        visits = drivers[id];
        for (i = _j = 0, _len1 = visits.length; _j < _len1; i = ++_j) {
          v = visits[i];
          next = visits[i + 1];
          if (next == null) {
            break;
          }
          lid = "" + v.id + "," + next.id;
          y = v.y;
          color = v.color;
          lines.push({
            id: lid,
            routeId: id,
            color: color,
            x1: v.x2,
            y1: y,
            x2: next.x1,
            y2: y
          });
          if (next.idleDate) {
            lines.push({
              id: "" + lid + "_idle",
              routeId: id,
              color: color,
              x1: next.x1 + 8,
              y1: y,
              x2: next.idleDate,
              y2: y,
              isIdle: true
            });
          }
        }
      }
      return lines;
    };
    _upsertLines = function(target, data) {
      var current, gGantt, gLines, lines;
      gGantt = d3.select(this);
      gLines = gGantt.selectAll('g.paths');
      if (gLines.empty()) {
        gLines = gGantt.append('g').classed('paths', true);
      }
      lines = _getLines(target, data);
      current = gLines.selectAll('line.item').data(lines, function(d) {
        return d.id;
      }).call(_customizeLines);
      current.enter().append('line').call(_customizeLines);
      return current.exit().remove();
    };
    LineChartF = function(target, selection) {
      return selection.each(function(data) {
        return _upsertLines.call(this, target, data);
      });
    };
    return LineChartF;
  };
  LineChartF.$inject = ["RouteS", "Constants"];

  angular.module('app').factory('LineChartF', LineChartF);

}).call(this);

(function() {
  var ScheduleChartF = function($filter, AxisChartF, ContentChartS, ClockLineS, ProjectF, TimeUtilF, ZoomChartF, GanttConstants, HudF, DemoF, EventListenersF, Events, DriverSorter) {
    var CHART_SCALE, DEFAULT_MARGIN_LEFT, INSERT_UNSCHEDULED_WIDTH, PADDING_TOP, PAGINATION_WITDH, TICK_FORMAT, TIME_DOMAIN_MARGIN, UNSERVED_ELEMENT_WIDTH, createAccessor, init, me, _filterTasksWithDomain, _getAxis, _getDriverIds, _getMaxEndDate, _getMaxUnservedPerPage, _getMinEndDate, _getTimeDomain, _getUnservedIndexRange;
    PADDING_TOP = 5;
    TICK_FORMAT = "%H:%M";
    TIME_DOMAIN_MARGIN = 30;
    UNSERVED_ELEMENT_WIDTH = GanttConstants.UNSERVED_WIDTH + GanttConstants.UNSERVED_MARGIN;
    INSERT_UNSCHEDULED_WIDTH = GanttConstants.AUTO_SCHEDULE_BTN_WIDTH + GanttConstants.AUTO_SCHEDULE_BTN_MARGIN_RIGHT + 25;
    PAGINATION_WITDH = 20;
    DEFAULT_MARGIN_LEFT = 260;
    CHART_SCALE = HudF.scale || 1;
    me = {
      scale: CHART_SCALE,
      width: 600,
      height: 400,
      rowHeight: 50,
      leftColumnWidth: 70,
      loadColumn: false,
      timeColumn: false,
      zoomMargin: 30,
      brush: null,
      timeStart: d3.time.day.offset(new Date(), -3),
      timeEnd: d3.time.day.offset(new Date(), +3),
      drivers: {},
      tasks: {},
      routeLocks: {},
      driverLoadsOverview: {},
      driverShiftsOverview: {},
      solution: {},
      axis: null,
      numUnserved: null,
      chartType: "plan",
      isPastProject: false,
      unservedPage: 0,
      margin: {
        top: 18,
        right: 60,
        bottom: 0,
        left: DEFAULT_MARGIN_LEFT
      },
      demoWidthChange: 60,
      solutionUpdated: function() {},
      scheduleUnserveds: function() {}
    };
    createAccessor = function(attr) {
      return function(value) {
        if (!arguments.length) {
          return me[attr];
        }
        me[attr] = value;
        return this;
      };
    };
    _getMaxEndDate = function(tasks) {
      var max, t, _i, _len;
      if (!(tasks && tasks.length > 0)) {
        return null;
      }
      max = null;
      for (_i = 0, _len = tasks.length; _i < _len; _i++) {
        t = tasks[_i];
        if (!(t.startDate || t.endDate)) {
          continue;
        }
        if (max === null || (t.endDate && t.endDate > max)) {
          max = t.endDate;
        }
        if (max === null || (t.startDate && t.startDate > max)) {
          max = t.startDate;
        }
      }
      return new Date(max);
    };
    _getMinEndDate = function(tasks) {
      var min, t, _i, _len;
      if (!(tasks && tasks.length > 0)) {
        return null;
      }
      min = null;
      for (_i = 0, _len = tasks.length; _i < _len; _i++) {
        t = tasks[_i];
        if (t.startDate) {
          if (t.startDate < min || min === null) {
            min = t.startDate;
          }
        }
      }
      return new Date(min);
    };
    _getDriverIds = function() {
      var sortedDriverIds, _ref, _ref1;
      if (((_ref = me.solution) != null ? (_ref1 = _ref.request) != null ? _ref1.fleet : void 0 : void 0) == null) {
        return [];
      }
      sortedDriverIds = DriverSorter.getSortedDriverIds();
      sortedDriverIds = _.filter(sortedDriverIds, function(id) {
        return !!me.drivers[id];
      });
      return sortedDriverIds;
    };
    _getAxis = function(tasks, timeDomain) {
      var axis, driverIds, height, tickValues, xAxis, xScale, yScale;
      driverIds = _getDriverIds(tasks);
      height = me.height - me.margin.top - me.margin.bottom;
      axis = {};
      xScale = d3.time.scale().domain(timeDomain).range([0, me.width]).clamp(true);
      yScale = d3.scale.ordinal().domain(driverIds).rangeRoundBands([0, me.rowHeight * driverIds.length], 0.1, 0);
      tickValues = xScale.ticks();
      tickValues.pop();
      xAxis = d3.svg.axis().scale(xScale).orient("top").tickFormat($filter('multiDay')).tickSubdivide(true).tickSize(0).tickPadding(0).tickValues(tickValues);
      return {
        x: xScale,
        y: yScale,
        xAxis: xAxis
      };
    };
    _filterTasksWithDomain = function(tasks, domain) {
      var end, start, task;
      start = domain[0];
      end = domain[1];
      return [
        (function() {
          var _i, _len, _results;
          _results = [];
          for (_i = 0, _len = tasks.length; _i < _len; _i++) {
            task = tasks[_i];
            if (task.endDate < end && task.startDate > start) {
              _results.push(task);
            }
          }
          return _results;
        })()
      ];
    };
    _getTimeDomain = function(tasks) {
      var todayNormalized;
      var timeDomain = {};
      if (!((tasks != null) && tasks.length > 0)) {
        timeDomain.start = d3.time.day.offset(new Date(), -3);
        timeDomain.end = d3.time.day.offset(new Date(), +3);
      } else {
        timeDomain.end = _getMaxEndDate(tasks);
        todayNormalized = TimeUtilF.getCurrentNormalizedTime();
        if (ProjectF.isToday() && timeDomain.end < todayNormalized) {
          timeDomain.end = todayNormalized;
        }
        timeDomain.end.setMinutes((Math.ceil(timeDomain.end.getMinutes() / TIME_DOMAIN_MARGIN) + 1) * TIME_DOMAIN_MARGIN);
        timeDomain.start = _getMinEndDate(tasks);
        timeDomain.start.setMinutes((Math.floor(timeDomain.start.getMinutes() / TIME_DOMAIN_MARGIN) - 1) * TIME_DOMAIN_MARGIN);
      }
      return [timeDomain.start, timeDomain.end];
    };
    _getUnservedIndexRange = function() {
      var maxUnservedIdx, maxUnservedPerPage, minUnservedIdx;
      maxUnservedPerPage = _getMaxUnservedPerPage();
      maxUnservedIdx = (me.unservedPage * maxUnservedPerPage) + maxUnservedPerPage;
      minUnservedIdx = (me.unservedPage * maxUnservedPerPage) + 1;
      return [minUnservedIdx, maxUnservedIdx];
    };
    _getMaxUnservedPerPage = function() {
      var maxUnservedPerPage, minUnservedIndex, unservedViewableWidth;
      unservedViewableWidth = me.width + me.margin.right - PAGINATION_WITDH;
      if (me.chartType !== 'live' && !me.isPastProject) {
        unservedViewableWidth -= INSERT_UNSCHEDULED_WIDTH;
      }
      minUnservedIndex = me.unservedPage;
      return maxUnservedPerPage = Math.floor(unservedViewableWidth / UNSERVED_ELEMENT_WIDTH);
    };
    init = function(selection) {
      return selection.each(function() {
        var height, svg, width;
        svg = d3.select(this);
        width = me.width + me.margin.left + me.margin.right;
        height = me.height + me.margin.top + me.margin.bottom;
        svg.attr('id', 'chart').attr('width', width).attr('height', height).attr('transform', "scale(" + me.scale + ")");
        return svg.append('g').attr('id', 'gantt-chart').attr('transform', "translate(" + me.margin.left + ", " + me.margin.top + ")");
      });
    };
    ScheduleChartF = function(container, _arg) {
      var attr, driverLoadsOverview, driverShiftsOverview, svg;
      driverLoadsOverview = _arg.driverLoadsOverview, driverShiftsOverview = _arg.driverShiftsOverview;
      if (driverLoadsOverview != null) {
        me.loadColumn = Object.keys(driverLoadsOverview).length > 0;
        me.driverLoadsOverview = driverLoadsOverview;
      }
      if (driverShiftsOverview != null) {
        me.timeColumn = Object.keys(driverShiftsOverview).length > 0;
        me.driverShiftsOverview = driverShiftsOverview;
      }
      me.margin.left = DEFAULT_MARGIN_LEFT + (me.leftColumnWidth * (me.loadColumn + me.timeColumn)) + me.zoomMargin;
      me.height = (container.clientHeight / me.scale) - me.margin.top - me.margin.bottom - PADDING_TOP;
      me.width = (container.clientWidth / me.scale) - me.margin.left - me.margin.right;
      if (DemoF.isInDemo()) {
        me.width += me.demoWidthChange;
      }
      me.unservedPage = 0;
      svg = d3.select(container);
      svg.append('svg').call(init);
      me.selection = svg.select('g#gantt-chart');
      for (attr in me) {
        if (!this[attr] && me.hasOwnProperty(attr)) {
          this[attr] = createAccessor.call(this, attr);
        }
      }
      return this;
    };
    ScheduleChartF.prototype.resizeHeight = function(container) {
      var chart, height, svg;
      me.height = container.clientHeight - me.margin.top - me.margin.bottom - PADDING_TOP;
      height = (me.height / me.scale) + me.margin.top + me.margin.bottom;
      if (height < 0) {
        height = 0;
      }
      svg = d3.select(container);
      chart = svg.select('#chart');
      chart.attr('height', height);
      return this;
    };
    ScheduleChartF.prototype.resizeWidth = function(container) {
      var chart, clipRect, svg, width;
      me.unservedPage = 0;
      if (container.clientWidth > 0) {
        me.width = (container.clientWidth / me.scale) - me.margin.left - me.margin.right;
        width = me.width + me.margin.left + me.margin.right;
        svg = d3.select(container);
        chart = svg.select('#chart');
        clipRect = svg.select('#clip-rect');
        chart.attr('width', width);
        return clipRect.attr('width', width);
      }
    };
    ScheduleChartF.prototype.nextUnservedPage = function() {
      var maxPageIdx = Math.ceil(me.numUnserved / _getMaxUnservedPerPage()) - 1;
      if (me.unservedPage < maxPageIdx) {
        me.unservedPage += 1;
        ContentChartS(this);
      }
      return this;
    };
    ScheduleChartF.prototype.prevUnservedPage = function() {
      if (me.unservedPage > 0) {
        me.unservedPage -= 1;
        ContentChartS(this);
      }
      return this;
    };
    ScheduleChartF.prototype.goToPageWithUnservedItem = function(unservedIndex) {
      var pageIdx;
      var maxPageIdx = Math.ceil(me.numUnserved / _getMaxUnservedPerPage()) - 1;
      pageIdx = Math.ceil(unservedIndex / _getMaxUnservedPerPage()) - 1;
      if (pageIdx <= maxPageIdx && pageIdx >= 0) {
        me.unservedPage = pageIdx;
        ContentChartS(this);
      }
      return this;
    };
    ScheduleChartF.prototype.getMaxUnservedPerPage = function() {
      return _getMaxUnservedPerPage();
    };
    ScheduleChartF.prototype.getUnservedIndexRange = function() {
      return _getUnservedIndexRange();
    };
    ScheduleChartF.prototype.redrawContentChart = function() {
      me.selection.data([me.tasks]);
      ContentChartS(this);
      return this;
    };
    ScheduleChartF.prototype.setSolution = function(solution) {
      if (solution) {
        me.solution = solution;
      }
      return this;
    };
    ScheduleChartF.prototype.redraw = function(showClock, keepZoom) {
      var timeDomain = _getTimeDomain(me.tasks);
      me.axis = _getAxis(me.tasks, timeDomain);
      me.selection.data([me.tasks]);
      if (!keepZoom) {
        me.brush = null;
      }
      AxisChartF(this);
      ZoomChartF(this);
      ContentChartS(this);
      if (showClock) {
        ClockLineS(this);
      }
      return this;
    };
    ScheduleChartF.prototype.zoomed = function(newTimeDomain) {
      me.axis = _getAxis(me.tasks, newTimeDomain);
      ContentChartS(this);
      return me.axis.x;
    };
    ScheduleChartF.prototype.getDriverIds = function(tasks) {
      return _getDriverIds(tasks);
    };
    ScheduleChartF.prototype.translate = function(x, y) {
      return "translate(" + x + "," + y + ")";
    };
    ScheduleChartF.prototype.onSolutionUpdated = function(solution, unserved) {
      me.unservedPage = 0;
      if (me.solutionUpdated) {
        return me.solutionUpdated(solution, unserved);
      }
    };
    ScheduleChartF.prototype.onScheduleUnservedClick = function() {
      if (me.scheduleUnserveds) {
        return me.scheduleUnserveds();
      }
    };
    ScheduleChartF.prototype.onUnscheduledReasonsClick = function() {
      return EventListenersF.notify(Events.SIDE_PANEL_UNSERVED_CHANGED);
    };
    return ScheduleChartF;
  };
  ScheduleChartF.$inject = ["$filter", "AxisChartF", "ContentChartS", "ClockLineS", "ProjectF", "TimeUtilF", "ZoomChartF", "GanttConstants", "HudF", "DemoF", "EventListenersF", "Events", "DriverSorter"];

  angular.module('app').factory('ScheduleChartF', ScheduleChartF);

}).call(this);

(function() {
  var ScrollBarF = function(ScrollChartF) {
    var LINE_LENGTH_ATTR, STARTING_POSITION, _customizeScroll, _drag, _dragEventListener, _getElemHeight, _lineScale, _onMove, _parseElem, _updatePosition, _upsertScroll;
    STARTING_POSITION = 12;
    LINE_LENGTH_ATTR = 'line-length';
    _lineScale = 1;
    _getElemHeight = function(elem) {
      if (!elem || (elem != null ? elem.empty() : void 0)) {
        return 0;
      }
      return parseFloat(elem.attr(LINE_LENGTH_ATTR), 10);
    };
    _drag = function(d) {
      var delta, speed;
      speed = ScrollChartF.DRAG_SPEED;
      delta = Math.max(-speed, Math.min(speed, -d3.event.dy));
      return ScrollChartF.move(delta);
    };
    _parseElem = function(elem) {
      var pos = d3.transform(elem.attr("transform"));
      return {
        x: pos.translate[0],
        y: pos.translate[1]
      };
    };
    _dragEventListener = function() {
      return d3.behavior.drag().on('drag', _drag).origin(function() {
        return _parseElem(d3.select(this));
      });
    };
    _updatePosition = function(selection, position, height) {
      var scrollPosition = (-position * (1 + _lineScale)) + STARTING_POSITION;
      height = _getElemHeight(selection);
      return selection.attr('y1', scrollPosition).attr('y2', scrollPosition + height);
    };
    _onMove = function(selection) {
      return function(position) {
        return _updatePosition(selection, position);
      };
    };
    _customizeScroll = function(gScroll, target, data) {
      var contentHeight, frameHeight, gLine, height, numDrivers, x;
      frameHeight = target.height();
      numDrivers = target.getDriverIds(data).length;
      contentHeight = numDrivers * target.rowHeight();
      height = 0;
      _lineScale = frameHeight / contentHeight;
      if (contentHeight > frameHeight) {
        height = _lineScale * frameHeight - STARTING_POSITION - 6;
      }
      x = target.width() + target.margin().right - 10;
      gLine = gScroll.selectAll('line.scrollbar');
      if (gLine.empty() && height > 0) {
        gLine = gScroll.append('line').classed('scrollbar', true);
        gLine.call(_dragEventListener());
        ScrollChartF.addListener(_onMove(gLine));
      }
      if (!gLine.empty() && height === 0) {
        gLine.remove();
      }
      gLine.attr('x1', x).attr('x2', x).attr(LINE_LENGTH_ATTR, height).transition();
      return _updatePosition(gLine, ScrollChartF.getPosition());
    };
    _upsertScroll = function(target, data) {
      var gScroll;
      var gContent = d3.select(this);
      gScroll = gContent.selectAll('g.scroll');
      if (gScroll.empty()) {
        gScroll = gContent.append('g').classed('scroll', true);
      }
      return _customizeScroll(gScroll, target, data);
    };
    return function(target, selection) {
      return selection.each(function(data) {
        return _upsertScroll.call(this, target, data);
      });
    };
  };
  ScrollBarF.$inject = ["ScrollChartF"];

  angular.module('app').factory('ScrollBarF', ScrollBarF);

}).call(this);

(function() {
  var ScrollChartF = function() {
    var _callbacks, _min, _notify, _position;
    _callbacks = [];
    _position = 0;
    _min = -100000000;
    _notify = function(event) {
      var c, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _callbacks.length; _i < _len; _i++) {
        c = _callbacks[_i];
        _results.push(c(_position, event));
      }
      return _results;
    };
    ScrollChartF = {};
    ScrollChartF.SCROLL_SPEED = 22;
    ScrollChartF.DRAG_SPEED = 15;
    ScrollChartF.addListener = function(callback) {
      return _callbacks.push(callback);
    };
    ScrollChartF.setPosition = function(position) {
      _position = position;
      _position = Math.min(0, Math.max(_min, _position));
      return _notify('move');
    };
    ScrollChartF.move = function(delta) {
      _position += delta;
      _position = Math.min(0, Math.max(_min, _position));
      return _notify('move');
    };
    ScrollChartF.setMinPosition = function(min) {
      _min = Math.min(0, min);
      if (_position < _min) {
        _position = Math.max(_min, _position);
        return _notify('move');
      }
    };
    ScrollChartF.resetPosition = function() {
      _position = 0;
      return _notify('reset');
    };
    ScrollChartF.getPosition = function() {
      return _position;
    };
    return ScrollChartF;
  };

  angular.module('app').factory('ScrollChartF', ScrollChartF);

}).call(this);

(function() {
  var TickLinesChartF = (function() {
    var MIN_TICK_MULTIPLY, ROWS_SHOWN_IN_MAX, _createLine, _customizeLines, _generateLines, _upsertLines;

    MIN_TICK_MULTIPLY = 2;

    ROWS_SHOWN_IN_MAX = 10;

    _createLine = function(x1, y1, x2, y2) {
      return {
        id: "x_" + x1,
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      };
    };

    _generateLines = function(target) {
      var axis, i, j, leftColumnNum, lines, numMajorTicks, range, t, tickMultiply, ticks, x, y1, y2, _i, _j, _len;
      lines = [];
      leftColumnNum = target.loadColumn() + target.timeColumn();
      axis = target.axis();
      numMajorTicks = axis.x.ticks().length;
      tickMultiply = MIN_TICK_MULTIPLY;
      ticks = axis.x.ticks(numMajorTicks * tickMultiply);
      range = axis.y.range();
      y1 = range[0];
      y2 = Math.max(range[range.length - 1] + target.rowHeight(), target.rowHeight() * ROWS_SHOWN_IN_MAX);
      for (i = _i = 0; 0 <= leftColumnNum ? _i <= leftColumnNum : _i >= leftColumnNum; i = 0 <= leftColumnNum ? ++_i : --_i) {
        x = (-1 * i * target.leftColumnWidth()) - target.zoomMargin();
        lines.push(_createLine(x, y1, x, y2));
      }
      for (j = _j = 0, _len = ticks.length; _j < _len; j = ++_j) {
        t = ticks[j];
        x = axis.x(t);
        lines.push(_createLine(x, y1, x, y2));
      }
      return lines;
    };

    _customizeLines = function(selection) {
      return selection.each(function(d) {
        var line = d3.select(this);
        return line.classed('tickLine', true).attr('x1', d.x1).attr('x2', d.x2).attr('y1', d.y1).attr('y2', d.y2);
      });
    };

    _upsertLines = function(target, data) {
      var current, gContent, gLines, lines;
      lines = _generateLines(target);
      gContent = d3.select(this);
      gLines = gContent.selectAll('g.tickLines');
      if (gLines.empty()) {
        gLines = gContent.append('g').classed('tickLines', true);
      }
      current = gLines.selectAll('line.tickLine').data(lines, function(d) {
        return d.id;
      }).call(_customizeLines);
      current.enter().append('line').call(_customizeLines);
      return current.exit().remove();
    };

    function TickLinesChartF(target, selection) {
      selection.each(function(data) {
        return _upsertLines.call(this, target, data);
      });
    }

    return TickLinesChartF;

  })();

  angular.module('app').factory('TickLinesChartF', function() {
    return TickLinesChartF;
  });

}).call(this);

(function() {
  var UnservedRowChartF = function(GanttConstants, GMarkerF, $translate, BuildVisitsF, LabelF) {
    var _addMarkerClickListener, _drawAutoScheduleButton, _drawUnscheduledReasonsButton, _drawUnservedLabel, _drawUnservedPaginationButtons, _drawUnservedRect, _getUnservedDriver, _isLiveOrPastProject, _nextUnservedPage, _prevUnservedPage;
    _prevUnservedPage = function(target) {
      return function() {
        return target.prevUnservedPage.call(target);
      };
    };
    _nextUnservedPage = function(target) {
      return function() {
        return target.nextUnservedPage.call(target);
      };
    };
    _drawUnservedRect = function(target, axis, container, hasUnserved) {
      var margins, x, xhtmlDiv, y;
      var foreignObj = container.selectAll('foreignObject.unserved-rect');
      if (hasUnserved) {
        margins = target.margin().left + target.margin().right;
        x = -target.margin().left;
        y = axis.y.range()[0] - 1;
        if (foreignObj.empty()) {
          foreignObj = container.append('foreignObject').classed("unserved-rect", true);
        }
        foreignObj.attr('height', target.rowHeight()).attr('width', target.width() + margins).attr('transform', "translate(" + x + ", " + y + ")");
        xhtmlDiv = foreignObj.selectAll('div.unserved-box');
        if (xhtmlDiv.empty()) {
          return xhtmlDiv = foreignObj.append('xhtml:div').classed('unserved-box', true);
        }
      } else {
        return foreignObj.remove();
      }
    };
    _isLiveOrPastProject = function(target) {
      return target.chartType() === 'live' || target.isPastProject();
    };
    _addMarkerClickListener = function(target, d) {
      if (!d.driverId) {
        return GMarkerF.addEventListener(d.id, 'click', 'unservedPagination', (function(_this) {
          return function() {
            if (!d.driverId) {
              return target.goToPageWithUnservedItem.call(target, d.index);
            }
          };
        })(this));
      }
    };
    _drawUnservedPaginationButtons = function(target, container, hasUnserved) {
      var maxPageIdx, maxUnservedPerPage, nextSpan, prevSpan, width, xhtmlDiv;
      var foreignObj = container.selectAll('foreignObject.unserved-pagination');
      maxUnservedPerPage = target.getMaxUnservedPerPage();
      if (hasUnserved && maxUnservedPerPage < target.numUnserved()) {
        if (foreignObj.empty()) {
          foreignObj = container.append('foreignObject').classed("unserved-pagination", true).attr('height', target.rowHeight());
        }
        width = null;
        if (_isLiveOrPastProject(target)) {
          width = target.width() + target.margin().right;
        } else {
          width = target.width() - 115;
        }
        foreignObj.attr('width', width);
        xhtmlDiv = foreignObj.selectAll('div.clean-pagination');
        if (xhtmlDiv.empty()) {
          xhtmlDiv = foreignObj.append('xhtml:div').classed('clean-pagination', true);
        }
        prevSpan = xhtmlDiv.selectAll('span.icon-back');
        if (prevSpan.empty()) {
          prevSpan = xhtmlDiv.append('span').on("click", _prevUnservedPage(target)).classed("icon-back", true);
        }
        nextSpan = xhtmlDiv.selectAll('span.icon-next');
        if (nextSpan.empty()) {
          nextSpan = xhtmlDiv.append('span').on("click", _nextUnservedPage(target)).classed("icon-next", true);
        }
        maxPageIdx = Math.ceil(target.numUnserved() / maxUnservedPerPage) - 1;
        if (target.unservedPage() >= maxPageIdx) {
          return nextSpan.remove();
        }
      } else {
        return foreignObj.remove();
      }
    };
    _drawUnscheduledReasonsButton = function(target, container, hasUnserved) {
      var text, unscheduledIcon, xPos, xhtmlDiv, yPos;
      var foreignObj = container.selectAll('foreignObject.unscheduled-reason-container');
      if (hasUnserved && !_isLiveOrPastProject(target)) {
        if (foreignObj.empty()) {
          foreignObj = container.append('foreignObject').classed("unscheduled-reason-container", true).on("click", target.onUnscheduledReasonsClick).attr('height', 40);
        }
        foreignObj.attr('width', GanttConstants.UNSCHEDULED_REASONS_BTN_WIDTH);
        xhtmlDiv = foreignObj.selectAll('div.unscheduled-reason-button');
        if (xhtmlDiv.empty()) {
          xhtmlDiv = foreignObj.append('xhtml:div').classed("unscheduled-reason-button", true);
        }
        unscheduledIcon = xhtmlDiv.selectAll('i.unscheduled-reason-icon');
        if (unscheduledIcon.empty()) {
          unscheduledIcon = xhtmlDiv.append('i').classed('unscheduled-reason-icon', true);
        }
        text = xhtmlDiv.selectAll('text.unscheduled-reason-text');
        if (text.empty()) {
          text = xhtmlDiv.append('text').classed("unscheduled-reason-text", true).text("See Unscheduled Reasons");
        }
        xPos = 0. - GanttConstants.UNSCHEDULED_REASONS_BTN_WIDTH;
        yPos = target.rowHeight() - GanttConstants.AUTO_SCHEDULE_BTN_HEIGHT - GanttConstants.AUTO_SCHEDULE_BTN_MARGIN_BOTTOM - 6;
        foreignObj.attr('transform', "translate(" + xPos + ", " + yPos + ")");
        return text.attr('transform', "translate(20, 20)");
      } else {
        return foreignObj.remove();
      }
    };
    _drawAutoScheduleButton = function(target, container, hasUnserved) {
      var rect, text, xPos, yPos;
      var g = container.selectAll('g.auto-schedule-button');
      if (hasUnserved && !_isLiveOrPastProject(target)) {
        if (g.empty()) {
          g = container.append('g').classed("auto-schedule-button", true).classed("onboarding-target-auto-reschedule-btn", true).on("click", target.onScheduleUnservedClick);
        }
        g.classed('active', hasUnserved);
        rect = g.selectAll('rect.auto-schedule');
        if (rect.empty()) {
          rect = g.append('rect').classed("auto-schedule", true).attr('height', GanttConstants.AUTO_SCHEDULE_BTN_HEIGHT).attr('width', GanttConstants.AUTO_SCHEDULE_BTN_WIDTH);
        }
        text = g.selectAll('text.auto-schedule-text');
        if (text.empty()) {
          text = g.append('text').classed("auto-schedule-text", true).text($translate.instant("Force Schedule All"));
        }
        xPos = (target.width() + target.margin().right) - GanttConstants.AUTO_SCHEDULE_BTN_WIDTH - GanttConstants.AUTO_SCHEDULE_BTN_MARGIN_RIGHT;
        yPos = target.rowHeight() - GanttConstants.AUTO_SCHEDULE_BTN_HEIGHT - GanttConstants.AUTO_SCHEDULE_BTN_MARGIN_BOTTOM - 4;
        g.attr('transform', "translate(" + xPos + ", " + yPos + ")");
        return text.attr('transform', "translate(20, 20)");
      } else {
        return g.remove();
      }
    };
    _getUnservedDriver = function(tasks) {
      var unservedTasks = _.filter(tasks, function(d) {
        return !d.driverId;
      });
      return _.uniq(_.map(unservedTasks, function(d) {
        return {
          id: d.driverId,
          color: d.color,
          dispatchStatus: d.dispatchStatus,
          yPos: 0
        };
      }));
    };
    _drawUnservedLabel = function(data, target, axis, gUnservedRow, hasUnserved) {
      var current, customLabels, gLabels, unservedDriver;
      gLabels = gUnservedRow.selectAll('g.labels');
      if (hasUnserved) {
        unservedDriver = _getUnservedDriver(data);
        if (gLabels.empty()) {
          gLabels = gUnservedRow.append('g').classed('labels', true);
        }
        customLabels = LabelF(target);
        current = gLabels.selectAll('g.item').data(unservedDriver, function(d) {
          return d.id;
        }).call(customLabels);
        current.enter().append('g').call(customLabels);
        return current.exit().remove();
      } else {
        return gLabels.remove();
      }
    };
    UnservedRowChartF = function(target, selection) {
      return selection.each(function(data) {
        var axis, d, forUnserved, gGantt, gUnservedRow, hasUnserved, _i, _len, _results;
        hasUnserved = target.numUnserved() > 0;
        gGantt = d3.select(this);
        gUnservedRow = gGantt.selectAll('g.unserved-row');
        if (gUnservedRow.empty()) {
          gUnservedRow = gGantt.append("g").classed('unserved-row', true);
        }
        gUnservedRow.classed('live', target.chartType() === 'live');
        axis = target.axis();
        _drawUnservedRect(target, axis, gUnservedRow, hasUnserved);
        _drawAutoScheduleButton(target, gUnservedRow, hasUnserved);
        _drawUnservedPaginationButtons(target, gUnservedRow, hasUnserved);
        _drawUnservedLabel(data, target, axis, gUnservedRow, hasUnserved);
        _drawUnscheduledReasonsButton(target, gUnservedRow, hasUnserved);
        BuildVisitsF(gUnservedRow, target, data, forUnserved = true);
        _results = [];
        for (_i = 0, _len = data.length; _i < _len; _i++) {
          d = data[_i];
          _results.push(_addMarkerClickListener(target, d));
        }
        return _results;
      });
    };
    return UnservedRowChartF;
  };
  UnservedRowChartF.$inject = ["GanttConstants", "GMarkerF", "$translate", "BuildVisitsF", "LabelF"];

  angular.module('app').service('UnservedRowChartF', UnservedRowChartF);

}).call(this);

(function() {
  var ZoomChartF = function(AnalyticsS, $translate) {
    var BRUSH_HEIGHT, BRUSH_Y_POS, ZOOM_BUTTONS_RIGHT, ZOOM_BUTTONS_Y_POS, ZOOM_BUTTON_SIZE, ZOOM_FACTOR, _brush, _brushed, _hideBrush, _makeZoomButtons, _originalScale, _redrawBrush, _resetZoom, _target, _zoom, _zoomChart, _zoomIn;
    BRUSH_HEIGHT = 30;
    BRUSH_Y_POS = -18;
    ZOOM_BUTTON_SIZE = 30;
    ZOOM_BUTTONS_RIGHT = 30;
    ZOOM_BUTTONS_Y_POS = -18;
    ZOOM_FACTOR = 0.2;
    _brush = null;
    _zoom = null;
    _originalScale = null;
    _target = null;
    _redrawBrush = function() {
      return _brush(d3.selectAll(".brush"));
    };
    _hideBrush = function() {
      return d3.selectAll(".brush").call(_brush.clear());
    };
    _zoomChart = function(domain) {
      _target.zoomed(domain);
      return _target.brush(domain);
    };
    _zoomIn = function() {
      var axis, currentScale, domain, targetZoom;
      currentScale = _zoom.scale();
      targetZoom = currentScale + ZOOM_FACTOR;
      _zoom.scale(targetZoom);
      _target.redrawContentChart();
      axis = _target.axis();
      domain = axis.x.domain();
      _brush.extent(domain);
      _redrawBrush();
      _target.brush(domain);
      return AnalyticsS.track('081 Zoom');
    };
    _resetZoom = function() {
      var axis;
      _zoomChart(_originalScale.domain());
      _brush.extent(_originalScale.domain());
      _hideBrush();
      axis = _target.axis();
      _zoom.x(axis.x);
      _target.brush(null);
      return AnalyticsS.track('082 Zoom reset');
    };
    _brushed = function() {
      var axis;
      if (_brush.empty()) {
        _zoomChart(_originalScale.domain());
      } else {
        _zoomChart(_brush.extent());
      }
      axis = _target.axis();
      return _zoom.x(axis.x);
    };
    _makeZoomButtons = function(gGantt) {
      var gZoomIn, gZoomReset, rectZoomButtons;
      rectZoomButtons = gGantt.append("g").attr("class", "zoom-buttons").attr("transform", "translate(" + (_target.width() - ZOOM_BUTTONS_RIGHT) + "," + ZOOM_BUTTONS_Y_POS + ")");
      gZoomIn = rectZoomButtons.append("g").attr("class", "zoom-in");
      gZoomIn.append("foreignObject").attr("width", ZOOM_BUTTON_SIZE).attr("height", ZOOM_BUTTON_SIZE).on("click", _zoomIn).append('xhtml:div').append("span").attr('class', "icon-zoom-in").attr('title', "Zoom Timeline").attr('transform', "translate(4,15)");
      gZoomReset = rectZoomButtons.append("g").attr("class", "zoom-reset").attr('transform', "translate(" + ZOOM_BUTTON_SIZE + ", 0)");
      return gZoomReset.append("foreignObject").attr("width", ZOOM_BUTTON_SIZE + 10).attr("height", ZOOM_BUTTON_SIZE).on("click", _resetZoom).append('xhtml:div').append("span").attr('class', "reset-text").attr('transform', "translate(4,15)").text($translate.instant("ROUTE_BOX.RESET")).attr('title', "Reset Timeline Zoom");
    };
    ZoomChartF = function(target) {
      var axis, selection;
      _target = target;
      selection = _target.selection();
      axis = _target.axis();
      return selection.each(function(data) {
        var gBrush, gGantt, gZoomButtons;
        gGantt = d3.select(this);
        _originalScale = d3.time.scale().domain(axis.x.domain()).range(axis.x.range()).clamp(false);
        if (_brush == null) {
          _brush = d3.svg.brush().on("brushend", _brushed);
        }
        _brush.x(_originalScale);
        if (_target.brush() != null) {
          _brush.extent(_target.brush());
          _brushed();
        } else {
          _hideBrush();
        }
        gBrush = gGantt.selectAll('g.brush-area');
        if (gBrush.empty()) {
          gBrush = gGantt.append("g").attr("class", "brush-area");
          gBrush.append("g").attr("class", "x brush").call(_brush).selectAll("rect").attr("y", BRUSH_Y_POS).attr("height", BRUSH_HEIGHT);
        }
        if (_zoom == null) {
          _zoom = d3.behavior.zoom();
        }
        _zoom.x(axis.x);
        _zoom.scaleExtent([-1000, 1000]);
        gZoomButtons = gGantt.selectAll('g.zoom-buttons');
        if (gZoomButtons.empty()) {
          return _makeZoomButtons(gGantt);
        } else {
          return gZoomButtons.attr("transform", "translate(" + (_target.width() - ZOOM_BUTTONS_RIGHT) + "," + ZOOM_BUTTONS_Y_POS + ")");
        }
      });
    };
    return ZoomChartF;
  };
  ZoomChartF.$inject = ["AnalyticsS", "$translate"];

  angular.module('app').factory('ZoomChartF', ZoomChartF);

}).call(this);

(function() {
  var DriverGeocoordF = function(GeocoordF) {
    DriverGeocoordF = new GeocoordF();
    return DriverGeocoordF;
  };
  DriverGeocoordF.$inject = ["GeocoordF"];

  angular.module('app').factory('DriverGeocoordF', DriverGeocoordF);

}).call(this);

(function() {
  var GeocodeCache = function() {
    var _coords, _generateKey;
    _coords = {};
    _generateKey = function(address) {
      return address.trim().toLowerCase();
    };
    GeocodeCache = {};
    GeocodeCache.load = function(address) {
      var key = _generateKey(address);
      return _coords[key];
    };
    GeocodeCache.save = function(address, latitude, longitude, allResults) {
      var coord, key;
      key = _generateKey(address);
      coord = {
        address: address.trim(),
        coords: {
          lat: latitude,
          lng: longitude
        },
        all_results: allResults ? allResults : void 0
      };
      return _coords[key] = coord;
    };
    return GeocodeCache;
  };

  angular.module('app').factory('GeocodeCache', GeocodeCache);

}).call(this);

(function() {
  var GeocoordF = function($q, $timeout, UUID, Constants, AccountF, GeocodeCache, GeocoordS) {
    var GMAPS_INTERVAL, ONE_SEC_IN_MS, WORKER_GEOCODE_ERROR, WORKER_GEOCODE_FINISHED, __batchTranslate, __isValidAddress, __resolveTask, _addToBatch, _dispatchBatchIfFilled, _incrementBatchComplete, _isValidFloat, _onWorkerFailed, _reverseTranslate, _translateAddress, _watcher;
    GMAPS_INTERVAL = 1000;
    WORKER_GEOCODE_FINISHED = 'finished';
    WORKER_GEOCODE_ERROR = 'error';
    ONE_SEC_IN_MS = 1000;
    __isValidAddress = function(address) {
      return (address != null) && (typeof address === 'string');
    };
    __resolveTask = function(task, place) {
      var location = GeocodeCache.save(place.address, place.latitude, place.longitude, place.all_results);
      task.location = location;
      return task.deferred.resolve(task.location);
    };
    __batchTranslate = function(tasks) {
      var task, _i, _len;
      var req = {
        places: {}
      };
      if (tasks.length <= 0) {
        return $q.when(req);
      }
      for (_i = 0, _len = tasks.length; _i < _len; _i++) {
        task = tasks[_i];
        req.places[task.uuid] = {
          address: task.location
        };
      }
      return GeocoordS.sendGeocodeJob(req).then((function(_this) {
        return function(jobId) {
          return GeocoordS.fetchJob(jobId, _watcher.bind(_this));
        };
      })(this))["catch"](function() {
        return $q.reject(new Error('Batch translation request failed'));
      });
    };
    _watcher = function(results) {
      var coords, id, place, task, _ref, _results;
      _ref = results.places;
      _results = [];
      for (id in _ref) {
        place = _ref[id];
        task = this.batch.tasks[id];
        coords = task.location.coords;
        if (!task || ((coords != null ? coords.lat : void 0) && (coords != null ? coords.lng : void 0)) || !place.latitude || !place.longitude) {
          continue;
        }
        _results.push(__resolveTask(task, place));
      }
      return _results;
    };
    _onWorkerFailed = function() {
      var index, task, _i, _len, _ref, _results;
      var failed = this.batch.failed;
      if (!(failed.length > 0)) {
        return;
      }
      _ref = this.batch.failed;
      _results = [];
      for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
        task = _ref[index];
        _results.push(task.deferred.reject(new Error(task.error)));
      }
      return _results;
    };
    _addToBatch = function(address) {
      var geocodeTask;
      var deferred = $q.defer();
      geocodeTask = {
        uuid: UUID.generate(),
        "function": GeocoordS.translate,
        location: address,
        deferred: deferred
      };
      this.batch.tasks[geocodeTask.uuid] = geocodeTask;
      this.batch.queue.push(geocodeTask);
      _dispatchBatchIfFilled.call(this);
      return deferred.promise;
    };
    _dispatchBatchIfFilled = function() {
      var batch, count, queue, tasks, total;
      if (this.batch.total === 0) {
        return;
      }
      count = this.batch.count;
      total = this.batch.total;
      tasks = this.batch.tasks;
      queue = this.batch.queue;
      if (count >= total || queue.length >= GeocoordF.BATCH_SIZE) {
        batch = queue.splice(0, GeocoordF.BATCH_SIZE);
        return __batchTranslate.call(this, batch).then((function(_this) {
          return function(results) {
            var coords, key, place, task, _ref, _ref1, _results;
            _ref = results.places;
            _results = [];
            for (key in _ref) {
              place = _ref[key];
              _this.batch.completed++;
              task = tasks[key];
              coords = task != null ? (_ref1 = task.location) != null ? _ref1.coords : void 0 : void 0;
              if (!task || ((coords != null ? coords.lat : void 0) && (coords != null ? coords.lng : void 0))) {
                continue;
              }
              if (place.latitude && place.longitude) {
                _results.push(__resolveTask(task, place));
              } else {
                task.error = "MESSAGES.INVALID_ADDRESS_ERR";
                _results.push(_this.batch.failed.push(task));
              }
            }
            return _results;
          };
        })(this))["catch"]((function(_this) {
          return function(error) {
            var task, _i, _len, _ref;
            _this.batch.completed += batch.length;
            for (_i = 0, _len = batch.length; _i < _len; _i++) {
              task = batch[_i];
              task.error = "MESSAGES.TRANSLATION_FAILED_ERR";
            }
            return (_ref = _this.batch.failed).push.apply(_ref, batch);
          };
        })(this))["finally"]((function(_this) {
          return function() {
            if (_this.batch.completed >= total) {
              _onWorkerFailed.call(_this);
              return _this.resetBatch(0);
            }
          };
        })(this));
      }
    };
    _incrementBatchComplete = function() {
      this.batch.completed++;
      return _dispatchBatchIfFilled.call(this);
    };
    _translateAddress = function(address) {
      var coord;
      if (!__isValidAddress(address)) {
        return $q.reject(new Error('Address must be defined and must be a String'));
      }
      coord = GeocodeCache.load(address);
      if (coord) {
        _incrementBatchComplete.call(this);
        return $q.when(coord);
      }
      return _addToBatch.call(this, address);
    };
    _isValidFloat = function(val) {
      return (val != null) && parseFloat(val).toString() === val.toString();
    };
    _reverseTranslate = function(lat, lng, address) {
      var newAddress;
      if (!_isValidFloat(lat)) {
        return $q.reject(new Error('Latitude must be defined and must be a Float'));
      }
      if (!_isValidFloat(lng)) {
        return $q.reject(new Error('Longitude must be defined and must be a Float'));
      }
      newAddress = (address != null ? address.trim().length : void 0) > 0 ? address : "" + lat + ", " + lng;
      return $q.when({
        address: newAddress,
        coords: {
          lat: lat,
          lng: lng
        }
      });
    };
    GeocoordF = (function() {
      function GeocoordF() {
        this.resetBatch(0);
      }

      return GeocoordF;

    })();
    GeocoordF.BATCH_SIZE = 500;
    GeocoordF.prototype.resetBatch = function(total) {
      return this.batch = {
        total: total,
        count: 0,
        completed: 0,
        tasks: {},
        queue: [],
        failed: []
      };
    };
    GeocoordF.prototype.translate = function(location) {
      var coords, __completeWithError, _ref, _ref1;
      this.batch.count++;
      __completeWithError = (function(_this) {
        return function(message) {
          _incrementBatchComplete.call(_this);
          return $q.reject(new Error(message));
        };
      })(this);
      if (!location) {
        return __completeWithError("Location is not provided");
      }
      if (!((location != null ? location.address : void 0) || ((location != null ? (_ref = location.coords) != null ? _ref.lat : void 0 : void 0) && (location != null ? (_ref1 = location.coords) != null ? _ref1.lng : void 0 : void 0)))) {
        return __completeWithError('No address or latitude/longitude is provided');
      }
      coords = location.coords;
      if (location.address && (coords != null ? coords.lat : void 0) && (coords != null ? coords.lng : void 0)) {
        _incrementBatchComplete.call(this);
        return $q.when(angular.copy(location));
      }
      if ((coords != null ? coords.lat : void 0) && (coords != null ? coords.lng : void 0)) {
        return _reverseTranslate(coords.lat, coords.lng, location.address).then((function(_this) {
          return function(place) {
            _incrementBatchComplete.call(_this);
            return place;
          };
        })(this));
      }
      return _translateAddress.call(this, location.address);
    };
    return GeocoordF;
  };
  GeocoordF.$inject = ["$q", "$timeout", "UUID", "Constants", "AccountF", "GeocodeCache", "GeocoordS"];

  angular.module('app').factory('GeocoordF', GeocoordF);

}).call(this);

(function() {
  var GeocoordS = function($http, $q, $timeout, Constants, AccountF, GeocodeCache, NumberUtilF) {
    var ONE_SEC_IN_MS, TRANSLATION_FAILED_ERR, WORKER_GEOCODE_ERROR, WORKER_GEOCODE_FINISHED, _formatResult, _gMap, _geocoder;
    WORKER_GEOCODE_FINISHED = 'finished';
    WORKER_GEOCODE_ERROR = 'error';
    TRANSLATION_FAILED_ERR = "Translation request failed";
    ONE_SEC_IN_MS = 1000;
    _gMap = google.maps;
    _geocoder = new _gMap.Geocoder();
    _formatResult = function(data) {
      var k, location, v, _i, _len, _ref, _ref1;
      _ref = data.places;
      for (k in _ref) {
        v = _ref[k];
        if (!v.latitude || !v.longitude) {
          continue;
        }
        v.latitude = NumberUtilF.toLatitude(v.latitude);
        v.longitude = NumberUtilF.toLongitude(v.longitude);
        if (v.all_results) {
          _ref1 = v.all_results;
          for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
            location = _ref1[_i];
            location.latitude = NumberUtilF.toLatitude(location.latitude);
            location.longitude = NumberUtilF.toLongitude(location.longitude);
          }
        }
      }
      return data;
    };
    GeocoordS = (function() {
      function GeocoordS() {}

      return GeocoordS;

    })();
    GeocoordS.translate = function(address) {
      var request = {
        address: address
      };
      return $q(function(resolve, reject) {
        return _geocoder.geocode(request, function(results, status) {
          var allResults, coord, error, latitude, location, longitude;
          if (status === _gMap.GeocoderStatus.OK) {
            location = results[0].geometry.location;
            latitude = location.lat();
            longitude = location.lng();
            if (location.all_results) {
              allResults = location.all_results;
            }
            coord = GeocodeCache.save(address, latitude, longitude, allResults);
            return resolve(coord);
          } else {
            error = new Error(TRANSLATION_FAILED_ERR);
            error.status = status;
            return reject(error);
          }
        });
      });
    };
    GeocoordS.sendGeocodeJob = function(req) {
      return $http.post("" + Constants.apiPath + "/v1/geocode", req, AccountF.getAuthHeader()).then(function(res) {
        if (res.status !== 200) {
          return $q.reject(new Error(res.data.error));
        }
        return res.data.id;
      });
    };
    GeocoordS.fetchJob = function(jobId, watcher) {
      return $http.get("" + Constants.apiPath + "/v1/geocode/" + jobId, AccountF.getAuthHeader()).then(function(res) {
        var data;
        if (res.status !== 200) {
          return $q.reject(new Error(res.data.error));
        }
        data = res.data;
        switch (data.status) {
          case WORKER_GEOCODE_ERROR:
            return $q.reject(new Error(data.error));
          case WORKER_GEOCODE_FINISHED:
            return _formatResult(data);
          default:
            watcher(_formatResult(data));
            return $timeout(function() {
              return GeocoordS.fetchJob(jobId, watcher);
            }, ONE_SEC_IN_MS);
        }
      });
    };
    return GeocoordS;
  };
  GeocoordS.$inject = ["$http", "$q", "$timeout", "Constants", "AccountF", "GeocodeCache", "NumberUtilF"];

  angular.module('app').service('GeocoordS', GeocoordS);

}).call(this);

(function() {
  var VisitGeocoordF = function(GeocoordF) {
    VisitGeocoordF = new GeocoordF();
    return VisitGeocoordF;
  };
  VisitGeocoordF.$inject = ["GeocoordF"];

  angular.module('app').factory('VisitGeocoordF', VisitGeocoordF);

}).call(this);

(function() {
  var GPSRoutesF = function(AccountF, GPSSocketS, DispatchStatusF, Events, EventListenersF, RouteS, DispatchF, ProjectF) {
    var _initializeEventListeners, _lastConnectedProjectId, _onMsg, _parseNewCoord, _subscribeGPSRouteChannels;
    _lastConnectedProjectId = null;
    _parseNewCoord = function(_arg) {
      var longitude;
      var latitude = _arg.latitude, longitude = _arg.longitude;
      return {
        lat: latitude,
        lng: longitude
      };
    };
    _onMsg = function(_arg) {
      var currentLocation, dispatch, lastLocation, location, nextLocation, projectId, routeId, timestamp, vehicleId;
      projectId = _arg.projectId, routeId = _arg.routeId, location = _arg.location, lastLocation = _arg.lastLocation, timestamp = _arg.timestamp;
      if (lastLocation) {
        currentLocation = _parseNewCoord(lastLocation);
      }
      nextLocation = _parseNewCoord(location);
      dispatch = DispatchF.getDispatchWithRouteId(routeId);
      vehicleId = dispatch.vehicle.id;
      return EventListenersF.notify(Events.DRIVER_GPS_LOCATION_UPDATED(vehicleId), {
        nextLocation: nextLocation,
        timestamp: timestamp
      });
    };
    _subscribeGPSRouteChannels = function() {
      var dispatched, dispatchedRoutes, projectId, route, _i, _len, _ref;
      if (DispatchStatusF.hasDispatches() && RouteS.hasRoute() && AccountF.hasGPSTracking()) {
        projectId = (_ref = ProjectF.project) != null ? _ref.id : void 0;
        route = RouteS.getRoute();
        if (!((projectId != null) && (route.routes != null))) {
          return;
        }
        dispatchedRoutes = route.routes.filter(function(r) {
          return r.routeId != null;
        });
        if (dispatchedRoutes.length > 0) {
          GPSSocketS.connect();
          for (_i = 0, _len = dispatchedRoutes.length; _i < _len; _i++) {
            dispatched = dispatchedRoutes[_i];
            GPSSocketS.subscribe(projectId, dispatched.routeId, _onMsg);
          }
        }
        _lastConnectedProjectId = projectId;
        return true;
      }
      return GPSSocketS.disconnect();
    };
    _initializeEventListeners = function() {
      EventListenersF.addEventListener(Events.DISPATCH_DELETED, function(_arg) {
        var projectId, routeId, _ref;
        routeId = _arg.routeId;
        projectId = (_ref = ProjectF.project) != null ? _ref.id : void 0;
        return GPSSocketS.unsubscribe(projectId, routeId);
      });
      EventListenersF.addEventListener(Events.DISPATCH_SENT, function(_arg) {
        var projectId, routeId, _ref;
        routeId = _arg.routeId;
        GPSSocketS.connect();
        projectId = (_ref = ProjectF.project) != null ? _ref.id : void 0;
        return GPSSocketS.subscribe(projectId, routeId, _onMsg);
      });
      EventListenersF.addEventListener(Events.PROJECT_LOADED, function(_arg) {
        var projectId = _arg.projectId;
        if (!AccountF.hasGPSTracking()) {
          GPSRoutesF.disable();
          return;
        }
        if (_lastConnectedProjectId !== projectId) {
          GPSSocketS.unsubscribeAll();
          _subscribeGPSRouteChannels();
          return _lastConnectedProjectId = projectId;
        }
      });
      return EventListenersF.addEventListener(Events.PROJECT_RELOADED, function(_arg) {
        var projectId = _arg.projectId;
        if (!AccountF.hasGPSTracking()) {
          GPSRoutesF.disable();
          return;
        }
        if (_lastConnectedProjectId !== projectId) {
          GPSSocketS.unsubscribeAll();
          return _subscribeGPSRouteChannels();
        }
      });
    };
    GPSRoutesF = {};
    GPSRoutesF.init = function() {
      _initializeEventListeners();
      return _subscribeGPSRouteChannels();
    };
    GPSRoutesF.disable = function() {
      GPSSocketS.unsubscribeAll();
      GPSSocketS.disconnect();
      return _lastConnectedProjectId = null;
    };
    GPSRoutesF.isSubscribedRoute = function(routeId) {
      var _ref;
      var projectId = (_ref = ProjectF.project) != null ? _ref.id : void 0;
      return GPSSocketS.isChannelSubscribed(projectId, routeId);
    };
    GPSRoutesF.getLastTracked = function(routeId) {
      var _ref;
      var projectId = (_ref = ProjectF.project) != null ? _ref.id : void 0;
      return GPSSocketS.getChannelLastTimestamp(projectId, routeId);
    };
    return GPSRoutesF;
  };
  GPSRoutesF.$inject = ["AccountF", "GPSSocketS", "DispatchStatusF", "Events", "EventListenersF", "RouteS", "DispatchF", "ProjectF"];

  angular.module('app').factory('GPSRoutesF', GPSRoutesF);

}).call(this);

(function() {
  var GPSSocketS = function(AccountF, Constants, Events, EventListenersF) {
    var SOCKET_LOCATION_EVENT, _createChannelKey, _currentProjectId, _currentSubscribedChannels, _isConnected, _socket;
    SOCKET_LOCATION_EVENT = 'location';
    _isConnected = false;
    _socket = new Ably.Realtime({
      key: Constants.gpsSocketKey,
      clientId: AccountF.getUser()._id,
      autoConnect: false
    });
    _socket.connection.on('connected', (function() {
      return _isConnected = true;
    }));
    _socket.connection.on('closed', (function() {
      return _isConnected = false;
    }));
    _createChannelKey = function(projectId, routeId) {
      return "project:" + projectId + ":route:" + routeId;
    };
    _currentSubscribedChannels = {};
    _currentProjectId = null;
    GPSSocketS = {};
    GPSSocketS.isConnected = function() {
      return _isConnected;
    };
    GPSSocketS.connect = function() {
      if (!_isConnected) {
        return _socket.connect();
      }
    };
    GPSSocketS.disconnect = function() {
      if (_isConnected) {
        return _socket.close();
      }
    };
    GPSSocketS.subscribe = function(projectId, routeId, onMsg) {
      var channelKey;
      if (_currentSubscribedChannels[channelKey] != null) {
        return;
      }
      channelKey = _createChannelKey(projectId, routeId);
      _currentSubscribedChannels[channelKey] = {};
      return _socket.channels.get("[?rewind=1]" + channelKey).subscribe(SOCKET_LOCATION_EVENT, function(msg) {
        var lastLocation, location, timestamp;
        location = msg.data;
        timestamp = msg.timestamp;
        lastLocation = _currentSubscribedChannels[channelKey].lastLocation;
        _currentSubscribedChannels[channelKey].lastMessageTime = timestamp;
        _currentSubscribedChannels[channelKey].lastLocation = location;
        return onMsg({
          projectId: projectId,
          routeId: routeId,
          location: location,
          lastLocation: lastLocation,
          timestamp: timestamp
        });
      });
    };
    GPSSocketS.unsubscribe = function(projectId, routeId) {
      var channelKey = _createChannelKey(projectId, routeId);
      _socket.channels.get(channelKey).unsubscribe();
      return _currentSubscribedChannels = {};
    };
    GPSSocketS.unsubscribeAll = function() {
      var channelKeys = Object.keys(_currentSubscribedChannels);
      _socket.channels.get(channelKeys).unsubscribe();
      return _currentSubscribedChannels = {};
    };
    GPSSocketS.isChannelSubscribed = function(projectId, routeId) {
      var channelKey = _createChannelKey(projectId, routeId);
      return _currentSubscribedChannels[channelKey] != null;
    };
    GPSSocketS.getChannelLastTimestamp = function(projectId, routeId) {
      var _ref;
      var channelKey = _createChannelKey(projectId, routeId);
      return (_ref = _currentSubscribedChannels[channelKey]) != null ? _ref.lastMessageTime : void 0;
    };
    return GPSSocketS;
  };
  GPSSocketS.$inject = ["AccountF", "Constants", "Events", "EventListenersF"];

  angular.module('app').factory('GPSSocketS', GPSSocketS);

}).call(this);

(function() {
  var     __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  var HudC = function($q, $state, $scope, $rootScope, $timeout, $kookies, $cacheFactory, $window, $location, isProjectLoaded, isInDemo, VisitF, DriverF, RouteS, Constants, MessagingF, RouteInspectorF, GMarkerF, RouteMarkerInfoF, TimeUtilF, OnboardingF, ConfirmF, ProjectF, DemoF, Messages, EventListenersF, Events, States, DispatchStatusF, NotificationF, DispatchF, MarkerClustererF, RedirectF, AnalyticsS, MessageTemplateF, ProgressBarF, ProjectSessionF, SocketF, AccountF, LoggerF, GPSRoutesF, ProjectJobF, Gtm, FeatureFlagF) {
    var CACHE_ID, ERROR_PROJECT_UPDATING, JSON_LIMIT_REACHED, ONE_DAY, SHOW_END_DAY_KEY, THREE_SECONDS_IN_MS, _activateIntercom, _canOptIn, _initializeEventListeners, _isModalState, _normalizeUpgradeMessage, _notifyProjectConnectToSocket, _ref, _ref1, _ref2, _resetInputState, _setupRedirects, _showEndOfDayCta, _showLandingMessage, _showOptIn, _showTrialEndMessage;
    this.isInDemo = isInDemo;
    this.userInTrial = AccountF.isInTrial();
    this.hasShopifyBilling = AccountF.hasShopifyBilling();
    this.getShopifyDomain = AccountF.getShopifyDomain();
    this.hasLassoDrawn = false;
    this.isUsableInDemo = DemoF.isUsableInDemo;
    ERROR_PROJECT_UPDATING = 'ERR_PROJECT_UPDATING';
    CACHE_ID = 'routeC';
    SHOW_END_DAY_KEY = "endDayCta";
    ONE_DAY = 24 * 60 * 60 * 1000;
    THREE_SECONDS_IN_MS = 3 * 1000;
    JSON_LIMIT_REACHED = 413;
    _showOptIn = function() {
      return _canOptIn().then(function(isEnabled) {
        return $scope.canViewOptInButton = isEnabled;
      });
    };
    _canOptIn = function() {
      return FeatureFlagF.isEnabled('opt_in_beta');
    };
    _resetInputState = function() {
      return RouteS.setAllRoutesVisible(true);
    };
    _showTrialEndMessage = (function(_this) {
      return function() {
        var isPaidUser, message, remaining;
        _this.showFreeTrialEndTooltip = false;
        isPaidUser = AccountF.isPaid();
        if (isPaidUser) {
          return false;
        }
        remaining = TimeUtilF.diffDays(_this.user.trialEnd, new Date());
        message = void 0;
        if (remaining <= 0) {
          ConfirmF.trialEndUpgrade(_this.user.firstName, _activateIntercom, _this.hasShopifyBilling).then(function() {
            return $state.go(States.modalAccountUpgrade);
          });
          return true;
        } else if (remaining <= 5) {
          _this.remainingTrialDays = remaining;
          _this.showFreeTrialEndTooltip = true;
        }
        return false;
      };
    })(this);
    _activateIntercom = function() {
      $window.Intercom('showNewMessage');
      return AnalyticsS.track('108 Upgrade talk to sales');
    };
    _showEndOfDayCta = function() {
      var cache, hasShownEndDayCta, isLandPastProject, _ref;
      if (((_ref = ProjectF.project) != null ? _ref.id : void 0) == null) {
        return;
      }
      if (!$cacheFactory.get(CACHE_ID)) {
        $cacheFactory(CACHE_ID);
      }
      cache = $cacheFactory.get(CACHE_ID);
      hasShownEndDayCta = cache.get(SHOW_END_DAY_KEY);
      isLandPastProject = !ProjectF.isToday() && !ProjectF.isInFuture();
      if (!isLandPastProject || hasShownEndDayCta) {
        return false;
      }
      cache.put(SHOW_END_DAY_KEY, true);
      $state.go(States.modalProjectEndDay);
      return true;
    };
    _showLandingMessage = function() {
      var query = $location.search();
      if (!ConfirmF.isDialogOpen()) {
        if (query != null ? query[Constants.UPGRADE_QS] : void 0) {
          $state.go(States.modalAccountUpgrade);
        } else if (_showTrialEndMessage()) {

        } else {
          _showEndOfDayCta();
        }
      }
    };
    _isModalState = function(state) {
      return state.$$state().includes[States.modal];
    };
    _normalizeUpgradeMessage = function(user, message) {
      var upgradeMessage;
      var upgradeLink = States.modalAccountUpgrade;
      upgradeMessage = message.replace("upgrade", "<a ui-sref='" + upgradeLink + "'>upgrade</a>");
      upgradeMessage = upgradeMessage.replace(Constants.email, "<a href='mailto:" + Constants.email + "'>" + Constants.email + "</a>");
      return upgradeMessage;
    };
    _notifyProjectConnectToSocket = (function(_this) {
      return function() {
        var _ref;
        var projectId = (_ref = ProjectF.project) != null ? _ref.id : void 0;
        if (!!projectId) {
          return ProjectSessionF.connectTo(projectId);
        }
      };
    })(this);
    _initializeEventListeners = (function(_this) {
      return function() {
        var _checkAndUpdateProjectVersion, _offlineEventTriggered;
        _offlineEventTriggered = function() {
          _this.messageTemplate = MessageTemplateF.templates.offline;
          return LoggerF.info(LoggerF.ACTIONS.TRIGGERED_OFFLINE);
        };
        _checkAndUpdateProjectVersion = function() {
          LoggerF.info(LoggerF.ACTIONS.TRIGGERED_ONLINE);
          return ProjectF.checkProjectVersion().then(function(res) {
            if (!res.isCurrentVersion) {
              _this.messageTemplate = MessageTemplateF.templates.projectOutOfDate;
              return $timeout((function() {
                ProjectF.isBusy = false;
                return ProjectF.reloadProject();
              }), 3000);
            }
          })["catch"](function(err) {
            var logPayload = {
              project_id: ProjectF.project.id
            };
            LoggerF.error(LoggerF.ACTIONS.TRIGGERED_ONLINE, logPayload, err);
            return $q.reject(err);
          })["finally"](function() {
            return _this.messageTemplate = null;
          });
        };
        $window.addEventListener("offline", _offlineEventTriggered, false);
        $window.addEventListener("online", _checkAndUpdateProjectVersion, false);
        EventListenersF.addEventListener(Events.SOCKET_DISCONNECTED, function() {
          LoggerF.info(LoggerF.ACTIONS.DISCONNECTED_SOCKET);
          if (_this.hasRoute() && _this.hasBeenDispatched() && (_this.messageTemplate == null)) {
            return _this.messageTemplate = MessageTemplateF.templates.socket;
          }
        });
        EventListenersF.addEventListener(Events.SOCKET_CONNECTED, function() {
          LoggerF.info(LoggerF.ACTIONS.CONNECTED_SOCKET);
          if (_this.messageTemplate === MessageTemplateF.templates.socket) {
            return _this.messageTemplate = null;
          }
        });
        EventListenersF.addEventListener(Events.VALID_VISITS_UPDATED, function() {
          return _this.visits = VisitF.getValidVisits();
        });
        EventListenersF.addEventListener(Events.VALID_DRIVERS_UPDATED, function() {
          return _this.drivers = DriverF.getValidDrivers();
        });
        EventListenersF.addEventListener(Events.NEW_MESSAGE, function() {
          return _this.updateMessages();
        });
        EventListenersF.addEventListener(Events.PROJECT_BUSY, function() {
          return _this.isProjectBusy = true;
        });
        EventListenersF.addEventListener(Events.PROJECT_NOT_BUSY, function() {
          return _this.isProjectBusy = false;
        });
        EventListenersF.addEventListener(Events.LASSO_UPDATED, function(hasLassoDrawn) {
          return _this.hasLassoDrawn = hasLassoDrawn;
        });
        EventListenersF.addEventListener(Events.PROJECT_RELOADED, function() {
          var _ref;
          return ProjectJobF.checkPendingJob((_ref = ProjectF.project) != null ? _ref.jobId : void 0).then(function(isPending) {
            var _ref;
            if (isPending) {
              return RouteS.resumeOptimizeRoute((_ref = ProjectF.project) != null ? _ref.jobId : void 0);
            }
          });
        });
        EventListenersF.addEventListener(Events.PROJECT_LOADED, function() {
          var _ref;
          _this.messageTemplate = null;
          _notifyProjectConnectToSocket();
          return ProjectJobF.checkPendingJob((_ref = ProjectF.project) != null ? _ref.jobId : void 0).then(function(isPending) {
            var _ref;
            if (isPending) {
              return RouteS.resumeOptimizeRoute((_ref = ProjectF.project) != null ? _ref.jobId : void 0);
            }
          });
        });
        EventListenersF.addEventListener(Events.PROJECT_LOAD_ERROR, function() {
          return _this.messageTemplate = MessageTemplateF.templates.hiccup;
        });
        EventListenersF.addEventListener(Events.PROJECT_RELOAD_ERROR, function() {
          return _this.messageTemplate = MessageTemplateF.templates.hiccup;
        });
        EventListenersF.addEventListener(Events.SOCKET_CONNECTED, function() {
          _notifyProjectConnectToSocket();
          return _checkAndUpdateProjectVersion();
        });
        EventListenersF.addEventListener(Events.OPTIMIZATION_IN_PROGRESS, function(numVisits) {
          _this.messageStart = Date.now();
          _this.messageTemplate = MessageTemplateF.templates.optimizationInProgress;
          return ProgressBarF.start(numVisits);
        });
        EventListenersF.addEventListener(Events.OPTIMIZATION_COMPLETED, function() {
          var messageWait = THREE_SECONDS_IN_MS - (Date.now() - _this.messageStart);
          return $timeout(function() {
            var _ref;
            if ((_ref = _this.messageTemplate) != null) {
              _ref.close();
            }
            _this.messageTemplate = null;
            return ProgressBarF.done();
          }, messageWait);
        });
        EventListenersF.addEventListener(Events.OPTIMIZATION_ERRORED, function(err) {
          var email, message, vals, _ref, _ref1, _ref2, _ref3;
          if (err) {
            if (!!err.cancel) {
              console.log('Optimize poll cancelled');
              return;
            }
            if (err.data != null) {
              switch (err.data.error_type) {
                case 'ERR_INVALID_VERSION':
                  return;
                case 'ERR_PROJECT_JOB_IN_PROGRESS':
                  EventListenersF.notify(Events.PROJECT_VERSION_MISMATCH);
                  return;
                case 'ERR_REACHED_VEHICLE_LIMIT_FT':
                case 'ERR_REACHED_STOP_LIMIT_FT':
                  MessagingF.replaceError("MESSAGES.TRIAL_LIMIT_ERROR", {
                    maxVehicles: (_ref = _this.user) != null ? _ref.maxVehicles : void 0,
                    maxVisits: (_ref1 = _this.user) != null ? _ref1.maxVisits : void 0
                  });
                  return;
                case 'ERR_VEHICLE_VISIT_OUT_OF_LIMIT':
                  MessagingF.replaceError("MESSAGES.VEHICLE_VISIT_OUT_OF_LIMIT_ERROR", {
                    maxVisits: ((_ref2 = err.data.error_vars) != null ? _ref2.maxTspVisits : void 0) || 500
                  });
                  return;
                case 'ERR_VISIT_OUT_OF_LIMIT':
                  MessagingF.replaceError("MESSAGES.VISIT_OUT_OF_LIMIT_ERROR", {
                    maxVisits: ((_ref3 = err.data.error_vars) != null ? _ref3.maxVisits : void 0) || 2500
                  });
                  return;
              }
            }
            message = null;
            vals = null;
            switch (err.status) {
              case 500:
                message = "MESSAGES.ERROR_500";
                vals = {
                  email: Messages.ERROR_500_EMAIL
                };
                break;
              case 429:
                message = err.data.error;
                message = _normalizeUpgradeMessage(_this.user, message);
                break;
              case JSON_LIMIT_REACHED:
                message = err.data.error;
                email = Constants.email;
                message = message.replace(email, "<a href='mailto:" + email + "'>" + email + "</a>");
                break;
              default:
                LoggerF.error(LoggerF.ACTIONS.OPTIMIZE_PROJECT, void 0, err);
                message = "MESSAGES.ERROR_500";
                vals = {
                  email: Messages.ERROR_500_EMAIL
                };
            }
            if (message) {
              return MessagingF.replaceError(message, vals);
            }
          }
        });
        EventListenersF.addEventListener(Events.PROJECT_DISPATCH_STARTED, function() {
          _this.messageTemplate = MessageTemplateF.templates.dispatchInProgress;
          return AnalyticsS.track('Project dispatch started');
        });
        EventListenersF.addEventListener(Events.PROJECT_DISPATCH_ENDED, function(debugInfo) {
          _this.messageTemplate = null;
          return AnalyticsS.track('Project dispatch ended', debugInfo);
        });
        EventListenersF.addEventListener(Events.DEMO_FINISHED, function() {
          EventListenersF.notify(Events.DEMO_MAP_CHANGED, true);
          _this.isInDemo = false;
          return DemoF.setDemoStatus(false);
        });
        EventListenersF.addEventListener(Events.STOPS_ADD_START, function(msg) {
          return _this.messageTemplate = MessageTemplateF.templates.lock;
        });
        EventListenersF.addEventListener(Events.STOPS_ADD_ERROR, function(msg) {
          return _this.messageTemplate = null;
        });
        EventListenersF.addEventListener(Events.PROJECT_UPDATING_STARTED, function(msg) {
          return _this.messageTemplate = MessageTemplateF.templates.lock;
        });
        EventListenersF.addEventListener(Events.PROJECT_UPDATING_ENDED, function(msg) {
          if (_this.messageTemplate === MessageTemplateF.templates.optimizationInProgress) {
            return;
          }
          return _this.messageTemplate = null;
        });
        return EventListenersF.addEventListener(Events.VISIT_STATUS_UPDATED, function(data) {
          var newVisitId = data.new_stop_id;
          if (!!newVisitId && !VisitF.getVisit(newVisitId)) {
            return ProjectF.fetchProjectVisit(newVisitId).then(function(visit) {
              return VisitF.addVisit(visit);
            }).then(function() {
              VisitF.updateValidVisits();
              return _this.visits = VisitF.getValidVisits();
            });
          }
        });
      };
    })(this);
    _setupRedirects = (function(_this) {
      return function() {
        var query, redirectTo;
        if (_this.isInDemo === true) {
          if (AccountF.shouldShowQuestionnaire()) {
            $state.go(States.project).then(function() {
              return $state.go(States.modalQuestionnaire);
            });
          } else {
            $state.go(States.project);
          }
        } else if (redirectTo = RedirectF.fetchRedirectState($state.current, true)) {
          $state.go(redirectTo);
        }
        query = $location.search();
        if (query != null ? query[Constants.UPDATE_EMAIL_QS] : void 0) {
          if (_this.messageTemplate === null) {
            _this.messageTemplate = MessageTemplateF.templates.updatedEmail;
          }
        }
        return $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState) {
          var redirectState;
          if (AccountF.shouldShowQuestionnaire() && fromState.name === States.modalQuestionnaire) {
            return event.preventDefault();
          } else {
            redirectState = RedirectF.fetchRedirectState(toState);
            if (redirectState != null) {
              event.preventDefault();
              $state.go(redirectState);
            }
            if (!(_isModalState(fromState) || _isModalState(toState))) {
              MessagingF.clear(MessagingF.Type.LOADING);
              return _resetInputState();
            }
          }
        });
      };
    })(this);
    this.clearLasso = function() {
      this.hasLassoDrawn = false;
      EventListenersF.notify(Events.CLEAR_LASSO_SELECTION, true);
      return EventListenersF.notify(Events.EXPAND_GANTT_CHART);
    };
    this.getUnreadMessages = function() {
      return AccountF.getUnreadMessages();
    };
    this.user = AccountF.getUser();
    this.hasNotification = function() {
      return AccountF.hasCustomerNotification();
    };
    this.visits = VisitF.getValidVisits();
    this.drivers = DriverF.getValidDrivers();
    this.messages = [];
    this.getNumVisits = function() {
      return this.visits.length;
    };
    this.updateMessages = function() {
      return this.messages = MessagingF.getMessages();
    };
    this.getNumSelectedDrivers = function() {
      return DriverF.getNumSelected();
    };
    this.getPolylines = function() {
      return RouteS.getPolylines();
    };
    this.hasRoute = RouteS.hasRoute;
    this.hasBeenDispatched = DispatchStatusF.hasDispatches;
    this.getWarnings = RouteInspectorF.getWarnings;
    this.messageTemplate = null;
    if (!isProjectLoaded || ProjectF.hasError()) {
      if (((_ref = ProjectF.project) != null ? (_ref1 = _ref.error) != null ? _ref1.error_type : void 0 : void 0) === ERROR_PROJECT_UPDATING) {
        this.messageTemplate = MessageTemplateF.templates.lock;
      } else if (AccountF.shouldShowQuestionnaire()) {
        this.messageTemplate = null;
      } else {
        this.messageTemplate = MessageTemplateF.templates.hiccup;
      }
    } else {
      ProjectJobF.checkPendingJob((_ref2 = ProjectF.project) != null ? _ref2.jobId : void 0).then(function(isPending) {
        var _ref2;
        if (isPending) {
          return RouteS.resumeOptimizeRoute((_ref2 = ProjectF.project) != null ? _ref2.jobId : void 0);
        }
      });
    }
    if (isProjectLoaded) {
      _notifyProjectConnectToSocket();
    }
    this.editRouteViewIsActive = function() {
      return $state.current.name === States.projectRouteEdit;
    };
    this.driversTabIsActive = function() {
      var _ref3;
      var driverStates = [States.projectDriversList, States.projectDriversCreate, States.projectDriversUpload, States.projectDriversEdit, States.projectDriversQuickadd];
      return _ref3 = $state.current.name, __indexOf.call(driverStates, _ref3) >= 0;
    };
    this.onboardingStateActive = function() {
      var _ref3;
      var onboardingStates = [States.projectDriversList, States.projectVisitsList, States.projectVisitsUpload, States.projectDriversUpload];
      return _ref3 = $state.current.name, __indexOf.call(onboardingStates, _ref3) >= 0;
    };
    this.visitsTabIsActive = function() {
      var _ref3;
      var visitStates = [States.projectVisitsList, States.projectVisitsCreate, States.projectVisitsUpload, States.projectVisitsEdit, States.projectVisitsQuickadd];
      return _ref3 = $state.current.name, __indexOf.call(visitStates, _ref3) >= 0;
    };
    this.customersViewIsActive = function() {
      return $state.includes('hud.nav.customers') || $state.current.name === States.modalCsvMapCustomers;
    };
    this.notificationsViewIsActive = function() {
      return $state.includes('hud.nav.notifications');
    };
    this.openCustomerNotification = function() {
      if (!this.hasNotification()) {
        AnalyticsS.track('Clicked on Customer Notifications and saw upgrade page');
        if (typeof chmln !== "undefined" && chmln !== null) {
          chmln.show(Constants.CN_TRIAL_OVER_MODAL, {
            use_segmentation: false,
            once: false,
            deepLinked: true,
            redirect: false
          });
        }
        return;
      }
      AnalyticsS.track('Clicked on Customer Notifications in the sidebar');
      return $state.go(States.notificationsChildren, {
        path: void 0
      });
    };
    this.openShopifyApp = function() {
      AnalyticsS.track('111 Go to shopify app');
      return window.location = "https://route-planning-app.routific.com?shop=" + this.getShopifyDomain;
    };
    this.projectsViewIsActive = function() {
      return $state.current.name === States.projects;
    };
    this.internalProjectsViewIsActive = function() {
      return $state.current.name === States.internalProjects;
    };
    this.showLiveTrackingCountdown = function() {
      return AccountF.hasLiveTracking() && this.editRouteViewIsActive() && ProjectF.isInFuture() && this.hasBeenDispatched();
    };
    this.showGPSTrackingUI = function() {
      return AccountF.hasGPSTracking() && this.hasRoute() && this.hasBeenDispatched();
    };
    this.hasGPSTracking = AccountF.hasGPSTracking();
    this.liveTrackingOngoing = ProjectF.isInLiveTracking;
    this.deleteProject = function() {
      var _ref3;
      if (!(((_ref3 = ProjectF.project) != null ? _ref3.id : void 0) && !this.isProjectBusy)) {
        return;
      }
      return ConfirmF.confirm("MESSAGES.DELETE_PROJECT").then(function() {
        return $state.go(States.projectVisitsList);
      }).then(function() {
        return ProjectF["delete"](ProjectF.project.id);
      }).then(function() {
        var tempInfo;
        AnalyticsS.track('014 Delete current project');
        ProjectF.clear(true);
        DispatchF.deleteAll();
        tempInfo = ProjectF.getProjectTempInfo();
        return ProjectF.create(tempInfo.name, tempInfo.date);
      }).then(function() {
        return ProjectF.load(ProjectF.project.id);
      })["catch"]((function(_this) {
        return function(err) {
          return _this.error = err.message;
        };
      })(this));
    };
    this.onboarding = OnboardingF;
    this.routeInfo = RouteMarkerInfoF.markersInfo;
    this.project = ProjectF.project;
    this.isProjectBusy = false;
    this.states = States;
    this.minMarkerClusterCount = Constants.minMarkerClusterCount;
    this.numParallelSessions = 0;
    $scope.$watch(function() {
      return ProjectF.numParallelSessions;
    }, (function(_this) {
      return function(newVal) {
        return _this.numParallelSessions = newVal;
      };
    })(this));
    this.logout = function() {
      return EventListenersF.notify(Events.USER_LOGGING_OUT).then(function() {
        AnalyticsS.track_force('008 Logout');
        Gtm.trackLogout();
        SocketF.disconnect();
        return AccountF.goToLogout();
      });
    };
    this.transitionTo = function(route) {
      if (this.isProjectBusy) {
        return;
      }
      return $state.go(route);
    };
    _resetInputState($state.current.name);
    _initializeEventListeners();
    _setupRedirects();
    _showLandingMessage();
    _showOptIn();
    GPSRoutesF.init();
    this.isMarkersVisible = true;
    this.toggleMarkers = function() {
      var visibility = !this.isMarkersVisible;
      RouteS.setAllMarkersVisible(visibility);
      MarkerClustererF.repaintAll();
      return this.isMarkersVisible = !this.isMarkersVisible;
    };
    this.logoClicked = function() {
      if (this.hasRoute()) {
        return $state.go(States.projectRoutePlan);
      } else {
        return $state.go(States.projectDriversList);
      }
    };
    this.stopsTabClicked = function() {
      AnalyticsS.track('016 Dropdown stop list');
      if (this.visitsTabIsActive() && this.hasRoute()) {
        return $state.go(States.projectRoutePlan);
      } else {
        return $state.go(States.projectVisitsList);
      }
    };
    this.driversTabClicked = function() {
      AnalyticsS.track('015 Dropdown driver list');
      if (this.driversTabIsActive() && this.hasRoute()) {
        return $state.go(States.projectRoutePlan);
      } else {
        return $state.go(States.projectDriversList);
      }
    };
    this.trackHover = function(msg) {
      return AnalyticsS.track(msg);
    };
  };
  HudC.$inject = ["$q", "$state", "$scope", "$rootScope", "$timeout", "$kookies", "$cacheFactory", "$window", "$location", "isProjectLoaded", "isInDemo", "VisitF", "DriverF", "RouteS", "Constants", "MessagingF", "RouteInspectorF", "GMarkerF", "RouteMarkerInfoF", "TimeUtilF", "OnboardingF", "ConfirmF", "ProjectF", "DemoF", "Messages", "EventListenersF", "Events", "States", "DispatchStatusF", "NotificationF", "DispatchF", "MarkerClustererF", "RedirectF", "AnalyticsS", "MessageTemplateF", "ProgressBarF", "ProjectSessionF", "SocketF", "AccountF", "LoggerF", "GPSRoutesF", "ProjectJobF", "Gtm", "FeatureFlagF"];

  angular.module('app').controller('HudC', HudC);

}).call(this);

(function() {
  var HudF = function() {
    HudF = {};
    HudF.scale = 0.9;
    HudF.getScale = function() {
      return this.scale;
    };
    return HudF;
  };

  angular.module('app').factory('HudF', HudF);

}).call(this);

(function() {
  var InputC = function($scope, $q, $state, ScrollToS, AccountF, VisitF, DriverF, RouteS, MessagingF, VisitMarker, UploadF, VisitUploadF, ConfirmF, Constants, OnboardingF, ProjectF, EventListenersF, Events, $kookies, States, VisitGridApiF, AnalyticsS, AbTestF) {
    var _confirmRemoveRoute, _getInvalidReason, _user;
    _user = AccountF.getUser();
    _confirmRemoveRoute = function() {
      if (RouteS.hasRoute()) {
        return ConfirmF.confirm("MESSAGES.CONFIRM_REMOVE_ROUTE").then(function() {
          RouteS.clear();
          return true;
        });
      } else {
        return $q.when(true);
      }
    };
    this.goToPlanRoute = function() {
      if (this.invalidReason) {
        return;
      }
      OnboardingF.finishOnboardingTour(OnboardingF.tourStages.INPUT_STAGE.NAME);
      return $state.go(States.projectRoutePlan);
    };
    _getInvalidReason = function() {
      if (DriverF.getDrivers().length === 0) {
        return "INVALID_MESSAGE.NO_DRIVER";
      } else if (DriverF.getInvalidDrivers().length > 0) {
        return "INVALID_MESSAGE.INVALID_DRIVER";
      } else if (DriverF.getNumSelected() === 0) {
        return "INVALID_MESSAGE.SELECT_DRIVER";
      } else if (VisitF.getVisits().length === 0) {
        return "INVALID_MESSAGE.NO_STOP";
      } else if (VisitF.getInvalidVisits().length > 0) {
        return "INVALID_MESSAGE.INVALID_STOP";
      } else {
        return "";
      }
    };
    this.invalidReason = _getInvalidReason();
    this.showAddStopButton = function() {
      return DriverF.getNumSelected() > 0 && (VisitF.getValidVisits().length === 0 || VisitF.getInvalidVisits().length > 0) && $state.includes(States.projectDriversList);
    };
    this.optimizeRoute = function() {
      if (this.invalidReason) {
        return;
      }
      if (RouteS.isInProgress()) {
        MessagingF.replaceInfoPopup("MESSAGES.ROUTING_IN_PROGRESS");
        return;
      }
      return _confirmRemoveRoute().then(function() {
        var date;
        OnboardingF.finishOnboardingTour(OnboardingF.tourStages.INPUT_STAGE.NAME);
        date = ProjectF.project.date;
        return RouteS.reoptimize(date);
      }).then(function() {
        var msg, _unserved;
        AnalyticsS.track('029 first optimize route', {
          num_unserved: RouteS.getNumUnserved(),
          settings: RouteS.getSettings()
        });
        $state.go(States.projectRoutePlan);
        _unserved = RouteS.getRoute().num_unserved;
        if (_unserved > 0) {
          msg = _unserved === 1 ? "MESSAGES.INFO_UNSERVED_ONE" : "MESSAGES.INFO_UNSERVED_MANY";
          MessagingF.replaceInfo(msg, {
            x: _unserved
          });
          return AnalyticsS.track('074 Unscheduled stops');
        } else {
          return MessagingF.clear();
        }
      });
    };
    this.getNumInvalidVisits = function() {
      return VisitF.getInvalidVisits().length;
    };
    this.getNumInvalidDrivers = function() {
      return DriverF.getInvalidDrivers().length;
    };
    this.filterInvalidVisits = function() {
      var redirectToVisitList = null;
      if ($state.is(States.projectVisitsList)) {
        redirectToVisitList = $q.when(true);
      } else {
        redirectToVisitList = $state.go(States.projectVisitsList);
      }
      return redirectToVisitList.then(function() {
        return VisitGridApiF.setFilter("invalid");
      });
    };
    this.scrollToInvalidDriver = function() {
      var driver, invalidDrivers;
      if (this.invalidDriverIndex == null) {
        this.invalidDriverIndex = -1;
      }
      invalidDrivers = DriverF.getInvalidDrivers();
      this.invalidDriverIndex = (this.invalidDriverIndex + 1) % invalidDrivers.length;
      driver = invalidDrivers[this.invalidDriverIndex];
      return ScrollToS.scrollToDriver(driver.id);
    };
    if (!OnboardingF.isDone() && !OnboardingF.wasStarted() && !ConfirmF.isDialogOpen() && !AccountF.shouldShowQuestionnaire()) {
      ConfirmF.onboardingStart(AbTestF.activateChameleonTour).then(function() {
        AnalyticsS.track_force('002 Onboarding started');
        $state.go(States.projectDriversList);
        return OnboardingF.startOnboarding();
      })["catch"](function() {
        AnalyticsS.track_force('003 Skip onboarding');
        return OnboardingF.skipTour();
      });
    }
    this.hasRoute = RouteS.hasRoute;
    EventListenersF.addEventListener(Events.SETTINGS_CHANGED, function() {
      return VisitF.revalidateAll();
    });
    EventListenersF.addEventListener(Events.PROJECT_MODIFIED, (function(_this) {
      return function() {
        return _this.invalidReason = _getInvalidReason();
      };
    })(this));
    EventListenersF.addEventListener(Events.PROJECT_LOADED, (function(_this) {
      return function() {
        return _this.invalidReason = _getInvalidReason();
      };
    })(this));
    EventListenersF.addEventListener(Events.PROJECT_RELOADED, (function(_this) {
      return function() {
        return _this.invalidReason = _getInvalidReason();
      };
    })(this));
    EventListenersF.addEventListener(Events.PROJECT_MODIFIED_LOCALLY, (function(_this) {
      return function() {
        return _this.invalidReason = _getInvalidReason();
      };
    })(this));
    EventListenersF.addEventListener(Events.CSV_UPLOAD_IN_PROGRESS, (function(_this) {
      return function() {
        return _this.invalidReason = "INVALID_MESSAGE.IN_PROGRESS";
      };
    })(this));
    $scope.forms = {};
  };
  InputC.$inject = ["$scope", "$q", "$state", "ScrollToS", "AccountF", "VisitF", "DriverF", "RouteS", "MessagingF", "VisitMarker", "UploadF", "VisitUploadF", "ConfirmF", "Constants", "OnboardingF", "ProjectF", "EventListenersF", "Events", "$kookies", "States", "VisitGridApiF", "AnalyticsS", "AbTestF"];

  angular.module('app').controller('InputC', InputC);

}).call(this);

(function() {
  var ProjectC = function($scope, $timeout, $state, mapCenter, States, Constants, AccountF, SignatureF, NotificationF, ProjectF, RedirectF, OnboardingF, AnalyticsS, MessagingF, GeoIpF, EventListenersF, Events, DriverF, MapStyleC, RouteS, ConfettiS) {
    var MAP_CONTROL_POSITION, _initializeEventListers, _mapOffsetModifications, _ref, _ref1, _showLiveTrackingTooltip, _showRouteProgressInfo, _updateNotificationsInfo;
    MAP_CONTROL_POSITION = google.maps.ControlPosition.TOP_LEFT;
    this.user = AccountF.getUser();
    this.isTrial = ((_ref = this.user) != null ? _ref.status : void 0) === 'trial';
    _updateNotificationsInfo = (function(_this) {
      return function(hasNotifications, notifications) {
        _this.hasNotifications = hasNotifications;
        return _this.allNotifications = notifications;
      };
    })(this);
    _initializeEventListers = (function(_this) {
      return function() {
        EventListenersF.addEventListener(Events.PROJECT_SWITCHED, function() {
          _this.hasPassed = ProjectF.isPastProject();
          _this.pastProjectWarning = false;
          _this.showNotifications = false;
          return NotificationF.updateNotificationsInfo(_updateNotificationsInfo, ProjectF.project.id);
        });
        EventListenersF.addEventListener(Events.VERIFIED_VISIT_STATUS_UPDATE, function(update) {
          var driverName, isRouteFinished, status, stopName, _ref1, _ref2, _ref3, _ref4, _ref5;
          status = update != null ? (_ref1 = update.data) != null ? (_ref2 = _ref1.detail) != null ? _ref2.status : void 0 : void 0 : void 0;
          driverName = update != null ? update.driverName : void 0;
          stopName = update != null ? (_ref3 = update.data) != null ? (_ref4 = _ref3.detail) != null ? (_ref5 = _ref4.location) != null ? _ref5.name : void 0 : void 0 : void 0 : void 0;
          if (!((status != null) && (driverName != null) && (stopName != null))) {
            return;
          }
          isRouteFinished = update != null ? update.isRouteFinished : void 0;
          if (isRouteFinished) {
            MessagingF.replaceSuccessPopup("MESSAGES.ROUTE_COMPLETED_NOTIFICATION", {
              driverName: driverName
            });
            return ConfettiS.delight();
          } else if (status === Constants.visitStatusDone) {
            return MessagingF.replaceSuccessPopup("MESSAGES.STOP_COMPLETED_NOTIFICATION", {
              driverName: driverName,
              stopName: stopName
            });
          } else if (Constants.visitStatusSkipped) {
            return MessagingF.replaceErrorPopup("MESSAGES.STOP_MISSED_NOTIFICATION", {
              driverName: driverName,
              stopName: stopName
            });
          }
        });
        EventListenersF.addEventListener(Events.SIDE_PANEL_OPENED_FROM_NOTIFICATION, function() {
          return _this.showNotifications = false;
        });
        EventListenersF.addEventListener(Events.NOTIFICATION_CLEARED, function() {
          _this.showNotifications = false;
          _this.hasNotifications = false;
          return _this.allNotifications = void 0;
        });
        EventListenersF.addEventListener(Events.SMS_FAILED, function(data) {
          NotificationF.addSmsErrorNotification(data);
          return NotificationF.updateNotificationsInfo(_updateNotificationsInfo, data.project_id);
        });
        return EventListenersF.addEventListener(Events.NEW_NOTIFICATION_ADDED, function(notifications) {
          _this.hasNotifications = true;
          return _this.allNotifications = notifications;
        });
      };
    })(this);
    _showRouteProgressInfo = function() {
      MessagingF.replaceInfoPopup("MESSAGES.ROUTING_IN_PROGRESS");
    };
    _mapOffsetModifications = function() {
      var targetState = RedirectF.fetchRedirectState($state.current);
      targetState = $state.get(targetState || $state.current.name).$$state();
      if (targetState.includes[States.projectRoute]) {
        mapCenter.offset.y = 100;
        return mapCenter['zoomOffset'] = 1;
      } else if (targetState.includes[States.projectInput]) {
        mapCenter.offset.x = Constants.defaultXMapOffset;
        return mapCenter['zoomOffset'] = 2;
      }
    };
    if (mapCenter == null) {
      mapCenter = {};
    }
    _mapOffsetModifications();
    this.config = {
      center: mapCenter.center,
      zoom: mapCenter.zoom,
      bounds: mapCenter.bounds,
      offset: mapCenter.offset,
      zoomOffset: mapCenter.zoomOffset,
      draggable: true,
      mapTypeControl: false,
      panControl: true,
      zoomControl: true,
      scaleControl: false,
      streetViewControl: false,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: MAP_CONTROL_POSITION
      },
      panControlOptions: {
        position: MAP_CONTROL_POSITION
      },
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.LARGE,
        position: MAP_CONTROL_POSITION
      },
      clickableIcons: false,
      styles: MapStyleC
    };
    this.hasPassed = ProjectF.isPastProject();
    this.hasLiveTracking = AccountF.hasLiveTracking;
    this.showLiveTrackTooltip = false;
    _showLiveTrackingTooltip = (function(_this) {
      return function() {
        _this.showLiveTrackTooltip = true;
        return $timeout(function() {
          return _this.showLiveTrackTooltip = false;
        }, 3000);
      };
    })(this);
    this.hideLiveTrackOptIn = function() {
      AnalyticsS.track('062 Not trying live tracking');
      this.showLiveTrackOptIn = false;
      return _showLiveTrackingTooltip();
    };
    this.optOutLiveTracking = function() {
      var updatedSettings;
      AnalyticsS.track("063 Don't show");
      updatedSettings = {
        liveTracking: {
          optedIn: false,
          optedOut: true
        }
      };
      this.showLiveTrackOptIn = false;
      _showLiveTrackingTooltip();
      return AccountF.updateSettings(updatedSettings);
    };
    this.optInLiveTracking = function(hud) {
      AccountF.optInLiveTracking().then((function(_this) {
        return function() {
          AnalyticsS.track('061 Try live tracking');
          OnboardingF.setOnboarding(true);
          if (ProjectF.isOngoing()) {
            return $state.go(States.projectRouteLive);
          } else {
            return $state.go(States.projectRouteEdit);
          }
        };
      })(this));
      return this.showLiveTrackOptIn = false;
    };
    this.isInRouteState = function() {
      return $state.includes(States.projectRoute);
    };
    this.showNotifications = false;
    this.hasNotifications = false;
    this.allNotifications = [];
    NotificationF.updateNotificationsInfo(_updateNotificationsInfo, (_ref1 = ProjectF.project) != null ? _ref1.id : void 0);
    this.toggleNotifications = function() {
      NotificationF.setHasNewNotifications(false);
      if (this.showNotifications) {
        NotificationF.markAllAsSeen();
      } else {
        AnalyticsS.track('020 Open notification');
      }
      return this.showNotifications = !this.showNotifications;
    };
    this.hasNewNotifications = function() {
      return NotificationF.getHasNewNotifications();
    };
    this.newNotificationCount = function() {
      return NotificationF.newNotificationCount();
    };
    this.downloadSignature = function(signatureId, routeId) {
      var signatureImage, w;
      w = window.open();
      signatureImage = new Image();
      return SignatureF.getSignature(signatureId, routeId).then(function(result) {
        signatureImage.src = "data:image/png;base64," + result.data;
        return w.document.write(signatureImage.outerHTML);
      })["catch"](function(e) {
        if (e.error) {
          return MessagingF.replaceError(e.error);
        }
      });
    };
    this.viewPhoto = function(photoUrl) {
      window.open(photoUrl, '_blank');
    };
    this.goToSettings = function() {
      var _goToNewProject, _goToRouteEdit;
      if (ProjectF.isPastProject()) {
        _goToNewProject = function() {
          return $state.go(States.modalProjectsNew);
        };
        return MessagingF.replaceInfo("MESSAGES.CANNOT_MODIFY_PAST_PROJECT", null, null, "MESSAGES.START_NEW_PROJECT", _goToNewProject);
      } else if ($state.is(States.projectRouteLive)) {
        _goToRouteEdit = function() {
          return $state.go(States.projectRouteEdit);
        };
        return MessagingF.replaceInfo("MESSAGES.SWITCH_TO_EDIT_MODE", null, null, "MESSAGES.GO_TO_PLAN_MODE", _goToRouteEdit);
      } else {
        return $state.go(States.modalSettings);
      }
    };
    this.goToNewStop = function() {
      var _goToNewProject;
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      if (ProjectF.isPastProject()) {
        _goToNewProject = function() {
          return $state.go(States.modalProjectsNew);
        };
        MessagingF.replaceInfo("MESSAGES.CANNOT_MODIFY_PAST_PROJECT", null, null, "MESSAGES.START_NEW_PROJECT", _goToNewProject);
        return;
      }
      if ($state.current.name === States.projectRouteLive) {
        return $state.go(States.projectRouteEdit).then(function() {
          return EventListenersF.notify(Events.SIDE_PANEL_OPENED);
        });
      } else {
        return EventListenersF.notify(Events.SIDE_PANEL_OPENED);
      }
    };
    this.closePastProjectModal = function() {
      return this.pastProjectWarning = true;
    };
    this.goToAddFromCustomerProfile = function() {
      var _goToNewProject;
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      if (ProjectF.isPastProject()) {
        _goToNewProject = function() {
          return $state.go(States.modalProjectsNew);
        };
        MessagingF.replaceInfo("MESSAGES.CANNOT_MODIFY_PAST_PROJECT", null, null, "MESSAGES.START_NEW_PROJECT", _goToNewProject);
        return;
      }
      if ($state.current.name === States.projectRouteLive) {
        return $state.go(States.projectRouteEdit).then(function() {
          return $state.go(States.modalCustomerProfile);
        });
      } else {
        return $state.go(States.modalCustomerProfile);
      }
    };
    if (OnboardingF.wasStarted() && !OnboardingF.isDone()) {
      OnboardingF.startOnboarding();
    }
    _initializeEventListers();
    GeoIpF.initialize();
  };
  ProjectC.$inject = ["$scope", "$timeout", "$state", "mapCenter", "States", "Constants", "AccountF", "SignatureF", "NotificationF", "ProjectF", "RedirectF", "OnboardingF", "AnalyticsS", "MessagingF", "GeoIpF", "EventListenersF", "Events", "DriverF", "MapStyleC", "RouteS", "ConfettiS"];

  angular.module('app').controller('ProjectC', ProjectC);

}).call(this);

(function() {
  var ScrollToS = function($q, $state, $location, $anchorScroll, $window, States) {
    var DRIVERS_LIST_STATE, VISITS_LIST_STATE, _scrollTo;
    VISITS_LIST_STATE = States.projectVisitsList;
    DRIVERS_LIST_STATE = States.projectDriversList;
    _scrollTo = function(hash) {
      if ($location.hash() !== hash) {
        $location.hash(hash);
      }
      $anchorScroll();
    };
    ScrollToS = {};
    ScrollToS.scrollToVisit = function(id) {
      var promise;
      if (!($state.is(VISITS_LIST_STATE) || $state.is(DRIVERS_LIST_STATE))) {
        return;
      }
      promise = null;
      if (!$state.is(VISITS_LIST_STATE)) {
        promise = $state.go(VISITS_LIST_STATE);
      } else {
        promise = $q.when(true);
      }
      return promise.then(function() {
        return _scrollTo("visit-" + id);
      });
    };
    ScrollToS.scrollToDriver = function(id) {
      var promise;
      if (!($state.is(VISITS_LIST_STATE) || $state.is(DRIVERS_LIST_STATE))) {
        return;
      }
      promise = null;
      if (!$state.is(DRIVERS_LIST_STATE)) {
        promise = $state.go(DRIVERS_LIST_STATE);
      } else {
        promise = $q.when(true);
      }
      return promise.then(function() {
        return _scrollTo("driver-" + id);
      });
    };
    return ScrollToS;
  };
  ScrollToS.$inject = ["$q", "$state", "$location", "$anchorScroll", "$window", "States"];

  angular.module('app').service('ScrollToS', ScrollToS);

}).call(this);

(function() {
  var IProjectS = function($http, $q, AccountF, Constants, ProjectsUtil) {
    this.fetchProjects = function(params) {
      var data = AccountF.getAuthHeader();
      data.params = params;
      return $http.get("" + Constants.apiPath + "/internal/projects", data).then(function(res) {
        var projects = ProjectsUtil.formatProjects(res.data);
        return projects;
      })["catch"](function(err) {
        return $q.reject(err.data.error);
      });
    };
    this.copyProject = function(email, id, keepContactInfo) {
      var data = AccountF.getAuthHeader();
      data.params = {
        email: email,
        keepContactInfo: keepContactInfo
      };
      id = {
        id: id
      };
      return $http.post("" + Constants.apiPath + "/internal/project/load", id, data).then(function(res) {
        return res.data;
      })["catch"](function(err) {
        return $q.reject(err.data.error);
      });
    };
    return this;
  };
  IProjectS.$inject = ["$http", "$q", "AccountF", "Constants", "ProjectsUtil"];

  angular.module('app').service('IProjectS', IProjectS);

}).call(this);

(function() {
  var IProjectsTableC = function($state, IProjectS, States, RouteS, ProjectF, MessagingF, IProjectValidator) {
    this.saveOriginal = false;
    this.loadProjects = function(email, id) {
      var params;
      if (!(email || id)) {
        MessagingF.replaceInfoPopup("Please enter an email or a project id");
        return;
      }
      params = {};
      if (email) {
        params.email = email;
      }
      if (id) {
        params.id = id;
      }
      return IProjectS.fetchProjects(params).then((function(_this) {
        return function(projects) {
          if (!projects || projects.length <= 0) {
            MessagingF.replaceInfoPopup("No projects found");
          }
          _this.projects = projects;
          return _this.email = email;
        };
      })(this))["catch"](function(err) {
        return MessagingF.replaceInfoPopup(err);
      });
    };
    this.copyProject = function(project) {
      if (!project) {
        MessagingF.replaceInfoPopup("No project has been selected");
        return;
      }
      return IProjectS.copyProject(this.email, project._id, this.saveOriginal).then(function(data) {
        project = data;
        IProjectValidator.checkProjectCorruption(data);
        return ProjectF.load(project._id);
      }).then(function() {
        var _ref;
        if (RouteS.hasRoute()) {
          return $state.go(States.projectRoutePlan);
        } else if (((_ref = DriverF.getValidDrivers()) != null ? _ref.length : void 0) > 0) {
          return $state.go(States.projectVisitsList);
        } else {
          return $state.go(States.projectDriversList);
        }
      })["catch"]((function(_this) {
        return function(err) {
          return MessagingF.replaceInfoPopup(err);
        };
      })(this));
    };
    return this;
  };
  IProjectsTableC.$inject = ["$state", "IProjectS", "States", "RouteS", "ProjectF", "MessagingF", "IProjectValidator"];

  angular.module('app').controller('IProjectsTableC', IProjectsTableC);

}).call(this);

(function() {
  var MiniMapF = function(MapControllerF, MapStyleC) {
    var mapElement, mapInstance;
    MiniMapF = new MapControllerF();
    mapElement = document.createElement('div');
    mapInstance = new google.maps.Map(mapElement, {
      zoom: 1,
      draggable: true,
      mapTypeControl: false,
      panControl: true,
      zoomControl: true,
      scaleControl: false,
      streetViewControl: false,
      clickableIcons: false,
      styles: MapStyleC
    });
    MiniMapF.setMap(mapInstance, false);
    MiniMapF.getElement = function() {
      return mapElement;
    };
    MiniMapF.getInstance = function() {
      return mapInstance;
    };
    return MiniMapF;
  };
  MiniMapF.$inject = ["MapControllerF", "MapStyleC"];

  angular.module('app').factory('MiniMapF', MiniMapF);

}).call(this);

(function() {
  var GMarkerF = function($q, $rootScope, $state, $compile, $templateRequest, $injector, States, SettingsF, Constants, EventListenersF, Events, MessagingF, ConfirmF, AccountF, VisitF) {
    var CLOCK_ICON, DONE_ICON, DispatchF, LATE_ICON, NEW_VISIT_ICON, ProjectF, RouteS, SKIPPED_ICON, UNSCHEDULED_ICON, VisitUtilF, WARNING_ICON, compiledCache, infoWindowContent, _centerMap, _createTemplateScope, _currentMarker, _currentTemplateScope, _forceCloseInfoWindow, _gMarkers, _getCompiledTemplate, _getMapTranslation, _listeners, _openInfoWindow, _setInfoWindowContent;
    RouteS = null;
    VisitUtilF = null;
    ProjectF = null;
    DispatchF = null;
    WARNING_ICON = 'icon-warning';
    CLOCK_ICON = 'icon-clock';
    DONE_ICON = 'icon-checkmark';
    SKIPPED_ICON = 'icon-cross';
    LATE_ICON = 'icon-late';
    UNSCHEDULED_ICON = 'icon-unserved';
    NEW_VISIT_ICON = 'icon-visit-new';
    _gMarkers = {};
    _listeners = {};
    _currentMarker = null;
    _currentTemplateScope = null;
    compiledCache = {};
    infoWindowContent = null;
    _getCompiledTemplate = function(template) {
      return compiledCache[template] || (compiledCache[template] = $templateRequest(template));
    };
    _createTemplateScope = function(parameter) {
      var templateScope;
      RouteS || (RouteS = $injector.get("RouteS"));
      VisitUtilF || (VisitUtilF = $injector.get("VisitUtilF"));
      ProjectF || (ProjectF = $injector.get("ProjectF"));
      DispatchF || (DispatchF = $injector.get("DispatchF"));
      templateScope = $rootScope.$new();
      templateScope.isVisitDone = VisitUtilF.isSkippedDoneStatus;
      templateScope.isSkipped = VisitUtilF.isSkipped;
      templateScope.canEdit = function() {
        var hasPassed, isInLiveOrDebugView, _ref;
        isInLiveOrDebugView = (_ref = $state.current.name) === States.projectRouteLive || _ref === States.projectRouteDebug;
        hasPassed = ProjectF.isPastProject();
        return !isInLiveOrDebugView && !hasPassed;
      };
      templateScope.isLocked = function(type, id) {
        if (id == null) {
          return false;
        }
        if (type === 'driver') {
          return RouteS.isRouteLocked(id);
        } else {
          return RouteS.isVisitLocked(id);
        }
      };
      templateScope.getStatusIcon = function(status, isLate) {
        if (status === Constants.visitStatusDone) {
          if (isLate) {
            return LATE_ICON;
          } else {
            return DONE_ICON;
          }
        } else if (status === Constants.visitStatusSkipped) {
          return SKIPPED_ICON;
        }
      };
      templateScope.moveVisitToUnserved = function(visit, driverId) {
        var isNotificationEnabled, promise, _goToNewProject;
        if (ProjectF.isPastProject()) {
          _goToNewProject = function() {
            return $state.go(States.modalProjectsNew);
          };
          MessagingF.replaceInfo("MESSAGES.CANNOT_MODIFY_PAST_PROJECT", null, null, "MESSAGES.START_NEW_PROJECT", _goToNewProject);
        } else if ($state.current.name === States.projectRouteDebug) {
          MessagingF.replaceInfoPopup("MESSAGES.CANNOT_MODIFY_DEBUG_PROJECT");
          return;
        }
        isNotificationEnabled = AccountF.hasCustomerNotification() && AccountF.isCancelledNotificationOn();
        if (isNotificationEnabled && DispatchF.isNotifiedStop(visit.id)) {
          promise = ConfirmF.notificationUnscheduleConfirm();
        } else {
          promise = $q.when();
        }
        return promise.then(function() {
          return EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS);
        }).then(function() {
          return RouteS.moveStopToUnserved(visit);
        }).then(function() {
          return VisitF.updateVisit(visit);
        }).then(function() {
          return EventListenersF.notify(Events.PROJECT_MODIFIED);
        })["finally"](function() {
          return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
        });
      };
      templateScope.canMoveVisitToUnserved = function(visit) {
        return RouteS.hasRoute() && !RouteS.isUnservedVisit(visit) && !VisitUtilF.isSkippedDoneStatus(visit.visitStatus);
      };
      templateScope.getIcon = function(warning) {
        var text = warning.key.toLowerCase();
        if (text.indexOf('late') > -1 || text.indexOf('early') > -1) {
          return CLOCK_ICON;
        } else if (text.indexOf('new') > -1) {
          return NEW_VISIT_ICON;
        } else if (text.indexOf('unserved') > -1 || text.indexOf('unsupported') > -1) {
          return UNSCHEDULED_ICON;
        } else {
          return WARNING_ICON;
        }
      };
      templateScope.parameter = parameter;
      templateScope.parameter.defaultDuration = SettingsF.settings.duration;
      templateScope.parameter.defaultLoad = SettingsF.settings.load;
      return templateScope;
    };
    _setInfoWindowContent = function(marker, infoWindow) {
      var parameter;
      _currentMarker = marker;
      parameter = marker.parameter;
      infoWindow.setOptions({
        pixelOffset: marker.getInfoWindowOffset()
      });
      return _getCompiledTemplate(marker.templateUrl).then(function(template) {
        if ((infoWindowContent != null ? infoWindowContent.scope() : void 0) != null) {
          infoWindowContent.scope().$destroy();
        }
        _currentTemplateScope = _createTemplateScope(parameter);
        infoWindowContent = $compile(template)(_currentTemplateScope);
        return infoWindow.setContent(infoWindowContent[0]);
      });
    };
    _openInfoWindow = function(gMarker) {
      if (!gMarker) {
        return $q.reject();
      }
      if ($state.includes(States.projectRoute)) {
        return GMarkerF.setSidepanelContent(gMarker.marker).then(function(res) {
          if ((infoWindowContent != null ? infoWindowContent.scope() : void 0) != null) {
            infoWindowContent.scope().$destroy();
          }
          _currentMarker = res.marker;
          _currentTemplateScope = res.scope;
          gMarker.marker.setSelected(true);
          return gMarker.infoWindowOpen = true;
        });
      } else {
        if (!GMarkerF.infoWindow) {
          return $q.reject();
        }
        gMarker.marker.setSelected(true);
        gMarker.infoWindowOpen = true;
        return GMarkerF.refreshInfoWindowContent(gMarker.marker).then(function() {
          return setTimeout(function() {
            GMarkerF.infoWindow.open(gMarker.map, gMarker.marker);
            return true;
          }, 10);
        });
      }
    };
    _getMapTranslation = function() {
      if ($state.includes(States.projectRoute)) {
        return {
          x: 0,
          y: 0
        };
      } else {
        return {
          x: -450,
          y: -100
        };
      }
    };
    _centerMap = function(gMarker) {
      var centerPos, translation;
      translation = _getMapTranslation();
      if (gMarker.mapD) {
        centerPos = gMarker.marker.getPosition();
        return gMarker.mapD.center(centerPos.lat(), centerPos.lng(), translation.x, translation.y);
      }
    };
    _forceCloseInfoWindow = function(gMarker) {
      var _ref, _ref1;
      if (!gMarker) {
        return $q.reject();
      }
      if (((_ref = gMarker.marker) != null ? (_ref1 = _ref.parameter) != null ? _ref1.id : void 0 : void 0) === (_currentMarker != null ? _currentMarker.parameter.id : void 0)) {
        if ($state.includes(States.projectRoute)) {
          return GMarkerF.closeSidepanel(gMarker);
        }
      }
      if (GMarkerF.infoWindow) {
        GMarkerF.infoWindow.close();
        delete gMarker.infoWindowOpen;
        if (!gMarker.isShiftSelected) {
          gMarker.marker.setSelected(false);
        }
      }
      return $q.when();
    };
    GMarkerF = {};
    GMarkerF.infoWindow = new google.maps.InfoWindow({
      maxWidth: 230
    });
    GMarkerF.add = function(id, map, marker, mapD, markerType) {
      if (!id) {
        throw new Error("id must be defined");
      }
      if (!map) {
        throw new Error("map must be defined");
      }
      if (!marker) {
        throw new Error("marker must be defined");
      }
      google.maps.event.addListener(GMarkerF.infoWindow, "closeclick", function(event) {
        var _ref;
        if (!((_ref = _gMarkers[id]) != null ? _ref.isShiftSelected : void 0)) {
          marker.setSelected(false);
        }
        return GMarkerF.forceCloseInfoWindow(id);
      });
      _gMarkers[id] = {
        map: map,
        marker: marker,
        mapD: mapD,
        listeners: {},
        type: markerType
      };
      EventListenersF.notify(Events.MAP_MARKER_ADDED, _gMarkers[id]);
    };
    GMarkerF.destroy = function(id) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      EventListenersF.notify(Events.MAP_MARKER_DESTROYED, gMarker.marker);
      if (_currentMarker === gMarker.marker) {
        _currentMarker = null;
        _currentTemplateScope = null;
      }
      gMarker.marker.setMap(null);
      gMarker.marker = null;
      delete _gMarkers[id];
      return true;
    };
    GMarkerF.refreshInfoWindowContent = function(marker) {
      return _setInfoWindowContent(marker, GMarkerF.infoWindow);
    };
    GMarkerF.setSidepanelContent = function(marker, isforceRefresh) {
      var currentId, id, parameter, promise, refresh, resolveFn;
      parameter = marker.parameter;
      id = parameter.parentId || parameter.id;
      currentId = (_currentMarker != null ? _currentMarker.parameter.parentId : void 0) || (_currentMarker != null ? _currentMarker.parameter.id : void 0);
      refresh = id === currentId;
      if (isforceRefresh && !refresh) {
        return;
      }
      resolveFn = null;
      promise = $q(function(resolve, reject) {
        return resolveFn = function(shouldUpdate) {
          var update;
          if (!shouldUpdate) {
            return reject();
          }
          update = {
            marker: marker,
            scope: _createTemplateScope(parameter)
          };
          resolve(update);
          return update;
        };
      });
      EventListenersF.notify(Events.SIDE_PANEL_CHANGED, {
        id: id,
        forceRefresh: isforceRefresh && refresh,
        resolveFn: resolveFn
      });
      return promise;
    };
    GMarkerF.closeSidepanel = function(gMarker, immediate) {
      var promise, resolveFn;
      resolveFn = null;
      promise = $q.when();
      if (!immediate) {
        promise = $q(function(resolve, reject) {
          return resolveFn = function(shouldClose) {
            if (shouldClose) {
              return resolve(gMarker);
            }
            return reject();
          };
        });
        EventListenersF.notify(Events.SIDE_PANEL_CLOSED, resolveFn);
      }
      promise.then(function() {
        var _ref, _ref1, _ref2;
        var id = (_ref = gMarker.marker) != null ? (_ref1 = _ref.parameter) != null ? _ref1.id : void 0 : void 0;
        if (id) {
          GMarkerF.emitEvent(id, 'unselect');
        }
        _currentMarker = null;
        _currentTemplateScope = null;
        delete gMarker.infoWindowOpen;
        if (!gMarker.isShiftSelected) {
          return (_ref2 = gMarker.marker) != null ? _ref2.setSelected(false) : void 0;
        }
      });
      return promise;
    };
    GMarkerF.closeInfoWindow = function(id) {
      var gMarker = _gMarkers[id];
      if (!!(gMarker != null ? gMarker.open : void 0)) {
        return $q.reject();
      }
      return _forceCloseInfoWindow(gMarker).then(function() {
        return GMarkerF.emitEvent(id, 'unselect');
      });
    };
    GMarkerF.forceCloseInfoWindow = function(id) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return $q.reject();
      }
      return _forceCloseInfoWindow(gMarker).then(function() {
        return GMarkerF.emitEvent(id, 'unselect');
      });
    };
    GMarkerF.closeOtherWindow = function(ids) {
      var current, currentId, promises;
      promises = [];
      for (currentId in _gMarkers) {
        current = _gMarkers[currentId];
        if (!_.contains(ids, currentId)) {
          promises.push((function(currentId) {
            return _forceCloseInfoWindow(current).then(function() {
              return GMarkerF.emitEvent(currentId, 'unselect');
            });
          })(currentId));
        }
      }
      return $q.all(promises);
    };
    GMarkerF.openInfoWindow = function(id) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return $q.reject();
      }
      return _openInfoWindow(gMarker).then(function() {
        return _centerMap(gMarker);
      });
    };
    GMarkerF.toggleInfoWindow = function(id) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return $q.reject();
      }
      if (gMarker.marker.getVisible()) {
        if (gMarker.infoWindowOpen) {
          return _forceCloseInfoWindow(gMarker);
        } else {
          return _openInfoWindow(gMarker).then(function() {
            return _centerMap(gMarker);
          });
        }
      }
      return $q.when();
    };
    GMarkerF.toggleAndCloseOtherWindow = function(id) {
      if (!_gMarkers[id]) {
        return $q.reject();
      }
      return GMarkerF.closeOtherWindow([id]).then(function() {
        return GMarkerF.toggleInfoWindow(id);
      });
    };
    GMarkerF.get = function(id) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return null;
      }
      return gMarker;
    };
    GMarkerF.getAll = function() {
      return _gMarkers;
    };
    GMarkerF.getAllDrivers = function() {
      var id, item;
      var drivers = [];
      for (id in _gMarkers) {
        item = _gMarkers[id];
        if (item.type === "driver") {
          drivers.push(item.marker);
        }
      }
      return drivers;
    };
    GMarkerF.getVisible = function(id) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return null;
      }
      return gMarker.marker.getVisible();
    };
    GMarkerF.setVisible = function(id, isVisible) {
      var gMarker = _gMarkers[id];
      if (!(gMarker && gMarker.marker.visible !== isVisible)) {
        return false;
      }
      gMarker.marker.setVisible(isVisible);
      if (!isVisible) {
        _forceCloseInfoWindow(gMarker).then(function() {
          return GMarkerF.emitEvent(id, 'unselect');
        });
      }
      return true;
    };
    GMarkerF.isInfoWindowOpen = function(id) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      return !!gMarker.infoWindowOpen;
    };
    GMarkerF.getSelected = function(id) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      return gMarker.marker.getSelected();
    };
    GMarkerF.getSelectedText = function(id) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      return gMarker.marker.text;
    };
    GMarkerF.clearAllStyles = function() {
      var id, marker, _results;
      _results = [];
      for (id in _gMarkers) {
        marker = _gMarkers[id];
        GMarkerF.setHovered(id, false);
        GMarkerF.setLassoSelected(id, false);
        GMarkerF.setSelected(id, false, false);
        GMarkerF.setHighlighted(id, false);
        _results.push(GMarkerF.emitEvent(id, 'unselect'));
      }
      return _results;
    };
    GMarkerF.setHighlighted = function(id, isHighlighted) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      if (!gMarker.infoWindowOpen) {
        gMarker.marker.setHighlighted(isHighlighted);
      }
      return true;
    };
    GMarkerF.setSelected = function(id, isSelected, isShiftSelected) {
      var gMarker;
      if (isShiftSelected == null) {
        isShiftSelected = false;
      }
      gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      if (!gMarker.infoWindowOpen) {
        gMarker.marker.setSelected(isSelected);
      }
      gMarker.isShiftSelected = isShiftSelected;
      return true;
    };
    GMarkerF.setLassoSelected = function(id, isSelected) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      gMarker.marker.setLassoSelected(isSelected);
      return true;
    };
    GMarkerF.setHovered = function(id, isHovered) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      if (!gMarker.infoWindowOpen) {
        gMarker.marker.setHovered(isHovered);
      }
      return true;
    };
    GMarkerF.addEventListener = function(id, event, callbackId, callback) {
      var _base;
      if (_listeners[id] == null) {
        _listeners[id] = {};
      }
      if ((_base = _listeners[id])[event] == null) {
        _base[event] = {};
      }
      _listeners[id][event][callbackId] = callback;
      return true;
    };
    GMarkerF.setText = function(id, text) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      gMarker.marker.setText(text);
      return true;
    };
    GMarkerF.setFillCss = function(id, fillCss) {
      var gMarker = _gMarkers[id];
      if (!gMarker) {
        return false;
      }
      gMarker.marker.setFillCss(fillCss);
      return true;
    };
    GMarkerF.emitEvent = function(id, event) {
      var listener, listeners, name, _results;
      listeners = _listeners[id];
      if (!listeners) {
        return false;
      }
      listeners = listeners[event];
      if (listeners) {
        _results = [];
        for (name in listeners) {
          listener = listeners[name];
          _results.push(listener());
        }
        return _results;
      }
    };
    GMarkerF.getMarkerAndScope = function() {
      return {
        marker: _currentMarker,
        scope: _currentTemplateScope
      };
    };

    return GMarkerF;
  };
  GMarkerF.$inject = ["$q", "$rootScope", "$state", "$compile", "$templateRequest", "$injector", "States", "SettingsF", "Constants", "EventListenersF", "Events", "MessagingF", "ConfirmF", "AccountF", "VisitF"];

  angular.module('app').factory('GMarkerF', GMarkerF);

}).call(this);

(function() {
  var Marker = function() {
    Marker = (function() {
      function Marker(position, templateUrl, parameter) {
        this.position = position;
        this.templateUrl = templateUrl;
        this.parameter = parameter;
      }

      return Marker;

    })();
    Marker.Status = {
      Pending: 'pending',
      Invalid: 'invalid',
      Validated: 'validated',
      Valid: 'valid'
    };
    return Marker;
  };

  angular.module('app').factory('Marker', Marker);

}).call(this);

(function() {
  var MarkersF = function($q, VisitF, DriverF, MapF, Constants) {
    var MapPoint = (function() {
      function MapPoint(x, y, zoomOffset) {
        this.x = x;
        this.y = y;
        this.zoomOffset = zoomOffset;
      }

      return MapPoint;

    })();
    MarkersF = {};
    MarkersF.OFFSET = {
      DEFAULT: new MapPoint(Constants.defaultXMapOffset, 0, 2),
      ROUTE_VIEW: new MapPoint(0, 150, 1)
    };
    MarkersF.getPoints = function() {
      var coords, driver, drivers, endCoords, isVisible, points, startCoords, visit, visits, _i, _j, _len, _len1, _ref, _ref1;
      points = [];
      visits = VisitF.getValidVisits();
      for (_i = 0, _len = visits.length; _i < _len; _i++) {
        visit = visits[_i];
        coords = visit.location.coords;
        if (coords) {
          points.push({
            lat: coords.lat,
            lng: coords.lng
          });
        }
      }
      drivers = DriverF.getValidDrivers();
      for (_j = 0, _len1 = drivers.length; _j < _len1; _j++) {
        driver = drivers[_j];
        isVisible = driver.getVisible();
        if (isVisible === null || isVisible) {
          if (driver.startLocation) {
            startCoords = (_ref = driver.startLocation.info) != null ? _ref.coords : void 0;
            if (startCoords) {
              points.push({
                lat: startCoords.lat,
                lng: startCoords.lng
              });
            }
          }
          if (driver.endLocation) {
            endCoords = (_ref1 = driver.endLocation.info) != null ? _ref1.coords : void 0;
            if (endCoords) {
              points.push({
                lat: endCoords.lat,
                lng: endCoords.lng
              });
            }
          }
        }
      }
      return points;
    };
    MarkersF.fitToPoints = function(offsetPoint) {
      var points;
      if (offsetPoint == null) {
        offsetPoint = MarkersF.OFFSET.DEFAULT;
      }
      points = MarkersF.getPoints();
      if ((points != null ? points.length : void 0) > 0) {
        return MapF.panToPoints(points, offsetPoint.x, offsetPoint.y, offsetPoint.zoomOffset);
      }
    };
    return MarkersF;
  };
  MarkersF.$inject = ["$q", "VisitF", "DriverF", "MapF", "Constants"];

  angular.module('app').factory('MarkersF', MarkersF);

}).call(this);

(function() {
  var MessageScreenD = function($compile, $http, $templateCache, $timeout) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'messageTemplates/main.html',
      scope: {
        'template': '='
      },
      link: function($scope, $elem, $attrs) {
        var CONTENT_CLASS, _templateScope, _updateContent;
        _templateScope = $scope.$new();
        _templateScope.exit = function() {
          $scope.template.close();
          $scope.template = null;
          return $scope.hasMessage = false;
        };
        CONTENT_CLASS = 'content';
        $scope.containerClass = "message-screen-container";
        _updateContent = function(template) {
          var content, contentElement, parentElement, _ref;
          parentElement = $elem.find("." + $scope.containerClass);
          if (!template || (parentElement != null ? parentElement.length : void 0) <= 0) {
            return $scope.hasMessage = false;
          }
          template.generateData();
          _templateScope.scope = template.scope;
          content = $compile(template.content)(_templateScope);
          parentElement.find("." + CONTENT_CLASS).remove();
          contentElement = angular.element("<div class='" + CONTENT_CLASS + "'></div>");
          contentElement.append(content);
          parentElement.append(contentElement);
          $scope.hasMessage = true;
          return $scope.allowModalOnTop = !!((_ref = template.scope) != null ? _ref.allowModalOnTop : void 0);
        };
        return $scope.$watch('template', function(newTemplate) {
          return $timeout(function() {
            return _updateContent(newTemplate);
          }, 0);
        });
      }
    };
  };
  MessageScreenD.$inject = ["$compile", "$http", "$templateCache", "$timeout"];

  angular.module('app').directive('messageScreenD', MessageScreenD);

}).call(this);

(function() {
  var MessageTemplateF = function($q, $http, $templateRequest, $state, $interval, $window, $location, States, FunFactsF, Constants) {
    var TEN_SECONDS_IN_MS, Template, compiledCache, hiccupTemplate, optimizeInProgressTemplate, socketDisconnect, updatedEmailTemplate, _getCompiledTemplate, _isLoaded;
    _isLoaded = false;
    TEN_SECONDS_IN_MS = 10 * 1000;
    compiledCache = {};
    _getCompiledTemplate = function(template) {
      return compiledCache[template] || (compiledCache[template] = $templateRequest(template));
    };
    Template = (function() {
      function Template(url, scope) {
        this.url = url;
        this.scope = scope != null ? scope : {};
        this.content = null;
      }

      return Template;

    })();
    Template.prototype.close = function() {};
    Template.prototype.load = function() {
      if (!this.url || this.content) {
        return $q.when(true);
      }
      return _getCompiledTemplate(this.url).then((function(_this) {
        return function(content) {
          return _this.content = content;
        };
      })(this));
    };
    Template.prototype.generateData = function() {
      return null;
    };
    optimizeInProgressTemplate = new Template("messageTemplates/optimizeInProgress.html");
    optimizeInProgressTemplate.scope.goToProjectList = function() {
      return $state.go(States.modalProjectsLoad);
    };
    optimizeInProgressTemplate.scope.allowModalOnTop = true;
    optimizeInProgressTemplate.generateData = function() {
      var _fetchNewFunFact;
      _fetchNewFunFact = (function(_this) {
        return function() {
          _this.scope.funFactUrl = Constants.funFactUrl;
          return _this.scope.funFact = FunFactsF.fetchRandom();
        };
      })(this);
      _fetchNewFunFact();
      return this.funFactInterval = $interval(_fetchNewFunFact, TEN_SECONDS_IN_MS);
    };
    optimizeInProgressTemplate.close = function() {
      if (!this.funFactInterval) {
        return;
      }
      $interval.cancel(this.funFactInterval);
      return this.funFactInterval = null;
    };
    hiccupTemplate = new Template("messageTemplates/hiccup.html");
    hiccupTemplate.scope.goToProjectList = function() {
      return $state.go(States.projects);
    };
    hiccupTemplate.scope.openChat = function() {
      return $window.location.href = "mailto:" + Constants.email;
    };
    socketDisconnect = new Template("messageTemplates/socketDisconnected.html");
    socketDisconnect.scope.openChat = function() {
      return $window.location.href = "mailto:" + Constants.email;
    };
    updatedEmailTemplate = new Template("messageTemplates/updatedEmail.html");
    updatedEmailTemplate.scope["continue"] = function(next) {
      $state.current.reloadOnSearch = false;
      $location.search('update-email-success', null).replace();
      $state.current.reloadOnSearch = true;
      return next();
    };
    MessageTemplateF = {};
    MessageTemplateF.templates = {
      optimizationInProgress: optimizeInProgressTemplate,
      dispatchInProgress: new Template("messageTemplates/dispatchInProgress.html"),
      projectOutOfDate: new Template("messageTemplates/projectOutOfDate.html"),
      offline: new Template("messageTemplates/offline.html"),
      hiccup: hiccupTemplate,
      socket: socketDisconnect,
      lock: new Template("messageTemplates/lock.html"),
      updatedEmail: updatedEmailTemplate
    };
    MessageTemplateF.load = function() {
      var current, key, promises, _ref;
      if (_isLoaded) {
        return $q.when();
      }
      promises = [];
      _ref = MessageTemplateF.templates;
      for (key in _ref) {
        current = _ref[key];
        promises.push(current.load());
      }
      return $q.all(promises);
    };
    return MessageTemplateF;
  };
  MessageTemplateF.$inject = ["$q", "$http", "$templateRequest", "$state", "$interval", "$window", "$location", "States", "FunFactsF", "Constants"];

  angular.module('app').factory('MessageTemplateF', MessageTemplateF);

}).call(this);

(function() {
  var MessageStyle, MessageType, MessagingF;
  var Message = (function() {
    function Message(type, content, style, closingText, action, options) {
      this.type = type;
      this.content = content;
      this.style = style;
      this.closingText = closingText;
      this.action = action;
      this.options = options != null ? options : {};
    }

    return Message;

  })();

  MessageType = {
    INFORMATION: 'info',
    ERROR: 'error',
    LOADING: 'loading',
    SUCCESS: 'success',
    WARNING: 'warning',
    CONFIRM: 'confirm'
  };

  MessageStyle = {
    MODAL: 'modal',
    POPUP: 'popup'
  };

  MessagingF = [
    '$translate', 'EventListenersF', 'Events', function($translate, EventListenersF, Events) {
      var _clearMessages, _messages, _replaceMessages, _showMessages;
      _messages = [];
      MessagingF = {};
      MessagingF.Message = Message;
      MessagingF.Type = MessageType;
      MessagingF.Style = MessageStyle;
      _clearMessages = function(except) {
        if (except) {
          return _.remove(_messages, function(msg) {
            return msg.type !== except;
          });
        } else {
          return _messages.length = 0;
        }
      };
      _replaceMessages = function(type, msgs, except, style, closingTextKey, options) {
        _clearMessages(except);
        return _showMessages(type, msgs, style, closingTextKey, options);
      };
      _showMessages = function(type, msgs, style, closingTextKey, options) {
        var closingText, msg, text, _i, _len;
        for (_i = 0, _len = msgs.length; _i < _len; _i++) {
          msg = msgs[_i];
          text = $translate.instant(msg.key, msg.vals) || msg.key;
          closingText = $translate.instant(closingTextKey);
          _messages.push(new Message(type, text, style, closingText, msg.action, options));
        }
        EventListenersF.notify(Events.NEW_MESSAGE);
        return null;
      };
      MessagingF.clear = function(except) {
        return _clearMessages(except);
      };
      MessagingF.removeMessageAt = function(index) {
        return _messages.splice(index, 1);
      };
      MessagingF.replaceSuccess = function(msgKey, msgVals, except, closingTextKey, action) {
        return MessagingF.replaceSuccesses([
          {
            key: msgKey,
            action: action,
            vals: msgVals
          }
        ], except, MessageStyle.MODAL, closingTextKey);
      };
      MessagingF.replaceSuccessPopup = function(msgKey, msgVals, except) {
        return MessagingF.replaceSuccesses([
          {
            key: msgKey,
            vals: msgVals
          }
        ], except, MessageStyle.POPUP);
      };
      MessagingF.replaceError = function(msgKey, msgVals, closingTextKey, action) {
        return MessagingF.replaceErrors([
          {
            key: msgKey,
            action: action,
            vals: msgVals
          }
        ], MessageStyle.MODAL, closingTextKey);
      };
      MessagingF.replaceErrorPopup = function(msgKey, msgVals) {
        return MessagingF.replaceErrors([
          {
            key: msgKey,
            vals: msgVals
          }
        ], MessageStyle.POPUP);
      };
      MessagingF.replaceInfo = function(msgKey, msgVals, except, closingTextKey, action) {
        return MessagingF.replaceInfos([
          {
            key: msgKey,
            action: action,
            vals: msgVals
          }
        ], except, MessageStyle.MODAL, closingTextKey);
      };
      MessagingF.replaceInfoPopup = function(msgKey, msgVals, except) {
        return MessagingF.replaceInfos([
          {
            key: msgKey,
            vals: msgVals
          }
        ], except, MessageStyle.POPUP);
      };
      MessagingF.replaceWarning = function(msgKey, msgVals, except, closingTextKey, action, options) {
        return MessagingF.replaceWarnings([
          {
            key: msgKey,
            action: action,
            vals: msgVals
          }
        ], except, MessageStyle.MODAL, closingTextKey, options);
      };
      MessagingF.replaceWarningPopup = function(msgKey, msgVals, except) {
        return MessagingF.replaceWarnings([
          {
            key: msgKey,
            vals: msgVals
          }
        ], except, MessageStyle.POPUP);
      };
      MessagingF.replaceConfirm = function(msgKey, msgVals, except, closingTextKey, action, options) {
        return MessagingF.replaceConfirms([
          {
            key: msgKey,
            action: action,
            vals: msgVals
          }
        ], except, MessageStyle.MODAL, closingTextKey, options);
      };
      MessagingF.replaceConfirmOverlay = function(msgKey, msgVals, except, closingTextKey, action) {
        return MessagingF.replaceConfirms([
          {
            key: msgKey,
            action: action,
            vals: msgVals
          }
        ], except, MessageStyle.MODAL, closingTextKey, {
          noClose: true,
          overlay: true
        });
      };
      MessagingF.topWarningPopup = function(msgKey, msgVals, except) {
        return MessagingF.replaceWarnings([
          {
            key: msgKey,
            vals: msgVals
          }
        ], except, MessageStyle.POPUP, void 0, {
          top: true
        });
      };
      MessagingF.replaceErrors = function(msgs, style, closingTextKey) {
        return _replaceMessages(MessageType.ERROR, msgs, null, style, closingTextKey);
      };
      MessagingF.replaceSuccesses = function(msgs, except, style, closingTextKey) {
        return _replaceMessages(MessageType.SUCCESS, msgs, except, style, closingTextKey);
      };
      MessagingF.replaceInfos = function(msgs, except, style, closingTextKey) {
        return _replaceMessages(MessageType.INFORMATION, msgs, except, style, closingTextKey);
      };
      MessagingF.replaceWarnings = function(msgs, except, style, closingTextKey, options) {
        return _replaceMessages(MessageType.WARNING, msgs, except, style, closingTextKey, options);
      };
      MessagingF.replaceConfirms = function(msgs, except, style, closingTextKey, options) {
        return _replaceMessages(MessageType.CONFIRM, msgs, except, style, closingTextKey, options);
      };
      MessagingF.replaceLoading = function(msgKey) {
        return _replaceMessages(MessageType.LOADING, [
          {
            key: msgKey
          }
        ], null, MessageStyle.POPUP);
      };
      MessagingF.showInfo = function(msgKey) {
        return _showMessages(MessageType.INFORMATION, [
          {
            key: msgKey
          }
        ]);
      };
      MessagingF.getMessages = function() {
        return _messages;
      };
      return MessagingF;
    }
  ];

  angular.module('app').factory('MessagingF', MessagingF);

}).call(this);

(function() {
  var Notification = function(ProjectTimezoneF, TimeUtilF) {
    Notification = (function() {
      function Notification(entry) {
        var browserTZ, diffHours, logDate, projectTZ, _ref;
        if (entry.projectId) {
          this.projectId = entry.projectId;
        }
        if (entry.routeId) {
          this.routeId = entry.routeId;
        }
        if (entry.vehicleId) {
          this.vehicleId = entry.vehicleId;
        }
        if (entry.type) {
          this.type = entry.type;
        }
        if (entry.date) {
          this.date = entry.date;
        }
        if (entry.primaryTitle) {
          this.primaryTitle = entry.primaryTitle;
        }
        if (entry.secondaryTitle) {
          this.secondaryTitle = entry.secondaryTitle;
        }
        if (entry.subtitle) {
          this.subtitle = entry.subtitle;
        }
        this.seen = false;
        if (entry.color) {
          this.color = entry.color;
        }
        if (entry.visitId) {
          this.visitId = entry.visitId;
        }
        if (entry.locationId) {
          this.locationId = entry.locationId;
        }
        if (entry.signatureId) {
          this.signatureId = entry.signatureId;
        }
        if (entry.photoUrl) {
          this.photoUrl = entry.photoUrl;
        }
        if (entry.errorMessage) {
          this.errorMessage = entry.errorMessage;
        }
        if (entry.phoneNumber) {
          this.phoneNumber = entry.phoneNumber;
        }
        if (this.date) {
          projectTZ = (_ref = ProjectTimezoneF.getProjectTimezone()) != null ? _ref.gmtOffset : void 0;
          browserTZ = new Date().getTimezoneOffset() * 60 * 1000 * -1;
          diffHours = browserTZ - projectTZ;
          logDate = new Date(this.date);
          logDate = new Date(logDate.getTime() + diffHours);
          this.date = logDate;
          this.dateStr = TimeUtilF.dateToTimeStr(logDate);
        }
      }

      Notification.prototype.setSeen = function(val) {
        return this.seen = val;
      };

      return Notification;

    })();
    return Notification;
  };
  Notification.$inject = ["ProjectTimezoneF", "TimeUtilF"];

  angular.module('app').factory('Notification', Notification);

}).call(this);

(function() {
  var NotificationF = function($http, $q, $translate, Constants, RouteS, Notification, VisitF, TimeUtilF, EventListenersF, AccountF, Events) {
    var ERROR_MAP, _allNotifications, _getInfoWithVisitAndVehicleId, _hasNewNotifications, _initEventListeners, _mapErrorCodeToMessage, _parseSmsError, _parseSmsErrorsArray, _smsErrorsFetched;
    NotificationF = {};
    _hasNewNotifications = false;
    _allNotifications = [];
    _smsErrorsFetched = false;
    ERROR_MAP = {
      21610: 'The phone number has unsubscribed from receiving sms notifications',
      30004: 'The phone number is on do-not-call list',
      30005: 'Phone number cannot be reached',
      30006: 'The phone number is landline or unreachable carrier'
    };
    _initEventListeners = function() {
      EventListenersF.addEventListener(Events.VERIFIED_VISIT_STATUS_UPDATE, function(update) {
        return NotificationF.visitUpdateToNotification(update.data, update.vehicleId);
      });
      EventListenersF.addEventListener(Events.DISPATCHES_UPDATED, function(dispatches) {
        return NotificationF.loadNotificationsFromDispatches(dispatches);
      });
      return EventListenersF.addEventListener(Events.DISPATCHES_DELETED, function() {
        return NotificationF.clearNotifications();
      });
    };
    _mapErrorCodeToMessage = function(errorCode) {
      if (ERROR_MAP[errorCode]) {
        return ERROR_MAP[errorCode];
      } else {
        return 'Failed to send sms notification';
      }
    };
    _parseSmsError = function(error) {
      var entry, isDriverError, locationId, primaryTitle, _ref;
      primaryTitle = void 0;
      locationId = void 0;
      isDriverError = false;
      if (error.stop_id != null) {
        primaryTitle = (_ref = VisitF.getVisit(error.stop_id)) != null ? _ref.name : void 0;
        locationId = error.stop_id;
      } else if (error.vehicle_id != null) {
        primaryTitle = RouteS.getDriverName(error.vehicle_id);
        locationId = error.vehicle_id;
        isDriverError = false;
      }
      entry = {
        type: Constants.notificationTypes.smsError,
        date: new Date(error.sent_time),
        locationId: locationId,
        primaryTitle: primaryTitle,
        errorMessage: _mapErrorCodeToMessage(error.error_code),
        isDriverError: isDriverError,
        phoneNumber: error.phone_number
      };
      return new Notification(entry);
    };
    _parseSmsErrorsArray = function(errors) {
      var error, formattedSmsErrors, _i, _len;
      if (!(errors.length > 0)) {
        return [];
      }
      formattedSmsErrors = [];
      for (_i = 0, _len = errors.length; _i < _len; _i++) {
        error = errors[_i];
        formattedSmsErrors.push(_parseSmsError(error));
      }
      return formattedSmsErrors;
    };
    NotificationF.addNewNotifications = function(notification) {
      _allNotifications.unshift(notification);
      NotificationF.setHasNewNotifications(true);
      return EventListenersF.notify(Events.NEW_NOTIFICATION_ADDED, _allNotifications);
    };
    NotificationF.visitUpdateToNotification = function(update, vehId) {
      var idx, lastLog, locationId, logs, notif, notification, notificationEntry, primaryTitle, routeId, secondaryTitle, statusType, subtitle, visit, visitId, _i, _len, _ref, _ref1, _results;
      routeId = update.routeId;
      visitId = update.visitId;
      visit = update.detail;
      logs = visit.log;
      lastLog = logs[logs.length - 1];
      locationId = (_ref = visit.location) != null ? _ref.id : void 0;
      if (visit.status === Constants.visitStatusPending) {
        _results = [];
        for (idx = _i = 0, _len = _allNotifications.length; _i < _len; idx = ++_i) {
          notif = _allNotifications[idx];
          if (notif.vehicleId === vehId && notif.visitId === visitId && notif.routeId === routeId) {
            _allNotifications.splice(idx, 1);
            break;
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      } else {
        _ref1 = _getInfoWithVisitAndVehicleId(visit, vehId), primaryTitle = _ref1[0], secondaryTitle = _ref1[1], subtitle = _ref1[2], statusType = _ref1[3];
        notificationEntry = {
          visitId: visitId,
          vehicleId: vehId,
          color: RouteS.getColorForDriver(vehId),
          routeId: routeId,
          date: lastLog != null ? lastLog.date : void 0,
          type: statusType,
          primaryTitle: primaryTitle,
          secondaryTitle: secondaryTitle,
          subtitle: subtitle,
          locationId: locationId,
          signatureId: visit._signature,
          photoUrl: visit.photo_url
        };
        notification = new Notification(notificationEntry);
        return NotificationF.addNewNotifications(notification);
      }
    };
    NotificationF.addSmsErrorNotification = function(data) {
      var notification = _parseSmsError(data);
      return NotificationF.addNewNotifications(notification);
    };
    NotificationF.loadNotificationsFromDispatches = function(dispatches) {
      var dispatch, idx, lastLog, locationId, logs, notification, notificationEntry, photoUrl, primaryTitle, routeNotifications, secondaryTitle, signatureId, statusType, subtitle, vehId, visit, visits, _i, _len, _ref, _ref1, _ref2;
      routeNotifications = [];
      for (vehId in dispatches) {
        dispatch = dispatches[vehId];
        visits = (_ref = dispatch.solution) != null ? _ref.visits : void 0;
        for (idx = _i = 0, _len = visits.length; _i < _len; idx = ++_i) {
          visit = visits[idx];
          if (visit.status && visit.status !== Constants.visitStatusPending) {
            logs = visit.log;
            lastLog = logs[logs.length - 1];
            locationId = (_ref1 = visit.location) != null ? _ref1.id : void 0;
            signatureId = visit._signature;
            photoUrl = visit.photo_url;
            _ref2 = _getInfoWithVisitAndVehicleId(visit, vehId), primaryTitle = _ref2[0], secondaryTitle = _ref2[1], subtitle = _ref2[2], statusType = _ref2[3];
            notificationEntry = {
              visitId: idx,
              vehicleId: vehId,
              color: RouteS.getColorForDriver(vehId),
              routeId: dispatch._id,
              date: lastLog != null ? lastLog.date : void 0,
              type: statusType,
              primaryTitle: primaryTitle,
              secondaryTitle: secondaryTitle,
              subtitle: subtitle,
              locationId: locationId,
              signatureId: signatureId,
              photoUrl: photoUrl
            };
            notification = new Notification(notificationEntry);
            routeNotifications.push(notification);
          }
        }
      }
      return _allNotifications = routeNotifications;
    };
    _getInfoWithVisitAndVehicleId = function(visit, vehId) {
      var driverName, primaryTitle, secondaryTitle, status, statusType, subtitle, _ref, _ref1;
      primaryTitle = null;
      secondaryTitle = null;
      statusType = null;
      subtitle = null;
      status = visit.status;
      driverName = RouteS.getDriverName(vehId);
      if (visit["break"] && status === Constants.visitStatusDone) {
        primaryTitle = driverName;
        secondaryTitle = $translate.instant("NOTIFICATIONS.ON_BREAK");
        statusType = Constants.notificationTypes.breakDone;
        subtitle = null;
      } else if (status === Constants.visitStatusDone) {
        if (visit.isLate) {
          secondaryTitle = $translate.instant("NOTIFICATIONS.LATE_BY", {
            mins: TimeUtilF.minutesToHoursStr(visit.minsLate)
          });
          statusType = Constants.notificationTypes.visitDoneLate;
        } else {
          secondaryTitle = $translate.instant("NOTIFICATIONS.ON_TIME");
          statusType = Constants.notificationTypes.visitDone;
        }
        if (visit.finish_time) {
          primaryTitle = (_ref = visit.location) != null ? _ref.name : void 0;
        } else {
          primaryTitle = $translate.instant("NOTIFICATIONS.DEPOT");
        }
        subtitle = driverName;
      } else if (status === Constants.visitStatusSkipped) {
        primaryTitle = (_ref1 = visit.location) != null ? _ref1.name : void 0;
        secondaryTitle = $translate.instant("NOTIFICATIONS.WAS_MISSED");
        statusType = Constants.notificationTypes.visitSkipped;
        subtitle = driverName;
      }
      return [primaryTitle, secondaryTitle, subtitle, statusType];
    };
    NotificationF.newNotificationCount = function() {
      var notification, _i, _len;
      var count = 0;
      for (_i = 0, _len = _allNotifications.length; _i < _len; _i++) {
        notification = _allNotifications[_i];
        if (!notification.seen) {
          count++;
        }
      }
      return count;
    };
    NotificationF.clearNotifications = function() {
      NotificationF.setHasNewNotifications(false);
      _allNotifications = [];
      _smsErrorsFetched = false;
      return EventListenersF.notify(Events.NOTIFICATION_CLEARED);
    };
    NotificationF.getHasNewNotifications = function() {
      return _hasNewNotifications;
    };
    NotificationF.setHasNewNotifications = function(state) {
      return _hasNewNotifications = state;
    };
    NotificationF.markAllAsSeen = function() {
      var notification, _i, _len;
      for (_i = 0, _len = _allNotifications.length; _i < _len; _i++) {
        notification = _allNotifications[_i];
        notification.setSeen(true);
      }
      return NotificationF.setHasNewNotifications(false);
    };
    NotificationF.getSmsErrors = function(projectId) {
      var authHeader;
      if (!_smsErrorsFetched) {
        authHeader = AccountF.getAuthHeader();
        return $http.get("" + Constants.notificationApiPath + "/notifications?failed=true&projectId=" + projectId, authHeader).then(function(res) {
          var sms;
          var errors = res.data;
          if (errors <= 0) {
            return [];
          }
          sms = _parseSmsErrorsArray(errors);
          return sms;
        })["catch"](function(err) {
          return [];
        })["finally"](function() {
          return _smsErrorsFetched = true;
        });
      }
    };
    NotificationF.getAllNotifications = function(projectId) {
      if (!_smsErrorsFetched) {
        return NotificationF.getSmsErrors(projectId).then(function(res) {
          if ((res != null ? res.length : void 0) > 0) {
            EventListenersF.notify(Events.SMS_ERRORS_LOADED, res);
            _allNotifications = _.sortBy(_allNotifications.concat(res), function(notification) {
              return notification.date * -1;
            });
          }
          return _allNotifications;
        });
      } else {
        return $q.when(_allNotifications);
      }
    };
    NotificationF.updateNotificationsInfo = function(cb, projectId) {
      if (!projectId) {
        return;
      }
      return NotificationF.getAllNotifications(projectId).then(function(res) {
        if (res.length > 0) {
          return cb(true, res);
        } else {
          return cb(false, res);
        }
      })["catch"](console.log);
    };
    _initEventListeners();
    return NotificationF;
  };
  NotificationF.$inject = ["$http", "$q", "$translate", "Constants", "RouteS", "Notification", "VisitF", "TimeUtilF", "EventListenersF", "AccountF", "Events"];

  angular.module('app').factory('NotificationF', NotificationF);

}).call(this);

(function() {
  var DemoDataC = {
    visits: [
      {
        "name": "Tommy",
        "location": {
          "address": "800 Kingsway, Vancouver, Canada",
          "coords": {
            "lat": 49.25548089999999,
            "lng": -123.08721350000002
          }
        },
        "startDate": null,
        "endDate": null,
        "duration": 10,
        "load": null,
        "notes": "",
        "id": "1a9f89821545483debd90a0282310c91",
        "status": "pending"
      }, {
        "name": "Anabel",
        "location": {
          "address": "1800 Robson, Vancouver, Canada",
          "coords": {
            "lat": 49.2915333,
            "lng": -123.13555350000001
          }
        },
        "startDate": null,
        "endDate": null,
        "duration": 10,
        "load": null,
        "notes": "",
        "id": "777291d5a47248a0bccb0cbd239b10a3",
        "status": "pending"
      }, {
        "name": "Svetlana",
        "location": {
          "address": "3780 Arbutus, Vancouver, Canada",
          "coords": {
            "lat": 49.2474623,
            "lng": -123.15322459999999
          }
        },
        "startDate": null,
        "endDate": null,
        "duration": 10,
        "load": null,
        "notes": "She likes a smile upon delivery!",
        "id": "ce8faf0d5f784459c89409c3941b1703",
        "status": "pending"
      }, {
        "name": "Tina",
        "location": {
          "address": "6800 Cambie, Vancouver, Canada",
          "coords": {
            "lat": 49.22462650000001,
            "lng": -123.11638909999999
          }
        },
        "startDate": "2014-02-01 12:00",
        "endDate": "2014-02-01 15:00",
        "duration": 30,
        "load": null,
        "notes": "",
        "id": "7d575e2c1d3340a69e87ba0094bfdc01",
        "status": "pending"
      }, {
        "name": "Armen",
        "location": {
          "address": "8500 Granville Street, Vancouver, Canada",
          "coords": {
            "lat": 49.2094459,
            "lng": -123.14039439999999
          }
        },
        "startDate": "2014-02-01 12:00",
        "endDate": "2014-02-01 15:00",
        "duration": 30,
        "load": null,
        "notes": "",
        "id": "365c5bcbbc74492f8f136ef6a6c5dd62",
        "status": "pending"
      }, {
        "name": "Elena",
        "location": {
          "address": "8600 Knight Street, Vancouver, Canada",
          "coords": {
            "lat": 49.2123836,
            "lng": -123.07712700000002
          }
        },
        "startDate": null,
        "endDate": null,
        "duration": 15,
        "load": null,
        "notes": "Use backdoor",
        "id": "c97f795a589147e8e88b4108bf278fcd",
        "status": "pending"
      }, {
        "name": "Jim",
        "location": {
          "address": "2200 Macdonald Street, Vancouver, Canada",
          "coords": {
            "lat": 49.2666451,
            "lng": -123.16836490000003
          }
        },
        "startDate": null,
        "endDate": null,
        "duration": 10,
        "load": null,
        "notes": "",
        "id": "0718c092a17049e0e0ea077d4cb14d16",
        "status": "pending"
      }, {
        "name": "Suzanne",
        "location": {
          "address": "1600 Manitoba Street, Vancouver, Canada",
          "coords": {
            "lat": 49.2706256,
            "lng": -123.1067195
          }
        },
        "startDate": null,
        "endDate": null,
        "duration": 5,
        "load": null,
        "notes": "",
        "id": "b516550ff6a9492cea78204e1dd5398e",
        "status": "pending"
      }, {
        "name": "School",
        "location": {
          "address": "800 Wallace Street, Vancouver",
          "coords": {
            "lat": 49.2480959,
            "lng": -123.190875
          }
        },
        "startDate": null,
        "endDate": null,
        "duration": 30,
        "load": null,
        "notes": "",
        "id": "70d3d38da4ea4262a3d73a80032bc929",
        "status": "pending"
      }, {
        "name": "Terminal",
        "location": {
          "address": "200 Commercial Drive, Vancouver, BC",
          "coords": {
            "lat": 49.28304900000001,
            "lng": -123.07031840000002
          }
        },
        "startDate": "2014-02-01 9:00",
        "endDate": "2014-02-01 9:30",
        "duration": 20,
        "load": null,
        "notes": "",
        "id": "99129af95c164b9cb68cafd8f2f30eb1",
        "status": "pending"
      }, {
        "name": "Foo",
        "location": {
          "address": "200 Renfrew Street, Vancouver, BC",
          "coords": {
            "lat": 49.2689655,
            "lng": -123.04420429999999
          }
        },
        "startDate": "2014-02-01 9:00",
        "endDate": "2014-02-01 10:00",
        "duration": 10,
        "load": null,
        "notes": "",
        "id": "2ce6f75d99674961ebaa844d22c6b09c",
        "status": "pending"
      }
    ],
    fleet: [
      {
        "id": "A",
        "startShift": "2014-02-01 08:00",
        "endShift": "2014-02-01 16:00",
        "name": "Driver A",
        "phoneNumber": "+18006888888",
        "startLocation": {
          "info": {
            "address": "788 Beatty Street, Vancouver, BC, Canada",
            "coords": {
              "lat": 49.2777805,
              "lng": -123.11367000000001
            }
          },
          "id": "546bf50028f64d27d1e9e5cf6348fc68"
        },
        "endLocation": {
          "info": {
            "address": "788 Beatty Street, Vancouver, BC, Canada",
            "coords": {
              "lat": 49.2777805,
              "lng": -123.11367000000001
            }
          },
          "id": "9b88eb0715474412f597153580511d31"
        }
      }, {
        "id": "B",
        "startShift": "2014-02-01 08:00",
        "endShift": "2014-02-01 16:00",
        "name": "Driver B",
        "startLocation": {
          "info": {
            "address": "UBC, West Mall, Vancouver, BC, Canada",
            "coords": {
              "lat": 49.260605,
              "lng": -123.245994
            }
          },
          "id": "919a9865acb04afeaa9adc82222a77b1"
        }
      }
    ]
  };

  angular.module('app').constant('DemoDataC', DemoDataC);

}).call(this);

(function() {
  var     __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  var OnboardingF = function($rootScope, $kookies, $state, $translate, VisitF, VisitUploadF, DriverF, MarkersF, DriverMarker, DemoDataC, AnalyticsS, AccountF, States, EventListenersF, Events, ProjectF, RouteS, DispatchStatusF) {
    var BETA_ONBOARDING_DONE, BETA_ONBOARDING_STARTED, EDIT_ROUTE_HINTS, LIVE_ROUTE_HINTS, NEW_DRIVER_SPEC, NEW_VISIT_SPEC, PLAN_ROUTE_HINTS, REACTIVATE_TOOLTIPS_HINT, READY_TO_OPTIMIZE, TOUR_STAGES, UNSCHEDULED_ROW_HINT, _areOnboardingToursDone, _changeStepIndex, _disableOnboardingTour, _enableOnboardingTour, _enableOnboardingTourCompletionState, _enableOnboardingTourListItem, _getEditModeSwitchBottom, _getEditUnscheduledRowBottom, _getOnboardingCookie, _getTourNamesForState, _isOnboardingTourDone, _setOnboardingCookie;
    OnboardingF = {};
    BETA_ONBOARDING_DONE = "BETA_ONBOARDING_DONE";
    BETA_ONBOARDING_STARTED = "BETA_ONBOARDING_STARTED";
    TOUR_STAGES = {
      INPUT_STAGE: {
        NAME: "inputOnboardingTour",
        STATES: [States.projectDriversList, States.projectVisitsList, States.projectVisitsUpload, States.projectDriversUpload]
      },
      PLAN_ROUTE_STAGE: {
        NAME: "planRouteOnboardingTour",
        STATES: [States.projectRoutePlan]
      },
      EDIT_ROUTE_STAGE: {
        NAME: "editRouteOnboardingTour",
        STATES: [States.projectRouteEdit]
      },
      LIVE_ROUTE_STAGE: {
        NAME: "liveRouteOnboardingTour",
        STATES: [States.projectRouteLive]
      },
      UNSCHEDULED_ROW_STAGE: {
        NAME: "unscheduledRowOnboardingTour",
        STATES: [States.projectRoutePlan]
      }
    };
    NEW_DRIVER_SPEC = 'newDriverSpec';
    NEW_VISIT_SPEC = 'newVisitSpec';
    READY_TO_OPTIMIZE = 'readyToOptimize';
    PLAN_ROUTE_HINTS = 'planRouteHints';
    UNSCHEDULED_ROW_HINT = 'unscheduledRowHint';
    EDIT_ROUTE_HINTS = 'editRouteHints';
    LIVE_ROUTE_HINTS = 'liveRouteHints';
    REACTIVATE_TOOLTIPS_HINT = 'reactivateTooltipsHint';
    _getTourNamesForState = function(state) {
      var STAGE, k, toursForState;
      toursForState = [];
      for (k in TOUR_STAGES) {
        STAGE = TOUR_STAGES[k];
        if (__indexOf.call(STAGE.STATES, state) >= 0) {
          toursForState.push(STAGE.NAME);
        }
      }
      return toursForState;
    };
    _setOnboardingCookie = function(cookieName, isEnabled) {
      var email = AccountF.getUser().email;
      return $kookies.set("" + email + "-" + cookieName, isEnabled);
    };
    _getOnboardingCookie = function(cookieName) {
      var email = AccountF.getUser().email;
      return $kookies.get("" + email + "-" + cookieName);
    };
    _getEditUnscheduledRowBottom = function(chartHeight) {
      return chartHeight - 55;
    };
    _getEditModeSwitchBottom = function(chartHeight) {
      return chartHeight + 15;
    };
    _areOnboardingToursDone = function(obTourNames) {
      var name, _i, _len;
      for (_i = 0, _len = obTourNames.length; _i < _len; _i++) {
        name = obTourNames[_i];
        if (!_isOnboardingTourDone(name)) {
          return false;
        }
      }
      return true;
    };
    _isOnboardingTourDone = function(obTourName) {
      var cookie, tourDoneStr, _ref;
      tourDoneStr = obTourName + 'Done';
      cookie = _getOnboardingCookie(tourDoneStr);
      return OnboardingF.isDone() || ((_ref = AccountF.getUser().settings) != null ? _ref[tourDoneStr] : void 0) || ((cookie != null) && JSON.parse(cookie));
    };
    _changeStepIndex = function(obStateName, index) {
      var onboardingObject = OnboardingF.tours[obStateName];
      return onboardingObject.index = index;
    };
    _disableOnboardingTour = function(obStateName) {
      var onboardingObject = OnboardingF.tours[obStateName];
      return onboardingObject.enabled = false;
    };
    _enableOnboardingTour = function(obStateName) {
      var onboardingObject;
      OnboardingF.disableAllTours();
      onboardingObject = OnboardingF.tours[obStateName];
      return onboardingObject.enabled = true;
    };
    _enableOnboardingTourListItem = function(obStateName, listIndex) {
      var onboardingObject;
      _enableOnboardingTour(obStateName);
      onboardingObject = OnboardingF.tours[obStateName];
      if (listIndex != null) {
        onboardingObject.activeListIndex = listIndex;
      }
      return onboardingObject.completed = false;
    };
    _enableOnboardingTourCompletionState = function(obStateName) {
      var onboardingObject;
      _enableOnboardingTour(obStateName);
      onboardingObject = OnboardingF.tours[obStateName];
      onboardingObject.activeListIndex = onboardingObject.listItems.length - 1;
      return onboardingObject.completed = true;
    };
    OnboardingF.tourStages = TOUR_STAGES;
    OnboardingF.tours = {};
    OnboardingF.tours[NEW_DRIVER_SPEC] = {
      enabled: false,
      hasProgressBar: true,
      progressIndex: 0,
      progressCount: 3,
      style: "orange",
      image: "/img/driver.png",
      title: $translate.instant("ONBOARDING.NEW_DRIVER_SPEC.TITLE"),
      activeListIndex: 0,
      listItems: [$translate.instant("ONBOARDING.NEW_DRIVER_SPEC.LIST_ITEM_1"), $translate.instant("ONBOARDING.NEW_DRIVER_SPEC.LIST_ITEM_2"), $translate.instant("ONBOARDING.NEW_DRIVER_SPEC.LIST_ITEM_3")],
      completed: false,
      completedTitle: $translate.instant("ONBOARDING.NEW_DRIVER_SPEC.COMPLETED_TITLE"),
      completedClass: "is-completed",
      completedListItems: [$translate.instant("ONBOARDING.NEW_DRIVER_SPEC.COMPLETED_ITEM_1"), $translate.instant("ONBOARDING.NEW_DRIVER_SPEC.COMPLETED_ITEM_2")]
    };
    OnboardingF.tours[NEW_VISIT_SPEC] = {
      enabled: false,
      hasProgressBar: true,
      progressIndex: 1,
      progressCount: 3,
      style: "orange",
      title: $translate.instant("ONBOARDING.NEW_VISIT_SPEC.TITLE"),
      image: "/img/stops.png",
      activeListIndex: 0,
      listItems: [$translate.instant("ONBOARDING.NEW_VISIT_SPEC.LIST_ITEM_1"), $translate.instant("ONBOARDING.NEW_VISIT_SPEC.LIST_ITEM_2"), $translate.instant("ONBOARDING.NEW_VISIT_SPEC.LIST_ITEM_3")],
      completed: false,
      completedTitle: $translate.instant("ONBOARDING.NEW_VISIT_SPEC.COMPLETED_TITLE"),
      completedListItems: [$translate.instant("ONBOARDING.NEW_VISIT_SPEC.COMPLETED_ITEM_1"), $translate.instant("ONBOARDING.NEW_VISIT_SPEC.COMPLETED_ITEM_2")]
    };
    OnboardingF.tours[READY_TO_OPTIMIZE] = {
      enabled: false,
      hasProgressBar: true,
      progressIndex: 2,
      progressCount: 3,
      style: "blue",
      title: $translate.instant("ONBOARDING.READY_TO_OPTIMIZE.TITLE"),
      image: "/img/thumbsUp.png",
      description: $translate.instant("ONBOARDING.READY_TO_OPTIMIZE.DESCRIPTION")
    };
    OnboardingF.tours[PLAN_ROUTE_HINTS] = {
      enabled: false,
      hasProgressBar: true,
      progressCount: 4,
      style: 'orange',
      showSkipButton: true,
      index: 0,
      steps: [
        {
          title: $translate.instant("ONBOARDING.PLAN_ROUTE_HINTS.STEP_1_TITLE"),
          description: $translate.instant("ONBOARDING.PLAN_ROUTE_HINTS.STEP_1_DESCRIPTION"),
          attachTo: ".onboarding-target-drivers-tab",
          position: "bottom",
          left: 380,
          top: 45,
          arrowLeftOffset: '10%'
        }, {
          title: $translate.instant("ONBOARDING.PLAN_ROUTE_HINTS.STEP_2_TITLE"),
          description: $translate.instant("ONBOARDING.PLAN_ROUTE_HINTS.STEP_2_DESCRIPTION"),
          attachTo: ".onboarding-target-history",
          position: "top",
          left: '38%'
        }, {
          title: $translate.instant("ONBOARDING.PLAN_ROUTE_HINTS.STEP_3_TITLE"),
          description: $translate.instant("ONBOARDING.PLAN_ROUTE_HINTS.STEP_3_DESCRIPTION"),
          attachTo: ".onboarding-target-reoptimize-btn",
          position: "top",
          right: 230,
          bottom: 75,
          arrowLeftOffset: '90%'
        }, {
          title: $translate.instant("ONBOARDING.PLAN_ROUTE_HINTS.STEP_4_TITLE"),
          description: $translate.instant("ONBOARDING.PLAN_ROUTE_HINTS.STEP_4_DESCRIPTION"),
          doneButtonText: $translate.instant("ONBOARDING.PLAN_ROUTE_HINTS.DONE_BUTTON"),
          attachTo: ".onboarding-target-dispatch-btn",
          position: "top",
          arrowLeftOffset: '90%',
          right: 40,
          bottom: 75
        }
      ],
      finishCb: function() {
        OnboardingF.finishOnboardingTour(TOUR_STAGES.PLAN_ROUTE_STAGE.NAME);
        if (RouteS.hasUnserved()) {
          return OnboardingF.tours[UNSCHEDULED_ROW_HINT].enabled = true;
        }
      },
      skipCb: function() {
        OnboardingF.finishOnboarding();
        return OnboardingF.tours[REACTIVATE_TOOLTIPS_HINT].enabled = true;
      }
    };
    EventListenersF.addEventListener(Events.ROUTE_CHART_HEIGHT_CHANGED, function(chartHeight) {
      OnboardingF.tours[PLAN_ROUTE_HINTS].steps[1].bottom = _getEditModeSwitchBottom(chartHeight);
      OnboardingF.tours[EDIT_ROUTE_HINTS].steps[1].bottom = _getEditModeSwitchBottom(chartHeight);
      OnboardingF.tours[UNSCHEDULED_ROW_HINT].steps[0].bottom = _getEditUnscheduledRowBottom(chartHeight);
      return OnboardingF.tours[LIVE_ROUTE_HINTS].steps[0].bottom = _getEditModeSwitchBottom(chartHeight);
    });
    EventListenersF.addEventListener(Events.ROUTE_SET, function(newRoute) {
      var _ref;
      if (!OnboardingF.wasStarted()) {
        return;
      }
      if (newRoute == null) {
        return;
      }
      if (RouteS.hasUnserved() && !(_isOnboardingTourDone(TOUR_STAGES.UNSCHEDULED_ROW_STAGE.NAME)) && !OnboardingF.tours[PLAN_ROUTE_HINTS].enabled && (_ref = $state.current.name, __indexOf.call(TOUR_STAGES.UNSCHEDULED_ROW_STAGE.STATES, _ref) >= 0)) {
        return _enableOnboardingTour(UNSCHEDULED_ROW_HINT);
      } else {
        return _disableOnboardingTour(UNSCHEDULED_ROW_HINT);
      }
    });
    OnboardingF.tours[EDIT_ROUTE_HINTS] = {
      enabled: false,
      hasProgressBar: true,
      progressCount: 3,
      style: 'orange',
      showSkipButton: true,
      index: 0,
      steps: [
        {
          title: $translate.instant("ONBOARDING.EDIT_ROUTE_HINTS.STEP_1_TITLE"),
          description: $translate.instant("ONBOARDING.EDIT_ROUTE_HINTS.STEP_1_DESCRIPTION"),
          attachTo: ".live-track-countdown",
          position: "left",
          top: 40,
          right: 370
        }, {
          title: $translate.instant("ONBOARDING.EDIT_ROUTE_HINTS.STEP_2_TITLE"),
          description: $translate.instant("ONBOARDING.EDIT_ROUTE_HINTS.STEP_2_DESCRIPTION"),
          attachTo: ".onboarding-target-edit-switch",
          position: "top",
          bottom: null,
          xOffset: -320,
          arrowLeftOffset: '90%',
          showBackButton: true
        }, {
          title: $translate.instant("ONBOARDING.EDIT_ROUTE_HINTS.STEP_3_TITLE"),
          description: $translate.instant("ONBOARDING.EDIT_ROUTE_HINTS.STEP_3_DESCRIPTION"),
          doneButtonText: $translate.instant("ONBOARDING.EDIT_ROUTE_HINTS.DONE_BUTTON"),
          attachTo: ".route-footer .btn-action",
          position: "top",
          arrowLeftOffset: '90%',
          right: 20
        }
      ],
      finishCb: function() {
        return OnboardingF.finishOnboardingTour(TOUR_STAGES.EDIT_ROUTE_STAGE.NAME);
      },
      skipCb: function() {
        OnboardingF.finishOnboarding();
        return OnboardingF.tours[REACTIVATE_TOOLTIPS_HINT].enabled = true;
      }
    };
    OnboardingF.tours[LIVE_ROUTE_HINTS] = {
      enabled: false,
      hasProgressBar: true,
      progressCount: 2,
      style: 'orange',
      showSkipButton: true,
      index: 0,
      steps: [
        {
          title: $translate.instant("ONBOARDING.LIVE_ROUTE_HINTS.STEP_1_TITLE"),
          description: $translate.instant("ONBOARDING.LIVE_ROUTE_HINTS.STEP_1_DESCRIPTION"),
          attachTo: ".onboarding-target-edit-switch",
          position: "top",
          bottom: null,
          xOffset: -320,
          arrowLeftOffset: '90%'
        }, {
          title: $translate.instant("ONBOARDING.LIVE_ROUTE_HINTS.STEP_2_TITLE"),
          description: $translate.instant("ONBOARDING.LIVE_ROUTE_HINTS.STEP_2_DESCRIPTION"),
          doneButtonText: $translate.instant("ONBOARDING.LIVE_ROUTE_HINTS.DONE_BUTTON"),
          attachTo: ".onboarding-target-report",
          position: "bottom",
          right: 60,
          arrowLeftOffset: '75%'
        }
      ],
      finishCb: function() {
        OnboardingF.finishOnboardingTour(TOUR_STAGES.LIVE_ROUTE_STAGE.NAME);
        OnboardingF.finishOnboarding();
        return OnboardingF.tours[REACTIVATE_TOOLTIPS_HINT].enabled = true;
      }
    };
    OnboardingF.tours[REACTIVATE_TOOLTIPS_HINT] = {
      enabled: false,
      hasProgressBar: false,
      style: 'orange',
      index: 0,
      showSkipButton: false,
      steps: [
        {
          description: $translate.instant("ONBOARDING.REACTIVATE_TOOLTIPS_HINT.STEP_1_DESCRIPTION"),
          doneButtonText: $translate.instant("ONBOARDING.REACTIVATE_TOOLTIPS_HINT.DONE_BUTTON"),
          attachTo: ".onboarding-target-tooltip-toggle",
          position: "right",
          left: 55,
          bottom: 186
        }
      ]
    };
    OnboardingF.tours[UNSCHEDULED_ROW_HINT] = {
      enabled: false,
      hasProgressBar: false,
      style: 'orange',
      index: 0,
      showSkipButton: false,
      steps: [
        {
          title: $translate.instant("ONBOARDING.UNSCHEDULED_ROW_HINT.STEP_1_TITLE"),
          description: $translate.instant("ONBOARDING.UNSCHEDULED_ROW_HINT.STEP_1_DESCRIPTION"),
          doneButtonText: $translate.instant("ONBOARDING.UNSCHEDULED_ROW_HINT.DONE_BUTTON"),
          attachTo: ".onboarding-target-auto-reschedule-btn",
          position: "top",
          arrowLeftOffset: '90%',
          xOffset: -300
        }
      ],
      finishCb: function() {
        return OnboardingF.finishOnboardingTour(TOUR_STAGES.UNSCHEDULED_ROW_STAGE.NAME);
      }
    };
    OnboardingF.inProgress = false;
    OnboardingF.startOnboarding = function() {
      OnboardingF.inProgress = true;
      AnalyticsS.track_force("Onboarding - Start");
      AccountF.updateSettings({
        betaOnboardingStarted: true,
        betaOnboardingDone: false
      });
      _setOnboardingCookie(BETA_ONBOARDING_STARTED, true);
      _setOnboardingCookie(BETA_ONBOARDING_DONE, false);
      return OnboardingF.startTourForState(States.projectDriversList);
    };
    OnboardingF.finishOnboarding = function(sendEvent) {
      if (sendEvent == null) {
        sendEvent = true;
      }
      OnboardingF.disableAllTours();
      OnboardingF.inProgress = false;
      if (sendEvent) {
        AnalyticsS.track_force("Onboarding - End");
      }
      AccountF.updateSettings({
        betaOnboardingDone: true
      });
      return _setOnboardingCookie(BETA_ONBOARDING_DONE, true);
    };
    OnboardingF.isDone = function() {
      var _ref;
      var cookie = _getOnboardingCookie(BETA_ONBOARDING_DONE);
      return ((_ref = AccountF.getUser().settings) != null ? _ref.betaOnboardingDone : void 0) || ((cookie != null) && JSON.parse(cookie));
    };
    OnboardingF.wasStarted = function() {
      var _ref;
      var cookie = _getOnboardingCookie(BETA_ONBOARDING_STARTED);
      return ((_ref = AccountF.getUser().settings) != null ? _ref.betaOnboardingStarted : void 0) || ((cookie != null) && JSON.parse(cookie));
    };
    OnboardingF.setOnboarding = function(value) {
      var tourName, updates, _i, _j, _len, _len1;
      var toolTipTours = [TOUR_STAGES.PLAN_ROUTE_STAGE.NAME, TOUR_STAGES.EDIT_ROUTE_STAGE.NAME, TOUR_STAGES.LIVE_ROUTE_STAGE.NAME, TOUR_STAGES.INPUT_STAGE.NAME, TOUR_STAGES.UNSCHEDULED_ROW_STAGE.NAME];
      updates = {};
      if (value) {
        OnboardingF.startOnboarding();
        for (_i = 0, _len = toolTipTours.length; _i < _len; _i++) {
          tourName = toolTipTours[_i];
          OnboardingF.reStartOnboardingTour(tourName, false);
          updates[tourName + "Done"] = false;
        }
        AccountF.updateSettings(updates);
        OnboardingF.startTourForState($state.current.name);
        return AnalyticsS.track_force('007 Restart onboarding');
      } else {
        OnboardingF.finishOnboarding();
        for (_j = 0, _len1 = toolTipTours.length; _j < _len1; _j++) {
          tourName = toolTipTours[_j];
          OnboardingF.finishOnboardingTour(tourName, false);
          updates[tourName + "Done"] = true;
        }
        return AccountF.updateSettings(updates);
      }
    };
    OnboardingF.toggleOnboarding = function() {
      return OnboardingF.setOnboarding(OnboardingF.isDone());
    };
    OnboardingF.finishOnboardingTour = function(tourName, sendUpdates) {
      var tourDoneStr, update;
      if (sendUpdates == null) {
        sendUpdates = true;
      }
      tourDoneStr = tourName + 'Done';
      if (sendUpdates) {
        update = {};
        update[tourDoneStr] = true;
        AccountF.updateSettings(update);
      }
      return _setOnboardingCookie(tourDoneStr, true);
    };
    OnboardingF.reStartOnboardingTour = function(tourName, sendUpdates) {
      var tourDoneStr, update;
      if (sendUpdates == null) {
        sendUpdates = true;
      }
      tourDoneStr = tourName + 'Done';
      if (sendUpdates) {
        update = {};
        update[tourDoneStr] = false;
        AccountF.updateSettings(update);
      }
      return _setOnboardingCookie(tourDoneStr, false);
    };
    OnboardingF.startTourForState = function(stateName) {
      var hasDrivers, hasInvalidDrivers, hasInvalidVisits, hasVisits, planRouteStageDone, toursForState, _ref, _ref1, _ref2, _ref3;
      if (!OnboardingF.wasStarted()) {
        return;
      }
      toursForState = _getTourNamesForState(stateName);
      if (_areOnboardingToursDone(toursForState)) {
        return;
      }
      hasDrivers = ((_ref = DriverF.getValidDrivers()) != null ? _ref.length : void 0) > 0;
      hasVisits = ((_ref1 = VisitF.getValidVisits()) != null ? _ref1.length : void 0) > 0;
      hasInvalidDrivers = ((_ref2 = DriverF.getInvalidDrivers()) != null ? _ref2.length : void 0) > 0;
      hasInvalidVisits = ((_ref3 = VisitF.getInvalidVisits()) != null ? _ref3.length : void 0) > 0;
      switch (stateName) {
        case States.projectDriversList:
          if (hasInvalidDrivers) {
            return;
          }
          if (hasVisits && hasDrivers && !hasInvalidVisits) {
            return _enableOnboardingTour(READY_TO_OPTIMIZE);
          } else if (hasDrivers) {
            return _enableOnboardingTourCompletionState(NEW_DRIVER_SPEC);
          } else {
            return _enableOnboardingTourListItem(NEW_DRIVER_SPEC, 2);
          }
          break;
        case States.projectDriversUpload:
          if (!hasDrivers && !hasInvalidDrivers) {
            return _enableOnboardingTourListItem(NEW_DRIVER_SPEC, 2);
          } else {
            return OnboardingF.disableAllTours();
          }
          break;
        case States.projectVisitsList:
          if (hasInvalidVisits) {
            return;
          }
          if (hasVisits && hasDrivers && !hasInvalidDrivers) {
            return _enableOnboardingTour(READY_TO_OPTIMIZE);
          } else if (hasVisits) {
            return _enableOnboardingTourCompletionState(NEW_VISIT_SPEC);
          } else {
            return _enableOnboardingTourListItem(NEW_VISIT_SPEC, 2);
          }
          break;
        case States.projectVisitsUpload:
          if (!hasVisits && !hasInvalidVisits) {
            return _enableOnboardingTourListItem(NEW_VISIT_SPEC, 2);
          } else {
            return OnboardingF.disableAllTours();
          }
          break;
        case States.projectRoutePlan:
          planRouteStageDone = _isOnboardingTourDone(TOUR_STAGES.PLAN_ROUTE_STAGE.NAME);
          if (RouteS.hasUnserved() && planRouteStageDone) {
            return _enableOnboardingTour(UNSCHEDULED_ROW_HINT);
          } else if (!planRouteStageDone) {
            return _enableOnboardingTour(PLAN_ROUTE_HINTS);
          }
          break;
        case States.projectRouteEdit:
          if (!DispatchStatusF.hasDispatches()) {
            return;
          }
          if (ProjectF.isToday() || !AccountF.hasLiveTracking()) {
            OnboardingF.tours[EDIT_ROUTE_HINTS].steps[1].showBackButton = false;
            _enableOnboardingTour(EDIT_ROUTE_HINTS);
            return _changeStepIndex(EDIT_ROUTE_HINTS, 1);
          } else if (ProjectF.isInFuture()) {
            OnboardingF.tours[EDIT_ROUTE_HINTS].steps[1].showBackButton = true;
            _enableOnboardingTour(EDIT_ROUTE_HINTS);
            return _changeStepIndex(EDIT_ROUTE_HINTS, 0);
          }
          break;
        case States.projectRouteLive:
          return _enableOnboardingTour(LIVE_ROUTE_HINTS);
        default:
          return OnboardingF.disableAllTours();
      }
    };
    OnboardingF.disableAllTours = function() {
      var key, tour, _ref, _results;
      _ref = OnboardingF.tours;
      _results = [];
      for (key in _ref) {
        tour = _ref[key];
        _results.push(tour.enabled = false);
      }
      return _results;
    };
    OnboardingF.skipTour = function() {
      AnalyticsS.track_force("Onboarding - Skip");
      return OnboardingF.finishOnboarding(false);
    };
    return OnboardingF;
  };
  OnboardingF.$inject = ["$rootScope", "$kookies", "$state", "$translate", "VisitF", "VisitUploadF", "DriverF", "MarkersF", "DriverMarker", "DemoDataC", "AnalyticsS", "AccountF", "States", "EventListenersF", "Events", "ProjectF", "RouteS", "DispatchStatusF"];

  angular.module('app').factory('OnboardingF', OnboardingF);

}).call(this);

(function() {
  var OptInBetaC = function($window, $http, AccountF, Constants, $kookies, AnalyticsS, MessagingF, LoggerF) {
    this.isLoading = false;
    this.optIn = function() {
      var authHeader;
      this.isLoading = true;
      AnalyticsS.track('113 Intent to opt in beta');
      authHeader = AccountF.getAuthHeader();
      return $http.put("" + Constants.apiPath + "/product/v3-optin", {}, authHeader).then(function(res) {
        var _ref, _ref1;
        AnalyticsS.track('114 Opt in beta');
        AccountF.setBetaUserToken(res != null ? (_ref = res.data) != null ? _ref.v3_token : void 0 : void 0);
        if ((_ref1 = res.data) != null ? _ref1.v3_token : void 0) {
          return AccountF.goToBeta();
        }
      })["catch"](function(err) {
        LoggerF.error(LoggerF.ACTIONS.OPTIN_BETA, void 0, err);
        return MessagingF.replaceErrorPopup("Something went wrong. Please try again in a few minutes.");
      })["finally"]((function(_this) {
        return function() {
          return _this.isLoading = false;
        };
      })(this));
    };
  };
  OptInBetaC.$inject = ["$window", "$http", "AccountF", "Constants", "$kookies", "AnalyticsS", "MessagingF", "LoggerF"];

  angular.module('app').controller('OptInBetaC', OptInBetaC);

}).call(this);

(function() {
  var GPolylineF = function() {
    var _gPolylines;
    _gPolylines = {};
    GPolylineF = {};
    GPolylineF.add = function(id, polyline) {
      if (!id) {
        throw new Error("id must be defined");
      }
      if (!polyline) {
        throw new Error("polyline must be defined");
      }
      return _gPolylines[id] = polyline;
    };
    GPolylineF.destroy = function(id) {
      if (!_gPolylines[id]) {
        return false;
      }
      _gPolylines[id].setMap(null);
      delete _gPolylines[id];
      return true;
    };
    GPolylineF.destroyAll = function() {
      var id;
      for (id in _gPolylines) {
        GPolylineF.destroy(id);
      }
    };
    GPolylineF.setVisible = function(id, isVisible) {
      if (!_gPolylines[id]) {
        return false;
      }
      _gPolylines[id].setVisible(isVisible);
      return true;
    };

    return GPolylineF;
  };

  angular.module('app').factory('GPolylineF', GPolylineF);

}).call(this);

(function() {
  var ProgressBarF = function($interval, ngProgressLite, RouteUtil) {
    var INTERVAL_TIME, STARTING_INC, _cancelProgress, _progressBarInterval;
    STARTING_INC = 0.1;
    INTERVAL_TIME = 500;
    _progressBarInterval = null;
    _cancelProgress = function() {
      if (_progressBarInterval) {
        $interval.cancel(_progressBarInterval);
        return _progressBarInterval = null;
      }
    };
    ProgressBarF = {};
    ProgressBarF.start = function(numVisits) {
      var incrementCount, intervalInc, processingTime;
      ProgressBarF.reset();
      processingTime = RouteUtil.calculateProcessingTime(numVisits);
      incrementCount = processingTime / INTERVAL_TIME;
      intervalInc = (1 - STARTING_INC) / incrementCount;
      ngProgressLite.set(STARTING_INC);
      _progressBarInterval = $interval(function() {
        var currentProgress = ngProgressLite.get();
        return ngProgressLite.inc(intervalInc / (currentProgress * 10));
      }, INTERVAL_TIME);
    };
    ProgressBarF.reset = function() {
      _cancelProgress();
      if (ngProgressLite.get() > 0) {
        return ngProgressLite.set(0);
      }
    };
    ProgressBarF.done = function() {
      _cancelProgress();
      return ngProgressLite.done();
    };
    return ProgressBarF;
  };
  ProgressBarF.$inject = ["$interval", "ngProgressLite", "RouteUtil"];

  angular.module('app').factory('ProgressBarF', ProgressBarF);

}).call(this);

(function() {
  var ProjectEndDayC = function(States, ProjectF, DispatchStatusF, AccountF) {
    var project;
    this.states = States;
    project = ProjectF.project;
    this.name = project.name;
    this.date = project.date;
    return this.isReportAvailable = DispatchStatusF.hasDispatches() && AccountF.hasLiveTracking();
  };
  ProjectEndDayC.$inject = ["States", "ProjectF", "DispatchStatusF", "AccountF"];

  angular.module('app').controller('ProjectEndDayC', ProjectEndDayC);

}).call(this);

(function() {
  var ProjectF = function($q, $kookies, $http, $state, $translate, $window, Constants, AccountF, DriverF, VisitF, DriverUtil, RouteS, TimeUtilF, RouteUtil, EventListenersF, Events, SettingsF, VisitCsvHeaderF, DispatchStatusF, DispatchF, RouteHistoryF, NotificationF, States, ProjectTimezoneF, ProjectsUtil, MessagingF, ConfirmF, AnalyticsS, SessionF, LoggerF, StoredDriverF) {
    var INVALID_PROJECT_DATE_ERROR, MISSING_PROJECT_DATE_ERROR, MISSING_PROJECT_NAME_ERROR, NO_PROJECT_OPEN_ERROR, OLD_TEMP_PROJECT_DATE, OLD_TEMP_PROJECT_NAME, PROJECT_BUSY_ERROR, PROJECT_BUSY_MESSAGE, PROJECT_VERSION_MISMATCH, _filterSolutionFleet, _formatSolution, _formatVisit, _getValidVisitsCountFromSolution, _initEventListeners, _isCurrentProject, _isTempProject, _jsonSizeInBytes, _parseSolution, _parseVisit, _removeDispatchInfoFromSolution, _removeFleetErrorAndStatus, _replaceProjectData, _retrieveProject, _setError, _toArray, _trackProjectDriverCount, _updateProjectDetail;
    MISSING_PROJECT_NAME_ERROR = $q.reject(new Error("Missing project name"));
    MISSING_PROJECT_DATE_ERROR = $q.reject(new Error("Missing project date"));
    INVALID_PROJECT_DATE_ERROR = $q.reject(new Error("Invalid project date"));
    NO_PROJECT_OPEN_ERROR = $q.reject(new Error("No project is opened"));
    PROJECT_BUSY_MESSAGE = "Project is busy. Please try again later.";
    PROJECT_BUSY_ERROR = $q.reject(new Error(PROJECT_BUSY_MESSAGE));
    OLD_TEMP_PROJECT_DATE = TimeUtilF.toString(new Date(0));
    OLD_TEMP_PROJECT_NAME = "(UNTITLED)";
    PROJECT_VERSION_MISMATCH = 409;
    _isTempProject = function(project) {
      var isOldTempDate, isTempName;
      isTempName = project.name === OLD_TEMP_PROJECT_NAME;
      isOldTempDate = project.date === OLD_TEMP_PROJECT_DATE;
      return isTempName || isOldTempDate;
    };
    _formatVisit = function(entry) {
      var visit;
      if (!(entry && Object.keys(entry).length > 0)) {
        return;
      }
      visit = _.pick(entry, 'id', 'name', 'duration', 'location', 'startDate', 'endDate', 'load', 'phone', 'types', 'notes', 'notes2', 'status', 'error', 'email', 'isPriority', 'customNotes', 'createdAt', 'pick_up_form');
      if (visit.startDate) {
        visit.start = TimeUtilF.convertDateToTime(visit.startDate);
      }
      if (visit.endDate) {
        visit.end = TimeUtilF.convertDateToTime(visit.endDate);
      }
      return visit;
    };
    _formatSolution = function(entry) {
      var current, id, message, routes, sentTimes, solution, time, unserved, _ref, _ref1;
      if (!(entry && Object.keys(entry).length > 0)) {
        return;
      }
      solution = _.pick(entry, 'distances', 'num_visits', 'pl_precision', 'polylines', 'total_distance', 'total_idle_time', 'total_travel_time', 'settings', 'dispatches', 'jobId');
      routes = [];
      _ref = entry.solution;
      for (id in _ref) {
        current = _ref[id];
        if (current instanceof Array) {
          routes.push({
            _id: id,
            isLocked: !!entry.routeLocks[id],
            visits: RouteUtil.formatRoute(current),
            routeId: entry.routeIdMap[id]
          });
        }
      }
      solution.routes = routes;
      if (solution.dispatches) {
        sentTimes = DispatchStatusF.getSentTimes();
        for (id in sentTimes) {
          time = sentTimes[id];
          solution.dispatches[id].sentTime = time;
        }
      }
      unserved = {};
      if (entry.unserved) {
        _ref1 = entry.unserved;
        for (id in _ref1) {
          current = _ref1[id];
          if (typeof current.error === 'string') {
            message = current.error;
          } else {
            message = Constants.unservedMessages.constraints;
          }
          unserved[id] = message;
        }
      }
      solution.unserved = unserved;
      return solution;
    };
    _removeDispatchInfoFromSolution = function(solution) {
      var dispatch, id, route, _i, _len, _ref, _ref1, _results;
      if (solution != null) {
        if (solution.dispatches != null) {
          _ref = solution.dispatches;
          for (id in _ref) {
            dispatch = _ref[id];
            delete dispatch.sentTime;
            dispatch.isDirty = true;
          }
        }
        _ref1 = solution.routes;
        _results = [];
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          route = _ref1[_i];
          if (route.isDirty != null) {
            _results.push(delete route.isDirty);
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      }
    };
    _removeFleetErrorAndStatus = function(fleet) {
      var id, newFleet, veh;
      newFleet = _.cloneDeep(fleet);
      for (id in newFleet) {
        veh = newFleet[id];
        delete veh.status;
        delete veh.error;
      }
      return newFleet;
    };
    _retrieveProject = function() {
      var driver, drivers, serialized, settings, solution, visit, visits, _fn, _i, _j, _len, _len1, _ref, _ref1;
      drivers = {};
      _ref = DriverF.getDrivers();
      _fn = function(driver) {
        var entry = DriverUtil.formatDriverMarker(driver);
        return drivers[driver.id] = entry;
      };
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        driver = _ref[_i];
        _fn(driver);
      }
      visits = {};
      _ref1 = VisitF.getVisits();
      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
        visit = _ref1[_j];
        serialized = _formatVisit(visit);
        visits[serialized.id] = serialized;
      }
      solution = _formatSolution(RouteS.getRoute());
      settings = SettingsF.settings;
      if (Object.keys(drivers).length === 0) {
        drivers = null;
      }
      return {
        fleet: drivers,
        visits: visits,
        solution: solution,
        settings: settings
      };
    };
    _toArray = function(obj) {
      var id, newVal, val;
      var array = [];
      for (id in obj) {
        val = obj[id];
        newVal = _.cloneDeep(val);
        newVal._id = id;
        array.push(newVal);
      }
      return array;
    };
    _updateProjectDetail = function(project) {
      ProjectF.project || (ProjectF.project = {});
      ProjectF.project.id = project._id;
      ProjectF.project.name = project.name;
      ProjectF.project.status = project.status;
      ProjectF.project.date = project.date;
      ProjectF.project.updateTime = project.updateTime;
      ProjectF.project.isLocked = project.isLocked;
      ProjectF.project.isDemo = project.isDemo;
      ProjectF.project.version = project.version;
      return ProjectF.project.jobId = project.jobId;
    };
    _setError = function(error) {
      return ProjectF.project.error = error;
    };
    _parseVisit = function(entry) {
      var visit = _.cloneDeep(entry);
      if (visit.start) {
        visit.startDate = TimeUtilF.convertTimeToDate(visit.start);
      }
      if (visit.end) {
        visit.endDate = TimeUtilF.convertTimeToDate(visit.end);
      }
      return visit;
    };
    _parseSolution = function(entry) {
      var current, id, message, routeIdMap, routeLocks, solution, unserved, _i, _len, _ref, _ref1;
      if (!entry) {
        return;
      }
      solution = {};
      routeLocks = {};
      routeIdMap = {};
      _ref = entry.routes;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        current = _ref[_i];
        solution[current._id] = RouteUtil.parseRoute(current.visits);
        routeLocks[current._id] = !!current.isLocked;
        routeIdMap[current._id] = current.routeId;
      }
      entry.solution = solution;
      entry.num_unserved = Object.keys(entry.unserved || {}).length;
      entry.routeLocks = routeLocks;
      entry.routeIdMap = routeIdMap;
      unserved = {};
      _ref1 = entry.unserved;
      for (id in _ref1) {
        current = _ref1[id];
        if (typeof current === 'string') {
          message = current;
        } else if (current.error && (typeof current.error) === 'string') {
          message = current.error;
        } else {
          message = Constants.unservedMessages.constraints;
        }
        unserved[id] = message;
      }
      entry.unserved = unserved;
      return entry;
    };
    _filterSolutionFleet = function(solution, fleet) {
      var filtered, fleetsUsed, vehicleId, _i, _len, _ref;
      fleetsUsed = {};
      _ref = Object.keys(solution);
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        vehicleId = _ref[_i];
        fleetsUsed[vehicleId] = true;
      }
      filtered = _.filter(fleet, function(vehicle) {
        return fleetsUsed[vehicle.id];
      });
      return filtered;
    };
    _isCurrentProject = function(id) {
      var _ref;
      return ((_ref = ProjectF.project) != null ? _ref.id : void 0) === id;
    };
    _trackProjectDriverCount = function(projects) {
      var totaldrivers = projects.reduce((function(accumulator, proj) {
        return Math.max(accumulator, proj.vehicleCount);
      }), 0);
      return AnalyticsS.set({
        "Max Driver Profiles": totaldrivers
      });
    };
    _initEventListeners = function() {
      EventListenersF.addEventListener(Events.VERIFIED_VISIT_STATUS_UPDATE, function(update) {
        return ProjectF.reloadSolution();
      });
      EventListenersF.addEventListener(Events.PROJECT_MODIFIED, function(setDispatchedSolution) {
        var promise;
        if (setDispatchedSolution == null) {
          setDispatchedSolution = false;
        }
        if (ProjectF.isBusy) {
          return PROJECT_BUSY_ERROR;
        }
        promise = ProjectF.update(ProjectF.project.name, ProjectF.project.date, setDispatchedSolution);
        EventListenersF.notify(Events.PROJECT_BUSY);
        ProjectF.isBusy = true;
        return promise;
      });
      EventListenersF.addEventListener(Events.PROJECT_UPDATE_FINISHED, function() {
        ProjectF.isBusy = false;
        return EventListenersF.notify(Events.PROJECT_NOT_BUSY);
      });
      EventListenersF.addEventListener(Events.PROJECT_VERSION_MISMATCH, function() {
        ConfirmF.projectVersionMismatch().then(function() {
          ProjectF.isBusy = false;
          return ProjectF.reloadProject().then(function() {
            MessagingF.replaceSuccessPopup("MESSAGES.PROJECT_UP_TO_DATE");
            return EventListenersF.notify(Events.PROJECT_NOT_BUSY);
          })["catch"](function(err) {
            var payload = {
              project_id: ProjectF.project.id,
              client_version: ProjectF.project.version
            };
            LoggerF.error(LoggerF.ACTIONS.VALIDATED_PROJECT_VERSION, payload, err);
            return $q.reject(err);
          });
        });
      });
      EventListenersF.addEventListener(Events.CSV_UPLOAD_IN_PROGRESS, function() {
        ProjectF.isBusy = true;
        return EventListenersF.notify(Events.PROJECT_BUSY);
      });
      EventListenersF.addEventListener(Events.CSV_UPLOAD_COMPLETED, function() {
        ProjectF.isBusy = false;
        return EventListenersF.notify(Events.PROJECT_NOT_BUSY);
      });
      EventListenersF.addEventListener(Events.SESSION_COUNT_UPDATE, (function(_this) {
        return function(data) {
          return ProjectF.numParallelSessions = data.count;
        };
      })(this));
      EventListenersF.addEventListener(Events.SESSION_PROJECT_UPDATED, function(updateEvent) {
        if (ProjectF.numParallelSessions <= 0 && updateEvent.sessionId !== 'api') {
          return;
        }
        if (ProjectF.isBusy) {
          return;
        }
        if (updateEvent.session_id !== SessionF.getSessionId()) {
          EventListenersF.notify(Events.PROJECT_UPDATING_STARTED);
          AnalyticsS.track('0005_WEB_UI project updated in another session');
          if (ConfirmF.isDialogOpen()) {
            ConfirmF.closeConfirm();
          }
          ProjectF.isBusy = false;
          return ProjectF.reloadProject().then(function() {
            MessagingF.replaceInfoPopup("MESSAGES.SESSION_UPDATED");
            EventListenersF.notify(Events.PROJECT_UPDATING_ENDED);
            return EventListenersF.notify(Events.UPDATE_LASSO_SELECTION);
          })["catch"](function(err) {
            var payload = {
              project_id: ProjectF.project.id,
              client_version: ProjectF.project.version
            };
            LoggerF.error(LoggerF.ACTIONS.SESSION_PROJECT_UPDATED, payload, err);
            return $q.reject(err);
          });
        }
      });
      EventListenersF.addEventListener(Events.STOPS_ADD_SUCCESS, (function(_this) {
        return function(msg) {
          var _ref;
          if ((msg != null ? msg.project_id : void 0) === ((_ref = ProjectF.project) != null ? _ref.id : void 0)) {
            return ProjectF.reloadProject().then(function() {
              return MessagingF.replaceSuccessPopup("MESSAGES.NEW_STOPS_ADDED");
            })["catch"](function(err) {
              var payload = {
                project_id: ProjectF.project.id,
                client_version: ProjectF.project.version
              };
              LoggerF.error(LoggerF.ACTIONS.SESSION_STOPS_ADDED, payload, err);
              return $q.reject(err);
            });
          }
        };
      })(this));
      EventListenersF.addEventListener(Events.STOPS_GEOCODE_SUCCESS, (function(_this) {
        return function(msg) {
          var _ref;
          if ((msg != null ? msg.project_id : void 0) === ((_ref = ProjectF.project) != null ? _ref.id : void 0)) {
            return ProjectF.reloadProject().then(function() {
              return MessagingF.replaceSuccessPopup("MESSAGES.NEW_STOPS_ADDED");
            })["catch"](function(err) {
              var payload = {
                project_id: ProjectF.project.id,
                client_version: ProjectF.project.version
              };
              LoggerF.error(LoggerF.ACTIONS.SESSION_STOPS_GEOCODE_SUCCESS, payload, err);
              return $q.reject(err);
            });
          }
        };
      })(this));
      EventListenersF.addEventListener(Events.STOPS_GEOCODE_ERROR, (function(_this) {
        return function(msg) {
          var _ref;
          if ((msg != null ? msg.project_id : void 0) === ((_ref = ProjectF.project) != null ? _ref.id : void 0)) {
            return ProjectF.reloadProject().then(function() {
              return $state.go(States.projectVisitsList);
            })["catch"](function(err) {
              var payload = {
                project_id: ProjectF.project.id,
                client_version: ProjectF.project.version
              };
              LoggerF.error(LoggerF.ACTIONS.SESSION_STOPS_GEOCODE_ERROR, payload, err);
              return $q.reject(err);
            });
          }
        };
      })(this));
      return EventListenersF.addEventListener(Events.SESSION_PROJECT_DELETED, function(_arg) {
        var project_id;
        project_id = _arg.project_id;
        if (_isCurrentProject(project_id)) {
          ProjectF.clear(true);
          _updateProjectDetail({});
          return $state.go(States.projects).then(function() {
            return MessagingF.topWarningPopup("MESSAGES.PROJECT_DELETED");
          });
        }
      });
    };
    ProjectF = {};
    ProjectF.numParallelSessions = 0;
    ProjectF.project = {};
    ProjectF.isBusy = false;
    ProjectF.getProjectTempInfo = function() {
      var today = new Date();
      return {
        date: today,
        name: TimeUtilF.toMonthDate(today)
      };
    };
    ProjectF.incrementVersion = function() {
      var _ref, _ref1;
      if (((_ref = ProjectF.project) != null ? _ref.version : void 0) != null) {
        ProjectF.project.version += 1;
      }
      return (_ref1 = ProjectF.project) != null ? _ref1.version : void 0;
    };
    ProjectF.fetch = function(projectId) {
      var header = AccountF.getAuthHeader();
      return $http.get("" + Constants.apiPath + "/product/projects/" + projectId, header).then(function(res) {
        return res.data;
      });
    };
    ProjectF.checkProjectVersion = function() {
      var header;
      if (!ProjectF.project.id) {
        return $q.reject(new Error('Project not loaded'));
      }
      if (ProjectF.project.version == null) {
        return $q.when();
      }
      header = AccountF.getAuthHeader();
      return $http.get("" + Constants.apiPath + "/product/projects/" + ProjectF.project.id + "/version", header).then(function(res) {
        return {
          isCurrentVersion: res.data.version === ProjectF.project.version,
          clientVersion: ProjectF.project.version,
          serverVersion: res.data.version
        };
      })["catch"](function(err) {
        var payload = {
          project_id: ProjectF.project.id,
          client_version: ProjectF.project.version
        };
        LoggerF.error(LoggerF.ACTIONS.CHECK_PROJECT_VERSION, payload, err);
        return $q.reject(err);
      });
    };
    ProjectF.clear = function(keepDrivers) {
      if (keepDrivers == null) {
        keepDrivers = false;
      }
      if (ProjectF.isBusy) {
        return PROJECT_BUSY_ERROR;
      }
      RouteS.clear();
      VisitF.clear();
      DispatchF.clear();
      DispatchStatusF.clearSentTimes();
      NotificationF.clearNotifications();
      if (!keepDrivers) {
        return DriverF.clear();
      }
    };
    ProjectF.isOngoing = function() {
      var extraDays, projectDate, projectEndDate, today, _ref, _ref1;
      today = TimeUtilF.toString(new Date());
      extraDays = RouteS.getExtraDays();
      projectDate = TimeUtilF.convertDateToUTC(new Date((_ref = ProjectF.project) != null ? _ref.date : void 0));
      projectEndDate = TimeUtilF.toString(TimeUtilF.addDays(projectDate, extraDays));
      return today >= ((_ref1 = ProjectF.project) != null ? _ref1.date : void 0) && today <= projectEndDate;
    };
    ProjectF.isInFuture = function() {
      var _ref;
      var today = TimeUtilF.toString(new Date());
      return today < ((_ref = ProjectF.project) != null ? _ref.date : void 0);
    };
    ProjectF.isToday = function() {
      var _ref;
      var today = TimeUtilF.toString(new Date());
      return today === ((_ref = ProjectF.project) != null ? _ref.date : void 0);
    };
    ProjectF.reloadSolution = function() {
      var authHeader, id, _ref;
      id = (_ref = ProjectF.project) != null ? _ref.id : void 0;
      if (!id) {
        return;
      }
      if (ProjectF.isBusy) {
        return PROJECT_BUSY_ERROR;
      }
      authHeader = AccountF.getAuthHeader();
      return $http.post("" + Constants.apiPath + "/product/projects/" + id + "/load", {}, authHeader).then(function(res) {
        var currentSolution, currentSolutionFleet, dispatchedSolution, dispatchedSolutionFleet, fleet, project, promises, visits;
        promises = [];
        project = res.data;
        ProjectTimezoneF.setProjectTimezone(project.timezone);
        if (project.solution) {
          fleet = DriverF.getDrivers();
          visits = VisitF.getVisits();
          RouteHistoryF.clear();
          if (project.isSolutionDirty && (project.dispatchedSolution != null)) {
            dispatchedSolution = _parseSolution(project.dispatchedSolution);
            dispatchedSolutionFleet = _filterSolutionFleet(dispatchedSolution.solution, fleet);
            RouteS.replace(dispatchedSolution, visits, dispatchedSolutionFleet);
          }
          currentSolution = _parseSolution(project.solution);
          currentSolutionFleet = _filterSolutionFleet(currentSolution.solution, fleet);
          RouteS.replace(currentSolution, visits, currentSolutionFleet);
          _updateProjectDetail(project);
          return LoggerF.updateProjectId(project._id);
        }
      })["catch"](function(err) {
        _setError(err.data || err.message);
        return $q.reject(err.data);
      });
    };
    _replaceProjectData = function(project) {
      var fleet, tempInfo;
      ProjectTimezoneF.setProjectTimezone(project.timezone);
      if (_isTempProject(project)) {
        tempInfo = ProjectF.getProjectTempInfo();
        project.date = TimeUtilF.toString(tempInfo.date);
        project.name = tempInfo.name;
      }
      fleet = _toArray(project.fleet);
      StoredDriverF.init(fleet);
      return DriverF.replace(fleet).then(function(newDrivers) {
        var array, visit, visits;
        fleet = newDrivers;
        array = _toArray(project.visits);
        visits = (function() {
          var _i, _len, _results;
          _results = [];
          for (_i = 0, _len = array.length; _i < _len; _i++) {
            visit = array[_i];
            _results.push(_parseVisit(visit));
          }
          return _results;
        })();
        return VisitF.replace(visits);
      }).then(function(newVisits) {
        var dispatchedSolution, solution, solutionFleet, visits;
        visits = newVisits;
        VisitCsvHeaderF.initializeColumns(visits);
        RouteS.clear();
        if ((project.dispatchedSolution != null) && project.isSolutionDirty) {
          dispatchedSolution = _parseSolution(project.dispatchedSolution);
          solutionFleet = _filterSolutionFleet(dispatchedSolution.solution, fleet);
          RouteS.replace(dispatchedSolution, visits, solutionFleet);
        }
        if (project.solution) {
          solution = _parseSolution(project.solution);
          solutionFleet = _filterSolutionFleet(solution.solution, fleet);
          RouteS.replace(solution, visits, solutionFleet);
          if (solution.dispatches != null) {
            DispatchStatusF.load(RouteS.getRoute(), solution.dispatches);
          } else {
            DispatchStatusF.resetDispatchStatus(RouteS.getRoute());
            DispatchStatusF.clearSentTimes();
          }
        }
        if (project.settings) {
          SettingsF.replace(project.settings);
        }
        DispatchF.initialize(fleet);
        if (DispatchStatusF.hasDispatches()) {
          DispatchF.getProjectRoutes(project._id).then(function(res) {
            var dispatches = res;
            if (dispatches) {
              return DispatchF.replace(dispatches);
            }
          });
        }
        _updateProjectDetail(project);
        return project;
      });
    };
    _jsonSizeInBytes = function(obj) {
      var jsonString = JSON.stringify(obj);
      return ~-encodeURI(jsonString).split(/%..|./).length;
    };
    _getValidVisitsCountFromSolution = function(project) {
      var count, routes, _ref;
      routes = (_ref = project.solution) != null ? _ref.routes : void 0;
      count = 0;
      if (routes != null) {
        routes.forEach(function(route) {
          return route.visits.forEach(function(visit) {
            var _ref1;
            if ((((_ref1 = visit.location) != null ? _ref1.id : void 0) != null) && (visit.finish_time != null)) {
              return count++;
            }
          });
        });
      }
      return count;
    };
    ProjectF.load = function(id) {
      var authHeader;
      if (!id) {
        return;
      }
      if (ProjectF.isBusy) {
        return PROJECT_BUSY_ERROR;
      }
      if (typeof analytics !== "undefined" && analytics !== null) {
        analytics.ready(function() {
          return typeof analytics !== "undefined" && analytics !== null ? analytics.track('Project loaded', {
            project_id: id
          }) : void 0;
        });
      }
      authHeader = AccountF.getAuthHeader();
      return $http.post("" + Constants.apiPath + "/product/projects/" + id + "/load", {}, authHeader).then(function(res) {
        return _replaceProjectData(res.data);
      }).then(function(project) {
        var comingFromDemo, countUnserved, countValidVisits, visitCount;
        EventListenersF.notify(Events.PROJECT_LOADED, {
          projectId: project._id
        });
        LoggerF.updateProjectId(project._id);
        LoggerF.info(LoggerF.ACTIONS.LOADED_PROJECT);
        visitCount = project.visits != null ? Object.keys(project.visits).length : 0;
        if (project.solution != null) {
          countValidVisits = _getValidVisitsCountFromSolution(project);
          countUnserved = Object.keys(project.solution.unserved).length;
          if ((countUnserved + countValidVisits) !== visitCount) {
            LoggerF.error(LoggerF.ACTIONS.LOADED_PROJECT, {
              inconsistentVisitCount: true,
              visitCount: visitCount,
              solutionValidVisitCount: countValidVisits,
              solutionUnservedCount: countUnserved
            });
          }
        }
        comingFromDemo = void 0;
        if (!AccountF.isDemoFinished()) {
          comingFromDemo = true;
          AccountF.updateSettings({
            demoFinished: true
          });
        }
        if (comingFromDemo) {
          EventListenersF.notify(Events.DEMO_FINISHED);
        }
        return project;
      })["catch"](function(err) {
        _setError(err.data || err.message);
        EventListenersF.notify(Events.PROJECT_LOAD_ERROR);
        return $q.reject(err.data);
      });
    };
    ProjectF.reloadProject = function() {
      var authHeader, projectId;
      if (ProjectF.isBusy) {
        return PROJECT_BUSY_ERROR;
      }
      projectId = ProjectF.project.id;
      authHeader = AccountF.getAuthHeader();
      if (typeof analytics !== "undefined" && analytics !== null) {
        analytics.ready(function() {
          return typeof analytics !== "undefined" && analytics !== null ? analytics.track('Project reloaded', {
            project_id: id
          }) : void 0;
        });
      }
      return ProjectF.clear().then(function() {
        return $http.get("" + Constants.apiPath + "/product/projects/" + projectId, authHeader);
      }).then(function(res) {
        return _replaceProjectData(res.data);
      }).then(function(project) {
        if (!DispatchStatusF.hasDispatches()) {
          EventListenersF.notify(Events.DISPATCHES_UPDATED);
        }
        EventListenersF.notify(Events.PROJECT_RELOADED, {
          projectId: projectId
        });
        LoggerF.info(LoggerF.ACTIONS.RELOADED_PROJECT);
        return project;
      })["catch"](function(err) {
        _setError(err.data || err.message);
        EventListenersF.notify(Events.PROJECT_RELOAD_ERROR);
        return $q.reject(err.data);
      });
    };
    ProjectF.previewProject = function(projectId) {
      var authHeader;
      if (ProjectF.isBusy) {
        return PROJECT_BUSY_ERROR;
      }
      authHeader = AccountF.getAuthHeader();
      return $http.get("" + Constants.apiPath + "/product/projects/" + projectId, authHeader).then(function(res) {
        return _replaceProjectData(res.data);
      })["catch"](function(err) {
        _setError(err.data || err.message);
        return $q.reject(err.data);
      });
    };
    ProjectF.loadProjectData = function(projectData) {
      if (ProjectF.isBusy) {
        return PROJECT_BUSY_ERROR;
      }
      return _replaceProjectData(projectData)["catch"](function(err) {
        _setError(err.data || err.message);
        return $q.reject(err.data);
      });
    };
    ProjectF.searchVisits = function(query) {
      var color, driver, driverId, id, isMatch, location, location_id, name, result, results, resultsList, route, routeSolution, visit, visitDriverInfo, visitId, visitMatchResult, visits, visitsDriverInfo, _i, _j, _len, _len1, _ref;
      query = query.toLowerCase();
      route = RouteS.getRoute();
      visitsDriverInfo = {};
      if ((route != null ? route.solution : void 0) != null) {
        routeSolution = route.solution.response;
        for (driverId in routeSolution) {
          route = routeSolution[driverId];
          visits = route.visits, driver = route.driver, color = route.color;
          isMatch = ((_ref = driver.name) != null ? _ref.toLowerCase().indexOf(query) : void 0) !== -1;
          for (_i = 0, _len = visits.length; _i < _len; _i++) {
            location_id = visits[_i].location_id;
            visitsDriverInfo[location_id] = {
              driverNameMatch: isMatch,
              driverId: driverId,
              driverName: driver.name,
              driverColor: color.rgba,
              matches: {
                "Driver": driver.name
              }
            };
          }
        }
      }
      results = {};
      visits = VisitF.getValidVisits();
      for (_j = 0, _len1 = visits.length; _j < _len1; _j++) {
        visit = visits[_j];
        id = visit.id, name = visit.name, location = visit.location;
        visitDriverInfo = visitsDriverInfo[visit.id];
        visitMatchResult = visit.querySearch(query);
        if ((visitDriverInfo != null ? visitDriverInfo.driverNameMatch : void 0) || visitMatchResult) {
          results[visit.id] = _.extend({
            visitId: id,
            visitName: name,
            visitAddress: location != null ? location.address : void 0
          }, visitDriverInfo || {}, visitMatchResult || {});
        }
      }
      resultsList = (function() {
        var _results;
        _results = [];
        for (visitId in results) {
          result = results[visitId];
          _results.push(result);
        }
        return _results;
      })();
      resultsList = resultsList.sort(function(a, b) {
        if (a.visitName < b.visitName) {
          return -1;
        }
        if (a.visitName > b.visitName) {
          return 1;
        }
        return 0;
      });
      return resultsList;
    };
    ProjectF.fetchProjects = function() {
      var authHeader = AccountF.getAuthHeader();
      return $http.get("" + Constants.apiPath + "/product/projects", authHeader).then(function(res) {
        _trackProjectDriverCount(res.data);
        return ProjectsUtil.formatProjects(res.data);
      })["catch"](function(err) {
        _setError(err.data || err.message);
        return $q.reject(err.data);
      });
    };
    ProjectF.fetchProjectsWithDates = function(fromDate, toDate) {
      var maxDate, minDate, params;
      var authHeader = AccountF.getAuthHeader();
      minDate = fromDate;
      maxDate = toDate;
      params = 'from=' + fromDate;
      if (maxDate) {
        params += '&to=' + maxDate;
      }
      return $http.get("" + Constants.apiPath + "/product/projects?" + params, authHeader).then(function(res) {
        _trackProjectDriverCount(res.data);
        return ProjectsUtil.formatProjects(res.data);
      })["catch"](function(err) {
        _setError(err.data || err.message);
        return $q.reject(err.data);
      });
    };
    ProjectF.fetchProjectVisit = function(visitId) {
      var authHeader, projectId, _ref;
      projectId = (_ref = ProjectF.project) != null ? _ref.id : void 0;
      if (!projectId) {
        return;
      }
      authHeader = AccountF.getAuthHeader();
      return $http.get("" + Constants.apiPath + "/product/projects/" + projectId + "/visits/" + visitId, authHeader).then(function(res) {
        return res.data;
      })["catch"](function(err) {
        _setError(err.data || err.message);
        return $q.reject(err.data);
      });
    };
    ProjectF.createProjectWithCustomers = function(name, date, customer_ids) {
      var authHeader, projectDate, projectEntry;
      if (ProjectF.isBusy) {
        return PROJECT_BUSY_ERROR;
      }
      if (!date) {
        return MISSING_PROJECT_DATE_ERROR;
      }
      projectDate = TimeUtilF.toString(date);
      if (!projectDate) {
        return INVALID_PROJECT_DATE_ERROR;
      }
      authHeader = AccountF.getAuthHeader();
      projectEntry = {
        name: name,
        date: projectDate,
        customer_ids: customer_ids
      };
      return $http.post("" + Constants.productApiPath + "/customers/project", projectEntry, authHeader).then(function(res) {
        var project = res.data;
        ProjectTimezoneF.setProjectTimezone(project.timezone);
        _updateProjectDetail(project);
        return project;
      })["catch"](function(err) {
        _setError(err.data || err.message);
        return $q.reject(err.data);
      });
    };
    ProjectF.create = function(name, date, isDuplicate) {
      var comingFromDemo, headers, project, projectDate;
      if (isDuplicate == null) {
        isDuplicate = false;
      }
      if (ProjectF.isBusy) {
        return PROJECT_BUSY_ERROR;
      }
      if (!date) {
        return MISSING_PROJECT_DATE_ERROR;
      }
      projectDate = TimeUtilF.toString(date);
      if (!projectDate) {
        return INVALID_PROJECT_DATE_ERROR;
      }
      project = _retrieveProject();
      if (project.solution != null) {
        _removeDispatchInfoFromSolution(project.solution);
      }
      project.fleet = _removeFleetErrorAndStatus(project.fleet);
      project.name = name;
      project.date = projectDate;
      comingFromDemo = void 0;
      if (!AccountF.isDemoFinished()) {
        comingFromDemo = true;
        AccountF.updateSettings({
          demoFinished: true
        });
      }
      if (comingFromDemo) {
        delete project.fleet;
      }
      headers = AccountF.getAuthHeader();
      if (isDuplicate) {
        project.isDuplicate = true;
      }
      return $http.post("" + Constants.apiPath + "/product/projects", project, headers).then(function(res) {
        project = res.data;
        ProjectTimezoneF.setProjectTimezone(project.timezone);
        _updateProjectDetail(project);
        if (comingFromDemo) {
          AnalyticsS.track("0013_WEB_UI demo start new project");
          EventListenersF.notify(Events.DEMO_FINISHED);
        }
        return project;
      })["catch"](function(err) {
        _setError(err.data || err.message);
        return $q.reject(err.data);
      });
    };
    ProjectF.isOverPayloadLimitSize = function(setDispatchedSolution) {
      var project, size;
      if (setDispatchedSolution == null) {
        setDispatchedSolution = false;
      }
      project = _retrieveProject();
      if (setDispatchedSolution) {
        project.dispatchedSolution = project.solution;
      }
      size = _jsonSizeInBytes(project);
      return size >= Constants.payloadLimitInBytes;
    };
    ProjectF.update = function(name, date, setDispatchedSolution) {
      var authHeader, dispatchSentTime, id, project, projectDate, routeHistoryIndex, routeHistoryTime, _ref;
      if (setDispatchedSolution == null) {
        setDispatchedSolution = false;
      }
      id = ProjectF.project.id;
      if (!id) {
        return NO_PROJECT_OPEN_ERROR;
      }
      if (ProjectF.isBusy) {
        LoggerF.error(LoggerF.ACTIONS.PROJECT_UPDATE, {
          project_id: ProjectF.project.id,
          client_version: ProjectF.project.version
        }, 'Project fail to update because it is busy');
        return PROJECT_BUSY_ERROR;
      }
      projectDate = null;
      if (date) {
        projectDate = date;
        if (projectDate instanceof Date) {
          projectDate = TimeUtilF.toString(date);
        }
        if (!projectDate) {
          return INVALID_PROJECT_DATE_ERROR;
        }
      }
      routeHistoryIndex = RouteHistoryF.currentIndex;
      routeHistoryTime = RouteHistoryF.getRouteTime();
      dispatchSentTime = DispatchStatusF.getLastSentTime();
      project = _retrieveProject();
      project.name = name || ProjectF.project.name;
      project.date = projectDate || ProjectF.project.date;
      project.status = ProjectF.project.status;
      if (ProjectF.project.version) {
        project.version = ProjectF.project.version;
      }
      project.isSolutionDirty = !!dispatchSentTime && ((!!routeHistoryTime && (routeHistoryTime > dispatchSentTime)) || (!routeHistoryTime && (routeHistoryIndex > 0)));
      if (setDispatchedSolution) {
        project.dispatchedSolution = project.solution;
        project.isSolutionDirty = false;
      }
      if (project.solution == null) {
        project.dispatchedSolution = null;
        project.isSolutionDirty = false;
      }
      authHeader = AccountF.getAuthHeader();
      if ((_ref = authHeader.headers) != null) {
        _ref['Session-Id'] = SessionF.getSessionId();
      }
      return $http.put("" + Constants.apiPath + "/product/projects/" + id, project, authHeader).then(function(res) {
        project = res.data;
        _updateProjectDetail(project);
        EventListenersF.notify(Events.PROJECT_UPDATE_FINISHED);
        return project;
      })["catch"](function(err) {
        if (err.status === PROJECT_VERSION_MISMATCH) {
          EventListenersF.notify(Events.PROJECT_VERSION_MISMATCH);
          return $q.reject(err);
        } else {
          _setError(err.data || err.message);
          return $q.reject(err.data);
        }
      });
    };
    ProjectF["delete"] = function(id) {
      var authHeader, _ref;
      if (id == null) {
        id = (_ref = ProjectF.project) != null ? _ref.id : void 0;
      }
      if (!id) {
        return;
      }
      if (ProjectF.isBusy) {
        return PROJECT_BUSY_ERROR;
      }
      authHeader = AccountF.getAuthHeader();
      return $http["delete"]("" + Constants.apiPath + "/product/projects/" + id, authHeader).then(function() {
        if (id === ProjectF.project.id) {
          _updateProjectDetail({});
        }
      })["catch"](function(err) {
        _setError(err.data || err.message);
        return $q.reject(err.data);
      });
    };
    ProjectF.hasError = function() {
      var test = !ProjectF.project || !!ProjectF.project.error;
      return test;
    };
    ProjectF.getSnapshot = function() {
      var project = _retrieveProject();
      project = _.assign(project, ProjectF.project);
      return project;
    };
    ProjectF.isDispatchedProject = function() {
      return DispatchStatusF.hasDispatches();
    };
    ProjectF.isPastProject = function() {
      var isPastDate = !ProjectF.isInFuture() && !ProjectF.isToday();
      return !ProjectF.isInLiveTracking() && isPastDate;
    };
    ProjectF.isInLiveTracking = function() {
      return DispatchStatusF.hasDispatches() && ProjectF.isOngoing();
    };
    ProjectF.createDemo = function(data) {
      var authHeader = AccountF.getAuthHeader();
      return $http.post("" + Constants.productApiPath + "/onboarding", data, authHeader).then(function(res) {
        var project;
        if (res.data.isPreset) {
          ConfirmF.confirmInfo($translate.instant("DEMO.PRESET_ERROR_HEADING"), $translate.instant("DEMO.PRESET_ERROR_TEXT"), void 0, $translate.instant("DEMO.PRESET_ERROR_CONFIRM"));
          AnalyticsS.track("0010_WEB_UI take me to windy city");
        }
        project = res.data.project;
        ProjectTimezoneF.setProjectTimezone(project.timezone);
        _updateProjectDetail(res.data.project);
        return project;
      });
    };
    _initEventListeners();
    return ProjectF;
  };
  ProjectF.$inject = ["$q", "$kookies", "$http", "$state", "$translate", "$window", "Constants", "AccountF", "DriverF", "VisitF", "DriverUtil", "RouteS", "TimeUtilF", "RouteUtil", "EventListenersF", "Events", "SettingsF", "VisitCsvHeaderF", "DispatchStatusF", "DispatchF", "RouteHistoryF", "NotificationF", "States", "ProjectTimezoneF", "ProjectsUtil", "MessagingF", "ConfirmF", "AnalyticsS", "SessionF", "LoggerF", "StoredDriverF"];

  angular.module('app').factory('ProjectF', ProjectF);

}).call(this);

(function() {
  var ProjectJobF = function($injector, $http, $q, $timeout, Constants, AccountF, SessionF) {
    var FETCH_JOB_TIMEOUT, JobStatus, PROMISE_STATE, RouteS, _currentLongOptimizePromise, _deferred, _fetchJob, _fetchJobStatus;
    RouteS = null;
    JobStatus = {
      FINISHED: 'finished',
      ERROR: 'error'
    };
    PROMISE_STATE = {
      PENDING: 0,
      RESOLVED: 1,
      REJECTED: 2
    };
    FETCH_JOB_TIMEOUT = 2000;
    _deferred = null;
    _currentLongOptimizePromise = null;
    _fetchJobStatus = function(id, poll, deferred) {
      var authHeader;
      if (poll == null) {
        poll = false;
      }
      if ((deferred != null) && deferred.promise.$$state.status !== PROMISE_STATE.PENDING) {
        return $q.reject();
      }
      authHeader = AccountF.getAuthHeader();
      return $http.get("" + Constants.apiPath + "/jobs/" + id + "/status", authHeader).then(function(res) {
        var _ref;
        var job = res.data;
        if (((_ref = job.status) !== JobStatus.FINISHED && _ref !== JobStatus.ERROR) && poll) {
          return $timeout(function() {
            return _fetchJobStatus(id, true, deferred);
          }, FETCH_JOB_TIMEOUT);
        } else {
          return job.status;
        }
      });
    };
    _fetchJob = function(id) {
      var authHeader = AccountF.getAuthHeader();
      return $http.get("" + Constants.apiPath + "/jobs/" + id, authHeader).then(function(res) {
        var job = res.data;
        if (job.status === JobStatus.FINISHED) {
          return job;
        } else if (job.status === JobStatus.ERROR) {
          return $q.reject(new Error(job.output));
        }
      });
    };
    ProjectJobF = {
      checkJobNotInProgress: function(projectId) {
        var authHeader = AccountF.getAuthHeader();
        return $http.get("" + Constants.apiPath + "/product/projects/" + projectId + "/optimize-status-check", authHeader);
      },
      setProjectJobId: function(projectId, jobId) {
        var payload, _ref;
        var authHeader = AccountF.getAuthHeader();
        if ((_ref = authHeader.headers) != null) {
          _ref['Session-Id'] = SessionF.getSessionId();
        }
        payload = {
          job_id: jobId
        };
        return $http.put("" + Constants.apiPath + "/product/projects/" + projectId + "/job", payload, authHeader);
      },
      checkPendingJob: function(jobId) {
        var currentRoute;
        RouteS || (RouteS = $injector.get('RouteS'));
        currentRoute = RouteS.getRoute();
        if (jobId) {
          return _fetchJobStatus(jobId).then(function(status) {
            return (status !== JobStatus.FINISHED && status !== JobStatus.ERROR) || (currentRoute != null ? currentRoute.jobId : void 0) !== jobId;
          });
        }
        return $q.when(false);
      },
      pollPendingJob: function(jobId) {
        _deferred = $q.defer();
        _fetchJobStatus(jobId, true, _deferred).then(function() {
          return _fetchJob(jobId);
        }).then(function(job) {
          job.output.isUserSolution = false;
          job.output.jobId = job.id;
          return _deferred.resolve(job.output);
        })["catch"](function(err) {
          return _deferred.reject(err);
        });
        return _deferred.promise;
      },
      saveLongOptimizePromise: function(promise) {
        return _currentLongOptimizePromise = promise;
      },
      cancelOptimizePoll: function() {
        if ((_deferred != null) && _deferred.promise.$$state.status === PROMISE_STATE.PENDING && (_currentLongOptimizePromise != null)) {
          if (_deferred != null) {
            _deferred.reject({
              cancel: true
            });
          }
          return _currentLongOptimizePromise;
        }
        return $q.when();
      }
    };
    return ProjectJobF;
  };
  ProjectJobF.$inject = ["$injector", "$http", "$q", "$timeout", "Constants", "AccountF", "SessionF"];

  angular.module('app').factory('ProjectJobF', ProjectJobF);

}).call(this);

(function() {
  var ProjectLoadC = function($scope, $state, $rootScope, projects, Constants, TimeUtilF, ProjectF, MarkersF, States, ProjectStatusListenerS, RouteS, DriverF, DispatchStatusF, AnalyticsS, EventListenersF, Events, ProjectJobF) {
    var _allProjects, _followProjectStatusUpdate, _initialize, _isProjectReady, _parseProjectSummary, _projectStatusUpdated, _unfollowProjectStatusUpdate;
    _allProjects = projects;
    _isProjectReady = function(project) {
      return !project.status || project.status === Constants.projectReadyStatus;
    };
    _parseProjectSummary = function(project) {
      return {
        _id: project._id,
        date: project.date,
        name: project.name || '(Untitled)',
        status: project.status
      };
    };
    _projectStatusUpdated = (function(_this) {
      return function(response) {
        var current, date, project, _i, _len, _results;
        project = response.project;
        date = project.date;
        date = TimeUtilF.fromString(date);
        projects = _this.projects[date];
        if (projects) {
          _results = [];
          for (_i = 0, _len = projects.length; _i < _len; _i++) {
            current = projects[_i];
            if (current._id === project._id) {
              current.status = project.status;
              break;
            } else {
              _results.push(void 0);
            }
          }
          return _results;
        }
      };
    })(this);
    _followProjectStatusUpdate = function(projects) {
      var current, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = projects.length; _i < _len; _i++) {
        current = projects[_i];
        _results.push((function(current) {
          var projectId = current._id;
          if (!_isProjectReady(current) && !ProjectStatusListenerS.isListening(projectId)) {
            return ProjectStatusListenerS.check(projectId).then(function(project) {
              current.status = project.status;
              if (!_isProjectReady(project)) {
                return ProjectStatusListenerS.listen(projectId, _projectStatusUpdated);
              }
            });
          }
        })(current));
      }
      return _results;
    };
    _unfollowProjectStatusUpdate = function() {
      return ProjectStatusListenerS.cancelAll();
    };
    _initialize = (function(_this) {
      return function() {
        var current, date, maxDate, minDate, project, projectSummary, _i, _len;
        minDate = new Date();
        maxDate = new Date();
        minDate.setHours(0, 0, 0, 0);
        maxDate.setHours(0, 0, 0, 0);
        projects = {};
        for (_i = 0, _len = _allProjects.length; _i < _len; _i++) {
          project = _allProjects[_i];
          if (project._id !== ProjectF.project.id) {
            date = TimeUtilF.fromString(project.date);
            if (minDate > date) {
              minDate = date;
            }
            if (maxDate < date) {
              maxDate = date;
            }
            projectSummary = _parseProjectSummary(project);
            projects[date] || (projects[date] = []);
            projects[date].push(projectSummary);
          }
        }
        _this.noProjectDates = [];
        current = new Date(minDate);
        while (current < maxDate) {
          if (!projects[current]) {
            _this.noProjectDates.push(TimeUtilF.toString(current));
          }
          current.setDate(current.getDate() + 1);
          current.setHours(0);
        }
        if (Object.keys(projects).length > 0) {
          _this.projects = projects;
        }
        _this.minDate = TimeUtilF.toString(minDate);
        return _this.maxDate = TimeUtilF.toString(maxDate);
      };
    })(this);
    this.filterProjects = (function(_this) {
      return function(dateStr) {
        var date;
        if (!(dateStr && _this.projects)) {
          return;
        }
        date = TimeUtilF.fromString(dateStr);
        _this.dateProjects = _this.projects[date] || [];
        return _followProjectStatusUpdate(_this.dateProjects);
      };
    })(this);
    this.selectProject = (function(_this) {
      return function(project) {
        _this.project = project;
        if (_this.project) {
          if (_this.project.name) {
            return _this.projectName = "" + _this.project.name + " - " + _this.project.date;
          } else {
            return _this.projectName = _this.project.date;
          }
        } else {
          return _this.projectName = null;
        }
      };
    })(this);
    this.loadProject = function(project) {
      if (!project) {
        this.error = "No project has been selected";
        return;
      }
      if (!_isProjectReady(project)) {
        this.error = "Project is still being processed";
        return;
      }
      return ProjectJobF.cancelOptimizePoll()["finally"](function() {
        $scope.closeThisDialog(States.projectVisitsList);
        ProjectF.clear();
        return ProjectF.load(project._id).then(function() {
          AnalyticsS.track('012 Load different project', {
            project_name: project.name,
            project_date: TimeUtilF.fromString(project.date)
          });
          return MarkersF.fitToPoints();
        }).then(function() {
          var _ref;
          EventListenersF.notify(Events.PROJECT_SWITCHED);
          if (RouteS.hasRoute()) {
            return $state.go(States.projectRoutePlan);
          } else if (((_ref = DriverF.getDrivers()) != null ? _ref.length : void 0) > 0) {
            return $state.go(States.projectVisitsList);
          } else {
            return $state.go(States.projectDriversList);
          }
        })["catch"]((function(_this) {
          return function(err) {
            return _this.error = err.message;
          };
        })(this));
      });
    };
    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState) {
      if (fromState.$$state().includes['hud.modal.projects.load']) {
        return _unfollowProjectStatusUpdate();
      }
    });
    _initialize();
  };
  ProjectLoadC.$inject = ["$scope", "$state", "$rootScope", "projects", "Constants", "TimeUtilF", "ProjectF", "MarkersF", "States", "ProjectStatusListenerS", "RouteS", "DriverF", "DispatchStatusF", "AnalyticsS", "EventListenersF", "Events", "ProjectJobF"];

  angular.module('app').controller('ProjectLoadC', ProjectLoadC);

}).call(this);

(function() {
  var ProjectSessionF = function(Events, SocketF, LoggerF) {
    ProjectSessionF = {};
    ProjectSessionF.currentProject = null;
    ProjectSessionF.connectTo = function(projectId) {
      if (!!ProjectSessionF.currentProject) {
        SocketF.notifyProjectDisconnect(ProjectSessionF.currentProject);
        LoggerF.info(LoggerF.ACTIONS.DISCONNECTED_PROJECT, {
          projectId: projectId
        });
      }
      return SocketF.notifyProjectConnect(projectId).then(function() {
        ProjectSessionF.currentProject = projectId;
        return LoggerF.info(LoggerF.ACTIONS.CONNECTED_PROJECT, {
          projectId: projectId
        });
      });
    };
    return ProjectSessionF;
  };
  ProjectSessionF.$inject = ["Events", "SocketF", "LoggerF"];

  angular.module('app').factory('ProjectSessionF', ProjectSessionF);

}).call(this);

(function() {
  var ProjectStatusListenerS = function($http, $timeout, Constants, ProjectF) {
    var Listener, PULL_INTERVAL, _isReady;
    PULL_INTERVAL = 5000;
    _isReady = function(status) {
      return status === Constants.projectReadyStatus;
    };
    Listener = (function() {
      var _delayFetch, _notify;

      function Listener(projectId) {
        this.projectId = projectId;
        this.callbacks = [];
        this.timer = null;
        this.status = null;
        this.project = null;
      }

      _delayFetch = function() {
        return this.timer = $timeout((function(_this) {
          return function() {
            return ProjectF.fetch(_this.projectId).then(function(project) {
              _this.project = project;
              _this.status = project.status;
              if (_isReady(project.status)) {
                return _notify.call(_this);
              } else {
                return _delayFetch.call(_this);
              }
            });
          };
        })(this), PULL_INTERVAL);
      };

      _notify = function() {
        var cb, response, _i, _len, _ref;
        response = {
          projectId: this.projectId,
          status: this.status,
          project: this.project
        };
        _ref = this.callbacks;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          cb = _ref[_i];
          cb(response);
        }
        return this.callbacks = [];
      };

      Listener.prototype.start = function() {
        if (this.timer) {
          return;
        }
        return _delayFetch.call(this);
      };

      Listener.prototype.notify = _notify.bind(Listener);

      Listener.prototype.stop = function() {
        if (this.timer) {
          return $timeout.cancel(this.timer);
        }
      };

      return Listener;

    })();
    this.projectListeners = {};
    this.check = ProjectF.fetch;
    this.listen = function(projectId, callback) {
      var listener = this.projectListeners[projectId];
      if (!listener) {
        listener = new Listener(projectId);
        listener.start();
        this.projectListeners[projectId] = listener;
      }
      listener.callbacks.push(callback);
      if (_isReady(listener.status)) {
        return listener.notify();
      }
    };
    this.isListening = function(projectId) {
      return !!this.projectListeners[projectId];
    };
    this.cancelAll = function() {
      var id, listener, _ref;
      _ref = this.projectListeners;
      for (id in _ref) {
        listener = _ref[id];
        listener.stop();
      }
      return this.projectListeners = {};
    };
  };
  ProjectStatusListenerS.$inject = ["$http", "$timeout", "Constants", "ProjectF"];

  angular.module('app').service('ProjectStatusListenerS', ProjectStatusListenerS);

}).call(this);

(function() {
  var ProjectsModalC = function($scope, $window, $state, $stateParams, $q, Constants, ProjectF, TimeUtilF, MessagingF, States, AnalyticsS, EventListenersF, Events, FeatureFlagF) {
    var _canOptIn, _initialize, _showOptIn;
    _initialize = (function(_this) {
      return function() {
        _this.selectedCustomerIds = $stateParams.selectedCustomerIds;
        _this.date = new Date();
        _this.today = TimeUtilF.toString(new Date());
        return _showOptIn();
      };
    })(this);
    _showOptIn = function() {
      return _canOptIn().then(function(isEnabled) {
        return $scope.canViewOptInButton = isEnabled;
      });
    };
    _canOptIn = function() {
      return FeatureFlagF.isEnabled('opt_in_beta');
    };
    this.goToBeta = function() {
      return $state.go(States.modalOptInBeta);
    };
    this.createNew = function(isValid, name, dateStr) {
      var date, projectCreationPromise;
      if (!isValid) {
        console.log('Invalid form, new project not created');
        return;
      }
      if (!dateStr) {
        this.error = "Project date must be chosen";
      }
      date = TimeUtilF.fromString(dateStr);
      if (name) {
        name = name.trim();
      }
      ProjectF.clear(true);
      if (this.selectedCustomerIds.length > 0) {
        projectCreationPromise = ProjectF.createProjectWithCustomers(name, date, this.selectedCustomerIds);
      } else {
        projectCreationPromise = ProjectF.create(name, date);
      }
      return projectCreationPromise.then(function() {
        AnalyticsS.track('010 Create a new project', {
          project_name: name,
          project_date: date
        });
        EventListenersF.notify(Events.PROJECT_SWITCHED);
        return ProjectF.load(ProjectF.project.id);
      }).then(function() {
        $scope.closeThisDialog(States.projectVisitsList);
        return $window.location.reload();
      })["catch"]((function(_this) {
        return function(err) {
          MessagingF.replaceError("PROJECT_POPUPS.CREATE_ERROR");
          return _this.error = err.message;
        };
      })(this));
    };
    this.duplicate = function(isValid, name, dateStr) {
      var date;
      if (!isValid) {
        console.log('Invalid form, project not duplicated');
        return;
      }
      if (!dateStr) {
        this.error = "Project date must be chosen";
      }
      date = TimeUtilF.fromString(dateStr);
      if (name) {
        name = name.trim();
      }
      $scope.closeThisDialog();
      return ProjectF.create(name, date, true).then(function() {
        return ProjectF.clear();
      }).then(function() {
        AnalyticsS.track('013 Save as a different project', {
          project_name: name,
          project_date: date
        });
        return ProjectF.load(ProjectF.project.id);
      }).then(function() {
        return EventListenersF.notify(Events.PROJECT_SWITCHED);
      }).then(function() {
        $state.go(States.projectRoutePlan);
        return $window.location.reload();
      })["catch"]((function(_this) {
        return function(err) {
          return _this.error = err.message;
        };
      })(this));
    };
    this.rename = function(isValid, name, dateStr) {
      var newDate, newName, project, promise;
      if (!isValid) {
        console.log('Invalid form, project not updated');
        return;
      }
      project = ProjectF.project;
      newName = null;
      if (name != null) {
        name = name.trim();
        if (name !== project.name) {
          newName = name;
        }
      }
      newDate = null;
      if (dateStr && project.date !== dateStr) {
        newDate = TimeUtilF.fromString(dateStr);
      }
      promise = null;
      if ((newName != null) || (newDate != null)) {
        promise = ProjectF.update(newName, newDate);
      } else {
        promise = $q.when(true);
      }
      return promise.then(function() {
        AnalyticsS.track('011 Rename current project', {
          project_name: newName || project.name,
          project_date: newDate || TimeUtilF.fromString(project.date)
        });
        EventListenersF.notify(Events.PROJECT_SWITCHED);
        $scope.closeThisDialog();
        return $window.location.reload();
      })["catch"]((function(_this) {
        return function(err) {
          return _this.error = err.message;
        };
      })(this));
    };
    _initialize();
  };
  ProjectsModalC.$inject = ["$scope", "$window", "$state", "$stateParams", "$q", "Constants", "ProjectF", "TimeUtilF", "MessagingF", "States", "AnalyticsS", "EventListenersF", "Events", "FeatureFlagF"];

  angular.module('app').controller('ProjectsModalC', ProjectsModalC);

}).call(this);

(function() {
  var ProjectsTableC = function($q, $state, $rootScope, $timeout, projects, minMaxDates, ProjectF, MarkersF, States, ConfirmF, SettingsF, DriverF, VisitF, RouteS, AnalyticsS, RouteDownloadF, DispatchF, DispatchStatusF) {
    var CURRENT_PROJECT, DEFAULT_STATE, _ref;
    DEFAULT_STATE = States.projectRoutePlan;
    CURRENT_PROJECT = (_ref = ProjectF.project) != null ? _ref.id : void 0;
    this.projects = projects;
    this.minDate = minMaxDates.minDate;
    this.maxDate = minMaxDates.maxDate;
    this.project = ProjectF.project;
    this.settings = SettingsF.settings;
    this.downloadProject = function(project) {
      return ProjectF.previewProject(project._id).then(function(res) {
        if (res.solution) {
          if (DispatchStatusF.hasDispatches()) {
            return DispatchF.getProjectRoutes(project._id).then(function(dispatches) {
              if (dispatches) {
                DispatchF.replace(dispatches);
                AnalyticsS.track('109 Download project', {
                  'Project': project.name + project.date
                });
                return RouteDownloadF.downloadCsv(project.name, project.date);
              }
            });
          } else {
            AnalyticsS.track('109 Download project', {
              'Project': project.name + project.date
            });
            return RouteDownloadF.downloadCsv(project.name, project.date);
          }
        }
      })["finally"](function() {
        return ProjectF.previewProject(CURRENT_PROJECT);
      })["catch"]((function(_this) {
        return function(err) {
          return _this.error = err.message;
        };
      })(this));
    };
    this.deleteProject = function(project) {
      var isCurrentProject, projectId, _ref1;
      projectId = project._id;
      if (!(projectId && !this.isProjectBusy)) {
        return;
      }
      isCurrentProject = ((_ref1 = ProjectF.project) != null ? _ref1.id : void 0) === projectId;
      return ConfirmF.confirm("MESSAGES.DELETE_PROJECT").then(function() {
        return ProjectF["delete"](projectId);
      }).then((function(_this) {
        return function() {
          var idx;
          if (isCurrentProject) {
            _this.project = null;
            ProjectF.clear(true);
          }
          idx = projects.indexOf(project);
          if (idx > -1) {
            return projects.splice(idx, 1);
          }
        };
      })(this))["catch"]((function(_this) {
        return function(err) {
          return _this.error = err.message;
        };
      })(this));
    };
    this.loadProject = function(project) {
      if (!project) {
        this.error = "No project has been selected";
        return;
      }
      return $state.go(States.main).then(function() {
        return ProjectF.clear();
      }).then(function() {
        return ProjectF.load(project._id);
      }).then(function() {
        var _ref1;
        if (RouteS.hasRoute()) {
          return $state.go(States.projectRoutePlan);
        } else if (((_ref1 = DriverF.getValidDrivers()) != null ? _ref1.length : void 0) > 0) {
          return $state.go(States.projectVisitsList);
        } else {
          return $state.go(States.projectDriversList);
        }
      })["catch"]((function(_this) {
        return function(err) {
          return _this.error = err.message;
        };
      })(this));
    };
    this.backToProject = function() {
      return $state.go(DEFAULT_STATE);
    };
    AnalyticsS.track('004 Open project list', {
      '#Projects': projects != null ? projects.length : void 0
    });
  };
  ProjectsTableC.$inject = ["$q", "$state", "$rootScope", "$timeout", "projects", "minMaxDates", "ProjectF", "MarkersF", "States", "ConfirmF", "SettingsF", "DriverF", "VisitF", "RouteS", "AnalyticsS", "RouteDownloadF", "DispatchF", "DispatchStatusF"];

  angular.module('app').controller('ProjectsTableC', ProjectsTableC);

}).call(this);

(function() {
  var QuestionnaireC = function($scope, $state, $kookies, States, Questions, AccountF, ConfirmF, OnboardingF, QuestionnaireF, ProjectF, AnalyticsS, EventListenersF, Events, $timeout) {
    this.name = AccountF.getUser().firstName;
    this.questions = angular.copy(Questions);
    this.hasShopifyBilling = AccountF.hasShopifyBilling();
    this.input = {
      'routing_method': '',
      'business_type': '',
      'total_monthly_stops': '',
      'routing_frequency': ''
    };
    this.sendQuestionnaire = function(form) {
      this.inProgress = true;
      form.$setSubmitted();
      return QuestionnaireF.sendQuestionnaire(this.input).then((function(_this) {
        return function() {
          var projectIdFromQuery, tempInfo, _ref;
          AnalyticsS.track('In App Questionnaire Sent');
          if (fbq) {
            fbq('track', 'CompleteRegistration', {
              content_name: 'in-app survey'
            });
          }
          if ((_ref = window.dataLayer) != null) {
            _ref.push({
              'formName': 'QuestionnaireForm',
              'event': 'Questionnaire_form',
              'total_monthly_stops': _this.input.total_monthly_stops,
              'routing_method': _this.input.routing_method,
              'business_type': _this.input.business_type,
              'routing_frequency': _this.input.routing_frequency
            });
          }
          $scope.closeThisDialog(States.project);
          projectIdFromQuery = $kookies.get('projectIdFromQuery');
          if (_this.hasShopifyBilling && projectIdFromQuery) {
            return ProjectF.load(projectIdFromQuery).then(function() {
              EventListenersF.notify(Events.DEMO_FINISHED);
              EventListenersF.notify(Events.PROJECT_SWITCHED);
              $state.go(States.projectDriversList);
              return $kookies.remove('projectIdFromQuery');
            });
          } else {
            tempInfo = ProjectF.getProjectTempInfo();
            return ProjectF.create(tempInfo.name, tempInfo.date).then(function() {
              return ProjectF.load(ProjectF.project.id);
            }).then(function() {
              EventListenersF.notify(Events.DEMO_FINISHED);
              EventListenersF.notify(Events.PROJECT_SWITCHED);
              return $state.go(States.projectDriversList);
            });
          }
        };
      })(this))["finally"]((function(_this) {
        return function() {
          return _this.inProgress = false;
        };
      })(this));
    };
  };
  QuestionnaireC.$inject = ["$scope", "$state", "$kookies", "States", "Questions", "AccountF", "ConfirmF", "OnboardingF", "QuestionnaireF", "ProjectF", "AnalyticsS", "EventListenersF", "Events", "$timeout"];

  angular.module('app').controller('QuestionnaireC', QuestionnaireC);

}).call(this);

(function() {
  var QuestionnaireF = function($http, $q, AccountF, Constants) {
    var _formatQuestions;
    QuestionnaireF = {};
    _formatQuestions = function(input) {
      var answer, formatted, q, question;
      formatted = [];
      for (q in input) {
        answer = input[q];
        if (!(answer.length > 0)) {
          continue;
        }
        if (_.isArray(answer)) {
          answer = answer.join(',');
        }
        question = {};
        question.question = q;
        if (answer === 'both') {
          question.answer = 'homes & businesses';
        } else {
          question.answer = answer;
        }
        formatted.push(question);
      }
      return formatted;
    };
    QuestionnaireF.setQuestionnaire = function(questionnaire) {
      QuestionnaireF.questionnaire = questionnaire;
      return questionnaire;
    };
    QuestionnaireF.fetchUserQuestionnaire = function() {
      return $http.get("" + Constants.apiPath + "/product/questionnaire", AccountF.getAuthHeader()).then(function(res) {
        return QuestionnaireF.setQuestionnaire(res.data);
      })["catch"](function(err) {
        return QuestionnaireF.setQuestionnaire(null);
      });
    };
    QuestionnaireF.sendQuestionnaire = function(input) {
      var data = {
        questions: _formatQuestions(input)
      };
      return $http.post("" + Constants.apiPath + "/product/questionnaire", data, AccountF.getAuthHeader()).then(function(res) {
        AccountF.getUser().settings.sentQuestionnaire = true;
        return QuestionnaireF.setQuestionnaire(res.data);
      })["catch"](function(err) {
        return QuestionnaireF.setQuestionnaire(null);
      });
    };
    return QuestionnaireF;
  };
  QuestionnaireF.$inject = ["$http", "$q", "AccountF", "Constants"];

  angular.module('app').factory('QuestionnaireF', QuestionnaireF);

}).call(this);

(function() {
  var ReduxStoreF = function(AccountF) {
    var _previousStoreState, _store, _syncChanges;
    ReduxStoreF = {};
    _store = void 0;
    _previousStoreState = void 0;
    _syncChanges = function() {
      var currentValue = _store.getState();
      if (!currentValue) {
        return;
      }
      if (_previousStoreState !== currentValue) {
        _previousStoreState = currentValue;
        AccountF.updateSettings(currentValue.userSettings, true);
        return AccountF.updateDeliveryMethod(currentValue.deliveryMethodSettings.delivery_method);
      }
    };
    ReduxStoreF.init = function() {
      _store = window.reduxStore;
      if (!_store) {
        return;
      }
      return _store.subscribe(_syncChanges);
    };
    return ReduxStoreF;
  };
  ReduxStoreF.$inject = ["AccountF"];

  angular.module('app').factory('ReduxStoreF', ReduxStoreF);

}).call(this);

(function() {
  var kmMiles = function(DistanceUtilF) {
    return function(value, format) {
      return DistanceUtilF.getDistance(value, format);
    };
  };
  kmMiles.$inject = ["DistanceUtilF"];

  angular.module('app').filter('kmMiles', kmMiles);

}).call(this);

(function() {
  var     __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  var RouteC = (function() {
    RouteC.$inject = ["$scope", "$state", "$timeout", "$q", "$window", "RouteS", "VisitF", "DriverF", "DispatchF", "ConfirmF", "AccountF", "MessagingF", "Constants", "OnboardingF", "SettingsF", "ProjectF", "EventListenersF", "Events", "States", "ValidatorF", "RedirectF", "AnalyticsS", "DispatchStatusF", "RouteUtil", "RouteHistoryF", "HudF", "DemoF", "CustomerNotificationF", "LoggerF", "ClientF", "$translate", "$animate", "TimeUtilF", "DriverSorter", "StopsAssignF", "GMarkerF", "GanttSettings"];
    var BASE_HEIGHT, CHART_HEIGHT_OFFSET, CHART_SIZE, DISPATCH_SUB_BAR_HEIGHT, ESCAPE_KEYCODE, FIVE_SECONDS_IN_MS, FOOTER_HEIGHT, HIDE_CHART_HEIGHT, MAXIMIZED_CHART_HEIGHT, MAX_ROWS, MENU_BAR_HEIGHT, MIN_UNDO_TIME, REG_ROWS, ROW_HEIGHT, SUB_BAR_HEIGHT, TOP_BAR_HEIGHT, _dispatches, _driverStats, _getChartHeight, _route, _shifts, _swapDriverInfo, _toggleSwapDriverState;

    MENU_BAR_HEIGHT = 80;

    TOP_BAR_HEIGHT = 42;

    SUB_BAR_HEIGHT = 33;

    DISPATCH_SUB_BAR_HEIGHT = 70;

    FOOTER_HEIGHT = 70;

    BASE_HEIGHT = TOP_BAR_HEIGHT + SUB_BAR_HEIGHT + FOOTER_HEIGHT;

    ROW_HEIGHT = 50;

    REG_ROWS = 5;

    MAX_ROWS = 9;

    HIDE_CHART_HEIGHT = 100;

    MAXIMIZED_CHART_HEIGHT = BASE_HEIGHT + ROW_HEIGHT * MAX_ROWS;

    MIN_UNDO_TIME = 1200;

    ESCAPE_KEYCODE = 27;

    FIVE_SECONDS_IN_MS = 5 * 1000;

    CHART_HEIGHT_OFFSET = -7;

    CHART_SIZE = {
      MIN: "minimized",
      REG: "regular",
      MAX: "maximized"
    };

    _route = null;

    _shifts = null;

    _dispatches = null;

    _driverStats = null;

    _swapDriverInfo = {};

    _toggleSwapDriverState = false;

    _getChartHeight = function(rows) {
      return BASE_HEIGHT + ROW_HEIGHT * Math.min(rows, REG_ROWS);
    };

    function RouteC($scope, $state, $timeout, $q, $window, RouteS, VisitF, DriverF, DispatchF, ConfirmF, AccountF, MessagingF, Constants, OnboardingF, SettingsF, ProjectF, EventListenersF, Events, States, ValidatorF, RedirectF, AnalyticsS, DispatchStatusF, RouteUtil, RouteHistoryF, HudF, DemoF, CustomerNotificationF, LoggerF, ClientF, $translate, $animate, TimeUtilF, DriverSorter, StopsAssignF, GMarkerF, GanttSettings) {
      var DEBUG_STATE, DISPATCH_STATE, DISPATCH_STATUS, EDIT_STATE, LIVE_STATE, PLAN_STATE, TIMELINE_STATES, _cancelPhoneUpdate, _driverHasServedStops, _getProject, _getRoutesInfo, _getSelectedDrivers, _hasEmptyDrivers, _mergeRoutes, _refreshChartHeight, _setHeightStyle, _showSortByDepartureTime, _user;
      LIVE_STATE = States.projectRouteLive;
      EDIT_STATE = States.projectRouteEdit;
      PLAN_STATE = States.projectRoutePlan;
      DISPATCH_STATE = States.projectRouteDispatch;
      DEBUG_STATE = States.projectRouteDebug;
      TIMELINE_STATES = [LIVE_STATE, EDIT_STATE, PLAN_STATE, DISPATCH_STATE, DEBUG_STATE];
      RouteS.setCurrentRouteState($state.current.name);
      $scope.$on('$stateChangeSuccess', function(event, toState) {
        var _ref;
        if (_ref = toState.name, __indexOf.call(TIMELINE_STATES, _ref) >= 0) {
          RouteS.setCurrentRouteState(toState.name);
        }
        if (_toggleSwapDriverState) {
          return _toggleSwapDriverState = false;
        }
      });
      DISPATCH_STATUS = Constants.DISPATCH_STATUS;
      _user = AccountF.getUser();
      _refreshChartHeight = (function(_this) {
        return function() {
          var hasUnserved, height, route, rows;
          rows = 0;
          if (RouteS.hasRoute()) {
            route = _this.getRoute();
            rows = route.solution.request.fleet.length;
            hasUnserved = route.unserved && Object.keys(route.unserved).length > 0;
            if (hasUnserved) {
              rows++;
            }
          }
          height = _getChartHeight(rows);
          return _setHeightStyle(height);
        };
      })(this);
      _setHeightStyle = (function(_this) {
        return function(height) {
          var scaledHeight = height * HudF.getScale();
          EventListenersF.notify(Events.ROUTE_CHART_HEIGHT_CHANGED, scaledHeight);
          _this.heightStyle = {
            height: scaledHeight
          };
          _this.dispatchHeightStyle = {
            height: "" + (height - FOOTER_HEIGHT - DISPATCH_SUB_BAR_HEIGHT - CHART_HEIGHT_OFFSET) + "px"
          };
          return _this.timelineHeightStyle = {
            height: "" + (height - FOOTER_HEIGHT - SUB_BAR_HEIGHT - CHART_HEIGHT_OFFSET) + "px"
          };
        };
      })(this);
      _cancelPhoneUpdate = function(driverRoute) {
        driverRoute.editNumber = false;
        return delete driverRoute.newPhone;
      };
      _getProject = function() {
        return ProjectF.project;
      };
      _getSelectedDrivers = function() {
        var driver, drivers, visibleDrivers, _i, _len;
        drivers = GMarkerF.getAllDrivers();
        visibleDrivers = [];
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          driver = drivers[_i];
          if (driver.visible) {
            visibleDrivers.push({
              id: driver.driverId,
              name: driver.parameter.originalName,
              color: driver.fillCss
            });
          }
        }
        return _.sortBy(visibleDrivers, 'name');
      };
      _driverHasServedStops = function() {
        var driver, _i, _len, _ref;
        _ref = DriverF.getDrivers();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          driver = _ref[_i];
          if (RouteS.isDriverHasServedStops(driver)) {
            return true;
          }
        }
        return false;
      };
      _hasEmptyDrivers = function() {
        var driver, _i, _len, _ref;
        _ref = DriverF.getSelectedDrivers();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          driver = _ref[_i];
          if (RouteS.isDriverEmpty(driver)) {
            return true;
          }
        }
        return false;
      };
      _showSortByDepartureTime = function() {
        var hasSameStartTime, routes, solution, vehId, vehicle, _ref, _ref1;
        if (RouteS.hasRoute()) {
          solution = RouteS.getRoute().solution;
          routes = [];
          for (vehId in solution) {
            vehicle = solution[vehId];
            if (solution[vehId][0]) {
              routes.push((_ref = TimeUtilF.convertTimeToDate((_ref1 = solution[vehId][0]) != null ? _ref1.arrival_time : void 0)) != null ? _ref.getTime() : void 0);
            }
          }
          hasSameStartTime = function(routes) {
            return routes.every(function(r) {
              return r === routes[0];
            });
          };
          return !hasSameStartTime(routes);
        } else {
          return false;
        }
      };
      this.settings = SettingsF.settings;
      this.inProgress = RouteS.isInProgress();
      this.initChartHeight = function() {
        setTimeout(function() {
          return _refreshChartHeight();
        });
        return this.chartSize = CHART_SIZE.REG;
      };
      this.showChart = function() {
        _refreshChartHeight();
        return this.hidden = false;
      };
      this.hideChart = function() {
        _setHeightStyle(HIDE_CHART_HEIGHT);
        return this.hidden = true;
      };
      this.showClock = ProjectF.isToday();
      this.showLiveTrackStats = function() {
        return AccountF.hasLiveTracking() && $scope.hud.hasBeenDispatched();
      };
      this.allowReoptimizeButton = function() {
        return RouteS.getCurrentRouteState() !== States.projectRouteLive;
      };
      this.showReoptimizeButton = function() {
        return RouteS.getCurrentRouteState() !== States.projectRouteDispatch;
      };
      this.showHideEmptyVehicles = _hasEmptyDrivers();
      this.showSortByDepartureTime = _showSortByDepartureTime();
      this.sortByDepartureTime = GanttSettings.getSortByDepartureTime();
      this.hideEmptyVehicles = GanttSettings.getHideEmptyVehicles();
      this.driverEnRoute = _driverHasServedStops();
      this.getSelectedDrivers = _getSelectedDrivers();
      this.showDispatchButton = function() {
        var _ref;
        return (_ref = RouteS.getCurrentRouteState()) !== States.projectRouteLive && _ref !== States.projectRouteDebug;
      };
      this.hideLassoButtons = function() {
        return _driverHasServedStops() || this.isInLiveState();
      };
      this.isInTimelineState = function() {
        return RouteS.getCurrentRouteState().includes(States.projectRouteTimeline);
      };
      this.isInLiveState = function() {
        return RouteS.getCurrentRouteState() === States.projectRouteLive;
      };
      this.isInDebugState = function() {
        return RouteS.getCurrentRouteState() === States.projectRouteDebug;
      };
      this.isInDispatchState = function() {
        return RouteS.getCurrentRouteState() === States.projectRouteDispatch;
      };
      this.toggleSwapDrivers = function() {
        return _toggleSwapDriverState;
      };
      this.chartSize = CHART_SIZE.REG;
      this.shrinkChart = function() {
        if (this.chartSize === 'minimized') {
          return;
        }
        AnalyticsS.track_force('037 Collapse chart');
        switch (this.chartSize) {
          case CHART_SIZE.REG:
            _setHeightStyle(HIDE_CHART_HEIGHT);
            return this.chartSize = CHART_SIZE.MIN;
          case CHART_SIZE.MAX:
            _refreshChartHeight();
            return this.chartSize = CHART_SIZE.REG;
        }
      };
      this.expandChart = function() {
        var height, maxWindowHeight;
        if (this.chartSize === 'maximized') {
          return;
        }
        AnalyticsS.track_force('038 Expand chart');
        switch (this.chartSize) {
          case CHART_SIZE.MIN:
            _refreshChartHeight();
            return this.chartSize = CHART_SIZE.REG;
          case CHART_SIZE.REG:
            maxWindowHeight = $window.innerHeight - BASE_HEIGHT - MENU_BAR_HEIGHT;
            height = Math.min(MAXIMIZED_CHART_HEIGHT, maxWindowHeight);
            _setHeightStyle(height);
            return this.chartSize = CHART_SIZE.MAX;
        }
      };
      this.isRouteDirty = RouteS.isRouteDirty;
      this.hasUnsentRoutes = DispatchStatusF.hasUnsentRoutes;
      this.pendingRoutesCount = DispatchStatusF.getPendingRoutesCount;
      this.pendingVisitsCount = RouteS.getNumberOfVisitsToNotify;
      this.setSortByDepartureTime = function(newValue) {
        return GanttSettings.setSortByDepartureTime(newValue);
      };
      this.setHideEmptyVehiclesInSort = function(newValue) {
        return GanttSettings.setHideEmptyVehicles(newValue);
      };
      this.getRoute = function() {
        if (!_route) {
          _route = RouteS.getRoute();
        }
        return _route;
      };
      this.getSortedShift = function() {
        var shiftsMap, sortedDriverIds;
        sortedDriverIds = DriverSorter.getSortedDriverIds();
        shiftsMap = {};
        _.every(_route.shifts, function(shift) {
          return shiftsMap[shift.id] = shift;
        });
        sortedDriverIds = _.filter(sortedDriverIds, function(id) {
          return !!shiftsMap[id];
        });
        _shifts = _.map(sortedDriverIds, function(id) {
          return shiftsMap[id];
        });
        return _shifts;
      };
      _mergeRoutes = function(shifts, routeLocks) {
        var routes = [];
        shifts.map(function(driver, i) {
          return Object.keys(routeLocks).map(function(key, index) {
            var routeObj;
            var hasServedStops = RouteS.isDriverHasServedStops(driver);
            if (driver.id === key) {
              routeObj = Object.assign(driver, {
                'locked': routeLocks[key]
              }, {
                'hasServedStops': hasServedStops
              });
              return routes.push(routeObj);
            }
          });
        });
        return routes;
      };
      this.getSwappableRoutes = function() {
        var newRoutes = _mergeRoutes(_route.shifts, _route.routeLocks);
        return newRoutes;
      };
      this.getDispatches = function() {
        var dispatches = DispatchF.getDispatches();
        if (dispatches) {
          _dispatches = dispatches;
        }
        return _dispatches;
      };
      this.hasDriverStats = !_.isEmpty(_driverStats);
      this.hasUnserved = (function(_this) {
        return function() {
          return _route.unserved && !_.isEmpty(_route.unserved);
        };
      })(this);
      this.getDriversStats = function() {
        var stats;
        var sortedDriverIds = DriverSorter.getSortedDriverIds();
        stats = DispatchF.getStats();
        if (stats != null ? stats.drivers : void 0) {
          sortedDriverIds = _.filter(sortedDriverIds, function(id) {
            return !!stats.drivers[id];
          });
          _driverStats = _.map(sortedDriverIds, function(id) {
            return stats.drivers[id];
          });
        }
        return _driverStats;
      };
      this.getTotalDoneVisits = function() {
        var stats = DispatchF.getStats();
        if (stats) {
          return stats.numDone;
        } else {
          return 0;
        }
      };
      this.getTotalSkippedVisits = function() {
        var stats = DispatchF.getStats();
        if (stats) {
          return stats.numSkipped;
        } else {
          return 0;
        }
      };
      this.getTotalServedVisits = function() {
        return _route.num_visits - _route.num_unserved;
      };
      this.getTotalVisits = function() {
        return _route.num_visits;
      };
      this.getTotalTime = function() {
        return _route.workingTime;
      };
      this.getTotalDistance = function() {
        return _route.total_distance;
      };
      this.swapDriverInfo = function() {
        return _swapDriverInfo;
      };
      this.fixRoute = function(unserved, solution) {
        var date = ProjectF.project.date;
        return EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS).then(function() {
          return RouteS.fixRoute(date, unserved, solution);
        }).then(function() {
          return EventListenersF.notify(Events.PROJECT_MODIFIED);
        })["finally"](function() {
          return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
        });
      };
      this.scheduleUnserveds = function() {
        var props;
        var promise = $q.reject();
        props = RouteS.getNumUnserved();
        promise = ConfirmF.confirmWarning(null, 'UNSERVED_MESSAGES.FORCE_UNSERVED_WARNING', 'Cancel', 'Confirm Force Schedule').then(function() {
          return EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS);
        }).then(function() {
          return RouteS.scheduleUnserveds();
        });
        return promise.then((function(_this) {
          return function() {
            EventListenersF.notify(Events.SIDE_PANEL_UNSERVED_CHANGED, true);
            AnalyticsS.track('040 Auto reschedule', {
              num_unserved: props
            });
            return MessagingF.replaceInfo('UNSERVED_MESSAGES.FORCE_UNSERVED_UPDATE', null, null, "SIDEPANEL.UNSAVED_CHANGES_OK");
          };
        })(this))["finally"](function() {
          return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
        });
      };
      this.swapRoute = function(driver) {
        return EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS).then(function() {
          return RouteS.swapRoute(_swapDriverInfo.id, driver);
        }).then(function() {
          return EventListenersF.notify(Events.PROJECT_MODIFIED);
        }).then(function() {
          var callback, successMessage;
          _toggleSwapDriverState = false;
          successMessage = $translate.instant("MESSAGES.SUCCESSFUL_SWAP", {
            name: _swapDriverInfo.name
          });
          MessagingF.replaceSuccessPopup(successMessage);
          $animate.removeClass(angular.element(document.querySelector('.animated')), 'pulse');
          callback = function() {
            return $animate.addClass(angular.element(document.querySelector('.animated')), 'pulse');
          };
          return setTimeout(callback, 0);
        })["catch"](function(err) {
          return MessagingF.replaceError(err);
        })["finally"](function() {
          return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
        });
      };
      this.reoptimize = function() {
        var currentUnservedIds;
        if (!this.allowReoptimizeButton() || this.driverEnRoute) {
          return;
        }
        currentUnservedIds = Object.keys(RouteS.getUnserved());
        return ConfirmF.confirm("MESSAGES.REOPTIMIZATION_CONFIRMATION").then(function() {
          var isDebugJob;
          var date = ProjectF.project.date;
          isDebugJob = $state.includes(States.projectRouteDebug);
          return RouteS.reoptimize(date, isDebugJob);
        }).then(function() {
          return AnalyticsS.track('039 Re-optimize route', {
            num_unserved: RouteS.getNumUnserved(),
            settings: RouteS.getSettings()
          });
        }).then(function() {
          var isNotificationEnabled, newUnservedHasNotifiedStop, reoptimzedUnservedIds;
          reoptimzedUnservedIds = Object.keys(RouteS.getUnserved());
          newUnservedHasNotifiedStop = (function() {
            var unservedId, _i, _len;
            var newUnservedIds = _.difference(reoptimzedUnservedIds, currentUnservedIds);
            for (_i = 0, _len = newUnservedIds.length; _i < _len; _i++) {
              unservedId = newUnservedIds[_i];
              if (DispatchF.isNotifiedStop(unservedId)) {
                return true;
              }
            }
            return false;
          })();
          isNotificationEnabled = AccountF.hasCustomerNotification() && AccountF.isCancelledNotificationOn();
          if (newUnservedHasNotifiedStop && isNotificationEnabled) {
            return ConfirmF.notificationUnscheduleWarning();
          }
        });
      };
      this.goToTimelineTab = function() {
        return $state.go(States.projectRoutePlan);
      };
      this.goToDispatchTab = function() {
        return $state.go(States.projectRouteDispatch);
      };
      this.goToDebugTab = function() {
        return $state.go(States.projectRouteDebug);
      };
      this.previousRoute = function() {
        AnalyticsS.track('050 Go back', {
          "project_id": ProjectF.project.id,
          "user_email": AccountF.getUser().email,
          "before_first_dispatch": !DispatchF.hasDispatches()
        });
        RouteS.goToPreviousRoute();
        this.inUndone = true;
        return $timeout((function(_this) {
          return function() {
            return _this.inUndone = false;
          };
        })(this), MIN_UNDO_TIME);
      };
      this.nextRoute = function() {
        AnalyticsS.track('052 Redo', {
          "project_id": ProjectF.project.id,
          "user_email": AccountF.getUser().email,
          "before_first_dispatch": !DispatchF.hasDispatches()
        });
        RouteS.goToNextRoute();
        this.inRedone = true;
        return $timeout((function(_this) {
          return function() {
            return _this.inRedone = false;
          };
        })(this), MIN_UNDO_TIME);
      };
      _getRoutesInfo = function() {
        var dispatch, dispatchStatus, dispatches, driverRoute, driverRoutes, driverRoutesById, fleet, formattedRoute, noPhoneRoutes, pendingRoutes, phone, route, routeDispatchInfo, routeDispatches, routeWithoutPhone, routes, sortedFleet, vehicle, _i, _j, _len, _len1, _ref;
        pendingRoutes = [];
        noPhoneRoutes = [];
        route = RouteS.getRoute();
        if ((route != null ? route.solution : void 0) == null) {
          return;
        }
        fleet = _.cloneDeep(route.solution.request.fleet);
        sortedFleet = _.sortBy(fleet, function(veh) {
          return veh.createdAt;
        });
        routeDispatches = route.dispatches;
        routes = _.pick(route.solution, _.isArray);
        driverRoutes = RouteUtil.parseRouteDispatch(fleet, routes);
        driverRoutes = _.cloneDeep(driverRoutes);
        dispatches = DispatchF.getDispatches();
        driverRoutesById = {};
        for (_i = 0, _len = driverRoutes.length; _i < _len; _i++) {
          route = driverRoutes[_i];
          driverRoutesById[route.id] = route;
        }
        for (_j = 0, _len1 = sortedFleet.length; _j < _len1; _j++) {
          vehicle = sortedFleet[_j];
          driverRoute = driverRoutesById[vehicle.id];
          routeDispatchInfo = routeDispatches[vehicle.id];
          dispatch = dispatches[vehicle.id];
          phone = (_ref = driverRoute.driver) != null ? _ref.phoneNumber : void 0;
          dispatchStatus = RouteUtil.getDispatchStatus(dispatch, routeDispatchInfo, phone, AccountF.hasGPSTracking());
          if (!phone || phone === "") {
            routeWithoutPhone = {
              id: driverRoute.id,
              name: driverRoute.driver.name,
              phone: null,
              newPhone: null,
              editNumber: false
            };
            noPhoneRoutes.push(routeWithoutPhone);
          } else if (dispatchStatus === DISPATCH_STATUS.WAITING_FOR_UPDATE || dispatchStatus === DISPATCH_STATUS.NOT_DISPATCHED) {
            formattedRoute = {
              id: driverRoute.id,
              name: driverRoute.driver.name,
              phone: phone || "",
              dispatchStatus: dispatchStatus
            };
            pendingRoutes.push(formattedRoute);
          }
        }
        return {
          noPhoneRoutes: noPhoneRoutes,
          pendingRoutes: pendingRoutes
        };
      };
      this.handleDispatchBtn = function() {
        if (DemoF.isModifiedDemoDispatch()) {
          return DemoF.clickedDispatch();
        }
        if (!this.isInDispatchState()) {
          return this.goToDispatchTab();
        }
        if (this.hasUnsentRoutes()) {
          return this.dispatch();
        }
      };
      this.getDriverNum = function() {
        return _route.solution.request.fleet.length;
      };
      this.reassignStops = function(stopIds) {
        var driverId, driverName, fleet, oldRoute, selectedDriver, unserved, visit, visits, _i, _len;
        EventListenersF.notify(Events.SIDE_PANEL_UPDATING, true);
        visits = VisitF.getValidVisits();
        fleet = DriverF.getSelectedDrivers();
        oldRoute = RouteS.getRoute();
        unserved = [];
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          visit = visits[_i];
          if (oldRoute.unserved[visit.id] != null) {
            if ((oldRoute.unserved[visit.id] != null) && stopIds.indexOf(visit.id) === -1) {
              visit.error = oldRoute.unserved[visit.id].error;
              unserved.push(visit);
            }
          }
        }
        selectedDriver = this.lassoSelectedDriver;
        driverId = selectedDriver.id;
        driverName = selectedDriver.name;
        return StopsAssignF.assignStops(driverId, stopIds).then(function(newSolution) {
          var affectedVehicles, assignedStops, oldSolution, unaffectedVehicles, unservedStops, vehicle, _j, _len1;
          ProjectF.project.version = newSolution.version;
          affectedVehicles = [];
          unaffectedVehicles = [];
          for (_j = 0, _len1 = fleet.length; _j < _len1; _j++) {
            vehicle = fleet[_j];
            if (newSolution.solution[vehicle.id] != null) {
              affectedVehicles.push(vehicle);
            } else {
              unaffectedVehicles.push(vehicle);
            }
          }
          oldSolution = {
            route: oldRoute,
            polylines: RouteS.getPolylines(),
            unserved: unserved,
            unaffectedVehicles: unaffectedVehicles,
            affectedVehicles: affectedVehicles
          };
          unservedStops = Object.keys(newSolution.unserved).length;
          assignedStops = stopIds.filter((function(_this) {
            return function(id) {
              return newSolution.unserved[id] === void 0;
            };
          })(this)).length;
          if (Object.keys(newSolution.unserved).length) {
            MessagingF.replaceSuccessPopup("MESSAGES.ASSIGN_ROUTES_SUCCESS_UNSERVED", {
              assigned: assignedStops,
              name: driverName,
              unserved: unservedStops
            });
          } else {
            MessagingF.replaceSuccessPopup("MESSAGES.ASSIGN_ROUTES_SUCCESS", {
              assigned: assignedStops,
              name: driverName
            });
          }
          RouteS.replace(newSolution, visits, fleet, oldSolution);
          EventListenersF.notify(Events.CLEAR_LASSO_SELECTION);
          return EventListenersF.notify(Events.REASSIGN_PANEL_CLOSED, true);
        })["catch"](function(err) {
          var message;
          MessagingF.removeMessageAt(0);
          message = (err != null ? err.status : void 0) === 409 ? "MESSAGES.PROJECT_VER_ERR_BODY" : "Unable to reassign stops at this time, please try again";
          EventListenersF.notify(Events.SIDE_PANEL_UPDATING, false);
          return ConfirmF.confirmWarning(null, message, void 0, "I understand");
        });
      };
      this.unscheduleStops = function(stopIds) {
        var fleet, oldRoute, unserved, visit, visits, _i, _len;
        EventListenersF.notify(Events.SIDE_PANEL_UPDATING, true);
        visits = VisitF.getValidVisits();
        fleet = DriverF.getSelectedDrivers();
        oldRoute = RouteS.getRoute();
        unserved = [];
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          visit = visits[_i];
          if (!(oldRoute.unserved[visit.id] != null)) {
            continue;
          }
          visit.error = oldRoute.unserved[visit.id].error;
          unserved.push(visit);
        }
        return StopsAssignF.unscheduleStops(stopIds).then(function(newSolution) {
          var affectedVehicles, oldSolution, unaffectedVehicles, unservedStops, vehicle, _j, _len1;
          ProjectF.project.version = newSolution.version;
          affectedVehicles = [];
          unaffectedVehicles = [];
          for (_j = 0, _len1 = fleet.length; _j < _len1; _j++) {
            vehicle = fleet[_j];
            if (newSolution.solution[vehicle.id] != null) {
              affectedVehicles.push(vehicle);
            } else {
              unaffectedVehicles.push(vehicle);
            }
          }
          oldSolution = {
            route: oldRoute,
            polylines: RouteS.getPolylines(),
            unserved: unserved,
            unaffectedVehicles: unaffectedVehicles,
            affectedVehicles: affectedVehicles
          };
          unservedStops = Object.keys(newSolution.unserved).length;
          MessagingF.replaceSuccessPopup("MESSAGES.UNSCHEDULE_ROUTES_SUCCESS", {
            unserved: unservedStops
          });
          RouteS.replace(newSolution, visits, fleet, oldSolution);
          EventListenersF.notify(Events.CLEAR_LASSO_SELECTION);
          return EventListenersF.notify(Events.REASSIGN_PANEL_CLOSED, true);
        })["catch"](function(err) {
          var message;
          MessagingF.removeMessageAt(0);
          EventListenersF.notify(Events.SIDE_PANEL_UPDATING, false);
          message = (err != null ? err.status : void 0) === 409 ? "MESSAGES.PROJECT_VER_ERR_BODY" : "Unable to unschedule stops at this time, please try again";
          return ConfirmF.confirmWarning(null, message, void 0, "I understand");
        });
      };
      this.deleteStops = function(stopIds) {
        var fleet, oldRoute, unserved, visit, visits, _i, _len, _ref;
        EventListenersF.notify(Events.SIDE_PANEL_UPDATING, true);
        fleet = DriverF.getSelectedDrivers();
        oldRoute = RouteS.getRoute();
        visits = [];
        unserved = [];
        _ref = VisitF.getValidVisits();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          visit = _ref[_i];
          if (stopIds.indexOf(visit.id) === -1) {
            visits.push(visit);
            if (oldRoute.unserved[visit.id] != null) {
              visit.error = oldRoute.unserved[visit.id].error;
              unserved.push(visit);
            }
          }
        }
        return ConfirmF.confirm("MESSAGES.REMOVE_VISITS_CONFIRMATION").then(function() {
          return StopsAssignF.deleteStops(stopIds);
        }).then(function(newSolution) {
          var affectedVehicles, deletedStops, oldSolution, unaffectedVehicles, vehicle, _j, _len1;
          ProjectF.project.version = newSolution.version;
          affectedVehicles = [];
          unaffectedVehicles = [];
          for (_j = 0, _len1 = fleet.length; _j < _len1; _j++) {
            vehicle = fleet[_j];
            if (newSolution.solution[vehicle.id] != null) {
              affectedVehicles.push(vehicle);
            } else {
              unaffectedVehicles.push(vehicle);
            }
          }
          oldSolution = {
            route: oldRoute,
            polylines: RouteS.getPolylines(),
            unserved: unserved,
            unaffectedVehicles: unaffectedVehicles,
            affectedVehicles: affectedVehicles
          };
          newSolution.deleted.forEach(function(id) {
            VisitF.removeVisit(id);
            return GMarkerF.destroy(id);
          });
          VisitF.updateValidVisits();
          deletedStops = Object.keys(newSolution.deleted).length;
          MessagingF.replaceSuccessPopup("MESSAGES.DELETE_ROUTES_SUCCESS", {
            deleted: deletedStops
          });
          RouteS.replace(newSolution, visits, fleet, oldSolution);
          RouteS.resetRoutesToCurrent();
          EventListenersF.notify(Events.CLEAR_LASSO_SELECTION);
          return EventListenersF.notify(Events.REASSIGN_PANEL_CLOSED, true);
        })["catch"](function(err) {
          var message;
          MessagingF.removeMessageAt(0);
          message = (err != null ? err.status : void 0) === 409 ? "MESSAGES.PROJECT_VER_ERR_BODY" : "Unable to delete stops at this time, please try again";
          ConfirmF.confirmWarning(null, message, void 0, "I understand");
          return EventListenersF.notify(Events.SIDE_PANEL_UPDATING, false);
        });
      };
      this.dispatch = function() {
        var errorCount, errorDispatchToDrivers, errorDuringDispatch, noPhoneRoutes, pendingRoutes, preDispatchProjectVersion, project, promise, startTimeMS, successCount, _doDispatchDrivers, _ref;
        successCount = 0;
        errorDuringDispatch = false;
        errorDispatchToDrivers = false;
        errorCount = 0;
        startTimeMS = null;
        if (ProjectF.isPastProject()) {
          MessagingF.replaceError("MESSAGES.CANNOT_DISPATCH_PAST_PROJECT");
          return;
        }
        if (ProjectF.isBusy) {
          return MessagingF.replaceError("MESSAGES.PROJECT_BUSY_ERROR");
        }
        project = ProjectF.project;
        _ref = _getRoutesInfo(), noPhoneRoutes = _ref.noPhoneRoutes, pendingRoutes = _ref.pendingRoutes;
        if ($state.current.name === States.projectRouteDispatch) {
          AnalyticsS.track('041 Dispatch to driver', {
            numPendingRoutes: pendingRoutes.length,
            numNoPhoneRoutes: noPhoneRoutes.length
          });
          if (typeof analytics !== "undefined" && analytics !== null) {
            analytics.ready(function() {
              return typeof analytics !== "undefined" && analytics !== null ? analytics.track('Project Dispatched', {
                project_id: project.id
              }) : void 0;
            });
          }
          ClientF.track('01 Dispatch to driver', {
            project_id: project.id
          });
          if (typeof _hsq !== "undefined" && _hsq !== null) {
            _hsq.push([
              'trackEvent', {
                id: '000012370756',
                value: 1
              }
            ]);
          }
        } else {
          AnalyticsS.track('049 Save & update', {
            numPendingRoutes: pendingRoutes.length,
            numNoPhoneRoutes: noPhoneRoutes.length
          });
        }
        preDispatchProjectVersion = project.version;
        _doDispatchDrivers = function() {
          startTimeMS = Date.now();
          return EventListenersF.notify(Events.PROJECT_DISPATCH_STARTED).then(function() {
            return DispatchF.dispatchDrivers(project);
          }).then(function(responses) {
            var postDispatchProjectVersion = project.version;
            if (preDispatchProjectVersion !== postDispatchProjectVersion) {
              LoggerF.error(LoggerF.ACTIONS.DISPATCH_ROUTE, {
                projectId: project.id,
                preRequestVersion: preDispatchProjectVersion,
                postRequestVersion: postDispatchProjectVersion
              }, 'Project was updated while waiting for route dispatch to complete');
              EventListenersF.notify(Events.PROJECT_VERSION_MISMATCH);
              return $q.reject();
            }
            return responses;
          }).then(function(responses) {
            var errors, hasLiveTracking, r, successMessage, sucesses;
            sucesses = (function() {
              var _i, _len, _results;
              _results = [];
              for (_i = 0, _len = responses.length; _i < _len; _i++) {
                r = responses[_i];
                if (!r.error && (r.res != null)) {
                  _results.push(r);
                }
              }
              return _results;
            })();
            errors = (function() {
              var _i, _len, _results;
              _results = [];
              for (_i = 0, _len = responses.length; _i < _len; _i++) {
                r = responses[_i];
                if ((r.error != null) && !r.res) {
                  _results.push(r);
                }
              }
              return _results;
            })();
            successCount = sucesses ? sucesses.length : 0;
            errorCount = errors ? errors.length : 0;
            if (successCount <= 0 && errorCount <= 0) {
              return $q.reject(new Error("MESSAGES.NO_DRIVER_HAS_NUMBER"));
            }
            RouteS.resetRoutesToCurrent();
            hasLiveTracking = AccountF.hasLiveTracking();
            if (!hasLiveTracking && !AccountF.isOptedOutOfLiveTracking()) {
              $scope.projectC.showLiveTrackOptIn = true;
              OnboardingF.setOnboarding(false);
            }
            if (ProjectF.isOngoing() && hasLiveTracking) {
              $state.go(States.projectRouteLive);
            } else {
              $state.go(States.projectRouteEdit);
            }
            if (errorCount > 0) {
              errorDispatchToDrivers = true;
              return MessagingF.replaceWarningPopup("MESSAGES.DISPATCH_ERROR", {
                errorCount: errorCount
              });
            } else {
              successMessage = AccountF.hasCustomerNotification() ? "MESSAGES.DISPATCH_SUCCESS_WITH_NOTIFICATION" : "MESSAGES.DISPATCH_SUCCESS";
              return MessagingF.replaceSuccessPopup(successMessage, {
                successCount: successCount
              });
            }
          })["catch"](function(err) {
            errorDispatchToDrivers = true;
            if (((err != null ? err.message : void 0) != null) || ((err != null ? err.error : void 0) != null)) {
              return MessagingF.replaceError(err.message || err.error);
            }
          }).then(function() {
            if ($state.current.name === States.projectRoutePlan) {
              return AnalyticsS.track('042 Confirm dispatch', {
                successfulDispatch: successCount,
                failedDispatch: errorCount
              });
            } else {
              return AnalyticsS.track('053 Confirm save & update');
            }
          });
        };
        promise = null;
        if ($scope.hud.hasBeenDispatched()) {
          promise = ConfirmF.confirmRedispatch(pendingRoutes, noPhoneRoutes, this).then(function() {
            return _doDispatchDrivers();
          }).then(function() {
            return CustomerNotificationF.sendCancellation();
          }).then(function() {
            var setDispatchedSolution;
            return EventListenersF.notify(Events.PROJECT_MODIFIED, setDispatchedSolution = true);
          }).then(function() {
            return CustomerNotificationF.sendPlannedEta();
          })["catch"](function(err) {
            var logPayload, _ref1, _ref2, _ref3;
            errorDuringDispatch = true;
            if ((err != null ? (_ref1 = err.data) != null ? _ref1.status : void 0 : void 0) === 409) {
              LoggerF.error(LoggerF.ACTIONS.VALIDATED_PROJECT_VERSION, {
                client_version: ProjectF.project.version,
                server_version: (_ref2 = err.data) != null ? (_ref3 = _ref2.error_vars) != null ? _ref3.version : void 0 : void 0
              }, 'Project version mismatch during dispatch');
            } else {
              logPayload = {
                projectId: project.id
              };
              LoggerF.error(LoggerF.ACTIONS.DISPATCH_ROUTE, logPayload, err);
            }
            if ($state.current.name === States.projectRoutePlan) {
              return AnalyticsS.track('043 Cancel dispatch');
            } else {
              return AnalyticsS.track('054 Cancel save & update');
            }
          });
        } else {
          promise = _doDispatchDrivers().then(function() {
            var setDispatchedSolution;
            return EventListenersF.notify(Events.PROJECT_MODIFIED, setDispatchedSolution = true);
          }).then(function() {
            return CustomerNotificationF.sendPlannedEta();
          })["catch"](function(err) {
            var logPayload, _ref1;
            errorDuringDispatch = true;
            if ((err != null ? err.status : void 0) === 409) {
              return LoggerF.error(LoggerF.ACTIONS.VALIDATED_PROJECT_VERSION, {
                client_version: ProjectF.project.version,
                server_version: (_ref1 = err.error_vars) != null ? _ref1.version : void 0
              }, 'Project version mismatch during dispatch');
            } else {
              logPayload = {
                projectId: project.id
              };
              return LoggerF.error(LoggerF.ACTIONS.DISPATCH_ROUTE, logPayload, err);
            }
          });
        }
        return promise["finally"](function() {
          var debugInfo = {
            'projectId': project.id,
            'Elapsed time': Date.now() - startTimeMS,
            'hasCustomerNotification': !!AccountF.hasCustomerNotification(),
            'hasEta': !!AccountF.isDOTWNotificationOn(),
            'hasDotw': !!AccountF.isDeliveryConfirmationNotificationOn(),
            'hasConfirm': !!AccountF.isDeliveryConfirmationNotificationOn(),
            'hasCancelled': !!AccountF.isCancelledNotificationOn(),
            'hasLivetracking': !!AccountF.hasLiveTracking(),
            'driverDispatchError': errorDispatchToDrivers,
            'error': errorDuringDispatch || errorDispatchToDrivers
          };
          return EventListenersF.notify(Events.PROJECT_DISPATCH_ENDED, debugInfo);
        });
      };
      this.prepPhoneUpdate = function(driverRoute) {
        if (!driverRoute.phone || driverRoute.phone === "") {
          AnalyticsS.track('044 Adding phone');
        }
        driverRoute.editNumber = true;
        return driverRoute.newPhone = driverRoute.phone;
      };
      this.keyUpPhoneField = function(event, driverRoute) {
        if (event.keyCode === ESCAPE_KEYCODE) {
          return _cancelPhoneUpdate(driverRoute);
        }
      };
      this.cancelPhoneUpdate = _cancelPhoneUpdate;
      this.updatePhone = function(valid, driverRoute, number) {
        var driver, previousNumber;
        if (!valid) {
          MessagingF.replaceErrorPopup("FORM_VALIDATION_ERR.PROVIDE_VALID_PHONE");
          return;
        }
        if (ProjectF.isBusy) {
          return MessagingF.replaceError("MESSAGES.PROJECT_BUSY_ERROR");
        }
        driver = DriverF.getDriver(driverRoute.id);
        previousNumber = driver.phoneNumber;
        if (number === previousNumber) {
          _cancelPhoneUpdate(driverRoute);
          return;
        }
        driver.phoneNumber = number;
        return DriverF.update(driver)["catch"](function(err) {
          driver.phoneNumber = previousNumber;
          return MessagingF.replaceError("MESSAGES.DRIVER_PHONE_UPDATE_ERROR", {
            number: err.message
          });
        })["finally"](function() {
          EventListenersF.notify(Events.PROJECT_MODIFIED);
          MessagingF.replaceSuccessPopup("MESSAGES.DRIVER_PHONE_UPDATE_SUCCESS", {
            driverName: driver.name
          });
          return _cancelPhoneUpdate(driverRoute);
        });
      };
      this.phoneRegex = ValidatorF.PHONE_REGEXP;
      this.undoAllRoute = function() {
        AnalyticsS.track('051 Reset solution');
        RouteS.goToFirstRoute();
        this.inUndoAll = true;
        MessagingF.replaceSuccessPopup("MESSAGES.UNDO_ALL_SUCCESS");
        return $timeout((function(_this) {
          return function() {
            return _this.inUndoAll = false;
          };
        })(this), MIN_UNDO_TIME);
      };
      this.hasUndoLock = function() {
        var currentLocks, previousLocks, _ref, _ref1;
        previousLocks = (_ref = RouteHistoryF.seek(-1)) != null ? _ref.numLocks : void 0;
        currentLocks = (_ref1 = RouteHistoryF.seek()) != null ? _ref1.numLocks : void 0;
        if ((previousLocks != null) && (currentLocks != null)) {
          return previousLocks < currentLocks;
        }
        return false;
      };
      this.hasUndo = function() {
        return RouteS.getHistoryIndex() > 0;
      };
      this.hasRedo = function() {
        return RouteS.getHistoryIndex() < (RouteS.getNumRouteHistory() - 1);
      };
      EventListenersF.addEventListener(Events.FIX_ROUTE_IN_PROGRESS, (function(_this) {
        return function() {
          return _this.inProgress = true;
        };
      })(this));
      EventListenersF.addEventListener(Events.FIX_ROUTE_COMPLETED, (function(_this) {
        return function() {
          return _this.inProgress = false;
        };
      })(this));
      EventListenersF.addEventListener(Events.ROUTE_SET, (function(_this) {
        return function(newRoute) {
          _route = newRoute;
          if (_this.chartSize === CHART_SIZE.REG) {
            return _refreshChartHeight();
          }
        };
      })(this));
      EventListenersF.addEventListener(Events.VISIT_STATUS_UPDATED, (function(_this) {
        return function() {
          if (_this.driverEnRoute) {
            return;
          }
          return _this.driverEnRoute = _driverHasServedStops();
        };
      })(this));
      EventListenersF.addEventListener(Events.SHRINK_GANTT_CHART, (function(_this) {
        return function() {
          return _this.hideChart();
        };
      })(this));
      EventListenersF.addEventListener(Events.EXPAND_GANTT_CHART, (function(_this) {
        return function() {
          return _this.showChart();
        };
      })(this));
      EventListenersF.addEventListener(Events.DISPATCHES_UPDATED, (function(_this) {
        return function() {
          if (_this.driverEnRoute) {
            return;
          }
          return _this.driverEnRoute = _driverHasServedStops();
        };
      })(this));
      EventListenersF.addEventListener(Events.PROJECT_MODIFIED, (function(_this) {
        return function() {
          _this.showHideEmptyVehicles = _hasEmptyDrivers();
          return _this.showSortByDepartureTime = _showSortByDepartureTime();
        };
      })(this));
      EventListenersF.addEventListener(Events.SWAP_DRIVERS, (function(_this) {
        return function(data) {
          _swapDriverInfo = data;
          _toggleSwapDriverState = data.toggle;
          return _this.toggleSwapDrivers(_toggleSwapDriverState);
        };
      })(this));
      this.isAnyRoutesVisible = function() {
        return RouteS.isAnyRoutesVisible();
      };
      this.isNativeAppEnabled = function() {
        return AccountF.nativeAppEnabled();
      };
      this.toggleRoutesVisibility = function() {
        return RouteS.setAllRoutesVisible(!this.isAnyRoutesVisible());
      };
      this.isLocked = true;
      this.toggleRoutesLocks = function() {
        if (this.isInLiveState() || ProjectF.isPastProject()) {
          return;
        }
        this.isLocked = !this.isLocked;
        RouteS.setAllRouteLocks(this.isLocked);
        if (!this.isLocked) {
          return MessagingF.replaceSuccessPopup("MESSAGES.ALL_ROUTE_UNLOCK_SUCCESS");
        } else {
          return MessagingF.replaceSuccessPopup("MESSAGES.ALL_ROUTE_LOCK_SUCCESS");
        }
      };
      this.hasLatenessOverview = function() {
        if ((_route != null ? _route.driverShiftsOverview : void 0) == null) {
          return 0;
        }
        return Object.keys(_route.driverShiftsOverview).length > 0;
      };
      this.hasCapacityOverview = function() {
        if ((_route != null ? _route.driverLoadsOverview : void 0) == null) {
          return 0;
        }
        return Object.keys(_route.driverLoadsOverview).length > 0;
      };
    }

    return RouteC;

  })();

  angular.module('app').controller('RouteC', RouteC);

}).call(this);

(function() {
  var RouteDispatchC = function($state, $translate, States, ProjectF, DispatchStatusF, AccountF, RouteS, RouteUtil, DispatchF, EventListenersF, Events, TimeUtilF, Constants, MessagingF, GMarkerF, GPSRoutesF, DriverSorter, GanttSettings) {
    var LAST_UPDATED, _addRouteVisibilityListener, _formatDriverRoute, _getLastTracked, _getLastUpdated, _getRoutesInfo, _initializeEventListeners;
    LAST_UPDATED = {
      SENT_AT: function(sentTime, sentDate) {
        var timeText = $translate.instant("DISPATCH_TAB.DISPATCHED_AT", {
          time: sentTime
        });
        return {
          timeText: timeText,
          date: sentDate,
          iconSvgSrc: '/img/gray-phone-with-checkmark.svg'
        };
      },
      SEEN_AT: function(seenTime, seenDate) {
        var timeText = $translate.instant("DISPATCH_TAB.SEEN_AT", {
          time: seenTime
        });
        return {
          timeText: timeText,
          date: seenDate,
          iconSvgSrc: '/img/blue-phone-with-checkmark.svg'
        };
      },
      NOT_SENT: {
        timeText: $translate.instant("DISPATCH_TAB.PLEASE_SAVE_AND_UPDATE"),
        timeClass: "route-state not-sent",
        iconSvgSrc: '/img/gray-phone.svg'
      },
      LAST_TRACKED: function(lastTracked) {
        var timeText = $translate.instant("DISPATCH_TAB.LAST_TRACKED", {
          time: lastTracked
        });
        return {
          timeText: timeText,
          iconSvgSrc: '/img/blue-phone-with-checkmark.svg'
        };
      },
      FINISHED_AT: function(finishTime) {
        var timeText = $translate.instant("DISPATCH_TAB.FINISHED_AT", {
          time: finishTime
        });
        return {
          timeText: timeText,
          iconSvgSrc: '/img/blue-phone-with-checkmark.svg'
        };
      }
    };
    _initializeEventListeners = (function(_this) {
      return function() {
        EventListenersF.addEventListener(Events.PROJECT_MODIFIED, function() {
          return _this.routesInfo = _getRoutesInfo();
        });
        EventListenersF.addEventListener(Events.VERIFIED_ROUTE_SEEN, function() {
          return _this.routesInfo = _getRoutesInfo();
        });
        EventListenersF.addEventListener(Events.DISPATCHES_UPDATED, function() {
          return _this.routesInfo = _getRoutesInfo();
        });
        EventListenersF.addEventListener(Events.HIDE_EMPTY_VEHICLES_CHANGED, function() {
          return _this.routesInfo = _getRoutesInfo();
        });
        return EventListenersF.addEventListener(Events.SORT_VEHICLES_BY_DEPARTURE_TIME_CHANGED, function() {
          return _this.routesInfo = _getRoutesInfo();
        });
      };
    })(this);
    _getLastTracked = function(routeId) {
      return GPSRoutesF.getLastTracked(routeId);
    };
    _getLastUpdated = function(seenDate, sentDate, phone, routeId, lastTracked, doneTimestamp) {
      var toDateStr, toTimeStr;
      toTimeStr = TimeUtilF.dateToTimeStr;
      toDateStr = TimeUtilF.dateToMMDD;
      if (doneTimestamp != null) {
        return LAST_UPDATED.FINISHED_AT(toTimeStr(doneTimestamp));
      }
      if (AccountF.hasGPSTracking() && (lastTracked != null)) {
        return LAST_UPDATED.LAST_TRACKED(toTimeStr(new Date(lastTracked)));
      }
      if ((sentDate && !seenDate) || (sentDate > seenDate)) {
        return LAST_UPDATED.SENT_AT(toTimeStr(sentDate), sentDate);
      }
      if (sentDate && seenDate && seenDate > sentDate) {
        return LAST_UPDATED.SEEN_AT(toTimeStr(seenDate), seenDate);
      }
      if (!sentDate && (phone != null)) {
        return LAST_UPDATED.NOT_SENT;
      }
      return null;
    };
    _formatDriverRoute = function(driverRoute, routeDispatchInfo, dispatch, sentTime) {
      var formatted, lastTracked, numStops, phone, routeId, seenDate, sentDate, vehicleId, _ref, _ref1;
      phone = (_ref = driverRoute.driver) != null ? _ref.phoneNumber : void 0;
      if (dispatch != null ? dispatch.lastSeen : void 0) {
        seenDate = new Date(dispatch != null ? dispatch.lastSeen : void 0);
      }
      if (sentTime) {
        sentDate = new Date(sentTime);
      }
      routeId = dispatch != null ? dispatch._id : void 0;
      vehicleId = dispatch != null ? (_ref1 = dispatch.vehicle) != null ? _ref1._id : void 0 : void 0;
      numStops = _.filter(driverRoute.steps, function(visit) {
        return !visit["break"] && (visit.finish_time != null);
      });
      lastTracked = _getLastTracked(routeId);
      return formatted = {
        id: driverRoute.id,
        routeId: routeId,
        vehicleId: vehicleId,
        name: driverRoute.driver.name,
        numStops: numStops.length,
        phone: phone || "",
        newPhone: null,
        dispatchStatus: RouteUtil.getDispatchStatus(dispatch, routeDispatchInfo, phone, AccountF.hasGPSTracking()),
        lastUpdated: _getLastUpdated(seenDate, sentDate, phone, routeId, lastTracked, RouteUtil.getDoneTime(dispatch)),
        hasDispatch: dispatch != null,
        routeLink: DispatchF.getRouteLink(routeId, vehicleId),
        isVisible: true,
        editNumber: false
      };
    };
    _addRouteVisibilityListener = function(route) {
      return RouteS.addVisibilityEventListener(route.id, function(isVisible) {
        return route.isVisible = isVisible;
      });
    };
    _getRoutesInfo = function() {
      var dispatch, dispatches, driverRoute, driverRoutes, driverRoutesById, fleet, fleetMap, formattedRoute, hasVisits, results, route, routeDispatchInfo, routeDispatches, routes, sentTime, sentTimes, sortedDriverIds, sortedFleet, vehicle, _i, _j, _len, _len1;
      route = RouteS.getRoute();
      if ((route != null ? route.solution : void 0) == null) {
        return;
      }
      results = [];
      fleet = _.cloneDeep(route.solution.request.fleet);
      fleetMap = {};
      _.every(fleet, function(d) {
        return fleetMap[d.id] = d;
      });
      sortedDriverIds = DriverSorter.getSortedDriverIds();
      sortedDriverIds = _.filter(sortedDriverIds, function(id) {
        return !!fleetMap[id];
      });
      sortedFleet = _.map(sortedDriverIds, function(id) {
        return fleetMap[id];
      });
      routeDispatches = route.dispatches;
      routes = _.pick(route.solution, _.isArray);
      driverRoutes = RouteUtil.parseRouteDispatch(fleet, routes);
      driverRoutes = _.cloneDeep(driverRoutes);
      sentTimes = DispatchStatusF.getSentTimes();
      dispatches = DispatchF.getDispatches();
      driverRoutesById = {};
      for (_i = 0, _len = driverRoutes.length; _i < _len; _i++) {
        route = driverRoutes[_i];
        driverRoutesById[route.id] = route;
      }
      for (_j = 0, _len1 = sortedFleet.length; _j < _len1; _j++) {
        vehicle = sortedFleet[_j];
        driverRoute = driverRoutesById[vehicle.id];
        hasVisits = driverRoute.numVisits > 0;
        if (hasVisits || !GanttSettings.getHideEmptyVehicles()) {
          routeDispatchInfo = routeDispatches[vehicle.id];
          dispatch = dispatches[vehicle.id];
          sentTime = sentTimes[vehicle.id];
          formattedRoute = _formatDriverRoute(driverRoute, routeDispatchInfo, dispatch, sentTime);
          _addRouteVisibilityListener(formattedRoute);
          results.push(formattedRoute);
        }
      }
      return results;
    };
    this.toggleRouteVisibility = function(route) {
      var isVisible = !route.isVisible;
      RouteS.setRouteVisible(route.id, isVisible);
      return route.isVisible = isVisible;
    };
    this.toggleInfoWindow = function(id) {
      return GMarkerF.toggleAndCloseOtherWindow(id);
    };
    this.goToEditDriver = function(route) {
      return $state.go(States.projectDriversEdit, {
        driverID: route.id
      });
    };
    this.routesInfo = _getRoutesInfo();
    this.showSuccessfulCopy = function(driverName) {
      return MessagingF.replaceSuccessPopup("MESSAGES.ROUTE_COPIED_SUCCESS", {
        driverName: driverName
      });
    };
    this.showCopyErrorMessage = function() {
      if (!this.clipboardCopySupported) {
        return MessagingF.replaceError("MESSAGES.CLIPBOARD_COPY_NOT_SUPPORTED");
      }
    };
    this.resendSms = function(routeId, vehicleId, driverName) {
      return DispatchF.resendSms(routeId, vehicleId).then(function(status) {
        if (status === 200) {
          return MessagingF.replaceSuccessPopup("MESSAGES.ROUTE_LINK_RESEND_SUCCESS", {
            driverName: driverName
          });
        } else {
          return MessagingF.replaceError("MESSAGES.ROUTE_LINK_RESEND_ERROR", {
            driverName: driverName
          });
        }
      })["catch"](function(err) {
        return MessagingF.replaceError("MESSAGES.ROUTE_LINK_RESEND_ERROR", {
          driverName: driverName
        });
      });
    };
    _initializeEventListeners();
  };
  RouteDispatchC.$inject = ["$state", "$translate", "States", "ProjectF", "DispatchStatusF", "AccountF", "RouteS", "RouteUtil", "DispatchF", "EventListenersF", "Events", "TimeUtilF", "Constants", "MessagingF", "GMarkerF", "GPSRoutesF", "DriverSorter", "GanttSettings"];

  angular.module('app').controller('RouteDispatchC', RouteDispatchC);

}).call(this);

(function() {
  var RouteDownloadF = function(AccountF, AnalyticsS, CsvExporter, VisitCsvHeaderF, DispatchF, DistanceUtilF, RouteS, SettingsF, TimeUtilF) {
    var DEFAULT_SOLUTION_MAPPING, DISTANCE_ID, HeaderMap, KILOMETER_IN_METER, ONE_MINUTE_IN_MS, downloadCsv, getCsvFilename, getSolutionCsv, getSolutionFilename, getSummaryCsv, getSummaryFilename, _fileNameDetail, _getCustomNotesHeader, _getHeader, _getRoute, _parseData, _sortByStartTime;
    HeaderMap = (function() {
      function HeaderMap(id, name) {
        this.id = id;
        this.name = name;
      }

      return HeaderMap;

    })();
    ONE_MINUTE_IN_MS = 1000 * 60;
    DISTANCE_ID = 'distance';
    KILOMETER_IN_METER = 1000;
    DEFAULT_SOLUTION_MAPPING = [new HeaderMap('driverName', 'Driver Name'), new HeaderMap('driverPhone', 'Driver Phone'), new HeaderMap('stopNumber', 'Stop Number'), new HeaderMap('visitName', 'Visit Name'), new HeaderMap('address', 'Address'), new HeaderMap('street', 'Street'), new HeaderMap('city', 'City'), new HeaderMap('state', 'State'), new HeaderMap('zipCode', 'Zip code'), new HeaderMap('latitude', 'Latitude'), new HeaderMap('longitude', 'Longitude'), new HeaderMap('start', 'Time window start'), new HeaderMap('end', 'Time window end'), new HeaderMap('arriveAt', 'Arrive at'), new HeaderMap('startAt', 'Start at'), new HeaderMap('finishBy', 'Finish by'), new HeaderMap('duration', 'Duration'), new HeaderMap('idleTime', 'Idle time'), new HeaderMap(DISTANCE_ID, "Distance"), new HeaderMap('load', 'Load'), new HeaderMap('phone', 'Phone'), new HeaderMap('email', 'Email'), new HeaderMap('types', 'Types'), new HeaderMap('notes', 'Notes'), new HeaderMap('notes2', 'Notes 2'), new HeaderMap('photoUrl', 'Photo Url')];
    _getRoute = function() {
      return RouteS.getRoute();
    };
    _getCustomNotesHeader = function() {
      var column, _i, _len, _ref, _results;
      _ref = VisitCsvHeaderF.columns;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        column = _ref[_i];
        if (column.isUserDefined) {
          _results.push(column.name);
        }
      }
      return _results;
    };
    _getHeader = function(customHeaderMap, customNotesHeader) {
      var map, name, _i, _len;
      var header = [];
      for (_i = 0, _len = customHeaderMap.length; _i < _len; _i++) {
        map = customHeaderMap[_i];
        if (!(!!map.id && !!map.name)) {
          continue;
        }
        name = map.name;
        if (map.id === DISTANCE_ID) {
          name = name + ("(" + SettingsF.settings.distanceFormat + ")");
        }
        header.push(name);
      }
      header = header.concat(customNotesHeader);
      return header;
    };
    _parseData = function(solutions, customHeaderMap, customNotesHeader) {
      var current, data, header, row, step, value, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref2, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref3, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;
      data = [];
      for (_i = 0, _len = solutions.length; _i < _len; _i++) {
        current = solutions[_i];
        _ref = current.steps;
        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
          step = _ref[_j];
          row = [];
          for (_k = 0, _len2 = customHeaderMap.length; _k < _len2; _k++) {
            header = customHeaderMap[_k];
            if (!(!!header.id && !!header.name)) {
              continue;
            }
            value = null;
            switch (header.id) {
              case 'driverName':
                value = current.driver.name;
                break;
              case 'driverPhone':
                value = current.driver.phoneNumber;
                break;
              case 'stopNumber':
                value = step.stopNumber;
                break;
              case 'visitName':
                value = (_ref1 = step.visit) != null ? _ref1.name : void 0;
                break;
              case 'address':
                value = step.location_name;
                break;
              case 'street':
                value = (_ref2 = step.visit) != null ? (_ref3 = _ref2.location) != null ? _ref3.street : void 0 : void 0;
                break;
              case 'city':
                value = (_ref4 = step.visit) != null ? (_ref5 = _ref4.location) != null ? _ref5.city : void 0 : void 0;
                break;
              case 'state':
                value = (_ref6 = step.visit) != null ? (_ref7 = _ref6.location) != null ? _ref7.state : void 0 : void 0;
                break;
              case 'zipCode':
                value = (_ref8 = step.visit) != null ? (_ref9 = _ref8.location) != null ? _ref9.zipCode : void 0 : void 0;
                break;
              case 'latitude':
                value = (_ref10 = step.coords) != null ? _ref10.lat : void 0;
                break;
              case 'longitude':
                value = (_ref11 = step.coords) != null ? _ref11.lng : void 0;
                break;
              case 'start':
                value = TimeUtilF.convertDateToTime((_ref12 = step.visit) != null ? _ref12.startDate : void 0);
                break;
              case 'end':
                value = TimeUtilF.convertDateToTime((_ref13 = step.visit) != null ? _ref13.endDate : void 0);
                break;
              case 'arriveAt':
                value = step.arrival_time;
                break;
              case 'startAt':
                value = step.start_time;
                break;
              case 'finishBy':
                value = step.finish_time;
                break;
              case 'duration':
                value = (_ref14 = step.visit) != null ? _ref14.duration : void 0;
                break;
              case 'idleTime':
                value = step.idle_time || '0';
                break;
              case 'load':
                value = (_ref15 = step.visit) != null ? _ref15.load : void 0;
                break;
              case 'distance':
                if (step.distance != null) {
                  value = DistanceUtilF.getDistance(step.distance / KILOMETER_IN_METER, SettingsF.settings.distanceFormat).toString();
                }
                break;
              case 'phone':
                value = (_ref16 = step.visit) != null ? _ref16.phone : void 0;
                break;
              case 'email':
                value = (_ref17 = step.visit) != null ? _ref17.email : void 0;
                break;
              case 'photoUrl':
                value = (_ref18 = step.visit) != null ? (_ref19 = _ref18.visitStatus) != null ? _ref19.photoUrl : void 0 : void 0;
                break;
              case 'types':
                value = (_ref20 = step.visit) != null ? (_ref21 = _ref20.types) != null ? _ref21.join(', ') : void 0 : void 0;
                break;
              case 'notes':
                value = (_ref22 = step.visit) != null ? _ref22.notes : void 0;
                break;
              case 'notes2':
                value = (_ref23 = step.visit) != null ? _ref23.notes2 : void 0;
                if (!value) {
                  value = (_ref24 = step.visit) != null ? (_ref25 = _ref24.customNotes) != null ? _ref25["Notes 2"] : void 0 : void 0;
                }
                break;
              case 'stopStatus':
                if (((_ref26 = step.visit) != null ? (_ref27 = _ref26.visitStatus) != null ? (_ref28 = _ref27.info) != null ? _ref28.status : void 0 : void 0 : void 0) != null) {
                  value = step.visit.visitStatus.info.status;
                }
                break;
              case 'confirmationTime':
                if (((_ref29 = step.visit) != null ? (_ref30 = _ref29.visitStatus) != null ? (_ref31 = _ref30.info) != null ? _ref31.date : void 0 : void 0 : void 0) != null) {
                  value = step.visit.visitStatus.info.date.toTimeString().split(' ')[0].substring(0, 5);
                }
                break;
              case 'reason':
                if (((_ref32 = step.visit) != null ? (_ref33 = _ref32.visitStatus) != null ? (_ref34 = _ref33.info) != null ? _ref34.reason : void 0 : void 0 : void 0) != null) {
                  value = step.visit.visitStatus.info.reason;
                }
                break;
              case 'driverNotes':
                if (((_ref35 = step.visit) != null ? (_ref36 = _ref35.visitStatus) != null ? (_ref37 = _ref36.info) != null ? _ref37.notes : void 0 : void 0 : void 0) != null) {
                  value = step.visit.visitStatus.info.notes;
                }
            }
            row.push(value || '');
          }
          for (_l = 0, _len3 = customNotesHeader.length; _l < _len3; _l++) {
            header = customNotesHeader[_l];
            row.push(((_ref38 = step.visit) != null ? (_ref39 = _ref38.customNotes) != null ? _ref39[header] : void 0 : void 0) || '');
          }
          data.push(row);
        }
      }
      return data;
    };
    _fileNameDetail = function(name, date) {
      var detail = [];
      if (name != null) {
        detail.push(name);
      }
      detail.push(date);
      return detail.join(' - ');
    };
    _sortByStartTime = function(solutions) {
      var err;
      try {
        return solutions = _.sortBy(solutions, function(solution) {
          var _ref, _ref1;
          return (_ref = solution.steps) != null ? (_ref1 = _ref[0]) != null ? _ref1.arrival_time : void 0 : void 0;
        });
      } catch (_error) {
        err = _error;
        return console.log(err);
      } finally {
        return solutions;
      }
    };
    getCsvFilename = function(name, date) {
      return "Routific - " + (_fileNameDetail(name, date)) + ".csv";
    };
    getSolutionFilename = function(name, date) {
      return "Routific solution - " + (_fileNameDetail(name, date)) + ".csv";
    };
    getSummaryFilename = function(name, date) {
      return "Routific summary - " + (_fileNameDetail(name, date)) + ".csv";
    };
    getSummaryCsv = function() {
      var distance, shift, summaryHeader, _i, _len, _ref;
      var data = [];
      summaryHeader = ['Driver Name', 'Time(min)', "Distance(" + SettingsF.settings.distanceFormat + ")", 'Number of Stops'];
      data.push(summaryHeader);
      _ref = _getRoute().shifts;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        shift = _ref[_i];
        distance = DistanceUtilF.getDistance(shift.distance, SettingsF.settings.distanceFormat);
        data.push([shift.driver.name, shift.shiftTime / ONE_MINUTE_IN_MS, distance, shift.numVisits]);
      }
      return data;
    };
    getSolutionCsv = function() {
      var customHeaderMap, customNotesHeader, data, solutionData, solutions, sortedSolutions;
      data = [];
      customNotesHeader = _getCustomNotesHeader();
      customHeaderMap = AccountF.getUser().csvHeaders || DEFAULT_SOLUTION_MAPPING;
      if (AccountF.hasLiveTracking() || DispatchF.hasLiveTrackingInVisit()) {
        customHeaderMap = _.cloneDeep(customHeaderMap);
        customHeaderMap.push(new HeaderMap('stopStatus', 'Stop Status'));
        customHeaderMap.push(new HeaderMap('confirmationTime', 'Completion/skipped Time'));
        customHeaderMap.push(new HeaderMap('reason', 'Skipped Reason'));
        customHeaderMap.push(new HeaderMap('driverNotes', 'Driver Notes'));
      }
      data.push(_getHeader(customHeaderMap, customNotesHeader));
      solutions = DispatchF.getAllSolutions();
      sortedSolutions = _sortByStartTime(solutions);
      solutionData = _parseData(sortedSolutions, customHeaderMap, customNotesHeader);
      data = data.concat(solutionData);
      return data;
    };
    downloadCsv = function(name, date) {
      var csvs, solutionData, summaryData;
      solutionData = getSolutionCsv();
      summaryData = getSummaryCsv();
      csvs = [new CsvExporter.CSV(getSolutionFilename(name, date), solutionData), new CsvExporter.CSV(getSummaryFilename(name, date), summaryData)];
      return CsvExporter.save(csvs);
    };
    return {
      getCsvFilename: getCsvFilename,
      getSolutionFilename: getSolutionFilename,
      getSummaryFilename: getSummaryFilename,
      getSummaryCsv: getSummaryCsv,
      getSolutionCsv: getSolutionCsv,
      downloadCsv: downloadCsv
    };
  };
  RouteDownloadF.$inject = ["AccountF", "AnalyticsS", "CsvExporter", "VisitCsvHeaderF", "DispatchF", "DistanceUtilF", "RouteS", "SettingsF", "TimeUtilF"];

  angular.module('app').factory('RouteDownloadF', RouteDownloadF);

}).call(this);

(function() {
  var RouteHistoryF = function(LocalStorageArrayF, LocalStorageObjectF, PolylineUtil) {
    var MAX_NUM_HISTORY, _formatRouteHistory, _getNumLocksFromRoute, _getSize, _historyIndex, _polylinesStorage, _saveHistoryIndex, _setHistoryIndex, _trimHistory;
    MAX_NUM_HISTORY = 20;
    _historyIndex = LocalStorageObjectF('historyIndex');
    _getSize = function() {
      return RouteHistoryF.routes.data.length;
    };
    _setHistoryIndex = function(index) {
      RouteHistoryF.currentIndex = index;
      return _historyIndex.set(index);
    };
    _saveHistoryIndex = function() {
      return _historyIndex.set(RouteHistoryF.currentIndex);
    };
    _trimHistory = function() {
      var numExcessRoute = _getSize() - RouteHistoryF.currentIndex - 1;
      while (numExcessRoute > 0) {
        RouteHistoryF.routes.pop();
        numExcessRoute--;
      }
      if (_getSize() >= MAX_NUM_HISTORY) {
        return RouteHistoryF.routes.shift();
      }
    };
    _getNumLocksFromRoute = function(route) {
      var k, routeLocks, v;
      var i = 0;
      routeLocks = route.routeLocks;
      if (routeLocks != null) {
        for (k in routeLocks) {
          v = routeLocks[k];
          if (v) {
            i++;
          }
        }
      }
      return i;
    };
    _formatRouteHistory = function(route) {
      return {
        time: Date.now(),
        numLocks: _getNumLocksFromRoute(route),
        data: route
      };
    };
    RouteHistoryF = {};
    RouteHistoryF.routes = LocalStorageArrayF('routes');
    _polylinesStorage = LocalStorageArrayF('polylines');
    _polylinesStorage.erase();
    RouteHistoryF.clear = function() {
      return RouteHistoryF.routes.erase();
    };
    RouteHistoryF.clearAllExceptCurrent = function() {
      var current = _.cloneDeep(RouteHistoryF.getRoute());
      RouteHistoryF.clear();
      return RouteHistoryF.push(current);
    };
    RouteHistoryF.push = function(route) {
      _trimHistory();
      RouteHistoryF.routes.push(_formatRouteHistory(route));
      return _setHistoryIndex(_getSize() - 1);
    };
    RouteHistoryF.updateCurrentRoute = function(route) {
      var clonedRoute = _formatRouteHistory(_.cloneDeep(route));
      return RouteHistoryF.routes.replace(RouteHistoryF.currentIndex, clonedRoute);
    };
    RouteHistoryF.pop = function() {
      RouteHistoryF.routes.pop();
      return _setHistoryIndex(_getSize() - 1);
    };
    RouteHistoryF.goToPrevious = function() {
      if (RouteHistoryF.currentIndex > 0) {
        return _setHistoryIndex(RouteHistoryF.currentIndex - 1);
      }
    };
    RouteHistoryF.goToNext = function() {
      if (RouteHistoryF.currentIndex < (_getSize() - 1)) {
        return _setHistoryIndex(RouteHistoryF.currentIndex + 1);
      }
    };
    RouteHistoryF.goToFirst = function() {
      if (RouteHistoryF.currentIndex > 0) {
        return _setHistoryIndex(0);
      }
    };
    RouteHistoryF.seek = function(offset) {
      if (offset == null) {
        offset = 0;
      }
      return RouteHistoryF.routes.data[RouteHistoryF.currentIndex + offset];
    };
    RouteHistoryF.getRoute = function() {
      var currentRoute = RouteHistoryF.routes.data[RouteHistoryF.currentIndex];
      return (currentRoute != null ? currentRoute.data : void 0) || currentRoute;
    };
    RouteHistoryF.getRouteTime = function() {
      var currentRoute = RouteHistoryF.routes.data[RouteHistoryF.currentIndex];
      return currentRoute != null ? currentRoute.time : void 0;
    };
    RouteHistoryF.getPolyline = function() {
      var colors, id, polylines, response, route, _ref;
      route = RouteHistoryF.getRoute();
      if (route) {
        polylines = route.polylines;
        polylines = PolylineUtil.decodePolylines(polylines, route.pl_precision);
        colors = {};
        _ref = route.solution.response;
        for (id in _ref) {
          response = _ref[id];
          colors[id] = response.color;
        }
        polylines = PolylineUtil.generateLines(polylines, colors);
      }
      return polylines;
    };
    RouteHistoryF.load = function() {
      RouteHistoryF.routes.load();
      _historyIndex.load();
      if (typeof _historyIndex.data !== 'number') {
        _historyIndex.set(_getSize() - 1);
      }
      return RouteHistoryF.currentIndex = _historyIndex.data;
    };
    RouteHistoryF.currentIndex = -1;
    RouteHistoryF.getNumHistory = _getSize;
    return RouteHistoryF;
  };
  RouteHistoryF.$inject = ["LocalStorageArrayF", "LocalStorageObjectF", "PolylineUtil"];

  angular.module('app').factory('RouteHistoryF', RouteHistoryF);

}).call(this);

(function() {
  var RouteInspectorF = function($translate, TimeUtilF, LocalStorageObjectF, Constants, EventListenersF, Events, SettingsF, UnservedUtil, LoggerF) {
    var UNSERVED_MESSAGE_KEYS_MAP, id, messageKey, _addBreakWarning, _addWarning, _breakId, _cacheWarnings, _clearWarnings, _inspectBreakTime, _inspectCapacity, _inspectDriverShift, _inspectUnserved, _inspectVisitTimeWindow, _inspectVisitType, _notifyOfWarningChanges, _ref, _save, _warnings;
    UNSERVED_MESSAGE_KEYS_MAP = {};
    _ref = Constants.unservedMessages;
    for (id in _ref) {
      messageKey = _ref[id];
      UNSERVED_MESSAGE_KEYS_MAP[messageKey] = messageKey;
    }
    UNSERVED_MESSAGE_KEYS_MAP[Constants.unservedMessages.constraints] = Constants.unservedMessages.unscheduled;
    RouteInspectorF = {};
    _cacheWarnings = LocalStorageObjectF('warnings');
    _warnings = _cacheWarnings.load();
    _breakId = function(driverId) {
      if (!driverId) {
        return;
      }
      return "" + driverId + "_break";
    };
    _addWarning = function(id, messageKey, messageDescription) {
      var warning = {
        key: messageKey,
        description: messageDescription ? UnservedUtil.formatReason(messageDescription) : void 0,
        solution: messageDescription ? UnservedUtil.formatSolution(messageDescription) : void 0
      };
      if (_warnings[id] == null) {
        _warnings[id] = [];
      }
      return _warnings[id].push(warning);
    };
    _addBreakWarning = function(driverId, messageKey) {
      return _addWarning(_breakId(driverId), messageKey);
    };
    _clearWarnings = function() {
      return _warnings = {};
    };
    _save = function() {
      var toSave = _.cloneDeep(_warnings);
      return _cacheWarnings.set(toSave);
    };
    _inspectDriverShift = function(drivers, solution) {
      var driver, endShift, endTime, lastVisit, startShift, startTime, visits, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = drivers.length; _i < _len; _i++) {
        driver = drivers[_i];
        if (!solution[driver.id]) {
          continue;
        }
        visits = solution[driver.id].visits;
        if (driver.startShift) {
          startTime = TimeUtilF.convertTimeToDate(visits[0].arrival_time);
          startShift = new Date(driver.startShift);
          if (TimeUtilF.compareDates(startTime, startShift) < 0) {
            _addWarning(driver.id, 'WARNINGS.BEGINS_EARLY');
          }
        }
        if (driver.endShift) {
          lastVisit = visits[visits.length - 1];
          endTime = lastVisit.finish_time || lastVisit.arrival_time;
          endTime = TimeUtilF.convertTimeToDate(endTime);
          endShift = new Date(driver.endShift);
          if (TimeUtilF.compareDates(endTime, endShift) > 0) {
            _results.push(_addWarning(driver.id, 'WARNINGS.FINISHES_LATE'));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };
    _inspectUnserved = function(unserved) {
      var data, knownKey, messageDescription, reason, _results;
      if (unserved != null) {
        _results = [];
        for (id in unserved) {
          data = unserved[id];
          reason = data.error;
          knownKey = UNSERVED_MESSAGE_KEYS_MAP[reason];
          messageKey = knownKey != null ? knownKey : Constants.unservedMessages.unscheduled;
          messageDescription = !knownKey && reason;
          _results.push(_addWarning(id, messageKey, messageDescription));
        }
        return _results;
      }
    };
    _inspectVisitTimeWindow = function(visits, solution) {
      var arrival, endWindow, finish, startWindow, vehicle, visit, visitObj, visitsMap, _i, _len, _results;
      visitsMap = {};
      for (_i = 0, _len = visits.length; _i < _len; _i++) {
        visit = visits[_i];
        visitsMap[visit.id] = visit;
      }
      _results = [];
      for (id in solution) {
        vehicle = solution[id];
        _results.push((function() {
          var _j, _len1, _ref1, _results1;
          _ref1 = vehicle.visits;
          _results1 = [];
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            visit = _ref1[_j];
            if (!(!visit["break"])) {
              continue;
            }
            visitObj = visitsMap[visit.location_id];
            if (visitObj) {
              finish = TimeUtilF.convertTimeToDate(visit.finish_time);
              if (visitObj.endDate) {
                endWindow = new Date(visitObj.endDate);
                if (TimeUtilF.compareDates(finish, endWindow) > 0) {
                  _addWarning(visitObj.id, 'WARNINGS.LATE_FINISH');
                  continue;
                }
              }
              if (visitObj.startDate) {
                startWindow = new Date(visitObj.startDate);
                arrival = TimeUtilF.addMinutes(finish, -(visit.duration || 0));
                if (TimeUtilF.compareDates(arrival, startWindow) < 0) {
                  _results1.push(_addWarning(visitObj.id, 'WARNINGS.EARLY_ARRIVAL'));
                } else {
                  _results1.push(void 0);
                }
              } else {
                _results1.push(void 0);
              }
            } else {
              _results1.push(void 0);
            }
          }
          return _results1;
        })());
      }
      return _results;
    };
    _inspectVisitType = function(visits, drivers, solution, routes) {
      var driver, err, isSupported, payload, routeId, supportedType, type, unsupported, vehicle, visit, visitObj, visitsMap, _driverTypes, _i, _j, _k, _len, _len1, _len2, _ref1, _results;
      _driverTypes = {};
      for (_i = 0, _len = drivers.length; _i < _len; _i++) {
        driver = drivers[_i];
        if (!(!!driver.types)) {
          continue;
        }
        _driverTypes[driver.id] = {};
        _ref1 = driver.types;
        for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
          type = _ref1[_j];
          _driverTypes[driver.id][type] = true;
        }
      }
      visitsMap = {};
      for (_k = 0, _len2 = visits.length; _k < _len2; _k++) {
        visit = visits[_k];
        visitsMap[visit.id] = visit;
      }
      _results = [];
      for (id in solution) {
        vehicle = solution[id];
        supportedType = _driverTypes[id];
        _results.push((function() {
          var _l, _len3, _len4, _m, _ref2, _ref3, _ref4, _results1;
          _ref2 = vehicle.visits;
          _results1 = [];
          for (_l = 0, _len3 = _ref2.length; _l < _len3; _l++) {
            visit = _ref2[_l];
            if (!(!!visit.finish_time && !visit["break"])) {
              continue;
            }
            visitObj = visitsMap[visit.location_id];
            if (!visitObj) {
              routeId = routes != null ? (_ref3 = routes.find(function(r) {
                return r._id === id;
              })) != null ? _ref3.routeId : void 0 : void 0;
              payload = {
                visit: visit,
                routeId: routeId
              };
              try {
                throw new Error();
              } catch (_error) {
                err = _error;
                payload.stack = err.stack;
              }
              LoggerF.error(LoggerF.ACTIONS.PROJECT_CORRUPTED, payload, "Visit from solution is missing in visits list");
            }
            unsupported = [];
            if (visitObj.types && (visitObj.types.length > 0)) {
              isSupported = false;
              _ref4 = visitObj.types;
              for (_m = 0, _len4 = _ref4.length; _m < _len4; _m++) {
                type = _ref4[_m];
                if (supportedType != null ? supportedType[type] : void 0) {
                  isSupported = true;
                  break;
                }
              }
              if (!isSupported) {
                _results1.push(_addWarning(visitObj.id, 'WARNINGS.UNSUPPORTED_TYPES'));
              } else {
                _results1.push(void 0);
              }
            } else {
              _results1.push(void 0);
            }
          }
          return _results1;
        })());
      }
      return _results;
    };
    _inspectBreakTime = function(drivers, solution) {
      var breakEnd, breakStart, breakTimes, brk, driver, driverBreak, idleTime, vehicle, visit, _i, _len, _ref1, _results;
      breakTimes = {};
      for (_i = 0, _len = drivers.length; _i < _len; _i++) {
        driver = drivers[_i];
        if (!((driver.breaks != null) && driver.breaks.length > 0)) {
          continue;
        }
        brk = (_ref1 = driver.breaks) != null ? _ref1[0] : void 0;
        breakTimes[driver.id] = {
          start: brk.start,
          end: brk.end
        };
      }
      _results = [];
      for (id in solution) {
        vehicle = solution[id];
        if (!(!!breakTimes[id])) {
          continue;
        }
        driverBreak = breakTimes[id];
        _results.push((function() {
          var _j, _len1, _ref2, _results1;
          _ref2 = vehicle.visits;
          _results1 = [];
          for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
            visit = _ref2[_j];
            if (visit["break"]) {
              breakStart = TimeUtilF.convertTimeToDate(visit.arrival_time);
              idleTime = visit.idle_time;
              if (idleTime) {
                breakStart = TimeUtilF.addMinutes(breakStart, idleTime);
              }
              if (breakStart < driverBreak.start) {
                _addBreakWarning(id, 'WARNINGS.EARLY_BREAK');
                break;
              }
              breakEnd = TimeUtilF.convertTimeToDate(visit.finish_time);
              if (breakEnd > driverBreak.end) {
                _addBreakWarning(id, 'WARNINGS.LATE_BREAK');
              }
              break;
            } else {
              _results1.push(void 0);
            }
          }
          return _results1;
        })());
      }
      return _results;
    };
    _inspectCapacity = function(visits, drivers, solution) {
      var capacity, currentLoad, driver, loads, route, visit, _i, _j, _k, _len, _len1, _len2, _ref1, _ref2, _results;
      loads = {};
      for (_i = 0, _len = visits.length; _i < _len; _i++) {
        visit = visits[_i];
        loads[visit.id] = visit.load || 0;
      }
      _results = [];
      for (_j = 0, _len1 = drivers.length; _j < _len1; _j++) {
        driver = drivers[_j];
        id = driver.id;
        route = solution[id];
        if (route) {
          capacity = driver.capacity;
          _ref1 = route.visits;
          for (_k = 0, _len2 = _ref1.length; _k < _len2; _k++) {
            visit = _ref1[_k];
            if (!visit.finish_time) {
              continue;
            }
            if (visit.location_id === 'nowhere') {
              continue;
            }
            currentLoad = loads[visit.location_id];
            if (currentLoad == null) {
              currentLoad = (_ref2 = solution.settings) != null ? _ref2.load : void 0;
            }
            if (currentLoad == null) {
              currentLoad = Constants.DEFAULT_LOAD;
            }
            capacity -= currentLoad;
          }
          if (capacity < 0) {
            _results.push(_addWarning(id, 'WARNINGS.OVER_CAPACITY'));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };
    _notifyOfWarningChanges = function() {
      return EventListenersF.notify(Events.VISIT_WARNINGS_CHANGED, _warnings);
    };
    RouteInspectorF.inspectRoute = function(route, visits, drivers) {
      var routes, solution;
      _clearWarnings();
      solution = route.solution.response;
      routes = route.routes;
      _inspectDriverShift(drivers, solution);
      _inspectUnserved(route.unserved);
      _inspectVisitTimeWindow(visits, solution);
      _inspectVisitType(visits, drivers, solution, routes);
      _inspectBreakTime(drivers, solution);
      _inspectCapacity(visits, drivers, solution);
      _notifyOfWarningChanges();
      _save();
      return _warnings;
    };
    RouteInspectorF.clearWarnings = function() {
      _clearWarnings();
      return _save();
    };
    RouteInspectorF.getWarnings = function(id) {
      return _warnings[id];
    };
    RouteInspectorF.getBreakWarnings = function(driverId) {
      if (!driverId) {
        return;
      }
      return _warnings[_breakId(driverId)];
    };
    return RouteInspectorF;
  };
  RouteInspectorF.$inject = ["$translate", "TimeUtilF", "LocalStorageObjectF", "Constants", "EventListenersF", "Events", "SettingsF", "UnservedUtil", "LoggerF"];

  angular.module('app').factory('RouteInspectorF', RouteInspectorF);

}).call(this);

(function() {
  var RouteMarkerInfoF = function(LocalStorageObjectF, EventListenersF, Events) {
    var _cacheMarkersInfo, _clearMarkerInfo, _markersInfo, _save, _setMarkerInfo;
    _cacheMarkersInfo = LocalStorageObjectF('markersInfo');
    _markersInfo = _cacheMarkersInfo.load();
    _setMarkerInfo = function(id, fill, order, driverId) {
      var info = {
        fill: fill,
        order: order,
        driverId: driverId
      };
      EventListenersF.notify(Events.VISIT_ROUTE_INFO_CHANGED(id), info);
      return _markersInfo[id] = info;
    };
    _clearMarkerInfo = function() {
      var id, _results;
      _results = [];
      for (id in _markersInfo) {
        _markersInfo[id] = null;
        EventListenersF.notify(Events.VISIT_ROUTE_INFO_CHANGED(id), null);
        _results.push(delete _markersInfo[id]);
      }
      return _results;
    };
    _save = function() {
      var toSave = _.cloneDeep(_markersInfo);
      return _cacheMarkersInfo.set(toSave);
    };
    RouteMarkerInfoF = {};
    RouteMarkerInfoF.updateAllMarkerInfo = function(solution, unserved) {
      var color, data, id, index, locationID, visit, _i, _len, _ref;
      _clearMarkerInfo();
      for (id in solution) {
        data = solution[id];
        color = data.color.name;
        index = 1;
        _setMarkerInfo(id, color, '', id);
        _ref = data.visits;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          visit = _ref[_i];
          if (!visit.finish_time) {
            continue;
          }
          locationID = visit.location_id;
          if (visit["break"]) {
            _setMarkerInfo(locationID, color, '', id);
          } else {
            _setMarkerInfo(locationID, color, index++, id);
          }
        }
      }
      index = 1;
      for (id in unserved) {
        data = unserved[id];
        _setMarkerInfo(id, data.color.name, index++, 'none');
      }
      _save();
      return _markersInfo;
    };
    RouteMarkerInfoF.clearInfo = function() {
      _clearMarkerInfo();
      return _save();
    };
    RouteMarkerInfoF.markersInfo = _markersInfo;
    return RouteMarkerInfoF;
  };
  RouteMarkerInfoF.$inject = ["LocalStorageObjectF", "EventListenersF", "Events"];

  angular.module('app').factory('RouteMarkerInfoF', RouteMarkerInfoF);

}).call(this);

(function() {
  var RouteS,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  RouteS = (function() {
    var AUTO_BALANCE_RATIO, BREAK_ID, DUMMY_VISIT_NAME, FIX_REQUEST_ERROR, FIX_REQUEST_ERROR_MSG, GOOGLE_POLYLINE_PRECISION, OSRM_POLYLINE_PRECISION, TYPE_FIX, TYPE_MIN_IDLE, _$http, _$injector, _$q, _$timeout, __getCoefficient, _accountF, _addEventListeners, _addRouteId, _analyticsS, _anyRoutesVisible, _apiPath, _checkAndRemoveConstraints, _checkAnyRoutesVisible, _clearVisibilityEventListeners, _constants, _defaultDuration, _defaultLoad, _destroyPolylines, _destroyRoutes, _dispatchF, _dispatchStatusF, _driverF, _emitRouteUpdatedEvent, _emitVisibilityEvent, _eventListenersF, _events, _fetchEmptyRoute, _fetchFix, _fetchFixRequests, _fetchFixWithRetry, _fetchLiveFixRequests, _fetchLiveMinIdleRequests, _fetchLiveRequests, _fetchMinIdle, _fetchMinIdleRequests, _fetchOptimizedRoute, _fetchVisits, _findAffectedVehicles, _findDriverIdWithStop, _findItem, _findUnaffectedVehicles, _fixSolutionIdleTime, _formatBreak, _formatFleet, _formatRoute, _formatVisits, _gMarkerF, _gPolylineF, _genUnserved, _getColor, _getDoneVisitsByVehicleId, _getDriverVisits, _getMaxEndDate, _getSolutionFromRoute, _getUnserved, _getUnservedAsArray, _getUnservedAsVisitsArray, _getVisitsAndDrivers, _hasTimeWindow, _inProgress, _isProjectBusy, _isUnservedsCompatible, _lengthenDriverShift, _load, _loggerF, _markerClustererF, _mergeOldSolution, _mergeRouteIdMap, _mergeRouteLocks, _mergeRoutes, _mergeSolutionWithDoneVisits, _mergeUnserved, _messagingF, _modifyDataWithDoneVisits, _modifyDataWithDoneVisitsByVehicleId, _modifyVehicleWithDoneVisitIds, _normalizePolylines, _parseLoads, _parseShifts, _parseSolution, _pendingRoutesCount, _polylineColors, _polylineUtil, _polylines, _projectF, _projectJobF, _refreshRoutes, _removeConstraints, _removeDoneVisitsFromData, _removeDummy, _removeUnservedTimeWindows, _removeVisitConstraints, _reoptimizedVehicles, _route, _routeHistoryF, _routeInspectorF, _routeMarkerInfoF, _routeUpdatedCallbacks, _routeVisibilityCallbacks, _saveOldSolution, _sessionF, _setFixRouteInProgress, _setOptimizationInProgress, _setRoute, _settingsF, _summary, _syncMarkersVisibility, _timeUtil, _toArray, _toFuture, _unservedColor, _unservedMessages, _updateRouteSummary, _updateVisitsCountWithNotification, _updateVisitsLockMapping, _visitCompatibilityF, _visitF, _visitUtilF, _visitsLockMapping, _visitsWithNotificationCount;

    _route = {};

    _pendingRoutesCount = 0;

    _summary = {};

    _polylines = {};

    _routeVisibilityCallbacks = {};

    _routeUpdatedCallbacks = [];

    _visitsLockMapping = {};

    _visitsWithNotificationCount = 0;

    _$http = void 0;

    _$q = void 0;

    _$injector = void 0;

    _$timeout = void 0;

    _accountF = void 0;

    _sessionF = void 0;

    _projectJobF = void 0;

    _apiPath = void 0;

    _defaultDuration = void 0;

    _defaultLoad = void 0;

    _polylineColors = void 0;

    _routeHistoryF = void 0;

    _unservedColor = void 0;

    _driverF = void 0;

    _visitF = void 0;

    _gPolylineF = void 0;

    _gMarkerF = void 0;

    _routeInspectorF = void 0;

    _routeMarkerInfoF = void 0;

    _markerClustererF = void 0;

    _timeUtil = void 0;

    _visitUtilF = void 0;

    _dispatchF = void 0;

    _dispatchStatusF = void 0;

    _settingsF = void 0;

    _inProgress = void 0;

    _polylineUtil = void 0;

    _eventListenersF = void 0;

    _events = void 0;

    _constants = void 0;

    _visitCompatibilityF = void 0;

    _unservedMessages = void 0;

    _anyRoutesVisible = void 0;

    _messagingF = void 0;

    _loggerF = void 0;

    _projectF = void 0;

    _analyticsS = void 0;

    AUTO_BALANCE_RATIO = 0.7;

    GOOGLE_POLYLINE_PRECISION = 5;

    OSRM_POLYLINE_PRECISION = 6;

    FIX_REQUEST_ERROR = ['ERR_INCOMPATIBLE_UNSERVED', 'ERR_UNABLE_TO_SQUEEZE_STOPS'];

    FIX_REQUEST_ERROR_MSG = "Sorry - we aren’t able to squeeze these stops in. Please adjust your parameters and try again.";

    DUMMY_VISIT_NAME = 'dummy';

    TYPE_MIN_IDLE = 'TYPE_MIN_IDLE';

    TYPE_FIX = 'TYPE_FIX';

    BREAK_ID = 'nowhere';

    function RouteS($http, $q, $timeout, $injector, Constants, PolylineColors, UnservedColor, AccountF, VisitF, DriverF, GPolylineF, GMarkerF, RouteHistoryF, RouteInspectorF, RouteMarkerInfoF, TimeUtilF, SettingsF, PolylineUtil, EventListenersF, Events, DispatchStatusF, VisitCompatibilityF, DispatchF, VisitUtilF, MarkerClustererF, MessagingF, LoggerF, AnalyticsS, SessionF, ProjectJobF) {
      this.getNumUnserved = __bind(this.getNumUnserved, this);
      this.getUnserved = __bind(this.getUnserved, this);
      this.hasUnserved = __bind(this.hasUnserved, this);
      this.scheduleUnserveds = __bind(this.scheduleUnserveds, this);
      this.reoptimize = __bind(this.reoptimize, this);
      this.fixRoute = __bind(this.fixRoute, this);
      var _currentLongOptimizeJob;
      _$http = $http;
      _$q = $q;
      _$injector = $injector;
      _$timeout = $timeout;
      _apiPath = Constants.apiPath;
      _defaultDuration = Constants.DEFAULT_DURATION;
      _defaultLoad = Constants.DEFAULT_LOAD;
      _polylineColors = PolylineColors;
      _unservedColor = UnservedColor;
      _accountF = AccountF;
      _sessionF = SessionF;
      _projectJobF = ProjectJobF;
      _visitF = VisitF;
      _visitUtilF = VisitUtilF;
      _driverF = DriverF;
      _gPolylineF = GPolylineF;
      _gMarkerF = GMarkerF;
      _routeHistoryF = RouteHistoryF;
      _routeInspectorF = RouteInspectorF;
      _routeMarkerInfoF = RouteMarkerInfoF;
      _markerClustererF = MarkerClustererF;
      _timeUtil = TimeUtilF;
      _dispatchF = DispatchF;
      _dispatchStatusF = DispatchStatusF;
      _settingsF = SettingsF;
      _messagingF = MessagingF;
      _polylineUtil = PolylineUtil;
      _eventListenersF = EventListenersF;
      _events = Events;
      _visitCompatibilityF = VisitCompatibilityF;
      _unservedMessages = Constants.unservedMessages;
      _inProgress = false;
      _anyRoutesVisible = true;
      _constants = Constants;
      _loggerF = LoggerF;
      _analyticsS = AnalyticsS;
      _projectF = void 0;
      _currentLongOptimizeJob = null;
      _load();
      _addEventListeners();
    }

    _formatVisits = function(entries) {
      var duration, entry, load, visit, visits, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
      visits = {};
      for (_i = 0, _len = entries.length; _i < _len; _i++) {
        entry = entries[_i];
        visit = {
          location: {
            name: (_ref = entry.location) != null ? _ref.address : void 0,
            lat: (_ref1 = entry.location) != null ? (_ref2 = _ref1.coords) != null ? _ref2.lat : void 0 : void 0,
            lng: (_ref3 = entry.location) != null ? (_ref4 = _ref3.coords) != null ? _ref4.lng : void 0 : void 0
          }
        };
        visit.start = _timeUtil.convertDateToTime(entry.startDate);
        visit.end = _timeUtil.convertDateToTime(entry.endDate);
        if (entry.types) {
          visit.type = entry.types;
        }
        duration = entry.duration || ((_ref5 = _settingsF.settings) != null ? _ref5.duration : void 0) || _defaultDuration;
        visit.duration = parseInt(duration, 10);
        load = entry.load;
        if (load == null) {
          load = (_ref6 = _settingsF.settings) != null ? _ref6.load : void 0;
        }
        if (load == null) {
          load = _defaultLoad;
        }
        visit.load = parseFloat(load);
        if (entry.isPriority) {
          visit.priority = 'high';
        } else {
          visit.priority = 'low';
        }
        visits[entry.id] = visit;
      }
      return visits;
    };

    _formatBreak = function(brk) {
      return {
        id: brk.id,
        start: _timeUtil.convertDateToTime(brk.start),
        end: _timeUtil.convertDateToTime(brk.end)
      };
    };

    _formatFleet = function(entries) {
      var breaks, data, driverBreak, entry, fleet, _i, _j, _len, _len1;
      fleet = {};
      for (_i = 0, _len = entries.length; _i < _len; _i++) {
        entry = entries[_i];
        data = {
          start_location: {
            id: entry.startLocation.id,
            name: entry.startLocation.info.address,
            lat: entry.startLocation.info.coords.lat,
            lng: entry.startLocation.info.coords.lng
          },
          shift_start: _timeUtil.convertDateToTime(entry.startShift),
          shift_end: _timeUtil.convertDateToTime(entry.endShift),
          speed: entry.speed
        };
        if (entry.endLocation != null) {
          data.end_location = {
            id: entry.endLocation.id,
            name: entry.endLocation.info.address,
            lat: entry.endLocation.info.coords.lat,
            lng: entry.endLocation.info.coords.lng
          };
        }
        if (entry.capacity != null) {
          data.capacity = entry.capacity;
        }
        if (entry.types != null) {
          data.type = entry.types;
        }
        data.breaks = [];
        breaks = entry.breaks || [];
        for (_j = 0, _len1 = breaks.length; _j < _len1; _j++) {
          driverBreak = breaks[_j];
          data.breaks.push(_formatBreak(driverBreak));
        }
        data['strict_start'] = !!data.shift_start && (entry.strictStart || _settingsF.settings.strictStart);
        fleet[entry.id] = data;
      }
      return fleet;
    };

    _getColor = function(index) {
      return _polylineColors[index % _polylineColors.length];
    };

    _fixSolutionIdleTime = function(solution) {
      var step, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = solution.length; _i < _len; _i++) {
        step = solution[_i];
        if (step.idle_time != null) {
          _results.push(step.idle_time = Math.ceil(step.idle_time));
        }
      }
      return _results;
    };

    _parseSolution = function(originalSolution, fleet) {
      var driver, id, index, isLocked, routeId, solution, visits, _ref, _ref1;
      solution = {};
      _ref = originalSolution.solution;
      for (id in _ref) {
        visits = _ref[id];
        index = _.findIndex(fleet, function(driver) {
          return driver.id === id;
        });
        driver = fleet[index];
        isLocked = !!((_ref1 = originalSolution.routeLocks) != null ? _ref1[id] : void 0);
        routeId = !!originalSolution.routeIdMap[id];
        _fixSolutionIdleTime(visits);
        solution[id] = {
          driver: driver,
          color: _getColor(index),
          visits: visits,
          isLocked: isLocked,
          routeId: routeId
        };
      }
      return solution;
    };

    _parseShifts = function(solution, fleet) {
      var actualWorkingTime, arrivalWithIdleDate, breakLength, color, distance, driver, driverShiftsOverview, finalDestination, finish, id, idleTime, numVisits, plannedShiftEnd, plannedShiftStart, plannedShiftTime, route, shiftTime, shifts, start, stop, total, vehicle, visit, visitArrivalTime, visitFinishTime, _i, _j, _k, _len, _len1, _len2;
      shifts = [];
      total = 0;
      driverShiftsOverview = {};
      for (_i = 0, _len = fleet.length; _i < _len; _i++) {
        vehicle = fleet[_i];
        id = vehicle.id;
        distance = solution.distances[id];
        color = solution.solution.response[id].color;
        driver = _findItem(id, fleet);
        route = solution.solution[id];
        plannedShiftStart = vehicle.startShift;
        plannedShiftEnd = vehicle.endShift;
        plannedShiftTime = void 0;
        if (plannedShiftStart && plannedShiftEnd) {
          plannedShiftTime = plannedShiftEnd.getTime() - plannedShiftStart.getTime();
        }
        start = _timeUtil.convertTimeToDate(route[0].arrival_time);
        finalDestination = route[route.length - 1];
        finish = finalDestination.finish_time || finalDestination.arrival_time;
        finish = _timeUtil.convertTimeToDate(finish);
        shiftTime = 0;
        actualWorkingTime = 0;
        if ((finish != null) && (start != null)) {
          shiftTime = finish.getTime() - start.getTime();
          actualWorkingTime = shiftTime;
          if (plannedShiftTime) {
            for (_j = 0, _len1 = route.length; _j < _len1; _j++) {
              visit = route[_j];
              arrivalWithIdleDate = _timeUtil.convertTimeToDate(visit.arrival_time);
              if (visit.idle_time) {
                idleTime = visit.idle_time;
                actualWorkingTime -= idleTime * 60000;
                arrivalWithIdleDate = _timeUtil.addMinutes(arrivalWithIdleDate, idleTime);
              }
              if (visit["break"]) {
                visitArrivalTime = arrivalWithIdleDate.getTime();
                visitFinishTime = _timeUtil.convertTimeToDate(visit.finish_time).getTime();
                breakLength = visitFinishTime - visitArrivalTime;
                actualWorkingTime -= breakLength;
                plannedShiftTime -= breakLength;
              }
              driverShiftsOverview[id] = {
                plannedShitTime: plannedShiftTime,
                actualWorkingTime: actualWorkingTime
              };
            }
          }
        }
        total += shiftTime;
        route = solution.solution[id];
        numVisits = 0;
        for (_k = 0, _len2 = route.length; _k < _len2; _k++) {
          stop = route[_k];
          if (stop.finish_time && !stop["break"]) {
            numVisits++;
          }
        }
        shifts.push({
          id: id,
          driver: driver,
          distance: distance,
          shiftTime: shiftTime,
          color: color,
          numVisits: numVisits
        });
      }
      return [total, shifts, driverShiftsOverview];
    };

    _parseLoads = function(solution, fleet, visits) {
      var driver, driverCapacity, driverId, formattedVisits, solutionVisit, solutionVisits, totalLoads, visitLoad, _i, _j, _len, _len1, _ref;
      var capacityOverview = {};
      formattedVisits = _formatVisits(visits);
      for (_i = 0, _len = fleet.length; _i < _len; _i++) {
        driver = fleet[_i];
        driverCapacity = driver.capacity;
        if (driverCapacity) {
          totalLoads = 0;
          driverId = driver.id;
          solutionVisits = solution.solution[driverId];
          for (_j = 0, _len1 = solutionVisits.length; _j < _len1; _j++) {
            solutionVisit = solutionVisits[_j];
            visitLoad = (_ref = formattedVisits[solutionVisit.location_id]) != null ? _ref.load : void 0;
            if (visitLoad) {
              totalLoads += visitLoad;
            }
          }
          capacityOverview[driverId] = {
            capacity: driverCapacity,
            loads: totalLoads
          };
        }
      }
      return capacityOverview;
    };

    _mergeUnserved = function(currentList, previousList) {
      var error, id, unserved, visit, _i, _len;
      unserved = {};
      for (id in currentList) {
        error = currentList[id];
        unserved[id] = _genUnserved(error);
      }
      if (previousList) {
        for (_i = 0, _len = previousList.length; _i < _len; _i++) {
          visit = previousList[_i];
          if (!unserved[visit.id]) {
            unserved[visit.id] = _genUnserved(visit.error);
          }
        }
      }
      return unserved;
    };

    _mergeRouteLocks = function(solution, oldRouteLocks) {
      var currentRouteLock, id, routeLocks, _ref;
      routeLocks = {};
      for (id in solution.solution) {
        currentRouteLock = (_ref = solution.routeLocks) != null ? _ref[id] : void 0;
        routeLocks[id] = !!currentRouteLock || !!(oldRouteLocks != null ? oldRouteLocks[id] : void 0);
      }
      return routeLocks;
    };

    _mergeRouteIdMap = function(solution, oldMap) {
      var currentRouteId, id, routeIdMap, _ref;
      routeIdMap = {};
      for (id in solution.solution) {
        currentRouteId = (_ref = solution.routeIdMap) != null ? _ref[id] : void 0;
        routeIdMap[id] = currentRouteId || (oldMap != null ? oldMap[id] : void 0);
      }
      return routeIdMap;
    };

    _checkAnyRoutesVisible = function() {
      var id, route;
      if (!_summary) {
        return false;
      }
      for (id in _summary) {
        route = _summary[id];
        if (route.visible && (route.polylines != null)) {
          return true;
        }
      }
      return false;
    };

    _syncMarkersVisibility = function(summary) {
      var current, id, visitId, _results;
      _results = [];
      for (id in summary) {
        current = summary[id];
        _results.push((function() {
          var _i, _len, _ref, _results1;
          _ref = current.visits;
          _results1 = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            visitId = _ref[_i];
            _results1.push(_gMarkerF.setVisible(visitId, current.visible));
          }
          return _results1;
        })());
      }
      return _results;
    };

    _updateRouteSummary = function(solution, polylines, unserved) {
      var data, driverVisits, id, summary, unservedVisits, visit, _ref, _ref1;
      summary = {};
      for (id in solution) {
        data = solution[id];
        driverVisits = (function() {
          var _i, _len, _ref, _results;
          _ref = data.visits;
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            visit = _ref[_i];
            if (visit.finish_time && !visit["break"]) {
              _results.push(visit.location_id);
            }
          }
          return _results;
        })();
        summary[id] = {
          visits: driverVisits
        };
        if (polylines != null ? polylines[id] : void 0) {
          summary[id].polylines = polylines[id];
        }
      }
      if (unserved) {
        unservedVisits = (function() {
          var _results;
          _results = [];
          for (id in unserved) {
            _results.push(id);
          }
          return _results;
        })();
        summary[null] = {
          visits: unservedVisits
        };
      }
      for (id in summary) {
        if (((_ref = _summary[id]) != null ? _ref.visible : void 0) != null) {
          summary[id].visible = (_ref1 = _summary[id]) != null ? _ref1.visible : void 0;
        } else {
          summary[id].visible = true;
        }
      }
      _summary = summary;
      return _summary;
    };

    _findItem = function(id, items) {
      return _.detect(items, function(item) {
        return item.id === id;
      });
    };

    _addEventListeners = function() {
      var _driverModifiedListener;
      _driverModifiedListener = function(driver) {
        var fleet, i, index, request, response, solution, vehicle, _i, _len;
        index = -1;
        solution = _route != null ? _route.solution : void 0;
        if (solution != null) {
          request = solution.request;
          if (request) {
            fleet = request.fleet;
            for (i = _i = 0, _len = fleet.length; _i < _len; i = ++_i) {
              vehicle = fleet[i];
              if (vehicle.id === driver.id) {
                index = i;
                break;
              }
            }
            if (index > -1) {
              fleet.splice(index, 1, driver);
            }
          }
          response = solution.response;
          if (response) {
            vehicle = response[driver.id];
            if (vehicle) {
              vehicle.driver = driver;
            }
          }
        }
        return _dispatchStatusF.setPendingRoutesCount(_route);
      };
      _eventListenersF.addEventListener(_events.DRIVER_MODIFIED, _driverModifiedListener);
      _eventListenersF.addEventListener(_events.DISPATCH_SENT, function() {
        _routeHistoryF.updateCurrentRoute(_route);
        return _dispatchStatusF.setPendingRoutesCount(_route);
      });
      _eventListenersF.addEventListener(_events.NEW_ROUTES_CREATED, function(newRoute) {
        var _ref;
        return _addRouteId((_ref = newRoute.vehicle) != null ? _ref.id : void 0, newRoute._id);
      });
      return _eventListenersF.addEventListener(_events.PROJECT_MODIFIED, function() {
        return _updateVisitsCountWithNotification();
      });
    };

    _addRouteId = function(vehicleId, newRouteId) {
      if (!_route) {
        return;
      }
      if (!_route.routeIdMap) {
        _route.routeIdMap = {};
      }
      return _route.routeIdMap[vehicleId] = newRouteId;
    };

    _load = function() {
      var _ref;
      _setRoute(_routeHistoryF.getRoute());
      _polylines = _routeHistoryF.getPolyline();
      return _updateRouteSummary(_route != null ? (_ref = _route.solution) != null ? _ref.response : void 0 : void 0, _polylines, _route != null ? _route.unserved : void 0);
    };

    _emitVisibilityEvent = function(id, isVisible) {
      var cb, routeCBs, _i, _len, _results;
      routeCBs = _routeVisibilityCallbacks[id];
      if (routeCBs) {
        _results = [];
        for (_i = 0, _len = routeCBs.length; _i < _len; _i++) {
          cb = routeCBs[_i];
          _results.push(cb(isVisible));
        }
        return _results;
      }
    };

    _emitRouteUpdatedEvent = function() {
      var cb, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _routeUpdatedCallbacks.length; _i < _len; _i++) {
        cb = _routeUpdatedCallbacks[_i];
        _results.push(cb());
      }
      return _results;
    };

    _clearVisibilityEventListeners = function() {
      return _routeVisibilityCallbacks = {};
    };

    _fetchMinIdle = function(data) {
      var preRequestProjectVersion, projectF;
      data.polylines = true;
      data.options = {
        traffic: _settingsF.getServerTraffic(),
        avoid_tolls: _settingsF.settings.avoidTolls
      };
      projectF = _$injector.get('ProjectF');
      preRequestProjectVersion = projectF.project.version;
      return _$http.post("" + _apiPath + "/v1/min-idle", data, _accountF.getAuthHeader()).then(function(res) {
        var postRequestProjectVersion;
        _loggerF.info(_loggerF.ACTIONS.CALLED_MIN_IDLE, {
          user_solution: data.solution,
          solution: res.data.solution
        });
        postRequestProjectVersion = projectF.project.version;
        if (preRequestProjectVersion !== postRequestProjectVersion) {
          _loggerF.error(_loggerF.ACTIONS.CALLED_MIN_IDLE, {
            projectId: projectF.project.id,
            preRequestVersion: preRequestProjectVersion,
            postRequestVersion: postRequestProjectVersion
          }, 'Project was updated while waiting for /min-idle request to complete');
          _eventListenersF.notify(_events.PROJECT_VERSION_MISMATCH);
          return _$q.reject();
        }
        res.data.isUserSolution = true;
        res.data.date = data.date;
        return res.data;
      })["catch"](function(err) {
        if (err.status === 408) {
          return _$http.post("" + _apiPath + "/v1/min-idle", data, _accountF.getAuthHeader()).then(function(res) {
            var postRequestProjectVersion;
            _loggerF.info(_loggerF.ACTIONS.CALLED_MIN_IDLE, {
              user_solution: data.solution,
              solution: res.data.solution
            });
            postRequestProjectVersion = projectF.project.version;
            if (preRequestProjectVersion !== postRequestProjectVersion) {
              _loggerF.error(_loggerF.ACTIONS.CALLED_MIN_IDLE, {
                projectId: projectF.project.id,
                preRequestVersion: preRequestProjectVersion,
                postRequestVersion: postRequestProjectVersion
              }, 'Project was updated while waiting for /min-idle request to complete');
              _eventListenersF.notify(_events.PROJECT_VERSION_MISMATCH);
              return _$q.reject();
            }
            res.data.isUserSolution = true;
            res.data.date = data.date;
            return res.data;
          });
        }
      });
    };

    _fetchFix = function(data) {
      var preRequestProjectVersion, projectF;
      data.polylines = true;
      data.options = {
        traffic: _settingsF.getServerTraffic(),
        shortest_distance: _settingsF.settings.shortestDistance,
        avoid_tolls: _settingsF.settings.avoidTolls,
        max_visit_lateness: _settingsF.settings.stopLateness,
        max_vehicle_overtime: _settingsF.settings.driverLateness
      };
      projectF = _$injector.get('ProjectF');
      preRequestProjectVersion = projectF.project.version;
      return _$http.post("" + _apiPath + "/v1/fix", data, _accountF.getAuthHeader()).then(function(res) {
        var postRequestProjectVersion;
        _loggerF.info(_loggerF.ACTIONS.CALLED_FIX, {
          user_solution: data.solution,
          solution: res.data.solution
        });
        postRequestProjectVersion = projectF.project.version;
        if (preRequestProjectVersion !== postRequestProjectVersion) {
          _loggerF.error(_loggerF.ACTIONS.CALLED_FIX, {
            projectId: projectF.project.id,
            preRequestVersion: preRequestProjectVersion,
            postRequestVersion: postRequestProjectVersion
          }, 'Project was updated while waiting /fix request to complete');
          _eventListenersF.notify(_events.PROJECT_VERSION_MISMATCH);
          return _$q.reject();
        }
        res.data.isUserSolution = true;
        res.data.date = data.date;
        return res.data;
      });
    };

    _fetchFixWithRetry = function(data, vehicles, options) {
      return _$q(function(resolve, reject) {
        var __retryFix;
        __retryFix = function(data, vehicles) {
          var isDriverShiftLengthened, isTimeWindowRemoved;
          isTimeWindowRemoved = _removeUnservedTimeWindows(data);
          isDriverShiftLengthened = (function(data, vehicles) {
            var vehicle, _i, _len;
            var isLengthened = false;
            for (_i = 0, _len = vehicles.length; _i < _len; _i++) {
              vehicle = vehicles[_i];
              if (_lengthenDriverShift(data, vehicle)) {
                isLengthened = true;
              }
            }
            return isLengthened;
          })(data, vehicles);
          if (isTimeWindowRemoved || isDriverShiftLengthened) {
            return _fetchFix(data).then(resolve, reject);
          } else {
            return _$q.reject(new Error(FIX_REQUEST_ERROR_MSG));
          }
        };
        return _fetchFix(data).then(function(res) {
          var unserved = res.unserved;
          if ((options != null ? options.retryOnUnserved : void 0) && (unserved != null) && Object.keys(unserved).length > 0) {
            return __retryFix(data, vehicles);
          }
          return resolve(res);
        })["catch"](function(err) {
          var _ref, _ref1;
          if (_ref = err != null ? (_ref1 = err.data) != null ? _ref1.error_type : void 0 : void 0, __indexOf.call(FIX_REQUEST_ERROR, _ref) >= 0) {
            return __retryFix(data, vehicles);
          }
          return reject(err);
        });
      });
    };

    _fetchFixRequests = function(reqs) {
      var data, promise, promises, vehicle;
      promises = {};
      for (vehicle in reqs) {
        data = reqs[vehicle];
        _checkAndRemoveConstraints(data);
        if (_hasTimeWindow(data)) {
          promise = _fetchFixWithRetry(data, [vehicle]);
        } else {
          promise = _fetchFix(data);
        }
        promises[vehicle] = promise;
      }
      return promises;
    };

    _fetchEmptyRoute = function(fleet, dateStr) {
      var driver, _i, _len;
      var data = {};
      data.fleet = _formatFleet(fleet);
      data.visits = {};
      data.visits[DUMMY_VISIT_NAME] = {
        duration: 1,
        location: data.fleet[fleet[0].id].start_location
      };
      data.solution = {};
      for (_i = 0, _len = fleet.length; _i < _len; _i++) {
        driver = fleet[_i];
        data.solution[driver.id] = [];
      }
      data.date = _toFuture(dateStr);
      return _fetchMinIdle(data);
    };

    _removeDoneVisitsFromData = function(data, doneVisitIds) {
      var lastDoneVisitId, lastDoneVisitWithTime, modifiedData, vehId, vehicle, _ref;
      modifiedData = _.cloneDeep(data);
      lastDoneVisitId = doneVisitIds[doneVisitIds.length - 1];
      _ref = modifiedData.fleet;
      for (vehId in _ref) {
        vehicle = _ref[vehId];
        lastDoneVisitWithTime = _.find(_route.solution[vehId], function(v) {
          return v.location_id === lastDoneVisitId;
        });
        vehicle.shift_start = lastDoneVisitWithTime != null ? lastDoneVisitWithTime.finish_time : void 0;
        if ((vehicle.shift_end != null) && vehicle.shift_start >= vehicle.shift_end) {
          delete vehicle["shift_end"];
        }
        vehicle.strict_start = true;
        modifiedData.solution[vehId] = _.filter(modifiedData.solution[vehId], function(locId) {
          return __indexOf.call(doneVisitIds, locId) < 0;
        });
      }
      return modifiedData;
    };

    _modifyVehicleWithDoneVisitIds = function(vehicleId, vehicle, visits, doneVisitIds) {
      var breakDone, breakTooEarly, doneVisitIsStartDepot, lastDoneVisitFinishTime, lastDoneVisitFromRoute, lastDoneVisitId, lastDoneVisitLocation, lastStop, lastStopTime, route, vehBreakStart, _ref, _ref1, _ref2, _ref3;
      lastDoneVisitId = doneVisitIds[doneVisitIds.length - 1];
      route = _route.solution[vehicleId];
      lastDoneVisitFromRoute = _.find(route, function(visit) {
        return visit.location_id === lastDoneVisitId;
      });
      lastDoneVisitLocation = visits != null ? (_ref = visits[lastDoneVisitId]) != null ? _ref.location : void 0 : void 0;
      doneVisitIsStartDepot = ((_ref1 = vehicle.start_location) != null ? _ref1.id : void 0) === lastDoneVisitId;
      lastDoneVisitFinishTime = (lastDoneVisitFromRoute != null ? lastDoneVisitFromRoute.finish_time : void 0) || (lastDoneVisitFromRoute != null ? lastDoneVisitFromRoute.arrival_time : void 0);
      vehicle.shift_start = lastDoneVisitFinishTime;
      vehicle.strict_start = true;
      if (!doneVisitIsStartDepot && (lastDoneVisitLocation != null)) {
        vehicle.start_location = lastDoneVisitLocation;
      }
      lastStop = route[route.length - 1];
      lastStopTime = lastStop.finish_time || lastStop.arrival_time;
      if ((vehicle.shift_end != null) && ((vehicle.shift_start >= vehicle.shift_end) || (vehicle.shift_end <= lastStopTime))) {
        delete vehicle["shift_end"];
      }
      vehBreakStart = (_ref2 = vehicle.breaks) != null ? (_ref3 = _ref2[0]) != null ? _ref3.start : void 0 : void 0;
      breakDone = __indexOf.call(doneVisitIds, BREAK_ID) >= 0;
      breakTooEarly = vehBreakStart && vehBreakStart < lastDoneVisitFinishTime;
      if (breakDone || breakTooEarly) {
        delete vehicle['break-start'];
        delete vehicle['break-end'];
        delete vehicle['break-duration'];
        vehicle.breaks = [];
      }
      return vehicle;
    };

    _modifyDataWithDoneVisits = function(data, doneVisitIds) {
      var vehId, vehicle, visits, _ref;
      var modifiedData = _.cloneDeep(data);
      visits = data.visits;
      _ref = modifiedData.fleet;
      for (vehId in _ref) {
        vehicle = _ref[vehId];
        vehicle = _modifyVehicleWithDoneVisitIds(vehId, vehicle, visits, doneVisitIds);
        modifiedData.solution[vehId] = _.filter(modifiedData.solution[vehId], function(locId) {
          return __indexOf.call(doneVisitIds, locId) < 0;
        });
      }
      return modifiedData;
    };

    _modifyDataWithDoneVisitsByVehicleId = function(data, doneVisitsByVehicleId) {
      var doneVisitIds, modifiedData, vehId, vehicle, visits, _ref, _ref1;
      modifiedData = _.cloneDeep(data);
      visits = data.visits;
      _ref = modifiedData.fleet;
      for (vehId in _ref) {
        vehicle = _ref[vehId];
        if (!((doneVisitsByVehicleId != null ? (_ref1 = doneVisitsByVehicleId[vehId]) != null ? _ref1.length : void 0 : void 0) > 0)) {
          continue;
        }
        doneVisitIds = doneVisitsByVehicleId[vehId];
        _modifyVehicleWithDoneVisitIds(vehId, vehicle, visits, doneVisitIds);
        modifiedData.solution[vehId] = _.filter(modifiedData.solution[vehId], function(locId) {
          return __indexOf.call(doneVisitIds, locId) < 0;
        });
      }
      return modifiedData;
    };

    _fetchLiveFixRequests = function(reqs) {
      return _fetchLiveRequests(TYPE_FIX, reqs);
    };

    _fetchLiveMinIdleRequests = function(reqs) {
      return _fetchLiveRequests(TYPE_MIN_IDLE, reqs);
    };

    _fetchLiveRequests = function(type, reqs) {
      var firstRequestPromises, minIdlePromises, modifiedData, modifiedReqs, promise, req, vehicleId, _fn;
      modifiedReqs = {};
      for (vehicleId in reqs) {
        req = reqs[vehicleId];
        modifiedData = _modifyDataWithDoneVisits(req.data, req.doneVisitIds);
        modifiedReqs[vehicleId] = modifiedData;
      }
      if (type === TYPE_MIN_IDLE) {
        firstRequestPromises = _fetchMinIdleRequests(modifiedReqs);
      } else if (type === TYPE_FIX) {
        firstRequestPromises = _fetchFixRequests(modifiedReqs);
      }
      minIdlePromises = {};
      _fn = function(vehicleId, promise) {
        return minIdlePromises[vehicleId] = promise.then(function(res) {
          var data, doneVisitIds, mergedSolution, oldSolution, solution, solutionForMinIdle, visitsForMinIdleSolution;
          solution = res.solution[vehicleId];
          data = reqs[vehicleId].data;
          oldSolution = reqs[vehicleId].oldSolution;
          doneVisitIds = reqs[vehicleId].doneVisitIds;
          mergedSolution = _mergeSolutionWithDoneVisits(solution, oldSolution, doneVisitIds);
          visitsForMinIdleSolution = _.filter(mergedSolution, function(visit) {
            return visit.finish_time != null;
          });
          solutionForMinIdle = _.map(visitsForMinIdleSolution, function(visit) {
            return visit.location_id;
          });
          data.solution[vehicleId] = solutionForMinIdle;
          delete data['unserved'];
          return _fetchMinIdle(data).then(function(resData) {
            resData.solution[vehicleId] = mergedSolution;
            return resData;
          });
        });
      };
      for (vehicleId in firstRequestPromises) {
        promise = firstRequestPromises[vehicleId];
        _fn(vehicleId, promise);
      }
      return minIdlePromises;
    };

    _mergeSolutionWithDoneVisits = function(solution, oldSolution, doneVisitIds) {
      var visit, _i, _len, _ref;
      var mergedSolution = [];
      for (_i = 0, _len = oldSolution.length; _i < _len; _i++) {
        visit = oldSolution[_i];
        if (_ref = visit.location_id, __indexOf.call(doneVisitIds, _ref) >= 0) {
          mergedSolution.push(visit);
        }
      }
      solution.shift();
      mergedSolution = mergedSolution.concat(solution);
      return mergedSolution;
    };

    _fetchMinIdleRequests = function(reqs) {
      var data, promises, vehicle;
      promises = {};
      for (vehicle in reqs) {
        data = reqs[vehicle];
        promises[vehicle] = _fetchMinIdle(data);
      }
      return promises;
    };

    _fetchOptimizedRoute = function(data, isInDemo) {
      var authHeader, isDebugJob, isRoutificAdmin, url, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      if (isInDemo == null) {
        isInDemo = false;
      }
      isRoutificAdmin = (_ref = _accountF.getUser()) != null ? _ref.isRoutificAdmin : void 0;
      isDebugJob = (_ref1 = data.options) != null ? _ref1.isDebugJob : void 0;
      data.options = {
        isDebugJob: isRoutificAdmin && isDebugJob,
        polylines: true,
        visit_balance_coefficient: __getCoefficient(data),
        min_vehicles: !_settingsF.settings.autoBalanced,
        shortest_distance: _settingsF.settings.shortestDistance,
        avoid_tolls: _settingsF.settings.avoidTolls,
        traffic: _settingsF.getServerTraffic(),
        max_vehicle_overtime: ((_ref2 = data.options) != null ? _ref2.max_vehicle_overtime : void 0) ? (_ref3 = data.options) != null ? _ref3.max_vehicle_overtime : void 0 : _settingsF.settings.driverLateness,
        max_visit_lateness: ((_ref4 = data.options) != null ? _ref4.max_visit_lateness : void 0) ? (_ref5 = data.options) != null ? _ref5.max_visit_lateness : void 0 : _settingsF.settings.stopLateness
      };
      url = "" + _apiPath + "/v1.9/vrp-long";
      if (isInDemo) {
        url = url + '?demo';
      }
      authHeader = _accountF.getAuthHeader();
      return _$http.post(url, data, authHeader).then(function(res) {
        var jobId = res.data.job_id;
        return jobId;
      });
    };

    __getCoefficient = function() {
      if (!_settingsF.settings.autoBalanced) {
        return null;
      }
      return 0.8;
    };

    _formatRoute = function(solution) {
      var routeStr, routes, stop, vehId, vehRoute, visitId, _i, _len;
      routes = {};
      for (vehId in solution) {
        vehRoute = solution[vehId];
        routeStr = [];
        for (_i = 0, _len = vehRoute.length; _i < _len; _i++) {
          stop = vehRoute[_i];
          if (!(!!stop.finish_time)) {
            continue;
          }
          visitId = stop["break"] ? "nowhere" : stop.location_id;
          routeStr.push(visitId);
        }
        routes[vehId] = {
          route: routeStr
        };
      }
      return routes;
    };

    _reoptimizedVehicles = function(newSolution, oldSolution, fleet, forced) {
      var diffVehicles, forcedObj, i, id, newRoute, newSolVisit, newStops, oldStops, vehicle, vehicleId, visit, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2;
      forcedObj = {};
      if (forced) {
        for (_i = 0, _len = forced.length; _i < _len; _i++) {
          vehicleId = forced[_i];
          forcedObj[vehicleId] = true;
        }
      }
      diffVehicles = {};
      for (_j = 0, _len1 = fleet.length; _j < _len1; _j++) {
        vehicle = fleet[_j];
        id = vehicle.id;
        if (forcedObj[id]) {
          diffVehicles[id] = newSolution[id] || oldSolution[id] || [];
          continue;
        }
        newStops = 0;
        if (newSolution[id] != null) {
          newRoute = newSolution[id];
          newStops = newRoute.route.length + (((_ref = newRoute.unserved) != null ? _ref.length : void 0) || 0);
        }
        oldStops = ((_ref1 = oldSolution[id]) != null ? _ref1.length : void 0) || 0;
        if (newStops !== oldStops) {
          diffVehicles[id] = newSolution[id] || [];
        }
      }
      if (Object.keys(diffVehicles).length > 0) {
        return diffVehicles;
      }
      for (id in oldSolution) {
        vehicle = oldSolution[id];
        for (i = _k = 0, _len2 = vehicle.length; _k < _len2; i = ++_k) {
          visit = vehicle[i];
          newSolVisit = (_ref2 = newSolution[id]) != null ? _ref2.route[i] : void 0;
          if (!newSolVisit || visit !== newSolVisit) {
            diffVehicles[id] = newSolution[id];
          }
        }
      }
      return diffVehicles;
    };

    _destroyRoutes = function() {
      return _setRoute({});
    };

    _destroyPolylines = function() {
      _gPolylineF.destroyAll();
      return _polylines = {};
    };

    _refreshRoutes = function() {
      var fleet, visits;
      _setRoute(_routeHistoryF.getRoute());
      _polylines = _routeHistoryF.getPolyline();
      _updateRouteSummary(_route.solution.response, _polylines, _route.unserved);
      _syncMarkersVisibility(_summary);
      _routeMarkerInfoF.updateAllMarkerInfo(_route.solution.response, _route.unserved);
      _markerClustererF.update(_route.solution.response, _route.unserved);
      visits = _visitF.getVisits();
      fleet = _driverF.getValidDrivers();
      _routeInspectorF.inspectRoute(_route, visits, fleet);
      _clearVisibilityEventListeners();
      return _emitRouteUpdatedEvent();
    };

    _getUnserved = function(route) {
      return route.unserved;
    };

    _getUnservedAsArray = function(route) {
      var id, reason, _ref, _results;
      _ref = _getUnserved(route);
      _results = [];
      for (id in _ref) {
        reason = _ref[id];
        _results.push(id);
      }
      return _results;
    };

    _getUnservedAsVisitsArray = function(route) {
      var visit, visits, _i, _len, _results;
      var unserved = route.unserved;
      visits = route.solution.request.visits;
      _results = [];
      for (_i = 0, _len = visits.length; _i < _len; _i++) {
        visit = visits[_i];
        if (!(unserved[visit.id] != null)) {
          continue;
        }
        visit.error = route.unserved[visit.id].error;
        _results.push(visit);
      }
      return _results;
    };

    _getSolutionFromRoute = function(route, fleet) {
      var end, id, routeSolution, solutions, vehicle, visit, _i, _j, _len, _len1, _ref;
      routeSolution = route.solution;
      solutions = {};
      for (_i = 0, _len = fleet.length; _i < _len; _i++) {
        vehicle = fleet[_i];
        id = vehicle.id;
        if (routeSolution[id]) {
          solutions[id] = [];
          end = vehicle.endLocation ? -2 : void 0;
          _ref = routeSolution[id].slice(1, +end + 1 || 9e9);
          for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
            visit = _ref[_j];
            solutions[id].push(visit.location_id);
          }
        }
      }
      return solutions;
    };

    _getDoneVisitsByVehicleId = function(dispatches) {
      var dispatch, doneVisitsByVehicleId, vehicleId, visit, visits, _i, _len, _ref, _ref1;
      doneVisitsByVehicleId = {};
      for (vehicleId in dispatches) {
        dispatch = dispatches[vehicleId];
        visits = (_ref = dispatch.solution) != null ? _ref.visits : void 0;
        doneVisitsByVehicleId[vehicleId] = [];
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          visit = visits[_i];
          if (_visitUtilF.isSkippedDoneStatus(visit.status)) {
            if (visit["break"]) {
              doneVisitsByVehicleId[vehicleId].push(BREAK_ID);
            } else {
              doneVisitsByVehicleId[vehicleId].push((_ref1 = visit.location) != null ? _ref1.id : void 0);
            }
          }
        }
      }
      return doneVisitsByVehicleId;
    };

    _getDriverVisits = function(driver) {
      var depots, driverVisits, locId, solution, visit, visitMarkers, _i, _j, _len, _len1, _ref, _ref1, _ref2;
      driverVisits = [];
      depots = [driver.startLocation.id];
      if (driver.endLocation) {
        depots.push(driver.endLocation.id);
      }
      solution = _route.solution;
      visitMarkers = {};
      _ref = solution.request.visits;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        visit = _ref[_i];
        visitMarkers[visit.id] = visit;
      }
      _ref1 = solution[driver.id];
      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
        visit = _ref1[_j];
        if (!(!visit["break"] && (_ref2 = visit.location_id, __indexOf.call(depots, _ref2) < 0))) {
          continue;
        }
        locId = visit.location_id;
        if (visitMarkers[locId]) {
          driverVisits.push(visitMarkers[locId]);
        }
      }
      return driverVisits;
    };

    _mergeOldSolution = function(route, oldRoute, oldPolylines, unaffected) {
      var distance, id, vehicle, visit, visitId, _i, _j, _len, _len1, _ref, _ref1;
      for (_i = 0, _len = unaffected.length; _i < _len; _i++) {
        vehicle = unaffected[_i];
        id = vehicle.id;
        if (!oldRoute.solution[id]) {
          _loggerF.error(_loggerF.ACTIONS.DRIVER_MISMATCH_ERROR, {
            projectId: _projectF.project.id,
            fleet: {
              vehicleId: vehicle.id,
              name: vehicle.name
            }
          }, "Driver mismatch error");
        }
        route.solution[id] = oldRoute.solution[id];
        route.polylines[id] = oldRoute.polylines[id];
        _ref = oldRoute.solution[id];
        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
          visit = _ref[_j];
          if (!(!visit["break"])) {
            continue;
          }
          visitId = visit.location_id;
          if (visitId !== vehicle.startLocation.id && visitId !== ((_ref1 = vehicle.endLocation) != null ? _ref1.id : void 0)) {
            if (route.unserved != null) {
              delete route.unserved[visitId];
            }
          }
        }
        distance = oldRoute.distances[id];
        route.distances[id] = distance;
        route.total_distance += distance;
      }
      return route.num_unserved = route.unserved != null ? Object.keys(route.unserved).length : 0;
    };

    _toFuture = function(dateStr) {
      var now;
      var date = dateStr ? _timeUtil.fromString(dateStr) : new Date();
      now = Date.now();
      while (date <= now) {
        date.setDate(date.getDate() + 7);
      }
      return _timeUtil.toString(date);
    };

    _normalizePolylines = function(route) {
      var decoded, encoded;
      if (route.pl_precision === GOOGLE_POLYLINE_PRECISION) {
        decoded = _polylineUtil.decodePolylines(route.polylines, GOOGLE_POLYLINE_PRECISION);
        encoded = _polylineUtil.encodePolylines(decoded, OSRM_POLYLINE_PRECISION);
        route.polylines = encoded;
        route.pl_precision = OSRM_POLYLINE_PRECISION;
      }
    };

    _removeDummy = function(route) {
      if (route.unserved && route.unserved[DUMMY_VISIT_NAME]) {
        delete route.unserved[DUMMY_VISIT_NAME];
        route.num_unserved--;
      }
    };

    _findAffectedVehicles = function(fleet, solution) {
      var vehicle, _i, _len;
      var affectedVehicles = [];
      for (_i = 0, _len = fleet.length; _i < _len; _i++) {
        vehicle = fleet[_i];
        if (solution != null ? solution[vehicle.id] : void 0) {
          affectedVehicles.push(vehicle);
        }
      }
      return affectedVehicles;
    };

    _findUnaffectedVehicles = function(fleet, solution) {
      var vehicle, _i, _len;
      var unaffectedVehicles = [];
      for (_i = 0, _len = fleet.length; _i < _len; _i++) {
        vehicle = fleet[_i];
        if (!(solution != null ? solution[vehicle.id] : void 0)) {
          unaffectedVehicles.push(vehicle);
        }
      }
      return unaffectedVehicles;
    };

    _mergeRoutes = function(routes) {
      var reason, vehicle, vehicleSolution, visit, _ref;
      var newSolution = {
        solution: {},
        polylines: {},
        distances: {},
        unserved: {},
        total_distance: 0,
        total_idle_time: 0,
        total_travel_time: 0,
        pl_precision: OSRM_POLYLINE_PRECISION
      };
      for (vehicle in routes) {
        vehicleSolution = routes[vehicle];
        newSolution.solution[vehicle] = vehicleSolution.solution[vehicle];
        newSolution.polylines[vehicle] = vehicleSolution.polylines[vehicle];
        newSolution.distances[vehicle] = vehicleSolution.distances[vehicle];
        newSolution.total_distance += vehicleSolution.total_distance;
        newSolution.total_travel_time += vehicleSolution.total_travel_time;
        newSolution.total_idle_time += vehicleSolution.total_idle_time;
        if (vehicleSolution.unserved) {
          _ref = vehicleSolution.unserved;
          for (visit in _ref) {
            reason = _ref[visit];
            if (reason !== "visit was not provided in the solution") {
              newSolution.unserved[visit] = reason;
            }
          }
        }
      }
      return newSolution;
    };

    _fetchVisits = function(solution, visits) {
      var id, routeVisits, _i, _j, _len, _len1, _ref, _ref1;
      routeVisits = {};
      if (solution.route) {
        _ref = solution.route;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          id = _ref[_i];
          if (id !== BREAK_ID) {
            routeVisits[id] = visits[id];
          }
        }
      }
      if (solution.unserved) {
        _ref1 = solution.unserved;
        for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
          id = _ref1[_j];
          routeVisits[id] = visits[id];
        }
      }
      return routeVisits;
    };

    _hasTimeWindow = function(data) {
      var driver, fleet, id, unserveds, visit, visits, _i, _len;
      visits = data.visits;
      unserveds = data.unserved;
      fleet = data.fleet;
      for (id in fleet) {
        driver = fleet[id];
        if ((driver.shift_start != null) || (driver.shift_end != null)) {
          return true;
        }
      }
      for (_i = 0, _len = unserveds.length; _i < _len; _i++) {
        id = unserveds[_i];
        if ((visit = visits[id])) {
          if ((visit.start != null) || (visit.end != null)) {
            return true;
          }
        }
      }
      return false;
    };

    _getMaxEndDate = function(solution) {
      var endDate, id, max, route, startDate, visit, _i, _len;
      max = null;
      for (id in solution) {
        route = solution[id];
        for (_i = 0, _len = route.length; _i < _len; _i++) {
          visit = route[_i];
          startDate = _timeUtil.convertTimeToDate(visit.arrival_time);
          endDate = _timeUtil.convertTimeToDate(visit.finish_time);
          if (startDate || endDate) {
            if (max === null || (endDate && endDate > max)) {
              max = endDate;
            }
            if (max === null || (startDate && startDate > max)) {
              max = startDate;
            }
          }
        }
      }
      return max;
    };

    _removeUnservedTimeWindows = function(data) {
      var id, isRemoved, unserved, visit, _i, _len;
      unserved = data.unserved;
      isRemoved = false;
      if (unserved) {
        for (_i = 0, _len = unserved.length; _i < _len; _i++) {
          id = unserved[_i];
          if (!(visit = data.visits[id])) {
            continue;
          }
          isRemoved = true;
          delete visit.start;
          delete visit.end;
        }
      }
      return isRemoved;
    };

    _lengthenDriverShift = function(data, vehicle) {
      var driver = data.fleet[vehicle];
      if (driver.shift_end) {
        delete driver.shift_end;
        return true;
      }
      return false;
    };

    _isUnservedsCompatible = function(data, vehicle) {
      var v, _i, _len, _ref;
      _ref = data.unserved;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        v = _ref[_i];
        if (!_visitCompatibilityF.isCompatible(data, v, vehicle)) {
          return false;
        }
      }
      return true;
    };

    _removeConstraints = function(vehicle, data) {
      var unserved, _i, _len, _ref, _results;
      _ref = data.unserved;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        unserved = _ref[_i];
        _results.push(_removeVisitConstraints(data, unserved, vehicle));
      }
      return _results;
    };

    _removeVisitConstraints = function(data, visitId, vehicleId, times) {
      var driver, visit, visitOrder;
      visit = data.visits[visitId];
      driver = data.fleet[vehicleId];
      visitOrder = data.solution[vehicleId];
      if (((times != null ? times.arrival_time : void 0) && _visitCompatibilityF.isStartRemoved(visit, times.arrival_time)) || !_visitCompatibilityF.isStartCompatible(visit, driver)) {
        delete visit.start;
      }
      if (((times != null ? times.finish_time : void 0) && _visitCompatibilityF.isEndRemoved(visit, times.finish_time)) || !_visitCompatibilityF.isEndCompatible(visit, driver)) {
        delete visit.end;
      }
      if (!_visitCompatibilityF.isTypesCompatible(visit, driver)) {
        delete visit.type;
      }
      if (!_visitCompatibilityF.hasCapacity(visit, driver, visitOrder, data.visits)) {
        return delete visit.load;
      }
    };

    _checkAndRemoveConstraints = function(data) {
      var arrival, arrivalDate, arrivalTime, arrivalWithIdle, driver, finish, idleTime, route, stop, timesMap, vehicle, _i, _len, _ref, _ref1, _results;
      _ref = data.fleet;
      _results = [];
      for (driver in _ref) {
        vehicle = _ref[driver];
        if (!(data != null ? (_ref1 = data.solution) != null ? _ref1[driver] : void 0 : void 0)) {
          continue;
        }
        route = _route.solution[driver];
        timesMap = {};
        for (_i = 0, _len = route.length; _i < _len; _i++) {
          stop = route[_i];
          if (!(!stop["break"] && !!stop.finish_time)) {
            continue;
          }
          arrival = stop.arrival_time;
          finish = stop.finish_time;
          idleTime = Math.ceil(stop.idle_time || 0);
          arrivalDate = _timeUtil.convertTimeToDate(arrival);
          arrivalWithIdle = _timeUtil.addMinutes(arrivalDate, idleTime);
          arrivalTime = _timeUtil.convertDateToTime(arrivalWithIdle);
          timesMap[stop.location_id] = {
            arrival_time: arrivalTime,
            finish_time: finish
          };
        }
        _results.push((function() {
          var _j, _len1, _ref2, _results1;
          _ref2 = data.solution[driver];
          _results1 = [];
          for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
            stop = _ref2[_j];
            if (stop !== BREAK_ID) {
              _results1.push(_removeVisitConstraints(data, stop, driver, timesMap[stop]));
            }
          }
          return _results1;
        })());
      }
      return _results;
    };

    _setOptimizationInProgress = function(inProgress, numVisits) {
      var event;
      _inProgress = inProgress;
      event = null;
      if (inProgress) {
        event = _events.OPTIMIZATION_IN_PROGRESS;
      } else {
        event = _events.OPTIMIZATION_COMPLETED;
      }
      return _eventListenersF.notify(event, numVisits);
    };

    _setFixRouteInProgress = function(inProgress) {
      return _inProgress = inProgress;
    };

    _setRoute = function(route) {
      _dispatchStatusF.setPendingRoutesCount(route);
      _route = route;
      _visitsLockMapping = _updateVisitsLockMapping(route);
      return _eventListenersF.notify(_events.ROUTE_SET, _route);
    };

    _updateVisitsLockMapping = function(route) {
      var driverId, driverRoute, solution, visitMap, visits, _i, _len, _ref, _ref1;
      solution = route != null ? (_ref = route.solution) != null ? _ref.response : void 0 : void 0;
      if (solution == null) {
        return {};
      }
      visitMap = {};
      for (driverId in solution) {
        driverRoute = solution[driverId];
        if (route.routeLocks[driverId] && (driverRoute.visits != null)) {
          _ref1 = driverRoute.visits;
          for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
            visits = _ref1[_i];
            visitMap[visits.location_id] = true;
          }
        }
      }
      return visitMap;
    };

    _genUnserved = function(error) {
      return {
        color: _unservedColor,
        error: error
      };
    };

    _toArray = function(obj) {
      var k, v, val;
      var arr = [];
      for (k in obj) {
        v = obj[k];
        val = _.cloneDeep(v);
        val.id = k;
        arr.push(val);
      }
      return arr;
    };

    _findDriverIdWithStop = function(targetVisit, solution) {
      var stop, vehId, vehRoute, _i, _len;
      for (vehId in solution) {
        vehRoute = solution[vehId];
        for (_i = 0, _len = vehRoute.length; _i < _len; _i++) {
          stop = vehRoute[_i];
          if (!!stop.finish_time) {
            if (stop.location_id === targetVisit.id) {
              return vehId;
            }
          }
        }
      }
      return null;
    };

    _getVisitsAndDrivers = function() {
      var driver, driverId, drivers, isLocked, route, routeLocks, visit, visitId, visitLockedMap, visits, _i, _j, _k, _len, _len1, _len2, _ref;
      visits = _visitF.getValidVisits();
      drivers = _driverF.getSelectedDrivers();
      visitLockedMap = {};
      if (_route != null ? _route.solution : void 0) {
        routeLocks = _route.routeLocks;
        _ref = _route.solution;
        for (driverId in _ref) {
          route = _ref[driverId];
          if (!(route instanceof Array)) {
            continue;
          }
          isLocked = !!(routeLocks != null ? routeLocks[driverId] : void 0);
          for (_i = 0, _len = route.length; _i < _len; _i++) {
            visit = route[_i];
            visitId = visit.location_id;
            visitLockedMap[visitId] = isLocked;
          }
        }
      }
      for (_j = 0, _len1 = visits.length; _j < _len1; _j++) {
        visit = visits[_j];
        visit.isLocked = visitLockedMap != null ? visitLockedMap[visit.id] : void 0;
      }
      for (_k = 0, _len2 = drivers.length; _k < _len2; _k++) {
        driver = drivers[_k];
        driver.isLocked = routeLocks != null ? routeLocks[driver.id] : void 0;
      }
      return {
        visits: visits,
        drivers: drivers
      };
    };

    _saveOldSolution = function(route, visits, drivers) {
      var driver, lockedVehicles, oldSolution, unlockedVehicles;
      unlockedVehicles = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          driver = drivers[_i];
          if (driver.visible && !driver.isLocked) {
            _results.push(driver);
          }
        }
        return _results;
      })();
      lockedVehicles = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          driver = drivers[_i];
          if (driver.isLocked) {
            _results.push(driver);
          }
        }
        return _results;
      })();
      return oldSolution = {
        route: route,
        affectedVehicles: unlockedVehicles,
        unaffectedVehicles: lockedVehicles
      };
    };

    _isProjectBusy = function() {
      _projectF = _$injector.get('ProjectF');
      return _projectF.isBusy;
    };

    RouteS.prototype.addVisibilityEventListener = function(id, callback) {
      if (!_routeVisibilityCallbacks[id]) {
        _routeVisibilityCallbacks[id] = [];
      }
      return _routeVisibilityCallbacks[id].push(callback);
    };

    RouteS.prototype.addRouteUpdatedEventListener = function(callback) {
      return _routeUpdatedCallbacks.push(callback);
    };

    RouteS.prototype.setMarkersVisible = function(id, isVisible) {
      var visitId, _i, _len, _ref;
      var route = _summary[id];
      if (route.visits) {
        _ref = route.visits;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          visitId = _ref[_i];
          _gMarkerF.setVisible(visitId, isVisible);
        }
      }
      return _markerClustererF.repaintCluster(id);
    };

    RouteS.prototype.setPolylinesVisible = function(id, isVisible) {
      if (_polylines[id]) {
        return _gPolylineF.setVisible(id, isVisible);
      }
    };

    RouteS.prototype.setDriverVisible = function(id, isVisible) {
      var driver;
      if (id && id !== 'null') {
        driver = _driverF.getDriver(id);
        return driver != null ? driver.setVisible(isVisible) : void 0;
      }
    };

    RouteS.prototype.setRouteVisible = function(id, isVisible) {
      var route = _summary[id];
      if (route) {
        route.visible = isVisible;
        this.setDriverVisible(id, isVisible);
        this.setMarkersVisible(id, isVisible);
        this.setPolylinesVisible(id, isVisible);
        _emitVisibilityEvent(id, isVisible);
      }
      return _anyRoutesVisible = _checkAnyRoutesVisible();
    };

    RouteS.prototype.isAnyRoutesVisible = function() {
      return _anyRoutesVisible;
    };

    RouteS.prototype.setAllRoutesVisible = function(isVisible) {
      var id, _results;
      _results = [];
      for (id in _summary) {
        _results.push(this.setRouteVisible(id, isVisible));
      }
      return _results;
    };

    RouteS.prototype.setAllMarkersVisible = function(isVisible) {
      var id, route, _results;
      _results = [];
      for (id in _summary) {
        route = _summary[id];
        if (route) {
          this.setDriverVisible(id, isVisible);
          this.setMarkersVisible(id, isVisible);
          _results.push(_emitVisibilityEvent(id, isVisible));
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    RouteS.prototype.clear = function() {
      _destroyPolylines();
      _destroyRoutes();
      _routeHistoryF.clear();
      _routeInspectorF.clearWarnings();
      _markerClustererF.setAllInUnserved();
      return _routeMarkerInfoF.clearInfo();
    };

    RouteS.prototype.isInProgress = function() {
      return _inProgress;
    };

    RouteS.prototype.fixRoute = function(dateStr, unserved, solution, forceFixFleet) {
      var affectedVehicles, data, doneVisitIdsForVehicle, doneVisitsByVehicleId, fixPromises, fixRequests, fleet, fleetObj, isCompatible, liveFixPromises, liveFixRequests, liveMinIdlePromises, liveMinIdleRequests, minIdlePromises, minIdleRequests, oldSolution, promises, promisesObj, req, solutions, unaffectedVehicles, value, vehicle, vehicleVisits, visits, visitsObj, __mapSolution, _fn, _i, _j, _len, _len1, _ref, _ref1, _ref2;
      if (_isProjectBusy()) {
        _eventListenersF.notify(_events.OPTIMIZATION_ERRORED, PROJECT_BUSY_ERROR);
        return _$q.reject(PROJECT_BUSY_ERROR);
      }
      visits = _visitF.getValidVisits();
      fleet = _driverF.getSelectedDrivers();
      oldSolution = _getSolutionFromRoute(_route, fleet);
      solution = _reoptimizedVehicles(solution, oldSolution, fleet, forceFixFleet);
      unaffectedVehicles = _findUnaffectedVehicles(fleet, solution);
      affectedVehicles = _findAffectedVehicles(fleet, solution);
      for (_i = 0, _len = affectedVehicles.length; _i < _len; _i++) {
        vehicle = affectedVehicles[_i];
        if (this.isDriverAtFinalDepot(vehicle.id)) {
          return _$q.reject("MESSAGES.UNABLE_ASSIGN_STOPS_TO_FINISHED_DRIVERS");
        }
      }
      oldSolution = {
        route: _route,
        polylines: _polylines,
        unserved: unserved,
        unaffectedVehicles: unaffectedVehicles,
        affectedVehicles: affectedVehicles
      };
      fleetObj = _formatFleet(fleet);
      visitsObj = _formatVisits(visits);
      promises = [];
      solutions = {};
      doneVisitsByVehicleId = _getDoneVisitsByVehicleId(_dispatchF.getDispatches());
      fixRequests = {};
      liveFixRequests = {};
      minIdleRequests = {};
      liveMinIdleRequests = {};
      for (vehicle in solution) {
        value = solution[vehicle];
        data = {
          fleet: {},
          solution: {}
        };
        data.fleet[vehicle] = fleetObj[vehicle];
        data.solution[vehicle] = value.route || [];
        vehicleVisits = _fetchVisits(value, visitsObj);
        if (Object.keys(vehicleVisits).length <= 0) {
          vehicleVisits[DUMMY_VISIT_NAME] = {
            duration: 1,
            location: data.fleet[vehicle].start_location
          };
        }
        data.visits = vehicleVisits;
        doneVisitIdsForVehicle = doneVisitsByVehicleId[vehicle];
        dateStr || (dateStr = _timeUtil.toString(new Date()));
        data.date = _toFuture(dateStr);
        if (value.unserved && value.unserved.length > 0) {
          data.unserved = value.unserved;
          if ((doneVisitIdsForVehicle != null ? doneVisitIdsForVehicle.length : void 0) > 0) {
            liveFixRequests[vehicle] = {
              doneVisitIds: doneVisitIdsForVehicle,
              data: data,
              oldSolution: (_ref = _route.solution) != null ? _ref[vehicle] : void 0
            };
          } else {
            fixRequests[vehicle] = data;
          }
        } else {
          if ((doneVisitIdsForVehicle != null ? doneVisitIdsForVehicle.length : void 0) > 0) {
            liveMinIdleRequests[vehicle] = {
              doneVisitIds: doneVisitIdsForVehicle,
              data: data,
              oldSolution: (_ref1 = _route.solution) != null ? _ref1[vehicle] : void 0
            };
          } else {
            minIdleRequests[vehicle] = data;
          }
        }
      }
      __mapSolution = function(vehicle, res) {
        _normalizePolylines(res);
        _removeDummy(res);
        return solutions[vehicle] = res;
      };
      isCompatible = true;
      if (Object.keys(fixRequests).length > 0) {
        for (vehicle in fixRequests) {
          data = fixRequests[vehicle];
          if (!_isUnservedsCompatible(data, vehicle)) {
            isCompatible = false;
            break;
          }
        }
      }
      if (Object.keys(liveFixRequests).length > 0) {
        for (vehicle in liveFixRequests) {
          req = liveFixRequests[vehicle];
          if (!_isUnservedsCompatible(req.data, vehicle)) {
            isCompatible = false;
            break;
          }
        }
      }
      if (!isCompatible) {
        for (vehicle in fixRequests) {
          data = fixRequests[vehicle];
          _removeConstraints(vehicle, data);
        }
        for (vehicle in liveFixRequests) {
          req = liveFixRequests[vehicle];
          _removeConstraints(vehicle, req.data);
        }
      }
      _projectF = _$injector.get('ProjectF');
      _projectF.isBusy = true;
      _setFixRouteInProgress(true);
      fixPromises = _fetchFixRequests(fixRequests);
      liveFixPromises = _fetchLiveFixRequests(liveFixRequests);
      minIdlePromises = _fetchMinIdleRequests(minIdleRequests);
      liveMinIdlePromises = _fetchLiveMinIdleRequests(liveMinIdleRequests);
      promises = [];
      _ref2 = [fixPromises, liveFixPromises, minIdlePromises, liveMinIdlePromises];
      _fn = function(promisesObj) {
        var promise, _results;
        _results = [];
        for (vehicle in promisesObj) {
          promise = promisesObj[vehicle];
          _results.push((function(vehicle, promise) {
            promise.then(function(res) {
              return __mapSolution(vehicle, res);
            });
            return promises.push(promise);
          })(vehicle, promise));
        }
        return _results;
      };
      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
        promisesObj = _ref2[_j];
        _fn(promisesObj);
      }
      return _$q.all(promises).then((function(_this) {
        return function() {
          var newSolution = _mergeRoutes(solutions);
          newSolution.isUserSolution = true;
          return _this.replace(newSolution, visits, fleet, oldSolution);
        };
      })(this)).then(function() {
        return _projectF.isBusy = false;
      })["catch"](function(err) {
        var _ref3;
        _projectF.isBusy = false;
        _setRoute(oldSolution.route);
        _polylines = oldSolution.polylines;
        _eventListenersF.notify(_events.OPTIMIZATION_ERRORED, err);
        return _$q.reject((err != null ? (_ref3 = err.data) != null ? _ref3.error : void 0 : void 0) || err.message);
      })["finally"](function() {
        return _setFixRouteInProgress(false);
      });
    };

    RouteS.prototype.reoptimize = function(dateStr, _arg) {
      var driver, drivers, isDebugJob, isInDemo, lockedVehicles, visits, _ref, _ref1;
      _ref = _arg != null ? _arg : {}, isDebugJob = _ref.isDebugJob, isInDemo = _ref.isInDemo;
      if (isDebugJob == null) {
        isDebugJob = false;
      }
      if (isInDemo == null) {
        isInDemo = false;
      }
      _ref1 = _getVisitsAndDrivers(), visits = _ref1.visits, drivers = _ref1.drivers;
      lockedVehicles = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          driver = drivers[_i];
          if (driver.isLocked) {
            _results.push(driver);
          }
        }
        return _results;
      })();
      if (!isDebugJob && (lockedVehicles != null ? lockedVehicles.length : void 0) > 0) {
        _projectF || (_projectF = _$injector.get('ProjectF'));
        _analyticsS.track('084 Re-optimize subset routes', {
          project_id: _projectF.project.id,
          user_email: _accountF.getUser().email,
          before_first_dispatch: !_dispatchF.hasDispatches()
        });
      }
      return this.optimizeRoute(visits, drivers, isInDemo, dateStr, isDebugJob);
    };

    RouteS.prototype.resumeOptimizeRoute = function(jobId) {
      var currentProjectid, drivers, oldSolution, promise, unlockedVisits, visit, visits, _ref;
      _ref = _getVisitsAndDrivers(), visits = _ref.visits, drivers = _ref.drivers;
      unlockedVisits = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          visit = visits[_i];
          if (!visit.isLocked) {
            _results.push(visit);
          }
        }
        return _results;
      })();
      oldSolution = _saveOldSolution(_route, visits, drivers);
      _projectF || (_projectF = _$injector.get('ProjectF'));
      _projectF.isBusy = true;
      currentProjectid = _projectF.project.id;
      _setOptimizationInProgress(true, unlockedVisits.length);
      promise = _projectJobF.pollPendingJob(jobId).then((function(_this) {
        return function(route) {
          if (currentProjectid !== _projectF.project.id) {
            return;
          }
          _normalizePolylines(route);
          _dispatchStatusF.resetDispatchStatus(route);
          _this.replace(route, visits, drivers, oldSolution, jobId);
          _projectF.isBusy = false;
          return _eventListenersF.notify(_events.PROJECT_MODIFIED);
        };
      })(this))["catch"](function(err) {
        _projectF.isBusy = false;
        _eventListenersF.notify(_events.OPTIMIZATION_ERRORED, err);
        return _$q.reject(err);
      })["finally"](function() {
        return _setOptimizationInProgress(false);
      });
      _projectJobF.saveLongOptimizePromise(promise);
      return promise;
    };

    RouteS.prototype.optimizeRoute = function(visits, drivers, isInDemo, dateStr, isDebugJob) {
      var data, driver, lockedVehicles, savedJobId, unlockedVehicles, unlockedVisits, visit;
      if (_isProjectBusy()) {
        _eventListenersF.notify(_events.OPTIMIZATION_ERRORED, PROJECT_BUSY_ERROR);
        return _$q.reject(PROJECT_BUSY_ERROR);
      }
      if (visits == null) {
        return _$q.reject(new Error("Visits must be defined"));
      }
      if (drivers == null) {
        return _$q.reject(new Error("Fleet must be defined"));
      }
      _projectF = _$injector.get('ProjectF');
      if (typeof analytics !== "undefined" && analytics !== null) {
        analytics.ready(function() {
          return typeof analytics !== "undefined" && analytics !== null ? analytics.track('Routes optimized', {
            project_id: _projectF.project.id,
            is_in_demo: isInDemo,
            is_debug_job: isDebugJob
          }) : void 0;
        });
      }
      unlockedVehicles = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          driver = drivers[_i];
          if (driver.visible && !driver.isLocked) {
            _results.push(driver);
          }
        }
        return _results;
      })();
      lockedVehicles = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          driver = drivers[_i];
          if (driver.isLocked) {
            _results.push(driver);
          }
        }
        return _results;
      })();
      unlockedVisits = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          visit = visits[_i];
          if (!visit.isLocked) {
            _results.push(visit);
          }
        }
        return _results;
      })();
      if ((drivers != null ? drivers.length : void 0) > 0 && (unlockedVehicles != null ? unlockedVehicles.length : void 0) <= 0) {
        _messagingF.replaceWarning("MESSAGES.ALL_VEHICLES_LOCKED");
        return _$q.reject(new Error("All vehicles are locked"));
      }
      data = {
        visits: _formatVisits(unlockedVisits),
        fleet: _formatFleet(unlockedVehicles),
        options: {
          isDebugJob: isDebugJob
        }
      };
      data.date = _toFuture(dateStr);
      _projectF.isBusy = true;
      savedJobId = null;
      _setOptimizationInProgress(true, unlockedVisits.length);
      return _projectJobF.checkJobNotInProgress(_projectF.project.id).then(function() {
        return _fetchOptimizedRoute(data, isInDemo);
      }).then(function(jobId) {
        savedJobId = jobId;
        return _projectJobF.setProjectJobId(_projectF.project.id, jobId);
      }).then((function(_this) {
        return function() {
          return _this.resumeOptimizeRoute(savedJobId);
        };
      })(this))["catch"](function(err) {
        _projectF.isBusy = false;
        _setOptimizationInProgress(false);
        _eventListenersF.notify(_events.OPTIMIZATION_ERRORED, err);
        return _$q.reject(err);
      });
    };

    RouteS.prototype.scheduleUnserveds = function() {
      var data, doneVisitIds, doneVisitsByVehicleId, driver, drivers, fleet, fleetObj, hasDoneVisits, isCompatible, k, lockedVehicles, oldSolution, optimizeMethod, originalData, polylines, route, solution, unserved, v, vehicle, vehicleId, vehicles, visits, visitsObj, _i, _len, _ref, _ref1;
      if (_isProjectBusy()) {
        _eventListenersF.notify(_events.OPTIMIZATION_ERRORED, PROJECT_BUSY_ERROR);
        return _$q.reject(PROJECT_BUSY_ERROR);
      }
      route = this.getRoute();
      polylines = this.getPolylines();
      _ref = _getVisitsAndDrivers(), visits = _ref.visits, drivers = _ref.drivers;
      fleet = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          driver = drivers[_i];
          if (driver.visible && !driver.isLocked) {
            _results.push(driver);
          }
        }
        return _results;
      })();
      lockedVehicles = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = drivers.length; _i < _len; _i++) {
          driver = drivers[_i];
          if (driver.isLocked) {
            _results.push(driver);
          }
        }
        return _results;
      })();
      if ((fleet != null ? fleet.length : void 0) <= 0) {
        _messagingF.replaceWarning("MESSAGES.ALL_VEHICLES_LOCKED_INSERT");
        return _$q.reject(new Error("All vehicles are locked"));
      }
      oldSolution = {
        route: route,
        polylines: polylines,
        unaffectedVehicles: lockedVehicles,
        affectedVehicles: fleet
      };
      fleetObj = _formatFleet(fleet);
      visitsObj = _formatVisits(visits);
      solution = _getSolutionFromRoute(route, fleet);
      unserved = _getUnservedAsArray(route);
      data = {
        fleet: fleetObj,
        visits: visitsObj,
        solution: solution,
        unserved: unserved,
        options: {
          max_vehicle_overtime: 10000,
          max_visit_lateness: 10000
        }
      };
      data.date = _toFuture(route.date);
      hasDoneVisits = false;
      doneVisitsByVehicleId = _getDoneVisitsByVehicleId(_dispatchF.getDispatches(), solution);
      originalData = _.cloneDeep(data);
      if ((doneVisitsByVehicleId != null) && Object.keys(doneVisitsByVehicleId).length > 0) {
        data = _modifyDataWithDoneVisitsByVehicleId(data, doneVisitsByVehicleId);
        for (vehicleId in doneVisitsByVehicleId) {
          doneVisitIds = doneVisitsByVehicleId[vehicleId];
          if (doneVisitIds.length > 0) {
            hasDoneVisits = true;
            break;
          }
        }
      }
      _setFixRouteInProgress(true);
      _ref1 = data.unserved;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        v = _ref1[_i];
        isCompatible = (function(v) {
          var vehicle;
          for (vehicle in data.fleet) {
            if (_visitCompatibilityF.isCompatible(data, v, vehicle)) {
              return true;
            }
          }
          return false;
        })(v);
        if (!isCompatible) {
          for (vehicle in data.fleet) {
            _removeVisitConstraints(data, v, vehicle);
          }
        }
      }
      vehicles = (function() {
        var _results;
        _results = [];
        for (k in data.fleet) {
          _results.push(k);
        }
        return _results;
      })();
      _checkAndRemoveConstraints(data);
      optimizeMethod = null;
      if (_dispatchF.hasDispatches()) {
        optimizeMethod = _fetchFixWithRetry(data, vehicles, {
          retryOnUnserved: true
        });
      } else {
        _removeUnservedTimeWindows(data);
        optimizeMethod = _fetchOptimizedRoute(data, false).then(_projectJobF.pollPendingJob);
      }
      return optimizeMethod.then((function(_this) {
        return function(res) {
          var mergedSolution, mergedSolutions, oldSolutionForVehicle, sltn, solutionForMinIdle, visitsForMinIdleSolution, _ref2;
          if (hasDoneVisits) {
            solution = res.solution;
            mergedSolutions = {};
            for (vehicleId in solution) {
              sltn = solution[vehicleId];
              oldSolutionForVehicle = (_ref2 = oldSolution.route) != null ? _ref2.solution[vehicleId] : void 0;
              doneVisitIds = doneVisitsByVehicleId[vehicleId];
              if ((oldSolutionForVehicle != null) && (doneVisitIds != null ? doneVisitIds.length : void 0) > 0) {
                mergedSolution = _mergeSolutionWithDoneVisits(sltn, oldSolutionForVehicle, doneVisitIds);
              } else {
                mergedSolution = sltn;
              }
              mergedSolutions[vehicleId] = mergedSolution;
              visitsForMinIdleSolution = _.filter(mergedSolution, function(visit) {
                return visit.finish_time != null;
              });
              solutionForMinIdle = _.map(visitsForMinIdleSolution, function(visit) {
                return visit.location_id;
              });
              originalData.solution[vehicleId] = solutionForMinIdle;
            }
            delete originalData['unserved'];
            return _fetchMinIdle(originalData).then(function(res) {
              var _ref3;
              _ref3 = res.solution;
              for (vehicleId in _ref3) {
                solution = _ref3[vehicleId];
                if (mergedSolutions[vehicleId] != null) {
                  res.solution[vehicleId] = mergedSolutions[vehicleId];
                }
              }
              _normalizePolylines(res);
              return _this.replace(res, visits, drivers, oldSolution);
            });
          } else {
            _normalizePolylines(res);
            return _this.replace(res, visits, drivers, oldSolution);
          }
        };
      })(this)).then(function() {
        return _eventListenersF.notify(_events.PROJECT_MODIFIED);
      })["catch"](function(err) {
        _setRoute(oldSolution.route);
        _polylines = oldSolution.polylines;
        _eventListenersF.notify(_events.OPTIMIZATION_ERRORED, err);
        return _$q.reject(err);
      })["finally"](function() {
        return _setFixRouteInProgress(false);
      });
    };

    RouteS.prototype.getColorForDriver = function(vehicleId) {
      var _ref, _ref1, _ref2, _ref3;
      var color = (_ref = _route.solution) != null ? (_ref1 = _ref.response) != null ? (_ref2 = _ref1[vehicleId]) != null ? (_ref3 = _ref2.color) != null ? _ref3.name : void 0 : void 0 : void 0 : void 0;
      if (color) {
        return color;
      }
      return null;
    };

    RouteS.prototype.getDriverName = function(vehicleId) {
      var _ref, _ref1, _ref2, _ref3;
      var name = (_ref = _route.solution) != null ? (_ref1 = _ref.response) != null ? (_ref2 = _ref1[vehicleId]) != null ? (_ref3 = _ref2.driver) != null ? _ref3.name : void 0 : void 0 : void 0 : void 0;
      if (name) {
        return name;
      }
      return null;
    };

    RouteS.prototype.getRoute = function() {
      return _route;
    };

    _updateVisitsCountWithNotification = function() {
      var driverId, routeInfo, routeVisit, routes, visits, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
      var count = 0;
      routes = _route != null ? (_ref = _route.solution) != null ? _ref.response : void 0 : void 0;
      if (!routes) {
        return;
      }
      visits = _visitF.getVisitInfoMap();
      if (!(Object.keys(visits).length > 0)) {
        return;
      }
      for (driverId in routes) {
        routeInfo = routes[driverId];
        _ref1 = routeInfo.visits;
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          routeVisit = _ref1[_i];
          if (_accountF.isEmailNotificationOn() && (((_ref2 = visits[routeVisit.location_id]) != null ? _ref2.email : void 0) != null) && ((_ref3 = visits[routeVisit.location_id]) != null ? _ref3.email.length : void 0) > 0) {
            count += 1;
          }
          if (_accountF.isSmsNotificationOn() && (((_ref4 = visits[routeVisit.location_id]) != null ? _ref4.phone : void 0) != null) && ((_ref5 = visits[routeVisit.location_id]) != null ? _ref5.phone.length : void 0) > 0 && ((_ref6 = visits[routeVisit.location_id]) != null ? _ref6.phoneWarning : void 0) === void 0 && ((_ref7 = visits[routeVisit.location_id]) != null ? _ref7.smsError : void 0) === void 0) {
            count += 1;
          }
        }
      }
      return _visitsWithNotificationCount = count;
    };

    RouteS.prototype.getNumberOfVisitsToNotify = function() {
      if (!_accountF.hasCustomerNotification() || _accountF.isNotificationDisabled() || (!_accountF.isEtaNotificationOn() && !_accountF.isDOTWNotificationOn() && !_accountF.isDeliveryConfirmationNotificationOn() && !_accountF.isCancelledNotificationOn())) {
        return null;
      }
      return _visitsWithNotificationCount;
    };

    RouteS.prototype.getExtraDays = function() {
      var maxEndDate, solution, _ref;
      solution = (_ref = this.getRoute()) != null ? _ref.solution : void 0;
      if (!solution) {
        return 0;
      }
      maxEndDate = _getMaxEndDate(solution);
      return maxEndDate.getDate() - 1;
    };

    RouteS.prototype.hasRoute = function() {
      return !_.isEmpty(_route);
    };

    RouteS.prototype.hasUnserved = function() {
      return !_.isEmpty(this.getUnserved());
    };

    RouteS.prototype.getUnserved = function() {
      var route = this.getRoute();
      return _getUnserved(route);
    };

    RouteS.prototype.getNumUnserved = function() {
      if (!this.hasUnserved()) {
        return 0;
      }
      return Object.keys(this.getUnserved()).length;
    };

    RouteS.prototype.getPolylines = function() {
      return _polylines;
    };

    RouteS.prototype.getSettings = function() {
      if (!_route) {
        return null;
      }
      return _route.settings;
    };

    RouteS.prototype.goToPreviousRoute = function() {
      _routeHistoryF.goToPrevious();
      _refreshRoutes();
      _eventListenersF.notify(_events.PROJECT_MODIFIED);
      return _messagingF.clear();
    };

    RouteS.prototype.goToNextRoute = function() {
      _routeHistoryF.goToNext();
      _refreshRoutes();
      return _eventListenersF.notify(_events.PROJECT_MODIFIED);
    };

    RouteS.prototype.goToFirstRoute = function() {
      _routeHistoryF.goToFirst();
      _refreshRoutes();
      return _eventListenersF.notify(_events.PROJECT_MODIFIED);
    };

    RouteS.prototype.getNumRouteHistory = function() {
      return _routeHistoryF.getNumHistory();
    };

    RouteS.prototype.getHistoryIndex = function() {
      return _routeHistoryF.currentIndex;
    };

    RouteS.prototype.resetRoutesToCurrent = function() {
      return _routeHistoryF.clearAllExceptCurrent();
    };

    RouteS.prototype.load = _load;

    RouteS.prototype.replace = function(solution, visits, fleet, oldSolution, newJobId) {
      var cluster, clusterColor, driver, driverShiftsOverview, i, key, marker, shift, shifts, stop, value, workingTime, _i, _j, _len, _len1, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;
      if (oldSolution == null) {
        oldSolution = {};
      }
      if (!(solution && visits && fleet)) {
        return;
      }
      solution.num_visits = visits.length;
      solution.settings || (solution.settings = {});
      _ref = _settingsF.settings;
      for (key in _ref) {
        value = _ref[key];
        if (solution.settings[key] == null) {
          solution.settings[key] = value;
        }
      }
      solution.jobId = newJobId || (oldSolution != null ? (_ref1 = oldSolution.route) != null ? _ref1.jobId : void 0 : void 0) || solution.jobId;
      if ((oldSolution != null ? (_ref2 = oldSolution.unaffectedVehicles) != null ? _ref2.length : void 0 : void 0) > 0) {
        _mergeOldSolution(solution, oldSolution.route, oldSolution.polylines, oldSolution.unaffectedVehicles);
      }
      if ((oldSolution != null ? oldSolution.affectedVehicles : void 0) != null) {
        _dispatchStatusF.updateDispatchStatusForRoute(solution, oldSolution.affectedVehicles, oldSolution.route);
      }
      solution.routeLocks = _mergeRouteLocks(solution, oldSolution != null ? (_ref3 = oldSolution.route) != null ? _ref3.routeLocks : void 0 : void 0);
      solution.routeIdMap = _mergeRouteIdMap(solution, oldSolution != null ? (_ref4 = oldSolution.route) != null ? _ref4.routeIdMap : void 0 : void 0);
      solution.solution.response = _parseSolution(solution, fleet);
      solution.solution.request = {
        visits: visits,
        fleet: fleet
      };
      solution.unserved = _mergeUnserved(solution.unserved, oldSolution.unserved);
      solution.num_unserved = Object.keys(solution.unserved).length;
      _ref5 = _parseShifts(solution, fleet), workingTime = _ref5[0], shifts = _ref5[1], driverShiftsOverview = _ref5[2];
      solution.workingTime = workingTime;
      solution.shifts = shifts;
      solution.driverShiftsOverview = driverShiftsOverview;
      solution.driverLoadsOverview = _parseLoads(solution, fleet, visits);
      if (solution.clusters != null) {
        _ref6 = solution.clusters;
        for (i = _i = 0, _len = _ref6.length; _i < _len; i = ++_i) {
          cluster = _ref6[i];
          clusterColor = _getColor(i);
          _ref7 = solution.unserved;
          for (stop in _ref7) {
            marker = _ref7[stop];
            if (cluster.visits[stop] != null) {
              marker.color = clusterColor;
            }
          }
          _ref8 = solution.shifts;
          for (i = _j = 0, _len1 = _ref8.length; _j < _len1; i = ++_j) {
            shift = _ref8[i];
            if (cluster.fleet[shift.id] != null) {
              shift.color = clusterColor;
            }
          }
          _ref9 = solution.solution.response;
          for (driver in _ref9) {
            marker = _ref9[driver];
            if (cluster.fleet[driver] != null) {
              marker.color = clusterColor;
            }
          }
        }
      }
      _routeHistoryF.push(_.cloneDeep(solution));
      _polylines = _routeHistoryF.getPolyline();
      _updateRouteSummary(solution.solution.response, _polylines, solution.unserved);
      _setRoute(solution);
      _syncMarkersVisibility(_summary);
      _routeInspectorF.inspectRoute(solution, visits, fleet);
      _routeMarkerInfoF.updateAllMarkerInfo(solution.solution.response, solution.unserved);
      _markerClustererF.update(solution.solution.response, solution.unserved);
      _clearVisibilityEventListeners();
      return _updateVisitsCountWithNotification();
    };

    RouteS.prototype.addVisitAsUnserved = function(entry) {
      return this.addVisitsAsUnserved([entry]);
    };

    RouteS.prototype.addVisitsAsUnserved = function(entries) {
      var entry, error, newRoute, request, _i, _len, _ref;
      if (!this.hasRoute()) {
        return;
      }
      newRoute = _.cloneDeep(_route);
      newRoute.num_visits += entries.length;
      request = (_ref = newRoute.solution) != null ? _ref.request : void 0;
      request.visits = request.visits.concat(entries);
      error = _constants.unservedMessages.newStop;
      newRoute.unserved || (newRoute.unserved = {});
      for (_i = 0, _len = entries.length; _i < _len; _i++) {
        entry = entries[_i];
        newRoute.unserved[entry.id] = _genUnserved(error);
      }
      newRoute.num_unserved = Object.keys(newRoute.unserved).length;
      _routeHistoryF.clear();
      _routeHistoryF.push(_.cloneDeep(newRoute));
      _polylines = _routeHistoryF.getPolyline();
      _updateRouteSummary(newRoute.solution.response, _polylines, newRoute.unserved);
      _syncMarkersVisibility(_summary);
      _routeInspectorF.inspectRoute(newRoute, request.visits, request.fleet);
      _routeMarkerInfoF.updateAllMarkerInfo(newRoute.solution.response, newRoute.unserved);
      _markerClustererF.update(_route.solution.response, _route.unserved);
      _clearVisibilityEventListeners();
      return _setRoute(newRoute);
    };

    RouteS.prototype.syncMarkersVisibility = function() {
      return _syncMarkersVisibility(_summary);
    };

    RouteS.prototype.setAllRouteLocks = function(lockStatus) {
      var driverId, newRoute;
      if (!this.hasRoute()) {
        return;
      }
      newRoute = _.cloneDeep(_route);
      for (driverId in newRoute.routeLocks) {
        newRoute.routeLocks[driverId] = lockStatus;
      }
      _routeHistoryF.push(_.cloneDeep(newRoute));
      _setRoute(newRoute);
      return _eventListenersF.notify(_events.PROJECT_MODIFIED);
    };

    RouteS.prototype.setRouteLock = function(driverId, lockStatus) {
      var newRoute;
      if (!this.hasRoute()) {
        return;
      }
      newRoute = _.cloneDeep(_route);
      newRoute.routeLocks[driverId] = lockStatus;
      _routeHistoryF.push(_.cloneDeep(newRoute));
      _setRoute(newRoute);
      return _eventListenersF.notify(_events.PROJECT_MODIFIED);
    };

    RouteS.prototype.toggleRouteLock = function(driverId) {
      var currentLockState = _route.routeLocks[driverId];
      return this.setRouteLock(driverId, !currentLockState);
    };

    RouteS.prototype.addEmptyDrivers = function(entries) {
      var entry, fleet, oldFleet, oldRoute, oldSolution, request, route, visits, _i, _len;
      if (!this.hasRoute()) {
        return;
      }
      oldRoute = _.cloneDeep(this.getRoute());
      route = _.cloneDeep(this.getRoute());
      request = route.solution.request;
      fleet = request.fleet;
      oldFleet = _.clone(fleet);
      for (_i = 0, _len = entries.length; _i < _len; _i++) {
        entry = entries[_i];
        fleet.push(entry);
        route.solution[entry.id] = [];
      }
      visits = request.visits;
      oldSolution = {
        route: route,
        polylines: this.getPolylines(),
        unserved: _getUnservedAsVisitsArray(route),
        unaffectedVehicles: oldFleet,
        affectedVehicles: []
      };
      return _fetchEmptyRoute(entries, route.date).then((function(_this) {
        return function(res) {
          _normalizePolylines(res);
          _removeDummy(res);
          return _this.replace(res, visits, fleet, oldSolution);
        };
      })(this))["catch"](function(err) {
        _setRoute(oldRoute);
        _polylines = oldRoute.polylines;
        return _eventListenersF.notify(_events.OPTIMIZATION_ERRORED, err);
      });
    };

    RouteS.prototype.moveDriverStopsToUnserved = function(driver, saveProject) {
      var affectedVehicles, d, driverVisits, fleet, isAffectedDriver, oldRoute, oldSolution, route, unaffectedVehicles, unserveds, visits, _i, _len;
      if (saveProject == null) {
        saveProject = true;
      }
      if (!this.hasRoute()) {
        return;
      }
      oldRoute = _.cloneDeep(this.getRoute());
      route = this.getRoute();
      visits = route.solution.request.visits;
      fleet = route.solution.request.fleet;
      affectedVehicles = [];
      unaffectedVehicles = [];
      for (_i = 0, _len = fleet.length; _i < _len; _i++) {
        d = fleet[_i];
        isAffectedDriver = d.id === driver.id;
        if (isAffectedDriver) {
          affectedVehicles.push(d);
        }
        if (!isAffectedDriver) {
          unaffectedVehicles.push(d);
        }
      }
      driverVisits = _getDriverVisits(driver);
      unserveds = driverVisits.concat(_getUnservedAsVisitsArray(route));
      oldSolution = {
        route: route,
        polylines: this.getPolylines(),
        unserved: unserveds,
        unaffectedVehicles: unaffectedVehicles,
        affectedVehicles: affectedVehicles
      };
      return _fetchEmptyRoute([driver], route.date).then((function(_this) {
        return function(res) {
          _normalizePolylines(res);
          _removeDummy(res);
          res.isUserSolution = true;
          _this.replace(res, visits, fleet, oldSolution);
          if (saveProject) {
            return _eventListenersF.notify(_events.PROJECT_MODIFIED);
          }
          return _$q.when(true);
        };
      })(this))["catch"](function(err) {
        _setRoute(oldRoute);
        _polylines = oldRoute.polylines;
        return _eventListenersF.notify(_events.OPTIMIZATION_ERRORED, err);
      });
    };

    RouteS.prototype.removeFromUnserved = function(visit) {
      var newRoute;
      if (!_route.unserved[visit.id]) {
        return;
      }
      delete _route.unserved[visit.id];
      _route.num_visits--;
      _route.num_unserved--;
      newRoute = _.cloneDeep(_route);
      _setRoute(newRoute);
      _routeHistoryF.push(newRoute);
      return _routeMarkerInfoF.updateAllMarkerInfo(_route.solution.response, _route.unserved);
    };

    RouteS.prototype.removeDepotFromRoute = function(locationId, entryId) {
      var _ref;
      if ((_route != null ? (_ref = _route.solution) != null ? _ref[entryId] : void 0 : void 0) == null) {
        return;
      }
      return _route.solution[entryId] = _route.solution[entryId].filter(function(obj) {
        return obj.location_id !== locationId;
      });
    };

    RouteS.prototype.removeStopsFromRoute = function(visits, dateStr) {
      var i, index, key, newSolution, stopId, unservedList, value, visit, _i, _len, _ref;
      newSolution = _formatRoute(_route.solution);
      for (i in visits) {
        visit = visits[i];
        if (_route.unserved[visit.id]) {
          this.removeFromUnserved(visit);
        } else {
          for (key in newSolution) {
            value = newSolution[key];
            _ref = value.route;
            for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
              stopId = _ref[index];
              if (stopId === visit.id) {
                value.route.splice(index, 1);
              }
            }
          }
        }
        unservedList = _toArray(_route.unserved);
        _loggerF.info(_loggerF.ACTIONS.UNSCHEDULED_STOP, {
          stop_id: visit.id
        });
      }
      if (_visitF.getVisits().length) {
        return this.fixRoute(dateStr, unservedList, newSolution);
      } else {
        this.clear();
        return _visitF.deleteAll();
      }
    };

    RouteS.prototype.removeStopFromRoute = function(visit, dateStr, asUnserved) {
      var index, key, newSolution, stopId, unservedList, value, visitIndex, visits, _i, _len, _ref;
      if (asUnserved == null) {
        asUnserved = false;
      }
      newSolution = _formatRoute(_route.solution);
      visitIndex = -1;
      for (key in newSolution) {
        value = newSolution[key];
        _ref = value.route;
        for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
          stopId = _ref[index];
          if (stopId === visit.id) {
            visitIndex = index;
            break;
          }
        }
        if (visitIndex > -1) {
          value.route.splice(visitIndex, 1);
          break;
        }
      }
      if (visitIndex < 0) {
        return _$q.when(true);
      }
      unservedList = _toArray(_route.unserved);
      if (asUnserved) {
        unservedList.push({
          id: visit.id,
          error: _constants.unservedMessages.manuallyUnserved
        });
      } else {
        visits = _.filter(visits, function(entry) {
          return entry.id !== visit.id;
        });
      }
      _loggerF.info(_loggerF.ACTIONS.UNSCHEDULED_STOP, {
        stop_id: visit.id
      });
      return this.fixRoute(dateStr, unservedList, newSolution);
    };

    RouteS.prototype.moveStopToUnserved = function(visit) {
      var date;
      if (_route.unserved[visit.id] && !this.hasRoute()) {
        return;
      }
      date = _toFuture(_route.date);
      _projectF = _$injector.get('ProjectF');
      _analyticsS.track('085 Unscheduling a stop', {
        project_id: _projectF.project.id,
        user_email: _accountF.getUser().email,
        before_first_dispatch: !_dispatchF.hasDispatches()
      });
      return this.removeStopFromRoute(visit, date, true);
    };

    RouteS.prototype.reoptimizeDriverWithStop = function(visit) {
      var driverId;
      if (this.isUnservedVisit(visit)) {
        return;
      }
      driverId = _findDriverIdWithStop(visit, _route.solution);
      if (!driverId) {
        return;
      }
      return this.forceDriversReroute([driverId]);
    };

    RouteS.prototype.isDriverAtFinalDepot = function(driverId) {
      var isDepot, isDone, lastStop, route, _ref, _ref1;
      route = (_ref = _dispatchF.getDispatchWithVehicleId(driverId)) != null ? (_ref1 = _ref.solution) != null ? _ref1.visits : void 0 : void 0;
      if (!((route != null ? route.length : void 0) > 0)) {
        return false;
      }
      lastStop = route[route.length - 1];
      isDepot = !lastStop.finish_time;
      isDone = _visitUtilF.isSkippedDoneStatus(lastStop.status);
      return isDepot && isDone;
    };

    RouteS.prototype.minIdleDrivers = function() {
      var driverId, fleet, route, _ref;
      fleet = [];
      _ref = _route.solution;
      for (driverId in _ref) {
        route = _ref[driverId];
        if (!this.isDriverAtFinalDepot(driverId)) {
          fleet.push(driverId);
        }
      }
      return this.forceDriversReroute(fleet);
    };

    RouteS.prototype.forceDriversReroute = function(fleetIds) {
      var newSolution, unservedList;
      var date = _toFuture(_route.date);
      unservedList = _toArray(_route.unserved);
      newSolution = _formatRoute(_route.solution);
      return this.fixRoute(date, unservedList, newSolution, fleetIds);
    };

    RouteS.prototype.removeStop = function(visit, dateStr) {
      var promise;
      if (!this.hasRoute()) {
        return;
      }
      promise = null;
      if (visit.length) {
        promise = this.removeStopsFromRoute(visit, dateStr);
      } else if (_route.unserved[visit.id]) {
        promise = this.removeFromUnserved(visit);
      } else {
        promise = this.removeStopFromRoute(visit, dateStr);
      }
      return promise;
    };

    RouteS.prototype.removeEmptyDriver = function(driver, saveProject) {
      var id, request, route, solution;
      if (saveProject == null) {
        saveProject = true;
      }
      if (!driver) {
        return;
      }
      id = driver.id;
      if (!this.hasRoute()) {
        return;
      }
      route = _.cloneDeep(this.getRoute());
      delete route.distances[id];
      delete route.polylines[id];
      solution = route.solution;
      delete solution[id];
      delete solution.response[id];
      route.routes = _.filter(route.routes, function(e) {
        return e._id !== id;
      });
      route.shifts = _.filter(route.shifts, function(e) {
        return e.id !== id;
      });
      request = route.solution.request;
      request.fleet = _.filter(request.fleet, function(e) {
        return e.id !== id;
      });
      delete _polylines[id];
      _setRoute(route);
      _routeHistoryF.clear();
      _routeHistoryF.push(_.cloneDeep(_route));
      _polylines = _routeHistoryF.getPolyline();
      _updateRouteSummary(_route.solution.response, _polylines, _route.unserved);
      if (saveProject) {
        return _eventListenersF.notify(_events.PROJECT_MODIFIED);
      }
      return _$q.when(driver);
    };

    RouteS.prototype.isUnservedVisit = function(visit) {
      var _ref;
      return !!(_route != null ? (_ref = _route.unserved) != null ? _ref[visit.id] : void 0 : void 0);
    };

    RouteS.prototype.isDriverEmpty = function(driver) {
      var depots, id, route, solution, stop, _i, _len, _ref, _ref1;
      if (!driver) {
        return void 0;
      }
      id = driver.id;
      route = this.getRoute();
      solution = (_ref = route.solution) != null ? _ref[id] : void 0;
      if (solution == null) {
        return true;
      }
      depots = [driver.startLocation.id];
      if (driver.endLocation) {
        depots.push(driver.endLocation.id);
      }
      for (_i = 0, _len = solution.length; _i < _len; _i++) {
        stop = solution[_i];
        if (_ref1 = stop.location_id, __indexOf.call(depots, _ref1) < 0) {
          return false;
        }
      }
      return true;
    };

    RouteS.prototype.isRouteLocked = function(driverId) {
      var _ref;
      return !!((_ref = _route.routeLocks) != null ? _ref[driverId] : void 0);
    };

    RouteS.prototype.isVisitLocked = function(visitId) {
      return !!_visitsLockMapping[visitId];
    };

    RouteS.prototype.isRouteDirty = function() {
      var dispatches, routeStatus, solution, vehId, _ref;
      if (!_route) {
        return false;
      }
      dispatches = _route.dispatches;
      solution = _route.solution;
      for (vehId in dispatches) {
        routeStatus = dispatches[vehId];
        if (routeStatus.isDirty && (solution[vehId] != null) && (((_ref = _dispatchStatusF.getSentTimes()) != null ? _ref[vehId] : void 0) != null)) {
          return true;
        }
      }
      return false;
    };

    RouteS.prototype.isDriverHasServedStops = function(driver) {
      var id, route, visit, _ref, _ref1;
      route = (_ref = _dispatchF.getDispatchWithVehicleId(driver.id)) != null ? (_ref1 = _ref.solution) != null ? _ref1.visits : void 0 : void 0;
      if (!route) {
        return false;
      }
      for (id in route) {
        visit = route[id];
        if (_visitUtilF.isSkippedDoneStatus(visit.status)) {
          return true;
        }
      }
      return false;
    };

    RouteS.prototype.getCurrentRouteState = function() {
      return this.currentState;
    };

    RouteS.prototype.setCurrentRouteState = function(state) {
      return this.currentState = state;
    };

    RouteS.prototype.emptySummary = function() {
      return _summary = {};
    };

    RouteS.prototype.reverseRoute = function(driver) {
      var date, newSolution, unservedList;
      if (!driver) {
        return _$q.reject(new Error("Driver not found"));
      }
      newSolution = _formatRoute(_route.solution);
      if (!newSolution) {
        return _$q.reject(new Error("Solution not found"));
      }
      newSolution[driver.id].route.reverse();
      unservedList = _toArray(_route.unserved);
      date = _toFuture(_route.date);
      return this.fixRoute(date, unservedList, newSolution);
    };

    RouteS.prototype.swapRoute = function(driver1, driver2) {
      var date, driver1Routes, driver2Routes, newSolution, unservedList;
      if (!(driver1 && driver2)) {
        return _$q.reject(new Error("Driver not found"));
      }
      newSolution = _formatRoute(_route.solution);
      if (!newSolution) {
        return _$q.reject(new Error("Solution not found"));
      }
      driver1Routes = newSolution[driver1].route;
      driver2Routes = newSolution[driver2].route;
      newSolution[driver1].route = driver2Routes;
      newSolution[driver2].route = driver1Routes;
      unservedList = _toArray(_route.unserved);
      date = _toFuture(_route.date);
      return this.fixRoute(date, unservedList, newSolution, false);
    };

    RouteS.prototype.updateRouteVisit = function(visit) {
      var driverId, solution, visits;
      solution = _route;
      visits = _visitF.getVisits();
      driverId = _findDriverIdWithStop(visit, solution.solution);
      _dispatchStatusF.updateDispatchStatusForRoute(solution, [
        {
          id: driverId
        }
      ], solution);
      return _dispatchStatusF.setPendingRoutesCount(solution);
    };

    return RouteS;

  })();

  angular.module('app').service('RouteS', ['$http', '$q', '$timeout', '$injector', 'Constants', 'PolylineColors', 'UnservedColor', 'AccountF', 'VisitF', 'DriverF', 'GPolylineF', 'GMarkerF', 'RouteHistoryF', 'RouteInspectorF', 'RouteMarkerInfoF', 'TimeUtilF', 'SettingsF', 'PolylineUtil', 'EventListenersF', 'Events', 'DispatchStatusF', 'VisitCompatibilityF', 'DispatchF', 'VisitUtilF', 'MarkerClustererF', 'MessagingF', 'LoggerF', 'AnalyticsS', 'SessionF', 'ProjectJobF', RouteS]);

}).call(this);

(function() {
  var RouteTimelineC = function($state, $scope, $cacheFactory, $timeout, $translate, States, ProjectF, AccountF, OnboardingF, ConfirmF, RouteS, MessagingF, Feature, AnalyticsS, TimeUtilF) {
    var CACHE_ID, EDIT_STATE, FIVE_SECONDS_IN_MS, LIVE_STATE, PLAN_STATE, ROUTE_STAGES, SHOW_LIVE_TRACKING_TRIAL_END_KEY, _isInState, _showLiveTrackingTrialEndMessage;
    CACHE_ID = 'routeTimelineC';
    SHOW_LIVE_TRACKING_TRIAL_END_KEY = 'liveTrackingTrialEnd';
    FIVE_SECONDS_IN_MS = 5 * 1000;
    LIVE_STATE = States.projectRouteLive;
    EDIT_STATE = States.projectRouteEdit;
    PLAN_STATE = States.projectRoutePlan;
    ROUTE_STAGES = {};
    ROUTE_STAGES[LIVE_STATE] = {
      className: 'live',
      stageName: "ROUTE_BOX.LIVE"
    };
    ROUTE_STAGES[PLAN_STATE] = {
      className: 'plan',
      stageName: "ROUTE_BOX.PLAN"
    };
    ROUTE_STAGES[EDIT_STATE] = {
      className: 'edit',
      stageName: "ROUTE_BOX.EDIT"
    };
    _isInState = function(stateName) {
      return RouteS.getCurrentRouteState() === stateName;
    };
    _showLiveTrackingTrialEndMessage = (function(_this) {
      return function(forceShow) {
        var cache, isLiveTrackingEndCtaShown, liveTrackingTrial, remaining;
        if (forceShow == null) {
          forceShow = false;
        }
        if (ProjectF.isPastProject()) {
          return;
        }
        if (!$cacheFactory.get(CACHE_ID)) {
          $cacheFactory(CACHE_ID);
        }
        cache = $cacheFactory.get(CACHE_ID);
        isLiveTrackingEndCtaShown = cache.get(SHOW_LIVE_TRACKING_TRIAL_END_KEY);
        liveTrackingTrial = AccountF.getLiveTrackingTrial();
        if (AccountF.hasPaidLiveTracking() || !liveTrackingTrial || (isLiveTrackingEndCtaShown && !forceShow)) {
          return;
        }
        remaining = TimeUtilF.diffDays(new Date(liveTrackingTrial.expiryTime), new Date());
        if (remaining > 5) {
          return;
        }
        _this.cancelLiveTrackingTrialEndMessage();
        _this.showLiveTrackingTrialEndMessage = true;
        _this.hasLiveTracking = AccountF.hasLiveTracking();
        _this.liveTrackingTrialDays = remaining;
        _this.liveTrackingEndMessageTime = Date.now();
        _this.liveTrackingMessageTimer = $timeout(function() {
          return _this.hideLiveTrackingTrialEndMessage();
        }, FIVE_SECONDS_IN_MS);
        return cache.put(SHOW_LIVE_TRACKING_TRIAL_END_KEY, true);
      };
    })(this);
    this.getClass = function() {
      var _ref;
      return (_ref = ROUTE_STAGES[RouteS.getCurrentRouteState()]) != null ? _ref.className : void 0;
    };
    this.getRouteStage = function() {
      var _ref;
      var stageName = (_ref = ROUTE_STAGES[RouteS.getCurrentRouteState()]) != null ? _ref.stageName : void 0;
      return $translate.instant(stageName);
    };
    this.inLiveState = function() {
      return _isInState(LIVE_STATE);
    };
    this.inPlanState = function() {
      return _isInState(PLAN_STATE);
    };
    this.inEditState = function() {
      return _isInState(EDIT_STATE);
    };
    this.toggleChartMode = function() {
      var forceShow, hasLiveTracking, isOptedOutOfLiveTracking, liveTransitionPromise, __trackTransition;
      __trackTransition = function(flow) {
        return AnalyticsS.track('045 Chart switch', {
          flow: flow
        });
      };
      if (this.inEditState()) {
        hasLiveTracking = AccountF.hasLiveTracking();
        isOptedOutOfLiveTracking = AccountF.isOptedOutOfLiveTracking();
        if (!hasLiveTracking) {
          if (isOptedOutOfLiveTracking) {
            $scope.projectC.showLiveTrackOptIn = true;
            return OnboardingF.setOnboarding(false);
          } else {
            return _showLiveTrackingTrialEndMessage(forceShow = true);
          }
        } else if ($scope.hud.liveTrackingOngoing()) {
          liveTransitionPromise = null;
          if ($scope.route.isRouteDirty()) {
            ConfirmF.confirm("MESSAGES.RETURN_TO_LIVE_MODE_CONFIRMATION").then(function() {
              __trackTransition('edit to live');
              RouteS.goToFirstRoute();
              return liveTransitionPromise = $state.go(States.projectRouteLive);
            });
          } else {
            __trackTransition('edit to live');
            liveTransitionPromise = $state.go(States.projectRouteLive);
          }
          if (liveTransitionPromise) {
            return liveTransitionPromise.then(function() {
              return _showLiveTrackingTrialEndMessage();
            });
          }
        } else if (ProjectF.isInFuture()) {
          return MessagingF.replaceError("MESSAGES.TOO_EARLY_FOR_LIVE_TRACKING", {
            date: ProjectF.project.date
          });
        }
      } else if (this.inLiveState()) {
        __trackTransition('live to edit');
        return $state.go(States.projectRouteEdit);
      }
    };
    this.cancelLiveTrackingTrialEndMessage = (function(_this) {
      return function() {
        if (_this.liveTrackingMessageTimer) {
          $timeout.cancel(_this.liveTrackingMessageTimer);
        }
        return _this.liveTrackingMessageTimer = null;
      };
    })(this);
    this.hideLiveTrackingTrialEndMessage = (function(_this) {
      return function() {
        var waitTime = (_this.liveTrackingEndMessageTime + FIVE_SECONDS_IN_MS) - Date.now();
        return $timeout(function() {
          return _this.showLiveTrackingTrialEndMessage = false;
        }, waitTime);
      };
    })(this);
    if (this.inLiveState()) {
      _showLiveTrackingTrialEndMessage();
    }
  };
  RouteTimelineC.$inject = ["$state", "$scope", "$cacheFactory", "$timeout", "$translate", "States", "ProjectF", "AccountF", "OnboardingF", "ConfirmF", "RouteS", "MessagingF", "Feature", "AnalyticsS", "TimeUtilF"];

  angular.module('app').controller('RouteTimelineC', RouteTimelineC);

}).call(this);

(function() {
  var RouteUtil = function(AccountF, VisitF, DriverF, TimeUtilF, Constants, $translate) {
    var DISPATCH_STATUS, _findDriverInfo, _findInfo, _findVisitInfo;
    DISPATCH_STATUS = Constants.DISPATCH_STATUS;
    _findVisitInfo = function(id) {
      var visit = VisitF.getVisit(id);
      if (!visit) {
        return null;
      }
      return {
        location: {
          id: id,
          name: visit.name,
          address: visit.location.address,
          lat: visit.location.coords.lat,
          lng: visit.location.coords.lng,
          coords: {
            lat: visit.location.coords.lat,
            lng: visit.location.coords.lng
          }
        },
        start: TimeUtilF.convertDateToTime(visit.startDate),
        end: TimeUtilF.convertDateToTime(visit.endDate),
        duration: visit.duration,
        load: visit.load,
        types: visit.types,
        phone: visit.phone,
        email: visit.email,
        notes: visit.notes,
        notes2: visit.notes2,
        customNotes: visit.customNotes
      };
    };
    _findDriverInfo = function(id) {
      var current, driver, drivers, location, _i, _len;
      driver = void 0;
      location = null;
      drivers = DriverF.getValidDrivers();
      for (_i = 0, _len = drivers.length; _i < _len; _i++) {
        current = drivers[_i];
        if (current.startLocation && current.startLocation.id.toString() === id) {
          location = current.startLocation;
        } else if (current.endLocation && current.endLocation.id.toString() === id) {
          location = current.endLocation;
        }
        if (location) {
          driver = {
            location: {
              id: id,
              name: current.name,
              address: location.info.address,
              lat: location.info.coords.lat,
              lng: location.info.coords.lng,
              coords: {
                lat: location.info.coords.lat,
                lng: location.info.coords.lng
              }
            }
          };
          break;
        }
      }
      return driver;
    };
    _findInfo = function(id) {
      return _findVisitInfo(id) || _findDriverInfo(id);
    };
    RouteUtil = {};
    RouteUtil.isDone = function(dispatch) {
      var visit, _i, _len, _ref, _ref1, _ref2;
      if (!(dispatch != null ? (_ref = dispatch.solution) != null ? _ref.visits : void 0 : void 0)) {
        return false;
      }
      _ref2 = dispatch != null ? (_ref1 = dispatch.solution) != null ? _ref1.visits : void 0 : void 0;
      for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
        visit = _ref2[_i];
        if (!visit.status) {
          return false;
        }
      }
      return true;
    };
    RouteUtil.isStarted = function(dispatch) {
      var _ref, _ref1, _ref2;
      return (dispatch != null ? (_ref = dispatch.solution) != null ? (_ref1 = _ref.visits) != null ? (_ref2 = _ref1[0]) != null ? _ref2.status : void 0 : void 0 : void 0 : void 0) != null;
    };
    RouteUtil.getDoneTime = function(dispatch) {
      var lastLog, lastVisit, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      if (!(dispatch != null ? (_ref = dispatch.solution) != null ? _ref.visits : void 0 : void 0)) {
        return;
      }
      lastVisit = (dispatch != null ? (_ref1 = dispatch.solution) != null ? (_ref2 = _ref1.visits) != null ? _ref2.length : void 0 : void 0 : void 0) - 1;
      lastLog = dispatch != null ? (_ref3 = dispatch.solution) != null ? (_ref4 = _ref3.visits[lastVisit]) != null ? (_ref5 = _ref4.log) != null ? _ref5.find(function(l) {
        return l.status === 'done' || l.status === 'skipped';
      }) : void 0 : void 0 : void 0 : void 0;
      return lastLog != null ? lastLog.date : void 0;
    };
    RouteUtil.calculateProcessingTime = function(numVisits) {
      var time = 0;
      if (numVisits < 100) {
        time = 10;
      } else if (numVisits < 200) {
        time = 60;
      } else if (numVisits < 300) {
        time = 150;
      } else if (numVisits < 2000) {
        time = 600;
      } else {
        time = 1200;
      }
      return time * 1000;
    };
    RouteUtil.formatRoute = function(route) {
      var current, index, info, step, _i, _len, _results;
      _results = [];
      for (index = _i = 0, _len = route.length; _i < _len; index = ++_i) {
        current = route[index];
        info = null;
        if (!current["break"]) {
          info = _findInfo(current.location_id);
          if (!info) {
            throw new Error("Location for " + current.location_name + " is not found");
          }
        }
        step = {
          arrival_time: current.arrival_time,
          finish_time: current.finish_time,
          idle_time: current.idle_time || 0,
          distance: current.distance || 0,
          id: current.location_id,
          "break": !!current["break"]
        };
        if (info) {
          step.location = info.location;
          step.name = info.location.name;
          if (info.duration) {
            step.duration = info.duration;
          }
          if (!AccountF.isTrimStopInfoFromSolution()) {
            if (info.load) {
              step.load = info.load;
            }
            if (info.phone) {
              step.phone = info.phone;
            }
            if (info.email) {
              step.email = info.email;
            }
            if (info.notes) {
              step.notes = info.notes;
            }
            if (info.notes2) {
              step.notes2 = info.notes2;
            }
            if (info.start) {
              step.start = info.start;
            }
            if (info.end) {
              step.end = info.end;
            }
            if (info.customNotes) {
              step.customNotes = info.customNotes;
            }
          }
        }
        _results.push(step);
      }
      return _results;
    };
    RouteUtil.formatDispatchRoute = function(route) {
      var arrivalTime, current, info, location, startTime, step, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = route.length; _i < _len; _i++) {
        current = route[_i];
        step = {
          "break": !!current["break"],
          arrival_time: current.arrival_time,
          finish_time: current.finish_time,
          idle_time: current.idle_time || 0
        };
        arrivalTime = TimeUtilF.convertTimeToDate(step.arrival_time);
        startTime = TimeUtilF.addMinutes(arrivalTime, step.idle_time);
        step.start_time = TimeUtilF.convertDateToTime(startTime);
        if (!current["break"]) {
          info = _findInfo(current.location_id);
          if (!info) {
            throw new Error("Location for " + current.location_name + " is not found");
          }
          location = info.location;
          step.location = {
            id: current.location_id,
            name: location.name,
            address: location.address,
            lat: location.lat,
            lng: location.lng
          };
          if (info.duration) {
            step.duration = info.duration;
          }
          if (info.load) {
            step.load = info.load;
          }
          if (info.phone) {
            step.phone = info.phone;
          }
          if (info.email) {
            step.email = info.email;
          }
          if (info.notes) {
            step.notes = info.notes;
          }
          if (info.notes2) {
            step.notes2 = info.notes2;
          }
          if (info.start) {
            step.start = info.start;
          }
          if (info.end) {
            step.end = info.end;
          }
          if (info.customNotes) {
            step.customNotes = info.customNotes;
          }
        }
        _results.push(step);
      }
      return _results;
    };
    RouteUtil.parseRoute = function(visits) {
      var current, step, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = visits.length; _i < _len; _i++) {
        current = visits[_i];
        step = {
          location_id: current.id,
          arrival_time: current.arrival_time,
          finish_time: current.finish_time,
          idle_time: current.idle_time || 0,
          "break": !!current["break"]
        };
        step.done = current.done || false;
        if (current.location) {
          step.location_name = current.location.address;
        }
        if (current.distance != null) {
          step.distance = current.distance;
        }
        if (current.duration) {
          step.duration = current.duration;
        }
        if (!AccountF.isTrimStopInfoFromSolution()) {
          if (current.load) {
            step.load = current.load;
          }
          if (current.phone) {
            step.phone = current.phone;
          }
          if (current.email) {
            step.email = current.email;
          }
          if (current.notes) {
            step.notes = current.notes;
          }
          if (current.notes2) {
            step.notes2 = current.notes2;
          }
          if (current.start) {
            step.start = current.start;
          }
          if (current.end) {
            step.end = current.end;
          }
          if (current.customNotes) {
            step.customNotes = current.customNotes;
          }
        }
        _results.push(step);
      }
      return _results;
    };
    RouteUtil.parseRouteDispatch = function(fleet, route) {
      var arrivalTime, coords, driver, driverMarker, id, index, numVisits, startTime, step, stopNumber, visits, _i, _j, _len, _len1, _ref, _results;
      _results = [];
      for (_i = 0, _len = fleet.length; _i < _len; _i++) {
        driver = fleet[_i];
        id = driver.id;
        visits = route[id];
        driverMarker = DriverF.getDriver(id);
        numVisits = 0;
        stopNumber = 1;
        for (index = _j = 0, _len1 = visits.length; _j < _len1; index = ++_j) {
          step = visits[index];
          coords = null;
          if (!!step.finish_time && !step["break"]) {
            step.visit = VisitF.getVisit(step.location_id);
            step.stopNumber = stopNumber++;
            coords = (_ref = step.visit.location) != null ? _ref.coords : void 0;
            numVisits++;
          } else if (step["break"]) {
            step.stopNumber = '';
            step.visit = {
              name: 'Break'
            };
          } else {
            if (index === 0) {
              coords = driverMarker.startLocation.info.coords;
              step.stopNumber = '0';
            } else {
              coords = driverMarker.endLocation.info.coords;
              step.stopNumber = 999;
            }
          }
          if (coords) {
            step.coords = {
              lat: coords.lat,
              lng: coords.lng
            };
          }
          arrivalTime = TimeUtilF.convertTimeToDate(step.arrival_time);
          startTime = TimeUtilF.addMinutes(arrivalTime, step.idle_time || 0);
          step.start_time = TimeUtilF.convertDateToTime(startTime);
        }
        _results.push({
          id: id,
          driver: driverMarker,
          steps: visits,
          selected: true,
          numVisits: numVisits
        });
      }
      return _results;
    };
    RouteUtil.getDispatchStatus = function(dispatch, routeDispatchInfo, phone, hasGPSTracking) {
      var dispatchStatus, isDone, isStarted;
      isDone = RouteUtil.isDone(dispatch);
      isStarted = RouteUtil.isStarted(dispatch);
      dispatchStatus = null;
      if ((dispatch != null) && (routeDispatchInfo != null ? routeDispatchInfo.isDirty : void 0)) {
        dispatchStatus = DISPATCH_STATUS.WAITING_FOR_UPDATE;
      }
      if ((dispatch != null) && !(routeDispatchInfo != null ? routeDispatchInfo.isDirty : void 0)) {
        dispatchStatus = DISPATCH_STATUS.DISPATCHED;
      }
      if ((dispatch == null) && (phone != null)) {
        dispatchStatus = DISPATCH_STATUS.NOT_DISPATCHED;
      }
      if ((dispatch == null) && (phone == null)) {
        dispatchStatus = DISPATCH_STATUS.MISSING_NUMBER;
      }
      if ((dispatch != null) && !(routeDispatchInfo != null ? routeDispatchInfo.isDirty : void 0) && hasGPSTracking && isStarted) {
        dispatchStatus = DISPATCH_STATUS.LIVE_TRACKING;
      }
      if (isDone) {
        dispatchStatus = DISPATCH_STATUS.COMPLETED;
      }
      if (dispatchStatus != null) {
        dispatchStatus.text = $translate.instant(dispatchStatus.key);
      }
      return dispatchStatus;
    };
    return RouteUtil;
  };
  RouteUtil.$inject = ["AccountF", "VisitF", "DriverF", "TimeUtilF", "Constants", "$translate"];

  angular.module('app').factory('RouteUtil', RouteUtil);

}).call(this);

(function() {
  var     __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  var VisitCompatibilityF = function(TimeUtilF) {
    var _hasCapacity, _isCompatible, _isEndCompatible, _isEndRemoved, _isStartCompatible, _isStartRemoved, _isTimeWindowCompatible, _isTypesCompatible;
    _isTimeWindowCompatible = function(visit, driver) {
      if (!(driver.shift_start || driver.shift_end)) {
        return true;
      }
      return _isStartCompatible(visit, driver) && _isEndCompatible(visit, driver);
    };
    _isStartCompatible = function(visit, driver) {
      var driverEnd, visitDurationOffset, visitStart;
      visitStart = TimeUtilF.convertTimeToDate(visit.start);
      driverEnd = TimeUtilF.convertTimeToDate(driver.shift_end);
      if (!((visitStart != null) && (driverEnd != null))) {
        return true;
      }
      visitDurationOffset = TimeUtilF.addMinutes(visitStart, visit.duration);
      return TimeUtilF.compareDates(visitDurationOffset, driverEnd) < 0;
    };
    _isStartRemoved = function(visit, arrival) {
      var arrivalDate, visitStart;
      if (!visit.start) {
        return false;
      }
      visitStart = TimeUtilF.convertTimeToDate(visit.start);
      arrivalDate = TimeUtilF.convertTimeToDate(arrival);
      return TimeUtilF.compareDates(arrivalDate, visitStart) < 0;
    };
    _isEndCompatible = function(visit, driver, times) {
      var driverStart, visitEnd;
      visitEnd = TimeUtilF.convertTimeToDate(visit.end);
      driverStart = TimeUtilF.convertTimeToDate(driver.shift_start);
      if (!((visitEnd != null) && (driverStart != null))) {
        return true;
      }
      return TimeUtilF.compareDates(visitEnd, driverStart) > 0;
    };
    _isEndRemoved = function(visit, finish) {
      var finishDate, visitEnd;
      if (!visit.end) {
        return false;
      }
      visitEnd = TimeUtilF.convertTimeToDate(visit.end);
      finishDate = TimeUtilF.convertTimeToDate(finish);
      return TimeUtilF.compareDates(finishDate, visitEnd) > 0;
    };
    _isTypesCompatible = function(visit, driver) {
      var driverTypes, type, _i, _len, _ref, _ref1;
      if (!(((_ref = visit.type) != null ? _ref.length : void 0) > 0)) {
        return true;
      }
      driverTypes = driver.type || [];
      _ref1 = visit.type;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        type = _ref1[_i];
        if (__indexOf.call(driverTypes, type) >= 0) {
          return true;
        }
      }
      return false;
    };
    _hasCapacity = function(visit, driver, route, visits) {
      var stop, totalLoad, _i, _len, _ref;
      if (driver.capacity == null) {
        return true;
      }
      totalLoad = visit.load || 0;
      if (route) {
        for (_i = 0, _len = route.length; _i < _len; _i++) {
          stop = route[_i];
          if (stop !== 'nowhere') {
            totalLoad += ((_ref = visits[stop]) != null ? _ref.load : void 0) || 0;
          }
        }
      }
      return totalLoad <= driver.capacity;
    };
    _isCompatible = function(data, visitId, driverId) {
      var driver, solution, visit;
      visit = data.visits[visitId];
      driver = data.fleet[driverId];
      solution = data.solution[driverId];
      return _isTimeWindowCompatible(visit, driver) && _isTypesCompatible(visit, driver) && _hasCapacity(visit, driver, solution, data.visits);
    };
    return {
      isStartCompatible: _isStartCompatible,
      isStartRemoved: _isStartRemoved,
      isEndCompatible: _isEndCompatible,
      isEndRemoved: _isEndRemoved,
      isTypesCompatible: _isTypesCompatible,
      hasCapacity: _hasCapacity,
      isCompatible: _isCompatible
    };
  };
  VisitCompatibilityF.$inject = ["TimeUtilF"];

  angular.module('app').factory('VisitCompatibilityF', VisitCompatibilityF);

}).call(this);

(function() {
  var RedirectF = function(States, AccountF, OnboardingF, DispatchStatusF, ProjectF, RouteS, DriverF, VisitF) {
    RedirectF.fetchRedirectState = function(toState, isRefresh) {
      var stateName;
      if (isRefresh == null) {
        isRefresh = false;
      }
      stateName = toState.name;
      OnboardingF.startTourForState(stateName);
      switch (stateName) {
        case States.projectRouteEdit:
          if (!DispatchStatusF.hasDispatches()) {
            return States.projectRoutePlan;
          }
          break;
        case States.projectRouteLive:
          if (!DispatchStatusF.hasDispatches()) {
            return States.projectRoutePlan;
          } else if (ProjectF.isInFuture() || !AccountF.hasLiveTracking() || RouteS.isRouteDirty()) {
            return States.projectRouteEdit;
          }
          break;
        case States.projectRouteDispatch:
          if (!RouteS.hasRoute()) {
            if (DriverF.getValidDrivers().length > 0) {
              return States.projectVisitsList;
            } else {
              return States.projectDriversList;
            }
          }
          break;
        case States.projectRoutePlan:
          if (DispatchStatusF.hasDispatches()) {
            if (ProjectF.isInFuture()) {
              return States.projectRouteEdit;
            } else {
              return States.projectRouteLive;
            }
          } else if (!RouteS.hasRoute()) {
            if (DriverF.getValidDrivers().length > 0) {
              return States.projectVisitsList;
            } else {
              return States.projectDriversList;
            }
          }
          break;
        case States.main:
          if (isRefresh) {
            return States.projectRoutePlan;
          }
          break;
        case States.projectRoute:
          return States.projectRoutePlan;
        case States.projectInput:
          if (DriverF.getValidDrivers().length === 0) {
            return States.projectDriversUpload;
          }
          if (VisitF.getVisits().length === 0) {
            return States.projectVisitsUpload;
          }
          return States.projectVisitsList;
        case States.projectVisits:
          if (VisitF.getVisits().length > 0) {
            return States.projectVisitsList;
          }
          return States.projectVisitsUpload;
        case States.projectDrivers:
          if (DriverF.getValidDrivers().length > 0) {
            return States.projectDriversList;
          }
          return States.projectDriversUpload;
      }
      return null;
    };
    return RedirectF;
  };
  RedirectF.$inject = ["States", "AccountF", "OnboardingF", "DispatchStatusF", "ProjectF", "RouteS", "DriverF", "VisitF"];

  angular.module('app').factory('RedirectF', RedirectF);

}).call(this);

(function() {
  var     __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  var ProjectReportC = function($state, $translate, RouteS, VisitF, DispatchF, Constants, VisitUtilF, TimeUtilF, ProjectF, SettingsF, States, $timeout, AnalyticsS, AccountF, OnboardingF) {
    var DONE_VISIT_STATUSES, STAT_BAR_WIDTH, STAT_TEXT_WIDTH, _addPercentParam, _dispatchesToDriverVisitDetails, _donutChartData, _driverVisitsDetails, _getDriverStatsWithVisits, _getDriverStop, _getVisitStatus, _showAllRows, _unscheduledVisitDetail, _visitsToStatusStats;
    DONE_VISIT_STATUSES = [Constants.visitStatusDone, Constants.visitStatusSkipped];
    STAT_BAR_WIDTH = 280;
    STAT_TEXT_WIDTH = 22;
    _donutChartData = null;
    _driverVisitsDetails = null;
    _showAllRows = function() {
      var row, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _driverVisitsDetails.length; _i < _len; _i++) {
        row = _driverVisitsDetails[_i];
        _results.push(row.show = true);
      }
      return _results;
    };
    _addPercentParam = function(data, total) {
      data.percent = data.count / total;
      return data;
    };
    _getVisitStatus = function(visit) {
      switch (visit.status) {
        case Constants.visitStatusSkipped:
          return VisitUtilF.VISIT_STATUSES.MISSED;
        case Constants.visitStatusDone:
          if (visit.isLate) {
            return VisitUtilF.VISIT_STATUSES.COMPLETED_LATE;
          } else {
            return VisitUtilF.VISIT_STATUSES.COMPLETED_ON_TIME;
          }
      }
    };
    _getDriverStop = function(visit) {
      var doneOrSkippedLog, log, logs, stop, visitStatus, _i, _len, _ref;
      visitStatus = _getVisitStatus(visit);
      logs = visit.log;
      for (_i = 0, _len = logs.length; _i < _len; _i++) {
        log = logs[_i];
        if (log.status === Constants.visitStatusDone || log.status === Constants.visitStatusSkipped) {
          doneOrSkippedLog = log;
        }
      }
      return stop = {
        name: (_ref = visit.location) != null ? _ref.name : void 0,
        status: $translate.instant(visitStatus.key),
        color: visitStatus.color,
        isLate: visit.isLate,
        minsLate: visit.minsLate,
        minsLateText: TimeUtilF.minutesToHoursStr(visit.minsLate),
        reason: doneOrSkippedLog != null ? doneOrSkippedLog.reason : void 0,
        notes: doneOrSkippedLog != null ? doneOrSkippedLog.notes : void 0,
        expectedTime: visit.end,
        actualTime: visit.finish_time
      };
    };
    _getDriverStatsWithVisits = function(visits) {
      var stat, statCount, status, totalCount, unitWidth, visit, visitStatus, _driverStats, _i, _len, _name, _ref;
      totalCount = 0;
      _driverStats = {};
      for (_i = 0, _len = visits.length; _i < _len; _i++) {
        visit = visits[_i];
        if (!((_ref = visit.status, __indexOf.call(DONE_VISIT_STATUSES, _ref) >= 0) && (visit.finish_time != null))) {
          continue;
        }
        totalCount += 1;
        visitStatus = _getVisitStatus(visit);
        _driverStats[_name = visitStatus.name] || (_driverStats[_name] = {
          color: visitStatus.color,
          count: 0,
          width: null
        });
        _driverStats[visitStatus.name].count += 1;
      }
      statCount = Object.keys(_driverStats).length;
      unitWidth = (STAT_BAR_WIDTH - (STAT_TEXT_WIDTH * statCount)) / totalCount;
      for (status in _driverStats) {
        stat = _driverStats[status];
        stat.width = unitWidth * stat.count;
      }
      return _driverStats;
    };
    _unscheduledVisitDetail = function(unserved) {
      var locationIdToIdxMap, stop, unscheduledDetail, val, visit, visitId, visitIdx, visits;
      unscheduledDetail = {
        name: $translate.instant("REPORT.UNSCHEDULED_STOPS"),
        show: false,
        stops: [],
        colorHex: '#ff8800'
      };
      locationIdToIdxMap = VisitF.getLocationToIndexMap();
      visits = VisitF.getVisits();
      for (visitId in unserved) {
        val = unserved[visitId];
        visitIdx = locationIdToIdxMap[visitId];
        visit = visits[visitIdx];
        stop = {
          name: visit.name,
          status: $translate.instant(VisitUtilF.VISIT_STATUSES.UNSCHEDULED.key),
          color: VisitUtilF.VISIT_STATUSES.UNSCHEDULED.color
        };
        unscheduledDetail.stops.push(stop);
      }
      return unscheduledDetail;
    };
    _dispatchesToDriverVisitDetails = function(dispatches) {
      var dispatch, driver, drivers, vehId, visit, visits, _ref, _ref1;
      drivers = [];
      for (vehId in dispatches) {
        dispatch = dispatches[vehId];
        driver = {
          name: (_ref = dispatch.vehicle) != null ? _ref.name : void 0,
          show: false,
          stops: [],
          stats: {},
          colorHex: '#53676d'
        };
        visits = (_ref1 = dispatch.solution) != null ? _ref1.visits : void 0;
        driver.stops = (function() {
          var _i, _len, _ref2, _results;
          _results = [];
          for (_i = 0, _len = visits.length; _i < _len; _i++) {
            visit = visits[_i];
            if ((_ref2 = visit.status, __indexOf.call(DONE_VISIT_STATUSES, _ref2) >= 0) && (visit.finish_time != null)) {
              _results.push(_getDriverStop(visit));
            }
          }
          return _results;
        })();
        driver.stats = _getDriverStatsWithVisits(visits);
        drivers.push(driver);
      }
      return drivers;
    };
    _visitsToStatusStats = function(visits) {
      var STATUS, data, dataList, dataObj, k, servedVisitStatus, visit, _i, _len, _ref;
      dataObj = {};
      _ref = VisitUtilF.VISIT_STATUSES;
      for (k in _ref) {
        STATUS = _ref[k];
        dataObj[STATUS.name] = {
          color: STATUS.color,
          name: $translate.instant(STATUS.key),
          count: 0
        };
      }
      for (_i = 0, _len = visits.length; _i < _len; _i++) {
        visit = visits[_i];
        servedVisitStatus = VisitUtilF.getVisitServedStatus(visit, RouteS.hasRoute(), RouteS.getRoute());
        dataObj[servedVisitStatus.name].count += 1;
      }
      dataList = (function() {
        var _results;
        _results = [];
        for (k in dataObj) {
          data = dataObj[k];
          if (data.count > 0) {
            _results.push(_addPercentParam(data, visits.length));
          }
        }
        return _results;
      })();
      return dataList;
    };
    this.hasLiveTracking = AccountF.hasLiveTracking();
    this.canLiveTrackingOptIn = AccountF.getUser().canLiveTrackingOptIn;
    this.optInLiveTracking = function() {
      return AccountF.optInLiveTracking().then((function(_this) {
        return function() {
          _this.hasLiveTracking = AccountF.hasLiveTracking();
          _this.canLiveTrackingOptIn = AccountF.getUser().canLiveTrackingOptIn;
          return OnboardingF.setOnboarding(true);
        };
      })(this));
    };
    this.getVisitCount = function() {
      return VisitF.getVisits().length;
    };
    this.getDonutChartData = function() {
      var visits = VisitF.getVisits();
      if (!_donutChartData && (visits != null)) {
        _donutChartData = _visitsToStatusStats(visits);
      }
      return _donutChartData;
    };
    this.getDriverVisitsDetails = function() {
      var unserved;
      var dispatches = DispatchF.getDispatches();
      unserved = RouteS.getUnserved();
      if (!_driverVisitsDetails) {
        _driverVisitsDetails = [];
        if (unserved != null) {
          _driverVisitsDetails.push(_unscheduledVisitDetail(unserved));
        }
        if (dispatches != null) {
          _driverVisitsDetails = _driverVisitsDetails.concat(_dispatchesToDriverVisitDetails(dispatches));
        }
      }
      return _driverVisitsDetails;
    };
    this.getProjectName = function() {
      var _ref;
      return (_ref = ProjectF.project) != null ? _ref.name : void 0;
    };
    this.getProjectDate = function() {
      var _ref;
      return (_ref = ProjectF.project) != null ? _ref.date : void 0;
    };
    this.goToNewProjectModal = function() {
      AnalyticsS.track('055 Start new project');
      return $state.go(States.modalProjectsNew);
    };
    this.getRoute = function() {
      var route = RouteS.getRoute();
      return route;
    };
    this.settings = SettingsF.settings;
    this.printReport = function() {
      AnalyticsS.track('065 Print report');
      _showAllRows();
      return $timeout(function() {
        return window.print();
      }, 1);
    };
    this.trackGoingToProjectList = function() {
      return AnalyticsS.track('066 Open project list');
    };
    this.trackClosing = function() {
      return AnalyticsS.track('064 Close report');
    };
    AnalyticsS.track('056 Open report');
  };
  ProjectReportC.$inject = ["$state", "$translate", "RouteS", "VisitF", "DispatchF", "Constants", "VisitUtilF", "TimeUtilF", "ProjectF", "SettingsF", "States", "$timeout", "AnalyticsS", "AccountF", "OnboardingF"];

  angular.module('app').controller('ProjectReportC', ProjectReportC);

}).call(this);

(function() {
  var StopsAssignF = function($http, AccountF, Constants, ProjectF, SessionF) {
    StopsAssignF = {};
    StopsAssignF.assignStops = function(driverId, stopIds) {
      var authHeader, projectId, _ref;
      projectId = ProjectF.project.id;
      authHeader = AccountF.getAuthHeader();
      if ((_ref = authHeader.headers) != null) {
        _ref['Session-Id'] = SessionF.getSessionId();
      }
      return $http.post("" + Constants.productApiPath + "/v0.1/project/" + projectId + "/fleet/" + driverId + "/route/assign", stopIds, authHeader).then(function(res) {
        return res.data;
      });
    };
    StopsAssignF.unscheduleStops = function(stopIds) {
      var authHeader, projectId, _ref;
      projectId = ProjectF.project.id;
      authHeader = AccountF.getAuthHeader();
      if ((_ref = authHeader.headers) != null) {
        _ref['Session-Id'] = SessionF.getSessionId();
      }
      return $http.post("" + Constants.productApiPath + "/v0.1/project/" + projectId + "/stops/unschedule", stopIds, authHeader).then(function(res) {
        return res.data;
      });
    };
    StopsAssignF.deleteStops = function(stopIds) {
      var authHeader, projectId, _ref;
      projectId = ProjectF.project.id;
      authHeader = AccountF.getAuthHeader();
      if ((_ref = authHeader.headers) != null) {
        _ref['Session-Id'] = SessionF.getSessionId();
      }
      return $http["delete"]("" + Constants.productApiPath + "/v0.1/project/" + projectId + "/stops?ids=" + (stopIds.join(',')), authHeader).then(function(res) {
        return res.data;
      });
    };
    return StopsAssignF;
  };
  StopsAssignF.$inject = ["$http", "AccountF", "Constants", "ProjectF", "SessionF"];

  angular.module('app').factory('StopsAssignF', StopsAssignF);

}).call(this);

(function() {
  var SessionF = function(UUID) {
    var _session_id;
    _session_id = null;
    SessionF.getSessionId = function() {
      if (!_session_id) {
        _session_id = UUID.generate();
      }
      return _session_id;
    };
    return SessionF;
  };
  SessionF.$inject = ["UUID"];

  angular.module('app').factory('SessionF', SessionF);

}).call(this);

(function() {
  var SidepanelC = function($rootScope, $http, $scope, $q, $state, $translate, $filter, ProjectF, TypeF, Constants, Events, RouteS, VisitF, DriverF, GMarkerF, MarkersF, NotificationF, States, MessagingF, ConfirmF, EventListenersF, AddressCheckerS, LoggerF, AnalyticsS) {
    var FLAG_ICON, NEW, PROJECT_VERSION_MISMATCH, RESULTS_PER_PAGE, TRUCK_ICON, _addMarkerHoverListener, _closeInProgress, _collapseMap, _driverC, _extendMap, _formRef, _getPhotoStatus, _hasEditChanges, _init, _initEventListeners, _initPanel, _originalEntry, _setPanel, _updateQueue, _visitC;
    _init = false;
    _visitC = null;
    _driverC = null;
    _formRef = null;
    _originalEntry = null;
    _closeInProgress = false;
    _updateQueue = null;
    NEW = 'new';
    this.inUpdate = false;
    this.blocking = false;
    TRUCK_ICON = 'img/driver-new.svg';
    FLAG_ICON = 'img/flag.svg';
    PROJECT_VERSION_MISMATCH = 409;
    _hasEditChanges = (function(_this) {
      return function() {
        var entry = (_visitC != null ? _visitC.entry : void 0) || (_driverC != null ? _driverC.entry : void 0);
        return (_originalEntry != null) && !angular.equals(_originalEntry, entry);
      };
    })(this);
    _collapseMap = function() {
      return $rootScope.$broadcast('SIDE_PANEL_OPEN_SUCCESS');
    };
    _extendMap = function() {
      return $rootScope.$broadcast('SIDE_PANEL_CLOSED_SUCCESS');
    };
    _setPanel = (function(_this) {
      return function(_arg) {
        var scope, _ref;
        var marker = _arg.marker, scope = _arg.scope;
        if ((marker != null) && (scope != null)) {
          if (!_this.isOpen()) {
            _collapseMap();
          }
          _this.marker = marker;
          _this.parameter = marker.parameter;
          _this.scope = scope;
          if ((_ref = _this.parameter) != null ? _ref.parentId : void 0) {
            return _this.type = "driver";
          } else {
            _this.type = "visit";
            return _getPhotoStatus();
          }
        }
      };
    })(this);
    _getPhotoStatus = (function(_this) {
      return function() {
        var _ref, _ref1;
        if ((_ref = _this.parameter) != null ? _ref.photoUrl : void 0) {
          return $http.get((_ref1 = _this.parameter) != null ? _ref1.photoUrl : void 0).then(function(res) {
            var status = res.status;
            if (status === 200) {
              return _this.validPhoto = true;
            } else {
              return _this.validPhoto = false;
            }
          });
        }
      };
    })(this);
    _addMarkerHoverListener = (function(_this) {
      return function(id) {
        GMarkerF.addEventListener(id, 'mouseover', 'sidepanelC', function() {
          return _this.hoveredVisitId = id;
        });
        return GMarkerF.addEventListener(id, 'mouseout', 'sidepanelC', function() {
          return _this.hoveredVisitId = null;
        });
      };
    })(this);
    _initPanel = function() {
      var _ref;
      if ((_ref = GMarkerF.infoWindow) != null) {
        _ref.close();
      }
      return _setPanel(GMarkerF.getMarkerAndScope());
    };
    _initEventListeners = (function(_this) {
      return function() {
        if (_init) {
          return;
        }
        $rootScope.$on('$stateChangeStart', function(e, toState) {
          if (_hasEditChanges() && !toState.name.includes(States.projectRoute)) {
            e.preventDefault();
            return _this.close();
          }
        });
        EventListenersF.addEventListener(Events.ROUTE_CHART_HEIGHT_CHANGED, function(height) {
          return _this.offsetBottom = "" + height + "px";
        });
        EventListenersF.addEventListener(Events.SIDE_PANEL_CHANGED, function(_arg) {
          var forceRefresh, id, newInfo, resolveFn, _ref, _ref1;
          id = _arg.id, resolveFn = _arg.resolveFn, forceRefresh = _arg.forceRefresh;
          if (_closeInProgress && !forceRefresh) {
            return _updateQueue = resolveFn;
          } else {
            if (forceRefresh) {
              _originalEntry = null;
            }
            newInfo = resolveFn(true);
            if (!_this.inUpdate || (_this.inUpdate && ((_ref = newInfo.marker) != null ? _ref.parameter.id : void 0) !== ((_ref1 = _this.parameter) != null ? _ref1.id : void 0))) {
              _this.goToInfo();
            }
            return _setPanel(newInfo);
          }
        });
        EventListenersF.addEventListener(Events.SIDE_PANEL_UNSERVED_CHANGED, function(forceClose) {
          if (forceClose) {
            return _this.closeUnscheduled();
          }
          if (_this.unscheduledView) {
            return _this.closeUnscheduled();
          } else {
            return _this.goToUnscheduled();
          }
        });
        EventListenersF.addEventListener(Events.SIDE_PANEL_OPENED, function() {
          var _ref;
          if ((_ref = _this.type) === 'driver' || _ref === 'visit') {
            _this.close();
          }
          return _this.type = NEW;
        });
        EventListenersF.addEventListener(Events.REASSIGN_PANEL_OPENED, function(lassoMarkers) {
          _this.split = true;
          return _this.lassoMarkers = lassoMarkers;
        });
        EventListenersF.addEventListener(Events.REASSIGN_PANEL_CLOSED, function(expandGantt) {
          return _this.closeReassign(expandGantt);
        });
        EventListenersF.addEventListener(Events.SIDE_PANEL_UPDATING, function(updating) {
          return _this.inUpdate = updating;
        });
        EventListenersF.addEventListener(Events.SIDE_PANEL_CLOSED, function(resolveFn) {
          if (!_this.isOpen()) {
            return;
          }
          return _this.close().then(function() {
            return resolveFn(true);
          })["catch"](function() {
            return resolveFn(false);
          })["finally"](function() {
            return _closeInProgress = false;
          });
        });
        EventListenersF.addEventListener(Events.MAP_MARKER_DESTROYED, function(update) {
          var _ref, _ref1;
          if (((_ref = update.parameter) != null ? _ref.id : void 0) === ((_ref1 = _this.parameter) != null ? _ref1.id : void 0)) {
            return _this.forceClose();
          }
        });
        return _init = true;
      };
    })(this);
    this.view = "info";
    this.unscheduledView = null;
    this.offsetBottom = 0;
    this.marker = null;
    this.scope = null;
    this.type = null;
    this.split = null;
    this.lassoMarkers = null;
    this.textQuery = "";
    this.searchResults = [];
    this.visibleSearchResults = [];
    this.hoveredVisitId = null;
    this.validPhoto = false;
    RESULTS_PER_PAGE = 20;
    this.openVisitInfoWindow = function(visitId) {
      return GMarkerF.openInfoWindow(visitId);
    };
    this.onVisitHoverOut = function(visitId) {
      GMarkerF.emitEvent(visitId, 'unselect');
      GMarkerF.setSelected(visitId, false, false);
      return this.hoveredVisitId = null;
    };
    this.onVisitHover = function(visitId) {
      GMarkerF.emitEvent(visitId, 'mouseover');
      GMarkerF.setSelected(visitId, true, false);
      return this.hoveredVisitId = visitId;
    };
    this.clearSearch = function() {
      this.textQuery = "";
      return this.onTextQueryChange();
    };
    this.onTextQueryChange = (function(_this) {
      return function() {
        var query, result, _i, _len, _ref;
        GMarkerF.clearAllStyles();
        RouteS.syncMarkersVisibility();
        if ((_this.textQuery != null) && _this.textQuery !== "") {
          if (!_this.isOpen()) {
            _collapseMap();
          }
          query = _this.textQuery.toLowerCase();
          _this.searchResults = ProjectF.searchVisits(query);
          _this.visibleSearchResults = _this.searchResults.slice(0, RESULTS_PER_PAGE);
          _ref = _this.searchResults;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            result = _ref[_i];
            GMarkerF.setVisible(result.visitId, true);
            GMarkerF.setHighlighted(result.visitId, true);
            _addMarkerHoverListener(result.visitId);
          }
        } else {
          _this.searchResults = [];
          _this.visibleSearchResults = [];
        }
        return _this.close();
      };
    })(this);
    this.loadMoreResults = function() {
      var endIdx, idx, startIdx, _i, _results;
      startIdx = this.visibleSearchResults.length;
      endIdx = Math.min(startIdx + RESULTS_PER_PAGE, this.searchResults.length - 1);
      if (endIdx > startIdx) {
        _results = [];
        for (idx = _i = startIdx; startIdx <= endIdx ? _i <= endIdx : _i >= endIdx; idx = startIdx <= endIdx ? ++_i : --_i) {
          _results.push(this.visibleSearchResults.push(this.searchResults[idx]));
        }
        return _results;
      }
    };
    this.hasResults = function() {
      return this.searchResults.length > 0;
    };
    this.setVisitCtrl = function(visitC) {
      _driverC = null;
      return _visitC = visitC;
    };
    this.setDriverCtrl = function(driverC) {
      _visitC = null;
      return _driverC = driverC;
    };
    this.createVisitEntry = function(visitId, form) {
      var visit = VisitF.getVisit(visitId);
      _formRef = form;
      return _originalEntry = _visitC.initializeEntry(_.cloneDeep(visit));
    };
    this.createDriverEntry = function(driverId, form) {
      var driver = DriverF.getDriver(driverId);
      _formRef = form;
      return _originalEntry = _driverC.initializeEntry(_.cloneDeep(driver));
    };
    this.canEdit = function() {
      return !ProjectF.isPastProject();
    };
    this.optimizeInProgress = function() {
      var inProgress = RouteS.isInProgress();
      if (inProgress && this.view !== "info") {
        this.goToInfo();
      }
      return inProgress;
    };
    this.isLocked = function() {
      var locked = this.scope.isLocked(this.type, this.parameter.parentId || this.parameter.id);
      if (locked && this.view !== "info") {
        this.goToInfo();
      }
      return locked;
    };
    this.unschedule = function() {
      if (this.optimizeInProgress() || this.isLocked()) {
        return;
      }
      return this.scope.moveVisitToUnserved(this.parameter);
    };
    this.goToSearch = function() {
      return this.view = "search";
    };
    this.goToUnscheduled = function() {
      return this.unscheduledView = "unscheduled";
    };
    this.closeUnscheduled = function() {
      return this.unscheduledView = null;
    };
    this.forceSchedule = function() {
      var props;
      var promise = $q.reject();
      props = RouteS.getNumUnserved();
      promise = ConfirmF.confirmWarning(null, "UNSERVED_MESSAGES.FORCE_UNSERVED_WARNING", 'Cancel', 'Confirm Force Schedule').then(function() {
        return EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS);
      }).then(function() {
        return RouteS.scheduleUnserveds();
      });
      return promise.then((function(_this) {
        return function() {
          _this.unscheduledView = null;
          AnalyticsS.track('104 Force schedule all', {
            num_unserved: props
          });
          return MessagingF.replaceInfo("UNSERVED_MESSAGES.FORCE_UNSERVED_UPDATE", null, null, "SIDEPANEL.UNSAVED_CHANGES_OK");
        };
      })(this))["finally"](function() {
        return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
      });
    };
    this.goToVideo = function() {
      return $state.go(States.modalVideo);
    };
    this.goToEdit = function() {
      if (this.optimizeInProgress() || this.isLocked()) {
        return;
      }
      return this.view = "edit";
    };
    this.goToInfo = function() {
      _originalEntry = null;
      return this.view = "info";
    };
    this.saveEdit = function(event) {
      var entry, name, promise, valid, _inProgressId, _ref;
      promise = $q.reject();
      valid = _formRef.$valid;
      entry = (_ref = _visitC || _driverC) != null ? _ref.entry : void 0;
      name = this.parameter.name;
      if (this.type === 'visit' && _visitC && !_formRef.address.$valid) {
        AddressCheckerS.check(_formRef.address.$viewValue).then(function(newLoc) {
          var _ref1;
          return (_ref1 = _visitC.entry) != null ? _ref1.location = newLoc : void 0;
        });
      }
      if (this.type === 'driver' && _driverC && !_formRef.startLoc.$valid) {
        AddressCheckerS.check(_formRef.startLoc.$viewValue).then(function(newLoc) {
          var _ref1, _ref2, _ref3;
          if (((_ref1 = _driverC.entry) != null ? _ref1.startLocation : void 0) == null) {
            if ((_ref2 = _driverC.entry) != null) {
              _ref2.startLocation = {};
            }
          }
          return (_ref3 = _driverC.entry) != null ? _ref3.startLocation.info = newLoc : void 0;
        });
      }
      if (this.type === 'driver' && _driverC && !_formRef.finalLoc.$valid) {
        AddressCheckerS.check(_formRef.finalLoc.$viewValue).then(function(newLoc) {
          var _ref1, _ref2, _ref3, _ref4;
          if (((_ref1 = _driverC.entry) != null ? _ref1.endLocation : void 0) == null) {
            if ((_ref2 = _driverC.entry) != null) {
              _ref2.endLocation = {};
            }
          }
          return (_ref3 = _driverC.entry) != null ? (_ref4 = _ref3.endLocation) != null ? _ref4.info = newLoc : void 0 : void 0;
        });
      }
      if (this.type === 'driver') {
        if (!(valid && entry)) {
          return promise;
        }
      } else {
        if (!entry) {
          return promise;
        }
      }
      if (this.scope.isVisitDone(this.parameter.visitStatus)) {
        MessagingF.replaceWarningPopup("SIDEPANEL.EDIT_FAIL_COMPLETED");
        this.goToInfo();
        return $q.when();
      }
      if (this.type === "visit" && _visitC) {
        if (event === 'save-and-reoptimize') {
          promise = ConfirmF.confirm("MESSAGES.REOPTIMIZATION_CONFIRMATION").then(function() {
            return promise = _visitC.updateVisit(_formRef, entry, null, false);
          });
        } else {
          promise = _visitC.updateVisit(_formRef, entry, null, false);
        }
      } else if (this.type === "driver" && _driverC) {
        promise = _driverC.updateDriver(valid, entry, null, false);
      }
      this.inUpdate = true;
      _inProgressId = this.parameter.id;
      return promise.then((function(_this) {
        return function() {
          var _ref1;
          if (event === 'save-and-reoptimize') {
            return RouteS.reoptimize();
          } else {
            $state.go(States.projectRouteEdit);
            MessagingF.replaceSuccessPopup("MESSAGES.GENERIC_UPDATE_SUCCESS", {
              name: name
            });
            if (_inProgressId === ((_ref1 = _this.parameter) != null ? _ref1.id : void 0)) {
              _this.goToInfo();
            }
            return _originalEntry = null;
          }
        };
      })(this))["finally"]((function(_this) {
        return function() {
          return _this.inUpdate = false;
        };
      })(this));
    };
    this.getDriverIcon = function() {
      var _ref;
      if (((_ref = this.parameter.info) != null ? _ref.driverMarkerType : void 0) === 'end') {
        return FLAG_ICON;
      }
      return TRUCK_ICON;
    };
    this.getStatusIcon = function() {
      if (this.scope.isVisitDone(this.parameter.visitStatus)) {
        return this.scope.getStatusIcon(this.parameter.visitStatus, this.parameter.isLate);
      } else {
        return "";
      }
    };
    this.getCompletionText = function() {
      var langKey, time;
      switch (this.parameter.visitStatus) {
        case Constants.visitStatusDone:
          langKey = "SIDEPANEL.VISIT_COMPLETED";
          break;
        case Constants.visitStatusSkipped:
          langKey = "SIDEPANEL.VISIT_SKIPPED";
          break;
        default:
          return "";
      }
      time = $filter('date')(this.parameter.visitStatusInfo.date, 'HH:mm');
      return $translate.instant(langKey, {
        time: time
      });
    };
    this.getDriverName = function() {
      if (this.marker.driverId != null) {
        return RouteS.getDriverName(this.marker.driverId);
      }
      return null;
    };
    this.isOpen = function() {
      return (this.marker != null) || this.hasResults() || this.type === NEW || this.view === "unscheduled";
    };
    this.forceClose = function() {
      this.marker = null;
      this.parameter = null;
      this.scope = null;
      if (this.hasResults()) {
        return this.view = "search";
      } else {
        return _extendMap();
      }
    };
    this.close = function() {
      var id, _ref;
      if (_hasEditChanges()) {
        _closeInProgress = true;
        MessagingF.replaceWarning("SIDEPANEL.UNSAVED_CHANGES", null, null, "SIDEPANEL.UNSAVED_CHANGES_OK");
        return $q.reject();
      } else {
        _originalEntry = null;
        id = (_ref = this.parameter) != null ? _ref.id : void 0;
        if (id) {
          return GMarkerF.closeSidepanel(GMarkerF.get(id), true).then((function(_this) {
            return function() {
              return _this.forceClose();
            };
          })(this));
        } else {
          this.forceClose();
          return $q.when();
        }
      }
    };
    this.closeReassign = function(expandGantt) {
      this.split = null;
      this.inUpdate = false;
      EventListenersF.notify(Events.CLEAR_LASSO_SELECTION, false);
      if (expandGantt) {
        EventListenersF.notify(Events.EXPAND_GANTT_CHART);
        return EventListenersF.notify(Events.LASSO_UPDATED, false);
      }
    };
    this.cancelAddNew = (function(_this) {
      return function(checkDirty) {
        if (checkDirty == null) {
          checkDirty = false;
        }
        if (checkDirty) {
          if (_hasEditChanges()) {
            MessagingF.replaceWarning("SIDEPANEL.UNSAVED_CHANGES", null, null, "SIDEPANEL.UNSAVED_CHANGES_OK");
            return $q.reject();
          }
        }
        _originalEntry = null;
        if (_visitC != null) {
          _visitC.entry = null;
        }
        return _this.type = null;
      };
    })(this);
    this.addNewStop = (function(_this) {
      return function(isValid, entry, addressCtrl) {
        var projectId, promise, _ref;
        _originalEntry = entry;
        promise = $q.reject();
        projectId = (_ref = ProjectF.project) != null ? _ref.id : void 0;
        if (!addressCtrl.$valid) {
          AddressCheckerS.check(addressCtrl.$viewValue).then(function(newLoc) {
            var _ref1;
            return (_ref1 = _visitC.entry) != null ? _ref1.location = newLoc : void 0;
          });
        }
        if (!(isValid && projectId)) {
          return promise;
        }
        _this.inUpdate = true;
        _this.blocking = true;
        entry.phone_number = entry.phone;
        entry.priority = entry.isPriority;
        return VisitF.postStops(projectId, [entry]).then(function(res) {
          ProjectF.incrementVersion();
          return VisitF.addVisit(res.data[0]);
        }).then(function(visit) {
          if (RouteS.hasRoute()) {
            RouteS.addVisitAsUnserved(visit);
          }
          VisitF.updateValidVisits();
          TypeF.addTypes(visit.types);
          LoggerF.info(LoggerF.ACTIONS.ADDED_STOPS_API, entry);
          return setTimeout(function() {
            GMarkerF.emitEvent(visit.id, 'mouseover');
            _this.openVisitInfoWindow(visit.id);
            _this.inUpdate = false;
            _this.blocking = false;
            return MessagingF.replaceSuccessPopup("MESSAGES.SINGLE_STOP_ADDED", {
              name: visit.name
            });
          }, 10);
        })["catch"](function(err) {
          var _ref1, _ref2, _ref3;
          if (err.status === PROJECT_VERSION_MISMATCH) {
            EventListenersF.notify(Events.PROJECT_VERSION_MISMATCH);
          } else {
            MessagingF.replaceError(((_ref1 = err.data) != null ? (_ref2 = _ref1.errors) != null ? (_ref3 = _ref2[0]) != null ? _ref3.message : void 0 : void 0 : void 0) || "DEMO.GENERIC_ERROR");
          }
          LoggerF.error(LoggerF.ACTIONS.ADDED_STOPS_API, entry, err);
          _this.inUpdate = false;
          return _this.blocking = false;
        });
      };
    })(this);
    _initPanel();
    _initEventListeners();
  };
  SidepanelC.$inject = ["$rootScope", "$http", "$scope", "$q", "$state", "$translate", "$filter", "ProjectF", "TypeF", "Constants", "Events", "RouteS", "VisitF", "DriverF", "GMarkerF", "MarkersF", "NotificationF", "States", "MessagingF", "ConfirmF", "EventListenersF", "AddressCheckerS", "LoggerF", "AnalyticsS"];

  angular.module('app').controller('SidepanelC', SidepanelC);

}).call(this);

(function() {
  var SignatureF = function($http, $q, Constants, AccountF) {
    SignatureF.getSignature = function(signatureId, routeId) {
      if (!signatureId) {
        return $q.reject(new Error("Signature ID is not provided"));
      }
      return $http.get("" + Constants.apiPath + "/product/routes/" + routeId + "/signature/" + signatureId, AccountF.getAuthHeader()).then(function(res) {
        return res.data;
      })["catch"](function(err) {
        return $q.reject(err.data);
      });
    };
    return SignatureF;
  };
  SignatureF.$inject = ["$http", "$q", "Constants", "AccountF"];

  angular.module('app').factory('SignatureF', SignatureF);

}).call(this);

(function() {
  var SocketEvent, SocketF;

  SocketF = [
    '$q', 'Constants', 'socketFactory', 'EventListenersF', 'Events', function($q, Constants, socketFactory, EventListenersF, Events) {
      var _addListeners, _client, _isConnected;
      var EVENTS = [new SocketEvent('visit status update', Events.VISIT_STATUS_UPDATED), new SocketEvent('route update', Events.ROUTE_UPDATED), new SocketEvent('route deleted', Events.ROUTE_DELETED), new SocketEvent('route seen', Events.ROUTE_SEEN), new SocketEvent('session count update', Events.SESSION_COUNT_UPDATE), new SocketEvent('project updated', Events.SESSION_PROJECT_UPDATED), new SocketEvent('project deleted', Events.SESSION_PROJECT_DELETED), new SocketEvent('customer geocoding started', Events.CUSTOMER_GEOCODING_STARTED), new SocketEvent('customer geocoding updated', Events.CUSTOMER_GEOCODING_UPDATED), new SocketEvent('stops_add_start', Events.STOPS_ADD_START), new SocketEvent('stops_add_error', Events.STOPS_ADD_ERROR), new SocketEvent('stops_add_success', Events.STOPS_ADD_SUCCESS), new SocketEvent('stops_geocode_error', Events.STOPS_GEOCODE_ERROR), new SocketEvent('stops_geocode_success', Events.STOPS_GEOCODE_SUCCESS), new SocketEvent('sms_failed', Events.SMS_FAILED)];
      _client = null;
      _addListeners = function(client) {
        var event, _fn, _i, _len;
        if (!client) {
          return;
        }
        _fn = function(event) {
          return client.on(event.name, function(data, callback) {
            EventListenersF.notify(event.listenerKey, data);
            return callback(true);
          });
        };
        for (_i = 0, _len = EVENTS.length; _i < _len; _i++) {
          event = EVENTS[_i];
          _fn(event);
        }
        client.on("disconnect", function() {
          return EventListenersF.notify(Events.SOCKET_DISCONNECTED);
        });
        client.on('connect_error', function() {
          return EventListenersF.notify(Events.SOCKET_DISCONNECTED);
        });
        return client.on("connect", function() {
          return EventListenersF.notify(Events.SOCKET_CONNECTED);
        });
      };
      _isConnected = function() {
        return !!_client && !_client.disconnected;
      };
      SocketF = {};
      SocketF.connect = function(authToken) {
        var ioSocket, options;
        if (_client) {
          SocketF.disconnect();
        }
        options = {
          query: {
            authToken: authToken
          }
        };
        ioSocket = io.connect("" + Constants.socketPath + "/dispatchers", options);
        _client = socketFactory({
          ioSocket: ioSocket
        });
        _addListeners(_client);
        if (!_isConnected()) {
          _client.connect();
        }
        return _client;
      };
      SocketF.notifyProjectConnect = function(projectId) {
        var deferred;
        if (!_isConnected()) {
          return $q.when(0);
        }
        deferred = $q.defer();
        _client.emit('project connect', {
          project: projectId
        }, function(err, data) {
          return deferred.resolve(data.count);
        });
        return deferred.promise;
      };
      SocketF.notifyProjectDisconnect = function(projectId) {
        var deferred;
        if (!_isConnected()) {
          return $q.when(false);
        }
        deferred = $q.defer();
        _client.emit('project disconnect', {
          project: projectId
        }, function() {
          return deferred.resolve(true);
        });
        return deferred.promise;
      };
      SocketF.disconnect = function() {
        if (_isConnected()) {
          _client.disconnect();
          _client = null;
        }
      };
      return SocketF;
    }
  ];

  SocketEvent = (function() {
    function SocketEvent(name, listenerKey) {
      this.name = name;
      this.listenerKey = listenerKey;
    }

    return SocketEvent;

  })();

  angular.module('app').factory('SocketF', SocketF);

}).call(this);

(function() {
  var SolutionC = function(Constants, ProjectF, DispatchF, AnalyticsS, AccountF, RouteDownloadF, MessagingF, CsvExporter) {
    var _downloadCsv, _getProject;
    _getProject = function() {
      return ProjectF.project;
    };
    this.downloadSolutionCsv = function() {
      var csv, solution;
      AnalyticsS.track('034 Download solution');
      if (typeof analytics !== "undefined" && analytics !== null) {
        analytics.ready(function() {
          return typeof analytics !== "undefined" && analytics !== null ? analytics.track('Downloaded Solution', {
            project_id: _getProject.id
          }) : void 0;
        });
      }
      solution = RouteDownloadF.getSolutionCsv();
      csv = [new CsvExporter.CSV(this.getSolutionFilename(), solution)];
      return CsvExporter.save(csv);
    };
    this.downloadSummaryCsv = function() {
      var csv, summary;
      AnalyticsS.track('035 Download summary');
      summary = RouteDownloadF.getSummaryCsv();
      csv = [new CsvExporter.CSV(this.getSummaryFilename(), summary)];
      return CsvExporter.save(csv);
    };
    _downloadCsv = function() {
      var project = _getProject();
      return RouteDownloadF.downloadCsv(project.name, project.date);
    };
    this.downloadCsvIcon = function() {
      AnalyticsS.track('032 Download route data');
      return _downloadCsv();
    };
    this.downloadCsvMenuItem = function() {
      AnalyticsS.track('036 Download all');
      return _downloadCsv();
    };
    this.getSolutionFilename = function() {
      var project = _getProject();
      return RouteDownloadF.getSolutionFilename(project.name, project.date);
    };
    this.getSummaryFilename = function() {
      var project = _getProject();
      return RouteDownloadF.getSummaryFilename(project.name, project.date);
    };
    this.sendWebhook = function() {
      MessagingF.replaceLoading("MESSAGES.DISPATCHING_WEBHOOK");
      return DispatchF.sendWebhook(ProjectF.project.id).then(function() {
        return MessagingF.replaceSuccess("MESSAGES.DISPATCHING_WEBHOOK_SUCCESS");
      })["catch"](function(err) {
        var message = err.message;
        message = message.replace(Constants.email, "<a href='mailto:" + Constants.email + "'>" + Constants.email + "</a>");
        return MessagingF.replaceError(message);
      });
    };
    this.webhookEnabled = function() {
      return !!AccountF.getUser().isWebhookEnabled || (AccountF.getUser().webhook != null);
    };
    this.isFirefox = CsvExporter.isFirefox;
    this.isSafari = CsvExporter.isSafari;
  };
  SolutionC.$inject = ["Constants", "ProjectF", "DispatchF", "AnalyticsS", "AccountF", "RouteDownloadF", "MessagingF", "CsvExporter"];

  angular.module('app').controller('SolutionC', SolutionC);

}).call(this);

(function() {
  var TypeF = function($q, VisitF, DriverF) {
    TypeF = {};
    TypeF.types = {};
    TypeF.addType = function(name) {
      var isNew = !TypeF.types[name];
      TypeF.types[name] = true;
      return isNew;
    };
    TypeF.addTypes = function(names) {
      var name, _i, _len, _results;
      if (!names) {
        return;
      }
      _results = [];
      for (_i = 0, _len = names.length; _i < _len; _i++) {
        name = names[_i];
        _results.push(TypeF.types[name] = true);
      }
      return _results;
    };
    TypeF.reload = function() {
      var driver, key, types, visit, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2;
      _ref = TypeF.types;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        key = _ref[_i];
        delete TypeF.types[key];
      }
      _ref1 = VisitF.getVisits();
      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
        visit = _ref1[_j];
        types = visit.types;
        TypeF.addTypes(types);
      }
      _ref2 = DriverF.getDrivers();
      for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
        driver = _ref2[_k];
        types = driver.types;
        TypeF.addTypes(types);
      }
      return TypeF.types;
    };
    return TypeF;
  };
  TypeF.$inject = ["$q", "VisitF", "DriverF"];

  angular.module('app').factory('TypeF', TypeF);

}).call(this);

(function() {
  var CsvHeader = function(AccountF, LocalStorageObjectF) {
    var BREAK_DURATION_COL, Column, Header, _parseHeaderMap, _removeBreakDurationFromCache, _saveHeaderMap;
    BREAK_DURATION_COL = 'break duration';
    Column = (function() {
      function Column(name, languageKey, tooltip, isOptional, isUserDefined) {
        this.name = name;
        this.languageKey = languageKey;
        this.tooltip = tooltip;
        this.isOptional = isOptional;
        this.isUserDefined = isUserDefined != null ? isUserDefined : false;
      }

      return Column;

    })();
    Header = (function() {
      function Header(name, mappedCol) {
        this.name = name;
        this.mappedCol = mappedCol;
      }

      return Header;

    })();
    CsvHeader = (function() {
      function CsvHeader(cacheName, defaultColumns, settingName) {
        this.defaultColumns = defaultColumns;
        this.settingName = settingName;
        this.columns = [];
        this.storedHeaders = [];
        this.headerMapCache = LocalStorageObjectF(cacheName);
        this.COLUMN_NAMES = _.map(this.defaultColumns, function(column) {
          return column.name.toLowerCase();
        });
        this.DEFAULT_COLUMN_MAPPING = _.map(this.defaultColumns, function(col) {
          var clone = _.clone(col);
          clone.mappedCol = clone.name.toLowerCase();
          return clone;
        });
      }

      return CsvHeader;

    })();
    _parseHeaderMap = function(map) {
      var current, headerMap, lowerCaseKey, _i, _len;
      headerMap = {};
      for (_i = 0, _len = map.length; _i < _len; _i++) {
        current = map[_i];
        lowerCaseKey = current.name.trim().toLowerCase();
        headerMap[lowerCaseKey] = current;
      }
      return headerMap;
    };
    _saveHeaderMap = function(map) {
      var settings;
      this.storedHeaders = map;
      this.headerMap = _parseHeaderMap(map);
      this.headerMapCache.set(map);
      if (this.settingName) {
        settings = {};
        settings[this.settingName] = map;
        return AccountF.updateSettings(settings).then(function() {
          return this.storedHeaders;
        });
      }
    };
    _removeBreakDurationFromCache = function(storedHeaders) {
      var breakDurationIndex = _.findIndex(storedHeaders, function(header) {
        return header.mappedCol === BREAK_DURATION_COL;
      });
      if (breakDurationIndex === -1) {
        return;
      }
      storedHeaders.splice(breakDurationIndex, 1);
      return this.setHeaderMap(storedHeaders);
    };
    CsvHeader.Column = Column;
    CsvHeader.prototype.initialize = function(entries) {
      var key, storedHeaders, value;
      storedHeaders = AccountF.getUser().settings[this.settingName] || this.headerMapCache.load();
      if (!(storedHeaders instanceof Array)) {
        storedHeaders = (function() {
          var _results;
          _results = [];
          for (key in storedHeaders) {
            value = storedHeaders[key];
            _results.push(new Header(key, value));
          }
          return _results;
        })();
      }
      _removeBreakDurationFromCache.call(this, storedHeaders);
      this.storedHeaders = storedHeaders;
      this.headerMap = _parseHeaderMap(storedHeaders);
      return this.initializeColumns(entries);
    };
    CsvHeader.prototype.initializeColumns = function(entries) {
      var current, entry, key, lowerCaseKey, lowerCaseList, value, _i, _j, _len, _len1, _ref, _ref1;
      var columns = [];
      lowerCaseList = {};
      _ref = this.storedHeaders;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        current = _ref[_i];
        key = current.name.trim().toLowerCase();
        columns.push(current.name);
        lowerCaseList[key] = true;
      }
      if (entries) {
        for (_j = 0, _len1 = entries.length; _j < _len1; _j++) {
          entry = entries[_j];
          _ref1 = entry.customNotes;
          for (key in _ref1) {
            value = _ref1[key];
            lowerCaseKey = key.trim().toLowerCase();
            if (!lowerCaseList[lowerCaseKey]) {
              columns.push(key);
              lowerCaseList[lowerCaseKey] = true;
            }
          }
        }
      }
      return this.updateColumns(columns);
    };
    CsvHeader.prototype.updateColumns = function(columnList) {
      var current, name, _i, _j, _len, _len1, _ref;
      var columns = {};
      this.columns = [];
      _ref = this.defaultColumns;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        current = _ref[_i];
        this.columns.push(_.cloneDeep(current));
        columns[current.name.toLowerCase()] = current.name;
      }
      for (_j = 0, _len1 = columnList.length; _j < _len1; _j++) {
        current = columnList[_j];
        name = current.trim();
        if (name && !columns[name.toLowerCase()]) {
          this.addColumn(name);
          columns[name.toLowerCase()] = name;
        }
      }
      return this.columns;
    };
    CsvHeader.prototype.addColumn = function(name) {
      return this.columns.push(new Column(name, null, null, true, true));
    };
    CsvHeader.prototype.setHeaderMap = function(mapping) {
      var col, parsed;
      parsed = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = mapping.length; _i < _len; _i++) {
          col = mapping[_i];
          _results.push(new Header(col.name.trim(), col.mappedCol || null));
        }
        return _results;
      })();
      return _saveHeaderMap.call(this, parsed);
    };
    return CsvHeader;
  };
  CsvHeader.$inject = ["AccountF", "LocalStorageObjectF"];

  angular.module('app').factory('CsvHeader', CsvHeader);

}).call(this);

(function() {
  var CsvHeaderF = function(LocalStorageObjectF, AccountF) {
    var HEADER_MAP_SETTING, Header, _headerMapCache, _parseHeaderMap, _saveHeaderMap;
    var Column = (function() {
      function Column(name, isOptional, isUserDefined) {
        this.name = name;
        this.isOptional = isOptional;
        this.isUserDefined = isUserDefined != null ? isUserDefined : false;
      }

      return Column;

    })();
    Header = (function() {
      function Header(name, mappedCol) {
        this.name = name;
        this.mappedCol = mappedCol;
      }

      return Header;

    })();
    HEADER_MAP_SETTING = 'csvUploadMap';
    _headerMapCache = LocalStorageObjectF('headerMapCache');
    _parseHeaderMap = function(map) {
      var current, headerMap, lowerCaseKey, _i, _len;
      headerMap = {};
      for (_i = 0, _len = map.length; _i < _len; _i++) {
        current = map[_i];
        lowerCaseKey = current.name.trim().toLowerCase();
        headerMap[lowerCaseKey] = current;
      }
      return headerMap;
    };
    _saveHeaderMap = function(map) {
      var settings;
      CsvHeaderF.storedHeaders = map;
      CsvHeaderF.headerMap = _parseHeaderMap(map);
      _headerMapCache.set(map);
      settings = {};
      settings[HEADER_MAP_SETTING] = map;
      return AccountF.updateSettings(settings).then(function() {
        return CsvHeaderF.storedHeaders;
      });
    };
    CsvHeaderF = {};
    CsvHeaderF.storedHeaders = [];
    CsvHeaderF.COLUMNS = [new Column('ID', false), new Column('Address', true), new Column('City', true), new Column('State', true), new Column('Zip code', true), new Column('From', true), new Column('To', true), new Column('Duration', true), new Column('Load', true), new Column('Types', true), new Column('Phone', true), new Column('Email', true), new Column('Priority', true), new Column('Notes', true), new Column('Notes 2', true), new Column('Latitude', true), new Column('Longitude', true)];
    CsvHeaderF.COLUMN_NAMES = _.map(CsvHeaderF.COLUMNS, function(column) {
      return column.name.toLowerCase();
    });
    CsvHeaderF.DEFAULT_COLUMN_MAPPING = _.map(CsvHeaderF.COLUMNS, function(col) {
      var clone = _.clone(col);
      clone.mappedCol = clone.name.toLowerCase();
      return clone;
    });
    CsvHeaderF.setHeaderMap = function(mapping) {
      var col, parsed;
      parsed = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = mapping.length; _i < _len; _i++) {
          col = mapping[_i];
          _results.push(new Header(col.name.trim(), col.mappedCol || null));
        }
        return _results;
      })();
      return _saveHeaderMap(parsed);
    };
    CsvHeaderF.updateColumns = function(columnList) {
      var current, name, _i, _j, _len, _len1, _ref;
      var columns = {};
      CsvHeaderF.columns = [];
      _ref = CsvHeaderF.COLUMNS;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        current = _ref[_i];
        CsvHeaderF.columns.push(_.cloneDeep(current));
        columns[current.name.toLowerCase()] = current.name;
      }
      for (_j = 0, _len1 = columnList.length; _j < _len1; _j++) {
        current = columnList[_j];
        name = current.trim();
        if (name && !columns[name.toLowerCase()]) {
          CsvHeaderF.addColumn(name);
          columns[name.toLowerCase()] = name;
        }
      }
      return CsvHeaderF.columns;
    };
    CsvHeaderF.addColumn = function(name) {
      return CsvHeaderF.columns.push(new Column(name, true, true));
    };
    CsvHeaderF.initializeColumns = function(visits) {
      var current, key, lowerCaseKey, lowerCaseList, value, visit, _i, _j, _len, _len1, _ref, _ref1;
      var columns = [];
      lowerCaseList = {};
      _ref = CsvHeaderF.storedHeaders;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        current = _ref[_i];
        key = current.name.trim().toLowerCase();
        columns.push(current.name);
        lowerCaseList[key] = true;
      }
      for (_j = 0, _len1 = visits.length; _j < _len1; _j++) {
        visit = visits[_j];
        _ref1 = visit.customNotes;
        for (key in _ref1) {
          value = _ref1[key];
          lowerCaseKey = key.trim().toLowerCase();
          if (!lowerCaseList[lowerCaseKey]) {
            columns.push(key);
            lowerCaseList[lowerCaseKey] = true;
          }
        }
      }
      return CsvHeaderF.updateColumns(columns);
    };
    CsvHeaderF.initialize = function(visits) {
      var key, storedHeaders, value;
      storedHeaders = AccountF.getUser().settings[HEADER_MAP_SETTING] || _headerMapCache.load();
      if (!(storedHeaders instanceof Array)) {
        storedHeaders = (function() {
          var _results;
          _results = [];
          for (key in storedHeaders) {
            value = storedHeaders[key];
            _results.push(new Header(key, value));
          }
          return _results;
        })();
      }
      CsvHeaderF.storedHeaders = storedHeaders;
      CsvHeaderF.headerMap = _parseHeaderMap(storedHeaders);
      return CsvHeaderF.initializeColumns(visits);
    };
    return CsvHeaderF;
  };
  CsvHeaderF.$inject = ["LocalStorageObjectF", "AccountF"];

  angular.module('app').factory('CsvHeaderF', CsvHeaderF);

}).call(this);

(function() {
  var DriverCsvHeaderF = function(CsvHeader) {
    var CACHE_NAME, DEFAULT_COLUMNS, SETTING_NAME;
    CACHE_NAME = 'driverHeaderMapCache';
    SETTING_NAME = 'driverCsvUploadMap';
    DEFAULT_COLUMNS = [new CsvHeader.Column('Driver Name', 'DRIVER_CSV_HEADERS.ID', 'DRIVER_CSV_HEADERS.ID_TOOLTIP', false), new CsvHeader.Column('Start Address', 'DRIVER_CSV_HEADERS.START_ADDRESS', 'DRIVER_CSV_HEADERS.START_ADDRESS_TOOLTIP', true), new CsvHeader.Column('Start City', 'DRIVER_CSV_HEADERS.START_CITY', null, true), new CsvHeader.Column('Start State', 'DRIVER_CSV_HEADERS.START_STATE', null, true), new CsvHeader.Column('Start Zip Code', 'DRIVER_CSV_HEADERS.START_ZIP', null, true), new CsvHeader.Column('Start Latitude', 'DRIVER_CSV_HEADERS.START_LATITUDE', null, true), new CsvHeader.Column('Start Longitude', 'DRIVER_CSV_HEADERS.START_LONGITUDE', null, true), new CsvHeader.Column('End Address', 'DRIVER_CSV_HEADERS.END_ADDRESS', 'DRIVER_CSV_HEADERS.END_ADDRESS_TOOLTIP', true), new CsvHeader.Column('End City', 'DRIVER_CSV_HEADERS.END_CITY', null, true), new CsvHeader.Column('End State', 'DRIVER_CSV_HEADERS.END_STATE', null, true), new CsvHeader.Column('End Zip Code', 'DRIVER_CSV_HEADERS.END_ZIP', null, true), new CsvHeader.Column('End Latitude', 'DRIVER_CSV_HEADERS.END_LATITUDE', null, true), new CsvHeader.Column('End Longitude', 'DRIVER_CSV_HEADERS.END_LONGITUDE', null, true), new CsvHeader.Column('Shift Start', 'DRIVER_CSV_HEADERS.SHIFT_START', 'DRIVER_CSV_HEADERS.SHIFT_START_TOOLTIP', true), new CsvHeader.Column('Shift End', 'DRIVER_CSV_HEADERS.SHIFT_END', 'DRIVER_CSV_HEADERS.SHIFT_END_TOOLTIP', true), new CsvHeader.Column('Capacity', 'DRIVER_CSV_HEADERS.CAPACITY', 'DRIVER_CSV_HEADERS.CAPACITY_TOOLTIP', true), new CsvHeader.Column('Types', 'DRIVER_CSV_HEADERS.TYPES', 'DRIVER_CSV_HEADERS.TYPES_TOOLTIP', true), new CsvHeader.Column('Driving Speed', 'DRIVER_CSV_HEADERS.DRIVING_SPEED', 'DRIVER_CSV_HEADERS.DRIVING_SPEED_TOOLTIP', true), new CsvHeader.Column('Phone', 'DRIVER_CSV_HEADERS.PHONE', 'DRIVER_CSV_HEADERS.PHONE_TOOLTIP', true), new CsvHeader.Column('Break Start', 'DRIVER_CSV_HEADERS.BREAK_START', 'DRIVER_CSV_HEADERS.BREAK_START_TOOLTIP', true), new CsvHeader.Column('Break End', 'DRIVER_CSV_HEADERS.BREAK_END', 'DRIVER_CSV_HEADERS.BREAK_END_TOOLTIP', true)];
    DriverCsvHeaderF = new CsvHeader(CACHE_NAME, DEFAULT_COLUMNS, SETTING_NAME);
    return DriverCsvHeaderF;
  };
  DriverCsvHeaderF.$inject = ["CsvHeader"];

  angular.module('app').factory('DriverCsvHeaderF', DriverCsvHeaderF);

}).call(this);

(function() {
  var DriverCsvMapC = function($scope, $state, DriverCsvHeaderF, DriverFileUploadF, MessagingF, MarkersF, EventListenersF, Events, States, OnboardingF) {
    var _isColumnSelected, _mapMatchingColumns, _saveCsvColumns;
    _mapMatchingColumns = (function(_this) {
      return function() {
        var col, columnName, lowerMappedName, mappedHeader, name, _i, _len, _ref, _ref1, _results;
        var cachedMap = DriverCsvHeaderF.headerMap;
        _ref = _this.columns;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          col = _ref[_i];
          columnName = col.name.toLowerCase();
          mappedHeader = cachedMap[columnName];
          lowerMappedName = mappedHeader != null ? (_ref1 = mappedHeader.mappedCol) != null ? _ref1.trim().toLowerCase() : void 0 : void 0;
          name = void 0;
          if (lowerMappedName) {
            name = _.detect(_this.userHeader, function(current) {
              return lowerMappedName === current.trim().toLowerCase();
            });
          }
          if (!name) {
            name = _.detect(_this.userHeader, function(current) {
              return columnName === current.trim().toLowerCase();
            });
          }
          _results.push(col.mappedCol = name ? name : void 0);
        }
        return _results;
      };
    })(this);
    _isColumnSelected = function(columns, columnName) {
      var col, _i, _len;
      for (_i = 0, _len = columns.length; _i < _len; _i++) {
        col = columns[_i];
        if (col.name === columnName) {
          return !!col.mappedCol;
        }
      }
      return false;
    };
    _saveCsvColumns = function(mapping) {
      var current;
      var columns = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = mapping.length; _i < _len; _i++) {
          current = mapping[_i];
          _results.push(current.name);
        }
        return _results;
      })();
      return DriverCsvHeaderF.updateColumns(columns);
    };
    this.enableCustomNotes = false;
    this.userHeader = DriverFileUploadF.userHeader;
    this.columns = _.cloneDeep(DriverCsvHeaderF.columns);
    this.read = function(columns) {
      var addressSelected, latSelected, lngSelected, message, onFileValidated;
      EventListenersF.notify(Events.CSV_MAP_CLOSED);
      columns = _.filter(columns, function(obj) {
        return !!obj.name;
      });
      addressSelected = _isColumnSelected(columns, 'Start Address');
      latSelected = _isColumnSelected(columns, 'Start Latitude');
      lngSelected = _isColumnSelected(columns, 'Start Longitude');
      if (latSelected || lngSelected) {
        message = null;
        if (!lngSelected) {
          message = "'Start Longitude' column must be selected since 'Start Latitude' is selected";
        }
        if (!latSelected) {
          message = "'Start Latitude' column must be selected since 'Start Longitude' is selected";
        }
        if (message) {
          this.error = message;
          return;
        }
      } else if (!addressSelected) {
        this.error = "'Start Address' or 'Start Latitude/Longitude' columns must be selected";
        return;
      }
      onFileValidated = function() {
        DriverCsvHeaderF.setHeaderMap(columns);
        _saveCsvColumns(columns);
        return $scope.closeThisDialog(States.projectDriversList);
      };
      return DriverFileUploadF.read(DriverFileUploadF.file, columns, false).then(null, null, onFileValidated)["catch"](function(err) {
        $scope.closeThisDialog();
        return MessagingF.replaceError(err.message || err.error);
      })["finally"](function() {
        OnboardingF.startTourForState($state.current.name);
        return MarkersF.fitToPoints();
      });
    };
    this.updateFieldName = function(column) {
      return function(newName) {
        return column.name = newName;
      };
    };
    this.updateCancelled = function(column) {
      return (function(_this) {
        return function() {
          var current, index, _i, _len, _ref, _results;
          if (column.name.trim().length === 0) {
            _ref = _this.columns;
            _results = [];
            for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
              current = _ref[index];
              if (!(current.id === column.id)) {
                continue;
              }
              _this.columns.splice(index, 1);
              break;
            }
            return _results;
          }
        };
      })(this);
    };
    this.addNewColumn = function() {
      return this.columns.push({
        id: this.columns.length,
        name: '',
        isOptional: true,
        isUserDefined: true
      });
    };
    _mapMatchingColumns();
  };
  DriverCsvMapC.$inject = ["$scope", "$state", "DriverCsvHeaderF", "DriverFileUploadF", "MessagingF", "MarkersF", "EventListenersF", "Events", "States", "OnboardingF"];

  angular.module('app').controller('DriverCsvMapC', DriverCsvMapC);

}).call(this);

(function() {
  var DriverFileUploadF = function($q, FileUploadUtil, DriverUploadF, ValidatorF, DriverCsvHeaderF, TimeUtilF, NumberUtilF, LoggerF) {
    var _addDrivers, _parseDriver, _retrieveLocation, _toInt, _toNumber;
    _toInt = function(val) {
      var numVal = val;
      if (numVal.trim && numVal.trim().length === 0) {
        return void 0;
      }
      return parseInt(numVal, 10);
    };
    _toNumber = function(val) {
      var numVal = val;
      if (numVal.trim && numVal.trim().length === 0) {
        return void 0;
      }
      return parseFloat(numVal);
    };
    _retrieveLocation = function(data, type) {
      var city, latitude, longitude, state, zipCode;
      var address = data["" + type + " Address"];
      latitude = NumberUtilF.toLatitude(data["" + type + " Latitude"]);
      longitude = NumberUtilF.toLongitude(data["" + type + " Longitude"]);
      if (address) {
        city = data["" + type + " City"];
        state = data["" + type + " State"];
        zipCode = data["" + type + " Zip Code"];
        if (city) {
          address += " , " + city;
        }
        if (state) {
          address += " , " + state;
        }
        if (zipCode) {
          address += " , " + zipCode;
        }
      }
      if (address || latitude || longitude) {
        return {
          info: {
            address: address,
            coords: {
              lat: latitude,
              lng: longitude
            }
          }
        };
      } else {
        return null;
      }
    };
    _parseDriver = function(row, mapping) {
      var breakEnd, breakStart, col, data, driver, endLocation, startLocation, type, types, uploadedDrivingSpeed, _i, _j, _len, _len1, _ref;
      data = {};
      for (_i = 0, _len = mapping.length; _i < _len; _i++) {
        col = mapping[_i];
        data[col.name] = row[col.mappedCol];
      }
      startLocation = _retrieveLocation(data, 'Start');
      endLocation = _retrieveLocation(data, 'End');
      types = [];
      if (data['Types']) {
        _ref = data['Types'].split(',');
        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
          type = _ref[_j];
          type = type.trim();
          if (type.length > 0) {
            types.push(type);
          }
        }
      }
      driver = {};
      driver.name = data['Driver Name'];
      driver.startLocation = startLocation;
      if (endLocation) {
        driver.endLocation = endLocation;
      }
      driver.startShift = TimeUtilF.convertTimeToDate(data['Shift Start']);
      driver.endShift = TimeUtilF.convertTimeToDate(data['Shift End']);
      driver.phoneNumber = data['Phone'];
      if (data['Capacity']) {
        driver.capacity = _toNumber(data['Capacity']);
      }
      driver.types = types;
      uploadedDrivingSpeed = data['Driving Speed'] || 100;
      driver.speed = _toInt(uploadedDrivingSpeed) / 100;
      breakStart = data['Break Start'];
      breakEnd = data['Break End'];
      driver.breaks = [];
      if (breakStart && breakEnd) {
        driver.breaks.push({
          id: null,
          start: TimeUtilF.convertTimeToDate(breakStart),
          end: TimeUtilF.convertTimeToDate(breakEnd)
        });
      }
      return driver;
    };
    _addDrivers = function(data, mapping) {
      var col, entries, row, _i, _j, _len, _len1, _ref;
      entries = [];
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        row = data[_i];
        for (_j = 0, _len1 = mapping.length; _j < _len1; _j++) {
          col = mapping[_j];
          if ((_ref = row[col.mappedCol]) != null ? _ref.trim() : void 0) {
            entries.push(_parseDriver(row, mapping));
            break;
          }
        }
      }
      LoggerF.info(LoggerF.ACTIONS.UPLOADED_DRIVERS, entries);
      return DriverUploadF.addDrivers(entries);
    };
    DriverFileUploadF = {};
    DriverFileUploadF.file = null;
    DriverFileUploadF.userHeader = null;
    DriverFileUploadF.read = function(file, mapping, isStrict) {
      var data, deferred, mapCopy;
      if (mapping == null) {
        mapping = DriverCsvHeaderF.DEFAULT_COLUMN_MAPPING;
      }
      if (isStrict == null) {
        isStrict = true;
      }
      DriverFileUploadF.file = null;
      DriverFileUploadF.userHeader = null;
      DriverFileUploadF.file = file;
      deferred = $q.defer();
      data = null;
      mapCopy = FileUploadUtil.toLowerCaseMapColumn(mapping);
      FileUploadUtil.read(file).then(function(res) {
        data = res.data;
        DriverFileUploadF.userHeader = res.header;
        return ValidatorF.validateDriverCsv(data, mapCopy, isStrict);
      }).then(function() {
        var promise;
        deferred.notify('validated');
        promise = _addDrivers(data, mapCopy);
        return deferred.resolve(promise);
      })["catch"](function(err) {
        return deferred.reject(err);
      });
      return deferred.promise;
    };
    return DriverFileUploadF;
  };
  DriverFileUploadF.$inject = ["$q", "FileUploadUtil", "DriverUploadF", "ValidatorF", "DriverCsvHeaderF", "TimeUtilF", "NumberUtilF", "LoggerF"];

  angular.module('app').factory('DriverFileUploadF', DriverFileUploadF);

}).call(this);

(function() {
  var DriverUploadC = function($q, $scope, $state, MessagingF, MarkersF, DriverFileUploadF, States, AnalyticsS, LoggerF, AccountF) {
    this.SUPPORTED_FILE_DROP = "*.csv,*.xml,*.xls,*.xlsx,*.xlsm";
    this.SUPPORTED_FILE_SELECT = ".csv,.xml,.xls,.xlsx,.xlsm";
    this.fileSelected = false;
    this.readFile = function(files) {
      var file, onFileValidated;
      if (!(files && files.length > 0)) {
        return;
      }
      AnalyticsS.track('028 Upload CSV drivers');
      onFileValidated = function() {
        return $state.go(States.projectDriversList);
      };
      file = files[0];
      DriverFileUploadF.read(file).then(null, null, onFileValidated)["catch"](function(err) {
        if (err.name === 'CsvUploadError') {
          return $state.go(States.modalCsvMapDrivers, {}, {
            location: false
          });
        } else {
          LoggerF.error(LoggerF.ACTIONS.UPLOADED_DRIVERS, void 0, err);
          return MessagingF.replaceError(err.message || err.error);
        }
      })["finally"]((function(_this) {
        return function() {
          _this.fileSelected = false;
          return MarkersF.fitToPoints();
        };
      })(this));
      return this.fileSelected = true;
    };
    this.cancel = function() {
      return $state.go(States.projectDriversList);
    };
  };
  DriverUploadC.$inject = ["$q", "$scope", "$state", "MessagingF", "MarkersF", "DriverFileUploadF", "States", "AnalyticsS", "LoggerF", "AccountF"];

  angular.module('app').controller('DriverUploadC', DriverUploadC);

}).call(this);

(function() {
  var DriverUploadF = function(DriverF, RouteS, UploadF, DriverGeocoordF, AnalyticsS, EventListenersF, Events) {
    DriverUploadF = (function() {
      function DriverUploadF() {
        UploadF.apply(this, arguments);
      }

      return DriverUploadF;

    })();
    DriverUploadF.prototype = new UploadF();
    DriverUploadF.prototype.addDrivers = function(drivers, quickAdd) {
      var newDrivers = null;
      return this.addEntries(drivers).then(function(entries) {
        var driver, validDrivers;
        newDrivers = entries;
        if (RouteS.hasRoute()) {
          validDrivers = (function() {
            var _i, _len, _results;
            _results = [];
            for (_i = 0, _len = newDrivers.length; _i < _len; _i++) {
              driver = newDrivers[_i];
              if (!(driver != null ? driver.error : void 0)) {
                _results.push(driver);
              }
            }
            return _results;
          })();
          if (validDrivers.length > 0) {
            return RouteS.addEmptyDrivers(validDrivers);
          }
        }
      }).then(function() {
        DriverF.updateDriversValidityList();
        return EventListenersF.notify(Events.PROJECT_MODIFIED);
      }).then(function() {
        var analyticsDriversObj, count, driver, _i, _len;
        count = newDrivers.length;
        analyticsDriversObj = {
          "#Uploaded Drivers": count,
          "Cancelled": this.status === UploadF.STATUS_LIST.CANCELLED
        };
        for (_i = 0, _len = newDrivers.length; _i < _len; _i++) {
          driver = newDrivers[_i];
          if (driver.error) {
            analyticsDriversObj['#Invalid Drivers'] = true;
          }
        }
        AnalyticsS.increment({
          "#Added Drivers": count
        });
        if (quickAdd) {
          return AnalyticsS.track("105 Quick add drivers", analyticsDriversObj);
        } else {
          return AnalyticsS.track("Add CSV drivers", analyticsDriversObj);
        }
      });
    };
    DriverUploadF.prototype.resetBatch = function(entries) {
      var entry, totalEntries, _i, _len;
      totalEntries = 0;
      for (_i = 0, _len = entries.length; _i < _len; _i++) {
        entry = entries[_i];
        if (entry.startLocation != null) {
          totalEntries++;
        }
        if (entry.endLocation != null) {
          totalEntries++;
        }
      }
      return DriverGeocoordF.resetBatch(totalEntries);
    };
    DriverUploadF.prototype.addEntry = function(entry) {
      return DriverF.add(entry, true);
    };
    return new DriverUploadF();
  };
  DriverUploadF.$inject = ["DriverF", "RouteS", "UploadF", "DriverGeocoordF", "AnalyticsS", "EventListenersF", "Events"];

  angular.module('app').factory('DriverUploadF', DriverUploadF);

}).call(this);

(function() {
  var FileUploadUtil = function($q) {
    var CSV_FILE, _getXlsHeaders, _readCsv, _readXls, _reader, _removeEmptyData, _removeUndefinedKeys, _toLowerCaseKey, _validateDuplicateHeader;
    CSV_FILE = /.csv$/i;
    _reader = new FileReader();
    _toLowerCaseKey = function(data, headers) {
      var key, template, _i, _len;
      template = {};
      for (_i = 0, _len = headers.length; _i < _len; _i++) {
        key = headers[_i];
        template[key] = '';
      }
      return _.map(data, function(current) {
        var value;
        var obj = _.clone(template);
        for (key in current) {
          value = current[key];
          obj[key.trim().toLowerCase()] = value;
        }
        return obj;
      });
    };
    _removeUndefinedKeys = function(data) {
      return _.map(data, function(current) {
        var key, obj, value;
        obj = {};
        for (key in current) {
          value = current[key];
          if (key !== 'undefined') {
            obj[key] = value;
          }
        }
        return obj;
      });
    };
    _removeEmptyData = function(data, appendRowNum) {
      var index, k, newData, row, v, _i, _len;
      if (appendRowNum == null) {
        appendRowNum = false;
      }
      newData = [];
      for (index = _i = 0, _len = data.length; _i < _len; index = ++_i) {
        row = data[index];
        for (k in row) {
          v = row[k];
          if (!(v && String(v).trim().length)) {
            continue;
          }
          if (appendRowNum) {
            row.__rowNum__ = index + 1;
          }
          newData.push(row);
          break;
        }
      }
      return newData;
    };
    _validateDuplicateHeader = function(header) {
      if (_.uniq(header).length !== header.length) {
        return this.reject(new Error("MESSAGES.DUPLICATE_HEADER"));
      }
    };
    _readCsv = function(file, skipEmptyRow) {
      var deferred;
      if (skipEmptyRow == null) {
        skipEmptyRow = true;
      }
      deferred = $q.defer();
      _reader.onload = function() {
        var data, headers, k, result;
        result = Papa.parse(_reader.result.trim(), {
          header: true,
          skipEmptyLines: skipEmptyRow
        });
        if (result.errors.length > 0) {
          deferred.reject(new Error("Error reading your CSV file: " + result.errors[0].message));
        }
        data = result.data;
        if (data.length) {
          headers = (function() {
            var _i, _len, _ref, _results;
            _ref = Object.keys(data[0]);
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              k = _ref[_i];
              if (k.trim().length > 0) {
                _results.push(k);
              }
            }
            return _results;
          })();
          _validateDuplicateHeader.call(deferred, headers);
        }
        return deferred.resolve({
          data: data,
          headers: headers
        });
      };
      _reader.readAsText(file, 'utf-8');
      return deferred.promise;
    };
    _getXlsHeaders = function(worksheet) {
      var cell, end, firstColumn, firstRow, header, headers, i, range, start, _i, _ref, _ref1;
      headers = [];
      range = XLSX.utils.decode_range(worksheet['!ref']);
      start = range.s;
      end = range.e;
      firstRow = start.r;
      firstColumn = start.c;
      for (i = _i = _ref = start.c, _ref1 = end.c; _ref <= _ref1 ? _i <= _ref1 : _i >= _ref1; i = _ref <= _ref1 ? ++_i : --_i) {
        cell = worksheet[XLSX.utils.encode_cell({
          c: i,
          r: firstRow
        })];
        header = null;
        if (cell != null ? cell.t : void 0) {
          header = XLSX.utils.format_cell(cell);
        } else {
          header = "undefined" + i;
        }
        headers.push(header.toLowerCase());
      }
      return headers;
    };
    _readXls = function(file) {
      var __arrayBufferToBinaryString;
      var deferred = $q.defer();
      __arrayBufferToBinaryString = function(buffer) {
        var arr, bytes, i, len, _i;
        bytes = new Uint8Array(buffer);
        arr = new Array();
        len = bytes.length;
        for (i = _i = 0; 0 <= len ? _i < len : _i > len; i = 0 <= len ? ++_i : --_i) {
          arr.push(String.fromCharCode(bytes[i]));
        }
        return arr.join('');
      };
      _reader.onloadend = function() {
        var data, e, headers, result, sheetNames, workbook, worksheet;
        try {
          result = __arrayBufferToBinaryString(_reader.result);
          workbook = XLSX.read(result, {
            type: 'binary'
          });
          sheetNames = workbook.SheetNames;
          worksheet = workbook.Sheets[sheetNames[0]];
          data = XLSX.utils.sheet_to_json(worksheet);
          if (data.length) {
            headers = _getXlsHeaders(worksheet);
            _validateDuplicateHeader.call(deferred, headers);
          }
          return deferred.resolve({
            data: data,
            headers: headers
          });
        } catch (_error) {
          e = _error;
          console.error('failed to read XLS', e);
          return deferred.reject(new Error("MESSAGES.XLS_PARSE_ERROR"));
        }
      };
      _reader.readAsArrayBuffer(file);
      return deferred.promise;
    };
    FileUploadUtil = {};
    FileUploadUtil.toLowerCaseMapColumn = function(mapping) {
      var current, _i, _len, _ref;
      var copy = _.cloneDeep(mapping);
      for (_i = 0, _len = copy.length; _i < _len; _i++) {
        current = copy[_i];
        current.mappedCol = (_ref = current.mappedCol) != null ? _ref.trim().toLowerCase() : void 0;
      }
      return copy;
    };
    FileUploadUtil.read = function(file, skipEmptyRow) {
      var fileReader, isCsv;
      if (skipEmptyRow == null) {
        skipEmptyRow = true;
      }
      fileReader = null;
      isCsv = file.name.match(CSV_FILE);
      if (isCsv) {
        fileReader = _readCsv;
      } else {
        fileReader = _readXls;
      }
      return fileReader(file, skipEmptyRow).then(function(res) {
        var data, originalData, parsedData, userHeader;
        if (isCsv && !skipEmptyRow) {
          data = _removeEmptyData(res.data, true);
        } else {
          data = _removeEmptyData(res.data);
        }
        if (!skipEmptyRow) {
          originalData = _.clone(data);
        }
        userHeader = res.headers || [];
        data = _toLowerCaseKey(data, userHeader);
        data = _removeUndefinedKeys(data);
        parsedData = {
          data: data,
          header: userHeader
        };
        if (originalData) {
          parsedData.originalData = originalData;
        }
        return parsedData;
      });
    };
    return FileUploadUtil;
  };
  FileUploadUtil.$inject = ["$q"];

  angular.module('app').factory('FileUploadUtil', FileUploadUtil);

}).call(this);

(function() {
  var SaveCsvUtilF = function($window, Constants, AccountF, $http, $q) {
    var CSV_FILE, XLSX_FILE, _readFile, _reader, _uploadCsv;
    _reader = new FileReader();
    CSV_FILE = /.csv$/i;
    XLSX_FILE = /.xlsx$/i;
    _uploadCsv = function(content, extension) {
      var e;
      try {
        return $http.post("" + Constants.productApiPath + "/csv", {
          content: content,
          ext: extension
        }, AccountF.getAuthHeader());
      } catch (_error) {
        e = _error;
        return console.error("error uploading csv: " + e);
      }
    };
    _readFile = function(file) {
      var __arrayBufferToBinaryString;
      var deferred = $q.defer();
      __arrayBufferToBinaryString = function(buffer) {
        var arr, bytes, i, len, _i;
        bytes = new Uint8Array(buffer);
        arr = new Array();
        len = bytes.length;
        for (i = _i = 0; 0 <= len ? _i < len : _i > len; i = 0 <= len ? ++_i : --_i) {
          arr.push(String.fromCharCode(bytes[i]));
        }
        return arr.join('');
      };
      _reader.onloadend = function() {
        var e, result;
        try {
          result = __arrayBufferToBinaryString(_reader.result);
          return deferred.resolve($window.btoa(result));
        } catch (_error) {
          e = _error;
          return console.error('error reading file', e);
        }
      };
      _reader.readAsArrayBuffer(file);
      return deferred.promise;
    };
    SaveCsvUtilF.readAndSave = function(file) {
      var extension, isCsv, isXlsx;
      isCsv = file.name.match(CSV_FILE);
      isXlsx = file.name.match(XLSX_FILE);
      extension = isCsv ? 'csv' : isXlsx ? 'xlsx' : 'xls';
      return _readFile(file).then(function(res) {
        return _uploadCsv(res, extension);
      });
    };
    return SaveCsvUtilF;
  };
  SaveCsvUtilF.$inject = ["$window", "Constants", "AccountF", "$http", "$q"];

  angular.module('app').factory('SaveCsvUtilF', SaveCsvUtilF);

}).call(this);

(function() {
  var UploadF = function($q, $timeout, EventListenersF, Events, AnalyticsS) {
    var ONE_SECOND, THREE_SECONDS, UPLOAD_IN_PROGRESS_ERROR;
    UPLOAD_IN_PROGRESS_ERROR = $q.reject(new Error("Upload already in progress"));
    ONE_SECOND = 1000;
    THREE_SECONDS = 3000;
    UploadF = (function() {
      function UploadF() {
        this.progress = 0;
        this.count = 0;
        this.status = UploadF.STATUS_LIST.READY;
      }

      return UploadF;

    })();
    UploadF.STATUS_LIST = {
      READY: 'ready',
      ACTIVE: 'active',
      DONE: 'done',
      CANCELLED: 'cancelled'
    };
    UploadF.prototype.addEntries = function(entries) {
      var entry, newEntries, promises, size, _fn, _i, _len;
      if (entries.length === 0) {
        return $q.when(true);
      }
      if (this.status !== UploadF.STATUS_LIST.READY) {
        return UPLOAD_IN_PROGRESS_ERROR;
      }
      this.count = 0;
      size = entries.length;
      promises = [];
      this.progress = 0;
      this.status = UploadF.STATUS_LIST.ACTIVE;
      this.resetBatch(entries);
      _fn = (function(_this) {
        return function(entry) {
          var promise = _this.addEntry(entry);
          promise["finally"](function() {
            return _this.progress = ++_this.count / size;
          });
          return promises.push(promise);
        };
      })(this);
      for (_i = 0, _len = entries.length; _i < _len; _i++) {
        entry = entries[_i];
        _fn(entry);
      }
      newEntries = null;
      EventListenersF.notify(Events.CSV_UPLOAD_IN_PROGRESS);
      return $q.all(promises).then((function(_this) {
        return function(entries) {
          EventListenersF.notify(Events.CSV_UPLOAD_COMPLETED);
          if (!(_this.status === UploadF.STATUS_LIST.CANCELLED)) {
            $timeout(function() {
              return _this.status = UploadF.STATUS_LIST.DONE;
            }, ONE_SECOND);
          }
          $timeout(function() {
            return _this.status = UploadF.STATUS_LIST.READY;
          }, THREE_SECONDS);
          newEntries = (function() {
            var _j, _len1, _results;
            _results = [];
            for (_j = 0, _len1 = entries.length; _j < _len1; _j++) {
              entry = entries[_j];
              if (!!entry) {
                _results.push(entry);
              }
            }
            return _results;
          })();
          return newEntries;
        };
      })(this))["catch"]((function(_this) {
        return function(err) {
          EventListenersF.notify(Events.CSV_UPLOAD_COMPLETED);
          _this.status = UploadF.STATUS_LIST.READY;
          return $q.reject(err);
        };
      })(this));
    };
    return UploadF;
  };
  UploadF.$inject = ["$q", "$timeout", "EventListenersF", "Events", "AnalyticsS"];

  angular.module('app').factory('UploadF', UploadF);

}).call(this);

(function() {
  var VisitCsvHeaderF = function(CsvHeader) {
    var CACHE_NAME, DEFAULT_COLUMNS, SETTING_NAME;
    CACHE_NAME = 'headerMapCache';
    SETTING_NAME = 'csvUploadMap';
    DEFAULT_COLUMNS = [new CsvHeader.Column('Name', 'VISIT_CSV_HEADERS.ID', 'VISIT_CSV_HEADERS.ID_TOOLTIP', false), new CsvHeader.Column('Address', 'VISIT_CSV_HEADERS.ADDRESS', 'VISIT_CSV_HEADERS.ADDRESS_TOOLTIP', true), new CsvHeader.Column('City', 'VISIT_CSV_HEADERS.CITY', 'VISIT_CSV_HEADERS.CITY_TOOLTIP', true), new CsvHeader.Column('State', 'VISIT_CSV_HEADERS.STATE', 'VISIT_CSV_HEADERS.STATE_TOOLTIP', true), new CsvHeader.Column('Zip code', 'VISIT_CSV_HEADERS.ZIP', 'VISIT_CSV_HEADERS.ZIP_TOOLTIP', true), new CsvHeader.Column('From', 'VISIT_CSV_HEADERS.FROM', 'VISIT_CSV_HEADERS.FROM_TOOLTIP', true), new CsvHeader.Column('To', 'VISIT_CSV_HEADERS.TO', 'VISIT_CSV_HEADERS.TO_TOOLTIP', true), new CsvHeader.Column('Duration', 'VISIT_CSV_HEADERS.DURATION', 'VISIT_CSV_HEADERS.DURATION_TOOLTIP', true), new CsvHeader.Column('Load', 'VISIT_CSV_HEADERS.LOAD', 'VISIT_CSV_HEADERS.LOAD_TOOLTIP', true), new CsvHeader.Column('Types', 'VISIT_CSV_HEADERS.TYPES', 'VISIT_CSV_HEADERS.TYPES_TOOLTIP', true), new CsvHeader.Column('Phone', 'VISIT_CSV_HEADERS.PHONE', 'VISIT_CSV_HEADERS.PHONE_TOOLTIP', true), new CsvHeader.Column('Email', 'VISIT_CSV_HEADERS.EMAIL', 'VISIT_CSV_HEADERS.EMAIL_TOOLTIP', true), new CsvHeader.Column('Priority', 'VISIT_CSV_HEADERS.PRIORITY', 'VISIT_CSV_HEADERS.PRIORITY_TOOLTIP', true), new CsvHeader.Column('Notes', 'VISIT_CSV_HEADERS.NOTES', 'VISIT_CSV_HEADERS.NOTES_TOOLTIP', true), new CsvHeader.Column('Notes 2', 'VISIT_CSV_HEADERS.NOTES_2', 'VISIT_CSV_HEADERS.NOTES_2_TOOLTIP', true), new CsvHeader.Column('Latitude', 'VISIT_CSV_HEADERS.LATITUDE', 'VISIT_CSV_HEADERS.LATITUDE_TOOLTIP', true), new CsvHeader.Column('Longitude', 'VISIT_CSV_HEADERS.LONGITUDE', 'VISIT_CSV_HEADERS.LONGITUDE_TOOLTIP', true)];
    VisitCsvHeaderF = new CsvHeader(CACHE_NAME, DEFAULT_COLUMNS, SETTING_NAME);
    return VisitCsvHeaderF;
  };
  VisitCsvHeaderF.$inject = ["CsvHeader"];

  angular.module('app').factory('VisitCsvHeaderF', VisitCsvHeaderF);

}).call(this);

(function() {
  var VisitCsvMapC = function($scope, $state, VisitCsvHeaderF, VisitFileUploadF, MessagingF, MarkersF, EventListenersF, Events, States, OnboardingF) {
    var _isColumnSelected, _mapMatchingColumns, _saveCsvColumns;
    _mapMatchingColumns = (function(_this) {
      return function() {
        var col, columnName, lowerMappedName, mappedHeader, name, _i, _len, _ref, _ref1, _results;
        var cachedMap = VisitCsvHeaderF.headerMap;
        _ref = _this.columns;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          col = _ref[_i];
          columnName = col.name.toLowerCase();
          mappedHeader = cachedMap[columnName];
          lowerMappedName = mappedHeader != null ? (_ref1 = mappedHeader.mappedCol) != null ? _ref1.trim().toLowerCase() : void 0 : void 0;
          name = void 0;
          if (lowerMappedName) {
            name = _.detect(_this.userHeader, function(current) {
              return lowerMappedName === current.trim().toLowerCase();
            });
          }
          if (!name) {
            name = _.detect(_this.userHeader, function(current) {
              return columnName === current.trim().toLowerCase();
            });
          }
          _results.push(col.mappedCol = name ? name : void 0);
        }
        return _results;
      };
    })(this);
    _isColumnSelected = function(columns, columnName) {
      var col, _i, _len;
      for (_i = 0, _len = columns.length; _i < _len; _i++) {
        col = columns[_i];
        if (col.name === columnName) {
          return !!col.mappedCol;
        }
      }
      return false;
    };
    _saveCsvColumns = function(mapping) {
      var current;
      var columns = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = mapping.length; _i < _len; _i++) {
          current = mapping[_i];
          _results.push(current.name);
        }
        return _results;
      })();
      return VisitCsvHeaderF.updateColumns(columns);
    };
    this.enableCustomNotes = true;
    this.userHeader = VisitFileUploadF.userHeader;
    this.columns = _.cloneDeep(VisitCsvHeaderF.columns);
    this.read = function(columns) {
      var addressSelected, latSelected, lngSelected, message, onFileValidated;
      EventListenersF.notify(Events.CSV_MAP_CLOSED);
      columns = _.filter(columns, function(obj) {
        return !!obj.name;
      });
      addressSelected = _isColumnSelected(columns, 'Address');
      latSelected = _isColumnSelected(columns, 'Latitude');
      lngSelected = _isColumnSelected(columns, 'Longitude');
      if (latSelected || lngSelected) {
        message = null;
        if (!lngSelected) {
          message = "'Longitude' column must be selected since 'Latitude' is selected";
        }
        if (!latSelected) {
          message = "'Latitude' column must be selected since 'Longitude' is selected";
        }
        if (message) {
          this.error = message;
          return;
        }
      } else if (!addressSelected) {
        this.error = "'Address' or 'Latitude/Longitude' columns must be selected";
        return;
      }
      onFileValidated = function() {
        VisitCsvHeaderF.setHeaderMap(columns);
        _saveCsvColumns(columns);
        return $scope.closeThisDialog(States.projectVisitsList);
      };
      return VisitFileUploadF.read(VisitFileUploadF.file, columns, false).then(null, null, onFileValidated)["catch"](function(err) {
        $scope.closeThisDialog();
        return MessagingF.replaceError(err.message || err.error);
      })["finally"](function() {
        OnboardingF.startTourForState($state.current.name);
        return MarkersF.fitToPoints();
      });
    };
    this.updateFieldName = function(column) {
      return function(newName) {
        return column.name = newName;
      };
    };
    this.updateCancelled = function(column) {
      return (function(_this) {
        return function() {
          var current, index, _i, _len, _ref, _results;
          if (column.name.trim().length === 0) {
            _ref = _this.columns;
            _results = [];
            for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {
              current = _ref[index];
              if (!(current.id === column.id)) {
                continue;
              }
              _this.columns.splice(index, 1);
              break;
            }
            return _results;
          }
        };
      })(this);
    };
    this.addNewColumn = function() {
      return this.columns.push({
        id: this.columns.length,
        name: '',
        isOptional: true,
        isUserDefined: true
      });
    };
    _mapMatchingColumns();
  };
  VisitCsvMapC.$inject = ["$scope", "$state", "VisitCsvHeaderF", "VisitFileUploadF", "MessagingF", "MarkersF", "EventListenersF", "Events", "States", "OnboardingF"];

  angular.module('app').controller('VisitCsvMapC', VisitCsvMapC);

}).call(this);

(function() {
  var VisitFileUploadF = function($q, FileUploadUtil, VisitUploadF, ValidatorF, VisitCsvHeaderF, TimeUtilF, NumberUtilF, LoggerF) {
    var _addVisits, _parseVisit;
    var AddressData = (function() {
      function AddressData(id, columnName) {
        this.id = id;
        this.columnName = columnName;
      }

      return AddressData;

    })();
    _parseVisit = function(row, mapping) {
      var address, addressColumns, addressData, col, data, info, location, type, types, visit, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2;
      data = {};
      visit = {
        customNotes: {}
      };
      for (_i = 0, _len = mapping.length; _i < _len; _i++) {
        col = mapping[_i];
        if (col.isUserDefined) {
          col.name = col.name.replace(/\./g, ' ');
          visit.customNotes[col.name] = (_ref = row[col.mappedCol]) != null ? _ref.toString() : void 0;
        } else {
          data[col.name] = row[col.mappedCol];
        }
      }
      addressColumns = [new AddressData('street', 'Address'), new AddressData('city', 'City'), new AddressData('state', 'State'), new AddressData('zipCode', 'Zip code')];
      location = {};
      address = [];
      for (_j = 0, _len1 = addressColumns.length; _j < _len1; _j++) {
        addressData = addressColumns[_j];
        info = data[addressData.columnName];
        if (info) {
          location[addressData.id] = info;
          address.push(info);
        }
      }
      if (address.length > 0) {
        location.address = address.join(', ');
      }
      location.coords = {
        lat: NumberUtilF.toLatitude(data['Latitude']),
        lng: NumberUtilF.toLongitude(data['Longitude'])
      };
      types = [];
      if (data['Types']) {
        _ref1 = data['Types'].split(',');
        for (_k = 0, _len2 = _ref1.length; _k < _len2; _k++) {
          type = _ref1[_k];
          type = type.trim();
          if (type.length > 0) {
            types.push(type);
          }
        }
      }
      if (data['Name']) {
        visit.name = data['Name'].toString();
      }
      visit.location = location;
      visit.startDate = TimeUtilF.convertTimeToDate(data['From']);
      visit.endDate = TimeUtilF.convertTimeToDate(data['To']);
      visit.duration = parseInt(data['Duration'], 10) || null;
      visit.load = parseFloat(data['Load']) || null;
      visit.types = types;
      visit.phone = data['Phone'];
      visit.email = data['Email'];
      if (data['Notes']) {
        visit.notes = data['Notes'].toString();
      }
      if (data['Notes 2']) {
        visit.notes2 = data['Notes 2'].toString();
      }
      if (((_ref2 = data['Priority']) != null ? _ref2.trim().toLowerCase() : void 0) === 'yes') {
        visit.isPriority = true;
      }
      return visit;
    };
    _addVisits = function(data, mapping) {
      var col, entries, row, _i, _j, _len, _len1, _ref;
      entries = [];
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        row = data[_i];
        for (_j = 0, _len1 = mapping.length; _j < _len1; _j++) {
          col = mapping[_j];
          if ((_ref = row[col.mappedCol]) != null ? _ref.trim() : void 0) {
            entries.push(_parseVisit(row, mapping));
            break;
          }
        }
      }
      LoggerF.info(LoggerF.ACTIONS.UPLOADED_STOPS, entries);
      return VisitUploadF.addVisits(entries);
    };
    VisitFileUploadF = {};
    VisitFileUploadF.file = null;
    VisitFileUploadF.userHeader = null;
    VisitFileUploadF.read = function(file, mapping, isStrict) {
      var data, deferred, mapCopy;
      if (mapping == null) {
        mapping = VisitCsvHeaderF.DEFAULT_COLUMN_MAPPING;
      }
      if (isStrict == null) {
        isStrict = true;
      }
      VisitFileUploadF.file = null;
      VisitFileUploadF.userHeader = null;
      VisitFileUploadF.file = file;
      deferred = $q.defer();
      data = null;
      mapCopy = FileUploadUtil.toLowerCaseMapColumn(mapping);
      FileUploadUtil.read(file).then(function(res) {
        data = res.data;
        VisitFileUploadF.userHeader = res.header;
        return ValidatorF.validateVisitCsv(data, mapCopy, isStrict);
      }).then(function() {
        var promise;
        deferred.notify('validated');
        promise = _addVisits(data, mapCopy);
        return deferred.resolve(promise);
      })["catch"](function(err) {
        return deferred.reject(err);
      });
      return deferred.promise;
    };
    return VisitFileUploadF;
  };
  VisitFileUploadF.$inject = ["$q", "FileUploadUtil", "VisitUploadF", "ValidatorF", "VisitCsvHeaderF", "TimeUtilF", "NumberUtilF", "LoggerF"];

  angular.module('app').factory('VisitFileUploadF', VisitFileUploadF);

}).call(this);

(function() {
  var VisitUploadC = function($q, $scope, $state, MessagingF, MarkersF, VisitFileUploadF, States, AnalyticsS, OnboardingF, LoggerF, SaveCsvUtilF, AccountF) {
    var _ref;
    this.SUPPORTED_FILE_DROP = "*.csv,*.xml,*.xls,*.xlsx,*.xlsm";
    this.SUPPORTED_FILE_SELECT = ".csv,.xml,.xls,.xlsx,.xlsm";
    this.fileSelected = false;
    this.user = AccountF.getUser();
    this.isTrial = ((_ref = this.user) != null ? _ref.status : void 0) === 'trial';
    this.readFile = function(files) {
      var file, onFileValidated;
      if (!(files && files.length > 0)) {
        return;
      }
      AnalyticsS.track('083 Upload CSV stops');
      onFileValidated = function() {
        return $state.go(States.projectVisitsList);
      };
      file = files[0];
      SaveCsvUtilF.readAndSave(file);
      VisitFileUploadF.read(file).then(null, null, onFileValidated).then(function() {
        return OnboardingF.startTourForState($state.current.name);
      })["catch"](function(err) {
        if (err.name === 'CsvUploadError') {
          return $state.go(States.modalCsvMapVisits, {}, {
            location: false
          });
        } else {
          LoggerF.error(LoggerF.ACTIONS.UPLOADED_STOPS, void 0, err);
          return MessagingF.replaceError(err.message || err.error);
        }
      })["finally"]((function(_this) {
        return function() {
          _this.fileSelected = false;
          return MarkersF.fitToPoints();
        };
      })(this));
      return this.fileSelected = true;
    };
    this.cancel = function() {
      return $state.go(States.projectVisitsList);
    };
  };
  VisitUploadC.$inject = ["$q", "$scope", "$state", "MessagingF", "MarkersF", "VisitFileUploadF", "States", "AnalyticsS", "OnboardingF", "LoggerF", "SaveCsvUtilF", "AccountF"];

  angular.module('app').controller('VisitUploadC', VisitUploadC);

}).call(this);

(function() {
  var VisitUploadF = function(VisitF, RouteS, UploadF, VisitGeocoordF, AnalyticsS, EventListenersF, Events) {
    VisitUploadF = (function() {
      function VisitUploadF() {
        UploadF.apply(this, arguments);
      }

      return VisitUploadF;

    })();
    VisitUploadF.prototype = new UploadF();
    VisitUploadF.prototype.addVisits = function(visits) {
      var emailList, newVisits;
      newVisits = null;
      emailList = [];
      return this.addEntries(visits).then(function(entries) {
        newVisits = entries;
        if (RouteS.hasRoute()) {
          RouteS.addVisitsAsUnserved(newVisits);
        }
        return EventListenersF.notify(Events.PROJECT_MODIFIED);
      }).then(function() {
        var ambiguousVisits, analyticsStopsObj, count, invalidVisits, visit, _i, _len, _ref;
        VisitF.updateValidVisits();
        count = newVisits.length;
        invalidVisits = 0;
        ambiguousVisits = 0;
        analyticsStopsObj = {
          "#Uploaded Visits": count,
          "Cancelled": this.status === UploadF.STATUS_LIST.CANCELLED
        };
        for (_i = 0, _len = newVisits.length; _i < _len; _i++) {
          visit = newVisits[_i];
          if (visit.status === 'invalid') {
            invalidVisits++;
          }
          if (((_ref = visit.location) != null ? _ref.all_results : void 0) != null) {
            ambiguousVisits++;
          }
          if (visit.error) {
            analyticsStopsObj['#Invalid Stops'] = true;
          }
          if ((visit.email != null) && visit.email.trim() !== '') {
            emailList.push(visit.email);
          }
        }
        if (invalidVisits > 0) {
          AnalyticsS.track("0001_WEB_UI invalid stops found", {
            "#Invalid Visits": invalidVisits
          });
        }
        if (ambiguousVisits > 0) {
          AnalyticsS.track("0004_WEB_UI multiple addresses found", {
            "#Multiple Address Visits": ambiguousVisits
          });
        }
        AnalyticsS.increment({
          "#Added Visits": count
        });
        return AnalyticsS.track("Add CSV visits", analyticsStopsObj);
      }).then(function() {
        if (emailList.length > 0) {
          VisitF.getAndUpdateUnsubscription(emailList);
        }
        return newVisits;
      });
    };
    VisitUploadF.prototype.resetBatch = function(entries) {
      return VisitGeocoordF.resetBatch(entries.length);
    };
    VisitUploadF.prototype.addEntry = function(entry) {
      return VisitF.addVisit(entry, true);
    };
    return new VisitUploadF();
  };
  VisitUploadF.$inject = ["VisitF", "RouteS", "UploadF", "VisitGeocoordF", "AnalyticsS", "EventListenersF", "Events"];

  angular.module('app').factory('VisitUploadF', VisitUploadF);

}).call(this);

(function() {
  var VideoC = function($scope, $sce) {
    this.url = $sce.trustAsResourceUrl('https://player.vimeo.com/video/384910994?autoplay=1');
    this.onExit = function() {
      return $scope.closeThisDialog();
    };
  };
  VideoC.$inject = ["$scope", "$sce"];

  angular.module('app').controller('VideoC', VideoC);

}).call(this);

(function() {
  var CsvFile;
  var CsvExporter = function($document, $q, CSV) {
    var CSV_OPTIONS;
    CSV_OPTIONS = {
      fieldSep: ',',
      txtDelim: '"',
      decimalSep: '.'
    };
    CsvExporter = {};
    CsvExporter.CSV = CsvFile;
    CsvExporter.isSafari = /safari/i.test(window.navigator.userAgent) && !/chrome/i.test(window.navigator.userAgent);
    CsvExporter.isFirefox = /firefox/i.test(window.navigator.userAgent);
    CsvExporter.save = function(csvs) {
      var csv, promises, _fn, _i, _len;
      promises = [];
      _fn = function(csv) {
        var promise = CSV.stringify(csv.data, CSV_OPTIONS).then(function(content) {
          var callback, dataBlob, element;
          dataBlob = new Blob([content], {
            type: 'text/csv;charset=utf-8;'
          });
          if (window.navigator.msSaveBlob != null) {
            window.navigator.msSaveBlob(dataBlob, csv.filename);
            return;
          }
          element = angular.element('<a/>');
          element.attr({
            href: window.URL.createObjectURL(dataBlob),
            target: CsvExporter.isSafari ? void 0 : '_blank',
            download: csv.filename
          });
          $document.find('body').append(element);
          callback = function() {
            element[0].click();
            return element.remove();
          };
          return setTimeout(callback, 0);
        });
        return promises.push(promise);
      };
      for (_i = 0, _len = csvs.length; _i < _len; _i++) {
        csv = csvs[_i];
        _fn(csv);
      }
      return $q.all(promises);
    };
    return CsvExporter;
  };
  CsvExporter.$inject = ["$document", "$q", "CSV"];

  angular.module('app').factory('CsvExporter', CsvExporter);

  CsvFile = (function() {
    function CsvFile(filename, data) {
      this.filename = filename;
      this.data = data;
    }

    return CsvFile;

  })();

}).call(this);

(function() {
  var DistanceUtilF = function(SettingsF) {
    var KM_TO_MILES;
    KM_TO_MILES = 0.621371;
    DistanceUtilF = {};
    DistanceUtilF.toMiles = function(distance) {
      return distance * KM_TO_MILES;
    };
    DistanceUtilF.getDistance = function(km, format) {
      if (format === SettingsF.MILES_DISTANCE) {
        return DistanceUtilF.toMiles(km);
      }
      return km;
    };
    return DistanceUtilF;
  };
  DistanceUtilF.$inject = ["SettingsF"];

  angular.module('app').factory('DistanceUtilF', DistanceUtilF);

}).call(this);

(function() {
  var DriverUtil = function(TimeUtilF) {
    var _formatDriverMarker;
    DriverUtil = {};
    _formatDriverMarker = function(entry) {
      var breaks, brk, coords, driver, _i, _len, _ref, _ref1, _ref2, _ref3;
      driver = {
        name: entry.name
      };
      if ((_ref = entry.startLocation) != null ? _ref.info : void 0) {
        driver['start-location'] = {
          id: entry.startLocation.id,
          address: entry.startLocation.info.address
        };
        if ((_ref1 = entry.startLocation.info) != null ? _ref1.coords : void 0) {
          coords = {
            lat: entry.startLocation.info.coords.lat,
            lng: entry.startLocation.info.coords.lng
          };
          driver['start-location'].lat = coords.lat;
          driver['start-location'].lng = coords.lng;
          driver['start-location'].coords = coords;
        }
      }
      if ((_ref2 = entry.endLocation) != null ? _ref2.info : void 0) {
        driver['end-location'] = {
          id: entry.endLocation.id,
          address: entry.endLocation.info.address
        };
        if ((_ref3 = entry.endLocation.info) != null ? _ref3.coords : void 0) {
          coords = {
            lat: entry.endLocation.info.coords.lat,
            lng: entry.endLocation.info.coords.lng
          };
          driver['end-location'].lat = coords.lat;
          driver['end-location'].lng = coords.lng;
          driver['end-location'].coords = coords;
        }
      } else {
        driver['end-location'] = null;
      }
      if ((entry.startShift != null) && entry.startShift instanceof Date) {
        driver['shift-start'] = TimeUtilF.convertDateToTime(entry.startShift);
      } else {
        driver['shift-start'] = entry.startShift;
      }
      if ((entry.endShift != null) && entry.endShift instanceof Date) {
        driver['shift-end'] = TimeUtilF.convertDateToTime(entry.endShift);
      } else {
        driver['shift-end'] = entry.endShift;
      }
      if (entry.phoneNumber) {
        driver['phone-number'] = entry.phoneNumber;
      } else {
        driver['phone-number'] = null;
      }
      if (entry.speed) {
        driver['speed'] = entry.speed;
      } else {
        driver['speed'] = 1;
      }
      if (entry.capacity != null) {
        driver.capacity = parseFloat(entry.capacity);
      } else {
        driver.capacity = null;
      }
      if (entry.types != null) {
        driver.types = entry.types;
      } else {
        driver.types = null;
      }
      driver.breaks = [];
      breaks = entry.breaks || [];
      for (_i = 0, _len = breaks.length; _i < _len; _i++) {
        brk = breaks[_i];
        if (brk.start && brk.end) {
          driver.breaks.push({
            id: brk.id,
            start: TimeUtilF.convertDateToTime(brk.start),
            end: TimeUtilF.convertDateToTime(brk.end)
          });
        }
      }
      driver['strict_start'] = entry.strictStart;
      if (entry.status) {
        driver.status = entry.status;
      }
      if (entry.error) {
        driver.error = entry.error;
      }
      return driver;
    };
    DriverUtil.formatDriverEntry = function(entry) {
      var driver = _formatDriverMarker(entry);
      driver.id = entry.id;
      return driver;
    };
    DriverUtil.formatDriverMarker = function(entry) {
      var driver = _formatDriverMarker(entry);
      driver._id = entry.id;
      driver.visible = entry.visible;
      driver.createdAt = entry.createdAt || Date.now();
      if (entry.vehicleId != null) {
        driver.vehicleId = entry.vehicleId;
      }
      return driver;
    };
    return DriverUtil;
  };
  DriverUtil.$inject = ["TimeUtilF"];

  angular.module('app').factory('DriverUtil', DriverUtil);

}).call(this);

(function() {
  var FeatureFlagF = function($http, AccountF, Constants, ProjectF, SessionF) {
    FeatureFlagF = {};
    FeatureFlagF.isEnabled = function(featureId) {
      var authHeader = AccountF.getAuthHeader();
      return $http.get("" + Constants.productApiPath + "/v1.0/feature-rollouts/" + featureId, authHeader).then(function(res) {
        return res.data.isEnabled;
      });
    };
    return FeatureFlagF;
  };
  FeatureFlagF.$inject = ["$http", "AccountF", "Constants", "ProjectF", "SessionF"];

  angular.module('app').factory('FeatureFlagF', FeatureFlagF);

}).call(this);

(function() {
  var GeoIpF = function($http, $q, Constants) {
    var IPGEOLOCATION_URL, token, _geoIpData, _getGeoIpData;
    token = Constants.ipGeolocationKey;
    IPGEOLOCATION_URL = "https://api.ipgeolocation.io/ipgeo?fields=country_code2";
    if (token) {
      IPGEOLOCATION_URL = IPGEOLOCATION_URL + ("&apiKey=" + token);
    }
    _geoIpData = null;
    _getGeoIpData = function() {
      if (_geoIpData === null) {
        return $http.get(IPGEOLOCATION_URL).then(function(res) {
          _geoIpData = res != null ? res.data : void 0;
          return _geoIpData;
        })["catch"](function(err) {
          return null;
        });
      }
      return $q.when(_geoIpData);
    };
    GeoIpF = {};
    GeoIpF.initialize = function() {
      return _getGeoIpData();
    };
    GeoIpF.getCountry = function() {
      return _getGeoIpData().then(function(data) {
        return data != null ? data.country_code2 : void 0;
      });
    };
    return GeoIpF;
  };
  GeoIpF.$inject = ["$http", "$q", "Constants"];

  angular.module('app').factory('GeoIpF', GeoIpF);

}).call(this);

(function() {
  var LocalStorageArrayF = [
    'LocalStorageF', function(LocalStorageF) {
      LocalStorageArrayF = function(key) {
        var _save;
        _save = function() {
          var e, _results;
          _results = [];
          while (true) {
            try {
              this.save();
              break;
            } catch (_error) {
              e = _error;
              _results.push(this.data.shift());
            }
          }
          return _results;
        };
        this.storage = LocalStorageF(key, [], false);
        this.storage.shift = function() {
          this.data.shift();
          return _save.call(this);
        };
        this.storage.push = function(value) {
          this.data.push(value);
          return _save.call(this);
        };
        this.storage.pop = function() {
          this.data.pop();
          return _save.call(this);
        };
        this.storage.replace = function(index, item) {
          this.data.splice(index, 1, item);
          return _save.call(this);
        };
        return this.storage;
      };
      return LocalStorageArrayF;
    }
  ];

  angular.module('app').factory('LocalStorageArrayF', LocalStorageArrayF);

}).call(this);

(function() {
  var LocalStorageObjectF = [
    'LocalStorageF', function(LocalStorageF) {
      LocalStorageObjectF = function(key) {
        this.storage = LocalStorageF(key, {}, false);
        this.storage.set = function(value) {
          this.data = value;
          return this.save();
        };
        return this.storage;
      };
      return LocalStorageObjectF;
    }
  ];

  angular.module('app').factory('LocalStorageObjectF', LocalStorageObjectF);

}).call(this);

(function() {
  var LocalStorageStringF = [
    'LocalStorageF', function(LocalStorageF) {
      LocalStorageStringF = function(key) {
        this.storage = LocalStorageF(key, "", false);
        this.storage.set = function(value) {
          this.data = value;
          return this.save();
        };
        return this.storage;
      };
      return LocalStorageStringF;
    }
  ];

  angular.module('app').factory('LocalStorageStringF', LocalStorageStringF);

}).call(this);

(function() {
  var LoggerF = function($injector, SessionF, Constants) {
    var LOGGING_LEVEL, ProjectF, TEMPLATE, _currentProjectId, _currentUserInfo, _getMetaInfo, _log;
    _currentProjectId = void 0;
    _currentUserInfo = {};
    ProjectF = null;
    LOGGING_LEVEL = {
      INFO: 'info',
      ERROR: 'error'
    };
    TEMPLATE = {
      ACTION: 'action',
      LEVEL: 'level',
      PAYLOAD: 'payload',
      MESSAGE: 'message'
    };
    LoggerF = {};
    LoggerF.ACTIONS = {
      USER_FETCHED: 'user_fetched',
      PROJECT_LOADED: 'project_loaded',
      ADDED_STOP: 'added_stop',
      UPLOADED_STOPS: 'uploaded_stops',
      ADDED_STOPS_API: 'added_stops_api',
      ADDED_STOPS_CUSTOMER: 'added_stops_customer',
      UPDATED_STOP: 'updated_stop',
      DELETED_STOP: 'deleted_stop',
      UNSCHEDULED_STOP: 'unscheduled_stop',
      DRAGGED_STOP: 'dragged_stop',
      ADDED_DRIVER: 'added_driver',
      UPLOADED_DRIVERS: 'uploaded_drivers',
      UPDATED_DRIVER: 'updated_driver',
      DELETED_DRIVER: 'deleted_driver',
      CHANGED_DRIVER_VISIBILITY: 'changed_driver_visibility',
      CALLED_MIN_IDLE: 'called_min_idle',
      CALLED_FIX: 'called_fix',
      CREATED_ROUTES: 'created_routes',
      UPDATED_ROUTES: 'updated_routes',
      TRIGGERED_OFFLINE: 'triggered_offline',
      TRIGGERED_ONLINE: 'triggered_online',
      CONNECTED_SOCKET: 'connected_socket',
      DISCONNECTED_SOCKET: 'disconnected_socket',
      LOADED_PROJECT: 'loaded_project',
      RELOADED_PROJECT: 'reloaded_project',
      DISCONNECTED_PROJECT: 'disconnected_project',
      CONNECTED_PROJECT: 'connected_project',
      VALIDATED_PROJECT_VERSION: 'validated_project_version',
      CHECK_PROJECT_VERSION: 'check_project_version',
      OPTIMIZE_PROJECT: 'optimize_project',
      OPTIN_BETA: 'optin_beta',
      PROJECT_UPDATE: 'project_update',
      DISPATCH_ROUTE: 'dispatch_route',
      PROJECT_CORRUPTED: 'project_corrupted',
      SESSION_PROJECT_UPDATED: 'session_project_updated',
      SESSION_STOPS_ADDED: 'session_stops_added',
      SESSION_STOPS_GEOCODE_SUCCESS: 'session_stops_geocode_success',
      SESSION_STOPS_GEOCODE_ERROR: 'session_stops_geocode_error',
      DRIVER_MISMATCH_ERROR: 'driver_mismatch_error'
    };
    _getMetaInfo = function() {
      var _ref;
      ProjectF || (ProjectF = $injector.get('ProjectF'));
      return {
        session_id: SessionF.getSessionId(),
        project_id: _currentProjectId,
        user_id: _currentUserInfo.userId,
        user_email: _currentUserInfo.userEmail,
        timestamp: Date.now(),
        project_version: ProjectF != null ? (_ref = ProjectF.project) != null ? _ref.version : void 0 : void 0
      };
    };
    _log = function(obj) {
      if ((typeof _LTracker === "undefined" || _LTracker === null) || !Constants.inProduction) {
        return;
      }
      return _LTracker.push(JSON.stringify(obj));
    };
    LoggerF.info = function(action, payload) {
      var data = _getMetaInfo();
      data[TEMPLATE.LEVEL] = LOGGING_LEVEL.INFO;
      data[TEMPLATE.ACTION] = action;
      data[TEMPLATE.PAYLOAD] = payload;
      return _log(data);
    };
    LoggerF.error = function(action, payload, message) {
      var data = _getMetaInfo();
      data[TEMPLATE.LEVEL] = LOGGING_LEVEL.ERROR;
      data[TEMPLATE.ACTION] = action;
      data[TEMPLATE.PAYLOAD] = payload;
      data[TEMPLATE.MESSAGE] = message;
      return _log(data);
    };
    LoggerF.updateUserInfo = function(newUser) {
      _currentUserInfo.userId = newUser._id;
      return _currentUserInfo.userEmail = newUser.email;
    };
    LoggerF.updateProjectId = function(id) {
      return _currentProjectId = id;
    };
    return LoggerF;
  };
  LoggerF.$inject = ["$injector", "SessionF", "Constants"];

  angular.module('app').factory('LoggerF', LoggerF);

}).call(this);

(function() {
  var NumberUtilF = function() {
    var MAX_LATITUDE, MAX_LONGITUDE, MIN_LATITUDE, MIN_LONGITUDE;
    NumberUtilF = {};
    MAX_LATITUDE = 90;
    MIN_LATITUDE = -90;
    MAX_LONGITUDE = 180;
    MIN_LONGITUDE = -180;
    NumberUtilF.toFloat = function(value, min, max) {
      var floatValue = parseFloat(value);
      if (isNaN(floatValue) || floatValue > max || floatValue < min) {
        return null;
      } else {
        return floatValue;
      }
    };
    NumberUtilF.toLatitude = function(value) {
      return NumberUtilF.toFloat(value, MIN_LATITUDE, MAX_LATITUDE);
    };
    NumberUtilF.toLongitude = function(value) {
      return NumberUtilF.toFloat(value, MIN_LONGITUDE, MAX_LONGITUDE);
    };
    return NumberUtilF;
  };

  angular.module('app').factory('NumberUtilF', NumberUtilF);

}).call(this);

(function() {
  var ProjectTimezoneF = function() {
    var MS_IN_AN_HOUR;
    ProjectTimezoneF = {};
    MS_IN_AN_HOUR = 60 * 1000;
    ProjectTimezoneF.setProjectTimezone = function(timezone) {
      return ProjectTimezoneF.timezone = timezone;
    };
    ProjectTimezoneF.getProjectTimezone = function() {
      return ProjectTimezoneF.timezone;
    };
    ProjectTimezoneF.getCurrentProjectTime = function() {
      var now = new Date().getTime();
      return ProjectTimezoneF.convertToProjectTime(now);
    };
    ProjectTimezoneF.convertToProjectTime = function(utcDate) {
      var date, local, projectTimezoneMins, tzDifference, _ref;
      if (((_ref = ProjectTimezoneF.timezone) != null ? _ref.gmtOffset : void 0) != null) {
        projectTimezoneMins = ProjectTimezoneF.timezone.gmtOffset / MS_IN_AN_HOUR;
        local = new Date(utcDate);
        tzDifference = projectTimezoneMins + local.getTimezoneOffset();
        return date = new Date(local.getTime() + (tzDifference * MS_IN_AN_HOUR));
      } else {
        return date = new Date(utcDate);
      }
    };
    return ProjectTimezoneF;
  };

  angular.module('app').factory('ProjectTimezoneF', ProjectTimezoneF);

}).call(this);

(function() {
  var ProjectsUtil = function() {
    this.formatProjects = function(projects) {
      var project, _i, _len;
      for (_i = 0, _len = projects.length; _i < _len; _i++) {
        project = projects[_i];
        project.vehicleCount || (project.vehicleCount = 0);
        project.visitCount || (project.visitCount = 0);
        project.unservedCount || (project.unservedCount = 0);
        project.distance || (project.distance = 0);
        project.travelTime || (project.travelTime = 0);
        project.name || (project.name = "(Untitled)");
      }
      return projects;
    };
    return this;
  };

  angular.module('app').service('ProjectsUtil', ProjectsUtil);

}).call(this);

(function() {
  var UnservedUtil = function($translate) {
    UnservedUtil.formatReason = function(reason) {
      switch (reason) {
        case 'The lat/lng is too far from the rest of the visits; likely a geocoding error?':
          return "This stop is too far away from your other stops for a driver to serve it.";
        case 'cannot be visited within the constraints':
          return "Not enough available time to fit this stop in.";
        case 'The types do not match with any vehicle.':
          return "This stop's types do not match with any vehicle types.";
        case 'The load is too large for any vehicle.':
          return "Not enough available capacity to fit this stop in.";
        case 'The loads cannot fit in any vehicle.':
          return "Not enough available capacity to fit this stop in.";
        case 'No vehicle available during the specified time windows.':
          return "No vehicle available during this stop’s time window.";
        case 'UNSERVED_MESSAGES.MANUALLY_UNSERVED':
          return 'You manually unscheduled this stop.';
        case 'UNSERVED_MESSAGES.NEW_STOP':
          return 'This stop was newly created, and has not yet been scheduled.';
        case 'UNSERVED_MESSAGES.UNSCHEDULED':
          return 'Not enough available time to fit this stop in.';
        default:
          return $translate.instant(reason);
      }
    };
    UnservedUtil.formatSolution = function(reason) {
      switch (reason) {
        case 'The lat/lng is too far from the rest of the visits; likely a geocoding error?':
          return "UNSERVED_MESSAGES.TOO_FAR_FROM_VISITS";
        case 'cannot be visited within the constraints':
          return "UNSERVED_MESSAGES.NOTE_ENOUGH_TIME_SOLUTION";
        case 'The types do not match with any vehicle.':
          return "UNSERVED_MESSAGES.MATCH_NO_VEHICLES_SOLUTION";
        case 'The load is too large for any vehicle.':
          return "UNSERVED_MESSAGES.NOT_ENOUGH_CAPACITY_SOLUTION";
        case 'The loads cannot fit in any vehicle.':
          return "UNSERVED_MESSAGES.NOT_ENOUGH_LOAD_SOLUTION";
        case 'No vehicle available during the specified time windows.':
          return "UNSERVED_MESSAGES.NO_VEHICLE_AVAILABLE_SOLUTION";
        default:
          return null;
      }
    };
    return UnservedUtil;
  };
  UnservedUtil.$inject = ["$translate"];

  angular.module('app').factory('UnservedUtil', UnservedUtil);

}).call(this);

(function() {
  var UUID = function(uuid4) {
    UUID = {};
    UUID.generate = function() {
      return uuid4.generate().replace(/-/gi, '');
    };
    return UUID;
  };
  UUID.$inject = ["uuid4"];

  angular.module('app').factory('UUID', UUID);

}).call(this);

(function() {
  var ValidatorF = function($q, $translate, Constants, VisitCsvHeaderF, DriverCsvHeaderF, CsvUploadError, GeoIpF, TimeUtilF, SettingsF, AccountF) {
    var CSV_ERROR_MESSAGE, CSV_FILE_EMPTY_ERROR, E164_PHONE_FORMAT, EXCEED_MAX_CSV_ROWS_ERROR, MAX_CSV_ROWS, MIN_DURATION_IN_MINS, ONE_MINUTE_IN_MS, _csvColumnMessageBuilder, _csvMessageBuilder, _isValidDriverLocation, _isValidLocation, _isValidPriority, _isValidTimeStr, _normalizePhoneNumber, _phoneUtil, _rejectWithTranslatedError, _validateCsv;
    ValidatorF = {};
    MIN_DURATION_IN_MINS = Constants.minDurationInMinutes;
    ONE_MINUTE_IN_MS = 60000;
    MAX_CSV_ROWS = 2000;
    CSV_ERROR_MESSAGE = "Sorry – your CSV is not formatted correctly. ";
    CSV_FILE_EMPTY_ERROR = $q.reject(new Error('Sorry – your CSV file is empty.'));
    EXCEED_MAX_CSV_ROWS_ERROR = $q.reject(new Error("Maximum number of rows per CSV upload is " + MAX_CSV_ROWS));
    _phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
    E164_PHONE_FORMAT = libphonenumber.PhoneNumberFormat.E164;
    _normalizePhoneNumber = function(phoneString) {
      var newPhone = phoneString.replace(/[- )(]/g, '');
      return GeoIpF.getCountry().then(function(country) {
        var phoneNumber;
        if (!country) {
          return newPhone;
        }
        phoneNumber = _phoneUtil.parseAndKeepRawInput(newPhone, country);
        if (_phoneUtil.isValidNumber(phoneNumber)) {
          return _phoneUtil.format(phoneNumber, E164_PHONE_FORMAT);
        } else {
          return newPhone;
        }
      })["catch"](function() {
        return newPhone;
      });
    };
    _rejectWithTranslatedError = (function(_this) {
      return function(message, variable) {
        var translatedError = new Error($translate.instant(message, variable ? variable : void 0));
        return $q.reject(translatedError);
      };
    })(this);
    _csvMessageBuilder = function(msg) {
      return $q.reject(new Error(CSV_ERROR_MESSAGE + msg));
    };
    _csvColumnMessageBuilder = function(msg) {
      return $q.reject(new CsvUploadError(CSV_ERROR_MESSAGE + msg));
    };
    _isValidLocation = function(location) {
      return (location != null) && ValidatorF.isString(location.address) && (location.coords != null) && (location.coords.lat != null) && (location.coords.lng != null);
    };
    _isValidDriverLocation = function(location) {
      return (location != null) && _isValidLocation(location.info) && (location.id != null);
    };
    _isValidTimeStr = function(timeStr) {
      var time;
      if (typeof timeStr !== 'string') {
        return false;
      }
      time = TimeUtilF.convertTimeToDate(timeStr);
      return !!time && time <= TimeUtilF.MAX_DATE;
    };
    _isValidPriority = function(val) {
      var _ref;
      if (typeof val !== 'string') {
        return false;
      }
      return (_ref = val.trim().toLowerCase()) === 'yes' || _ref === 'no' || _ref === '';
    };
    ValidatorF.PHONE_REGEXP = /^\+\d+$/;
    ValidatorF.EMAIL_REGEXP = /.+@.+\..+/;
    ValidatorF.isObject = function(entry) {
      return (entry != null) && typeof entry === 'object';
    };
    ValidatorF.isString = function(entry) {
      return entry && typeof entry === 'string';
    };
    ValidatorF.isPhoneNumber = function(entry) {
      var isValid;
      if (!entry.match(ValidatorF.PHONE_REGEXP)) {
        return false;
      } else {
        try {
          entry = _phoneUtil.parse(entry);
          isValid = _phoneUtil.isValidNumber(entry);
        } catch (_error) {
          return false;
        }
      }
      return isValid;
    };
    ValidatorF.isLandline = function(entry) {
      var isValid;
      if (!entry.match(ValidatorF.PHONE_REGEXP)) {
        return false;
      } else {
        try {
          entry = _phoneUtil.parse(entry);
          isValid = _phoneUtil.getNumberType(entry) === libphonenumber.PhoneNumberType.FIXED_LINE;
        } catch (_error) {
          return false;
        }
      }
      return isValid;
    };
    ValidatorF.isEmail = function(entry) {
      return entry.match(ValidatorF.EMAIL_REGEXP);
    };
    ValidatorF.validateVisit = function(entry) {
      var duration, timeWindow, _ref;
      if (!ValidatorF.isObject(entry)) {
        return $q.reject(new Error("Stop must be an object"));
      }
      if (!ValidatorF.isString(entry.id)) {
        return _rejectWithTranslatedError("MESSAGES.ID_ERROR");
      }
      if (!ValidatorF.isString(entry.name)) {
        return _rejectWithTranslatedError("MESSAGES.NAME_ERROR");
      }
      if ((entry.duration != null) && entry.duration < MIN_DURATION_IN_MINS) {
        return _rejectWithTranslatedError("MESSAGES.MIN_DURATION_ERROR", {
          minDuration: Constants.minDurationInMinutes
        });
      }
      if (!!entry.email && !ValidatorF.isEmail(entry.email)) {
        return _rejectWithTranslatedError("MESSAGES.EMAIL_ERROR");
      }
      if (entry.startDate && entry.endDate) {
        timeWindow = entry.endDate.getTime() - entry.startDate.getTime();
        if (timeWindow <= 0) {
          return _rejectWithTranslatedError("MESSAGES.END_BEFORE_START_ERROR");
        }
        duration = entry.duration || ((_ref = SettingsF.settings) != null ? _ref.duration : void 0) || Constants.DEFAULT_DURATION;
        duration = parseInt(duration, 10);
        if ((timeWindow / ONE_MINUTE_IN_MS) < duration) {
          return _rejectWithTranslatedError("MESSAGES.TIME_WINDOW_DURATION_ERROR");
        }
      }
      if (!_isValidLocation(entry.location)) {
        return _rejectWithTranslatedError("MESSAGES.LOCATION_ERROR");
      }
      if (entry.phone) {
        return _normalizePhoneNumber(entry.phone).then(function(normalizedNumber) {
          entry.phone = normalizedNumber;
          if (!ValidatorF.isPhoneNumber(entry.phone) && AccountF.isSmsNotificationOn()) {
            entry.phoneWarning = true;
          }
          if (ValidatorF.isLandline(entry.phone) && AccountF.isSmsNotificationOn()) {
            entry.smsError = true;
          }
          return true;
        });
      }
      return $q.when(true);
    };
    ValidatorF.validateDriver = function(entry) {
      var breakWindow, breaks, brk, missingBreakEnd, missingBreakStart, timeWindow, _i, _len, _ref, _ref1, _ref2, _ref3;
      if (!ValidatorF.isObject(entry)) {
        return $q.reject(new Error("Driver must be an object"));
      }
      if (!ValidatorF.isString(entry.name)) {
        return _rejectWithTranslatedError("MESSAGES.NAME_ERROR");
      }
      if ((((_ref = entry.startLocation) != null ? (_ref1 = _ref.info) != null ? _ref1.coords : void 0 : void 0) == null) || !_isValidDriverLocation(entry.startLocation)) {
        return _rejectWithTranslatedError("MESSAGES.START_LOCATION_ERROR");
      }
      if ((((_ref2 = entry.endLocation) != null ? (_ref3 = _ref2.info) != null ? _ref3.coords : void 0 : void 0) != null) && !_isValidDriverLocation(entry.endLocation)) {
        return _rejectWithTranslatedError("MESSAGES.END_LOCATION_ERROR");
      }
      if (_.isNaN(entry.capacity)) {
        return _rejectWithTranslatedError("MESSAGES.CAPACITY_ERROR_TYPE");
      }
      if ((entry.capacity != null) && entry.capacity <= 0) {
        return _rejectWithTranslatedError("MESSAGES.CAPACITY_ERROR");
      }
      breaks = entry.breaks || [];
      for (_i = 0, _len = breaks.length; _i < _len; _i++) {
        brk = breaks[_i];
        missingBreakStart = !!brk.end && !brk.start;
        missingBreakEnd = !!brk.start && !brk.end;
        if (missingBreakStart || missingBreakEnd) {
          return _rejectWithTranslatedError("MESSAGES.MISSING_LUNCH_BREAK_VALUE");
        }
        breakWindow = brk.end - brk.start;
        if (breakWindow < 0) {
          return _rejectWithTranslatedError("MESSAGES.NEED_BIGGER_LUNCH_BREAK_WINDOW_ERROR");
        }
      }
      if (entry.startShift && entry.endShift) {
        timeWindow = entry.endShift.getTime() - entry.startShift.getTime();
        if (timeWindow <= 0) {
          return _rejectWithTranslatedError("MESSAGES.SHIFT_END_BEFORE_START_ERROR");
        }
      }
      if (entry.phoneNumber) {
        return _normalizePhoneNumber(entry.phoneNumber).then(function(normalizedNumber) {
          entry.phoneNumber = normalizedNumber;
          if (!ValidatorF.isPhoneNumber(entry.phoneNumber)) {
            return _rejectWithTranslatedError("MESSAGES.PHONE_NUMBER_ERROR");
          }
          return true;
        });
      }
      return $q.when(true);
    };
    ValidatorF.validateRoute = function(route) {
      var visit, _i, _len;
      if (!(route && route.constructor === Array)) {
        return $q.reject(new Error("Route must be an array"));
      }
      for (_i = 0, _len = route.length; _i < _len; _i++) {
        visit = route[_i];
        if (!(!visit["break"])) {
          continue;
        }
        if (!ValidatorF.isString(visit.location_id)) {
          return _rejectWithTranslatedError("MESSAGES.ID_ERROR");
        }
        if (!ValidatorF.isString(visit.location_name)) {
          return _rejectWithTranslatedError("MESSAGES.LOCATION_NAME_ERROR");
        }
        if (!_isValidTimeStr(visit.arrival_time)) {
          return _rejectWithTranslatedError("MESSAGES.ARRIVAL_TIME_ERROR");
        }
        if (visit.finish_time && !_isValidTimeStr(visit.finish_time)) {
          return _rejectWithTranslatedError("MESSAGES.FINISH_TIME_ERROR");
        }
      }
      return $q.when(true);
    };
    _validateCsv = function(data, mapping, isStrict) {
      var col, columns, diff, first, headerNames, _i, _len;
      if (!(data.length > 0)) {
        return CSV_FILE_EMPTY_ERROR;
      }
      if (data.length > MAX_CSV_ROWS) {
        return EXCEED_MAX_CSV_ROWS_ERROR;
      }
      first = data[0];
      columns = Object.keys(first);
      if (columns.length < 2) {
        return _csvMessageBuilder("Please make sure Row 1 has column headers filled in. <img src='/img/spreadsheet-good-bad-formatting.png'/>");
      }
      headerNames = _.pluck(mapping, 'mappedCol');
      diff = _.difference(columns, headerNames);
      if (diff.length === columns.length) {
        return _csvColumnMessageBuilder("Missing or invalid header in the file?");
      }
      if (isStrict && diff.length) {
        return _csvColumnMessageBuilder("Unknown columns exist in file");
      }
      for (_i = 0, _len = mapping.length; _i < _len; _i++) {
        col = mapping[_i];
        if (!(col.isOptional || (first[col.mappedCol] != null))) {
          return _csvColumnMessageBuilder("Missing '" + col.name + "' field");
        }
      }
      return $q.when(true);
    };
    ValidatorF.validateDriverCsv = function(data, mapping, isStrict) {
      if (mapping == null) {
        mapping = DriverCsvHeaderF.DEFAULT_COLUMN_MAPPING;
      }
      if (isStrict == null) {
        isStrict = true;
      }
      return _validateCsv(data, mapping, isStrict).then(function() {
        var addressCol, breakEndCol, breakStartCol, first, fromCol, i, latCol, lngCol, speedCol, toCol, visit, visitSpeed, _i, _j, _len, _len1;
        first = data[0];
        addressCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Start Address';
        });
        latCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Start Latitude';
        });
        lngCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Start Longitude';
        });
        if (!((first[addressCol.mappedCol] != null) || ((first[latCol.mappedCol] != null) && (first[lngCol.mappedCol] != null)))) {
          return _csvMessageBuilder("Missing 'Start Address' field");
        }
        fromCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Shift Start';
        });
        toCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Shift End';
        });
        breakStartCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Break Start';
        });
        breakEndCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Break End';
        });
        for (i = _i = 0, _len = data.length; _i < _len; i = ++_i) {
          visit = data[i];
          if (visit[fromCol.mappedCol] && !_isValidTimeStr(visit[fromCol.mappedCol])) {
            return _csvMessageBuilder("'From' time field improperly formated in line " + (i + 2));
          }
          if (visit[toCol.mappedCol] && !_isValidTimeStr(visit[toCol.mappedCol])) {
            return _csvMessageBuilder("'To' time field improperly formated in line " + (i + 2));
          }
          if (visit[breakStartCol.mappedCol] && !_isValidTimeStr(visit[breakStartCol.mappedCol])) {
            return _csvMessageBuilder("'Break Start' time field improperly formated in line " + (i + 2));
          }
          if (visit[breakEndCol.mappedCol] && !_isValidTimeStr(visit[breakEndCol.mappedCol])) {
            return _csvMessageBuilder("'Break End' time field improperly formated in line " + (i + 2));
          }
        }
        speedCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Driving Speed';
        });
        for (i = _j = 0, _len1 = data.length; _j < _len1; i = ++_j) {
          visit = data[i];
          visitSpeed = parseInt(visit[speedCol.mappedCol], 10);
          if (!isNaN(visitSpeed) && (visitSpeed > 190 || visitSpeed < 10)) {
            return _csvMessageBuilder(" 'Driving Speed' must be between 10% and 190% in line " + (i + 2));
          }
        }
        return $q.when(true);
      });
    };
    ValidatorF.validateVisitCsv = function(data, mapping, isStrict) {
      if (mapping == null) {
        mapping = VisitCsvHeaderF.DEFAULT_COLUMN_MAPPING;
      }
      if (isStrict == null) {
        isStrict = true;
      }
      return _validateCsv(data, mapping, isStrict).then(function() {
        var addressCol, first, fromCol, i, latCol, lngCol, priorityCol, toCol, visit, _i, _len;
        first = data[0];
        addressCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Address';
        });
        latCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Latitude';
        });
        lngCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Longitude';
        });
        if (!((first[addressCol.mappedCol] != null) || ((first[latCol.mappedCol] != null) && (first[lngCol.mappedCol] != null)))) {
          return _csvMessageBuilder("Missing 'Address' field");
        }
        priorityCol = _.find(mapping, function(colMap) {
          return colMap.name === 'Priority';
        });
        fromCol = _.find(mapping, function(colMap) {
          return colMap.name === 'From';
        });
        toCol = _.find(mapping, function(colMap) {
          return colMap.name === 'To';
        });
        for (i = _i = 0, _len = data.length; _i < _len; i = ++_i) {
          visit = data[i];
          if (visit[fromCol.mappedCol] && !_isValidTimeStr(visit[fromCol.mappedCol])) {
            return _csvMessageBuilder("'From' time field improperly formated in line " + (i + 2));
          }
          if (visit[toCol.mappedCol] && !_isValidTimeStr(visit[toCol.mappedCol])) {
            return _csvMessageBuilder("'To' time field improperly formated in line " + (i + 2));
          }
          if (visit[priorityCol.mappedCol] && !_isValidPriority(visit[priorityCol.mappedCol])) {
            return _csvMessageBuilder("'Priority' field must be either 'yes' or 'no'");
          }
        }
        return $q.when(true);
      });
    };
    ValidatorF.validateCustomerCsv = function(data, mapping, isStrict) {
      if (mapping == null) {
        mapping = VisitCsvHeaderF.DEFAULT_COLUMN_MAPPING;
      }
      if (isStrict == null) {
        isStrict = true;
      }
      return _validateCsv(data, mapping, isStrict);
    };

    return ValidatorF;
  };
  ValidatorF.$inject = ["$q", "$translate", "Constants", "VisitCsvHeaderF", "DriverCsvHeaderF", "CsvUploadError", "GeoIpF", "TimeUtilF", "SettingsF", "AccountF"];

  angular.module('app').factory('ValidatorF', ValidatorF);

}).call(this);

(function() {
  var     __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  var VisitUtilF = function(Constants, TimeUtilF, Marker) {
    var SKIPPED_DONE_STATUSES, VISIT_STATUS;
    SKIPPED_DONE_STATUSES = [Constants.visitStatusDone, Constants.visitStatusSkipped];
    VISIT_STATUS = {
      VALIDATING: {
        name: 'validating',
        cssClass: 'validating',
        key: 'VISIT_STATUS.VALIDATING'
      },
      INVALID: {
        name: 'invalid',
        cssClass: 'invalid',
        key: 'VISIT_STATUS.INVALID'
      },
      UNSCHEDULED: {
        name: 'unscheduled',
        cssClass: 'unscheduled',
        color: '#53676D',
        key: 'VISIT_STATUS.UNSCHEDULED'
      },
      SCHEDULED: {
        name: 'scheduled',
        cssClass: 'scheduled',
        color: '#b5c4c9',
        key: 'VISIT_STATUS.SCHEDULED'
      },
      COMPLETED_ON_TIME: {
        name: 'on time',
        cssClass: 'on-time',
        color: '#20c989',
        key: 'VISIT_STATUS.COMPLETED_ON_TIME'
      },
      COMPLETED_LATE: {
        name: 'late',
        cssClass: 'late',
        color: '#FFBC00',
        key: 'VISIT_STATUS.COMPLETED_LATE'
      },
      MISSED: {
        name: 'missed',
        cssClass: 'missed',
        color: '#F16466',
        key: 'VISIT_STATUS.MISSED'
      }
    };
    VisitUtilF = {};
    VisitUtilF.VISIT_STATUSES = VISIT_STATUS;
    VisitUtilF.getVisitLateness = function(visitUpdate) {
      var diff, doneDate, expectedDoneDate, expectedDoneTime, lastLog, logs, minsLate;
      minsLate = 0;
      if (visitUpdate.status === Constants.visitStatusDone) {
        expectedDoneTime = visitUpdate.end;
        logs = visitUpdate.log;
        lastLog = logs[logs.length - 1];
        doneDate = new Date(lastLog != null ? lastLog.date : void 0);
        if (expectedDoneTime != null) {
          expectedDoneDate = TimeUtilF.convertTimeToDate(expectedDoneTime, doneDate.getFullYear(), doneDate.getMonth(), doneDate.getDate());
          diff = TimeUtilF.diffMins(doneDate, expectedDoneDate);
          if (diff > 0) {
            minsLate = diff;
          }
        }
      }
      return minsLate;
    };
    VisitUtilF.isDone = function(visit) {
      var _ref;
      return VisitUtilF.isSkippedDoneStatus((_ref = visit.visitStatus) != null ? _ref.status : void 0);
    };
    VisitUtilF.isSkippedDoneStatus = function(status) {
      return (status != null) && (__indexOf.call(SKIPPED_DONE_STATUSES, status) >= 0);
    };
    VisitUtilF.isSkipped = function(status) {
      return (status != null) && status === Constants.visitStatusSkipped;
    };
    VisitUtilF.getVisitServedStatus = function(visit, routeExists, route) {
      var isLate, visitStatus, _ref, _ref1;
      visitStatus = (_ref = visit.visitStatus) != null ? _ref.status : void 0;
      isLate = (_ref1 = visit.visitStatus) != null ? _ref1.isLate : void 0;
      if (visit.status === Marker.Status.Pending) {
        return VISIT_STATUS.VALIDATING;
      }
      if (visit.status === Marker.Status.Invalid) {
        return VISIT_STATUS.INVALID;
      }
      if (!routeExists) {
        return VISIT_STATUS.UNSCHEDULED;
      }
      switch (visitStatus) {
        case Constants.visitStatusDone:
          if (isLate) {
            return VISIT_STATUS.COMPLETED_LATE;
          } else {
            return VISIT_STATUS.COMPLETED_ON_TIME;
          }
          break;
        case Constants.visitStatusSkipped:
          return VISIT_STATUS.MISSED;
        default:
          if ((route != null ? route.unserved[visit.id] : void 0) != null) {
            return VISIT_STATUS.UNSCHEDULED;
          } else {
            return VISIT_STATUS.SCHEDULED;
          }
      }
    };
    return VisitUtilF;
  };
  VisitUtilF.$inject = ["Constants", "TimeUtilF", "Marker"];

  angular.module('app').factory('VisitUtilF', VisitUtilF);

}).call(this);

(function() {
  var VisitC = function($q, $scope, $state, $previousState, $filter, $timeout, $translate, $rootScope, MessagingF, UploadF, VisitUploadF, ConfirmF, Marker, RouteS, GMarkerF, MarkersF, SettingsF, ValidatorF, TypeF, VisitCsvHeaderF, TimeUtilF, States, DispatchF, ProjectF, DispatchStatusF, EventListenersF, Events, VisitGridApiF, VisitUtilF, AnalyticsS, OnboardingF, RouteHistoryF, VisitF, AccountF, Constants, AddressCheckerS, CustomerNotificationF, LoggerF, RouteInspectorF, UnservedUtil) {
    var ROUTE_STATE, VISIT_LIST_STATE, _addContactColumn, _addVisitsToSelection, _canProceedSaving, _clearActions, _getFilterKey, _getNumMissingContactVisits, _getNumMultipleAddressesVisits, _getTimeEntry, _getVisitEntry, _goToPreviousOrDefaultState, _goToState, _hasEditChanges, _infoChanges, _initializeEntry, _isInfoChange, _isResetChange, _originalEntry, _ref, _resetPhoneValidityStatus, _resetSelectedVisits, _resetableChanges, _routeAlterStates, _setSelected, _showInvalidVisitsIfAny, _showMissingContactIfAny, _showMultipleAddressesIfAny, _showRouteProgressInfo;
    _routeAlterStates = [States.projectVisitsEdit, States.projectVisitsCreate, States.projectVisitsUpload];
    _resetableChanges = ['location', 'startDate', 'endDate', 'duration', 'load', 'types', 'isPriority'];
    _infoChanges = ['name', 'phone', 'email', 'notes', 'notes2', 'customNotes'];
    _originalEntry = null;
    this.user = AccountF.getUser();
    this.isTrial = ((_ref = this.user) != null ? _ref.status : void 0) === 'trial';
    this.timePickerConfig = Constants.timePickerConfig;
    this.maxHours = TimeUtilF.MAX_HOURS;
    this.maxDate = TimeUtilF.MAX_DATE;
    _showRouteProgressInfo = function() {
      MessagingF.replaceInfoPopup("MESSAGES.ROUTING_IN_PROGRESS");
    };
    _initializeEntry = function(entry) {
      this.entry = entry || {};
      return _originalEntry = _.cloneDeep(this.entry);
    };
    _setSelected = function(entry, isSelected) {
      return GMarkerF.setSelected(entry.id, isSelected);
    };
    _hasEditChanges = (function(_this) {
      return function() {
        var _ref1, _ref2;
        if (((_ref1 = _this.quickAddStopsModel) != null ? _ref1.name : void 0) || ((_ref2 = _this.quickAddStopsModel) != null ? _ref2.location : void 0)) {
          return true;
        }
      };
    })(this);
    _isInfoChange = function(entry) {
      var newValue, original, property, _i, _len;
      for (_i = 0, _len = _infoChanges.length; _i < _len; _i++) {
        property = _infoChanges[_i];
        newValue = entry[property];
        original = _originalEntry[property];
        if (property === 'customNotes' && Object.keys(newValue).length === 0 && Object.keys(original).length === 0) {
          continue;
        } else if (!newValue && !original) {
          continue;
        }
        switch (property) {
          case 'customNotes':
            if (!angular.equals(newValue, original)) {
              return true;
            }
            break;
          default:
            if (newValue !== original) {
              return true;
            }
        }
      }
      return false;
    };
    _isResetChange = function(entry) {
      var newValue, original, property, val, _i, _j, _len, _len1, _ref1, _ref2, _ref3, _ref4;
      for (_i = 0, _len = _resetableChanges.length; _i < _len; _i++) {
        property = _resetableChanges[_i];
        newValue = entry[property];
        original = _originalEntry[property];
        if (!newValue && !original) {
          continue;
        }
        switch (property) {
          case 'location':
            if (((newValue != null) !== (original != null)) || (((_ref1 = newValue.coords) != null ? _ref1.lat : void 0) !== ((_ref2 = original.coords) != null ? _ref2.lat : void 0)) || (((_ref3 = newValue.coords) != null ? _ref3.lng : void 0) !== ((_ref4 = original.coords) != null ? _ref4.lng : void 0))) {
              return true;
            }
            break;
          case 'types':
            if (((newValue != null ? newValue.length : void 0) || 0) !== ((original != null ? original.length : void 0) || 0)) {
              return true;
            }
            if (newValue != null) {
              for (_j = 0, _len1 = newValue.length; _j < _len1; _j++) {
                val = newValue[_j];
                if (!_.contains(original, val)) {
                  return true;
                }
              }
            }
            break;
          case 'startDate':
          case 'endDate':
            if (!newValue || !original || (newValue.getTime() !== original.getTime())) {
              return true;
            }
            break;
          default:
            if (newValue !== original) {
              return true;
            }
        }
      }
      return false;
    };
    _goToPreviousOrDefaultState = (function(_this) {
      return function() {
        var _ref1;
        if (!_hasEditChanges) {
          _this.quickCreateVisits = [];
        }
        if ((_ref1 = $previousState.get(_this.previousState)) != null ? _ref1.state : void 0) {
          return $previousState.go(_this.previousState);
        } else {
          return $state.go(VISIT_LIST_STATE);
        }
      };
    })(this);
    _getTimeEntry = function(visit) {
      var endTime, startTime, time;
      time = '';
      startTime = $filter('multiDay')(visit.startDate);
      endTime = $filter('multiDay')(visit.endDate);
      if (startTime) {
        time += "" + startTime;
      }
      time += " - ";
      if (endTime) {
        time += "" + endTime;
      }
      return time;
    };
    _getVisitEntry = (function(_this) {
      return function(visit) {
        var visitEntry;
        var status = _this.getVisitServedStatus(visit);
        visitEntry = {
          Name: visit.name,
          Address: visit.location.address,
          Time: _getTimeEntry(visit),
          Info: "i",
          Status: $translate.instant(status.key),
          Class: status.cssClass,
          visit: visit,
          errorStatus: visit.status
        };
        return visitEntry;
      };
    })(this);
    _goToState = function(visit, event, targetState) {
      if (event) {
        event.stopPropagation();
      }
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      return $state.go(targetState, {
        visitID: visit.id
      });
    };
    _getNumMissingContactVisits = (function(_this) {
      return function() {
        if (_this.shouldShowEmailNotificationWarning) {
          return VisitF.getMissingEmailVisits().length;
        } else if (_this.shouldShowSmsNotificationWarning) {
          return VisitF.getInvalidPhoneVisits().length;
        }
      };
    })(this);
    _getNumMultipleAddressesVisits = function() {
      return VisitF.getMultipleAddressesVisits().length;
    };
    _getFilterKey = (function(_this) {
      return function() {
        if (_this.shouldShowEmailNotificationWarning) {
          return VisitGridApiF.filterSymbols.missingEmail;
        } else if (_this.shouldShowSmsNotificationWarning) {
          return VisitGridApiF.filterSymbols.invalidPhone;
        }
        return void 0;
      };
    })(this);
    _resetPhoneValidityStatus = function(formValid, entry) {
      if (formValid) {
        entry.phoneWarning = void 0;
        return entry.smsError = void 0;
      } else {
        return entry.phoneModified = false;
      }
    };
    _canProceedSaving = function(formCtrl) {
      var _isPhoneNumberError;
      _isPhoneNumberError = function(errorObj) {
        var currentError, _i, _len, _ref1;
        _ref1 = errorObj.pattern;
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          currentError = _ref1[_i];
          if (currentError.$name !== 'phone') {
            return false;
          }
        }
        return true;
      };
      if (!formCtrl.$valid) {
        if (Object.keys(formCtrl.$error).length > 1) {
          return false;
        } else if (!_isPhoneNumberError(formCtrl.$error)) {
          return false;
        }
      }
      return true;
    };
    VISIT_LIST_STATE = States.projectVisitsList;
    ROUTE_STATE = States.projectRoute;
    this.previousState = 'visitPrevious';
    this.shouldShowEmailNotificationWarning = AccountF.isEmailNotificationOn();
    this.shouldShowSmsNotificationWarning = AccountF.isSmsNotificationOn();
    this.numVisitsMissingContact = _getNumMissingContactVisits();
    this.numMultipleAddressesVisits = _getNumMultipleAddressesVisits();
    this.isShowMissingContact = false;
    this.isShowMultipleAddresses = false;
    this.customNotesList = VisitCsvHeaderF.columns;
    this.gridApiManager = VisitGridApiF;
    this.gridApi = VisitGridApiF.getGridApi;
    this.quickCreateVisits = [];
    this.visitSelections = [];
    this.allSelectedInView = false;
    this.selectDeselectText = 'Select';
    this.phoneChanged = false;
    this.rowTemplate = "<div tooltip-d=\"This stop cannot be edited because it belongs to a locked route.\" can-show=\"grid.appScope.isVisitLocked(row.entity.visit.id)\" ng-class='{\"locked-visit\": grid.appScope.isVisitLocked(row.entity.visit.id)}' > <div ng-repeat='col in colContainer.renderedColumns track by col.colDef.name' class='ui-grid-cell' ui-grid-cell></div> </div>";
    _clearActions = function() {
      RouteS.clear();
      VisitF.deleteAll();
      DispatchF.deleteAll();
      VisitGridApiF.setFilter('');
      OnboardingF.startTourForState($state.current.name);
      return EventListenersF.notify(Events.PROJECT_MODIFIED);
    };
    this.notifyPhoneChange = function() {
      if (!DispatchStatusF.hasDispatches()) {
        return;
      }
      if (!this.entry.phoneModified) {
        return this.entry.phoneModified = true;
      }
    };
    this.getListData = function() {
      var visit, visits;
      visits = VisitF.getVisits();
      return (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          visit = visits[_i];
          _results.push(_getVisitEntry(visit));
        }
        return _results;
      })();
    };
    this.colDefs = [
      {
        field: 'Select',
        displayName: '',
        cellClass: 'grid-cell',
        cellTemplate: 'cells/visitSelectCell.html',
        width: "6%"
      }, {
        field: 'Name',
        displayName: $translate.instant("STOP_INFO.NAME"),
        cellClass: 'grid-cell',
        cellTemplate: 'cells/visitNameCell.html',
        width: "15%"
      }, {
        field: 'Address',
        displayName: $translate.instant("STOP_INFO.ADDRESS"),
        cellClass: 'grid-cell',
        cellTemplate: 'cells/visitAddressCell.html',
        width: "22%"
      }, {
        field: 'Time',
        displayName: $translate.instant("STOP_INFO.TIME"),
        cellClass: 'grid-cell',
        cellTemplate: 'cells/visitTimeCell.html',
        width: "14%"
      }, {
        field: 'Info',
        displayName: '',
        cellClass: 'grid-cell',
        cellTemplate: 'cells/visitInfoCell.html',
        enableSorting: false,
        width: "6%"
      }, {
        field: 'Status',
        displayName: $translate.instant("STOP_INFO.STATUS"),
        cellClass: 'grid-cell',
        cellTemplate: 'cells/visitStatusCell.html',
        width: "12%"
      }, {
        field: 'Actions',
        cellClass: 'grid-cell',
        displayName: '',
        cellTemplate: 'cells/visitActionCell.html',
        enableSorting: false
      }
    ];
    _addContactColumn = (function(_this) {
      return function() {
        var contactFields, template;
        if (AccountF.shouldHideCustomerNotificationUi()) {
          return;
        }
        template = void 0;
        if (AccountF.isEmailNotificationOn()) {
          template = 'cells/visitEmailCell.html';
        } else if (AccountF.isSmsNotificationOn()) {
          template = 'cells/visitPhoneCell.html';
        }
        contactFields = {
          field: 'Contact',
          displayName: $translate.instant("STOP_INFO.CONTACT_INFO"),
          cellClass: 'grid-cell',
          cellTemplate: template,
          width: "17%"
        };
        return _this.colDefs.splice(5, 0, contactFields);
      };
    })(this);
    _addContactColumn();
    this.isVisitLocked = function(visitId) {
      return RouteS.isVisitLocked(visitId);
    };
    this.getList = function() {
      return VisitF.getVisits();
    };
    this.getListUnserved = function(length) {
      var a, i, item, unservedGroups, unservedReasons, visit, visits, warningKey, warnings;
      if (length) {
        return RouteS.getNumUnserved();
      }
      visits = null;
      visits = VisitF.getVisits();
      unservedReasons = [];
      for (i in visits) {
        visit = visits[i];
        visit.reason = null;
        visit.hide = null;
        visit.reasonTitle = null;
        visit.selected = GMarkerF.getSelected(visit.id);
        visit.markerId = GMarkerF.getSelectedText(visit.id);
        warnings = RouteInspectorF.getWarnings(visit.id);
        warningKey = warnings != null ? warnings[0].key : void 0;
        visit.reason = (warnings != null ? warnings[0].description : void 0) ? warnings != null ? warnings[0].description : void 0 : visit.reason = UnservedUtil.formatReason(warningKey);
        visit.newStop = (warnings != null ? warnings[0].key : void 0) === "UNSERVED_MESSAGES.NEW_STOP";
        if (visit.reason && warningKey !== "WARNINGS.LATE_FINISH" && warningKey !== "WARNINGS.EARLY_ARRIVAL" && warningKey !== "WARNINGS.UNSUPPORTED_TYPES") {
          if (unservedReasons.indexOf(visit.reason) === -1) {
            unservedReasons.push(visit.reason);
            visit.reasonTitle = visit.reason;
          }
        } else {
          visit.hide = true;
        }
      }
      unservedGroups = visits.reduce((function(r, a) {
        if (a.reason) {
          r[a.reason] = [].concat(r[a.reason] || [], [a]);
        }
        return r;
      }), {});
      for (i in unservedGroups) {
        item = unservedGroups[i];
        for (a in visits) {
          visit = visits[a];
          if (visit.reasonTitle === i) {
            visit.reasonLength = unservedGroups[i].length;
          }
        }
      }
      return visits;
    };
    this.getVisitServedStatus = function(visit) {
      return VisitUtilF.getVisitServedStatus(visit, RouteS.hasRoute(), RouteS.getRoute());
    };
    this.goToUpload = function() {
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      if (VisitUploadF.inProgress) {
        MessagingF.replaceInfo("MESSAGES.CSV_UPLOAD_IN_PROGRESS");
        return;
      }
      return $state.go(States.projectVisitsUpload);
    };
    this.goToCreate = function() {
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      return $state.go(States.projectVisitsCreate);
    };
    this.goToQuickadd = function() {
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      return $state.go(States.projectVisitsQuickadd);
    };
    this.goToAddFromCustomerProfile = function() {
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      return $state.go(States.modalCustomerProfile);
    };
    this.goToEdit = function(visit, event) {
      var promise = _goToState(visit, event, States.projectVisitsEdit);
      if (promise) {
        return promise.then(function() {
          return AnalyticsS.track('026 Edit stop');
        });
      }
    };
    this.goToDuplicate = function(visit, event) {
      var promise = _goToState(visit, event, States.projectVisitsDuplicate);
      if (promise) {
        return promise.then(function() {
          return AnalyticsS.track('026 Edit stop');
        });
      }
    };
    this.goToAddressChecker = function(visit, event) {
      var promise, _ref1, _ref2;
      if ((_ref1 = (_ref2 = visit.visitStatus) != null ? _ref2.status : void 0) === 'done' || _ref1 === 'skipped') {
        return;
      }
      promise = _goToState(visit, event, States.modalVisitChecker);
      if (promise) {
        return promise.then(function() {
          return AnalyticsS.track('0002_WEB_UI address checker opened');
        });
      }
    };
    this.quickCreate = function(formCtrl, entry, addressCtrl) {
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      if (addressCtrl && !addressCtrl.$valid) {
        AddressCheckerS.check(addressCtrl.$viewValue).then(function(newLoc) {
          var _ref1, _ref2;
          return (_ref1 = $scope.visit) != null ? (_ref2 = _ref1.entry) != null ? _ref2.location = newLoc : void 0 : void 0;
        });
      }
      if (!_canProceedSaving(formCtrl)) {
        return;
      }
      return VisitF.addVisit(entry).then((function(_this) {
        return function(visit) {
          if (RouteS.hasRoute()) {
            RouteS.addVisitAsUnserved(visit).then(function() {
              return EventListenersF.notify(Events.PROJECT_MODIFIED);
            }).then(function() {
              return _this.toggleInfoWindow(visit);
            });
          } else {
            EventListenersF.notify(Events.PROJECT_MODIFIED);
          }
          VisitF.updateValidVisits();
          LoggerF.info(LoggerF.ACTIONS.ADDED_STOP, entry);
          _initializeEntry();
          TypeF.addTypes(visit.types);
          MarkersF.fitToPoints();
          AnalyticsS.track('106 Quick add a stop', visit);
          _showMissingContactIfAny();
          _this.quickCreateVisits.push(visit);
          MessagingF.replaceSuccessPopup("MESSAGES.SINGLE_STOP_ADDED", {
            name: visit.name
          });
          _this.quickAddStopsModel = {};
          document.querySelector(".quickadd-address input").value = '';
          formCtrl.$setPristine();
          return formCtrl.$setUntouched();
        };
      })(this))["catch"](function(err) {
        return LoggerF.error(LoggerF.ACTIONS.ADDED_STOP, entry, err);
      });
    };
    this.create = function(formCtrl, entry, addressCtrl) {
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      if (addressCtrl && !addressCtrl.$valid) {
        AddressCheckerS.check(addressCtrl.$viewValue).then(function(newLoc) {
          var _ref1, _ref2;
          return (_ref1 = $scope.visit) != null ? (_ref2 = _ref1.entry) != null ? _ref2.location = newLoc : void 0 : void 0;
        });
      }
      if (!_canProceedSaving(formCtrl)) {
        return;
      }
      return VisitF.addVisit(entry).then((function(_this) {
        return function(visit) {
          if (RouteS.hasRoute()) {
            RouteS.addVisitAsUnserved(visit).then(function() {
              return EventListenersF.notify(Events.PROJECT_MODIFIED);
            }).then(function() {
              return _this.toggleInfoWindow(visit);
            });
          } else {
            EventListenersF.notify(Events.PROJECT_MODIFIED);
          }
          VisitF.updateValidVisits();
          LoggerF.info(LoggerF.ACTIONS.ADDED_STOP, entry);
          _initializeEntry();
          TypeF.addTypes(visit.types);
          MarkersF.fitToPoints();
          AnalyticsS.track('025 Add a stop', visit);
          _showMissingContactIfAny();
          return _goToPreviousOrDefaultState();
        };
      })(this))["catch"](function(err) {
        return LoggerF.error(LoggerF.ACTIONS.ADDED_STOP, entry, err);
      });
    };
    this.getNumVisits = function() {
      return VisitF.getVisits().length;
    };
    this.getNumUnservedVisits = function() {
      return this.getListUnserved(true);
    };
    this.getNumInvalidVisits = function() {
      return VisitF.getInvalidVisits().length;
    };
    this.cancel = (function(_this) {
      return function() {
        AnalyticsS.track('076 Cancel stop form');
        return _goToPreviousOrDefaultState();
      };
    })(this);
    this.clear = (function(_this) {
      return function() {
        var _ref1;
        if (_this.getNumVisits() === 0) {
          return;
        }
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        if (ProjectF.isDispatchedProject()) {
          MessagingF.replaceWarning("MESSAGES.UNABLE_CLEAR_LIVE_ROUTE_STOPS");
          return;
        }
        if (((_ref1 = RouteHistoryF.seek()) != null ? _ref1.numLocks : void 0) > 0) {
          return MessagingF.replaceConfirm("MESSAGES.DELETE_ALL_STOPS_CONTAIN_LOCK ", null, null, "Confirm deletion", _clearActions);
        } else {
          return ConfirmF.confirm("MESSAGES.DELETE_ALL_STOPS_CONFIRMATION").then(function() {
            return _clearActions();
          });
        }
      };
    })(this);
    this.projectHasPassed = ProjectF.isPastProject();
    this.removeVisit = function(visit, event, quickAdd) {
      var hasDispatches, isNotificationEnabled, preRequestProjectVersion, project, promise, quickAddList, __removeVisit;
      if (event) {
        event.stopPropagation();
      }
      quickAddList = this.quickCreateVisits;
      AnalyticsS.track('027 Delete stop');
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return;
      }
      if (ProjectF.isBusy) {
        return MessagingF.replaceError("MESSAGES.PROJECT_BUSY_ERROR");
      }
      preRequestProjectVersion = ProjectF.project.version;
      hasDispatches = DispatchStatusF.hasDispatches();
      __removeVisit = function() {
        var promise;
        var date = ProjectF.project.date;
        VisitF.removeVisit(visit.id);
        VisitF.updateValidVisits();
        promise = null;
        if (RouteS.hasRoute()) {
          promise = EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS).then(function() {
            return RouteS.removeStop(visit, date);
          });
        } else {
          promise = $q.when(true);
        }
        return promise;
      };
      if (VisitUtilF.isDone(visit)) {
        return MessagingF.replaceError("MESSAGES.UNABLE_DELETE_SERVED_STOP");
      }
      if (hasDispatches) {
        isNotificationEnabled = AccountF.hasCustomerNotification() && AccountF.isCancelledNotificationOn();
        project = ProjectF.project;
        if (DispatchF.isNotifiedStop(visit.id) && isNotificationEnabled) {
          promise = ConfirmF.notificationDeleteWarning().then(function() {
            return ConfirmF.notificationDeleteConfirm();
          }).then(__removeVisit).then(function() {
            return DispatchF.dispatchDrivers(project);
          }).then(function() {
            return CustomerNotificationF.sendCancellation(project.id, visit);
          });
        } else {
          promise = ConfirmF.notificationDeleteConfirm().then(__removeVisit).then(function() {
            return DispatchF.dispatchDrivers(project);
          });
        }
      } else {
        promise = ConfirmF.confirm("MESSAGES.REMOVE_VISIT_CONFIRMATION").then(__removeVisit);
      }
      return promise.then(function() {
        var postRequestProjectVersion = ProjectF.project.version;
        if (preRequestProjectVersion !== postRequestProjectVersion) {
          LoggerF.error(LoggerF.ACTIONS.DELETED_STOP, {
            projectId: project.id,
            preRequestVersion: preRequestProjectVersion,
            postRequestVersion: postRequestProjectVersion
          }, 'Project was updated while waiting for stop delete to complete');
          EventListenersF.notify(Events.PROJECT_VERSION_MISMATCH);
          return $q.reject();
        }
      }).then(function() {
        AnalyticsS.track("Remove Visit");
        if (RouteS.hasRoute()) {
          return RouteS.resetRoutesToCurrent();
        }
      }).then(function() {
        var setDispatchedSolution;
        return EventListenersF.notify(Events.PROJECT_MODIFIED, setDispatchedSolution = hasDispatches);
      }).then(function() {
        var i, item;
        LoggerF.info(LoggerF.ACTIONS.DELETED_STOP, visit);
        _resetSelectedVisits();
        if ($state.current.name === VISIT_LIST_STATE || $state.includes(ROUTE_STATE)) {
          return;
        }
        _showMissingContactIfAny();
        if (quickAdd) {
          AnalyticsS.track('107 Delete quick add stop');
          for (i in quickAddList) {
            item = quickAddList[i];
            if (item.id === visit.id) {
              quickAddList.splice(i, 1);
            }
          }
          return this.quickCreateVisits = quickAddList;
        } else {
          return _goToPreviousOrDefaultState();
        }
      })["catch"](function(err) {
        if (((err != null ? err.message : void 0) != null) || ((err != null ? err.error : void 0) != null)) {
          MessagingF.replaceError(err.message || err.error);
        }
        return LoggerF.error(LoggerF.ACTIONS.DELETED_STOP, visit, err);
      })["finally"](function() {
        return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
      });
    };
    _addVisitsToSelection = (function(_this) {
      return function(visit) {
        if (visit.isSelected) {
          if (!_this.visitSelections.includes(visit)) {
            return _this.visitSelections.push(visit);
          }
        } else {
          return _this.visitSelections = _this.visitSelections.filter(function(item) {
            return item.id !== visit.id;
          });
        }
      };
    })(this);
    this.selectVisit = (function(_this) {
      return function(visit) {
        visit.isSelected = visit.isSelected ? false : true;
        return _addVisitsToSelection(visit);
      };
    })(this);
    this.selectAllInView = (function(_this) {
      return function() {
        var i, visit, visits, _results;
        _this.allSelectedInView = _this.allSelectedInView ? true : false;
        visits = VisitGridApiF.getInViewVisits();
        _results = [];
        for (i in visits) {
          visit = visits[i];
          visit = visit.entity.visit;
          visit.isSelected = _this.allSelectedInView;
          _results.push(_addVisitsToSelection(visit));
        }
        return _results;
      };
    })(this);
    this.selectAllVisits = (function(_this) {
      return function() {
        var i, visit, visits, _results;
        _this.allSelected = _this.allSelected ? false : true;
        visits = VisitF.getVisits();
        if (_this.allSelected) {
          _this.selectDeselectText = 'Deselect';
          _this.allSelectedInView = true;
        } else {
          _this.selectDeselectText = 'Select';
          _this.allSelectedInView = false;
        }
        _results = [];
        for (i in visits) {
          visit = visits[i];
          visit.isSelected = _this.allSelected;
          _results.push(_addVisitsToSelection(visit));
        }
        return _results;
      };
    })(this);
    this.showDeleteVisits = (function(_this) {
      return function() {
        return _this.visitSelections.length;
      };
    })(this);
    this.selectVisitsDisabled = (function(_this) {
      return function() {
        return ProjectF.isDispatchedProject();
      };
    })(this);
    this.removeSelectedVisits = (function(_this) {
      return function() {
        var date, hasLockedRoutes, i, promise, visit, visits, __removeVisits, _ref1;
        visits = _this.visitSelections;
        hasLockedRoutes = false;
        date = ProjectF.project.date;
        __removeVisits = function() {
          var i, promise, visit;
          for (i in visits) {
            visit = visits[i];
            VisitF.removeVisit(visit.id);
            VisitF.updateValidVisits();
          }
          promise = null;
          if (RouteS.hasRoute()) {
            promise = EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS).then(function() {
              return RouteS.removeStop(visits, date);
            });
          } else {
            promise = $q.when(true);
          }
          return promise;
        };
        if (ProjectF.isDispatchedProject()) {
          MessagingF.replaceWarning("MESSAGES.UNABLE_CLEAR_LIVE_ROUTE_STOPS");
          return;
        }
        if (RouteS.isInProgress()) {
          _showRouteProgressInfo();
          return;
        }
        if (ProjectF.isBusy) {
          return MessagingF.replaceError("MESSAGES.PROJECT_BUSY_ERROR");
        }
        if (((_ref1 = RouteHistoryF.seek()) != null ? _ref1.numLocks : void 0) > 0) {
          for (i in visits) {
            visit = visits[i];
            if (_this.isVisitLocked(visit.id)) {
              hasLockedRoutes = true;
              break;
            }
          }
        }
        if (hasLockedRoutes) {
          promise = ConfirmF.confirmWarning($translate.instant("Some of these stops are on locked routes. Are you sure you wish to delete them?"), '', $translate.instant("Cancel"), $translate.instant("CUSTOMER_MESSAGES.CONFIRM_DELETION")).then(__removeVisits);
        } else {
          promise = $q.when(true).then(__removeVisits);
        }
        return promise.then(function() {
          if (visits.length < 2) {
            MessagingF.replaceSuccessPopup("STOP_INFO.DELETE_SINGLE_STOP_MESSAGE", {
              stops: visits.length
            });
          } else {
            MessagingF.replaceSuccessPopup("STOP_INFO.DELETE_MULTIPLE_STOPS_MESSAGE", {
              stops: visits.length
            });
          }
          _resetSelectedVisits();
          VisitGridApiF.setFilter('');
          AnalyticsS.track("110 Remove Batch Visits", {
            '#removedVisits': visits.length
          });
          if (RouteS.hasRoute()) {
            return RouteS.resetRoutesToCurrent();
          }
        }).then(function() {
          return EventListenersF.notify(Events.PROJECT_MODIFIED);
        })["catch"](function(err) {
          if (((err != null ? err.message : void 0) != null) || ((err != null ? err.error : void 0) != null)) {
            MessagingF.replaceError(err.message || err.error);
          }
          return LoggerF.error(LoggerF.ACTIONS.DELETED_STOP, visits, err);
        })["finally"](function() {
          return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
        });
      };
    })(this);
    _resetSelectedVisits = (function(_this) {
      return function() {
        var i, visit, visits;
        visits = VisitF.getVisits();
        for (i in visits) {
          visit = visits[i];
          visit.isSelected = false;
        }
        _this.visitSelections = [];
        return _this.allSelectedInView = false;
      };
    })(this);
    this.updateVisit = function(formCtrl, visit, addressCtrl, fromListView) {
      var _canRedispatch, _needRefetchRoute, _refetchRoute;
      if (fromListView == null) {
        fromListView = true;
      }
      if (RouteS.isInProgress()) {
        _showRouteProgressInfo();
        return $q.reject();
      }
      if (addressCtrl && !addressCtrl.$valid) {
        AddressCheckerS.check(addressCtrl.$viewValue).then(function(newLoc) {
          var _ref1, _ref2;
          return (_ref1 = $scope.visit) != null ? (_ref2 = _ref1.entry) != null ? _ref2.location = newLoc : void 0 : void 0;
        });
      }
      if (!_canProceedSaving(formCtrl)) {
        return $q.reject();
      }
      _resetPhoneValidityStatus(formCtrl.$valid, this.entry);
      _needRefetchRoute = false;
      _refetchRoute = $q.when(true);
      if (!RouteS.isUnservedVisit(visit) && RouteS.hasRoute()) {
        if (_isResetChange(visit)) {
          _refetchRoute = ConfirmF.confirm("MESSAGES.CLEAR_HISTORY_CONFIRMATION").then(function() {
            return _needRefetchRoute = true;
          });
        }
        if (_isInfoChange(visit)) {
          _canRedispatch = true;
        }
      }
      return _refetchRoute.then(function() {
        return VisitF.updateVisit(visit);
      }).then(function() {
        VisitF.updateValidVisits();
        if (_needRefetchRoute) {
          return EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS).then(function() {
            return RouteS.reoptimizeDriverWithStop(visit);
          });
        }
        if (_canRedispatch) {
          RouteS.updateRouteVisit(visit);
        }
        return $q.when(true);
      }).then(function() {
        if (_needRefetchRoute) {
          RouteS.resetRoutesToCurrent();
        }
        if (_isInfoChange(visit) || _isResetChange(visit)) {
          $rootScope.$broadcast('ganttInfoChanged');
        }
        return EventListenersF.notify(Events.PROJECT_MODIFIED);
      }).then(function() {
        _initializeEntry();
        if ($state.includes(VISIT_LIST_STATE)) {
          MarkersF.fitToPoints();
        }
        if (VisitF.getInvalidVisits().length <= 0) {
          VisitGridApiF.setFilter('');
        }
        _showMultipleAddressesIfAny();
        _showMissingContactIfAny();
        if (fromListView) {
          _goToPreviousOrDefaultState();
        }
        MessagingF.replaceSuccessPopup("MESSAGES.GENERIC_UPDATE_SUCCESS", {
          name: visit.name
        });
        return LoggerF.info(LoggerF.ACTIONS.UPDATED_STOP, visit);
      })["catch"](function(err) {
        if (err != null ? err.message : void 0) {
          MessagingF.replaceError(err.message);
        }
        LoggerF.error(LoggerF.ACTIONS.UPDATED_STOP, visit, err);
        return $q.reject();
      })["finally"](function() {
        return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
      });
    };
    this.isVisitDone = VisitUtilF.isDone;
    this.isSkipped = function(visit) {
      var _ref1;
      return VisitUtilF.isSkipped((_ref1 = visit.visitStatus) != null ? _ref1.status : void 0);
    };
    this.isPending = function(visit) {
      return visit.status === Marker.Status.Pending;
    };
    this.isValidated = function(visit) {
      return visit.status === Marker.Status.Validated || visit.status === Marker.Status.Valid;
    };
    this.isAmbiguous = function(visit) {
      var _ref1, _ref2;
      return ((_ref1 = visit.location) != null ? _ref1.num_results : void 0) > 1 || (((_ref2 = visit.location) != null ? _ref2.all_results : void 0) != null);
    };
    this.highlight = function(visit) {
      return _setSelected(visit, true);
    };
    this.unhighlight = function(visit) {
      return _setSelected(visit, false);
    };
    this.toggleInfoWindow = function(visit) {
      return GMarkerF.toggleAndCloseOtherWindow(visit.id);
    };
    this.toggleUnservedClick = function(visit) {
      GMarkerF.toggleAndCloseOtherWindow(visit.id);
      return GMarkerF.setSelected(visit.id, true);
    };
    this.getTimeWindowDuration = (function(_this) {
      return function() {
        return TimeUtilF.compareDates(_this.entry.endDate, _this.entry.startDate);
      };
    })(this);
    this.hideInvalidViewMessage = function() {
      VisitGridApiF.setFilter("invalid");
      return this.isShowInvalidView = false;
    };
    this.condenseErrorMessage = function(error) {
      switch (error) {
        case $translate.instant("MESSAGES.NAME_ERROR"):
          return 'NAME_ERROR';
        case $translate.instant("MESSAGES.ARRIVAL_TIME_ERROR"):
        case $translate.instant("MESSAGES.FINISH_TIME_ERROR"):
        case $translate.instant("MESSAGES.END_BEFORE_START_ERROR"):
        case $translate.instant("MESSAGES.TIME_WINDOW_DURATION_ERROR"):
          return "TIME_ERROR";
        case $translate.instant("MESSAGES.ADDRESS_NOT_PROVIDED"):
          return "ADDRESS_NOT_PROVIDED";
        case "MESSAGES.INVALID_ADDRESS_ERR":
          return "INVALID_ADDRESS_ERR";
        default:
          return 'Invalid';
      }
    };
    this.statusList = UploadF.STATUS_LIST;
    this.upload = VisitUploadF;
    this.filterMissingContact = (function(_this) {
      return function(showMissingOnly) {
        var filterKey = _getFilterKey();
        if (!filterKey) {
          return;
        }
        _this.isShowMultipleAddresses = false;
        if (showMissingOnly) {
          _this.isShowMissingContact = true;
          return VisitGridApiF.setFilter(filterKey);
        } else if (!showMissingOnly) {
          _this.isShowMissingContact = false;
          return VisitGridApiF.setFilter("");
        }
      };
    })(this);
    this.filterMultipleAddresses = (function(_this) {
      return function(checked) {
        var filterKey = VisitGridApiF.filterSymbols.multipleAddresses;
        if (!filterKey) {
          return;
        }
        _this.isShowMissingContact = false;
        if (checked) {
          _this.isShowMultipleAddresses = true;
          return VisitGridApiF.setFilter(filterKey);
        } else if (!checked) {
          _this.isShowMultipleAddresses = false;
          return VisitGridApiF.setFilter("");
        }
      };
    })(this);
    this.setPriority = (function(_this) {
      return function(isPriority) {
        return _this.entry.isPriority = isPriority;
      };
    })(this);
    this.initializeEntry = _initializeEntry;
    _showInvalidVisitsIfAny = (function(_this) {
      return function() {
        var filterText;
        _this.isShowInvalidView = _this.getNumInvalidVisits() > 0;
        if (_this.isShowInvalidView) {
          filterText = "invalid";
        } else {
          filterText = "";
        }
        return $timeout(function() {
          return VisitGridApiF.setFilter(filterText);
        }, 100);
      };
    })(this);
    _showMultipleAddressesIfAny = (function(_this) {
      return function() {
        _this.numMultipleAddressesVisits = _getNumMultipleAddressesVisits();
        if (!_this.isShowMultipleAddresses) {
          return;
        }
        if (_this.numMultipleAddressesVisits > 0) {
          return $timeout(function() {
            return VisitGridApiF.setFilter(VisitGridApiF.filterSymbols.multipleAddresses);
          }, 100);
        } else {
          VisitGridApiF.setFilter('');
          return _this.isShowMultipleAddresses = false;
        }
      };
    })(this);
    _showMissingContactIfAny = (function(_this) {
      return function() {
        var filterKey;
        _this.numVisitsMissingContact = _getNumMissingContactVisits();
        if (!_this.isShowMissingContact) {
          return;
        }
        filterKey = _getFilterKey();
        if (!filterKey) {
          return;
        }
        if (_this.numVisitsMissingContact > 0) {
          return $timeout(function() {
            return VisitGridApiF.setFilter(filterKey);
          }, 100);
        } else {
          VisitGridApiF.setFilter('');
          return _this.isShowMissingContact = false;
        }
      };
    })(this);
    EventListenersF.addEventListener(Events.STOPS_GEOCODE_ERROR, (function(_this) {
      return function(msg) {
        return _this.isShowInvalidView = true;
      };
    })(this));
    EventListenersF.addEventListener(Events.CSV_UPLOAD_COMPLETED, (function(_this) {
      return function() {
        _showInvalidVisitsIfAny();
        _this.numVisitsMissingContact = _getNumMissingContactVisits();
        return _this.numMultipleAddressesVisits = _getNumMultipleAddressesVisits();
      };
    })(this));
    EventListenersF.addEventListener(Events.PROJECT_LOADED, (function(_this) {
      return function() {
        return _this.projectHasPassed = ProjectF.isPastProject();
      };
    })(this));
    EventListenersF.addEventListener(Events.DELIVERY_METHOD_CHANGED, (function(_this) {
      return function() {
        _this.shouldShowEmailNotificationWarning = AccountF.isEmailNotificationOn();
        return _this.shouldShowSmsNotificationWarning = AccountF.isSmsNotificationOn();
      };
    })(this));
    EventListenersF.addEventListener(Events.VISIT_PHONE_VALIDATED, (function(_this) {
      return function() {
        return _this.phoneValidated = true;
      };
    })(this));
    EventListenersF.addEventListener(Events.VISIT_CONFIRMED_ADDRESS, function() {
      return _showMultipleAddressesIfAny();
    });
    $rootScope.$on('$stateChangeStart', (function(_this) {
      return function(e) {
        if ($state.current.name !== States.projectVisitsQuickadd) {
          return false;
        }
        if (_hasEditChanges()) {
          e.preventDefault();
          return MessagingF.replaceWarning("SIDEPANEL.UNSAVED_CHANGES", null, null, "SIDEPANEL.UNSAVED_CHANGES_OK");
        } else {
          return _this.quickCreateVisits = [];
        }
      };
    })(this));
    _showInvalidVisitsIfAny();
    _showMissingContactIfAny();
    _resetSelectedVisits();
  };
  VisitC.$inject = ["$q", "$scope", "$state", "$previousState", "$filter", "$timeout", "$translate", "$rootScope", "MessagingF", "UploadF", "VisitUploadF", "ConfirmF", "Marker", "RouteS", "GMarkerF", "MarkersF", "SettingsF", "ValidatorF", "TypeF", "VisitCsvHeaderF", "TimeUtilF", "States", "DispatchF", "ProjectF", "DispatchStatusF", "EventListenersF", "Events", "VisitGridApiF", "VisitUtilF", "AnalyticsS", "OnboardingF", "RouteHistoryF", "VisitF", "AccountF", "Constants", "AddressCheckerS", "CustomerNotificationF", "LoggerF", "RouteInspectorF", "UnservedUtil"];

  angular.module('app').controller('VisitC', VisitC);

}).call(this);

(function() {
  var VisitF = function($q, $timeout, $http, $translate, UUID, VisitMarker, ValidatorF, LocalStorageArrayF, Marker, AnalyticsS, VisitGeocoordF, EventListenersF, AccountF, Events, Constants, ProjectTimezoneF, SessionF) {
    var EMPTY_ENTRY_ERROR, MS_IN_AN_HOUR, NO_ADDRESS_ERROR, _cache, _formalizeEntry, _getVisitEmailList, _isValidOrValidated, _toSerialize, _valid, _validVisits, _visits;
    EMPTY_ENTRY_ERROR = $q.reject(new Error('No information is provided'));
    NO_ADDRESS_ERROR = $q.reject(new Error('No address or latitude/longitude is provided'));
    VisitF = {};
    _validVisits = [];
    _visits = [];
    _cache = LocalStorageArrayF('visits');
    MS_IN_AN_HOUR = 60 * 1000;
    _toSerialize = function(entry) {
      return _.pick(entry, 'id', 'name', 'duration', 'location', 'startDate', 'endDate', 'load', 'phone', 'email', 'types', 'notes', 'notes2', 'status', 'error', 'customNotes');
    };
    _formalizeEntry = function(visit) {
      return VisitGeocoordF.translate(visit.location).then(function(location) {
        visit.location || (visit.location = {});
        visit.location.address = location.address;
        visit.location.coords = location.coords;
        if (location.all_results) {
          visit.location.all_results = location.all_results;
        }
        return ValidatorF.validateVisit(visit);
      }).then(function() {
        visit.status = Marker.Status.Validated;
        if (visit.phoneWarning) {
          visit.setPhoneWarningStatus();
        }
        if (visit.smsError) {
          visit.setSmsError(true);
        }
        return visit;
      })["catch"](function(error) {
        visit.status = Marker.Status.Invalid;
        visit.error = error.message;
        return visit;
      });
    };
    _isValidOrValidated = function(visit) {
      var valid, validated;
      validated = Marker.Status.Validated;
      valid = Marker.Status.Valid;
      return visit.status === validated || visit.status === valid;
    };
    _valid = function(visit) {
      if (visit.status === Marker.Status.Invalid) {
        visit.status = Marker.Status.Validated;
        return delete visit.error;
      } else {
        return visit.status = Marker.Status.Valid;
      }
    };
    VisitF.addVisit = function(entry, isBatch) {
      var visit;
      if (isBatch == null) {
        isBatch = false;
      }
      if (entry == null) {
        return EMPTY_ENTRY_ERROR;
      }
      entry.id || (entry.id = UUID.generate());
      entry.status = Marker.Status.Pending;
      entry.visitStatus = Constants.visitStatusPending;
      visit = new VisitMarker(entry);
      _visits.push(visit);
      return _formalizeEntry(visit).then(function(res) {
        visit = res;
        return $q.when(true);
      }).then(function() {
        if ((entry.email != null) && !isBatch) {
          return VisitF.getAndUpdateUnsubscription([entry.email]);
        }
      }).then(function() {
        if (!isBatch) {
          AnalyticsS.track("New Visit");
          AnalyticsS.increment({
            "#Added Visits": 1
          });
        }
        return visit;
      });
    };
    VisitF.getVisit = function(id) {
      return _.find(_visits, function(visit) {
        return visit.id === id;
      });
    };
    VisitF.getVisits = function() {
      return _visits;
    };
    VisitF.getVisitIds = function() {
      var visit, visitIdMap, _i, _len;
      visitIdMap = {};
      for (_i = 0, _len = _visits.length; _i < _len; _i++) {
        visit = _visits[_i];
        visitIdMap[visit.id] = true;
      }
      return visitIdMap;
    };
    VisitF.getVisitInfoMap = function() {
      var visit, _i, _len;
      var map = {};
      for (_i = 0, _len = _visits.length; _i < _len; _i++) {
        visit = _visits[_i];
        map[visit.id] = visit;
      }
      return map;
    };
    VisitF.updateValidVisits = function() {
      var visit;
      _validVisits = (function() {
        var _i, _len, _results;
        _results = [];
        for (_i = 0, _len = _visits.length; _i < _len; _i++) {
          visit = _visits[_i];
          if (_isValidOrValidated(visit)) {
            _results.push(visit);
          }
        }
        return _results;
      })();
      return EventListenersF.notify(Events.VALID_VISITS_UPDATED);
    };
    VisitF.updateUnsubscription = function(unsubscriptionInfo, updateAll) {
      var customer, visit, _i, _j, _len, _len1, _ref, _results, _unsubscriptionMap;
      if (updateAll == null) {
        updateAll = false;
      }
      if (!(unsubscriptionInfo && unsubscriptionInfo.length > 0)) {
        return;
      }
      _unsubscriptionMap = {};
      for (_i = 0, _len = unsubscriptionInfo.length; _i < _len; _i++) {
        customer = unsubscriptionInfo[_i];
        if ((_ref = customer.unsubscribed_notification_type) != null ? _ref.driver_on_way : void 0) {
          _unsubscriptionMap[customer.customer_email] = true;
        }
      }
      _results = [];
      for (_j = 0, _len1 = _visits.length; _j < _len1; _j++) {
        visit = _visits[_j];
        if (visit.email != null) {
          if (updateAll) {
            _results.push(visit.hasUnsubscribed = _unsubscriptionMap[visit.email] ? true : false);
          } else {
            if (_unsubscriptionMap[visit.email]) {
              _results.push(visit.hasUnsubscribed = true);
            } else {
              _results.push(void 0);
            }
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };
    VisitF.getAndUpdateUnsubscription = function(emailLists, updateAll) {
      if (updateAll == null) {
        updateAll = false;
      }
      if (!emailLists) {
        return;
      }
      return VisitF.getUnsubscriptions(emailLists).then(function(res) {
        if (res.data) {
          return VisitF.updateUnsubscription(res.data, updateAll);
        }
      })["catch"](function(err) {
        return console.log(err);
      });
    };
    VisitF.getValidVisits = function() {
      return _validVisits;
    };
    VisitF.getInvalidVisits = function() {
      var visit, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _visits.length; _i < _len; _i++) {
        visit = _visits[_i];
        if (visit.status === Marker.Status.Invalid) {
          _results.push(visit);
        }
      }
      return _results;
    };
    VisitF.getMissingEmailVisits = function() {
      var visit, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _visits.length; _i < _len; _i++) {
        visit = _visits[_i];
        if (!visit.email) {
          _results.push(visit);
        }
      }
      return _results;
    };
    VisitF.getInvalidPhoneVisits = function() {
      var visit, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _visits.length; _i < _len; _i++) {
        visit = _visits[_i];
        if (!visit.phone || visit.phoneWarning) {
          _results.push(visit);
        }
      }
      return _results;
    };
    VisitF.getMultipleAddressesVisits = function() {
      var visit, _i, _len, _ref, _ref1, _results;
      _results = [];
      for (_i = 0, _len = _visits.length; _i < _len; _i++) {
        visit = _visits[_i];
        if (((_ref = visit.location) != null ? _ref.num_results : void 0) > 1 || (((_ref1 = visit.location) != null ? _ref1.all_results : void 0) != null)) {
          _results.push(visit);
        }
      }
      return _results;
    };
    VisitF.clear = function() {
      _visits = [];
      return VisitF.updateValidVisits();
    };
    VisitF.deleteAll = function() {
      VisitF.clear();
      _cache.erase();
      return AnalyticsS.track("Clear Visits");
    };
    VisitF.clearCache = function() {
      return _cache.erase();
    };
    VisitF.removeVisit = function(id) {
      var removedVisits;
      return removedVisits = _.remove(_visits, {
        id: id
      });
    };
    VisitF.updateVisit = function(entry) {
      var visit = null;
      return ValidatorF.validateVisit(entry).then(function() {
        var index = _.findIndex(_visits, {
          id: entry.id
        });
        if (index < 0) {
          return $q.reject(new Error("stop with id " + entry.id + " does not exist"));
        }
        _valid(entry);
        visit = new VisitMarker(entry);
        if ((_visits[index].smsError != null) && _visits[index].phone !== entry.phone) {
          visit.setSmsError(void 0);
        }
        _visits[index] = visit;
        return EventListenersF.notify(Events.VISIT_MARKER_CHANGED(visit.id), visit.marker);
      }).then(function() {
        if ((entry.email != null) && entry.email.trim() !== '') {
          return VisitF.getAndUpdateUnsubscription([entry.email]);
        }
      }).then(function() {
        AnalyticsS.track("Update Stop", visit);
        return visit;
      });
    };
    VisitF.getLocationToIndexMap = function() {
      var idx, locationIdToIdxMap, visit, _i, _len;
      locationIdToIdxMap = {};
      for (idx = _i = 0, _len = _visits.length; _i < _len; idx = ++_i) {
        visit = _visits[idx];
        locationIdToIdxMap[visit.id] = idx;
      }
      return locationIdToIdxMap;
    };
    VisitF.updateVisitsWithDispatchInfo = function(dispatches) {
      var dispatch, doneOrSkippedLog, driverName, idx, locationIdToIdxMap, log, logs, routeId, toUpdate, vehId, visit, visits, _i, _len, _ref, _ref1, _ref2;
      locationIdToIdxMap = VisitF.getLocationToIndexMap();
      for (vehId in dispatches) {
        dispatch = dispatches[vehId];
        visits = (_ref = dispatch.solution) != null ? _ref.visits : void 0;
        routeId = dispatch._id;
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          visit = visits[_i];
          logs = visit.log;
          doneOrSkippedLog = ((function() {
            var _j, _len1, _results;
            _results = [];
            for (_j = 0, _len1 = logs.length; _j < _len1; _j++) {
              log = logs[_j];
              if (log.status === Constants.visitStatusDone || log.status === Constants.visitStatusSkipped) {
                _results.push(log);
              }
            }
            return _results;
          })())[0];
          if (doneOrSkippedLog != null ? doneOrSkippedLog.date : void 0) {
            doneOrSkippedLog.date = ProjectTimezoneF.convertToProjectTime(doneOrSkippedLog.date);
          }
          idx = locationIdToIdxMap[(_ref1 = visit.location) != null ? _ref1.id : void 0];
          if (idx != null) {
            toUpdate = _visits[idx];
            driverName = (_ref2 = dispatch.vehicle) != null ? _ref2.name : void 0;
            toUpdate.setStatus(visit.status, doneOrSkippedLog, driverName, visit.isLate, visit._signature, visit.photo_url, routeId);
            EventListenersF.notify(Events.VISIT_STATUS_CHANGED(toUpdate.id), toUpdate.visitStatus);
          }
        }
      }
      return VisitF.updateValidVisits();
    };
    VisitF.replace = function(visits) {
      var entry, promises, visit, _i, _len;
      _visits = [];
      promises = [];
      if (visits) {
        for (_i = 0, _len = visits.length; _i < _len; _i++) {
          entry = visits[_i];
          if (entry.status === Marker.Status.Validated) {
            entry.status = Marker.Status.Valid;
          }
          if (AccountF.isSmsNotificationOn()) {
            if (entry.phone && !ValidatorF.isPhoneNumber(entry.phone)) {
              entry.phoneWarning = true;
            }
            if (entry.phone && ValidatorF.isLandline(entry.phone)) {
              entry.smsError = true;
            }
          }
          visit = new VisitMarker(entry);
          _visits.push(visit);
          if (entry.status === Marker.Status.Pending) {
            promises.push(_formalizeEntry(visit));
          } else {
            promises.push($q.when(visit));
          }
        }
      }
      return $q.all(promises).then(function() {
        var emails;
        VisitF.updateValidVisits();
        if (AccountF.hasCustomerNotification()) {
          emails = _getVisitEmailList();
          if (!(emails.length > 0)) {
            return _visits;
          }
          VisitF.getAndUpdateUnsubscription(emails, true);
        }
        return _visits;
      });
    };
    VisitF.revalidateAll = function() {
      var visit, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _visits.length; _i < _len; _i++) {
        visit = _visits[_i];
        _results.push((function(visit) {
          return ValidatorF.validateVisit(visit).then(function() {
            _valid(visit);
            return visit;
          })["catch"](function(error) {
            visit.status = Marker.Status.Invalid;
            visit.error = error.message;
            return error;
          });
        })(visit));
      }
      return _results;
    };
    VisitF.postStops = function(projectId, stops) {
      var authHeader, _ref;
      if (!(projectId && stops)) {
        return $q.reject();
      }
      authHeader = AccountF.getAuthHeader();
      if ((_ref = authHeader.headers) != null) {
        _ref['Session-Id'] = SessionF.getSessionId();
      }
      return $http.post("" + Constants.productApiPath + "/v0.1/project/" + projectId + "/stops", stops, authHeader);
    };
    _getVisitEmailList = function() {
      var visit, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = _visits.length; _i < _len; _i++) {
        visit = _visits[_i];
        if ((visit.email != null) && visit.email.trim() !== '') {
          _results.push(visit.email);
        }
      }
      return _results;
    };
    VisitF.getUnsubscriptions = function(emails) {
      var authHeader;
      if (emails.length > 0) {
        authHeader = AccountF.getAuthHeader();
        return $http.put("" + Constants.notificationApiPath + "/users/settings/subscription-settings", emails, authHeader);
      }
      return $q.when(true);
    };
    EventListenersF.addEventListener(Events.SMS_FAILED, function(data) {
      var index, visitId;
      visitId = data.visit_id;
      if (!visitId) {
        return;
      }
      index = _.findIndex(_visits, {
        id: visitId
      });
      if (index < 0) {
        return;
      }
      _visits[index].setSmsError(true);
      return EventListenersF.notify(Events.VISIT_MARKER_CHANGED(visitId), _visits[index].marker);
    });
    EventListenersF.addEventListener(Events.SMS_ERRORS_LOADED, function(errors) {
      var currentVisit, error, index, stopId, _i, _len;
      for (_i = 0, _len = errors.length; _i < _len; _i++) {
        error = errors[_i];
        if (error.isDriverError) {
          return;
        }
        stopId = error.locationId;
        if (!stopId) {
          return;
        }
        index = _.findIndex(_visits, {
          id: stopId
        });
        if (index < 0) {
          return;
        }
        currentVisit = _visits[index];
        if (currentVisit.phone === error.phoneNumber) {
          currentVisit.setSmsError(true);
        }
      }
    });

    return VisitF;
  };
  VisitF.$inject = ["$q", "$timeout", "$http", "$translate", "UUID", "VisitMarker", "ValidatorF", "LocalStorageArrayF", "Marker", "AnalyticsS", "VisitGeocoordF", "EventListenersF", "AccountF", "Events", "Constants", "ProjectTimezoneF", "SessionF"];

  angular.module('app').factory('VisitF', VisitF);

}).call(this);

(function() {
  var VisitGridApiF = function($translate) {
    var _filterInvalidPhone, _filterMissingEmail, _filterMultipleAddresses, _gridApi, _isInternalFilter;
    _isInternalFilter = function(string) {
      return string.trim().substring(0, 9) === '|filter::';
    };
    _gridApi = null;
    VisitGridApiF = {};
    VisitGridApiF.filterSymbols = {
      missingEmail: '|filter::missingEmail',
      invalidPhone: '|filter::invalidPhone',
      multipleAddresses: '|filter::multipleAddresses'
    };
    VisitGridApiF.getGridApi = function() {
      return _gridApi;
    };
    VisitGridApiF.setFilter = function(val) {
      if (!_gridApi) {
        return;
      }
      VisitGridApiF.filterValue = val;
      return _gridApi.grid.refresh();
    };
    VisitGridApiF.paginationPageSize = 20;
    VisitGridApiF.onRegisterApi = function(gridApi) {
      _gridApi = gridApi;
      return _gridApi.grid.registerRowsProcessor(VisitGridApiF.universalFilter, 200);
    };
    VisitGridApiF.filter = function() {
      return _gridApi.grid.refresh();
    };
    VisitGridApiF.getInViewVisits = function() {
      return VisitGridApiF.getGridApi().grid.getVisibleRows();
    };
    VisitGridApiF.getPaginationText = function() {
      var firstStopInPage, pageSize, text, totalItemsInPage;
      var curPage = _gridApi.pagination.getPage() - 1;
      pageSize = this.paginationPageSize;
      firstStopInPage = (curPage * pageSize) + 1;
      totalItemsInPage = VisitGridApiF.getGridApi().grid.getVisibleRowCount();
      text = $translate.instant("STOPS_LIST.PAGINATION_TEXT", {
        from: firstStopInPage,
        to: firstStopInPage + totalItemsInPage - 1
      });
      return text;
    };
    _filterMissingEmail = function(renderableRows) {
      return renderableRows.forEach(function(row) {
        var email, match, _ref;
        match = false;
        email = (_ref = row.entity.visit) != null ? _ref.email : void 0;
        if ((email == null) || (typeof email.trim === "function" ? email.trim().length : void 0) === 0) {
          match = true;
        }
        if (!match) {
          return row.visible = false;
        }
      });
    };
    _filterInvalidPhone = function(renderableRows) {
      return renderableRows.forEach(function(row) {
        var phoneNumber, _ref, _ref1;
        var match = false;
        phoneNumber = (_ref = row.entity.visit) != null ? _ref.phone : void 0;
        if ((phoneNumber == null) || phoneNumber === '') {
          match = true;
        }
        if ((_ref1 = row.entity.visit) != null ? _ref1.phoneWarning : void 0) {
          match = true;
        }
        if (!match) {
          return row.visible = false;
        }
      });
    };
    _filterMultipleAddresses = function(renderableRows) {
      return renderableRows.forEach(function(row) {
        var _ref, _ref1, _ref2, _ref3;
        var match = false;
        if (((_ref = row.entity.visit) != null ? (_ref1 = _ref.location) != null ? _ref1.num_results : void 0 : void 0) > 1 || (((_ref2 = row.entity.visit) != null ? (_ref3 = _ref2.location) != null ? _ref3.all_results : void 0 : void 0) != null)) {
          match = true;
        }
        if (!match) {
          return row.visible = false;
        }
      });
    };
    VisitGridApiF.universalFilter = (function(_this) {
      return function(renderableRows) {
        var matcher;
        if (!_isInternalFilter(VisitGridApiF.filterValue)) {
          matcher = new RegExp(VisitGridApiF.filterValue, 'i');
          renderableRows.forEach(function(row) {
            var match = false;
            ['Name', 'Address', 'Status', 'errorStatus'].forEach(function(field) {
              var _ref;
              if ((_ref = row.entity[field]) != null ? _ref.match(matcher) : void 0) {
                return match = true;
              }
            });
            if (!match) {
              return row.visible = false;
            }
          });
        } else {
          switch (VisitGridApiF.filterValue) {
            case VisitGridApiF.filterSymbols.missingEmail:
              _filterMissingEmail(renderableRows);
              break;
            case VisitGridApiF.filterSymbols.invalidPhone:
              _filterInvalidPhone(renderableRows);
              break;
            case VisitGridApiF.filterSymbols.multipleAddresses:
              _filterMultipleAddresses(renderableRows);
          }
        }
        return renderableRows;
      };
    })(this);
    VisitGridApiF.filterValue = "";
    return VisitGridApiF;
  };
  VisitGridApiF.$inject = ["$translate"];

  angular.module('app').factory('VisitGridApiF', VisitGridApiF);

}).call(this);

(function() {
  var     __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  var VisitMarker = function(Marker, VisitUtilF) {
    var PRIVATE_FIELDS, _isArray, _isObject, _isString, _updateResults;
    VisitMarker = (function() {
      function VisitMarker(entry) {
        var templateUrl;
        this.id = entry.id || entry._id;
        this.name = entry.name;
        this.location = entry.location;
        if (entry.startDate) {
          this.startDate = new Date(entry.startDate);
          if (isNaN(this.startDate.getTime())) {
            this.startDate = null;
          }
        }
        if (entry.endDate) {
          this.endDate = new Date(entry.endDate);
          if (isNaN(this.endDate.getTime())) {
            this.endDate = null;
          }
        }
        this.duration = entry.duration;
        this.load = entry.load;
        this.phone = entry.phone;
        this.email = entry.email;
        this.notes = entry.notes;
        this.notes2 = entry.notes2;
        this.customNotes = entry.customNotes || {};
        this.pick_up_form = entry.pick_up_form;
        this.status = entry.status;
        this.error = entry.error;
        this.createdAt = entry.createdAt || Date.now();
        this.types = entry.types ? [].concat(entry.types) : [];
        this.isPriority = entry.isPriority || false;
        this.smsError = entry.smsError;
        this.phoneWarning = entry.phoneWarning;
        this.phoneModified = entry.phoneModified;
        templateUrl = 'markers/visit.html';
        this.marker = new Marker(this.location, templateUrl, _.clone(this));
      }

      return VisitMarker;

    })();
    PRIVATE_FIELDS = ["marker", "isPriority", "id", "error", "createdAt"];
    _isString = function(v) {
      return typeof v === 'string' || v instanceof String;
    };
    _isArray = function(v) {
      return v instanceof Array;
    };
    _isObject = function(v) {
      return v instanceof Object;
    };
    _updateResults = function(values, query, key, results) {
      var endIndex, prefix, prefixCount, queryStartIdx, snippet, snippets, startIndex, suffix, suffixCount, value, _i, _len;
      snippets = [];
      for (_i = 0, _len = values.length; _i < _len; _i++) {
        value = values[_i];
        queryStartIdx = value.toLowerCase().indexOf(query);
        if (queryStartIdx !== -1) {
          prefixCount = 5;
          suffixCount = 5;
          startIndex = Math.max(0, queryStartIdx - prefixCount);
          endIndex = queryStartIdx + query.length + suffixCount;
          prefix = startIndex > 0 ? "..." : "";
          suffix = endIndex < value.length ? "..." : "";
          snippet = prefix + value.slice(startIndex, endIndex) + suffix;
          snippets.push(snippet);
        }
      }
      if (snippets.length > 0) {
        results.matches || (results.matches = {});
        return results.matches[key] = snippets.join(", ");
      }
    };
    VisitMarker.prototype.querySearch = function(query) {
      var key, matchFound, results, subKey, subVal, val, value;
      query = query.toLowerCase();
      results = {};
      for (key in this) {
        val = this[key];
        if (!((val != null) && __indexOf.call(PRIVATE_FIELDS, key) < 0)) {
          continue;
        }
        value = _.clone(val);
        if (_isString(value)) {
          _updateResults([value], query, key, results);
        } else if (_isArray(value)) {
          if (_isString(value[0])) {
            _updateResults(value, query, key, results);
          }
        } else if (_isObject(value)) {
          for (subKey in value) {
            subVal = value[subKey];
            if (_isString(subVal)) {
              _updateResults([subVal], query, subKey, results);
            }
          }
        }
      }
      matchFound = Object.keys(results).length > 0;
      return matchFound && results;
    };
    VisitMarker.prototype.setStatus = function(status, statusInfo, driverName, isLate, signatureId, photoUrl, routeId) {
      if (driverName == null) {
        driverName = null;
      }
      if (isLate == null) {
        isLate = null;
      }
      if (signatureId == null) {
        signatureId = null;
      }
      if (photoUrl == null) {
        photoUrl = null;
      }
      if ((status != null) || (signatureId != null)) {
        return this.visitStatus = {
          status: status != null ? status : void 0,
          info: statusInfo != null ? statusInfo : void 0,
          isLate: isLate != null ? isLate : void 0,
          driver: driverName != null ? driverName : void 0,
          signatureId: signatureId != null ? signatureId : void 0,
          photoUrl: photoUrl != null ? photoUrl : void 0,
          routeId: routeId
        };
      }
    };
    VisitMarker.prototype.setSmsError = function(status) {
      return this.marker.parameter.smsError = status;
    };
    VisitMarker.prototype.setPhoneWarningStatus = function() {
      return this.marker.parameter.phoneWarning = true;
    };
    return VisitMarker;
  };
  VisitMarker.$inject = ["Marker", "VisitUtilF"];

  angular.module('app').factory('VisitMarker', VisitMarker);

}).call(this);

(function() {
  var VisitCheckerC = function($scope, $state, $q, visit, RouteS, VisitF, MessagingF, MarkersF, DispatchF, VisitGridApiF, EventListenersF, ConfirmF, Events, AnalyticsS) {
    var _createMessage;
    _createMessage = function(isVisitDispatched) {
      if (isVisitDispatched) {
        return {
          heading: "ADDRESS_CHECKER.DISPATCH_SAVE_HEADING",
          text: "ADDRESS_CHECKER.DISPATCH_SAVE_TEXT",
          cancelCopy: "ADDRESS_CHECKER.DISPATCH_SAVE_CANCEL",
          confirmCopy: "ADDRESS_CHECKER.DISPATCH_SAVE_CONFIRM"
        };
      } else {
        return {
          heading: "ADDRESS_CHECKER.ROUTE_SAVE_HEADING",
          text: "ADDRESS_CHECKER.ROUTE_SAVE_TEXT"
        };
      }
    };
    this.visit = visit;
    this.onExit = function() {
      return $scope.closeThisDialog();
    };
    this.updateAddress = (function(_this) {
      return function(isValid, isAddressChanged, selectedLocation) {
        var confirmMessage, newVisit, _needRefetchRoute, _refetchRoute;
        if (!isValid) {
          return;
        }
        if (RouteS.isInProgress()) {
          MessagingF.replaceInfoPopup("MESSAGES.ROUTING_IN_PROGRESS");
          return;
        }
        if (!isAddressChanged) {
          return $scope.closeThisDialog();
        }
        newVisit = _.cloneDeep(_this.visit);
        newVisit.location = selectedLocation;
        newVisit.location.resolved = true;
        _needRefetchRoute = false;
        _refetchRoute = null;
        if (!RouteS.isUnservedVisit(newVisit) && RouteS.hasRoute()) {
          confirmMessage = _createMessage(DispatchF.hasVisitBeenDispatched(newVisit.id));
          _refetchRoute = ConfirmF.confirmInfo(confirmMessage.heading, confirmMessage.text, confirmMessage.cancelCopy, confirmMessage.confirmCopy).then(function() {
            return _needRefetchRoute = true;
          });
        } else {
          _refetchRoute = $q.when(true);
        }
        return _refetchRoute.then(function() {
          return VisitF.updateVisit(newVisit);
        }).then(function() {
          VisitF.updateValidVisits();
          if (!_needRefetchRoute) {
            return $q.when(true);
          }
          return EventListenersF.notify(Events.OPTIMIZATION_IN_PROGRESS).then(function() {
            return RouteS.reoptimizeDriverWithStop(newVisit);
          });
        }).then(function() {
          if (_needRefetchRoute) {
            RouteS.resetRoutesToCurrent();
          }
          return EventListenersF.notify(Events.PROJECT_MODIFIED);
        }).then(function() {
          MarkersF.fitToPoints();
          if (VisitF.getInvalidVisits().length <= 0) {
            VisitGridApiF.setFilter('');
          }
          EventListenersF.notify(Events.VISIT_CONFIRMED_ADDRESS);
          AnalyticsS.track('0003_WEB_UI address updated via address checker');
          $scope.closeThisDialog();
          return MessagingF.replaceSuccessPopup("ADDRESS_CHECKER.SUCCESS", {
            driverName: newVisit.name
          });
        })["catch"](function(err) {
          if ((err != null ? err.message : void 0) || (err != null ? err.error : void 0)) {
            return MessagingF.replaceError((err != null ? err.message : void 0) || (err != null ? err.error : void 0));
          }
        })["finally"](function() {
          return EventListenersF.notify(Events.OPTIMIZATION_COMPLETED);
        });
      };
    })(this);
  };
  VisitCheckerC.$inject = ["$scope", "$state", "$q", "visit", "RouteS", "VisitF", "MessagingF", "MarkersF", "DispatchF", "VisitGridApiF", "EventListenersF", "ConfirmF", "Events", "AnalyticsS"];

  angular.module('app').controller('visitCheckerC', VisitCheckerC);

}).call(this);

(function() {
  var BuildVisitsF = function($translate, GanttUtilF, GanttConstants, Constants, GMarkerF, RouteInspectorF, RouteS, VisitF, UnservedUtil) {
    var LATE_ICON_CLASS, ON_TIME_ICON_CLASS, PREV_PAGE_CONTROL_WIDTH, ROUTE_INVISIBLE_CLASS, SELECTED_CLASS, SKIPPED_ICON_CLASS, _addVisibilityEventListener, _axis, _drawCompletedVisit, _drawPendingVisit, _drawVisits, _getVisitUpdateClass, _getVisitsData, _rowHeight, _target, _unservedIndexRange;
    _rowHeight = null;
    _target = null;
    _axis = null;
    _unservedIndexRange = null;
    SELECTED_CLASS = 'selected';
    ROUTE_INVISIBLE_CLASS = Constants.routeInvisibleCSS;
    ON_TIME_ICON_CLASS = "icon-checkmark";
    LATE_ICON_CLASS = "icon-late";
    SKIPPED_ICON_CLASS = "icon-cross";
    PREV_PAGE_CONTROL_WIDTH = 20;
    _addVisibilityEventListener = function(id, selection) {
      return RouteS.addVisibilityEventListener(id, function(isVisible) {
        return selection.classed(ROUTE_INVISIBLE_CLASS, !isVisible);
      });
    };
    _getVisitUpdateClass = function(d) {
      var visitUpdateClass = null;
      if (d.visitStatus === Constants.visitStatusSkipped) {
        visitUpdateClass = GanttConstants.VISIT_SKIPPED_CLASS;
      } else if (d.visitStatus === Constants.visitStatusDone) {
        if (d.isLate) {
          visitUpdateClass = GanttConstants.VISIT_LATE_CLASS;
        } else {
          visitUpdateClass = GanttConstants.VISIT_ON_TIME_CLASS;
        }
      }
      return visitUpdateClass;
    };
    _getVisitsData = function(data, forUnserved) {
      var d, driverYPos, height, indexText, isFirstRow, isPriority, isUnserved, isVisible, leftMargin, relativeIndex, rightType, selected, startDate, timeText, transform, unservedOutOfRange, unservedText, updateClass, visitStatus, visits, width, x, _i, _len, _ref;
      visits = [];
      for (_i = 0, _len = data.length; _i < _len; _i++) {
        d = data[_i];
        if (!(d.isVisit && !d["break"])) {
          continue;
        }
        rightType = forUnserved ? !d.driverId : d.driverId;
        if (rightType) {
          leftMargin = 0;
          driverYPos = _axis.y(d.driverId);
          isUnserved = !d.driverId;
          isFirstRow = driverYPos < _rowHeight;
          isVisible = GMarkerF.getVisible(d.id);
          if (isVisible == null) {
            isVisible = true;
          }
          selected = GMarkerF.getSelected(d.id);
          isPriority = (_ref = VisitF.getVisit(d.id)) != null ? _ref.isPriority : void 0;
          indexText = String(d.index);
          unservedText = d.driverId ? "" : UnservedUtil.formatReason(d.error);
          timeText = d.displayTime;
          updateClass = _getVisitUpdateClass(d);
          height = GanttConstants.VISIT_HEIGHT;
          visitStatus = d.visitStatus;
          startDate = d.idleDate || d.startDate;
          if (isUnserved) {
            width = GanttConstants.UNSERVED_WIDTH;
            unservedOutOfRange = d.index < _unservedIndexRange[0] || d.index > _unservedIndexRange[1];
            relativeIndex = d.index - _unservedIndexRange[0];
            x = relativeIndex * (GanttConstants.UNSERVED_WIDTH + GanttConstants.UNSERVED_MARGIN) + 30;
            if (_target.unservedPage() > 0) {
              x += PREV_PAGE_CONTROL_WIDTH;
              leftMargin = PREV_PAGE_CONTROL_WIDTH;
            }
            transform = "translate(" + x + ", " + 0 + ")";
          } else {
            width = GanttUtilF.getVisitWidth(_axis, startDate, d.endDate);
            transform = GanttUtilF.rectTransform(_target, _axis, d);
          }
          d.driverYPos = driverYPos;
          d.height = height;
          d.width = width;
          d.transform = transform;
          d.isFirstRow = isFirstRow;
          d.isVisible = isVisible;
          d.selected = selected;
          d.isPriority = isPriority;
          d.updateClass = updateClass;
          d.timeText = timeText;
          d.indexText = indexText;
          d.unservedText = unservedText;
          d.leftMargin = leftMargin;
          d.isUnserved = isUnserved;
          d.unservedIndex = relativeIndex;
          d.unservedOutOfRange = unservedOutOfRange;
          d.visitStatus = visitStatus;
          visits.push(d);
        }
      }
      return visits;
    };
    _drawVisits = function(selection) {
      return selection.each(function(v) {
        var defaultUnserved, foreignObj, gContainer, gVisit, rect, tooltipText, unservedText;
        gVisit = d3.select(this);
        if (v.isUnserved && v.unservedOutOfRange) {
          gVisit.remove();
          return;
        }
        defaultUnserved = $translate.instant(Constants.unservedMessages.constraints);
        unservedText = v.isUnserved ? v.unservedText || defaultUnserved : void 0;
        tooltipText = unservedText ? '<div class="content">Unscheduled stop <br><br><div class="description">' + unservedText + '</div></div>' : v.timeText;
        gVisit.attr('class', 'visit item gantt-tooltip').classed(SELECTED_CLASS, v.selected).classed(v.color.name, true).classed(ROUTE_INVISIBLE_CLASS, !v.isVisible).classed(GanttConstants.DRAG_CLASS, false).classed(v.updateClass, v.updateClass != null).attr('data-tooltip-index', !v.isUnserved ? v.indexText : void 0).attr('data-tooltip-text', tooltipText).attr('data-tooltip-color', v.color.name).attr('data-tooltip-pos', !v.isUnserved ? 'top' : 'bottom').attr('data-tooltip-class', unservedText ? "unscheduled" : void 0);
        _addVisibilityEventListener(v.driverId, gVisit);
        gVisit.transition().attr('transform', v.transform).attr('width', v.width);
        rect = gVisit.selectAll('rect.bar');
        if (rect.empty()) {
          rect = gVisit.append('rect').classed('bar', true).attr('rx', 2).attr('ry', 2);
        }
        rect.classed('unserved', v.isUnserved).transition().attr('height', v.height).attr('width', v.width).attr('y', GanttConstants.ITEM_MARGIN).style('stroke', v.isPriority ? 'lightcoral' : 'black').style('stroke-width', v.isPriority ? '3' : '1').style('stroke-opacity', v.isPriority ? '1' : '0.2');
        gContainer = gVisit.selectAll('g.container');
        foreignObj = gVisit.selectAll('foreignObject.status-icon');
        if (v.visitStatus !== Constants.visitStatusPending) {
          return _drawCompletedVisit(v, gVisit, gContainer, foreignObj);
        } else {
          return _drawPendingVisit(v, gVisit, gContainer, foreignObj);
        }
      });
    };
    _drawCompletedVisit = function(v, gVisit, gContainer, foreignObj) {
      var icon, x, xhtmlDiv;
      gContainer.remove();
      gContainer = gVisit.append('g').classed('container', true);
      if (v.width > GanttConstants.UPDATE_VISIT_ICON_SIZE) {
        if (foreignObj.empty()) {
          foreignObj = gVisit.append('foreignObject').classed('status-icon', true);
        }
        xhtmlDiv = foreignObj.selectAll('div.clean.icon-gantt');
        if (xhtmlDiv.empty()) {
          xhtmlDiv = foreignObj.append('xhtml:div').attr('class', 'clean icon-gantt');
        }
        icon = foreignObj.selectAll('i.icon');
        if (icon.empty()) {
          icon = xhtmlDiv.append('i').classed('icon', true).classed(ON_TIME_ICON_CLASS, v.updateClass === GanttConstants.VISIT_ON_TIME_CLASS).classed(LATE_ICON_CLASS, v.updateClass === GanttConstants.VISIT_LATE_CLASS).classed(SKIPPED_ICON_CLASS, v.updateClass === GanttConstants.VISIT_SKIPPED_CLASS);
        }
        x = (v.width - 9) / 2;
        return foreignObj.attr('transform', "translate(" + x + ", 0)");
      } else {
        return foreignObj.remove();
      }
    };
    _drawPendingVisit = function(v, gVisit, gContainer, foreignObj) {
      var content, gIcon, gWarning, iUse, minTextWidth, numDigits, text, textWidth, warningIcon, warnings, x, y;
      foreignObj.remove();
      if (gContainer.empty()) {
        gContainer = gVisit.append('g').classed('container', true);
      }
      gIcon = gContainer.selectAll('g.icon');
      text = String(v.index);
      if (gIcon.empty()) {
        gIcon = gContainer.append('g').classed('icon', true).attr('style', "color: " + v.color.rgba);
        gIcon.append('text').classed('content', true);
      }
      numDigits = Math.log(v.index) * Math.LOG10E + 1 | 0;
      textWidth = numDigits * GanttConstants.INDEX_TEXT_WIDTH;
      minTextWidth = text.length * GanttConstants.PER_CHAR_WIDTH;
      content = gIcon.selectAll('text.content');
      if (minTextWidth > v.width) {
        content.text('');
      } else {
        content.text(text);
      }
      x = (v.width - textWidth) / 2;
      y = ((v.height + GanttConstants.INDEX_TEXT_HEIGHT) / 2) + GanttConstants.ITEM_MARGIN;
      content.attr('transform', "translate(" + x + ", " + y + ")");
      warnings = RouteInspectorF.getWarnings(v.id);
      gWarning = gContainer.selectAll('g.warning');
      if ((warnings != null ? warnings.length : void 0) > 0) {
        if (gWarning.empty()) {
          gWarning = gContainer.append('g').classed('warning', true);
          gWarning.append('svg').attr('width', GanttConstants.ICON_SIZE).attr('height', GanttConstants.ICON_SIZE).append('use');
        }
        x = -(GanttConstants.ICON_SIZE / 2);
        y = v.height - (GanttConstants.ICON_SIZE / 2) + GanttConstants.ITEM_MARGIN;
        gWarning.attr('transform', "translate(" + x + ", " + y + ")");
        iUse = gWarning.selectAll('use');
        warningIcon = GanttUtilF.getWarningIcon(warnings);
        return iUse.attr('xlink:href', "#" + warningIcon);
      } else {
        return gWarning.remove();
      }
    };
    BuildVisitsF = function(selection, target, data, forUnserved) {
      var current, newRect, visits;
      _target = target;
      _rowHeight = target.rowHeight();
      _axis = target.axis();
      _unservedIndexRange = target.getUnservedIndexRange();
      visits = _getVisitsData(data, forUnserved);
      current = selection.selectAll('g.visit').data(visits, function(v) {
        return v.id;
      }).call(_drawVisits);
      newRect = current.enter().append("g").call(_drawVisits);
      return current.exit().remove();
    };
    return BuildVisitsF;
  };
  BuildVisitsF.$inject = ["$translate", "GanttUtilF", "GanttConstants", "Constants", "GMarkerF", "RouteInspectorF", "RouteS", "VisitF", "UnservedUtil"];

  angular.module('app').factory('BuildVisitsF', BuildVisitsF);

}).call(this);

(function() {
  var ganttToolTipF = function(Constants, HudF, GanttConstants) {
    var _buildVisitTip, _tooltipBox, _tooltipClass;
    _tooltipBox = angular.element(Constants.tooltipBoxId);
    _tooltipClass = '.gantt-tooltip';
    _buildVisitTip = function(index, text, color) {
      var divider, indexSpan, textSpan, typeDiv;
      if (color == null) {
        color = "";
      }
      if (index != null) {
        indexSpan = "<span>" + index + "</span>";
      }
      divider = index != null ? " | " : "";
      if (text != null) {
        textSpan = "<span>" + divider + (text.charAt(0).toUpperCase()) + (text.slice(1)) + "</span>";
      }
      typeDiv = "class='gantt-text " + color + "'";
      return "<div " + typeDiv + ">" + (indexSpan || "<span></span>") + (textSpan || "") + "</div>";
    };
    return function(container) {
      var gantt;
      if (!_tooltipBox) {
        return;
      }
      gantt = angular.element(container);
      gantt.on('mouseover', function(e) {
        var centered, classNames, color, height, icon, iconNode, index, isCurrentNode, left, offsetX, offsetY, pos, scale, target, text, top, width, x, y, _ref, _ref1, _ref2, _ref3;
        target = angular.element(e.target);
        iconNode = target.parents(_tooltipClass);
        isCurrentNode = target.hasClass(_tooltipClass.slice(1));
        if (iconNode.length > 0 || isCurrentNode) {
          e.stopPropagation();
          icon = iconNode[0] || e.target;
          index = icon.getAttribute('data-tooltip-index');
          text = icon.getAttribute('data-tooltip-text');
          if (!(index || text)) {
            return;
          }
          _ref1 = (_ref = icon.getAttribute('data-tooltip-pos')) != null ? _ref.split(' ') : void 0, pos = _ref1[0], centered = _ref1[1];
          color = icon.getAttribute('data-tooltip-color');
          classNames = (_ref2 = icon.getAttribute('data-tooltip-class')) != null ? _ref2.split(' ') : void 0;
          scale = HudF.getScale();
          _ref3 = icon.getBoundingClientRect(), top = _ref3.top, left = _ref3.left, width = _ref3.width, height = _ref3.height;
          offsetX = 0;
          offsetY = 0;
          if (pos != null) {
            switch (pos) {
              case 'top':
                offsetY = -height;
                if (centered != null) {
                  offsetX = width / 2;
                }
                break;
              case 'bottom':
                offsetY = height;
                if (centered != null) {
                  offsetX = width / 2;
                }
                break;
              case 'left':
                offsetX = -width;
                if (centered != null) {
                  offsetY = height / 2;
                }
                break;
              case 'right':
                offsetX = width;
                if (centered != null) {
                  offsetY = height / 2;
                }
            }
          }
          x = left;
          y = top;
          _tooltipBox[0].style.top = "" + (y + offsetY) + "px";
          _tooltipBox[0].style.left = "" + (x + offsetX) + "px";
          _tooltipBox[0].style.right = "auto";
          _tooltipBox[0].classList.add.apply(_tooltipBox[0].classList, classNames);
          if (pos != null) {
            _tooltipBox[0].classList.add(pos);
          }
          _tooltipBox.html(_buildVisitTip(index, text, color));
          return _tooltipBox[0].classList.add('show');
        }
      });
      gantt.on('mouseout', function() {
        return _tooltipBox[0].classList = "";
      });
      return function() {
        gantt.off('mouseover');
        return gantt.off('mouseout');
      };
    };
  };
  ganttToolTipF.$inject = ["Constants", "HudF", "GanttConstants"];

  angular.module('app').factory('GanttToolTipF', ganttToolTipF);

}).call(this);

(function() {
  var     __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  var GanttUtilF = function(GanttConstants, Constants) {
    var GanttUtil, NEW_STOP_ERROR_MESSAGES;
    NEW_STOP_ERROR_MESSAGES = [Constants.unservedMessages.newStop, Constants.unservedMessages.newVisit];
    GanttUtil = {
      getWarningIcon: function(warnings) {
        var key, text;
        if (warnings.length > 1) {
          return GanttConstants.WARNING_ICON;
        }
        key = warnings[0].key;
        text = key.toLowerCase();
        if (text.indexOf('late') > -1 || text.indexOf('early') > -1) {
          return GanttConstants.CLOCK_ICON;
        } else if (__indexOf.call(NEW_STOP_ERROR_MESSAGES, key) >= 0) {
          return GanttConstants.NEW_VISIT_ICON;
        } else {
          return GanttConstants.WARNING_ICON;
        }
      },
      rectTransform: function(target, axis, d) {
        var end, start, xDate;
        start = d.idleDate || d.startDate;
        end = d.endDate;
        xDate = end > start ? start : end;
        return target.translate(axis.x(xDate), axis.y(d.driverId));
      },
      getVisitWidth: function(axis, startDate, endDate) {
        if (endDate > startDate) {
          return axis.x(endDate) - axis.x(startDate);
        } else {
          return 5;
        }
      }
    };
    return GanttUtil;
  };
  GanttUtilF.$inject = ["GanttConstants", "Constants"];

  angular.module('app').factory('GanttUtilF', GanttUtilF);

}).call(this);

(function() {
  var LabelF = function($state, GanttConstants, Constants, DropZoneEventsF, RouteS, DemoF, $translate, AnalyticsS, MessagingF, AccountF, DispatchF, ProjectF, States, $animate, EventListenersF, Events) {
    var DISPATCH_STATUS, ICON_CLASS, LOCK_ICON_CLASS, REVERSE_ICON_CLASS, ROUTE_INVISIBLE, ROUTE_INVISIBLE_CLASS, ROUTE_VISIBLE, SWAP_ICON_CLASS, _addVisibilityEventListener, _customizeForeignObj, _customizeForeignObjForDropZone, _dropZoneChangeListener, _setRouteVisibility, _toPercent, _toggleRouteLock, _toggleRouteVisibility, _toggleSwapDriverDropdown;
    ICON_CLASS = 'icon-hide';
    ROUTE_VISIBLE = 'show-route';
    ROUTE_INVISIBLE = 'hide-route';
    LOCK_ICON_CLASS = 'icon-lock';
    REVERSE_ICON_CLASS = 'icon-tab';
    SWAP_ICON_CLASS = 'icon-swap-route';
    ROUTE_INVISIBLE_CLASS = Constants.routeInvisibleCSS;
    DISPATCH_STATUS = Constants.DISPATCH_STATUS;
    _toPercent = function(num) {
      return "" + (+num.toFixed(1)) + "%";
    };
    _toggleSwapDriverDropdown = function(element) {
      var isCurrentVisible = element ? true : false;
      return !isCurrentVisible;
    };
    _toggleRouteLock = function(driverId) {
      return RouteS.toggleRouteLock(driverId);
    };
    _toggleRouteVisibility = function(icon, id) {
      var isCurrentVisible;
      var currentClass = icon.attr('class');
      isCurrentVisible = currentClass.indexOf(ROUTE_VISIBLE) > -1;
      return _setRouteVisibility(icon, id, !isCurrentVisible);
    };
    _setRouteVisibility = function(icon, id, isVisible) {
      icon.classed(ROUTE_VISIBLE, isVisible);
      icon.classed(ROUTE_INVISIBLE, !isVisible);
      RouteS.setRouteVisible(id, isVisible);
      return AnalyticsS.track('048 Toggle driver visibility', {
        route_id: id,
        new_state: (isVisible ? 'shown' : 'hidden')
      });
    };
    _addVisibilityEventListener = function(id, selection) {
      var icon = selection.selectAll('i.visibility');
      return RouteS.addVisibilityEventListener(id, function(isVisible) {
        selection.classed(ROUTE_INVISIBLE_CLASS, !isVisible);
        icon.classed(ROUTE_VISIBLE, isVisible);
        return icon.classed(ROUTE_INVISIBLE, !isVisible);
      });
    };
    _dropZoneChangeListener = function(foreignObj, objectDriverId) {
      return function(driverId, type, event) {
        var dropZoneExists, isOnDriverColumn, labelIsHovered;
        if (event === GanttConstants.DROP_ZONE_EVENT_ACTIVATE) {
          dropZoneExists = driverId != null;
          labelIsHovered = driverId === objectDriverId;
          isOnDriverColumn = type === GanttConstants.ZONE_TYPE_DRIVER;
          return _customizeForeignObjForDropZone(foreignObj, dropZoneExists, labelIsHovered, isOnDriverColumn);
        } else if (event === GanttConstants.DROP_ZONE_EVENT_HIDE) {
          return _customizeForeignObjForDropZone(foreignObj, false, false, false);
        }
      };
    };
    _customizeForeignObjForDropZone = function(foreignObj, activeDropZoneExists, rowIsHovered, isOnDriverColumn) {
      foreignObj.classed('drop-zone-active-hover', isOnDriverColumn && activeDropZoneExists && rowIsHovered);
      return foreignObj.classed('drop-zone-active-no-hover', isOnDriverColumn && activeDropZoneExists && !rowIsHovered);
    };
    _customizeForeignObj = function(foreignObj, driver, width, height, name, numUnserved, routeLocks, target) {
      var NOT_SET, STATUS, capacityFill, capacityMeter, capacityText, dispatchStatus, driverSpan, icon, isCapacity, isDriverEmpty, isLateness, isLocked, isUnserved, k, lateFill, lateMeter, lateText, lockIcon, lockText, percent, percentStr, reverseRoute, reverseRouteDisabled, reverseRouteText, swapRoute, swapRouteDisabled, swapRouteText, unservedSuffix, xhtmlDiv, xhtmlDiv2, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _route;
      _route = RouteS.getRoute();
      isUnserved = name === GanttConstants.UNSCHEDULED_DRIVER_NAME;
      isLocked = !!routeLocks[driver.id];
      if (_route) {
        isDriverEmpty = RouteS.isDriverEmpty((_ref = _route.solution) != null ? (_ref1 = _ref.response) != null ? (_ref2 = _ref1[driver.id]) != null ? _ref2.driver : void 0 : void 0 : void 0);
      }
      isCapacity = (_ref3 = target.driverLoadsOverview()) != null ? _ref3[driver.id] : void 0;
      isLateness = (_ref4 = target.driverShiftsOverview()) != null ? _ref4[driver.id] : void 0;
      if (isUnserved) {
        name = $translate.instant(name);
      }
      unservedSuffix = "";
      if (isUnserved && (numUnserved != null)) {
        unservedSuffix = " (" + numUnserved + ")";
      }
      foreignObj.classed('content', true).attr('width', width).attr('height', height);
      xhtmlDiv = foreignObj.selectAll('div.clean');
      if (xhtmlDiv.empty()) {
        xhtmlDiv = foreignObj.append('xhtml:div').classed('clean', true);
      }

      /*
        Route lock icon
       */
      if (!isUnserved && DemoF.isUsableInDemo('routeLock')) {
        lockIcon = foreignObj.selectAll('i.route-lock');
        if (lockIcon.empty()) {
          lockIcon = xhtmlDiv.append('i').attr('class', 'route-lock select gantt-tooltip').classed(LOCK_ICON_CLASS, true);
        }
        lockIcon.classed('locked', isLocked).attr('data-tooltip-pos', 'right centered');
        if (target.isPastProject()) {
          lockIcon.classed('is-disabled', true).attr('data-tooltip-class', null);
          lockText = "MESSAGES.LOCK_ROUTE_DISABLED_PAST";
        } else if (target.chartType() === 'live') {
          lockIcon.classed('is-disabled', true).attr('data-tooltip-class', null);
          lockText = "MESSAGES.LOCK_ROUTE_DISABLED_LIVE";
        } else {
          lockIcon.classed('is-disabled', false).attr('data-tooltip-class', 'dark');
          lockText = isLocked ? "CONSTANTS.UNLOCK_ROUTE" : "CONSTANTS.LOCK_ROUTE";
        }
        lockIcon.attr('data-tooltip-text', $translate.instant(lockText));
        lockIcon.on('click', function() {
          var text, _goToEditRoute, _goToNewProject;
          d3.event.stopPropagation();
          if (target.isPastProject()) {
            _goToNewProject = function() {
              return $state.go(States.modalProjectsNew);
            };
            return MessagingF.replaceInfo("MESSAGES.CANNOT_MODIFY_PAST_PROJECT", null, null, "MESSAGES.START_NEW_PROJECT", _goToNewProject);
          } else if (target.chartType() === 'live') {
            _goToEditRoute = function() {
              return $state.go(States.projectRouteEdit);
            };
            return MessagingF.replaceInfo("MESSAGES.SWITCH_TO_EDIT_MODE", null, null, "MESSAGES.GO_TO_PLAN_MODE", _goToEditRoute);
          } else {
            _toggleRouteLock(driver.id);
            lockIcon.attr('data-tooltip-text', $translate.instant(lockText));
            text = isLocked ? "MESSAGES.UNLOCK_ROUTE_SUCCESS" : "MESSAGES.LOCK_ROUTE_SUCCESS";
            MessagingF.replaceSuccessPopup(text, {
              name: name
            });
            return reverseRoute.classed('is-disabled', !isLocked);
          }
        });
      }

      /*
          Visibility Icon
       */
      icon = foreignObj.selectAll('i.visibility');
      if (icon.empty()) {
        icon = xhtmlDiv.append('i');
      }
      icon.classed('visibility', true).classed('select', true).classed(ROUTE_VISIBLE, true).classed(ICON_CLASS, true).classed('unserved', isUnserved).attr('title', "Hide/show driver");
      icon.on('click', function() {
        d3.event.stopPropagation();
        return _toggleRouteVisibility(icon, driver.id);
      });

      /*
        Driver name
       */
      driverSpan = xhtmlDiv.selectAll('span.driver-name');
      if (driverSpan.empty()) {
        driverSpan = xhtmlDiv.append('span').classed('driver-name', true).classed('no-text-overflow', true);
      }
      driverSpan.classed('unserved', isUnserved).text("" + name + unservedSuffix);

      /*
          Dispatch Icon
       */
      dispatchStatus = xhtmlDiv.selectAll('span.dispatch-icon');
      if (dispatchStatus.empty() && !isUnserved) {
        dispatchStatus = xhtmlDiv.append('span').attr('class', 'dispatch-icon').attr('data-tooltip-class', 'dark').attr('data-tooltip-pos', 'right centered');
      }
      for (k in DISPATCH_STATUS) {
        STATUS = DISPATCH_STATUS[k];
        dispatchStatus.classed(STATUS.className, ((_ref5 = driver.dispatchStatus) != null ? _ref5.className : void 0) === STATUS.className);
      }
      if ((_ref6 = driver.dispatchStatus) != null ? _ref6.text : void 0) {
        dispatchStatus.classed('gantt-tooltip', true).attr('data-tooltip-text', driver.dispatchStatus.text);
      } else {
        dispatchStatus.classed('gantt-tooltip', false);
      }

      /*
        Swap route icon
       */
      swapRoute = xhtmlDiv.selectAll('span.swap-route');
      if (swapRoute.empty() && !isUnserved) {
        swapRoute = xhtmlDiv.append('span').attr('class', 'swap-route gantt-tooltip').attr('data-tooltip-text', 'CONSTANTS.SWAP_ROUTE').classed(SWAP_ICON_CLASS, true);
      }
      swapRouteDisabled = true;
      if (target.isPastProject()) {
        swapRouteText = "MESSAGES.SWAP_ROUTE_DISABLED_PAST";
      } else if (RouteS.isDriverHasServedStops(driver)) {
        swapRouteText = "MESSAGES.NO_SWAP_AFTER_SERVED";
      } else if (target.chartType() === 'live') {
        swapRouteText = "MESSAGES.SWAP_ROUTE_DISABLED_LIVE";
      } else if (isLocked) {
        swapRouteText = "MESSAGES.SWAP_ROUTE_DISABLED_LOCK";
      } else {
        swapRouteDisabled = false;
        swapRouteText = "CONSTANTS.SWAP_ROUTE";
      }
      if (swapRouteDisabled) {
        swapRoute.attr('data-tooltip-class', null).attr('data-tooltip-pos', 'right');
      } else {
        swapRoute.attr('data-tooltip-class', 'dark').attr('data-tooltip-pos', 'top centered');
      }
      swapRoute.classed('is-disabled', swapRouteDisabled).attr('data-tooltip-text', $translate.instant(swapRouteText));
      swapRoute.on('click', function() {
        var data, swapContainer, toggleSwapState, _goToEditRoute, _goToNewProject;
        if (RouteS.isDriverHasServedStops(driver) || isLocked) {

        } else if (target.chartType() === 'live') {
          _goToEditRoute = function() {
            return $state.go(States.projectRouteEdit);
          };
          return MessagingF.replaceInfo("MESSAGES.SWITCH_TO_EDIT_MODE", null, null, "MESSAGES.GO_TO_PLAN_MODE", _goToEditRoute);
        } else if (target.isPastProject()) {
          _goToNewProject = function() {
            return $state.go(States.modalProjectsNew);
          };
          return MessagingF.replaceInfo("MESSAGES.CANNOT_MODIFY_PAST_PROJECT", null, null, "MESSAGES.START_NEW_PROJECT", _goToNewProject);
        } else if (target.chartType() === 'debug') {
          return MessagingF.replaceInfoPopup("MESSAGES.CANNOT_MODIFY_DEBUG_PROJECT");
        } else {
          swapContainer = document.querySelector(".swap-driver-container");
          toggleSwapState = _toggleSwapDriverDropdown(swapContainer);
          data = {
            id: driver.id,
            name: name,
            drivers: target.drivers(),
            toggle: toggleSwapState
          };
          return EventListenersF.notify(Events.SWAP_DRIVERS, data);
        }
      });

      /*
        Reverse route icon
       */
      reverseRoute = xhtmlDiv.selectAll('span.reverse-route');
      if (reverseRoute.empty() && !isUnserved && DemoF.isUsableInDemo('reverseRoute')) {
        reverseRoute = xhtmlDiv.append('span').attr('class', 'reverse-route gantt-tooltip').classed(REVERSE_ICON_CLASS, true);
      }
      reverseRouteDisabled = true;
      if (target.isPastProject()) {
        reverseRouteText = "MESSAGES.REVERSE_ROUTE_DISABLED_PAST";
      } else if (RouteS.isDriverHasServedStops(driver)) {
        reverseRouteText = "MESSAGES.NO_REVERSE_AFTER_SERVED";
      } else if (target.chartType() === 'live') {
        reverseRouteText = "MESSAGES.REVERSE_ROUTE_DISABLED_LIVE";
      } else if (isLocked) {
        reverseRouteText = "MESSAGES.REVERSE_ROUTE_DISABLED_LOCK";
      } else if (isDriverEmpty) {
        reverseRoute.classed('hidden', true);
      } else {
        reverseRouteDisabled = false;
        reverseRouteText = "CONSTANTS.REVERSE_ROUTE";
        reverseRoute.classed('hidden', false);
      }
      if (reverseRouteDisabled) {
        reverseRoute.attr('data-tooltip-class', null).attr('data-tooltip-pos', 'right');
      } else {
        reverseRoute.attr('data-tooltip-class', 'dark').attr('data-tooltip-pos', 'top centered');
      }
      reverseRoute.classed('is-disabled', reverseRouteDisabled).attr('data-tooltip-text', $translate.instant(reverseRouteText));
      reverseRoute.on('click', function() {
        var _goToEditRoute, _goToNewProject;
        if (RouteS.isDriverHasServedStops(driver) || isLocked) {

        } else if (target.chartType() === 'live') {
          _goToEditRoute = function() {
            return $state.go(States.projectRouteEdit);
          };
          return MessagingF.replaceInfo("MESSAGES.SWITCH_TO_EDIT_MODE", null, null, "MESSAGES.GO_TO_PLAN_MODE", _goToEditRoute);
        } else if (target.isPastProject()) {
          _goToNewProject = function() {
            return $state.go(States.modalProjectsNew);
          };
          return MessagingF.replaceInfo("MESSAGES.CANNOT_MODIFY_PAST_PROJECT", null, null, "MESSAGES.START_NEW_PROJECT", _goToNewProject);
        } else if (target.chartType() === 'debug') {
          return MessagingF.replaceInfoPopup("MESSAGES.CANNOT_MODIFY_DEBUG_PROJECT");
        } else {
          AnalyticsS.track('Reverse route', {
            "project_id": ProjectF.project.id,
            "user_email": AccountF.getUser().email,
            "before_first_dispatch": !DispatchF.hasDispatches()
          });
          return EventListenersF.notify(Events.FIX_ROUTE_IN_PROGRESS).then(function() {
            return RouteS.reverseRoute(driver);
          }).then(function() {
            return EventListenersF.notify(Events.PROJECT_MODIFIED);
          }).then(function() {
            var callback, successMessage;
            successMessage = $translate.instant("MESSAGES.SUCCESSFUL_REVERSE", {
              name: name
            });
            MessagingF.replaceSuccessPopup(successMessage);
            $animate.removeClass(angular.element(document.querySelector('.animated')), 'pulse');
            callback = function() {
              return $animate.addClass(angular.element(document.querySelector('.animated')), 'pulse');
            };
            return setTimeout(callback, 0);
          })["catch"](function(err) {
            return MessagingF.replaceError(err);
          })["finally"](function() {
            return EventListenersF.notify(Events.FIX_ROUTE_COMPLETED);
          });
        }
      });

      /*
        Capacity & Time meters
       */
      if (!isUnserved && (target.loadColumn() || target.timeColumn())) {
        xhtmlDiv2 = foreignObj.selectAll('div.clean-meter');
        if (xhtmlDiv2.empty()) {
          xhtmlDiv2 = foreignObj.append('xhtml:div').classed('clean-meter', true);
        }
        NOT_SET = $translate.instant("CONSTANTS.NOT_SET");
        if ((isCapacity != null) || target.loadColumn()) {
          capacityMeter = foreignObj.selectAll('div.capacity');
          if (capacityMeter.empty()) {
            capacityMeter = xhtmlDiv2.append('div');
          }
          capacityFill = capacityMeter.select('div:nth-child(1)');
          if (capacityFill.empty()) {
            capacityFill = capacityMeter.append('div');
          }
          capacityText = capacityMeter.select('div:nth-child(2)');
          if (capacityText.empty()) {
            capacityText = capacityMeter.append('div');
          }
          percent = ((isCapacity != null ? isCapacity.loads : void 0) / (isCapacity != null ? isCapacity.capacity : void 0)) * 100;
          percentStr = _toPercent(percent);
          capacityMeter.classed('capacity', true).classed('is-disabled', isCapacity == null).classed('is-over', percent > 94);
          capacityFill.style('width', percentStr);
          capacityText.text(isCapacity != null ? percentStr : NOT_SET);
        }
        if ((isLateness != null) || target.timeColumn()) {
          lateMeter = foreignObj.selectAll('div.lateness');
          if (lateMeter.empty()) {
            lateMeter = xhtmlDiv2.append('div');
          }
          lateFill = lateMeter.select('div:nth-child(1)');
          if (lateFill.empty()) {
            lateFill = lateMeter.append('div');
          }
          lateText = lateMeter.select('div:nth-child(2)');
          if (lateText.empty()) {
            lateText = lateMeter.append('div');
          }
          percent = ((isLateness != null ? isLateness.actualWorkingTime : void 0) / (isLateness != null ? isLateness.plannedShitTime : void 0)) * 100;
          percentStr = _toPercent(percent);
          lateMeter.classed('lateness', true).classed('is-disabled', isLateness == null).classed('is-over', percent > 94);
          lateFill.style('width', percentStr);
          return lateText.text(isLateness != null ? percentStr : NOT_SET);
        }
      }
    };
    return function(target) {
      var drivers, height, numUnserved, routeLocks, width;
      var axis = target.axis();
      drivers = target.drivers();
      height = axis.y.rangeBand();
      width = target.margin().left;
      numUnserved = target.numUnserved();
      routeLocks = target.routeLocks();
      return function(selection) {
        return selection.each(function(d) {
          var foreignObj, gItem, id, y;
          gItem = d3.select(this);
          id = d.id;
          y = d.yPos;
          gItem.classed('item', true).attr('transform', "translate(" + (-width) + ", " + y + ")").classed('locked', routeLocks[id]);
          foreignObj = gItem.selectAll('.content');
          if (foreignObj.empty()) {
            foreignObj = gItem.append('foreignObject');
          }
          _customizeForeignObj(foreignObj, d, width, height, drivers[id], numUnserved, routeLocks, target);
          DropZoneEventsF.addListener(_dropZoneChangeListener(foreignObj, id));
          return _addVisibilityEventListener(id, gItem);
        });
      };
    };
  };
  LabelF.$inject = ["$state", "GanttConstants", "Constants", "DropZoneEventsF", "RouteS", "DemoF", "$translate", "AnalyticsS", "MessagingF", "AccountF", "DispatchF", "ProjectF", "States", "$animate", "EventListenersF", "Events"];

  angular.module('app').factory('LabelF', LabelF);

}).call(this);

(function() {
  var IRouteDebugC = function(RouteS, IRouteDebugF, MessagingF) {
    IRouteDebugF.clearDebugInfo();
    this.route = null;
    this.getDebugInfo = function() {
      this.route = RouteS.getRoute();
      return IRouteDebugF.fetchDebugInfo(this.route)["catch"](function(e) {
        return MessagingF.replaceInfoPopup(e);
      });
    };
    this.getSteps = function() {
      return IRouteDebugF.getDebugInfo();
    };
    this.loadStep = function(step) {
      var fleet, route, visits;
      route = _.cloneDeep(this.route);
      if (step !== 'globalFix') {
        delete route.polylines;
      }
      fleet = route.solution.request.fleet;
      visits = route.solution.request.visits;
      step = IRouteDebugF.findStep(step);
      route.solution = step.solution;
      route.unserved = step.unserved;
      if (step.clusters != null) {
        route.clusters = step.clusters;
      }
      return RouteS.replace(route, visits, fleet);
    };
    return this;
  };

  angular.module('app').controller('IRouteDebugC', ['RouteS', 'IRouteDebugF', 'MessagingF', IRouteDebugC]);

}).call(this);

(function() {
  var ERROR_JOB_STATUS, FINISH_JOB_STATUS, IRouteDebugF;

  FINISH_JOB_STATUS = 'finished';

  ERROR_JOB_STATUS = 'error';

  IRouteDebugF = function($http, Constants, Messages, AccountF) {
    var _debug;
    _debug = null;
    IRouteDebugF = {};
    IRouteDebugF.clearDebugInfo = function() {
      return IRouteDebugF._debug = null;
    };
    IRouteDebugF.getDebugInfo = function() {
      return IRouteDebugF._debug;
    };
    IRouteDebugF.fetchDebugInfo = function(route) {
      var debug;
      if (!route) {
        return;
      }
      debug = route != null ? route.debug : void 0;
      return new Promise(function(resolve, reject) {
        var authHeader;
        if (debug != null) {
          if (typeof debug === 'string') {
            reject(debug);
          }
          IRouteDebugF._debug = _.cloneDeep(debug);
          return resolve(debug);
        } else if (route.jobId && !debug) {
          authHeader = AccountF.getAuthHeader();
          return $http.get("" + Constants.apiPath + "/jobs/" + route.jobId, authHeader).then(function(res) {
            var job = res.data;
            if (job.status === ERROR_JOB_STATUS) {
              return reject(Messages.DEBUG_RUN_ERROR);
            }
            if (job.status !== FINISH_JOB_STATUS) {
              return reject(Messages.DEBUG_RUN_INCOMPLETE);
            }
            if (!job.output.debug) {
              return reject(Messages.DEBUG_NOT_FOUND);
            }
            if (typeof job.output.debug === 'string') {
              return reject(job.output.debug);
            }
            IRouteDebugF._debug = job.output.debug;
            return resolve(IRouteDebugF._debug);
          });
        } else {
          return reject(Messages.DEBUG_NOT_FOUND);
        }
      });
    };
    IRouteDebugF.findStep = function(name) {
      var step;
      if (!name) {
        return;
      }
      step = _.cloneDeep(IRouteDebugF._debug[name]);
      return step;
    };
    return IRouteDebugF;
  };

  angular.module('app').factory('IRouteDebugF', ['$http', 'Constants', 'Messages', IRouteDebugF]);

}).call(this);

(function() {
  var IProjectValidator = function() {
    var _buildVisitErrorMessage, _checkDriverAssignment, _checkSolutionCorruption, _isArrivalAfterFinish, _isMissingInVisitsList;
    _checkDriverAssignment = function(fleet, routes) {
      var driverId, foundDriver, route, visibleDrivers, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _results;
      visibleDrivers = [];
      _ref = Object.keys(fleet);
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        driverId = _ref[_i];
        if ((_ref1 = fleet[driverId]) != null ? _ref1.visible : void 0) {
          visibleDrivers.push(driverId);
        }
      }
      _results = [];
      for (_j = 0, _len1 = visibleDrivers.length; _j < _len1; _j++) {
        driverId = visibleDrivers[_j];
        foundDriver = false;
        for (_k = 0, _len2 = routes.length; _k < _len2; _k++) {
          route = routes[_k];
          if (route._id === driverId) {
            foundDriver = true;
            break;
          }
        }
        if (!foundDriver) {
          throw new Error("Potential mismatch between selected drivers and routes (" + fleet[driverId].name + ")");
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };
    _isArrivalAfterFinish = function(visit) {
      return visit.arrival_time > visit.finish_time;
    };
    _isMissingInVisitsList = function(visitId, visitsList) {
      return !visitsList.includes(visitId);
    };
    _buildVisitErrorMessage = function(error, visitId, routeId, visitIndex, routeIndex) {
      return "Error: " + error + ";  Visit id: " + visitId + ";  Visit index: " + visitIndex + ";  Route id: " + routeId + ";  Route index: " + routeIndex;
    };
    _checkSolutionCorruption = function(routes, visitsList, solutionType) {
      var route, routeIndex, visit, visitIndex, _i, _len, _results;
      _results = [];
      for (routeIndex = _i = 0, _len = routes.length; _i < _len; routeIndex = ++_i) {
        route = routes[routeIndex];
        _results.push((function() {
          var _j, _len1, _ref, _results1;
          _ref = route.visits;
          _results1 = [];
          for (visitIndex = _j = 0, _len1 = _ref.length; _j < _len1; visitIndex = ++_j) {
            visit = _ref[visitIndex];
            if (visit.finish_time && visit["break"] !== true) {
              if (_isArrivalAfterFinish(visit)) {
                throw new Error(_buildVisitErrorMessage("Visit in " + solutionType + " has arrival after finish time", visit.id, route._id, visitIndex, routeIndex));
              }
              if (_isMissingInVisitsList(visit.id, visitsList)) {
                throw new Error(_buildVisitErrorMessage("Visit in " + solutionType + " is missing in visits list", visit.id, route._id, visitIndex, routeIndex));
              } else {
                _results1.push(void 0);
              }
            } else {
              _results1.push(void 0);
            }
          }
          return _results1;
        })());
      }
      return _results;
    };
    IProjectValidator = {};
    IProjectValidator.checkProjectCorruption = function(project) {
      var visitId, visitsList, _i, _j, _len, _len1, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;
      visitsList = Object.keys(project.visits);
      if ((project != null ? (_ref = project.dispatchedSolution) != null ? _ref.routes : void 0 : void 0) != null) {
        _checkSolutionCorruption(project.dispatchedSolution.routes, visitsList, 'dispatched solution');
      }
      if ((project != null ? (_ref1 = project.solution) != null ? _ref1.routes : void 0 : void 0) != null) {
        _checkSolutionCorruption(project.solution.routes, visitsList, 'solution');
      }
      if ((project != null ? (_ref2 = project.solution) != null ? _ref2.unserved : void 0 : void 0) != null) {
        _ref3 = Object.keys(project.solution.unserved);
        for (_i = 0, _len = _ref3.length; _i < _len; _i++) {
          visitId = _ref3[_i];
          if (_isMissingInVisitsList(visitId, visitsList)) {
            throw new Error("Unscheduled Visit in solution is missing in visits list: " + visitId);
          }
        }
      }
      if ((project != null ? (_ref4 = project.dispatchedSolution) != null ? _ref4.unserved : void 0 : void 0) != null) {
        _ref5 = Object.keys(project.dispatchedSolution.unserved);
        for (_j = 0, _len1 = _ref5.length; _j < _len1; _j++) {
          visitId = _ref5[_j];
          if (_isMissingInVisitsList(visitId, visitsList)) {
            throw new Error("Unscheduled Visit in dispatched solution is missing in visits list: " + visitId);
          }
        }
      }
      if ((project != null ? (_ref6 = project.dispatchedSolution) != null ? _ref6.routes : void 0 : void 0) != null) {
        _checkDriverAssignment(project != null ? project.fleet : void 0, project != null ? (_ref7 = project.dispatchedSolution) != null ? _ref7.routes : void 0 : void 0);
      }
      if ((project != null ? (_ref8 = project.solution) != null ? _ref8.routes : void 0 : void 0) != null) {
        return _checkDriverAssignment(project != null ? project.fleet : void 0, project != null ? (_ref9 = project.solution) != null ? _ref9.routes : void 0 : void 0);
      }
    };
    return IProjectValidator;
  };

  angular.module('app').factory('IProjectValidator', IProjectValidator);

}).call(this);

(function() {
  var Feature, Flags, k, v;

  Flags = {
    LIVE_TRACKING: 'liveTracking',
    SIGNATURE: 'signature',
    LIVE_CHAT: 'liveChat',
    CUSTOMER_NOTIFICATION: 'customerNotification',
    GPS_TRACKING: 'gpsTracking'
  };

  Feature = {};

  Feature.ALL_ADD_ONS = [];

  for (k in Flags) {
    v = Flags[k];
    Feature[k] = v;
    Feature.ALL_ADD_ONS.push(v);
  }

  Feature.CUSTOMER_NOTIFICATION_FLAG = {
    ETA: 'eta',
    DRIVER_ON_THE_WAY: 'driverOnTheWay',
    DELIVERY_CONFIRMATION: 'deliveryConfirmation',
    CANCELLED: 'cancelled',
    ENFORCED_MESSAGE_TRUNCATE_LENGTH: 'enforcedMessageTruncateLength'
  };

  angular.module('app').constant('Feature', Feature);

}).call(this);

(function() {
  var MapStyleC = [
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "administrative.country",
      elementType: "all",
      stylers: [
        {
          visibility: "on"
        }
      ]
    }, {
      featureType: "administrative.province",
      elementType: "all",
      stylers: [
        {
          visibility: "on"
        }
      ]
    }, {
      featureType: "administrative.locality",
      elementType: "all",
      stylers: [
        {
          visibility: "on"
        }
      ]
    }, {
      featureType: "administrative.neighborhood",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "administrative.land_parcel",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "landscape.natural",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#c4eeb5"
        }
      ]
    }, {
      featureType: "landscape.natural.terrain",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#bde6af"
        }
      ]
    }, {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "poi",
      elementType: "labels",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "poi.attraction",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "poi.business",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "poi.government",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "poi.medical",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "poi.park",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "poi.place_of_worship",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "poi.school",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "poi.sports_complex",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }, {
      featureType: "transit.station",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }
  ];

  angular.module('app').constant('MapStyleC', MapStyleC);

}).call(this);

(function() {
  var colors, unservedColor;
  var Color = (function() {
    function Color(name, rgba) {
      this.name = name;
      this.rgba = rgba;
    }

    return Color;

  })();

  colors = [new Color('colorDriverViolet', 'rgba(88,86,214,0.7)'), new Color('colorDriverPink', 'rgba(255,45,85,0.7)'), new Color('colorDriverBlue', 'rgba(0,122,255,0.7)'), new Color('colorDriverOrange', 'rgba(255,149,0,0.7)'), new Color('colorDriverLimeGreen', 'rgba(170,215,35,0.9)'), new Color('colorDriverGreen', 'rgba(76,217,100,0.7)'), new Color('colorDriverFushcia', 'rgba(239,66,148,0.7)'), new Color('colorDriverYellow', 'rgba(255,204,0,0.7)'), new Color('colorDriverLightBlue', 'rgba(52,170,220,0.7)'), new Color('colorDriverBloodOrange', 'rgba(255,59,48,0.7)'), new Color('colorDriverBlueGreen', 'rgba(90,200,250,0.7)'), new Color('colorDriverGrey', 'rgba(142,142,147,0.7)')];

  unservedColor = new Color('colorDriverUnserved', 'rgba(74,72,71, 0.8)');

  angular.module('app').constant('PolylineColors', colors).constant('UnservedColor', unservedColor);

}).call(this);

(function() {
  var EventListenersF = function($q, Events) {
    var _listeners;
    _listeners = {};
    EventListenersF = {};
    EventListenersF.addEventListener = function(key, cb) {
      _listeners[key] || (_listeners[key] = []);
      _listeners[key].push(cb);
      return true;
    };
    EventListenersF.notify = function(key, arg) {
      var callback, promise, promises, _i, _len, _ref, _ref1;
      if (!(((_ref = _listeners[key]) != null ? _ref.length : void 0) > 0)) {
        return $q.when(true);
      }
      promises = [];
      _ref1 = _listeners[key];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        callback = _ref1[_i];
        promise = callback(arg);
        if (promise != null ? promise.then : void 0) {
          promises.push(promise);
        } else {
          promises.push($q.when(true));
        }
      }
      return $q.all(promises);
    };
    EventListenersF.removeEventListener = function(key, cb) {
      var index = _listeners[key].indexOf(cb);
      if (index !== -1) {
        return _listeners[key].splice(index, 1);
      }
    };
    return EventListenersF;
  };
  EventListenersF.$inject = ["$q", "Events"];

  angular.module('app').factory('EventListenersF', EventListenersF);

}).call(this);

(function() {
  var ClassStateD = function($state) {
    return {
      restrict: 'A',
      scope: {},
      link: function(scope, elem, attrs) {
        var data = scope.$eval(attrs.classStateD);
        data = _.mapValues(data, function(states) {
          if (_.isArray(states)) {
            return states;
          }
          return [states];
        });
        return scope.$on("$stateChangeSuccess", function() {
          return _.forEach(data, function(states, className) {
            var found = _.find(states, $state.includes);
            if (found) {
              elem.addClass(className);
            } else {
              elem.removeClass(className);
            }
            return true;
          });
        });
      }
    };
  };
  ClassStateD.$inject = ["$state"];

  angular.module('app').directive('classStateD', ClassStateD);

}).call(this);

(function() {
  var MapD = function(Constants, EventListenersF, Events, $rootScope, MapStyleC, MapF) {
    return {
      restrict: 'E',
      replace: false,
      transclude: true,
      scope: {
        options: '=?'
      },
      templateUrl: 'map.html',
      link: {
        pre: function($scope, $elem, $attrs) {
          var options;
          var mapElem = $elem.find(".map")[0];
          options = _.clone($scope.options);
          if (options.zoom > 3) {
            options.styles = MapStyleC;
          }
          $scope.map = new google.maps.Map(mapElem, options);
          google.maps.event.addDomListener($scope.map, 'tilesloaded', function() {
            var mtc, scaleDiv, zoomDiv;
            var mapDiv = $('.map');
            mtc = mapDiv.find('.gmnoprint > .gm-style-mtc').parent();
            mtc.addClass('map-type-control');
            zoomDiv = mapDiv.find('.gmnoprint > .gmnoprint > div > button[title="Zoom in"]');
            scaleDiv = zoomDiv.parent().parent();
            return scaleDiv.addClass('map-scale-control');
          });
          return MapF.setMap($scope.map);
        },
        post: function($scope, $elem, $attrs) {
          google.maps.event.addListenerOnce($scope.map, 'idle', function() {
            var xOffset, yOffset, zoomOffset, _ref, _ref1;
            var options = _.clone($scope.options);
            if (options.bounds) {
              zoomOffset = options.zoomOffset || 1;
              xOffset = ((_ref = options.offset) != null ? _ref.x : void 0) || 0;
              yOffset = ((_ref1 = options.offset) != null ? _ref1.y : void 0) || 0;
              return MapF.panToBounds(options.bounds, xOffset, yOffset, zoomOffset);
            }
          });
          if (Constants.isDispatcherApp) {
            EventListenersF.addEventListener(Events.ROUTE_CHART_HEIGHT_CHANGED, function(height) {
              return $scope.staticOffset.y = (height - Constants.headerAndTabOffset) / 2;
            });
            $rootScope.$on('RESET_MAP_SIZE', function() {
              $scope.staticOffset.x = 0;
              return $scope.staticOffset.y = 0;
            });
            $rootScope.$on('SIDE_PANEL_OPEN_SUCCESS', function() {
              return $scope.staticOffset.x = (Constants.sidePanelOffset - Constants.leftNavOffset) / 2;
            });
            $rootScope.$on('SIDE_PANEL_CLOSED_SUCCESS', function() {
              return $scope.staticOffset.x = 0;
            });
            return EventListenersF.addEventListener(Events.DEMO_MAP_CHANGED, (function(_this) {
              return function(setDefault) {
                var coords;
                if (setDefault) {
                  coords = Constants.vancouver.coords;
                  $scope.map.panTo(new google.maps.LatLng(coords.lat, coords.lng));
                }
                $scope.map.setZoom(10);
                return $scope.map.setOptions({
                  styles: MapStyleC
                });
              };
            })(this));
          }
        }
      },
      controller: ["$scope", function($scope) {
        var _lastLocation, _lastOffset;
        $scope.staticOffset = {
          x: 0,
          y: 0
        };
        _lastLocation = {
          lat: 0,
          lng: 0
        };
        _lastOffset = {
          x: 0,
          y: 0
        };
        this.getMap = function() {
          return $scope.map;
        };
        this.center = function(lat, lng, x, y) {
          _lastLocation = new google.maps.LatLng(lat, lng);
          _lastOffset.x = x || 0;
          _lastOffset.y = y || 0;
          $scope.map.panTo(_lastLocation);
          return this.recenter();
        };
        return this.recenter = function() {
          var yOffset;
          var xOffset = $scope.staticOffset.x + _lastOffset.x;
          yOffset = $scope.staticOffset.y + _lastOffset.y;
          return $scope.map.panBy(xOffset, yOffset);
        };
      }]
    };
  };
  MapD.$inject = ["Constants", "EventListenersF", "Events", "$rootScope", "MapStyleC", "MapF"];

  angular.module('app').directive('mapD', MapD);

}).call(this);

(function() {
  var MultiDay = function($filter) {
    return function(value) {
      var extraDay, str;
      if (!(value && value instanceof Date)) {
        return;
      }
      extraDay = value.getDate() - 1;
      str = $filter('date')(value, 'HH:mm');
      if (extraDay > 0) {
        str = "" + str + "+" + extraDay;
      }
      return str;
    };
  };
  MultiDay.$inject = ["$filter"];

  angular.module('app').filter('multiDay', MultiDay);

}).call(this);

(function() {
  var MultiDayStr = function($filter, TimeUtilF) {
    return function(value) {
      var date = TimeUtilF.convertTimeToDate(value);
      return $filter('multiDay')(date);
    };
  };
  MultiDayStr.$inject = ["$filter", "TimeUtilF"];

  angular.module('app').filter('multiDayStr', MultiDayStr);

}).call(this);

(function() {
  var MapControllerF = function($q, SvgMarkerF, EventListenersF, Events) {
    var MAP_NOT_SET_ERROR, MIN_ZOOM, NO_POSITION_ERROR, _offset;
    MAP_NOT_SET_ERROR = $q.reject(new Error('Map has not been set'));
    NO_POSITION_ERROR = $q.reject(new Error('No position has been provided'));
    MIN_ZOOM = 15;
    _offset = function(map, x, y) {
      var xOffset, yOffset;
      if (!((map != null) && (x != null) && (y != null))) {
        return;
      }
      xOffset = x || 0;
      yOffset = y || 0;
      return map.panBy(xOffset, yOffset);
    };
    MapControllerF = (function() {
      function MapControllerF(map, marker) {
        this.map = map;
        this.marker = marker;
      }

      MapControllerF.prototype.setMap = function(map, isMain) {
        if (isMain == null) {
          isMain = true;
        }
        if (isMain) {
          EventListenersF.notify(Events.MAP_SET, map);
        }
        return this.map = map;
      };

      MapControllerF.prototype.calculateLatLngBound = function(points) {
        var current, latLngBounds, _i, _len;
        latLngBounds = new google.maps.LatLngBounds();
        for (_i = 0, _len = points.length; _i < _len; _i++) {
          current = points[_i];
          latLngBounds.extend(new google.maps.LatLng(current.lat, current.lng));
        }
        return latLngBounds;
      };

      MapControllerF.prototype.getCurrentPosition = function() {
        var error, geolocation, success;
        var deferred = $q.defer();
        geolocation = navigator.geolocation;
        if (geolocation) {
          success = function(position) {
            var lng;
            var lat = position.coords.latitude;
            lng = position.coords.longitude;
            return deferred.resolve({
              lat: lat,
              lng: lng
            });
          };
          error = function() {
            return deferred.reject(new Error('Failed to get current position'));
          };
          geolocation.getCurrentPosition(success, error);
        } else {
          return $q.reject(new Error('Geolocation not enabled in browser'));
        }
        return deferred.promise;
      };

      MapControllerF.prototype.center = function(lat, lng, x, y, zoomLevel) {
        if (!this.map) {
          return MAP_NOT_SET_ERROR;
        }
        if (zoomLevel != null) {
          this.map.setZoom(zoomLevel);
        }
        this.map.panTo(new google.maps.LatLng(lat, lng));
        _offset(this.map, x, y);
        return $q.when(true);
      };

      MapControllerF.prototype.isPositionShown = function(pos) {
        var bounds, position;
        if (!(this.map && this.marker)) {
          return false;
        }
        position = new google.maps.LatLng(pos.lat, pos.lng);
        bounds = this.map.getBounds();
        return bounds.contains(position);
      };

      MapControllerF.prototype.showPosition = function(pos) {
        if (!this.map) {
          return MAP_NOT_SET_ERROR;
        }
        if (!pos) {
          return NO_POSITION_ERROR;
        }
        if (this.marker) {
          this.marker.setMap(null);
          this.marker = null;
        }
        this.marker = new SvgMarkerF(pos, SvgMarkerF.markers.current, this.map);
        this.center(pos.lat, pos.lng);
        return $q.when(true);
      };

      MapControllerF.prototype.panToBounds = function(bounds, x, y, zoomOffset) {
        var zoomLevel;
        if (zoomOffset == null) {
          zoomOffset = 0;
        }
        if (!bounds) {
          return;
        }
        if (!this.map) {
          return MAP_NOT_SET_ERROR;
        }
        this.map.fitBounds(bounds);
        _offset(this.map, x, y);
        zoomLevel = this.map.getZoom() || MIN_ZOOM;
        this.map.setZoom(zoomLevel - zoomOffset);
        if (this.map.getZoom() > MIN_ZOOM) {
          this.map.setZoom(MIN_ZOOM);
        }
        return $q.when(true);
      };

      MapControllerF.prototype.panToPoints = function(points, x, y, zoomOffset) {
        var bounds;
        if (!points) {
          return;
        }
        if (!this.map) {
          return MAP_NOT_SET_ERROR;
        }
        bounds = this.calculateLatLngBound(points);
        return this.panToBounds(bounds, x, y, zoomOffset);
      };

      MapControllerF.prototype.panToVisits = function(visits, x, y) {
        var current, points, position;
        if (!visits) {
          return;
        }
        if (!this.map) {
          return MAP_NOT_SET_ERROR;
        }
        points = (function() {
          var _i, _len, _results;
          _results = [];
          for (_i = 0, _len = visits.length; _i < _len; _i++) {
            current = visits[_i];
            _results.push(current.location);
          }
          return _results;
        })();
        if (this.marker) {
          position = this.marker.position;
          points.push({
            lat: position.lat(),
            lng: position.lng()
          });
        }
        return this.panToPoints(points, x, y, 0);
      };

      return MapControllerF;

    })();
    return MapControllerF;
  };
  MapControllerF.$inject = ["$q", "SvgMarkerF", "EventListenersF", "Events"];

  angular.module('app').factory('MapControllerF', MapControllerF);

}).call(this);

(function() {
  var MapF = function(MapControllerF) {
    return new MapControllerF();
  };

  angular.module('app').factory('MapF', ['MapControllerF', MapF]);

}).call(this);

(function() {
  var MarkerClustererF = function($state, ClusterStyles, GMarkerF, EventListenersF, Events, States, VisitF, Constants) {
    var OFFSET, OPTIONS, UNSERVED_COLOR, UNSERVED_VEH_ID, _addMarkerToClusterer, _clusterers, _getNewClusterer, _initEventListeners, _map, _removeMarkerFromClusterer, _setMap;
    UNSERVED_VEH_ID = 'none';
    UNSERVED_COLOR = 'colorDriverUnserved';
    OPTIONS = {
      minimumClusterSize: 5,
      maxZoom: 16,
      averageCenter: false,
      zoomOnClick: false,
      ignoreHidden: true
    };
    OFFSET = {
      DEFAULT: {
        x: -800,
        y: 0,
        zoomOffset: 1
      },
      ROUTE_VIEW: {
        x: 0,
        y: 150,
        zoomOffset: 1
      }
    };
    _clusterers = {};
    _map = null;
    _getNewClusterer = function(map, markers, options) {
      var clusterer = new MarkerClusterer(map, markers, options);
      google.maps.event.addListener(clusterer, 'clusterclick', function(cluster) {
        var offsetPoint, zoomLevel;
        var bounds = cluster.getBounds();
        map = cluster.getMap();
        map.fitBounds(bounds);
        if ($state.includes(States.projectInput)) {
          offsetPoint = OFFSET.DEFAULT;
        } else {
          offsetPoint = OFFSET.ROUTE_VIEW;
        }
        map.panBy(offsetPoint.x, offsetPoint.y);
        zoomLevel = map.getZoom();
        return map.setZoom(zoomLevel - offsetPoint.zoomOffset);
      });
      return clusterer;
    };
    _setMap = function(map) {
      MarkerClustererF.clear();
      return _map = map;
    };
    _addMarkerToClusterer = function(marker) {
      var color, vehId, _ref;
      vehId = marker.driverId || UNSERVED_VEH_ID;
      if ((vehId != null) && !((_ref = marker.parameter) != null ? _ref.isDriverLocation : void 0)) {
        color = marker.fillCss || UNSERVED_COLOR;
        _clusterers[vehId] || (_clusterers[vehId] = _getNewClusterer(_map, [], OPTIONS));
        _clusterers[vehId].setStyles(ClusterStyles[color]);
        return _clusterers[vehId].addMarker(marker);
      }
    };
    _removeMarkerFromClusterer = function(marker) {
      var clusterer, vehId, _results;
      _results = [];
      for (vehId in _clusterers) {
        clusterer = _clusterers[vehId];
        if (clusterer.removeMarker(marker, false, true)) {
          break;
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };
    _initEventListeners = function() {
      EventListenersF.addEventListener(Events.MAP_MARKER_ADDED, function(gMarker) {
        var _ref;
        if ((_map != null) && (((_ref = VisitF.getVisits()) != null ? _ref.length : void 0) > Constants.minMarkerClusterCount) && gMarker.type === "visit") {
          return _addMarkerToClusterer(gMarker.marker);
        }
      });
      EventListenersF.addEventListener(Events.MAP_MARKER_DESTROYED, function(marker) {
        return _removeMarkerFromClusterer(marker);
      });
      return EventListenersF.addEventListener(Events.MAP_SET, function(map) {
        return _setMap(map);
      });
    };
    MarkerClustererF.update = function(solution, unserved) {
      var clusterer, color, data, gMarker, id, markerMap, sol, vehId, visit, _i, _len, _ref, _ref1, _ref2, _ref3, _results;
      if ((_map != null) && (((_ref = VisitF.getVisits()) != null ? _ref.length : void 0) > Constants.minMarkerClusterCount)) {
        MarkerClustererF.clear();
        markerMap = {};
        for (vehId in solution) {
          sol = solution[vehId];
          color = sol.color.name;
          if (color != null) {
            _clusterers[vehId] || (_clusterers[vehId] = _getNewClusterer(_map, [], OPTIONS));
            _clusterers[vehId].setStyles(ClusterStyles[color]);
            markerMap[vehId] = [];
            _ref1 = sol.visits;
            for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
              visit = _ref1[_i];
              gMarker = GMarkerF.get(visit.location_id);
              if ((gMarker != null) && !((_ref2 = gMarker.marker.parameter) != null ? _ref2.isDriverLocation : void 0)) {
                markerMap[vehId].push(gMarker.marker);
              }
            }
          }
        }
        markerMap[UNSERVED_VEH_ID] = [];
        for (id in unserved) {
          data = unserved[id];
          color = data.color.name;
          if (color != null) {
            _clusterers[UNSERVED_VEH_ID] || (_clusterers[UNSERVED_VEH_ID] = _getNewClusterer(_map, [], OPTIONS));
            _clusterers[UNSERVED_VEH_ID].setStyles(ClusterStyles[color]);
            gMarker = GMarkerF.get(id);
            if ((gMarker != null ? gMarker.type : void 0) === "visit" && !((_ref3 = gMarker.marker.parameter) != null ? _ref3.isDriverLocation : void 0)) {
              markerMap[UNSERVED_VEH_ID].push(gMarker.marker);
            }
          }
        }
        _results = [];
        for (vehId in _clusterers) {
          clusterer = _clusterers[vehId];
          _results.push(_clusterers[vehId].addMarkers(markerMap[vehId]));
        }
        return _results;
      }
    };
    MarkerClustererF.clear = function() {
      var clusterer, vehId;
      for (vehId in _clusterers) {
        clusterer = _clusterers[vehId];
        clusterer.clearMarkers();
      }
      return _clusterers = {};
    };
    MarkerClustererF.setAllInUnserved = function() {
      var clusterer, markers, vehId;
      var allMarkers = [];
      for (vehId in _clusterers) {
        clusterer = _clusterers[vehId];
        markers = clusterer.getMarkers();
        allMarkers = allMarkers.concat(markers);
      }
      MarkerClustererF.clear();
      _clusterers[UNSERVED_VEH_ID] = _getNewClusterer(_map, [], OPTIONS);
      _clusterers[UNSERVED_VEH_ID].setStyles(ClusterStyles[UNSERVED_COLOR]);
      return _clusterers[UNSERVED_VEH_ID].addMarkers(allMarkers);
    };
    MarkerClustererF.repaintCluster = function(id) {
      id || (id = UNSERVED_VEH_ID);
      if (_clusterers[id] != null) {
        return _clusterers[id].repaint();
      }
    };
    MarkerClustererF.repaintAll = function() {
      var clusterer, vehId, _results;
      _results = [];
      for (vehId in _clusterers) {
        clusterer = _clusterers[vehId];
        _results.push(clusterer.repaint());
      }
      return _results;
    };
    _initEventListeners();
    return MarkerClustererF;
  };
  MarkerClustererF.$inject = ["$state", "ClusterStyles", "GMarkerF", "EventListenersF", "Events", "States", "VisitF", "Constants"];

  angular.module('app').factory('MarkerClustererF', MarkerClustererF);

}).call(this);

(function() {
  var SvgMarkerF, initMarkerExtension,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  SvgMarkerF = function($q, $http) {
    var data, name, _fn, _ref;
    SvgMarkerF = (function(_super) {
      __extends(SvgMarkerF, _super);

      function SvgMarkerF(position, data, map, visible, templateUrl, parameter) {
        this.data = data;
        this.map = map;
        this.visible = visible != null ? visible : true;
        this.templateUrl = templateUrl != null ? templateUrl : null;
        this.parameter = parameter != null ? parameter : null;
        this.position = new google.maps.LatLng(position.lat, position.lng);
        this.setMap(this.map);
      }

      SvgMarkerF.prototype._createDiv = function() {
        if (this.div) {
          return $q.when(true);
        }
        return this.data.svg.then((function(_this) {
          return function(svg) {
            var panes, self;
            _this.div = $("<div>").addClass("marker").html(svg).css({
              width: (_this.data.size.width * _this.data.scale) + "px",
              height: (_this.data.size.height * _this.data.scale) + "px"
            });
            if (!_this.visible) {
              _this.div.hide();
            }
            _this.div.find('svg').css({
              width: "100%",
              height: "100%"
            });
            _this.textDiv = $("<div>").addClass("marker-info");
            _this.textDiv.appendTo(_this.div);
            if (panes = _this.getPanes()) {
              panes.overlayImage.appendChild(_this.div[0]);
            }
            _this.setFillCss(_this.fillCss);
            _this.setSelected(_this.selected);
            _this.setDone(_this.done);
            _this.setText(_this.text);
            self = _this;
            google.maps.event.addDomListener(_this.div[0], "click", function(event) {
              return google.maps.event.trigger(self, "click");
            });
            google.maps.event.addDomListener(_this.div[0], "mouseover", function(event) {
              return google.maps.event.trigger(self, "mouseover");
            });
            google.maps.event.addDomListener(_this.div[0], "mouseout", function(event) {
              return google.maps.event.trigger(self, "mouseout");
            });
            _this._positionDiv();
            return true;
          };
        })(this));
      };

      SvgMarkerF.prototype._positionDiv = function() {
        var point, x, y, _ref;
        if (!this.div) {
          return;
        }
        point = (_ref = this.getProjection()) != null ? _ref.fromLatLngToDivPixel(this.position) : void 0;
        if (point) {
          x = point.x;
          x -= this.data.size.width * this.data.scale * this.data.anchor.x;
          y = point.y;
          y -= this.data.size.height * this.data.scale * this.data.anchor.y;
          return this.div.css({
            left: x + 'px',
            top: y + 'px'
          });
        }
      };

      SvgMarkerF.prototype.draw = function() {
        return this._positionDiv();
      };

      SvgMarkerF.prototype.redraw = function() {
        return this._createDiv();
      };

      SvgMarkerF.prototype.onAdd = function() {
        return this._createDiv();
      };

      SvgMarkerF.prototype.remove = function() {
        if (this.div) {
          this.div.remove();
          return this.div = null;
        }
      };

      SvgMarkerF.prototype.getDraggable = function() {
        return false;
      };

      SvgMarkerF.prototype.getPosition = function() {
        return this.position;
      };

      SvgMarkerF.prototype.setPosition = function(lat, lng) {
        this.position = new google.maps.LatLng(lat, lng);
        return this._positionDiv();
      };

      SvgMarkerF.prototype.updatePosition = function() {
        return this._positionDiv();
      };

      SvgMarkerF.prototype.getVisible = function() {
        return this.visible;
      };

      SvgMarkerF.prototype.setVisible = function(visible) {
        this.visible = visible;
        if (this.div) {
          if (visible) {
            return this.div.show();
          } else {
            return this.div.hide();
          }
        }
      };

      SvgMarkerF.prototype.getSelected = function() {
        return this.selected;
      };

      SvgMarkerF.prototype.setHighlighted = function(highlighted) {
        this.highlighted = highlighted;
        if (this.div) {
          if (highlighted) {
            this.div.css({
              'z-index': 1
            });
            return this.div[0].classList.add('highlighted');
          } else {
            this.div.css({
              'z-index': 'auto'
            });
            return this.div[0].classList.remove('highlighted');
          }
        }
      };

      SvgMarkerF.prototype.setSelected = function(selected) {
        this.selected = selected;
        if (this.div) {
          if (selected) {
            this.div.css({
              'z-index': 1
            });
            return this.div[0].classList.add('selected');
          } else {
            this.div.css({
              'z-index': 'auto'
            });
            return this.div[0].classList.remove('selected');
          }
        }
      };

      SvgMarkerF.prototype.setLassoSelected = function(selected) {
        if (this.div) {
          if (selected) {
            this.div.css({
              'z-index': 1
            });
            return this.div[0].classList.add('lasso-selected');
          } else {
            this.div.css({
              'z-index': 'auto'
            });
            return this.div[0].classList.remove('lasso-selected');
          }
        }
      };

      SvgMarkerF.prototype.getDone = function() {
        return this.done;
      };

      SvgMarkerF.prototype.setDone = function(done) {
        this.done = done;
        if (this.div) {
          if (done) {
            this.div.css({
              'z-index': 1
            });
            return this.div[0].classList.add('done');
          } else {
            this.div.css({
              'z-index': 'auto'
            });
            return this.div[0].classList.remove('done');
          }
        }
      };

      SvgMarkerF.prototype.setHovered = function(hovered) {
        this.hovered = hovered;
        if (this.div) {
          if (hovered) {
            this.div.css({
              'z-index': 1
            });
            return this.div[0].classList.add('hovered');
          } else {
            this.div.css({
              'z-index': 'auto'
            });
            return this.div[0].classList.remove('hovered');
          }
        }
      };

      SvgMarkerF.prototype.setText = function(text) {
        this.text = text;
        if (this.textDiv) {
          return this.textDiv.text(text);
        }
      };

      SvgMarkerF.prototype.setDataWithHeading = function(heading) {
        var _getDataWithHeading;
        _getDataWithHeading = function(heading) {
          switch (heading) {
            case 'liveDriverNE':
              return SvgMarkerF.markers.liveDriverNE;
            case 'liveDriverSE':
              return SvgMarkerF.markers.liveDriverSE;
            case 'liveDriverSW':
              return SvgMarkerF.markers.liveDriverSW;
            case 'liveDriverNW':
              return SvgMarkerF.markers.liveDriverNW;
          }
        };
        return this.data = _getDataWithHeading(heading);
      };

      SvgMarkerF.prototype.setParameter = function(parameter) {
        return this.parameter = parameter;
      };

      SvgMarkerF.prototype.setFillCss = function(fillCss) {
        if (this.div) {
          this.removeFillCss();
          if (fillCss) {
            this.div[0].classList.add(fillCss);
          }
        }
        return this.fillCss = fillCss;
      };

      SvgMarkerF.prototype.setDriverId = function(driverId) {
        return this.driverId = driverId;
      };

      SvgMarkerF.prototype.removeFillCss = function() {
        if (this.div) {
          if (this.fillCss) {
            this.div[0].classList.remove(this.fillCss);
          }
        }
        if (this.fillCss) {
          return this.fillCss = void 0;
        }
      };

      SvgMarkerF.markers = {
        visit: {
          size: {
            width: 90,
            height: 136
          },
          anchor: {
            x: 0.5,
            y: 0.96
          },
          scale: 0.4,
          svgImage: "img/marker-visit.svg"
        },
        driver: {
          size: {
            width: 102,
            height: 134
          },
          anchor: {
            x: 0.5,
            y: 0.96
          },
          scale: 0.4,
          svgImage: "img/marker-driver.svg"
        },
        driverGps: {
          size: {
            width: 100,
            height: 100
          },
          anchor: {
            x: 0.5,
            y: 0.5
          },
          scale: 0.4,
          svgImage: "img/marker-driver-gps.svg"
        },
        finish: {
          size: {
            width: 102,
            height: 134
          },
          anchor: {
            x: 0.5,
            y: 0.96
          },
          scale: 0.4,
          svgImage: "img/marker-finish.svg"
        },
        current: {
          size: {
            width: 102,
            height: 134
          },
          anchor: {
            x: 0.5,
            y: 0.96
          },
          scale: 0.4,
          svgImage: "img/marker-current.svg"
        },
        liveDriverNE: {
          size: {
            width: 100,
            height: 100
          },
          anchor: {
            x: 0.8,
            y: 0.15
          },
          scale: 0.4,
          svgImage: "img/marker-live-driver-ne.svg"
        },
        liveDriverSE: {
          size: {
            width: 100,
            height: 100
          },
          anchor: {
            x: 0.8,
            y: 0.8
          },
          scale: 0.4,
          svgImage: "img/marker-live-driver-se.svg"
        },
        liveDriverSW: {
          size: {
            width: 100,
            height: 100
          },
          anchor: {
            x: 0.2,
            y: 0.8
          },
          scale: 0.4,
          svgImage: "img/marker-live-driver-sw.svg"
        },
        liveDriverNW: {
          size: {
            width: 100,
            height: 100
          },
          anchor: {
            x: 0.2,
            y: 0.15
          },
          scale: 0.4,
          svgImage: "img/marker-live-driver-nw.svg"
        }
      };

      SvgMarkerF.prototype.getInfoWindowOffset = function() {
        var offsetY = this.data.size.height * this.data.scale;
        offsetY -= this.data.size.height * this.data.scale * (1 - this.data.anchor.y);
        return new google.maps.Size(0, -offsetY);
      };

      return SvgMarkerF;

    })(google.maps.OverlayView);
    _ref = SvgMarkerF.markers;
    _fn = function(data) {
      return data.svg = $http.get(data.svgImage).then(function(response) {
        return response.data;
      });
    };
    for (name in _ref) {
      data = _ref[name];
      _fn(data);
    }
    initMarkerExtension(SvgMarkerF);
    return SvgMarkerF;
  };

  angular.module('app').factory('SvgMarkerF', ["$q", "$http", SvgMarkerF]);

  initMarkerExtension = function(cls) {
    return cls.prototype.animateTo = function(newPosition, options) {
      var animateStep, defaultOptions, key, newPosition_lat, newPosition_lng;
      defaultOptions = {
        duration: 1000,
        easing: 'linear',
        complete: null
      };
      options = options || {};
      for (key in defaultOptions) {
        key = key;
        options[key] = options[key] || defaultOptions[key];
      }
      if (options.easing !== 'linear') {
        if (typeof jQuery === 'undefined' || !jQuery.easing[options.easing]) {
          throw '"' + options.easing + '" easing function doesn\'t exist. Include jQuery and/or the jQuery easing plugin and use the right function name.';
          return;
        }
      }
      window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
      window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
      this.AT_startPosition_lat = this.getPosition().lat();
      this.AT_startPosition_lng = this.getPosition().lng();
      newPosition_lat = newPosition.lat();
      newPosition_lng = newPosition.lng();
      if (Math.abs(newPosition_lng - this.AT_startPosition_lng) > 180) {
        if (newPosition_lng > this.AT_startPosition_lng) {
          newPosition_lng -= 360;
        } else {
          newPosition_lng += 360;
        }
      }
      animateStep = function(marker, startTime) {
        var deltaPosition, durationRatio, easingDurationRatio, ellapsedTime;
        ellapsedTime = (new Date).getTime() - startTime;
        durationRatio = ellapsedTime / options.duration;
        easingDurationRatio = durationRatio;
        if (options.easing !== 'linear') {
          easingDurationRatio = jQuery.easing[options.easing](durationRatio, ellapsedTime, 0, 1, options.duration);
        }
        if (durationRatio < 1) {
          deltaPosition = new google.maps.LatLng(marker.AT_startPosition_lat + (newPosition_lat - marker.AT_startPosition_lat) * easingDurationRatio, marker.AT_startPosition_lng + (newPosition_lng - marker.AT_startPosition_lng) * easingDurationRatio);
          marker.setPosition(deltaPosition.lat(), deltaPosition.lng());
          if (window.requestAnimationFrame) {
            marker.AT_animationHandler = window.requestAnimationFrame(function() {
              animateStep(marker, startTime);
            });
          } else {
            marker.AT_animationHandler = setTimeout((function() {
              animateStep(marker, startTime);
            }), 17);
          }
        } else {
          marker.setPosition(newPosition.lat(), newPosition.lng());
          if (typeof options.complete === 'function') {
            options.complete();
          }
        }
      };
      if (window.cancelAnimationFrame) {
        window.cancelAnimationFrame(this.AT_animationHandler);
      } else {
        clearTimeout(this.AT_animationHandler);
      }
      animateStep(this, (new Date).getTime());
    };
  };

}).call(this);

(function() {
  var Translate = function($translateProvider, $provide) {
    var TranslateProvider, _isValidLocaleObj, _setAngularLocale;
    _isValidLocaleObj = function(localeObj) {
      return ((localeObj != null ? localeObj['DATETIME_FORMATS'] : void 0) != null) && ((localeObj != null ? localeObj['NUMBER_FORMATS'] : void 0) != null);
    };
    _setAngularLocale = function(localeObj) {
      if (!!_isValidLocaleObj(localeObj)) {
        return $provide.value("$locale", localeObj);
      }
    };
    TranslateProvider = {};
    TranslateProvider.$get = [
      "$http", "$window", "$translate", "Constants", "TranslationApi", "Translation", function($http, $window, $translate, Constants, TranslationApi, Translation) {
        var DEFAULT_TRANSLATION, TranslateObj, isLocal, _availableTranslations, _parseAvailableLanguages, _setUserTranslation;
        DEFAULT_TRANSLATION = new Translation("en-full-product", "" + Constants.fullProductUrl + "assets/lang.json", 'English', null, isLocal = true, true);
        _availableTranslations = [];
        _setUserTranslation = function(translation) {
          $translateProvider.translations(translation.key, translation.file);
          $translate.use(translation.key);
          _setAngularLocale(translation.file["ANGULAR_LOCALE"]);
          return TranslateObj.selectedLanguage = translation.name;
        };
        _parseAvailableLanguages = function(languages) {
          var isDefault, lang, translation, translations, _i, _len;
          translations = [];
          for (_i = 0, _len = languages.length; _i < _len; _i++) {
            lang = languages[_i];
            translation = new Translation(lang.id, null, lang.name, null, isLocal = false, isDefault = lang.is_default);
            translations.push(translation);
          }
          return translations;
        };
        TranslateObj = {};
        TranslateObj.selectedLanguage = null;
        TranslateObj.getAvailableTranslations = function() {
          return _availableTranslations;
        };
        TranslateObj.setAvailableTranslations = function(userAvailableLanguages) {
          var parsedTranslations = _parseAvailableLanguages(userAvailableLanguages);
          return _availableTranslations = parsedTranslations || [];
        };
        TranslateObj.setDefaultTranslation = function() {
          return $http.get(DEFAULT_TRANSLATION.url).then(function(res) {
            var file = res.data;
            if (file != null) {
              $translateProvider.translations(DEFAULT_TRANSLATION.key, file).fallbackLanguage(DEFAULT_TRANSLATION.key).preferredLanguage(DEFAULT_TRANSLATION.key);
              $translate.use(DEFAULT_TRANSLATION.key);
              _setAngularLocale(file["ANGULAR_LOCALE"]);
              return TranslateObj.selectedLanguage = DEFAULT_TRANSLATION.name;
            }
          });
        };
        TranslateObj.setSelectedTranslation = function(key) {
          var t, translations, _i, _len;
          translations = TranslateObj.getAvailableTranslations();
          for (_i = 0, _len = translations.length; _i < _len; _i++) {
            t = translations[_i];
            if (!(t.key === key)) {
              continue;
            }
            if (t.isDefault) {
              return;
            }
            return TranslateObj.changeTranslation(t, false);
          }
        };
        TranslateObj.setMobileTranslation = function(key) {
          var translation;
          if (key == null) {
            return;
          }
          translation = new Translation(key, null, null, null, false, false);
          return TranslationApi.getTranslationData(translation).then(function(data) {
            translation.file = data;
            if (data != null) {
              return _setUserTranslation(translation);
            }
          });
        };
        TranslateObj.changeTranslation = function(translation, updateUserLanguage, updateLanguageCb) {
          return TranslationApi.getTranslationData(translation).then(function(data) {
            translation.file = data;
            if (data != null) {
              _setUserTranslation(translation);
              if (updateUserLanguage) {
                return updateLanguageCb(translation.key).then(function() {
                  return $window.location.reload();
                });
              }
            }
          });
        };
        return TranslateObj;
      }
    ];
    return TranslateProvider;
  };
  Translate.$inject = ["$translateProvider", "$provide"];

  angular.module('app').provider('Translate', Translate);

}).call(this);

(function() {
  var Translation = function() {
    Translation = (function() {
      function Translation(key, url, name, file, isLocal, isDefault) {
        this.key = key;
        this.url = url;
        this.name = name;
        this.file = file;
        this.isLocal = isLocal;
        this.isDefault = isDefault;
      }

      return Translation;

    })();
    return Translation;
  };

  angular.module('app').factory('Translation', Translation);

}).call(this);

(function() {
  var TranslationApi = function($http, Constants) {
    var _getLanguagePath, _translations;
    _translations = null;
    _getLanguagePath = function(languageId) {
      return "" + Constants.apiPath + "/product/languages/" + languageId;
    };
    TranslationApi = {};
    TranslationApi.getTranslationData = function(translation) {
      var url = translation.isLocal ? translation.url : _getLanguagePath(translation.key);
      return $http.get(url).then(function(res) {
        var data = translation.isLocal ? res.data : res.data.data;
        return data;
      });
    };
    return TranslationApi;
  };
  TranslationApi.$inject = ["$http", "Constants"];

  angular.module('app').factory('TranslationApi', TranslationApi);

}).call(this);

(function() {
  var TimeUtilF = function($translate) {
    var DATE_COMPONENT_SEPARATOR, DAY_IN_MINUTES, DEFAULT_DAY, DEFAULT_MONTH, DEFAULT_YEAR, HOUR_IN_MINUTES, ONE_DAY, ONE_MIN, _convertTimeToDate, _dateToHhMmAmPmStr, _dateToHhMmStr, _dateToMMDD, _dateToMinutes, _paddedZero;
    ONE_MIN = 60 * 1000;
    ONE_DAY = 24 * 60 * 60 * 1000;
    HOUR_IN_MINUTES = 60;
    DAY_IN_MINUTES = 24 * HOUR_IN_MINUTES;
    DEFAULT_YEAR = 2014;
    DEFAULT_MONTH = 2;
    DEFAULT_DAY = 1;
    DATE_COMPONENT_SEPARATOR = '-';
    _dateToMinutes = function(date) {
      var hours, minutes, numMinutes;
      var days = date.getDate();
      hours = date.getHours();
      minutes = date.getMinutes();
      numMinutes = (days * DAY_IN_MINUTES) + (hours * HOUR_IN_MINUTES) + minutes;
      return numMinutes;
    };
    _paddedZero = function(value, numDigits) {
      var valueStr = value ? value.toString() : '';
      while (valueStr.length < numDigits) {
        valueStr = '0' + valueStr;
      }
      return valueStr;
    };
    _convertTimeToDate = function(timeStr, year, month, day) {
      var apm, hour, minute, time;
      if (year == null) {
        year = DEFAULT_YEAR;
      }
      if (month == null) {
        month = DEFAULT_MONTH;
      }
      if (day == null) {
        day = DEFAULT_DAY;
      }
      if (!timeStr) {
        return null;
      }
      time = timeStr.match(TimeUtilF.TIME_REGEX);
      if (!time) {
        return null;
      }
      hour = parseInt(time[1], 10);
      apm = time[4];
      if (apm != null) {
        if (apm.toLowerCase() === 'p' && (hour < 12)) {
          hour += 12;
        }
        if (apm.toLowerCase() === 'a' && (hour === 12)) {
          hour = 0;
        }
      }
      minute = parseInt(time[2], 10) || 0;
      if (minute > 59) {
        return null;
      }
      return new Date(year, month, day, hour, minute);
    };
    TimeUtilF = {};
    TimeUtilF.TIME_REGEX = /(\d+)(?:[:|.](\d\d))?(?:[:|.](\d\d))?\s*([ap]?)/i;
    TimeUtilF.DEFAULT_DATE = new Date(DEFAULT_YEAR, DEFAULT_MONTH, DEFAULT_DAY);
    TimeUtilF.MAX_HOURS = "99:59";
    TimeUtilF.MAX_DATE = _convertTimeToDate(TimeUtilF.MAX_HOURS);
    TimeUtilF.MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
    TimeUtilF.DATE_FORMAT = 'yyyy-M-d';
    TimeUtilF.convertTimeToDate = _convertTimeToDate;
    TimeUtilF.normalizeDateMonthYear = function(date) {
      if (!date) {
        return;
      }
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      date.setFullYear(DEFAULT_YEAR, DEFAULT_MONTH, DEFAULT_DAY);
      return date;
    };
    TimeUtilF.getCurrentNormalizedTime = function() {
      var date = new Date();
      date = TimeUtilF.normalizeDateMonthYear(date);
      return date;
    };
    TimeUtilF.convertDateToTime = function(date) {
      var dateObj, extraDays, hours, minutes;
      if (!date) {
        return null;
      }
      dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) {
        return null;
      }
      extraDays = dateObj.getDate() - DEFAULT_DAY;
      hours = dateObj.getHours() + (extraDays * 24);
      if ((hours != null ? hours.toString().length : void 0) < 2) {
        hours = _paddedZero(hours, 2);
      }
      minutes = dateObj.getMinutes();
      minutes = _paddedZero(minutes, 2);
      return "" + hours + ":" + minutes;
    };
    TimeUtilF.minutesToHoursStr = function(minutes) {
      var hrsStr, hrsTrans, mins, minsStr, minsTrans;
      var hrs = Math.floor(minutes / 60);
      mins = minutes % 60;
      hrsTrans = $translate.instant("GENERAL.HOURS");
      minsTrans = $translate.instant("GENERAL.MINS");
      hrsStr = hrs > 0 ? "" + hrs + " " + hrsTrans : "";
      minsStr = mins > 0 ? "" + mins + " " + minsTrans : "";
      return "" + hrsStr + " " + minsStr;
    };
    _dateToHhMmStr = function(d, padZero) {
      var h, hh, min, time;
      hh = d.getHours();
      h = padZero ? _paddedZero(hh, 2) : hh;
      min = ('0' + d.getMinutes()).slice(-2);
      time = h + ':' + min;
      return time;
    };
    _dateToMMDD = function(d) {
      var date, dd, mm;
      mm = ('0' + (d.getMonth() + 1)).slice(-2);
      dd = ('0' + d.getDate()).slice(-2);
      date = dd + '/' + mm;
      return date;
    };
    _dateToHhMmAmPmStr = function(d) {
      var ampm, h, hh, min, time;
      hh = d.getHours();
      h = hh;
      min = ('0' + d.getMinutes()).slice(-2);
      ampm = 'AM';
      if (hh > 12) {
        h = hh - 12;
        ampm = 'PM';
      } else if (hh === 12) {
        h = 12;
        ampm = 'PM';
      } else if (hh === 0) {
        h = 12;
      }
      time = h + ':' + min + ' ' + ampm;
      return time;
    };
    TimeUtilF.dateToMMDD = function(date) {
      if (date == null) {
        return null;
      }
      return _dateToMMDD(date);
    };
    TimeUtilF.dateToHhMm = function(date, padZero) {
      if (date == null) {
        return null;
      }
      return _dateToHhMmStr(date, padZero);
    };
    TimeUtilF.dateToTimeStr = function(date) {
      if (date == null) {
        return null;
      }
      return _dateToHhMmAmPmStr(date);
    };
    TimeUtilF.timestampToDayMonthYearStr = function(timestamp) {
      var dd, mm, time, yyyy;
      var d = new Date(timestamp);
      yyyy = d.getFullYear();
      mm = ('0' + (d.getMonth() + 1)).slice(-2);
      dd = ('0' + d.getDate()).slice(-2);
      time = dd + '-' + mm + '-' + yyyy;
      return time;
    };
    TimeUtilF.timestampToTimeStr = function(timestamp) {
      var d;
      if (!timestamp) {
        return null;
      }
      d = new Date(timestamp);
      return _dateToHhMmStr(d);
    };
    TimeUtilF.compareTimes = function(time1, time2) {
      var date1, date2;
      if (!(time1 && time2)) {
        return null;
      }
      date1 = _convertTimeToDate(time1);
      date2 = _convertTimeToDate(time2);
      return TimeUtilF.compareDates(date1, date2);
    };
    TimeUtilF.compareDates = function(date1, date2) {
      var minutes1, minutes2;
      if (!(date1 && date2)) {
        return null;
      }
      minutes1 = _dateToMinutes(date1);
      minutes2 = _dateToMinutes(date2);
      return minutes1 - minutes2;
    };
    TimeUtilF.addMinutes = function(date, minutes) {
      var newDate;
      if (!date) {
        return null;
      }
      if (!minutes) {
        return date;
      }
      newDate = new Date(date);
      newDate.setMinutes(newDate.getMinutes() + minutes);
      return newDate;
    };
    TimeUtilF.addDays = function(date, days) {
      var newDate;
      if (!date) {
        return null;
      }
      if (!days) {
        return date;
      }
      newDate = new Date(date);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    };
    TimeUtilF.diffDays = function(date1, date2) {
      if (!(date1 && date2)) {
        return null;
      }
      return Math.round((date1.getTime() - date2.getTime()) / TimeUtilF.MILLISECONDS_IN_DAY);
    };
    TimeUtilF.diffMins = function(date1, date2) {
      var diff;
      if (!(date1 && date2)) {
        return null;
      }
      return diff = Math.round((date1.getTime() - date2.getTime()) / ONE_MIN);
    };
    TimeUtilF.toString = function(date) {
      var dateObj, day, month, year;
      if (!date) {
        return null;
      }
      dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) {
        return null;
      }
      year = dateObj.getFullYear();
      month = dateObj.getMonth() + 1;
      month = _paddedZero(month, 2);
      day = dateObj.getDate();
      day = _paddedZero(day, 2);
      return [year, month, day].join(DATE_COMPONENT_SEPARATOR);
    };
    TimeUtilF.toMonthDate = function(date) {
      var dateObj, day, month;
      if (!date) {
        return null;
      }
      dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) {
        return null;
      }
      month = dateObj.getMonth() + 1;
      month = _paddedZero(month, 2);
      day = dateObj.getDate();
      day = _paddedZero(day, 2);
      return [month, day].join(DATE_COMPONENT_SEPARATOR);
    };
    TimeUtilF.fromString = function(dateStr) {
      var components, date, month, year;
      if (!dateStr) {
        return;
      }
      components = dateStr.split(DATE_COMPONENT_SEPARATOR);
      if (components.length < 3) {
        return;
      }
      year = components[0];
      month = parseInt(components[1], 10) - 1;
      date = components[2];
      return new Date(year, month, date);
    };
    TimeUtilF.convertDateToUTC = function(date) {
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    };
    TimeUtilF.padZero = function(timeStr) {
      var time = timeStr.toString().split(':');
      return _paddedZero(time[0], 2) + ':' + _paddedZero(time[1], 2);
    };
    return TimeUtilF;
  };
  TimeUtilF.$inject = ["$translate"];

  angular.module('app').factory('TimeUtilF', TimeUtilF);

}).call(this);

(function() {
  var cachedStorages;
  var LocalStorageF = function(key, initial) {
    var _initialData;
    _initialData = function() {
      return _.cloneDeep(initial);
    };
    return {
      data: _initialData(),
      save: function() {
        var e;
        if (typeof localStorage === 'object') {
          try {
            return localStorage.setItem(key, JSON.stringify(this.data));
          } catch (_error) {
            e = _error;
            return console.log("Local Storage not enabled");
          }
        }
      },
      erase: function() {
        var e;
        this.data = _initialData();
        if (typeof localStorage === 'object') {
          try {
            return localStorage.removeItem(key);
          } catch (_error) {
            e = _error;
            return console.log("Local Storage not enabled");
          }
        }
      },
      load: function() {
        if (!localStorage[key]) {
          this.data = _initialData();
          return this.data;
        }
        try {
          this.data = JSON.parse(localStorage.getItem(key));
        } catch (_error) {
          this.data = _initialData();
        }
        return this.data;
      },
      remove: function(conditions) {
        _.remove(this.data, conditions);
        return this.save();
      },
      replace: function(conditions, newObject) {
        var idx = _.findIndex(this.data, conditions);
        if (idx === -1) {
          return;
        }
        this.data[idx] = newObject;
        return this.save();
      }
    };
  };

  cachedStorages = {};

  angular.module('app').factory('LocalStorageF', ["$injector", "Events", "EventListenersF", function($injector, Events, EventListenersF) {
    EventListenersF.addEventListener(Events.USER_LOGGING_OUT, function() {
      var id, storage, _results;
      _results = [];
      for (id in cachedStorages) {
        storage = cachedStorages[id];
        _results.push(storage.erase());
      }
      return _results;
    });
    return function(key, initial, isMobile) {
      var AccountF, id, _ref;
      if (!isMobile) {
        AccountF = $injector.get("AccountF");
        id = (_ref = AccountF.getUser()) != null ? _ref._id : void 0;
        if (id) {
          key = "" + id + "[" + key + "]";
        }
      }
      return cachedStorages[key] || (cachedStorages[key] = LocalStorageF(key, initial));
    };
  }]);

}).call(this);

(function() {
  var PolylineUtil = function(PolylineColors) {
    var DEFAULT_PRECISION, _decode, _encodeCoordinate, _encodeCoordinates, _generateLineOptions;
    DEFAULT_PRECISION = 6;
    _decode = function(encoded, precision) {
      var array, b, dlat, dlng, index, lat, len, lng, result, shift;
      precision = Math.pow(10, -precision);
      len = encoded.length;
      index = 0;
      lat = 0;
      lng = 0;
      array = [];
      while (index < len) {
        b = void 0;
        shift = 0;
        result = 0;
        while (true) {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
          if (!(b >= 0x20)) {
            break;
          }
        }
        dlat = (result & 1 ? ~(result >> 1) : result >> 1);
        lat += dlat;
        shift = 0;
        result = 0;
        while (true) {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
          if (!(b >= 0x20)) {
            break;
          }
        }
        dlng = (result & 1 ? ~(result >> 1) : result >> 1);
        lng += dlng;
        array.push({
          latitude: lat * precision,
          longitude: lng * precision
        });
      }
      return array;
    };
    _encodeCoordinate = function(coordinate, factor) {
      var output;
      coordinate = Math.round(coordinate * factor);
      coordinate <<= 1;
      if (coordinate < 0) {
        coordinate = ~coordinate;
      }
      output = '';
      while (coordinate >= 0x20) {
        output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
        coordinate >>= 5;
      }
      output += String.fromCharCode(coordinate + 63);
      return output;
    };
    _encodeCoordinates = function(coordinates, precision) {
      var a, b, factor, index, output;
      if (precision == null) {
        precision = DEFAULT_PRECISION;
      }
      if (!coordinates.length) {
        return '';
      }
      factor = Math.pow(10, precision);
      output = _encodeCoordinate(coordinates[0].latitude, factor) + _encodeCoordinate(coordinates[0].longitude, factor);
      index = 1;
      while (index < coordinates.length) {
        a = coordinates[index];
        b = coordinates[index - 1];
        output += _encodeCoordinate(a.latitude - b.latitude, factor);
        output += _encodeCoordinate(a.longitude - b.longitude, factor);
        index++;
      }
      return output;
    };
    _generateLineOptions = function(color) {
      return {
        strokeColor: color.rgba
      };
    };
    PolylineUtil = {};
    PolylineUtil.decodePolylines = function(lines, precision) {
      var e, encoded, id, polylines, _i, _len;
      polylines = {};
      for (id in lines) {
        encoded = lines[id];
        polylines[id] = [];
        for (_i = 0, _len = encoded.length; _i < _len; _i++) {
          e = encoded[_i];
          if (e) {
            polylines[id] = polylines[id].concat(_decode(e, precision));
          }
        }
      }
      return polylines;
    };
    PolylineUtil.decodePolyline = function(line, precision) {
      return _decode(line, precision);
    };
    PolylineUtil.encodePolylines = function(lines, precision) {
      var coordinates, id, polylines;
      if (precision == null) {
        precision = DEFAULT_PRECISION;
      }
      polylines = {};
      for (id in lines) {
        coordinates = lines[id];
        polylines[id] = [_encodeCoordinates(coordinates, precision)];
      }
      return polylines;
    };
    PolylineUtil.generateLines = function(lines, colors) {
      var id, line, polylines;
      polylines = {};
      for (id in lines) {
        line = lines[id];
        polylines[id] = {
          visible: true,
          coords: line,
          options: _generateLineOptions(colors[id] || PolylineColors[0])
        };
      }
      return polylines;
    };
    return PolylineUtil;
  };
  PolylineUtil.$inject = ["PolylineColors"];

  angular.module('app').factory('PolylineUtil', PolylineUtil);

}).call(this);

//# sourceMappingURL=app.js.map